webpackJsonp([0],[
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(8);

/*global toString:true*/

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */
function isBuffer(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor)
    && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData);
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.replace(/^\s*/, '').replace(/\s*$/, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' ||
                                           navigator.product === 'NativeScript' ||
                                           navigator.product === 'NS')) {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = merge(result[key], val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Function equal to merge with the difference being that no reference
 * to original objects is kept.
 *
 * @see merge
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function deepMerge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = deepMerge(result[key], val);
    } else if (typeof val === 'object') {
      result[key] = deepMerge({}, val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  deepMerge: deepMerge,
  extend: extend,
  trim: trim
};


/***/ }),
/* 1 */
/***/ (function(module, exports) {

/* globals __VUE_SSR_CONTEXT__ */

// this module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = injectStyles
  }

  if (hook) {
    var functional = options.functional
    var existing = functional
      ? options.render
      : options.beforeCreate
    if (!functional) {
      // inject component registration as beforeCreate hook
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    } else {
      // register for functioal component in vue file
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return existing(h, context)
      }
    }
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),
/* 2 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, setImmediate) {/*!
 * Vue.js v2.6.12
 * (c) 2014-2020 Evan You
 * Released under the MIT License.
 */
/*  */

var emptyObject = Object.freeze({});

// These helpers produce better VM code in JS engines due to their
// explicitness and function inlining.
function isUndef (v) {
  return v === undefined || v === null
}

function isDef (v) {
  return v !== undefined && v !== null
}

function isTrue (v) {
  return v === true
}

function isFalse (v) {
  return v === false
}

/**
 * Check if value is primitive.
 */
function isPrimitive (value) {
  return (
    typeof value === 'string' ||
    typeof value === 'number' ||
    // $flow-disable-line
    typeof value === 'symbol' ||
    typeof value === 'boolean'
  )
}

/**
 * Quick object check - this is primarily used to tell
 * Objects from primitive values when we know the value
 * is a JSON-compliant type.
 */
function isObject (obj) {
  return obj !== null && typeof obj === 'object'
}

/**
 * Get the raw type string of a value, e.g., [object Object].
 */
var _toString = Object.prototype.toString;

function toRawType (value) {
  return _toString.call(value).slice(8, -1)
}

/**
 * Strict object type check. Only returns true
 * for plain JavaScript objects.
 */
function isPlainObject (obj) {
  return _toString.call(obj) === '[object Object]'
}

function isRegExp (v) {
  return _toString.call(v) === '[object RegExp]'
}

/**
 * Check if val is a valid array index.
 */
function isValidArrayIndex (val) {
  var n = parseFloat(String(val));
  return n >= 0 && Math.floor(n) === n && isFinite(val)
}

function isPromise (val) {
  return (
    isDef(val) &&
    typeof val.then === 'function' &&
    typeof val.catch === 'function'
  )
}

/**
 * Convert a value to a string that is actually rendered.
 */
function toString (val) {
  return val == null
    ? ''
    : Array.isArray(val) || (isPlainObject(val) && val.toString === _toString)
      ? JSON.stringify(val, null, 2)
      : String(val)
}

/**
 * Convert an input value to a number for persistence.
 * If the conversion fails, return original string.
 */
function toNumber (val) {
  var n = parseFloat(val);
  return isNaN(n) ? val : n
}

/**
 * Make a map and return a function for checking if a key
 * is in that map.
 */
function makeMap (
  str,
  expectsLowerCase
) {
  var map = Object.create(null);
  var list = str.split(',');
  for (var i = 0; i < list.length; i++) {
    map[list[i]] = true;
  }
  return expectsLowerCase
    ? function (val) { return map[val.toLowerCase()]; }
    : function (val) { return map[val]; }
}

/**
 * Check if a tag is a built-in tag.
 */
var isBuiltInTag = makeMap('slot,component', true);

/**
 * Check if an attribute is a reserved attribute.
 */
var isReservedAttribute = makeMap('key,ref,slot,slot-scope,is');

/**
 * Remove an item from an array.
 */
function remove (arr, item) {
  if (arr.length) {
    var index = arr.indexOf(item);
    if (index > -1) {
      return arr.splice(index, 1)
    }
  }
}

/**
 * Check whether an object has the property.
 */
var hasOwnProperty = Object.prototype.hasOwnProperty;
function hasOwn (obj, key) {
  return hasOwnProperty.call(obj, key)
}

/**
 * Create a cached version of a pure function.
 */
function cached (fn) {
  var cache = Object.create(null);
  return (function cachedFn (str) {
    var hit = cache[str];
    return hit || (cache[str] = fn(str))
  })
}

/**
 * Camelize a hyphen-delimited string.
 */
var camelizeRE = /-(\w)/g;
var camelize = cached(function (str) {
  return str.replace(camelizeRE, function (_, c) { return c ? c.toUpperCase() : ''; })
});

/**
 * Capitalize a string.
 */
var capitalize = cached(function (str) {
  return str.charAt(0).toUpperCase() + str.slice(1)
});

/**
 * Hyphenate a camelCase string.
 */
var hyphenateRE = /\B([A-Z])/g;
var hyphenate = cached(function (str) {
  return str.replace(hyphenateRE, '-$1').toLowerCase()
});

/**
 * Simple bind polyfill for environments that do not support it,
 * e.g., PhantomJS 1.x. Technically, we don't need this anymore
 * since native bind is now performant enough in most browsers.
 * But removing it would mean breaking code that was able to run in
 * PhantomJS 1.x, so this must be kept for backward compatibility.
 */

/* istanbul ignore next */
function polyfillBind (fn, ctx) {
  function boundFn (a) {
    var l = arguments.length;
    return l
      ? l > 1
        ? fn.apply(ctx, arguments)
        : fn.call(ctx, a)
      : fn.call(ctx)
  }

  boundFn._length = fn.length;
  return boundFn
}

function nativeBind (fn, ctx) {
  return fn.bind(ctx)
}

var bind = Function.prototype.bind
  ? nativeBind
  : polyfillBind;

/**
 * Convert an Array-like object to a real Array.
 */
function toArray (list, start) {
  start = start || 0;
  var i = list.length - start;
  var ret = new Array(i);
  while (i--) {
    ret[i] = list[i + start];
  }
  return ret
}

/**
 * Mix properties into target object.
 */
function extend (to, _from) {
  for (var key in _from) {
    to[key] = _from[key];
  }
  return to
}

/**
 * Merge an Array of Objects into a single Object.
 */
function toObject (arr) {
  var res = {};
  for (var i = 0; i < arr.length; i++) {
    if (arr[i]) {
      extend(res, arr[i]);
    }
  }
  return res
}

/* eslint-disable no-unused-vars */

/**
 * Perform no operation.
 * Stubbing args to make Flow happy without leaving useless transpiled code
 * with ...rest (https://flow.org/blog/2017/05/07/Strict-Function-Call-Arity/).
 */
function noop (a, b, c) {}

/**
 * Always return false.
 */
var no = function (a, b, c) { return false; };

/* eslint-enable no-unused-vars */

/**
 * Return the same value.
 */
var identity = function (_) { return _; };

/**
 * Generate a string containing static keys from compiler modules.
 */
function genStaticKeys (modules) {
  return modules.reduce(function (keys, m) {
    return keys.concat(m.staticKeys || [])
  }, []).join(',')
}

/**
 * Check if two values are loosely equal - that is,
 * if they are plain objects, do they have the same shape?
 */
function looseEqual (a, b) {
  if (a === b) { return true }
  var isObjectA = isObject(a);
  var isObjectB = isObject(b);
  if (isObjectA && isObjectB) {
    try {
      var isArrayA = Array.isArray(a);
      var isArrayB = Array.isArray(b);
      if (isArrayA && isArrayB) {
        return a.length === b.length && a.every(function (e, i) {
          return looseEqual(e, b[i])
        })
      } else if (a instanceof Date && b instanceof Date) {
        return a.getTime() === b.getTime()
      } else if (!isArrayA && !isArrayB) {
        var keysA = Object.keys(a);
        var keysB = Object.keys(b);
        return keysA.length === keysB.length && keysA.every(function (key) {
          return looseEqual(a[key], b[key])
        })
      } else {
        /* istanbul ignore next */
        return false
      }
    } catch (e) {
      /* istanbul ignore next */
      return false
    }
  } else if (!isObjectA && !isObjectB) {
    return String(a) === String(b)
  } else {
    return false
  }
}

/**
 * Return the first index at which a loosely equal value can be
 * found in the array (if value is a plain object, the array must
 * contain an object of the same shape), or -1 if it is not present.
 */
function looseIndexOf (arr, val) {
  for (var i = 0; i < arr.length; i++) {
    if (looseEqual(arr[i], val)) { return i }
  }
  return -1
}

/**
 * Ensure a function is called only once.
 */
function once (fn) {
  var called = false;
  return function () {
    if (!called) {
      called = true;
      fn.apply(this, arguments);
    }
  }
}

var SSR_ATTR = 'data-server-rendered';

var ASSET_TYPES = [
  'component',
  'directive',
  'filter'
];

var LIFECYCLE_HOOKS = [
  'beforeCreate',
  'created',
  'beforeMount',
  'mounted',
  'beforeUpdate',
  'updated',
  'beforeDestroy',
  'destroyed',
  'activated',
  'deactivated',
  'errorCaptured',
  'serverPrefetch'
];

/*  */



var config = ({
  /**
   * Option merge strategies (used in core/util/options)
   */
  // $flow-disable-line
  optionMergeStrategies: Object.create(null),

  /**
   * Whether to suppress warnings.
   */
  silent: false,

  /**
   * Show production mode tip message on boot?
   */
  productionTip: "production" !== 'production',

  /**
   * Whether to enable devtools
   */
  devtools: "production" !== 'production',

  /**
   * Whether to record perf
   */
  performance: false,

  /**
   * Error handler for watcher errors
   */
  errorHandler: null,

  /**
   * Warn handler for watcher warns
   */
  warnHandler: null,

  /**
   * Ignore certain custom elements
   */
  ignoredElements: [],

  /**
   * Custom user key aliases for v-on
   */
  // $flow-disable-line
  keyCodes: Object.create(null),

  /**
   * Check if a tag is reserved so that it cannot be registered as a
   * component. This is platform-dependent and may be overwritten.
   */
  isReservedTag: no,

  /**
   * Check if an attribute is reserved so that it cannot be used as a component
   * prop. This is platform-dependent and may be overwritten.
   */
  isReservedAttr: no,

  /**
   * Check if a tag is an unknown element.
   * Platform-dependent.
   */
  isUnknownElement: no,

  /**
   * Get the namespace of an element
   */
  getTagNamespace: noop,

  /**
   * Parse the real tag name for the specific platform.
   */
  parsePlatformTagName: identity,

  /**
   * Check if an attribute must be bound using property, e.g. value
   * Platform-dependent.
   */
  mustUseProp: no,

  /**
   * Perform updates asynchronously. Intended to be used by Vue Test Utils
   * This will significantly reduce performance if set to false.
   */
  async: true,

  /**
   * Exposed for legacy reasons
   */
  _lifecycleHooks: LIFECYCLE_HOOKS
});

/*  */

/**
 * unicode letters used for parsing html tags, component names and property paths.
 * using https://www.w3.org/TR/html53/semantics-scripting.html#potentialcustomelementname
 * skipping \u10000-\uEFFFF due to it freezing up PhantomJS
 */
var unicodeRegExp = /a-zA-Z\u00B7\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u037D\u037F-\u1FFF\u200C-\u200D\u203F-\u2040\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD/;

/**
 * Check if a string starts with $ or _
 */
function isReserved (str) {
  var c = (str + '').charCodeAt(0);
  return c === 0x24 || c === 0x5F
}

/**
 * Define a property.
 */
function def (obj, key, val, enumerable) {
  Object.defineProperty(obj, key, {
    value: val,
    enumerable: !!enumerable,
    writable: true,
    configurable: true
  });
}

/**
 * Parse simple path.
 */
var bailRE = new RegExp(("[^" + (unicodeRegExp.source) + ".$_\\d]"));
function parsePath (path) {
  if (bailRE.test(path)) {
    return
  }
  var segments = path.split('.');
  return function (obj) {
    for (var i = 0; i < segments.length; i++) {
      if (!obj) { return }
      obj = obj[segments[i]];
    }
    return obj
  }
}

/*  */

// can we use __proto__?
var hasProto = '__proto__' in {};

// Browser environment sniffing
var inBrowser = typeof window !== 'undefined';
var inWeex = typeof WXEnvironment !== 'undefined' && !!WXEnvironment.platform;
var weexPlatform = inWeex && WXEnvironment.platform.toLowerCase();
var UA = inBrowser && window.navigator.userAgent.toLowerCase();
var isIE = UA && /msie|trident/.test(UA);
var isIE9 = UA && UA.indexOf('msie 9.0') > 0;
var isEdge = UA && UA.indexOf('edge/') > 0;
var isAndroid = (UA && UA.indexOf('android') > 0) || (weexPlatform === 'android');
var isIOS = (UA && /iphone|ipad|ipod|ios/.test(UA)) || (weexPlatform === 'ios');
var isChrome = UA && /chrome\/\d+/.test(UA) && !isEdge;
var isPhantomJS = UA && /phantomjs/.test(UA);
var isFF = UA && UA.match(/firefox\/(\d+)/);

// Firefox has a "watch" function on Object.prototype...
var nativeWatch = ({}).watch;

var supportsPassive = false;
if (inBrowser) {
  try {
    var opts = {};
    Object.defineProperty(opts, 'passive', ({
      get: function get () {
        /* istanbul ignore next */
        supportsPassive = true;
      }
    })); // https://github.com/facebook/flow/issues/285
    window.addEventListener('test-passive', null, opts);
  } catch (e) {}
}

// this needs to be lazy-evaled because vue may be required before
// vue-server-renderer can set VUE_ENV
var _isServer;
var isServerRendering = function () {
  if (_isServer === undefined) {
    /* istanbul ignore if */
    if (!inBrowser && !inWeex && typeof global !== 'undefined') {
      // detect presence of vue-server-renderer and avoid
      // Webpack shimming the process
      _isServer = global['process'] && global['process'].env.VUE_ENV === 'server';
    } else {
      _isServer = false;
    }
  }
  return _isServer
};

// detect devtools
var devtools = inBrowser && window.__VUE_DEVTOOLS_GLOBAL_HOOK__;

/* istanbul ignore next */
function isNative (Ctor) {
  return typeof Ctor === 'function' && /native code/.test(Ctor.toString())
}

var hasSymbol =
  typeof Symbol !== 'undefined' && isNative(Symbol) &&
  typeof Reflect !== 'undefined' && isNative(Reflect.ownKeys);

var _Set;
/* istanbul ignore if */ // $flow-disable-line
if (typeof Set !== 'undefined' && isNative(Set)) {
  // use native Set when available.
  _Set = Set;
} else {
  // a non-standard Set polyfill that only works with primitive keys.
  _Set = /*@__PURE__*/(function () {
    function Set () {
      this.set = Object.create(null);
    }
    Set.prototype.has = function has (key) {
      return this.set[key] === true
    };
    Set.prototype.add = function add (key) {
      this.set[key] = true;
    };
    Set.prototype.clear = function clear () {
      this.set = Object.create(null);
    };

    return Set;
  }());
}

/*  */

var warn = noop;
var tip = noop;
var generateComponentTrace = (noop); // work around flow check
var formatComponentName = (noop);

if (false) {
  var hasConsole = typeof console !== 'undefined';
  var classifyRE = /(?:^|[-_])(\w)/g;
  var classify = function (str) { return str
    .replace(classifyRE, function (c) { return c.toUpperCase(); })
    .replace(/[-_]/g, ''); };

  warn = function (msg, vm) {
    var trace = vm ? generateComponentTrace(vm) : '';

    if (config.warnHandler) {
      config.warnHandler.call(null, msg, vm, trace);
    } else if (hasConsole && (!config.silent)) {
      console.error(("[Vue warn]: " + msg + trace));
    }
  };

  tip = function (msg, vm) {
    if (hasConsole && (!config.silent)) {
      console.warn("[Vue tip]: " + msg + (
        vm ? generateComponentTrace(vm) : ''
      ));
    }
  };

  formatComponentName = function (vm, includeFile) {
    if (vm.$root === vm) {
      return '<Root>'
    }
    var options = typeof vm === 'function' && vm.cid != null
      ? vm.options
      : vm._isVue
        ? vm.$options || vm.constructor.options
        : vm;
    var name = options.name || options._componentTag;
    var file = options.__file;
    if (!name && file) {
      var match = file.match(/([^/\\]+)\.vue$/);
      name = match && match[1];
    }

    return (
      (name ? ("<" + (classify(name)) + ">") : "<Anonymous>") +
      (file && includeFile !== false ? (" at " + file) : '')
    )
  };

  var repeat = function (str, n) {
    var res = '';
    while (n) {
      if (n % 2 === 1) { res += str; }
      if (n > 1) { str += str; }
      n >>= 1;
    }
    return res
  };

  generateComponentTrace = function (vm) {
    if (vm._isVue && vm.$parent) {
      var tree = [];
      var currentRecursiveSequence = 0;
      while (vm) {
        if (tree.length > 0) {
          var last = tree[tree.length - 1];
          if (last.constructor === vm.constructor) {
            currentRecursiveSequence++;
            vm = vm.$parent;
            continue
          } else if (currentRecursiveSequence > 0) {
            tree[tree.length - 1] = [last, currentRecursiveSequence];
            currentRecursiveSequence = 0;
          }
        }
        tree.push(vm);
        vm = vm.$parent;
      }
      return '\n\nfound in\n\n' + tree
        .map(function (vm, i) { return ("" + (i === 0 ? '---> ' : repeat(' ', 5 + i * 2)) + (Array.isArray(vm)
            ? ((formatComponentName(vm[0])) + "... (" + (vm[1]) + " recursive calls)")
            : formatComponentName(vm))); })
        .join('\n')
    } else {
      return ("\n\n(found in " + (formatComponentName(vm)) + ")")
    }
  };
}

/*  */

var uid = 0;

/**
 * A dep is an observable that can have multiple
 * directives subscribing to it.
 */
var Dep = function Dep () {
  this.id = uid++;
  this.subs = [];
};

Dep.prototype.addSub = function addSub (sub) {
  this.subs.push(sub);
};

Dep.prototype.removeSub = function removeSub (sub) {
  remove(this.subs, sub);
};

Dep.prototype.depend = function depend () {
  if (Dep.target) {
    Dep.target.addDep(this);
  }
};

Dep.prototype.notify = function notify () {
  // stabilize the subscriber list first
  var subs = this.subs.slice();
  if (false) {
    // subs aren't sorted in scheduler if not running async
    // we need to sort them now to make sure they fire in correct
    // order
    subs.sort(function (a, b) { return a.id - b.id; });
  }
  for (var i = 0, l = subs.length; i < l; i++) {
    subs[i].update();
  }
};

// The current target watcher being evaluated.
// This is globally unique because only one watcher
// can be evaluated at a time.
Dep.target = null;
var targetStack = [];

function pushTarget (target) {
  targetStack.push(target);
  Dep.target = target;
}

function popTarget () {
  targetStack.pop();
  Dep.target = targetStack[targetStack.length - 1];
}

/*  */

var VNode = function VNode (
  tag,
  data,
  children,
  text,
  elm,
  context,
  componentOptions,
  asyncFactory
) {
  this.tag = tag;
  this.data = data;
  this.children = children;
  this.text = text;
  this.elm = elm;
  this.ns = undefined;
  this.context = context;
  this.fnContext = undefined;
  this.fnOptions = undefined;
  this.fnScopeId = undefined;
  this.key = data && data.key;
  this.componentOptions = componentOptions;
  this.componentInstance = undefined;
  this.parent = undefined;
  this.raw = false;
  this.isStatic = false;
  this.isRootInsert = true;
  this.isComment = false;
  this.isCloned = false;
  this.isOnce = false;
  this.asyncFactory = asyncFactory;
  this.asyncMeta = undefined;
  this.isAsyncPlaceholder = false;
};

var prototypeAccessors = { child: { configurable: true } };

// DEPRECATED: alias for componentInstance for backwards compat.
/* istanbul ignore next */
prototypeAccessors.child.get = function () {
  return this.componentInstance
};

Object.defineProperties( VNode.prototype, prototypeAccessors );

var createEmptyVNode = function (text) {
  if ( text === void 0 ) text = '';

  var node = new VNode();
  node.text = text;
  node.isComment = true;
  return node
};

function createTextVNode (val) {
  return new VNode(undefined, undefined, undefined, String(val))
}

// optimized shallow clone
// used for static nodes and slot nodes because they may be reused across
// multiple renders, cloning them avoids errors when DOM manipulations rely
// on their elm reference.
function cloneVNode (vnode) {
  var cloned = new VNode(
    vnode.tag,
    vnode.data,
    // #7975
    // clone children array to avoid mutating original in case of cloning
    // a child.
    vnode.children && vnode.children.slice(),
    vnode.text,
    vnode.elm,
    vnode.context,
    vnode.componentOptions,
    vnode.asyncFactory
  );
  cloned.ns = vnode.ns;
  cloned.isStatic = vnode.isStatic;
  cloned.key = vnode.key;
  cloned.isComment = vnode.isComment;
  cloned.fnContext = vnode.fnContext;
  cloned.fnOptions = vnode.fnOptions;
  cloned.fnScopeId = vnode.fnScopeId;
  cloned.asyncMeta = vnode.asyncMeta;
  cloned.isCloned = true;
  return cloned
}

/*
 * not type checking this file because flow doesn't play well with
 * dynamically accessing methods on Array prototype
 */

var arrayProto = Array.prototype;
var arrayMethods = Object.create(arrayProto);

var methodsToPatch = [
  'push',
  'pop',
  'shift',
  'unshift',
  'splice',
  'sort',
  'reverse'
];

/**
 * Intercept mutating methods and emit events
 */
methodsToPatch.forEach(function (method) {
  // cache original method
  var original = arrayProto[method];
  def(arrayMethods, method, function mutator () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    var result = original.apply(this, args);
    var ob = this.__ob__;
    var inserted;
    switch (method) {
      case 'push':
      case 'unshift':
        inserted = args;
        break
      case 'splice':
        inserted = args.slice(2);
        break
    }
    if (inserted) { ob.observeArray(inserted); }
    // notify change
    ob.dep.notify();
    return result
  });
});

/*  */

var arrayKeys = Object.getOwnPropertyNames(arrayMethods);

/**
 * In some cases we may want to disable observation inside a component's
 * update computation.
 */
var shouldObserve = true;

function toggleObserving (value) {
  shouldObserve = value;
}

/**
 * Observer class that is attached to each observed
 * object. Once attached, the observer converts the target
 * object's property keys into getter/setters that
 * collect dependencies and dispatch updates.
 */
var Observer = function Observer (value) {
  this.value = value;
  this.dep = new Dep();
  this.vmCount = 0;
  def(value, '__ob__', this);
  if (Array.isArray(value)) {
    if (hasProto) {
      protoAugment(value, arrayMethods);
    } else {
      copyAugment(value, arrayMethods, arrayKeys);
    }
    this.observeArray(value);
  } else {
    this.walk(value);
  }
};

/**
 * Walk through all properties and convert them into
 * getter/setters. This method should only be called when
 * value type is Object.
 */
Observer.prototype.walk = function walk (obj) {
  var keys = Object.keys(obj);
  for (var i = 0; i < keys.length; i++) {
    defineReactive$$1(obj, keys[i]);
  }
};

/**
 * Observe a list of Array items.
 */
Observer.prototype.observeArray = function observeArray (items) {
  for (var i = 0, l = items.length; i < l; i++) {
    observe(items[i]);
  }
};

// helpers

/**
 * Augment a target Object or Array by intercepting
 * the prototype chain using __proto__
 */
function protoAugment (target, src) {
  /* eslint-disable no-proto */
  target.__proto__ = src;
  /* eslint-enable no-proto */
}

/**
 * Augment a target Object or Array by defining
 * hidden properties.
 */
/* istanbul ignore next */
function copyAugment (target, src, keys) {
  for (var i = 0, l = keys.length; i < l; i++) {
    var key = keys[i];
    def(target, key, src[key]);
  }
}

/**
 * Attempt to create an observer instance for a value,
 * returns the new observer if successfully observed,
 * or the existing observer if the value already has one.
 */
function observe (value, asRootData) {
  if (!isObject(value) || value instanceof VNode) {
    return
  }
  var ob;
  if (hasOwn(value, '__ob__') && value.__ob__ instanceof Observer) {
    ob = value.__ob__;
  } else if (
    shouldObserve &&
    !isServerRendering() &&
    (Array.isArray(value) || isPlainObject(value)) &&
    Object.isExtensible(value) &&
    !value._isVue
  ) {
    ob = new Observer(value);
  }
  if (asRootData && ob) {
    ob.vmCount++;
  }
  return ob
}

/**
 * Define a reactive property on an Object.
 */
function defineReactive$$1 (
  obj,
  key,
  val,
  customSetter,
  shallow
) {
  var dep = new Dep();

  var property = Object.getOwnPropertyDescriptor(obj, key);
  if (property && property.configurable === false) {
    return
  }

  // cater for pre-defined getter/setters
  var getter = property && property.get;
  var setter = property && property.set;
  if ((!getter || setter) && arguments.length === 2) {
    val = obj[key];
  }

  var childOb = !shallow && observe(val);
  Object.defineProperty(obj, key, {
    enumerable: true,
    configurable: true,
    get: function reactiveGetter () {
      var value = getter ? getter.call(obj) : val;
      if (Dep.target) {
        dep.depend();
        if (childOb) {
          childOb.dep.depend();
          if (Array.isArray(value)) {
            dependArray(value);
          }
        }
      }
      return value
    },
    set: function reactiveSetter (newVal) {
      var value = getter ? getter.call(obj) : val;
      /* eslint-disable no-self-compare */
      if (newVal === value || (newVal !== newVal && value !== value)) {
        return
      }
      /* eslint-enable no-self-compare */
      if (false) {
        customSetter();
      }
      // #7981: for accessor properties without setter
      if (getter && !setter) { return }
      if (setter) {
        setter.call(obj, newVal);
      } else {
        val = newVal;
      }
      childOb = !shallow && observe(newVal);
      dep.notify();
    }
  });
}

/**
 * Set a property on an object. Adds the new property and
 * triggers change notification if the property doesn't
 * already exist.
 */
function set (target, key, val) {
  if (false
  ) {
    warn(("Cannot set reactive property on undefined, null, or primitive value: " + ((target))));
  }
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.length = Math.max(target.length, key);
    target.splice(key, 1, val);
    return val
  }
  if (key in target && !(key in Object.prototype)) {
    target[key] = val;
    return val
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    "production" !== 'production' && warn(
      'Avoid adding reactive properties to a Vue instance or its root $data ' +
      'at runtime - declare it upfront in the data option.'
    );
    return val
  }
  if (!ob) {
    target[key] = val;
    return val
  }
  defineReactive$$1(ob.value, key, val);
  ob.dep.notify();
  return val
}

/**
 * Delete a property and trigger change if necessary.
 */
function del (target, key) {
  if (false
  ) {
    warn(("Cannot delete reactive property on undefined, null, or primitive value: " + ((target))));
  }
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.splice(key, 1);
    return
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    "production" !== 'production' && warn(
      'Avoid deleting properties on a Vue instance or its root $data ' +
      '- just set it to null.'
    );
    return
  }
  if (!hasOwn(target, key)) {
    return
  }
  delete target[key];
  if (!ob) {
    return
  }
  ob.dep.notify();
}

/**
 * Collect dependencies on array elements when the array is touched, since
 * we cannot intercept array element access like property getters.
 */
function dependArray (value) {
  for (var e = (void 0), i = 0, l = value.length; i < l; i++) {
    e = value[i];
    e && e.__ob__ && e.__ob__.dep.depend();
    if (Array.isArray(e)) {
      dependArray(e);
    }
  }
}

/*  */

/**
 * Option overwriting strategies are functions that handle
 * how to merge a parent option value and a child option
 * value into the final value.
 */
var strats = config.optionMergeStrategies;

/**
 * Options with restrictions
 */
if (false) {
  strats.el = strats.propsData = function (parent, child, vm, key) {
    if (!vm) {
      warn(
        "option \"" + key + "\" can only be used during instance " +
        'creation with the `new` keyword.'
      );
    }
    return defaultStrat(parent, child)
  };
}

/**
 * Helper that recursively merges two data objects together.
 */
function mergeData (to, from) {
  if (!from) { return to }
  var key, toVal, fromVal;

  var keys = hasSymbol
    ? Reflect.ownKeys(from)
    : Object.keys(from);

  for (var i = 0; i < keys.length; i++) {
    key = keys[i];
    // in case the object is already observed...
    if (key === '__ob__') { continue }
    toVal = to[key];
    fromVal = from[key];
    if (!hasOwn(to, key)) {
      set(to, key, fromVal);
    } else if (
      toVal !== fromVal &&
      isPlainObject(toVal) &&
      isPlainObject(fromVal)
    ) {
      mergeData(toVal, fromVal);
    }
  }
  return to
}

/**
 * Data
 */
function mergeDataOrFn (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    // in a Vue.extend merge, both should be functions
    if (!childVal) {
      return parentVal
    }
    if (!parentVal) {
      return childVal
    }
    // when parentVal & childVal are both present,
    // we need to return a function that returns the
    // merged result of both functions... no need to
    // check if parentVal is a function here because
    // it has to be a function to pass previous merges.
    return function mergedDataFn () {
      return mergeData(
        typeof childVal === 'function' ? childVal.call(this, this) : childVal,
        typeof parentVal === 'function' ? parentVal.call(this, this) : parentVal
      )
    }
  } else {
    return function mergedInstanceDataFn () {
      // instance merge
      var instanceData = typeof childVal === 'function'
        ? childVal.call(vm, vm)
        : childVal;
      var defaultData = typeof parentVal === 'function'
        ? parentVal.call(vm, vm)
        : parentVal;
      if (instanceData) {
        return mergeData(instanceData, defaultData)
      } else {
        return defaultData
      }
    }
  }
}

strats.data = function (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    if (childVal && typeof childVal !== 'function') {
      "production" !== 'production' && warn(
        'The "data" option should be a function ' +
        'that returns a per-instance value in component ' +
        'definitions.',
        vm
      );

      return parentVal
    }
    return mergeDataOrFn(parentVal, childVal)
  }

  return mergeDataOrFn(parentVal, childVal, vm)
};

/**
 * Hooks and props are merged as arrays.
 */
function mergeHook (
  parentVal,
  childVal
) {
  var res = childVal
    ? parentVal
      ? parentVal.concat(childVal)
      : Array.isArray(childVal)
        ? childVal
        : [childVal]
    : parentVal;
  return res
    ? dedupeHooks(res)
    : res
}

function dedupeHooks (hooks) {
  var res = [];
  for (var i = 0; i < hooks.length; i++) {
    if (res.indexOf(hooks[i]) === -1) {
      res.push(hooks[i]);
    }
  }
  return res
}

LIFECYCLE_HOOKS.forEach(function (hook) {
  strats[hook] = mergeHook;
});

/**
 * Assets
 *
 * When a vm is present (instance creation), we need to do
 * a three-way merge between constructor options, instance
 * options and parent options.
 */
function mergeAssets (
  parentVal,
  childVal,
  vm,
  key
) {
  var res = Object.create(parentVal || null);
  if (childVal) {
    "production" !== 'production' && assertObjectType(key, childVal, vm);
    return extend(res, childVal)
  } else {
    return res
  }
}

ASSET_TYPES.forEach(function (type) {
  strats[type + 's'] = mergeAssets;
});

/**
 * Watchers.
 *
 * Watchers hashes should not overwrite one
 * another, so we merge them as arrays.
 */
strats.watch = function (
  parentVal,
  childVal,
  vm,
  key
) {
  // work around Firefox's Object.prototype.watch...
  if (parentVal === nativeWatch) { parentVal = undefined; }
  if (childVal === nativeWatch) { childVal = undefined; }
  /* istanbul ignore if */
  if (!childVal) { return Object.create(parentVal || null) }
  if (false) {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = {};
  extend(ret, parentVal);
  for (var key$1 in childVal) {
    var parent = ret[key$1];
    var child = childVal[key$1];
    if (parent && !Array.isArray(parent)) {
      parent = [parent];
    }
    ret[key$1] = parent
      ? parent.concat(child)
      : Array.isArray(child) ? child : [child];
  }
  return ret
};

/**
 * Other object hashes.
 */
strats.props =
strats.methods =
strats.inject =
strats.computed = function (
  parentVal,
  childVal,
  vm,
  key
) {
  if (childVal && "production" !== 'production') {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = Object.create(null);
  extend(ret, parentVal);
  if (childVal) { extend(ret, childVal); }
  return ret
};
strats.provide = mergeDataOrFn;

/**
 * Default strategy.
 */
var defaultStrat = function (parentVal, childVal) {
  return childVal === undefined
    ? parentVal
    : childVal
};

/**
 * Validate component names
 */
function checkComponents (options) {
  for (var key in options.components) {
    validateComponentName(key);
  }
}

function validateComponentName (name) {
  if (!new RegExp(("^[a-zA-Z][\\-\\.0-9_" + (unicodeRegExp.source) + "]*$")).test(name)) {
    warn(
      'Invalid component name: "' + name + '". Component names ' +
      'should conform to valid custom element name in html5 specification.'
    );
  }
  if (isBuiltInTag(name) || config.isReservedTag(name)) {
    warn(
      'Do not use built-in or reserved HTML elements as component ' +
      'id: ' + name
    );
  }
}

/**
 * Ensure all props option syntax are normalized into the
 * Object-based format.
 */
function normalizeProps (options, vm) {
  var props = options.props;
  if (!props) { return }
  var res = {};
  var i, val, name;
  if (Array.isArray(props)) {
    i = props.length;
    while (i--) {
      val = props[i];
      if (typeof val === 'string') {
        name = camelize(val);
        res[name] = { type: null };
      } else if (false) {
        warn('props must be strings when using array syntax.');
      }
    }
  } else if (isPlainObject(props)) {
    for (var key in props) {
      val = props[key];
      name = camelize(key);
      res[name] = isPlainObject(val)
        ? val
        : { type: val };
    }
  } else if (false) {
    warn(
      "Invalid value for option \"props\": expected an Array or an Object, " +
      "but got " + (toRawType(props)) + ".",
      vm
    );
  }
  options.props = res;
}

/**
 * Normalize all injections into Object-based format
 */
function normalizeInject (options, vm) {
  var inject = options.inject;
  if (!inject) { return }
  var normalized = options.inject = {};
  if (Array.isArray(inject)) {
    for (var i = 0; i < inject.length; i++) {
      normalized[inject[i]] = { from: inject[i] };
    }
  } else if (isPlainObject(inject)) {
    for (var key in inject) {
      var val = inject[key];
      normalized[key] = isPlainObject(val)
        ? extend({ from: key }, val)
        : { from: val };
    }
  } else if (false) {
    warn(
      "Invalid value for option \"inject\": expected an Array or an Object, " +
      "but got " + (toRawType(inject)) + ".",
      vm
    );
  }
}

/**
 * Normalize raw function directives into object format.
 */
function normalizeDirectives (options) {
  var dirs = options.directives;
  if (dirs) {
    for (var key in dirs) {
      var def$$1 = dirs[key];
      if (typeof def$$1 === 'function') {
        dirs[key] = { bind: def$$1, update: def$$1 };
      }
    }
  }
}

function assertObjectType (name, value, vm) {
  if (!isPlainObject(value)) {
    warn(
      "Invalid value for option \"" + name + "\": expected an Object, " +
      "but got " + (toRawType(value)) + ".",
      vm
    );
  }
}

/**
 * Merge two option objects into a new one.
 * Core utility used in both instantiation and inheritance.
 */
function mergeOptions (
  parent,
  child,
  vm
) {
  if (false) {
    checkComponents(child);
  }

  if (typeof child === 'function') {
    child = child.options;
  }

  normalizeProps(child, vm);
  normalizeInject(child, vm);
  normalizeDirectives(child);

  // Apply extends and mixins on the child options,
  // but only if it is a raw options object that isn't
  // the result of another mergeOptions call.
  // Only merged options has the _base property.
  if (!child._base) {
    if (child.extends) {
      parent = mergeOptions(parent, child.extends, vm);
    }
    if (child.mixins) {
      for (var i = 0, l = child.mixins.length; i < l; i++) {
        parent = mergeOptions(parent, child.mixins[i], vm);
      }
    }
  }

  var options = {};
  var key;
  for (key in parent) {
    mergeField(key);
  }
  for (key in child) {
    if (!hasOwn(parent, key)) {
      mergeField(key);
    }
  }
  function mergeField (key) {
    var strat = strats[key] || defaultStrat;
    options[key] = strat(parent[key], child[key], vm, key);
  }
  return options
}

/**
 * Resolve an asset.
 * This function is used because child instances need access
 * to assets defined in its ancestor chain.
 */
function resolveAsset (
  options,
  type,
  id,
  warnMissing
) {
  /* istanbul ignore if */
  if (typeof id !== 'string') {
    return
  }
  var assets = options[type];
  // check local registration variations first
  if (hasOwn(assets, id)) { return assets[id] }
  var camelizedId = camelize(id);
  if (hasOwn(assets, camelizedId)) { return assets[camelizedId] }
  var PascalCaseId = capitalize(camelizedId);
  if (hasOwn(assets, PascalCaseId)) { return assets[PascalCaseId] }
  // fallback to prototype chain
  var res = assets[id] || assets[camelizedId] || assets[PascalCaseId];
  if (false) {
    warn(
      'Failed to resolve ' + type.slice(0, -1) + ': ' + id,
      options
    );
  }
  return res
}

/*  */



function validateProp (
  key,
  propOptions,
  propsData,
  vm
) {
  var prop = propOptions[key];
  var absent = !hasOwn(propsData, key);
  var value = propsData[key];
  // boolean casting
  var booleanIndex = getTypeIndex(Boolean, prop.type);
  if (booleanIndex > -1) {
    if (absent && !hasOwn(prop, 'default')) {
      value = false;
    } else if (value === '' || value === hyphenate(key)) {
      // only cast empty string / same name to boolean if
      // boolean has higher priority
      var stringIndex = getTypeIndex(String, prop.type);
      if (stringIndex < 0 || booleanIndex < stringIndex) {
        value = true;
      }
    }
  }
  // check default value
  if (value === undefined) {
    value = getPropDefaultValue(vm, prop, key);
    // since the default value is a fresh copy,
    // make sure to observe it.
    var prevShouldObserve = shouldObserve;
    toggleObserving(true);
    observe(value);
    toggleObserving(prevShouldObserve);
  }
  if (
    false
  ) {
    assertProp(prop, key, value, vm, absent);
  }
  return value
}

/**
 * Get the default value of a prop.
 */
function getPropDefaultValue (vm, prop, key) {
  // no default, return undefined
  if (!hasOwn(prop, 'default')) {
    return undefined
  }
  var def = prop.default;
  // warn against non-factory defaults for Object & Array
  if (false) {
    warn(
      'Invalid default value for prop "' + key + '": ' +
      'Props with type Object/Array must use a factory function ' +
      'to return the default value.',
      vm
    );
  }
  // the raw prop value was also undefined from previous render,
  // return previous default value to avoid unnecessary watcher trigger
  if (vm && vm.$options.propsData &&
    vm.$options.propsData[key] === undefined &&
    vm._props[key] !== undefined
  ) {
    return vm._props[key]
  }
  // call factory function for non-Function types
  // a value is Function if its prototype is function even across different execution context
  return typeof def === 'function' && getType(prop.type) !== 'Function'
    ? def.call(vm)
    : def
}

/**
 * Assert whether a prop is valid.
 */
function assertProp (
  prop,
  name,
  value,
  vm,
  absent
) {
  if (prop.required && absent) {
    warn(
      'Missing required prop: "' + name + '"',
      vm
    );
    return
  }
  if (value == null && !prop.required) {
    return
  }
  var type = prop.type;
  var valid = !type || type === true;
  var expectedTypes = [];
  if (type) {
    if (!Array.isArray(type)) {
      type = [type];
    }
    for (var i = 0; i < type.length && !valid; i++) {
      var assertedType = assertType(value, type[i]);
      expectedTypes.push(assertedType.expectedType || '');
      valid = assertedType.valid;
    }
  }

  if (!valid) {
    warn(
      getInvalidTypeMessage(name, value, expectedTypes),
      vm
    );
    return
  }
  var validator = prop.validator;
  if (validator) {
    if (!validator(value)) {
      warn(
        'Invalid prop: custom validator check failed for prop "' + name + '".',
        vm
      );
    }
  }
}

var simpleCheckRE = /^(String|Number|Boolean|Function|Symbol)$/;

function assertType (value, type) {
  var valid;
  var expectedType = getType(type);
  if (simpleCheckRE.test(expectedType)) {
    var t = typeof value;
    valid = t === expectedType.toLowerCase();
    // for primitive wrapper objects
    if (!valid && t === 'object') {
      valid = value instanceof type;
    }
  } else if (expectedType === 'Object') {
    valid = isPlainObject(value);
  } else if (expectedType === 'Array') {
    valid = Array.isArray(value);
  } else {
    valid = value instanceof type;
  }
  return {
    valid: valid,
    expectedType: expectedType
  }
}

/**
 * Use function string name to check built-in types,
 * because a simple equality check will fail when running
 * across different vms / iframes.
 */
function getType (fn) {
  var match = fn && fn.toString().match(/^\s*function (\w+)/);
  return match ? match[1] : ''
}

function isSameType (a, b) {
  return getType(a) === getType(b)
}

function getTypeIndex (type, expectedTypes) {
  if (!Array.isArray(expectedTypes)) {
    return isSameType(expectedTypes, type) ? 0 : -1
  }
  for (var i = 0, len = expectedTypes.length; i < len; i++) {
    if (isSameType(expectedTypes[i], type)) {
      return i
    }
  }
  return -1
}

function getInvalidTypeMessage (name, value, expectedTypes) {
  var message = "Invalid prop: type check failed for prop \"" + name + "\"." +
    " Expected " + (expectedTypes.map(capitalize).join(', '));
  var expectedType = expectedTypes[0];
  var receivedType = toRawType(value);
  var expectedValue = styleValue(value, expectedType);
  var receivedValue = styleValue(value, receivedType);
  // check if we need to specify expected value
  if (expectedTypes.length === 1 &&
      isExplicable(expectedType) &&
      !isBoolean(expectedType, receivedType)) {
    message += " with value " + expectedValue;
  }
  message += ", got " + receivedType + " ";
  // check if we need to specify received value
  if (isExplicable(receivedType)) {
    message += "with value " + receivedValue + ".";
  }
  return message
}

function styleValue (value, type) {
  if (type === 'String') {
    return ("\"" + value + "\"")
  } else if (type === 'Number') {
    return ("" + (Number(value)))
  } else {
    return ("" + value)
  }
}

function isExplicable (value) {
  var explicitTypes = ['string', 'number', 'boolean'];
  return explicitTypes.some(function (elem) { return value.toLowerCase() === elem; })
}

function isBoolean () {
  var args = [], len = arguments.length;
  while ( len-- ) args[ len ] = arguments[ len ];

  return args.some(function (elem) { return elem.toLowerCase() === 'boolean'; })
}

/*  */

function handleError (err, vm, info) {
  // Deactivate deps tracking while processing error handler to avoid possible infinite rendering.
  // See: https://github.com/vuejs/vuex/issues/1505
  pushTarget();
  try {
    if (vm) {
      var cur = vm;
      while ((cur = cur.$parent)) {
        var hooks = cur.$options.errorCaptured;
        if (hooks) {
          for (var i = 0; i < hooks.length; i++) {
            try {
              var capture = hooks[i].call(cur, err, vm, info) === false;
              if (capture) { return }
            } catch (e) {
              globalHandleError(e, cur, 'errorCaptured hook');
            }
          }
        }
      }
    }
    globalHandleError(err, vm, info);
  } finally {
    popTarget();
  }
}

function invokeWithErrorHandling (
  handler,
  context,
  args,
  vm,
  info
) {
  var res;
  try {
    res = args ? handler.apply(context, args) : handler.call(context);
    if (res && !res._isVue && isPromise(res) && !res._handled) {
      res.catch(function (e) { return handleError(e, vm, info + " (Promise/async)"); });
      // issue #9511
      // avoid catch triggering multiple times when nested calls
      res._handled = true;
    }
  } catch (e) {
    handleError(e, vm, info);
  }
  return res
}

function globalHandleError (err, vm, info) {
  if (config.errorHandler) {
    try {
      return config.errorHandler.call(null, err, vm, info)
    } catch (e) {
      // if the user intentionally throws the original error in the handler,
      // do not log it twice
      if (e !== err) {
        logError(e, null, 'config.errorHandler');
      }
    }
  }
  logError(err, vm, info);
}

function logError (err, vm, info) {
  if (false) {
    warn(("Error in " + info + ": \"" + (err.toString()) + "\""), vm);
  }
  /* istanbul ignore else */
  if ((inBrowser || inWeex) && typeof console !== 'undefined') {
    console.error(err);
  } else {
    throw err
  }
}

/*  */

var isUsingMicroTask = false;

var callbacks = [];
var pending = false;

function flushCallbacks () {
  pending = false;
  var copies = callbacks.slice(0);
  callbacks.length = 0;
  for (var i = 0; i < copies.length; i++) {
    copies[i]();
  }
}

// Here we have async deferring wrappers using microtasks.
// In 2.5 we used (macro) tasks (in combination with microtasks).
// However, it has subtle problems when state is changed right before repaint
// (e.g. #6813, out-in transitions).
// Also, using (macro) tasks in event handler would cause some weird behaviors
// that cannot be circumvented (e.g. #7109, #7153, #7546, #7834, #8109).
// So we now use microtasks everywhere, again.
// A major drawback of this tradeoff is that there are some scenarios
// where microtasks have too high a priority and fire in between supposedly
// sequential events (e.g. #4521, #6690, which have workarounds)
// or even between bubbling of the same event (#6566).
var timerFunc;

// The nextTick behavior leverages the microtask queue, which can be accessed
// via either native Promise.then or MutationObserver.
// MutationObserver has wider support, however it is seriously bugged in
// UIWebView in iOS >= 9.3.3 when triggered in touch event handlers. It
// completely stops working after triggering a few times... so, if native
// Promise is available, we will use it:
/* istanbul ignore next, $flow-disable-line */
if (typeof Promise !== 'undefined' && isNative(Promise)) {
  var p = Promise.resolve();
  timerFunc = function () {
    p.then(flushCallbacks);
    // In problematic UIWebViews, Promise.then doesn't completely break, but
    // it can get stuck in a weird state where callbacks are pushed into the
    // microtask queue but the queue isn't being flushed, until the browser
    // needs to do some other work, e.g. handle a timer. Therefore we can
    // "force" the microtask queue to be flushed by adding an empty timer.
    if (isIOS) { setTimeout(noop); }
  };
  isUsingMicroTask = true;
} else if (!isIE && typeof MutationObserver !== 'undefined' && (
  isNative(MutationObserver) ||
  // PhantomJS and iOS 7.x
  MutationObserver.toString() === '[object MutationObserverConstructor]'
)) {
  // Use MutationObserver where native Promise is not available,
  // e.g. PhantomJS, iOS7, Android 4.4
  // (#6466 MutationObserver is unreliable in IE11)
  var counter = 1;
  var observer = new MutationObserver(flushCallbacks);
  var textNode = document.createTextNode(String(counter));
  observer.observe(textNode, {
    characterData: true
  });
  timerFunc = function () {
    counter = (counter + 1) % 2;
    textNode.data = String(counter);
  };
  isUsingMicroTask = true;
} else if (typeof setImmediate !== 'undefined' && isNative(setImmediate)) {
  // Fallback to setImmediate.
  // Technically it leverages the (macro) task queue,
  // but it is still a better choice than setTimeout.
  timerFunc = function () {
    setImmediate(flushCallbacks);
  };
} else {
  // Fallback to setTimeout.
  timerFunc = function () {
    setTimeout(flushCallbacks, 0);
  };
}

function nextTick (cb, ctx) {
  var _resolve;
  callbacks.push(function () {
    if (cb) {
      try {
        cb.call(ctx);
      } catch (e) {
        handleError(e, ctx, 'nextTick');
      }
    } else if (_resolve) {
      _resolve(ctx);
    }
  });
  if (!pending) {
    pending = true;
    timerFunc();
  }
  // $flow-disable-line
  if (!cb && typeof Promise !== 'undefined') {
    return new Promise(function (resolve) {
      _resolve = resolve;
    })
  }
}

/*  */

var mark;
var measure;

if (false) {
  var perf = inBrowser && window.performance;
  /* istanbul ignore if */
  if (
    perf &&
    perf.mark &&
    perf.measure &&
    perf.clearMarks &&
    perf.clearMeasures
  ) {
    mark = function (tag) { return perf.mark(tag); };
    measure = function (name, startTag, endTag) {
      perf.measure(name, startTag, endTag);
      perf.clearMarks(startTag);
      perf.clearMarks(endTag);
      // perf.clearMeasures(name)
    };
  }
}

/* not type checking this file because flow doesn't play well with Proxy */

var initProxy;

if (false) {
  var allowedGlobals = makeMap(
    'Infinity,undefined,NaN,isFinite,isNaN,' +
    'parseFloat,parseInt,decodeURI,decodeURIComponent,encodeURI,encodeURIComponent,' +
    'Math,Number,Date,Array,Object,Boolean,String,RegExp,Map,Set,JSON,Intl,' +
    'require' // for Webpack/Browserify
  );

  var warnNonPresent = function (target, key) {
    warn(
      "Property or method \"" + key + "\" is not defined on the instance but " +
      'referenced during render. Make sure that this property is reactive, ' +
      'either in the data option, or for class-based components, by ' +
      'initializing the property. ' +
      'See: https://vuejs.org/v2/guide/reactivity.html#Declaring-Reactive-Properties.',
      target
    );
  };

  var warnReservedPrefix = function (target, key) {
    warn(
      "Property \"" + key + "\" must be accessed with \"$data." + key + "\" because " +
      'properties starting with "$" or "_" are not proxied in the Vue instance to ' +
      'prevent conflicts with Vue internals. ' +
      'See: https://vuejs.org/v2/api/#data',
      target
    );
  };

  var hasProxy =
    typeof Proxy !== 'undefined' && isNative(Proxy);

  if (hasProxy) {
    var isBuiltInModifier = makeMap('stop,prevent,self,ctrl,shift,alt,meta,exact');
    config.keyCodes = new Proxy(config.keyCodes, {
      set: function set (target, key, value) {
        if (isBuiltInModifier(key)) {
          warn(("Avoid overwriting built-in modifier in config.keyCodes: ." + key));
          return false
        } else {
          target[key] = value;
          return true
        }
      }
    });
  }

  var hasHandler = {
    has: function has (target, key) {
      var has = key in target;
      var isAllowed = allowedGlobals(key) ||
        (typeof key === 'string' && key.charAt(0) === '_' && !(key in target.$data));
      if (!has && !isAllowed) {
        if (key in target.$data) { warnReservedPrefix(target, key); }
        else { warnNonPresent(target, key); }
      }
      return has || !isAllowed
    }
  };

  var getHandler = {
    get: function get (target, key) {
      if (typeof key === 'string' && !(key in target)) {
        if (key in target.$data) { warnReservedPrefix(target, key); }
        else { warnNonPresent(target, key); }
      }
      return target[key]
    }
  };

  initProxy = function initProxy (vm) {
    if (hasProxy) {
      // determine which proxy handler to use
      var options = vm.$options;
      var handlers = options.render && options.render._withStripped
        ? getHandler
        : hasHandler;
      vm._renderProxy = new Proxy(vm, handlers);
    } else {
      vm._renderProxy = vm;
    }
  };
}

/*  */

var seenObjects = new _Set();

/**
 * Recursively traverse an object to evoke all converted
 * getters, so that every nested property inside the object
 * is collected as a "deep" dependency.
 */
function traverse (val) {
  _traverse(val, seenObjects);
  seenObjects.clear();
}

function _traverse (val, seen) {
  var i, keys;
  var isA = Array.isArray(val);
  if ((!isA && !isObject(val)) || Object.isFrozen(val) || val instanceof VNode) {
    return
  }
  if (val.__ob__) {
    var depId = val.__ob__.dep.id;
    if (seen.has(depId)) {
      return
    }
    seen.add(depId);
  }
  if (isA) {
    i = val.length;
    while (i--) { _traverse(val[i], seen); }
  } else {
    keys = Object.keys(val);
    i = keys.length;
    while (i--) { _traverse(val[keys[i]], seen); }
  }
}

/*  */

var normalizeEvent = cached(function (name) {
  var passive = name.charAt(0) === '&';
  name = passive ? name.slice(1) : name;
  var once$$1 = name.charAt(0) === '~'; // Prefixed last, checked first
  name = once$$1 ? name.slice(1) : name;
  var capture = name.charAt(0) === '!';
  name = capture ? name.slice(1) : name;
  return {
    name: name,
    once: once$$1,
    capture: capture,
    passive: passive
  }
});

function createFnInvoker (fns, vm) {
  function invoker () {
    var arguments$1 = arguments;

    var fns = invoker.fns;
    if (Array.isArray(fns)) {
      var cloned = fns.slice();
      for (var i = 0; i < cloned.length; i++) {
        invokeWithErrorHandling(cloned[i], null, arguments$1, vm, "v-on handler");
      }
    } else {
      // return handler return value for single handlers
      return invokeWithErrorHandling(fns, null, arguments, vm, "v-on handler")
    }
  }
  invoker.fns = fns;
  return invoker
}

function updateListeners (
  on,
  oldOn,
  add,
  remove$$1,
  createOnceHandler,
  vm
) {
  var name, def$$1, cur, old, event;
  for (name in on) {
    def$$1 = cur = on[name];
    old = oldOn[name];
    event = normalizeEvent(name);
    if (isUndef(cur)) {
      "production" !== 'production' && warn(
        "Invalid handler for event \"" + (event.name) + "\": got " + String(cur),
        vm
      );
    } else if (isUndef(old)) {
      if (isUndef(cur.fns)) {
        cur = on[name] = createFnInvoker(cur, vm);
      }
      if (isTrue(event.once)) {
        cur = on[name] = createOnceHandler(event.name, cur, event.capture);
      }
      add(event.name, cur, event.capture, event.passive, event.params);
    } else if (cur !== old) {
      old.fns = cur;
      on[name] = old;
    }
  }
  for (name in oldOn) {
    if (isUndef(on[name])) {
      event = normalizeEvent(name);
      remove$$1(event.name, oldOn[name], event.capture);
    }
  }
}

/*  */

function mergeVNodeHook (def, hookKey, hook) {
  if (def instanceof VNode) {
    def = def.data.hook || (def.data.hook = {});
  }
  var invoker;
  var oldHook = def[hookKey];

  function wrappedHook () {
    hook.apply(this, arguments);
    // important: remove merged hook to ensure it's called only once
    // and prevent memory leak
    remove(invoker.fns, wrappedHook);
  }

  if (isUndef(oldHook)) {
    // no existing hook
    invoker = createFnInvoker([wrappedHook]);
  } else {
    /* istanbul ignore if */
    if (isDef(oldHook.fns) && isTrue(oldHook.merged)) {
      // already a merged invoker
      invoker = oldHook;
      invoker.fns.push(wrappedHook);
    } else {
      // existing plain hook
      invoker = createFnInvoker([oldHook, wrappedHook]);
    }
  }

  invoker.merged = true;
  def[hookKey] = invoker;
}

/*  */

function extractPropsFromVNodeData (
  data,
  Ctor,
  tag
) {
  // we are only extracting raw values here.
  // validation and default values are handled in the child
  // component itself.
  var propOptions = Ctor.options.props;
  if (isUndef(propOptions)) {
    return
  }
  var res = {};
  var attrs = data.attrs;
  var props = data.props;
  if (isDef(attrs) || isDef(props)) {
    for (var key in propOptions) {
      var altKey = hyphenate(key);
      if (false) {
        var keyInLowerCase = key.toLowerCase();
        if (
          key !== keyInLowerCase &&
          attrs && hasOwn(attrs, keyInLowerCase)
        ) {
          tip(
            "Prop \"" + keyInLowerCase + "\" is passed to component " +
            (formatComponentName(tag || Ctor)) + ", but the declared prop name is" +
            " \"" + key + "\". " +
            "Note that HTML attributes are case-insensitive and camelCased " +
            "props need to use their kebab-case equivalents when using in-DOM " +
            "templates. You should probably use \"" + altKey + "\" instead of \"" + key + "\"."
          );
        }
      }
      checkProp(res, props, key, altKey, true) ||
      checkProp(res, attrs, key, altKey, false);
    }
  }
  return res
}

function checkProp (
  res,
  hash,
  key,
  altKey,
  preserve
) {
  if (isDef(hash)) {
    if (hasOwn(hash, key)) {
      res[key] = hash[key];
      if (!preserve) {
        delete hash[key];
      }
      return true
    } else if (hasOwn(hash, altKey)) {
      res[key] = hash[altKey];
      if (!preserve) {
        delete hash[altKey];
      }
      return true
    }
  }
  return false
}

/*  */

// The template compiler attempts to minimize the need for normalization by
// statically analyzing the template at compile time.
//
// For plain HTML markup, normalization can be completely skipped because the
// generated render function is guaranteed to return Array<VNode>. There are
// two cases where extra normalization is needed:

// 1. When the children contains components - because a functional component
// may return an Array instead of a single root. In this case, just a simple
// normalization is needed - if any child is an Array, we flatten the whole
// thing with Array.prototype.concat. It is guaranteed to be only 1-level deep
// because functional components already normalize their own children.
function simpleNormalizeChildren (children) {
  for (var i = 0; i < children.length; i++) {
    if (Array.isArray(children[i])) {
      return Array.prototype.concat.apply([], children)
    }
  }
  return children
}

// 2. When the children contains constructs that always generated nested Arrays,
// e.g. <template>, <slot>, v-for, or when the children is provided by user
// with hand-written render functions / JSX. In such cases a full normalization
// is needed to cater to all possible types of children values.
function normalizeChildren (children) {
  return isPrimitive(children)
    ? [createTextVNode(children)]
    : Array.isArray(children)
      ? normalizeArrayChildren(children)
      : undefined
}

function isTextNode (node) {
  return isDef(node) && isDef(node.text) && isFalse(node.isComment)
}

function normalizeArrayChildren (children, nestedIndex) {
  var res = [];
  var i, c, lastIndex, last;
  for (i = 0; i < children.length; i++) {
    c = children[i];
    if (isUndef(c) || typeof c === 'boolean') { continue }
    lastIndex = res.length - 1;
    last = res[lastIndex];
    //  nested
    if (Array.isArray(c)) {
      if (c.length > 0) {
        c = normalizeArrayChildren(c, ((nestedIndex || '') + "_" + i));
        // merge adjacent text nodes
        if (isTextNode(c[0]) && isTextNode(last)) {
          res[lastIndex] = createTextVNode(last.text + (c[0]).text);
          c.shift();
        }
        res.push.apply(res, c);
      }
    } else if (isPrimitive(c)) {
      if (isTextNode(last)) {
        // merge adjacent text nodes
        // this is necessary for SSR hydration because text nodes are
        // essentially merged when rendered to HTML strings
        res[lastIndex] = createTextVNode(last.text + c);
      } else if (c !== '') {
        // convert primitive to vnode
        res.push(createTextVNode(c));
      }
    } else {
      if (isTextNode(c) && isTextNode(last)) {
        // merge adjacent text nodes
        res[lastIndex] = createTextVNode(last.text + c.text);
      } else {
        // default key for nested array children (likely generated by v-for)
        if (isTrue(children._isVList) &&
          isDef(c.tag) &&
          isUndef(c.key) &&
          isDef(nestedIndex)) {
          c.key = "__vlist" + nestedIndex + "_" + i + "__";
        }
        res.push(c);
      }
    }
  }
  return res
}

/*  */

function initProvide (vm) {
  var provide = vm.$options.provide;
  if (provide) {
    vm._provided = typeof provide === 'function'
      ? provide.call(vm)
      : provide;
  }
}

function initInjections (vm) {
  var result = resolveInject(vm.$options.inject, vm);
  if (result) {
    toggleObserving(false);
    Object.keys(result).forEach(function (key) {
      /* istanbul ignore else */
      if (false) {
        defineReactive$$1(vm, key, result[key], function () {
          warn(
            "Avoid mutating an injected value directly since the changes will be " +
            "overwritten whenever the provided component re-renders. " +
            "injection being mutated: \"" + key + "\"",
            vm
          );
        });
      } else {
        defineReactive$$1(vm, key, result[key]);
      }
    });
    toggleObserving(true);
  }
}

function resolveInject (inject, vm) {
  if (inject) {
    // inject is :any because flow is not smart enough to figure out cached
    var result = Object.create(null);
    var keys = hasSymbol
      ? Reflect.ownKeys(inject)
      : Object.keys(inject);

    for (var i = 0; i < keys.length; i++) {
      var key = keys[i];
      // #6574 in case the inject object is observed...
      if (key === '__ob__') { continue }
      var provideKey = inject[key].from;
      var source = vm;
      while (source) {
        if (source._provided && hasOwn(source._provided, provideKey)) {
          result[key] = source._provided[provideKey];
          break
        }
        source = source.$parent;
      }
      if (!source) {
        if ('default' in inject[key]) {
          var provideDefault = inject[key].default;
          result[key] = typeof provideDefault === 'function'
            ? provideDefault.call(vm)
            : provideDefault;
        } else if (false) {
          warn(("Injection \"" + key + "\" not found"), vm);
        }
      }
    }
    return result
  }
}

/*  */



/**
 * Runtime helper for resolving raw children VNodes into a slot object.
 */
function resolveSlots (
  children,
  context
) {
  if (!children || !children.length) {
    return {}
  }
  var slots = {};
  for (var i = 0, l = children.length; i < l; i++) {
    var child = children[i];
    var data = child.data;
    // remove slot attribute if the node is resolved as a Vue slot node
    if (data && data.attrs && data.attrs.slot) {
      delete data.attrs.slot;
    }
    // named slots should only be respected if the vnode was rendered in the
    // same context.
    if ((child.context === context || child.fnContext === context) &&
      data && data.slot != null
    ) {
      var name = data.slot;
      var slot = (slots[name] || (slots[name] = []));
      if (child.tag === 'template') {
        slot.push.apply(slot, child.children || []);
      } else {
        slot.push(child);
      }
    } else {
      (slots.default || (slots.default = [])).push(child);
    }
  }
  // ignore slots that contains only whitespace
  for (var name$1 in slots) {
    if (slots[name$1].every(isWhitespace)) {
      delete slots[name$1];
    }
  }
  return slots
}

function isWhitespace (node) {
  return (node.isComment && !node.asyncFactory) || node.text === ' '
}

/*  */

function normalizeScopedSlots (
  slots,
  normalSlots,
  prevSlots
) {
  var res;
  var hasNormalSlots = Object.keys(normalSlots).length > 0;
  var isStable = slots ? !!slots.$stable : !hasNormalSlots;
  var key = slots && slots.$key;
  if (!slots) {
    res = {};
  } else if (slots._normalized) {
    // fast path 1: child component re-render only, parent did not change
    return slots._normalized
  } else if (
    isStable &&
    prevSlots &&
    prevSlots !== emptyObject &&
    key === prevSlots.$key &&
    !hasNormalSlots &&
    !prevSlots.$hasNormal
  ) {
    // fast path 2: stable scoped slots w/ no normal slots to proxy,
    // only need to normalize once
    return prevSlots
  } else {
    res = {};
    for (var key$1 in slots) {
      if (slots[key$1] && key$1[0] !== '$') {
        res[key$1] = normalizeScopedSlot(normalSlots, key$1, slots[key$1]);
      }
    }
  }
  // expose normal slots on scopedSlots
  for (var key$2 in normalSlots) {
    if (!(key$2 in res)) {
      res[key$2] = proxyNormalSlot(normalSlots, key$2);
    }
  }
  // avoriaz seems to mock a non-extensible $scopedSlots object
  // and when that is passed down this would cause an error
  if (slots && Object.isExtensible(slots)) {
    (slots)._normalized = res;
  }
  def(res, '$stable', isStable);
  def(res, '$key', key);
  def(res, '$hasNormal', hasNormalSlots);
  return res
}

function normalizeScopedSlot(normalSlots, key, fn) {
  var normalized = function () {
    var res = arguments.length ? fn.apply(null, arguments) : fn({});
    res = res && typeof res === 'object' && !Array.isArray(res)
      ? [res] // single vnode
      : normalizeChildren(res);
    return res && (
      res.length === 0 ||
      (res.length === 1 && res[0].isComment) // #9658
    ) ? undefined
      : res
  };
  // this is a slot using the new v-slot syntax without scope. although it is
  // compiled as a scoped slot, render fn users would expect it to be present
  // on this.$slots because the usage is semantically a normal slot.
  if (fn.proxy) {
    Object.defineProperty(normalSlots, key, {
      get: normalized,
      enumerable: true,
      configurable: true
    });
  }
  return normalized
}

function proxyNormalSlot(slots, key) {
  return function () { return slots[key]; }
}

/*  */

/**
 * Runtime helper for rendering v-for lists.
 */
function renderList (
  val,
  render
) {
  var ret, i, l, keys, key;
  if (Array.isArray(val) || typeof val === 'string') {
    ret = new Array(val.length);
    for (i = 0, l = val.length; i < l; i++) {
      ret[i] = render(val[i], i);
    }
  } else if (typeof val === 'number') {
    ret = new Array(val);
    for (i = 0; i < val; i++) {
      ret[i] = render(i + 1, i);
    }
  } else if (isObject(val)) {
    if (hasSymbol && val[Symbol.iterator]) {
      ret = [];
      var iterator = val[Symbol.iterator]();
      var result = iterator.next();
      while (!result.done) {
        ret.push(render(result.value, ret.length));
        result = iterator.next();
      }
    } else {
      keys = Object.keys(val);
      ret = new Array(keys.length);
      for (i = 0, l = keys.length; i < l; i++) {
        key = keys[i];
        ret[i] = render(val[key], key, i);
      }
    }
  }
  if (!isDef(ret)) {
    ret = [];
  }
  (ret)._isVList = true;
  return ret
}

/*  */

/**
 * Runtime helper for rendering <slot>
 */
function renderSlot (
  name,
  fallback,
  props,
  bindObject
) {
  var scopedSlotFn = this.$scopedSlots[name];
  var nodes;
  if (scopedSlotFn) { // scoped slot
    props = props || {};
    if (bindObject) {
      if (false) {
        warn(
          'slot v-bind without argument expects an Object',
          this
        );
      }
      props = extend(extend({}, bindObject), props);
    }
    nodes = scopedSlotFn(props) || fallback;
  } else {
    nodes = this.$slots[name] || fallback;
  }

  var target = props && props.slot;
  if (target) {
    return this.$createElement('template', { slot: target }, nodes)
  } else {
    return nodes
  }
}

/*  */

/**
 * Runtime helper for resolving filters
 */
function resolveFilter (id) {
  return resolveAsset(this.$options, 'filters', id, true) || identity
}

/*  */

function isKeyNotMatch (expect, actual) {
  if (Array.isArray(expect)) {
    return expect.indexOf(actual) === -1
  } else {
    return expect !== actual
  }
}

/**
 * Runtime helper for checking keyCodes from config.
 * exposed as Vue.prototype._k
 * passing in eventKeyName as last argument separately for backwards compat
 */
function checkKeyCodes (
  eventKeyCode,
  key,
  builtInKeyCode,
  eventKeyName,
  builtInKeyName
) {
  var mappedKeyCode = config.keyCodes[key] || builtInKeyCode;
  if (builtInKeyName && eventKeyName && !config.keyCodes[key]) {
    return isKeyNotMatch(builtInKeyName, eventKeyName)
  } else if (mappedKeyCode) {
    return isKeyNotMatch(mappedKeyCode, eventKeyCode)
  } else if (eventKeyName) {
    return hyphenate(eventKeyName) !== key
  }
}

/*  */

/**
 * Runtime helper for merging v-bind="object" into a VNode's data.
 */
function bindObjectProps (
  data,
  tag,
  value,
  asProp,
  isSync
) {
  if (value) {
    if (!isObject(value)) {
      "production" !== 'production' && warn(
        'v-bind without argument expects an Object or Array value',
        this
      );
    } else {
      if (Array.isArray(value)) {
        value = toObject(value);
      }
      var hash;
      var loop = function ( key ) {
        if (
          key === 'class' ||
          key === 'style' ||
          isReservedAttribute(key)
        ) {
          hash = data;
        } else {
          var type = data.attrs && data.attrs.type;
          hash = asProp || config.mustUseProp(tag, type, key)
            ? data.domProps || (data.domProps = {})
            : data.attrs || (data.attrs = {});
        }
        var camelizedKey = camelize(key);
        var hyphenatedKey = hyphenate(key);
        if (!(camelizedKey in hash) && !(hyphenatedKey in hash)) {
          hash[key] = value[key];

          if (isSync) {
            var on = data.on || (data.on = {});
            on[("update:" + key)] = function ($event) {
              value[key] = $event;
            };
          }
        }
      };

      for (var key in value) loop( key );
    }
  }
  return data
}

/*  */

/**
 * Runtime helper for rendering static trees.
 */
function renderStatic (
  index,
  isInFor
) {
  var cached = this._staticTrees || (this._staticTrees = []);
  var tree = cached[index];
  // if has already-rendered static tree and not inside v-for,
  // we can reuse the same tree.
  if (tree && !isInFor) {
    return tree
  }
  // otherwise, render a fresh tree.
  tree = cached[index] = this.$options.staticRenderFns[index].call(
    this._renderProxy,
    null,
    this // for render fns generated for functional component templates
  );
  markStatic(tree, ("__static__" + index), false);
  return tree
}

/**
 * Runtime helper for v-once.
 * Effectively it means marking the node as static with a unique key.
 */
function markOnce (
  tree,
  index,
  key
) {
  markStatic(tree, ("__once__" + index + (key ? ("_" + key) : "")), true);
  return tree
}

function markStatic (
  tree,
  key,
  isOnce
) {
  if (Array.isArray(tree)) {
    for (var i = 0; i < tree.length; i++) {
      if (tree[i] && typeof tree[i] !== 'string') {
        markStaticNode(tree[i], (key + "_" + i), isOnce);
      }
    }
  } else {
    markStaticNode(tree, key, isOnce);
  }
}

function markStaticNode (node, key, isOnce) {
  node.isStatic = true;
  node.key = key;
  node.isOnce = isOnce;
}

/*  */

function bindObjectListeners (data, value) {
  if (value) {
    if (!isPlainObject(value)) {
      "production" !== 'production' && warn(
        'v-on without argument expects an Object value',
        this
      );
    } else {
      var on = data.on = data.on ? extend({}, data.on) : {};
      for (var key in value) {
        var existing = on[key];
        var ours = value[key];
        on[key] = existing ? [].concat(existing, ours) : ours;
      }
    }
  }
  return data
}

/*  */

function resolveScopedSlots (
  fns, // see flow/vnode
  res,
  // the following are added in 2.6
  hasDynamicKeys,
  contentHashKey
) {
  res = res || { $stable: !hasDynamicKeys };
  for (var i = 0; i < fns.length; i++) {
    var slot = fns[i];
    if (Array.isArray(slot)) {
      resolveScopedSlots(slot, res, hasDynamicKeys);
    } else if (slot) {
      // marker for reverse proxying v-slot without scope on this.$slots
      if (slot.proxy) {
        slot.fn.proxy = true;
      }
      res[slot.key] = slot.fn;
    }
  }
  if (contentHashKey) {
    (res).$key = contentHashKey;
  }
  return res
}

/*  */

function bindDynamicKeys (baseObj, values) {
  for (var i = 0; i < values.length; i += 2) {
    var key = values[i];
    if (typeof key === 'string' && key) {
      baseObj[values[i]] = values[i + 1];
    } else if (false) {
      // null is a special value for explicitly removing a binding
      warn(
        ("Invalid value for dynamic directive argument (expected string or null): " + key),
        this
      );
    }
  }
  return baseObj
}

// helper to dynamically append modifier runtime markers to event names.
// ensure only append when value is already string, otherwise it will be cast
// to string and cause the type check to miss.
function prependModifier (value, symbol) {
  return typeof value === 'string' ? symbol + value : value
}

/*  */

function installRenderHelpers (target) {
  target._o = markOnce;
  target._n = toNumber;
  target._s = toString;
  target._l = renderList;
  target._t = renderSlot;
  target._q = looseEqual;
  target._i = looseIndexOf;
  target._m = renderStatic;
  target._f = resolveFilter;
  target._k = checkKeyCodes;
  target._b = bindObjectProps;
  target._v = createTextVNode;
  target._e = createEmptyVNode;
  target._u = resolveScopedSlots;
  target._g = bindObjectListeners;
  target._d = bindDynamicKeys;
  target._p = prependModifier;
}

/*  */

function FunctionalRenderContext (
  data,
  props,
  children,
  parent,
  Ctor
) {
  var this$1 = this;

  var options = Ctor.options;
  // ensure the createElement function in functional components
  // gets a unique context - this is necessary for correct named slot check
  var contextVm;
  if (hasOwn(parent, '_uid')) {
    contextVm = Object.create(parent);
    // $flow-disable-line
    contextVm._original = parent;
  } else {
    // the context vm passed in is a functional context as well.
    // in this case we want to make sure we are able to get a hold to the
    // real context instance.
    contextVm = parent;
    // $flow-disable-line
    parent = parent._original;
  }
  var isCompiled = isTrue(options._compiled);
  var needNormalization = !isCompiled;

  this.data = data;
  this.props = props;
  this.children = children;
  this.parent = parent;
  this.listeners = data.on || emptyObject;
  this.injections = resolveInject(options.inject, parent);
  this.slots = function () {
    if (!this$1.$slots) {
      normalizeScopedSlots(
        data.scopedSlots,
        this$1.$slots = resolveSlots(children, parent)
      );
    }
    return this$1.$slots
  };

  Object.defineProperty(this, 'scopedSlots', ({
    enumerable: true,
    get: function get () {
      return normalizeScopedSlots(data.scopedSlots, this.slots())
    }
  }));

  // support for compiled functional template
  if (isCompiled) {
    // exposing $options for renderStatic()
    this.$options = options;
    // pre-resolve slots for renderSlot()
    this.$slots = this.slots();
    this.$scopedSlots = normalizeScopedSlots(data.scopedSlots, this.$slots);
  }

  if (options._scopeId) {
    this._c = function (a, b, c, d) {
      var vnode = createElement(contextVm, a, b, c, d, needNormalization);
      if (vnode && !Array.isArray(vnode)) {
        vnode.fnScopeId = options._scopeId;
        vnode.fnContext = parent;
      }
      return vnode
    };
  } else {
    this._c = function (a, b, c, d) { return createElement(contextVm, a, b, c, d, needNormalization); };
  }
}

installRenderHelpers(FunctionalRenderContext.prototype);

function createFunctionalComponent (
  Ctor,
  propsData,
  data,
  contextVm,
  children
) {
  var options = Ctor.options;
  var props = {};
  var propOptions = options.props;
  if (isDef(propOptions)) {
    for (var key in propOptions) {
      props[key] = validateProp(key, propOptions, propsData || emptyObject);
    }
  } else {
    if (isDef(data.attrs)) { mergeProps(props, data.attrs); }
    if (isDef(data.props)) { mergeProps(props, data.props); }
  }

  var renderContext = new FunctionalRenderContext(
    data,
    props,
    children,
    contextVm,
    Ctor
  );

  var vnode = options.render.call(null, renderContext._c, renderContext);

  if (vnode instanceof VNode) {
    return cloneAndMarkFunctionalResult(vnode, data, renderContext.parent, options, renderContext)
  } else if (Array.isArray(vnode)) {
    var vnodes = normalizeChildren(vnode) || [];
    var res = new Array(vnodes.length);
    for (var i = 0; i < vnodes.length; i++) {
      res[i] = cloneAndMarkFunctionalResult(vnodes[i], data, renderContext.parent, options, renderContext);
    }
    return res
  }
}

function cloneAndMarkFunctionalResult (vnode, data, contextVm, options, renderContext) {
  // #7817 clone node before setting fnContext, otherwise if the node is reused
  // (e.g. it was from a cached normal slot) the fnContext causes named slots
  // that should not be matched to match.
  var clone = cloneVNode(vnode);
  clone.fnContext = contextVm;
  clone.fnOptions = options;
  if (false) {
    (clone.devtoolsMeta = clone.devtoolsMeta || {}).renderContext = renderContext;
  }
  if (data.slot) {
    (clone.data || (clone.data = {})).slot = data.slot;
  }
  return clone
}

function mergeProps (to, from) {
  for (var key in from) {
    to[camelize(key)] = from[key];
  }
}

/*  */

/*  */

/*  */

/*  */

// inline hooks to be invoked on component VNodes during patch
var componentVNodeHooks = {
  init: function init (vnode, hydrating) {
    if (
      vnode.componentInstance &&
      !vnode.componentInstance._isDestroyed &&
      vnode.data.keepAlive
    ) {
      // kept-alive components, treat as a patch
      var mountedNode = vnode; // work around flow
      componentVNodeHooks.prepatch(mountedNode, mountedNode);
    } else {
      var child = vnode.componentInstance = createComponentInstanceForVnode(
        vnode,
        activeInstance
      );
      child.$mount(hydrating ? vnode.elm : undefined, hydrating);
    }
  },

  prepatch: function prepatch (oldVnode, vnode) {
    var options = vnode.componentOptions;
    var child = vnode.componentInstance = oldVnode.componentInstance;
    updateChildComponent(
      child,
      options.propsData, // updated props
      options.listeners, // updated listeners
      vnode, // new parent vnode
      options.children // new children
    );
  },

  insert: function insert (vnode) {
    var context = vnode.context;
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isMounted) {
      componentInstance._isMounted = true;
      callHook(componentInstance, 'mounted');
    }
    if (vnode.data.keepAlive) {
      if (context._isMounted) {
        // vue-router#1212
        // During updates, a kept-alive component's child components may
        // change, so directly walking the tree here may call activated hooks
        // on incorrect children. Instead we push them into a queue which will
        // be processed after the whole patch process ended.
        queueActivatedComponent(componentInstance);
      } else {
        activateChildComponent(componentInstance, true /* direct */);
      }
    }
  },

  destroy: function destroy (vnode) {
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isDestroyed) {
      if (!vnode.data.keepAlive) {
        componentInstance.$destroy();
      } else {
        deactivateChildComponent(componentInstance, true /* direct */);
      }
    }
  }
};

var hooksToMerge = Object.keys(componentVNodeHooks);

function createComponent (
  Ctor,
  data,
  context,
  children,
  tag
) {
  if (isUndef(Ctor)) {
    return
  }

  var baseCtor = context.$options._base;

  // plain options object: turn it into a constructor
  if (isObject(Ctor)) {
    Ctor = baseCtor.extend(Ctor);
  }

  // if at this stage it's not a constructor or an async component factory,
  // reject.
  if (typeof Ctor !== 'function') {
    if (false) {
      warn(("Invalid Component definition: " + (String(Ctor))), context);
    }
    return
  }

  // async component
  var asyncFactory;
  if (isUndef(Ctor.cid)) {
    asyncFactory = Ctor;
    Ctor = resolveAsyncComponent(asyncFactory, baseCtor);
    if (Ctor === undefined) {
      // return a placeholder node for async component, which is rendered
      // as a comment node but preserves all the raw information for the node.
      // the information will be used for async server-rendering and hydration.
      return createAsyncPlaceholder(
        asyncFactory,
        data,
        context,
        children,
        tag
      )
    }
  }

  data = data || {};

  // resolve constructor options in case global mixins are applied after
  // component constructor creation
  resolveConstructorOptions(Ctor);

  // transform component v-model data into props & events
  if (isDef(data.model)) {
    transformModel(Ctor.options, data);
  }

  // extract props
  var propsData = extractPropsFromVNodeData(data, Ctor, tag);

  // functional component
  if (isTrue(Ctor.options.functional)) {
    return createFunctionalComponent(Ctor, propsData, data, context, children)
  }

  // extract listeners, since these needs to be treated as
  // child component listeners instead of DOM listeners
  var listeners = data.on;
  // replace with listeners with .native modifier
  // so it gets processed during parent component patch.
  data.on = data.nativeOn;

  if (isTrue(Ctor.options.abstract)) {
    // abstract components do not keep anything
    // other than props & listeners & slot

    // work around flow
    var slot = data.slot;
    data = {};
    if (slot) {
      data.slot = slot;
    }
  }

  // install component management hooks onto the placeholder node
  installComponentHooks(data);

  // return a placeholder vnode
  var name = Ctor.options.name || tag;
  var vnode = new VNode(
    ("vue-component-" + (Ctor.cid) + (name ? ("-" + name) : '')),
    data, undefined, undefined, undefined, context,
    { Ctor: Ctor, propsData: propsData, listeners: listeners, tag: tag, children: children },
    asyncFactory
  );

  return vnode
}

function createComponentInstanceForVnode (
  vnode, // we know it's MountedComponentVNode but flow doesn't
  parent // activeInstance in lifecycle state
) {
  var options = {
    _isComponent: true,
    _parentVnode: vnode,
    parent: parent
  };
  // check inline-template render functions
  var inlineTemplate = vnode.data.inlineTemplate;
  if (isDef(inlineTemplate)) {
    options.render = inlineTemplate.render;
    options.staticRenderFns = inlineTemplate.staticRenderFns;
  }
  return new vnode.componentOptions.Ctor(options)
}

function installComponentHooks (data) {
  var hooks = data.hook || (data.hook = {});
  for (var i = 0; i < hooksToMerge.length; i++) {
    var key = hooksToMerge[i];
    var existing = hooks[key];
    var toMerge = componentVNodeHooks[key];
    if (existing !== toMerge && !(existing && existing._merged)) {
      hooks[key] = existing ? mergeHook$1(toMerge, existing) : toMerge;
    }
  }
}

function mergeHook$1 (f1, f2) {
  var merged = function (a, b) {
    // flow complains about extra args which is why we use any
    f1(a, b);
    f2(a, b);
  };
  merged._merged = true;
  return merged
}

// transform component v-model info (value and callback) into
// prop and event handler respectively.
function transformModel (options, data) {
  var prop = (options.model && options.model.prop) || 'value';
  var event = (options.model && options.model.event) || 'input'
  ;(data.attrs || (data.attrs = {}))[prop] = data.model.value;
  var on = data.on || (data.on = {});
  var existing = on[event];
  var callback = data.model.callback;
  if (isDef(existing)) {
    if (
      Array.isArray(existing)
        ? existing.indexOf(callback) === -1
        : existing !== callback
    ) {
      on[event] = [callback].concat(existing);
    }
  } else {
    on[event] = callback;
  }
}

/*  */

var SIMPLE_NORMALIZE = 1;
var ALWAYS_NORMALIZE = 2;

// wrapper function for providing a more flexible interface
// without getting yelled at by flow
function createElement (
  context,
  tag,
  data,
  children,
  normalizationType,
  alwaysNormalize
) {
  if (Array.isArray(data) || isPrimitive(data)) {
    normalizationType = children;
    children = data;
    data = undefined;
  }
  if (isTrue(alwaysNormalize)) {
    normalizationType = ALWAYS_NORMALIZE;
  }
  return _createElement(context, tag, data, children, normalizationType)
}

function _createElement (
  context,
  tag,
  data,
  children,
  normalizationType
) {
  if (isDef(data) && isDef((data).__ob__)) {
    "production" !== 'production' && warn(
      "Avoid using observed data object as vnode data: " + (JSON.stringify(data)) + "\n" +
      'Always create fresh vnode data objects in each render!',
      context
    );
    return createEmptyVNode()
  }
  // object syntax in v-bind
  if (isDef(data) && isDef(data.is)) {
    tag = data.is;
  }
  if (!tag) {
    // in case of component :is set to falsy value
    return createEmptyVNode()
  }
  // warn against non-primitive key
  if (false
  ) {
    {
      warn(
        'Avoid using non-primitive value as key, ' +
        'use string/number value instead.',
        context
      );
    }
  }
  // support single function children as default scoped slot
  if (Array.isArray(children) &&
    typeof children[0] === 'function'
  ) {
    data = data || {};
    data.scopedSlots = { default: children[0] };
    children.length = 0;
  }
  if (normalizationType === ALWAYS_NORMALIZE) {
    children = normalizeChildren(children);
  } else if (normalizationType === SIMPLE_NORMALIZE) {
    children = simpleNormalizeChildren(children);
  }
  var vnode, ns;
  if (typeof tag === 'string') {
    var Ctor;
    ns = (context.$vnode && context.$vnode.ns) || config.getTagNamespace(tag);
    if (config.isReservedTag(tag)) {
      // platform built-in elements
      if (false) {
        warn(
          ("The .native modifier for v-on is only valid on components but it was used on <" + tag + ">."),
          context
        );
      }
      vnode = new VNode(
        config.parsePlatformTagName(tag), data, children,
        undefined, undefined, context
      );
    } else if ((!data || !data.pre) && isDef(Ctor = resolveAsset(context.$options, 'components', tag))) {
      // component
      vnode = createComponent(Ctor, data, context, children, tag);
    } else {
      // unknown or unlisted namespaced elements
      // check at runtime because it may get assigned a namespace when its
      // parent normalizes children
      vnode = new VNode(
        tag, data, children,
        undefined, undefined, context
      );
    }
  } else {
    // direct component options / constructor
    vnode = createComponent(tag, data, context, children);
  }
  if (Array.isArray(vnode)) {
    return vnode
  } else if (isDef(vnode)) {
    if (isDef(ns)) { applyNS(vnode, ns); }
    if (isDef(data)) { registerDeepBindings(data); }
    return vnode
  } else {
    return createEmptyVNode()
  }
}

function applyNS (vnode, ns, force) {
  vnode.ns = ns;
  if (vnode.tag === 'foreignObject') {
    // use default namespace inside foreignObject
    ns = undefined;
    force = true;
  }
  if (isDef(vnode.children)) {
    for (var i = 0, l = vnode.children.length; i < l; i++) {
      var child = vnode.children[i];
      if (isDef(child.tag) && (
        isUndef(child.ns) || (isTrue(force) && child.tag !== 'svg'))) {
        applyNS(child, ns, force);
      }
    }
  }
}

// ref #5318
// necessary to ensure parent re-render when deep bindings like :style and
// :class are used on slot nodes
function registerDeepBindings (data) {
  if (isObject(data.style)) {
    traverse(data.style);
  }
  if (isObject(data.class)) {
    traverse(data.class);
  }
}

/*  */

function initRender (vm) {
  vm._vnode = null; // the root of the child tree
  vm._staticTrees = null; // v-once cached trees
  var options = vm.$options;
  var parentVnode = vm.$vnode = options._parentVnode; // the placeholder node in parent tree
  var renderContext = parentVnode && parentVnode.context;
  vm.$slots = resolveSlots(options._renderChildren, renderContext);
  vm.$scopedSlots = emptyObject;
  // bind the createElement fn to this instance
  // so that we get proper render context inside it.
  // args order: tag, data, children, normalizationType, alwaysNormalize
  // internal version is used by render functions compiled from templates
  vm._c = function (a, b, c, d) { return createElement(vm, a, b, c, d, false); };
  // normalization is always applied for the public version, used in
  // user-written render functions.
  vm.$createElement = function (a, b, c, d) { return createElement(vm, a, b, c, d, true); };

  // $attrs & $listeners are exposed for easier HOC creation.
  // they need to be reactive so that HOCs using them are always updated
  var parentData = parentVnode && parentVnode.data;

  /* istanbul ignore else */
  if (false) {
    defineReactive$$1(vm, '$attrs', parentData && parentData.attrs || emptyObject, function () {
      !isUpdatingChildComponent && warn("$attrs is readonly.", vm);
    }, true);
    defineReactive$$1(vm, '$listeners', options._parentListeners || emptyObject, function () {
      !isUpdatingChildComponent && warn("$listeners is readonly.", vm);
    }, true);
  } else {
    defineReactive$$1(vm, '$attrs', parentData && parentData.attrs || emptyObject, null, true);
    defineReactive$$1(vm, '$listeners', options._parentListeners || emptyObject, null, true);
  }
}

var currentRenderingInstance = null;

function renderMixin (Vue) {
  // install runtime convenience helpers
  installRenderHelpers(Vue.prototype);

  Vue.prototype.$nextTick = function (fn) {
    return nextTick(fn, this)
  };

  Vue.prototype._render = function () {
    var vm = this;
    var ref = vm.$options;
    var render = ref.render;
    var _parentVnode = ref._parentVnode;

    if (_parentVnode) {
      vm.$scopedSlots = normalizeScopedSlots(
        _parentVnode.data.scopedSlots,
        vm.$slots,
        vm.$scopedSlots
      );
    }

    // set parent vnode. this allows render functions to have access
    // to the data on the placeholder node.
    vm.$vnode = _parentVnode;
    // render self
    var vnode;
    try {
      // There's no need to maintain a stack because all render fns are called
      // separately from one another. Nested component's render fns are called
      // when parent component is patched.
      currentRenderingInstance = vm;
      vnode = render.call(vm._renderProxy, vm.$createElement);
    } catch (e) {
      handleError(e, vm, "render");
      // return error render result,
      // or previous vnode to prevent render error causing blank component
      /* istanbul ignore else */
      if (false) {
        try {
          vnode = vm.$options.renderError.call(vm._renderProxy, vm.$createElement, e);
        } catch (e) {
          handleError(e, vm, "renderError");
          vnode = vm._vnode;
        }
      } else {
        vnode = vm._vnode;
      }
    } finally {
      currentRenderingInstance = null;
    }
    // if the returned array contains only a single node, allow it
    if (Array.isArray(vnode) && vnode.length === 1) {
      vnode = vnode[0];
    }
    // return empty vnode in case the render function errored out
    if (!(vnode instanceof VNode)) {
      if (false) {
        warn(
          'Multiple root nodes returned from render function. Render function ' +
          'should return a single root node.',
          vm
        );
      }
      vnode = createEmptyVNode();
    }
    // set parent
    vnode.parent = _parentVnode;
    return vnode
  };
}

/*  */

function ensureCtor (comp, base) {
  if (
    comp.__esModule ||
    (hasSymbol && comp[Symbol.toStringTag] === 'Module')
  ) {
    comp = comp.default;
  }
  return isObject(comp)
    ? base.extend(comp)
    : comp
}

function createAsyncPlaceholder (
  factory,
  data,
  context,
  children,
  tag
) {
  var node = createEmptyVNode();
  node.asyncFactory = factory;
  node.asyncMeta = { data: data, context: context, children: children, tag: tag };
  return node
}

function resolveAsyncComponent (
  factory,
  baseCtor
) {
  if (isTrue(factory.error) && isDef(factory.errorComp)) {
    return factory.errorComp
  }

  if (isDef(factory.resolved)) {
    return factory.resolved
  }

  var owner = currentRenderingInstance;
  if (owner && isDef(factory.owners) && factory.owners.indexOf(owner) === -1) {
    // already pending
    factory.owners.push(owner);
  }

  if (isTrue(factory.loading) && isDef(factory.loadingComp)) {
    return factory.loadingComp
  }

  if (owner && !isDef(factory.owners)) {
    var owners = factory.owners = [owner];
    var sync = true;
    var timerLoading = null;
    var timerTimeout = null

    ;(owner).$on('hook:destroyed', function () { return remove(owners, owner); });

    var forceRender = function (renderCompleted) {
      for (var i = 0, l = owners.length; i < l; i++) {
        (owners[i]).$forceUpdate();
      }

      if (renderCompleted) {
        owners.length = 0;
        if (timerLoading !== null) {
          clearTimeout(timerLoading);
          timerLoading = null;
        }
        if (timerTimeout !== null) {
          clearTimeout(timerTimeout);
          timerTimeout = null;
        }
      }
    };

    var resolve = once(function (res) {
      // cache resolved
      factory.resolved = ensureCtor(res, baseCtor);
      // invoke callbacks only if this is not a synchronous resolve
      // (async resolves are shimmed as synchronous during SSR)
      if (!sync) {
        forceRender(true);
      } else {
        owners.length = 0;
      }
    });

    var reject = once(function (reason) {
      "production" !== 'production' && warn(
        "Failed to resolve async component: " + (String(factory)) +
        (reason ? ("\nReason: " + reason) : '')
      );
      if (isDef(factory.errorComp)) {
        factory.error = true;
        forceRender(true);
      }
    });

    var res = factory(resolve, reject);

    if (isObject(res)) {
      if (isPromise(res)) {
        // () => Promise
        if (isUndef(factory.resolved)) {
          res.then(resolve, reject);
        }
      } else if (isPromise(res.component)) {
        res.component.then(resolve, reject);

        if (isDef(res.error)) {
          factory.errorComp = ensureCtor(res.error, baseCtor);
        }

        if (isDef(res.loading)) {
          factory.loadingComp = ensureCtor(res.loading, baseCtor);
          if (res.delay === 0) {
            factory.loading = true;
          } else {
            timerLoading = setTimeout(function () {
              timerLoading = null;
              if (isUndef(factory.resolved) && isUndef(factory.error)) {
                factory.loading = true;
                forceRender(false);
              }
            }, res.delay || 200);
          }
        }

        if (isDef(res.timeout)) {
          timerTimeout = setTimeout(function () {
            timerTimeout = null;
            if (isUndef(factory.resolved)) {
              reject(
                 false
                  ? ("timeout (" + (res.timeout) + "ms)")
                  : null
              );
            }
          }, res.timeout);
        }
      }
    }

    sync = false;
    // return in case resolved synchronously
    return factory.loading
      ? factory.loadingComp
      : factory.resolved
  }
}

/*  */

function isAsyncPlaceholder (node) {
  return node.isComment && node.asyncFactory
}

/*  */

function getFirstComponentChild (children) {
  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      var c = children[i];
      if (isDef(c) && (isDef(c.componentOptions) || isAsyncPlaceholder(c))) {
        return c
      }
    }
  }
}

/*  */

/*  */

function initEvents (vm) {
  vm._events = Object.create(null);
  vm._hasHookEvent = false;
  // init parent attached events
  var listeners = vm.$options._parentListeners;
  if (listeners) {
    updateComponentListeners(vm, listeners);
  }
}

var target;

function add (event, fn) {
  target.$on(event, fn);
}

function remove$1 (event, fn) {
  target.$off(event, fn);
}

function createOnceHandler (event, fn) {
  var _target = target;
  return function onceHandler () {
    var res = fn.apply(null, arguments);
    if (res !== null) {
      _target.$off(event, onceHandler);
    }
  }
}

function updateComponentListeners (
  vm,
  listeners,
  oldListeners
) {
  target = vm;
  updateListeners(listeners, oldListeners || {}, add, remove$1, createOnceHandler, vm);
  target = undefined;
}

function eventsMixin (Vue) {
  var hookRE = /^hook:/;
  Vue.prototype.$on = function (event, fn) {
    var vm = this;
    if (Array.isArray(event)) {
      for (var i = 0, l = event.length; i < l; i++) {
        vm.$on(event[i], fn);
      }
    } else {
      (vm._events[event] || (vm._events[event] = [])).push(fn);
      // optimize hook:event cost by using a boolean flag marked at registration
      // instead of a hash lookup
      if (hookRE.test(event)) {
        vm._hasHookEvent = true;
      }
    }
    return vm
  };

  Vue.prototype.$once = function (event, fn) {
    var vm = this;
    function on () {
      vm.$off(event, on);
      fn.apply(vm, arguments);
    }
    on.fn = fn;
    vm.$on(event, on);
    return vm
  };

  Vue.prototype.$off = function (event, fn) {
    var vm = this;
    // all
    if (!arguments.length) {
      vm._events = Object.create(null);
      return vm
    }
    // array of events
    if (Array.isArray(event)) {
      for (var i$1 = 0, l = event.length; i$1 < l; i$1++) {
        vm.$off(event[i$1], fn);
      }
      return vm
    }
    // specific event
    var cbs = vm._events[event];
    if (!cbs) {
      return vm
    }
    if (!fn) {
      vm._events[event] = null;
      return vm
    }
    // specific handler
    var cb;
    var i = cbs.length;
    while (i--) {
      cb = cbs[i];
      if (cb === fn || cb.fn === fn) {
        cbs.splice(i, 1);
        break
      }
    }
    return vm
  };

  Vue.prototype.$emit = function (event) {
    var vm = this;
    if (false) {
      var lowerCaseEvent = event.toLowerCase();
      if (lowerCaseEvent !== event && vm._events[lowerCaseEvent]) {
        tip(
          "Event \"" + lowerCaseEvent + "\" is emitted in component " +
          (formatComponentName(vm)) + " but the handler is registered for \"" + event + "\". " +
          "Note that HTML attributes are case-insensitive and you cannot use " +
          "v-on to listen to camelCase events when using in-DOM templates. " +
          "You should probably use \"" + (hyphenate(event)) + "\" instead of \"" + event + "\"."
        );
      }
    }
    var cbs = vm._events[event];
    if (cbs) {
      cbs = cbs.length > 1 ? toArray(cbs) : cbs;
      var args = toArray(arguments, 1);
      var info = "event handler for \"" + event + "\"";
      for (var i = 0, l = cbs.length; i < l; i++) {
        invokeWithErrorHandling(cbs[i], vm, args, vm, info);
      }
    }
    return vm
  };
}

/*  */

var activeInstance = null;
var isUpdatingChildComponent = false;

function setActiveInstance(vm) {
  var prevActiveInstance = activeInstance;
  activeInstance = vm;
  return function () {
    activeInstance = prevActiveInstance;
  }
}

function initLifecycle (vm) {
  var options = vm.$options;

  // locate first non-abstract parent
  var parent = options.parent;
  if (parent && !options.abstract) {
    while (parent.$options.abstract && parent.$parent) {
      parent = parent.$parent;
    }
    parent.$children.push(vm);
  }

  vm.$parent = parent;
  vm.$root = parent ? parent.$root : vm;

  vm.$children = [];
  vm.$refs = {};

  vm._watcher = null;
  vm._inactive = null;
  vm._directInactive = false;
  vm._isMounted = false;
  vm._isDestroyed = false;
  vm._isBeingDestroyed = false;
}

function lifecycleMixin (Vue) {
  Vue.prototype._update = function (vnode, hydrating) {
    var vm = this;
    var prevEl = vm.$el;
    var prevVnode = vm._vnode;
    var restoreActiveInstance = setActiveInstance(vm);
    vm._vnode = vnode;
    // Vue.prototype.__patch__ is injected in entry points
    // based on the rendering backend used.
    if (!prevVnode) {
      // initial render
      vm.$el = vm.__patch__(vm.$el, vnode, hydrating, false /* removeOnly */);
    } else {
      // updates
      vm.$el = vm.__patch__(prevVnode, vnode);
    }
    restoreActiveInstance();
    // update __vue__ reference
    if (prevEl) {
      prevEl.__vue__ = null;
    }
    if (vm.$el) {
      vm.$el.__vue__ = vm;
    }
    // if parent is an HOC, update its $el as well
    if (vm.$vnode && vm.$parent && vm.$vnode === vm.$parent._vnode) {
      vm.$parent.$el = vm.$el;
    }
    // updated hook is called by the scheduler to ensure that children are
    // updated in a parent's updated hook.
  };

  Vue.prototype.$forceUpdate = function () {
    var vm = this;
    if (vm._watcher) {
      vm._watcher.update();
    }
  };

  Vue.prototype.$destroy = function () {
    var vm = this;
    if (vm._isBeingDestroyed) {
      return
    }
    callHook(vm, 'beforeDestroy');
    vm._isBeingDestroyed = true;
    // remove self from parent
    var parent = vm.$parent;
    if (parent && !parent._isBeingDestroyed && !vm.$options.abstract) {
      remove(parent.$children, vm);
    }
    // teardown watchers
    if (vm._watcher) {
      vm._watcher.teardown();
    }
    var i = vm._watchers.length;
    while (i--) {
      vm._watchers[i].teardown();
    }
    // remove reference from data ob
    // frozen object may not have observer.
    if (vm._data.__ob__) {
      vm._data.__ob__.vmCount--;
    }
    // call the last hook...
    vm._isDestroyed = true;
    // invoke destroy hooks on current rendered tree
    vm.__patch__(vm._vnode, null);
    // fire destroyed hook
    callHook(vm, 'destroyed');
    // turn off all instance listeners.
    vm.$off();
    // remove __vue__ reference
    if (vm.$el) {
      vm.$el.__vue__ = null;
    }
    // release circular reference (#6759)
    if (vm.$vnode) {
      vm.$vnode.parent = null;
    }
  };
}

function mountComponent (
  vm,
  el,
  hydrating
) {
  vm.$el = el;
  if (!vm.$options.render) {
    vm.$options.render = createEmptyVNode;
    if (false) {
      /* istanbul ignore if */
      if ((vm.$options.template && vm.$options.template.charAt(0) !== '#') ||
        vm.$options.el || el) {
        warn(
          'You are using the runtime-only build of Vue where the template ' +
          'compiler is not available. Either pre-compile the templates into ' +
          'render functions, or use the compiler-included build.',
          vm
        );
      } else {
        warn(
          'Failed to mount component: template or render function not defined.',
          vm
        );
      }
    }
  }
  callHook(vm, 'beforeMount');

  var updateComponent;
  /* istanbul ignore if */
  if (false) {
    updateComponent = function () {
      var name = vm._name;
      var id = vm._uid;
      var startTag = "vue-perf-start:" + id;
      var endTag = "vue-perf-end:" + id;

      mark(startTag);
      var vnode = vm._render();
      mark(endTag);
      measure(("vue " + name + " render"), startTag, endTag);

      mark(startTag);
      vm._update(vnode, hydrating);
      mark(endTag);
      measure(("vue " + name + " patch"), startTag, endTag);
    };
  } else {
    updateComponent = function () {
      vm._update(vm._render(), hydrating);
    };
  }

  // we set this to vm._watcher inside the watcher's constructor
  // since the watcher's initial patch may call $forceUpdate (e.g. inside child
  // component's mounted hook), which relies on vm._watcher being already defined
  new Watcher(vm, updateComponent, noop, {
    before: function before () {
      if (vm._isMounted && !vm._isDestroyed) {
        callHook(vm, 'beforeUpdate');
      }
    }
  }, true /* isRenderWatcher */);
  hydrating = false;

  // manually mounted instance, call mounted on self
  // mounted is called for render-created child components in its inserted hook
  if (vm.$vnode == null) {
    vm._isMounted = true;
    callHook(vm, 'mounted');
  }
  return vm
}

function updateChildComponent (
  vm,
  propsData,
  listeners,
  parentVnode,
  renderChildren
) {
  if (false) {
    isUpdatingChildComponent = true;
  }

  // determine whether component has slot children
  // we need to do this before overwriting $options._renderChildren.

  // check if there are dynamic scopedSlots (hand-written or compiled but with
  // dynamic slot names). Static scoped slots compiled from template has the
  // "$stable" marker.
  var newScopedSlots = parentVnode.data.scopedSlots;
  var oldScopedSlots = vm.$scopedSlots;
  var hasDynamicScopedSlot = !!(
    (newScopedSlots && !newScopedSlots.$stable) ||
    (oldScopedSlots !== emptyObject && !oldScopedSlots.$stable) ||
    (newScopedSlots && vm.$scopedSlots.$key !== newScopedSlots.$key)
  );

  // Any static slot children from the parent may have changed during parent's
  // update. Dynamic scoped slots may also have changed. In such cases, a forced
  // update is necessary to ensure correctness.
  var needsForceUpdate = !!(
    renderChildren ||               // has new static slots
    vm.$options._renderChildren ||  // has old static slots
    hasDynamicScopedSlot
  );

  vm.$options._parentVnode = parentVnode;
  vm.$vnode = parentVnode; // update vm's placeholder node without re-render

  if (vm._vnode) { // update child tree's parent
    vm._vnode.parent = parentVnode;
  }
  vm.$options._renderChildren = renderChildren;

  // update $attrs and $listeners hash
  // these are also reactive so they may trigger child update if the child
  // used them during render
  vm.$attrs = parentVnode.data.attrs || emptyObject;
  vm.$listeners = listeners || emptyObject;

  // update props
  if (propsData && vm.$options.props) {
    toggleObserving(false);
    var props = vm._props;
    var propKeys = vm.$options._propKeys || [];
    for (var i = 0; i < propKeys.length; i++) {
      var key = propKeys[i];
      var propOptions = vm.$options.props; // wtf flow?
      props[key] = validateProp(key, propOptions, propsData, vm);
    }
    toggleObserving(true);
    // keep a copy of raw propsData
    vm.$options.propsData = propsData;
  }

  // update listeners
  listeners = listeners || emptyObject;
  var oldListeners = vm.$options._parentListeners;
  vm.$options._parentListeners = listeners;
  updateComponentListeners(vm, listeners, oldListeners);

  // resolve slots + force update if has children
  if (needsForceUpdate) {
    vm.$slots = resolveSlots(renderChildren, parentVnode.context);
    vm.$forceUpdate();
  }

  if (false) {
    isUpdatingChildComponent = false;
  }
}

function isInInactiveTree (vm) {
  while (vm && (vm = vm.$parent)) {
    if (vm._inactive) { return true }
  }
  return false
}

function activateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = false;
    if (isInInactiveTree(vm)) {
      return
    }
  } else if (vm._directInactive) {
    return
  }
  if (vm._inactive || vm._inactive === null) {
    vm._inactive = false;
    for (var i = 0; i < vm.$children.length; i++) {
      activateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'activated');
  }
}

function deactivateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = true;
    if (isInInactiveTree(vm)) {
      return
    }
  }
  if (!vm._inactive) {
    vm._inactive = true;
    for (var i = 0; i < vm.$children.length; i++) {
      deactivateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'deactivated');
  }
}

function callHook (vm, hook) {
  // #7573 disable dep collection when invoking lifecycle hooks
  pushTarget();
  var handlers = vm.$options[hook];
  var info = hook + " hook";
  if (handlers) {
    for (var i = 0, j = handlers.length; i < j; i++) {
      invokeWithErrorHandling(handlers[i], vm, null, vm, info);
    }
  }
  if (vm._hasHookEvent) {
    vm.$emit('hook:' + hook);
  }
  popTarget();
}

/*  */

var MAX_UPDATE_COUNT = 100;

var queue = [];
var activatedChildren = [];
var has = {};
var circular = {};
var waiting = false;
var flushing = false;
var index = 0;

/**
 * Reset the scheduler's state.
 */
function resetSchedulerState () {
  index = queue.length = activatedChildren.length = 0;
  has = {};
  if (false) {
    circular = {};
  }
  waiting = flushing = false;
}

// Async edge case #6566 requires saving the timestamp when event listeners are
// attached. However, calling performance.now() has a perf overhead especially
// if the page has thousands of event listeners. Instead, we take a timestamp
// every time the scheduler flushes and use that for all event listeners
// attached during that flush.
var currentFlushTimestamp = 0;

// Async edge case fix requires storing an event listener's attach timestamp.
var getNow = Date.now;

// Determine what event timestamp the browser is using. Annoyingly, the
// timestamp can either be hi-res (relative to page load) or low-res
// (relative to UNIX epoch), so in order to compare time we have to use the
// same timestamp type when saving the flush timestamp.
// All IE versions use low-res event timestamps, and have problematic clock
// implementations (#9632)
if (inBrowser && !isIE) {
  var performance = window.performance;
  if (
    performance &&
    typeof performance.now === 'function' &&
    getNow() > document.createEvent('Event').timeStamp
  ) {
    // if the event timestamp, although evaluated AFTER the Date.now(), is
    // smaller than it, it means the event is using a hi-res timestamp,
    // and we need to use the hi-res version for event listener timestamps as
    // well.
    getNow = function () { return performance.now(); };
  }
}

/**
 * Flush both queues and run the watchers.
 */
function flushSchedulerQueue () {
  currentFlushTimestamp = getNow();
  flushing = true;
  var watcher, id;

  // Sort queue before flush.
  // This ensures that:
  // 1. Components are updated from parent to child. (because parent is always
  //    created before the child)
  // 2. A component's user watchers are run before its render watcher (because
  //    user watchers are created before the render watcher)
  // 3. If a component is destroyed during a parent component's watcher run,
  //    its watchers can be skipped.
  queue.sort(function (a, b) { return a.id - b.id; });

  // do not cache length because more watchers might be pushed
  // as we run existing watchers
  for (index = 0; index < queue.length; index++) {
    watcher = queue[index];
    if (watcher.before) {
      watcher.before();
    }
    id = watcher.id;
    has[id] = null;
    watcher.run();
    // in dev build, check and stop circular updates.
    if (false) {
      circular[id] = (circular[id] || 0) + 1;
      if (circular[id] > MAX_UPDATE_COUNT) {
        warn(
          'You may have an infinite update loop ' + (
            watcher.user
              ? ("in watcher with expression \"" + (watcher.expression) + "\"")
              : "in a component render function."
          ),
          watcher.vm
        );
        break
      }
    }
  }

  // keep copies of post queues before resetting state
  var activatedQueue = activatedChildren.slice();
  var updatedQueue = queue.slice();

  resetSchedulerState();

  // call component updated and activated hooks
  callActivatedHooks(activatedQueue);
  callUpdatedHooks(updatedQueue);

  // devtool hook
  /* istanbul ignore if */
  if (devtools && config.devtools) {
    devtools.emit('flush');
  }
}

function callUpdatedHooks (queue) {
  var i = queue.length;
  while (i--) {
    var watcher = queue[i];
    var vm = watcher.vm;
    if (vm._watcher === watcher && vm._isMounted && !vm._isDestroyed) {
      callHook(vm, 'updated');
    }
  }
}

/**
 * Queue a kept-alive component that was activated during patch.
 * The queue will be processed after the entire tree has been patched.
 */
function queueActivatedComponent (vm) {
  // setting _inactive to false here so that a render function can
  // rely on checking whether it's in an inactive tree (e.g. router-view)
  vm._inactive = false;
  activatedChildren.push(vm);
}

function callActivatedHooks (queue) {
  for (var i = 0; i < queue.length; i++) {
    queue[i]._inactive = true;
    activateChildComponent(queue[i], true /* true */);
  }
}

/**
 * Push a watcher into the watcher queue.
 * Jobs with duplicate IDs will be skipped unless it's
 * pushed when the queue is being flushed.
 */
function queueWatcher (watcher) {
  var id = watcher.id;
  if (has[id] == null) {
    has[id] = true;
    if (!flushing) {
      queue.push(watcher);
    } else {
      // if already flushing, splice the watcher based on its id
      // if already past its id, it will be run next immediately.
      var i = queue.length - 1;
      while (i > index && queue[i].id > watcher.id) {
        i--;
      }
      queue.splice(i + 1, 0, watcher);
    }
    // queue the flush
    if (!waiting) {
      waiting = true;

      if (false) {
        flushSchedulerQueue();
        return
      }
      nextTick(flushSchedulerQueue);
    }
  }
}

/*  */



var uid$2 = 0;

/**
 * A watcher parses an expression, collects dependencies,
 * and fires callback when the expression value changes.
 * This is used for both the $watch() api and directives.
 */
var Watcher = function Watcher (
  vm,
  expOrFn,
  cb,
  options,
  isRenderWatcher
) {
  this.vm = vm;
  if (isRenderWatcher) {
    vm._watcher = this;
  }
  vm._watchers.push(this);
  // options
  if (options) {
    this.deep = !!options.deep;
    this.user = !!options.user;
    this.lazy = !!options.lazy;
    this.sync = !!options.sync;
    this.before = options.before;
  } else {
    this.deep = this.user = this.lazy = this.sync = false;
  }
  this.cb = cb;
  this.id = ++uid$2; // uid for batching
  this.active = true;
  this.dirty = this.lazy; // for lazy watchers
  this.deps = [];
  this.newDeps = [];
  this.depIds = new _Set();
  this.newDepIds = new _Set();
  this.expression =  false
    ? expOrFn.toString()
    : '';
  // parse expression for getter
  if (typeof expOrFn === 'function') {
    this.getter = expOrFn;
  } else {
    this.getter = parsePath(expOrFn);
    if (!this.getter) {
      this.getter = noop;
      "production" !== 'production' && warn(
        "Failed watching path: \"" + expOrFn + "\" " +
        'Watcher only accepts simple dot-delimited paths. ' +
        'For full control, use a function instead.',
        vm
      );
    }
  }
  this.value = this.lazy
    ? undefined
    : this.get();
};

/**
 * Evaluate the getter, and re-collect dependencies.
 */
Watcher.prototype.get = function get () {
  pushTarget(this);
  var value;
  var vm = this.vm;
  try {
    value = this.getter.call(vm, vm);
  } catch (e) {
    if (this.user) {
      handleError(e, vm, ("getter for watcher \"" + (this.expression) + "\""));
    } else {
      throw e
    }
  } finally {
    // "touch" every property so they are all tracked as
    // dependencies for deep watching
    if (this.deep) {
      traverse(value);
    }
    popTarget();
    this.cleanupDeps();
  }
  return value
};

/**
 * Add a dependency to this directive.
 */
Watcher.prototype.addDep = function addDep (dep) {
  var id = dep.id;
  if (!this.newDepIds.has(id)) {
    this.newDepIds.add(id);
    this.newDeps.push(dep);
    if (!this.depIds.has(id)) {
      dep.addSub(this);
    }
  }
};

/**
 * Clean up for dependency collection.
 */
Watcher.prototype.cleanupDeps = function cleanupDeps () {
  var i = this.deps.length;
  while (i--) {
    var dep = this.deps[i];
    if (!this.newDepIds.has(dep.id)) {
      dep.removeSub(this);
    }
  }
  var tmp = this.depIds;
  this.depIds = this.newDepIds;
  this.newDepIds = tmp;
  this.newDepIds.clear();
  tmp = this.deps;
  this.deps = this.newDeps;
  this.newDeps = tmp;
  this.newDeps.length = 0;
};

/**
 * Subscriber interface.
 * Will be called when a dependency changes.
 */
Watcher.prototype.update = function update () {
  /* istanbul ignore else */
  if (this.lazy) {
    this.dirty = true;
  } else if (this.sync) {
    this.run();
  } else {
    queueWatcher(this);
  }
};

/**
 * Scheduler job interface.
 * Will be called by the scheduler.
 */
Watcher.prototype.run = function run () {
  if (this.active) {
    var value = this.get();
    if (
      value !== this.value ||
      // Deep watchers and watchers on Object/Arrays should fire even
      // when the value is the same, because the value may
      // have mutated.
      isObject(value) ||
      this.deep
    ) {
      // set new value
      var oldValue = this.value;
      this.value = value;
      if (this.user) {
        try {
          this.cb.call(this.vm, value, oldValue);
        } catch (e) {
          handleError(e, this.vm, ("callback for watcher \"" + (this.expression) + "\""));
        }
      } else {
        this.cb.call(this.vm, value, oldValue);
      }
    }
  }
};

/**
 * Evaluate the value of the watcher.
 * This only gets called for lazy watchers.
 */
Watcher.prototype.evaluate = function evaluate () {
  this.value = this.get();
  this.dirty = false;
};

/**
 * Depend on all deps collected by this watcher.
 */
Watcher.prototype.depend = function depend () {
  var i = this.deps.length;
  while (i--) {
    this.deps[i].depend();
  }
};

/**
 * Remove self from all dependencies' subscriber list.
 */
Watcher.prototype.teardown = function teardown () {
  if (this.active) {
    // remove self from vm's watcher list
    // this is a somewhat expensive operation so we skip it
    // if the vm is being destroyed.
    if (!this.vm._isBeingDestroyed) {
      remove(this.vm._watchers, this);
    }
    var i = this.deps.length;
    while (i--) {
      this.deps[i].removeSub(this);
    }
    this.active = false;
  }
};

/*  */

var sharedPropertyDefinition = {
  enumerable: true,
  configurable: true,
  get: noop,
  set: noop
};

function proxy (target, sourceKey, key) {
  sharedPropertyDefinition.get = function proxyGetter () {
    return this[sourceKey][key]
  };
  sharedPropertyDefinition.set = function proxySetter (val) {
    this[sourceKey][key] = val;
  };
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function initState (vm) {
  vm._watchers = [];
  var opts = vm.$options;
  if (opts.props) { initProps(vm, opts.props); }
  if (opts.methods) { initMethods(vm, opts.methods); }
  if (opts.data) {
    initData(vm);
  } else {
    observe(vm._data = {}, true /* asRootData */);
  }
  if (opts.computed) { initComputed(vm, opts.computed); }
  if (opts.watch && opts.watch !== nativeWatch) {
    initWatch(vm, opts.watch);
  }
}

function initProps (vm, propsOptions) {
  var propsData = vm.$options.propsData || {};
  var props = vm._props = {};
  // cache prop keys so that future props updates can iterate using Array
  // instead of dynamic object key enumeration.
  var keys = vm.$options._propKeys = [];
  var isRoot = !vm.$parent;
  // root instance props should be converted
  if (!isRoot) {
    toggleObserving(false);
  }
  var loop = function ( key ) {
    keys.push(key);
    var value = validateProp(key, propsOptions, propsData, vm);
    /* istanbul ignore else */
    if (false) {
      var hyphenatedKey = hyphenate(key);
      if (isReservedAttribute(hyphenatedKey) ||
          config.isReservedAttr(hyphenatedKey)) {
        warn(
          ("\"" + hyphenatedKey + "\" is a reserved attribute and cannot be used as component prop."),
          vm
        );
      }
      defineReactive$$1(props, key, value, function () {
        if (!isRoot && !isUpdatingChildComponent) {
          warn(
            "Avoid mutating a prop directly since the value will be " +
            "overwritten whenever the parent component re-renders. " +
            "Instead, use a data or computed property based on the prop's " +
            "value. Prop being mutated: \"" + key + "\"",
            vm
          );
        }
      });
    } else {
      defineReactive$$1(props, key, value);
    }
    // static props are already proxied on the component's prototype
    // during Vue.extend(). We only need to proxy props defined at
    // instantiation here.
    if (!(key in vm)) {
      proxy(vm, "_props", key);
    }
  };

  for (var key in propsOptions) loop( key );
  toggleObserving(true);
}

function initData (vm) {
  var data = vm.$options.data;
  data = vm._data = typeof data === 'function'
    ? getData(data, vm)
    : data || {};
  if (!isPlainObject(data)) {
    data = {};
    "production" !== 'production' && warn(
      'data functions should return an object:\n' +
      'https://vuejs.org/v2/guide/components.html#data-Must-Be-a-Function',
      vm
    );
  }
  // proxy data on instance
  var keys = Object.keys(data);
  var props = vm.$options.props;
  var methods = vm.$options.methods;
  var i = keys.length;
  while (i--) {
    var key = keys[i];
    if (false) {
      if (methods && hasOwn(methods, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a data property."),
          vm
        );
      }
    }
    if (props && hasOwn(props, key)) {
      "production" !== 'production' && warn(
        "The data property \"" + key + "\" is already declared as a prop. " +
        "Use prop default value instead.",
        vm
      );
    } else if (!isReserved(key)) {
      proxy(vm, "_data", key);
    }
  }
  // observe data
  observe(data, true /* asRootData */);
}

function getData (data, vm) {
  // #7573 disable dep collection when invoking data getters
  pushTarget();
  try {
    return data.call(vm, vm)
  } catch (e) {
    handleError(e, vm, "data()");
    return {}
  } finally {
    popTarget();
  }
}

var computedWatcherOptions = { lazy: true };

function initComputed (vm, computed) {
  // $flow-disable-line
  var watchers = vm._computedWatchers = Object.create(null);
  // computed properties are just getters during SSR
  var isSSR = isServerRendering();

  for (var key in computed) {
    var userDef = computed[key];
    var getter = typeof userDef === 'function' ? userDef : userDef.get;
    if (false) {
      warn(
        ("Getter is missing for computed property \"" + key + "\"."),
        vm
      );
    }

    if (!isSSR) {
      // create internal watcher for the computed property.
      watchers[key] = new Watcher(
        vm,
        getter || noop,
        noop,
        computedWatcherOptions
      );
    }

    // component-defined computed properties are already defined on the
    // component prototype. We only need to define computed properties defined
    // at instantiation here.
    if (!(key in vm)) {
      defineComputed(vm, key, userDef);
    } else if (false) {
      if (key in vm.$data) {
        warn(("The computed property \"" + key + "\" is already defined in data."), vm);
      } else if (vm.$options.props && key in vm.$options.props) {
        warn(("The computed property \"" + key + "\" is already defined as a prop."), vm);
      }
    }
  }
}

function defineComputed (
  target,
  key,
  userDef
) {
  var shouldCache = !isServerRendering();
  if (typeof userDef === 'function') {
    sharedPropertyDefinition.get = shouldCache
      ? createComputedGetter(key)
      : createGetterInvoker(userDef);
    sharedPropertyDefinition.set = noop;
  } else {
    sharedPropertyDefinition.get = userDef.get
      ? shouldCache && userDef.cache !== false
        ? createComputedGetter(key)
        : createGetterInvoker(userDef.get)
      : noop;
    sharedPropertyDefinition.set = userDef.set || noop;
  }
  if (false) {
    sharedPropertyDefinition.set = function () {
      warn(
        ("Computed property \"" + key + "\" was assigned to but it has no setter."),
        this
      );
    };
  }
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function createComputedGetter (key) {
  return function computedGetter () {
    var watcher = this._computedWatchers && this._computedWatchers[key];
    if (watcher) {
      if (watcher.dirty) {
        watcher.evaluate();
      }
      if (Dep.target) {
        watcher.depend();
      }
      return watcher.value
    }
  }
}

function createGetterInvoker(fn) {
  return function computedGetter () {
    return fn.call(this, this)
  }
}

function initMethods (vm, methods) {
  var props = vm.$options.props;
  for (var key in methods) {
    if (false) {
      if (typeof methods[key] !== 'function') {
        warn(
          "Method \"" + key + "\" has type \"" + (typeof methods[key]) + "\" in the component definition. " +
          "Did you reference the function correctly?",
          vm
        );
      }
      if (props && hasOwn(props, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a prop."),
          vm
        );
      }
      if ((key in vm) && isReserved(key)) {
        warn(
          "Method \"" + key + "\" conflicts with an existing Vue instance method. " +
          "Avoid defining component methods that start with _ or $."
        );
      }
    }
    vm[key] = typeof methods[key] !== 'function' ? noop : bind(methods[key], vm);
  }
}

function initWatch (vm, watch) {
  for (var key in watch) {
    var handler = watch[key];
    if (Array.isArray(handler)) {
      for (var i = 0; i < handler.length; i++) {
        createWatcher(vm, key, handler[i]);
      }
    } else {
      createWatcher(vm, key, handler);
    }
  }
}

function createWatcher (
  vm,
  expOrFn,
  handler,
  options
) {
  if (isPlainObject(handler)) {
    options = handler;
    handler = handler.handler;
  }
  if (typeof handler === 'string') {
    handler = vm[handler];
  }
  return vm.$watch(expOrFn, handler, options)
}

function stateMixin (Vue) {
  // flow somehow has problems with directly declared definition object
  // when using Object.defineProperty, so we have to procedurally build up
  // the object here.
  var dataDef = {};
  dataDef.get = function () { return this._data };
  var propsDef = {};
  propsDef.get = function () { return this._props };
  if (false) {
    dataDef.set = function () {
      warn(
        'Avoid replacing instance root $data. ' +
        'Use nested data properties instead.',
        this
      );
    };
    propsDef.set = function () {
      warn("$props is readonly.", this);
    };
  }
  Object.defineProperty(Vue.prototype, '$data', dataDef);
  Object.defineProperty(Vue.prototype, '$props', propsDef);

  Vue.prototype.$set = set;
  Vue.prototype.$delete = del;

  Vue.prototype.$watch = function (
    expOrFn,
    cb,
    options
  ) {
    var vm = this;
    if (isPlainObject(cb)) {
      return createWatcher(vm, expOrFn, cb, options)
    }
    options = options || {};
    options.user = true;
    var watcher = new Watcher(vm, expOrFn, cb, options);
    if (options.immediate) {
      try {
        cb.call(vm, watcher.value);
      } catch (error) {
        handleError(error, vm, ("callback for immediate watcher \"" + (watcher.expression) + "\""));
      }
    }
    return function unwatchFn () {
      watcher.teardown();
    }
  };
}

/*  */

var uid$3 = 0;

function initMixin (Vue) {
  Vue.prototype._init = function (options) {
    var vm = this;
    // a uid
    vm._uid = uid$3++;

    var startTag, endTag;
    /* istanbul ignore if */
    if (false) {
      startTag = "vue-perf-start:" + (vm._uid);
      endTag = "vue-perf-end:" + (vm._uid);
      mark(startTag);
    }

    // a flag to avoid this being observed
    vm._isVue = true;
    // merge options
    if (options && options._isComponent) {
      // optimize internal component instantiation
      // since dynamic options merging is pretty slow, and none of the
      // internal component options needs special treatment.
      initInternalComponent(vm, options);
    } else {
      vm.$options = mergeOptions(
        resolveConstructorOptions(vm.constructor),
        options || {},
        vm
      );
    }
    /* istanbul ignore else */
    if (false) {
      initProxy(vm);
    } else {
      vm._renderProxy = vm;
    }
    // expose real self
    vm._self = vm;
    initLifecycle(vm);
    initEvents(vm);
    initRender(vm);
    callHook(vm, 'beforeCreate');
    initInjections(vm); // resolve injections before data/props
    initState(vm);
    initProvide(vm); // resolve provide after data/props
    callHook(vm, 'created');

    /* istanbul ignore if */
    if (false) {
      vm._name = formatComponentName(vm, false);
      mark(endTag);
      measure(("vue " + (vm._name) + " init"), startTag, endTag);
    }

    if (vm.$options.el) {
      vm.$mount(vm.$options.el);
    }
  };
}

function initInternalComponent (vm, options) {
  var opts = vm.$options = Object.create(vm.constructor.options);
  // doing this because it's faster than dynamic enumeration.
  var parentVnode = options._parentVnode;
  opts.parent = options.parent;
  opts._parentVnode = parentVnode;

  var vnodeComponentOptions = parentVnode.componentOptions;
  opts.propsData = vnodeComponentOptions.propsData;
  opts._parentListeners = vnodeComponentOptions.listeners;
  opts._renderChildren = vnodeComponentOptions.children;
  opts._componentTag = vnodeComponentOptions.tag;

  if (options.render) {
    opts.render = options.render;
    opts.staticRenderFns = options.staticRenderFns;
  }
}

function resolveConstructorOptions (Ctor) {
  var options = Ctor.options;
  if (Ctor.super) {
    var superOptions = resolveConstructorOptions(Ctor.super);
    var cachedSuperOptions = Ctor.superOptions;
    if (superOptions !== cachedSuperOptions) {
      // super option changed,
      // need to resolve new options.
      Ctor.superOptions = superOptions;
      // check if there are any late-modified/attached options (#4976)
      var modifiedOptions = resolveModifiedOptions(Ctor);
      // update base extend options
      if (modifiedOptions) {
        extend(Ctor.extendOptions, modifiedOptions);
      }
      options = Ctor.options = mergeOptions(superOptions, Ctor.extendOptions);
      if (options.name) {
        options.components[options.name] = Ctor;
      }
    }
  }
  return options
}

function resolveModifiedOptions (Ctor) {
  var modified;
  var latest = Ctor.options;
  var sealed = Ctor.sealedOptions;
  for (var key in latest) {
    if (latest[key] !== sealed[key]) {
      if (!modified) { modified = {}; }
      modified[key] = latest[key];
    }
  }
  return modified
}

function Vue (options) {
  if (false
  ) {
    warn('Vue is a constructor and should be called with the `new` keyword');
  }
  this._init(options);
}

initMixin(Vue);
stateMixin(Vue);
eventsMixin(Vue);
lifecycleMixin(Vue);
renderMixin(Vue);

/*  */

function initUse (Vue) {
  Vue.use = function (plugin) {
    var installedPlugins = (this._installedPlugins || (this._installedPlugins = []));
    if (installedPlugins.indexOf(plugin) > -1) {
      return this
    }

    // additional parameters
    var args = toArray(arguments, 1);
    args.unshift(this);
    if (typeof plugin.install === 'function') {
      plugin.install.apply(plugin, args);
    } else if (typeof plugin === 'function') {
      plugin.apply(null, args);
    }
    installedPlugins.push(plugin);
    return this
  };
}

/*  */

function initMixin$1 (Vue) {
  Vue.mixin = function (mixin) {
    this.options = mergeOptions(this.options, mixin);
    return this
  };
}

/*  */

function initExtend (Vue) {
  /**
   * Each instance constructor, including Vue, has a unique
   * cid. This enables us to create wrapped "child
   * constructors" for prototypal inheritance and cache them.
   */
  Vue.cid = 0;
  var cid = 1;

  /**
   * Class inheritance
   */
  Vue.extend = function (extendOptions) {
    extendOptions = extendOptions || {};
    var Super = this;
    var SuperId = Super.cid;
    var cachedCtors = extendOptions._Ctor || (extendOptions._Ctor = {});
    if (cachedCtors[SuperId]) {
      return cachedCtors[SuperId]
    }

    var name = extendOptions.name || Super.options.name;
    if (false) {
      validateComponentName(name);
    }

    var Sub = function VueComponent (options) {
      this._init(options);
    };
    Sub.prototype = Object.create(Super.prototype);
    Sub.prototype.constructor = Sub;
    Sub.cid = cid++;
    Sub.options = mergeOptions(
      Super.options,
      extendOptions
    );
    Sub['super'] = Super;

    // For props and computed properties, we define the proxy getters on
    // the Vue instances at extension time, on the extended prototype. This
    // avoids Object.defineProperty calls for each instance created.
    if (Sub.options.props) {
      initProps$1(Sub);
    }
    if (Sub.options.computed) {
      initComputed$1(Sub);
    }

    // allow further extension/mixin/plugin usage
    Sub.extend = Super.extend;
    Sub.mixin = Super.mixin;
    Sub.use = Super.use;

    // create asset registers, so extended classes
    // can have their private assets too.
    ASSET_TYPES.forEach(function (type) {
      Sub[type] = Super[type];
    });
    // enable recursive self-lookup
    if (name) {
      Sub.options.components[name] = Sub;
    }

    // keep a reference to the super options at extension time.
    // later at instantiation we can check if Super's options have
    // been updated.
    Sub.superOptions = Super.options;
    Sub.extendOptions = extendOptions;
    Sub.sealedOptions = extend({}, Sub.options);

    // cache constructor
    cachedCtors[SuperId] = Sub;
    return Sub
  };
}

function initProps$1 (Comp) {
  var props = Comp.options.props;
  for (var key in props) {
    proxy(Comp.prototype, "_props", key);
  }
}

function initComputed$1 (Comp) {
  var computed = Comp.options.computed;
  for (var key in computed) {
    defineComputed(Comp.prototype, key, computed[key]);
  }
}

/*  */

function initAssetRegisters (Vue) {
  /**
   * Create asset registration methods.
   */
  ASSET_TYPES.forEach(function (type) {
    Vue[type] = function (
      id,
      definition
    ) {
      if (!definition) {
        return this.options[type + 's'][id]
      } else {
        /* istanbul ignore if */
        if (false) {
          validateComponentName(id);
        }
        if (type === 'component' && isPlainObject(definition)) {
          definition.name = definition.name || id;
          definition = this.options._base.extend(definition);
        }
        if (type === 'directive' && typeof definition === 'function') {
          definition = { bind: definition, update: definition };
        }
        this.options[type + 's'][id] = definition;
        return definition
      }
    };
  });
}

/*  */



function getComponentName (opts) {
  return opts && (opts.Ctor.options.name || opts.tag)
}

function matches (pattern, name) {
  if (Array.isArray(pattern)) {
    return pattern.indexOf(name) > -1
  } else if (typeof pattern === 'string') {
    return pattern.split(',').indexOf(name) > -1
  } else if (isRegExp(pattern)) {
    return pattern.test(name)
  }
  /* istanbul ignore next */
  return false
}

function pruneCache (keepAliveInstance, filter) {
  var cache = keepAliveInstance.cache;
  var keys = keepAliveInstance.keys;
  var _vnode = keepAliveInstance._vnode;
  for (var key in cache) {
    var cachedNode = cache[key];
    if (cachedNode) {
      var name = getComponentName(cachedNode.componentOptions);
      if (name && !filter(name)) {
        pruneCacheEntry(cache, key, keys, _vnode);
      }
    }
  }
}

function pruneCacheEntry (
  cache,
  key,
  keys,
  current
) {
  var cached$$1 = cache[key];
  if (cached$$1 && (!current || cached$$1.tag !== current.tag)) {
    cached$$1.componentInstance.$destroy();
  }
  cache[key] = null;
  remove(keys, key);
}

var patternTypes = [String, RegExp, Array];

var KeepAlive = {
  name: 'keep-alive',
  abstract: true,

  props: {
    include: patternTypes,
    exclude: patternTypes,
    max: [String, Number]
  },

  created: function created () {
    this.cache = Object.create(null);
    this.keys = [];
  },

  destroyed: function destroyed () {
    for (var key in this.cache) {
      pruneCacheEntry(this.cache, key, this.keys);
    }
  },

  mounted: function mounted () {
    var this$1 = this;

    this.$watch('include', function (val) {
      pruneCache(this$1, function (name) { return matches(val, name); });
    });
    this.$watch('exclude', function (val) {
      pruneCache(this$1, function (name) { return !matches(val, name); });
    });
  },

  render: function render () {
    var slot = this.$slots.default;
    var vnode = getFirstComponentChild(slot);
    var componentOptions = vnode && vnode.componentOptions;
    if (componentOptions) {
      // check pattern
      var name = getComponentName(componentOptions);
      var ref = this;
      var include = ref.include;
      var exclude = ref.exclude;
      if (
        // not included
        (include && (!name || !matches(include, name))) ||
        // excluded
        (exclude && name && matches(exclude, name))
      ) {
        return vnode
      }

      var ref$1 = this;
      var cache = ref$1.cache;
      var keys = ref$1.keys;
      var key = vnode.key == null
        // same constructor may get registered as different local components
        // so cid alone is not enough (#3269)
        ? componentOptions.Ctor.cid + (componentOptions.tag ? ("::" + (componentOptions.tag)) : '')
        : vnode.key;
      if (cache[key]) {
        vnode.componentInstance = cache[key].componentInstance;
        // make current key freshest
        remove(keys, key);
        keys.push(key);
      } else {
        cache[key] = vnode;
        keys.push(key);
        // prune oldest entry
        if (this.max && keys.length > parseInt(this.max)) {
          pruneCacheEntry(cache, keys[0], keys, this._vnode);
        }
      }

      vnode.data.keepAlive = true;
    }
    return vnode || (slot && slot[0])
  }
};

var builtInComponents = {
  KeepAlive: KeepAlive
};

/*  */

function initGlobalAPI (Vue) {
  // config
  var configDef = {};
  configDef.get = function () { return config; };
  if (false) {
    configDef.set = function () {
      warn(
        'Do not replace the Vue.config object, set individual fields instead.'
      );
    };
  }
  Object.defineProperty(Vue, 'config', configDef);

  // exposed util methods.
  // NOTE: these are not considered part of the public API - avoid relying on
  // them unless you are aware of the risk.
  Vue.util = {
    warn: warn,
    extend: extend,
    mergeOptions: mergeOptions,
    defineReactive: defineReactive$$1
  };

  Vue.set = set;
  Vue.delete = del;
  Vue.nextTick = nextTick;

  // 2.6 explicit observable API
  Vue.observable = function (obj) {
    observe(obj);
    return obj
  };

  Vue.options = Object.create(null);
  ASSET_TYPES.forEach(function (type) {
    Vue.options[type + 's'] = Object.create(null);
  });

  // this is used to identify the "base" constructor to extend all plain-object
  // components with in Weex's multi-instance scenarios.
  Vue.options._base = Vue;

  extend(Vue.options.components, builtInComponents);

  initUse(Vue);
  initMixin$1(Vue);
  initExtend(Vue);
  initAssetRegisters(Vue);
}

initGlobalAPI(Vue);

Object.defineProperty(Vue.prototype, '$isServer', {
  get: isServerRendering
});

Object.defineProperty(Vue.prototype, '$ssrContext', {
  get: function get () {
    /* istanbul ignore next */
    return this.$vnode && this.$vnode.ssrContext
  }
});

// expose FunctionalRenderContext for ssr runtime helper installation
Object.defineProperty(Vue, 'FunctionalRenderContext', {
  value: FunctionalRenderContext
});

Vue.version = '2.6.12';

/*  */

// these are reserved for web because they are directly compiled away
// during template compilation
var isReservedAttr = makeMap('style,class');

// attributes that should be using props for binding
var acceptValue = makeMap('input,textarea,option,select,progress');
var mustUseProp = function (tag, type, attr) {
  return (
    (attr === 'value' && acceptValue(tag)) && type !== 'button' ||
    (attr === 'selected' && tag === 'option') ||
    (attr === 'checked' && tag === 'input') ||
    (attr === 'muted' && tag === 'video')
  )
};

var isEnumeratedAttr = makeMap('contenteditable,draggable,spellcheck');

var isValidContentEditableValue = makeMap('events,caret,typing,plaintext-only');

var convertEnumeratedValue = function (key, value) {
  return isFalsyAttrValue(value) || value === 'false'
    ? 'false'
    // allow arbitrary string value for contenteditable
    : key === 'contenteditable' && isValidContentEditableValue(value)
      ? value
      : 'true'
};

var isBooleanAttr = makeMap(
  'allowfullscreen,async,autofocus,autoplay,checked,compact,controls,declare,' +
  'default,defaultchecked,defaultmuted,defaultselected,defer,disabled,' +
  'enabled,formnovalidate,hidden,indeterminate,inert,ismap,itemscope,loop,multiple,' +
  'muted,nohref,noresize,noshade,novalidate,nowrap,open,pauseonexit,readonly,' +
  'required,reversed,scoped,seamless,selected,sortable,translate,' +
  'truespeed,typemustmatch,visible'
);

var xlinkNS = 'http://www.w3.org/1999/xlink';

var isXlink = function (name) {
  return name.charAt(5) === ':' && name.slice(0, 5) === 'xlink'
};

var getXlinkProp = function (name) {
  return isXlink(name) ? name.slice(6, name.length) : ''
};

var isFalsyAttrValue = function (val) {
  return val == null || val === false
};

/*  */

function genClassForVnode (vnode) {
  var data = vnode.data;
  var parentNode = vnode;
  var childNode = vnode;
  while (isDef(childNode.componentInstance)) {
    childNode = childNode.componentInstance._vnode;
    if (childNode && childNode.data) {
      data = mergeClassData(childNode.data, data);
    }
  }
  while (isDef(parentNode = parentNode.parent)) {
    if (parentNode && parentNode.data) {
      data = mergeClassData(data, parentNode.data);
    }
  }
  return renderClass(data.staticClass, data.class)
}

function mergeClassData (child, parent) {
  return {
    staticClass: concat(child.staticClass, parent.staticClass),
    class: isDef(child.class)
      ? [child.class, parent.class]
      : parent.class
  }
}

function renderClass (
  staticClass,
  dynamicClass
) {
  if (isDef(staticClass) || isDef(dynamicClass)) {
    return concat(staticClass, stringifyClass(dynamicClass))
  }
  /* istanbul ignore next */
  return ''
}

function concat (a, b) {
  return a ? b ? (a + ' ' + b) : a : (b || '')
}

function stringifyClass (value) {
  if (Array.isArray(value)) {
    return stringifyArray(value)
  }
  if (isObject(value)) {
    return stringifyObject(value)
  }
  if (typeof value === 'string') {
    return value
  }
  /* istanbul ignore next */
  return ''
}

function stringifyArray (value) {
  var res = '';
  var stringified;
  for (var i = 0, l = value.length; i < l; i++) {
    if (isDef(stringified = stringifyClass(value[i])) && stringified !== '') {
      if (res) { res += ' '; }
      res += stringified;
    }
  }
  return res
}

function stringifyObject (value) {
  var res = '';
  for (var key in value) {
    if (value[key]) {
      if (res) { res += ' '; }
      res += key;
    }
  }
  return res
}

/*  */

var namespaceMap = {
  svg: 'http://www.w3.org/2000/svg',
  math: 'http://www.w3.org/1998/Math/MathML'
};

var isHTMLTag = makeMap(
  'html,body,base,head,link,meta,style,title,' +
  'address,article,aside,footer,header,h1,h2,h3,h4,h5,h6,hgroup,nav,section,' +
  'div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,' +
  'a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,rtc,ruby,' +
  's,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,' +
  'embed,object,param,source,canvas,script,noscript,del,ins,' +
  'caption,col,colgroup,table,thead,tbody,td,th,tr,' +
  'button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,' +
  'output,progress,select,textarea,' +
  'details,dialog,menu,menuitem,summary,' +
  'content,element,shadow,template,blockquote,iframe,tfoot'
);

// this map is intentionally selective, only covering SVG elements that may
// contain child elements.
var isSVG = makeMap(
  'svg,animate,circle,clippath,cursor,defs,desc,ellipse,filter,font-face,' +
  'foreignObject,g,glyph,image,line,marker,mask,missing-glyph,path,pattern,' +
  'polygon,polyline,rect,switch,symbol,text,textpath,tspan,use,view',
  true
);

var isPreTag = function (tag) { return tag === 'pre'; };

var isReservedTag = function (tag) {
  return isHTMLTag(tag) || isSVG(tag)
};

function getTagNamespace (tag) {
  if (isSVG(tag)) {
    return 'svg'
  }
  // basic support for MathML
  // note it doesn't support other MathML elements being component roots
  if (tag === 'math') {
    return 'math'
  }
}

var unknownElementCache = Object.create(null);
function isUnknownElement (tag) {
  /* istanbul ignore if */
  if (!inBrowser) {
    return true
  }
  if (isReservedTag(tag)) {
    return false
  }
  tag = tag.toLowerCase();
  /* istanbul ignore if */
  if (unknownElementCache[tag] != null) {
    return unknownElementCache[tag]
  }
  var el = document.createElement(tag);
  if (tag.indexOf('-') > -1) {
    // http://stackoverflow.com/a/28210364/1070244
    return (unknownElementCache[tag] = (
      el.constructor === window.HTMLUnknownElement ||
      el.constructor === window.HTMLElement
    ))
  } else {
    return (unknownElementCache[tag] = /HTMLUnknownElement/.test(el.toString()))
  }
}

var isTextInputType = makeMap('text,number,password,search,email,tel,url');

/*  */

/**
 * Query an element selector if it's not an element already.
 */
function query (el) {
  if (typeof el === 'string') {
    var selected = document.querySelector(el);
    if (!selected) {
      "production" !== 'production' && warn(
        'Cannot find element: ' + el
      );
      return document.createElement('div')
    }
    return selected
  } else {
    return el
  }
}

/*  */

function createElement$1 (tagName, vnode) {
  var elm = document.createElement(tagName);
  if (tagName !== 'select') {
    return elm
  }
  // false or null will remove the attribute but undefined will not
  if (vnode.data && vnode.data.attrs && vnode.data.attrs.multiple !== undefined) {
    elm.setAttribute('multiple', 'multiple');
  }
  return elm
}

function createElementNS (namespace, tagName) {
  return document.createElementNS(namespaceMap[namespace], tagName)
}

function createTextNode (text) {
  return document.createTextNode(text)
}

function createComment (text) {
  return document.createComment(text)
}

function insertBefore (parentNode, newNode, referenceNode) {
  parentNode.insertBefore(newNode, referenceNode);
}

function removeChild (node, child) {
  node.removeChild(child);
}

function appendChild (node, child) {
  node.appendChild(child);
}

function parentNode (node) {
  return node.parentNode
}

function nextSibling (node) {
  return node.nextSibling
}

function tagName (node) {
  return node.tagName
}

function setTextContent (node, text) {
  node.textContent = text;
}

function setStyleScope (node, scopeId) {
  node.setAttribute(scopeId, '');
}

var nodeOps = /*#__PURE__*/Object.freeze({
  createElement: createElement$1,
  createElementNS: createElementNS,
  createTextNode: createTextNode,
  createComment: createComment,
  insertBefore: insertBefore,
  removeChild: removeChild,
  appendChild: appendChild,
  parentNode: parentNode,
  nextSibling: nextSibling,
  tagName: tagName,
  setTextContent: setTextContent,
  setStyleScope: setStyleScope
});

/*  */

var ref = {
  create: function create (_, vnode) {
    registerRef(vnode);
  },
  update: function update (oldVnode, vnode) {
    if (oldVnode.data.ref !== vnode.data.ref) {
      registerRef(oldVnode, true);
      registerRef(vnode);
    }
  },
  destroy: function destroy (vnode) {
    registerRef(vnode, true);
  }
};

function registerRef (vnode, isRemoval) {
  var key = vnode.data.ref;
  if (!isDef(key)) { return }

  var vm = vnode.context;
  var ref = vnode.componentInstance || vnode.elm;
  var refs = vm.$refs;
  if (isRemoval) {
    if (Array.isArray(refs[key])) {
      remove(refs[key], ref);
    } else if (refs[key] === ref) {
      refs[key] = undefined;
    }
  } else {
    if (vnode.data.refInFor) {
      if (!Array.isArray(refs[key])) {
        refs[key] = [ref];
      } else if (refs[key].indexOf(ref) < 0) {
        // $flow-disable-line
        refs[key].push(ref);
      }
    } else {
      refs[key] = ref;
    }
  }
}

/**
 * Virtual DOM patching algorithm based on Snabbdom by
 * Simon Friis Vindum (@paldepind)
 * Licensed under the MIT License
 * https://github.com/paldepind/snabbdom/blob/master/LICENSE
 *
 * modified by Evan You (@yyx990803)
 *
 * Not type-checking this because this file is perf-critical and the cost
 * of making flow understand it is not worth it.
 */

var emptyNode = new VNode('', {}, []);

var hooks = ['create', 'activate', 'update', 'remove', 'destroy'];

function sameVnode (a, b) {
  return (
    a.key === b.key && (
      (
        a.tag === b.tag &&
        a.isComment === b.isComment &&
        isDef(a.data) === isDef(b.data) &&
        sameInputType(a, b)
      ) || (
        isTrue(a.isAsyncPlaceholder) &&
        a.asyncFactory === b.asyncFactory &&
        isUndef(b.asyncFactory.error)
      )
    )
  )
}

function sameInputType (a, b) {
  if (a.tag !== 'input') { return true }
  var i;
  var typeA = isDef(i = a.data) && isDef(i = i.attrs) && i.type;
  var typeB = isDef(i = b.data) && isDef(i = i.attrs) && i.type;
  return typeA === typeB || isTextInputType(typeA) && isTextInputType(typeB)
}

function createKeyToOldIdx (children, beginIdx, endIdx) {
  var i, key;
  var map = {};
  for (i = beginIdx; i <= endIdx; ++i) {
    key = children[i].key;
    if (isDef(key)) { map[key] = i; }
  }
  return map
}

function createPatchFunction (backend) {
  var i, j;
  var cbs = {};

  var modules = backend.modules;
  var nodeOps = backend.nodeOps;

  for (i = 0; i < hooks.length; ++i) {
    cbs[hooks[i]] = [];
    for (j = 0; j < modules.length; ++j) {
      if (isDef(modules[j][hooks[i]])) {
        cbs[hooks[i]].push(modules[j][hooks[i]]);
      }
    }
  }

  function emptyNodeAt (elm) {
    return new VNode(nodeOps.tagName(elm).toLowerCase(), {}, [], undefined, elm)
  }

  function createRmCb (childElm, listeners) {
    function remove$$1 () {
      if (--remove$$1.listeners === 0) {
        removeNode(childElm);
      }
    }
    remove$$1.listeners = listeners;
    return remove$$1
  }

  function removeNode (el) {
    var parent = nodeOps.parentNode(el);
    // element may have already been removed due to v-html / v-text
    if (isDef(parent)) {
      nodeOps.removeChild(parent, el);
    }
  }

  function isUnknownElement$$1 (vnode, inVPre) {
    return (
      !inVPre &&
      !vnode.ns &&
      !(
        config.ignoredElements.length &&
        config.ignoredElements.some(function (ignore) {
          return isRegExp(ignore)
            ? ignore.test(vnode.tag)
            : ignore === vnode.tag
        })
      ) &&
      config.isUnknownElement(vnode.tag)
    )
  }

  var creatingElmInVPre = 0;

  function createElm (
    vnode,
    insertedVnodeQueue,
    parentElm,
    refElm,
    nested,
    ownerArray,
    index
  ) {
    if (isDef(vnode.elm) && isDef(ownerArray)) {
      // This vnode was used in a previous render!
      // now it's used as a new node, overwriting its elm would cause
      // potential patch errors down the road when it's used as an insertion
      // reference node. Instead, we clone the node on-demand before creating
      // associated DOM element for it.
      vnode = ownerArray[index] = cloneVNode(vnode);
    }

    vnode.isRootInsert = !nested; // for transition enter check
    if (createComponent(vnode, insertedVnodeQueue, parentElm, refElm)) {
      return
    }

    var data = vnode.data;
    var children = vnode.children;
    var tag = vnode.tag;
    if (isDef(tag)) {
      if (false) {
        if (data && data.pre) {
          creatingElmInVPre++;
        }
        if (isUnknownElement$$1(vnode, creatingElmInVPre)) {
          warn(
            'Unknown custom element: <' + tag + '> - did you ' +
            'register the component correctly? For recursive components, ' +
            'make sure to provide the "name" option.',
            vnode.context
          );
        }
      }

      vnode.elm = vnode.ns
        ? nodeOps.createElementNS(vnode.ns, tag)
        : nodeOps.createElement(tag, vnode);
      setScope(vnode);

      /* istanbul ignore if */
      {
        createChildren(vnode, children, insertedVnodeQueue);
        if (isDef(data)) {
          invokeCreateHooks(vnode, insertedVnodeQueue);
        }
        insert(parentElm, vnode.elm, refElm);
      }

      if (false) {
        creatingElmInVPre--;
      }
    } else if (isTrue(vnode.isComment)) {
      vnode.elm = nodeOps.createComment(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    } else {
      vnode.elm = nodeOps.createTextNode(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    }
  }

  function createComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i = vnode.data;
    if (isDef(i)) {
      var isReactivated = isDef(vnode.componentInstance) && i.keepAlive;
      if (isDef(i = i.hook) && isDef(i = i.init)) {
        i(vnode, false /* hydrating */);
      }
      // after calling the init hook, if the vnode is a child component
      // it should've created a child instance and mounted it. the child
      // component also has set the placeholder vnode's elm.
      // in that case we can just return the element and be done.
      if (isDef(vnode.componentInstance)) {
        initComponent(vnode, insertedVnodeQueue);
        insert(parentElm, vnode.elm, refElm);
        if (isTrue(isReactivated)) {
          reactivateComponent(vnode, insertedVnodeQueue, parentElm, refElm);
        }
        return true
      }
    }
  }

  function initComponent (vnode, insertedVnodeQueue) {
    if (isDef(vnode.data.pendingInsert)) {
      insertedVnodeQueue.push.apply(insertedVnodeQueue, vnode.data.pendingInsert);
      vnode.data.pendingInsert = null;
    }
    vnode.elm = vnode.componentInstance.$el;
    if (isPatchable(vnode)) {
      invokeCreateHooks(vnode, insertedVnodeQueue);
      setScope(vnode);
    } else {
      // empty component root.
      // skip all element-related modules except for ref (#3455)
      registerRef(vnode);
      // make sure to invoke the insert hook
      insertedVnodeQueue.push(vnode);
    }
  }

  function reactivateComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i;
    // hack for #4339: a reactivated component with inner transition
    // does not trigger because the inner node's created hooks are not called
    // again. It's not ideal to involve module-specific logic in here but
    // there doesn't seem to be a better way to do it.
    var innerNode = vnode;
    while (innerNode.componentInstance) {
      innerNode = innerNode.componentInstance._vnode;
      if (isDef(i = innerNode.data) && isDef(i = i.transition)) {
        for (i = 0; i < cbs.activate.length; ++i) {
          cbs.activate[i](emptyNode, innerNode);
        }
        insertedVnodeQueue.push(innerNode);
        break
      }
    }
    // unlike a newly created component,
    // a reactivated keep-alive component doesn't insert itself
    insert(parentElm, vnode.elm, refElm);
  }

  function insert (parent, elm, ref$$1) {
    if (isDef(parent)) {
      if (isDef(ref$$1)) {
        if (nodeOps.parentNode(ref$$1) === parent) {
          nodeOps.insertBefore(parent, elm, ref$$1);
        }
      } else {
        nodeOps.appendChild(parent, elm);
      }
    }
  }

  function createChildren (vnode, children, insertedVnodeQueue) {
    if (Array.isArray(children)) {
      if (false) {
        checkDuplicateKeys(children);
      }
      for (var i = 0; i < children.length; ++i) {
        createElm(children[i], insertedVnodeQueue, vnode.elm, null, true, children, i);
      }
    } else if (isPrimitive(vnode.text)) {
      nodeOps.appendChild(vnode.elm, nodeOps.createTextNode(String(vnode.text)));
    }
  }

  function isPatchable (vnode) {
    while (vnode.componentInstance) {
      vnode = vnode.componentInstance._vnode;
    }
    return isDef(vnode.tag)
  }

  function invokeCreateHooks (vnode, insertedVnodeQueue) {
    for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
      cbs.create[i$1](emptyNode, vnode);
    }
    i = vnode.data.hook; // Reuse variable
    if (isDef(i)) {
      if (isDef(i.create)) { i.create(emptyNode, vnode); }
      if (isDef(i.insert)) { insertedVnodeQueue.push(vnode); }
    }
  }

  // set scope id attribute for scoped CSS.
  // this is implemented as a special case to avoid the overhead
  // of going through the normal attribute patching process.
  function setScope (vnode) {
    var i;
    if (isDef(i = vnode.fnScopeId)) {
      nodeOps.setStyleScope(vnode.elm, i);
    } else {
      var ancestor = vnode;
      while (ancestor) {
        if (isDef(i = ancestor.context) && isDef(i = i.$options._scopeId)) {
          nodeOps.setStyleScope(vnode.elm, i);
        }
        ancestor = ancestor.parent;
      }
    }
    // for slot content they should also get the scopeId from the host instance.
    if (isDef(i = activeInstance) &&
      i !== vnode.context &&
      i !== vnode.fnContext &&
      isDef(i = i.$options._scopeId)
    ) {
      nodeOps.setStyleScope(vnode.elm, i);
    }
  }

  function addVnodes (parentElm, refElm, vnodes, startIdx, endIdx, insertedVnodeQueue) {
    for (; startIdx <= endIdx; ++startIdx) {
      createElm(vnodes[startIdx], insertedVnodeQueue, parentElm, refElm, false, vnodes, startIdx);
    }
  }

  function invokeDestroyHook (vnode) {
    var i, j;
    var data = vnode.data;
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.destroy)) { i(vnode); }
      for (i = 0; i < cbs.destroy.length; ++i) { cbs.destroy[i](vnode); }
    }
    if (isDef(i = vnode.children)) {
      for (j = 0; j < vnode.children.length; ++j) {
        invokeDestroyHook(vnode.children[j]);
      }
    }
  }

  function removeVnodes (vnodes, startIdx, endIdx) {
    for (; startIdx <= endIdx; ++startIdx) {
      var ch = vnodes[startIdx];
      if (isDef(ch)) {
        if (isDef(ch.tag)) {
          removeAndInvokeRemoveHook(ch);
          invokeDestroyHook(ch);
        } else { // Text node
          removeNode(ch.elm);
        }
      }
    }
  }

  function removeAndInvokeRemoveHook (vnode, rm) {
    if (isDef(rm) || isDef(vnode.data)) {
      var i;
      var listeners = cbs.remove.length + 1;
      if (isDef(rm)) {
        // we have a recursively passed down rm callback
        // increase the listeners count
        rm.listeners += listeners;
      } else {
        // directly removing
        rm = createRmCb(vnode.elm, listeners);
      }
      // recursively invoke hooks on child component root node
      if (isDef(i = vnode.componentInstance) && isDef(i = i._vnode) && isDef(i.data)) {
        removeAndInvokeRemoveHook(i, rm);
      }
      for (i = 0; i < cbs.remove.length; ++i) {
        cbs.remove[i](vnode, rm);
      }
      if (isDef(i = vnode.data.hook) && isDef(i = i.remove)) {
        i(vnode, rm);
      } else {
        rm();
      }
    } else {
      removeNode(vnode.elm);
    }
  }

  function updateChildren (parentElm, oldCh, newCh, insertedVnodeQueue, removeOnly) {
    var oldStartIdx = 0;
    var newStartIdx = 0;
    var oldEndIdx = oldCh.length - 1;
    var oldStartVnode = oldCh[0];
    var oldEndVnode = oldCh[oldEndIdx];
    var newEndIdx = newCh.length - 1;
    var newStartVnode = newCh[0];
    var newEndVnode = newCh[newEndIdx];
    var oldKeyToIdx, idxInOld, vnodeToMove, refElm;

    // removeOnly is a special flag used only by <transition-group>
    // to ensure removed elements stay in correct relative positions
    // during leaving transitions
    var canMove = !removeOnly;

    if (false) {
      checkDuplicateKeys(newCh);
    }

    while (oldStartIdx <= oldEndIdx && newStartIdx <= newEndIdx) {
      if (isUndef(oldStartVnode)) {
        oldStartVnode = oldCh[++oldStartIdx]; // Vnode has been moved left
      } else if (isUndef(oldEndVnode)) {
        oldEndVnode = oldCh[--oldEndIdx];
      } else if (sameVnode(oldStartVnode, newStartVnode)) {
        patchVnode(oldStartVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
        oldStartVnode = oldCh[++oldStartIdx];
        newStartVnode = newCh[++newStartIdx];
      } else if (sameVnode(oldEndVnode, newEndVnode)) {
        patchVnode(oldEndVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
        oldEndVnode = oldCh[--oldEndIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldStartVnode, newEndVnode)) { // Vnode moved right
        patchVnode(oldStartVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
        canMove && nodeOps.insertBefore(parentElm, oldStartVnode.elm, nodeOps.nextSibling(oldEndVnode.elm));
        oldStartVnode = oldCh[++oldStartIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldEndVnode, newStartVnode)) { // Vnode moved left
        patchVnode(oldEndVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
        canMove && nodeOps.insertBefore(parentElm, oldEndVnode.elm, oldStartVnode.elm);
        oldEndVnode = oldCh[--oldEndIdx];
        newStartVnode = newCh[++newStartIdx];
      } else {
        if (isUndef(oldKeyToIdx)) { oldKeyToIdx = createKeyToOldIdx(oldCh, oldStartIdx, oldEndIdx); }
        idxInOld = isDef(newStartVnode.key)
          ? oldKeyToIdx[newStartVnode.key]
          : findIdxInOld(newStartVnode, oldCh, oldStartIdx, oldEndIdx);
        if (isUndef(idxInOld)) { // New element
          createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
        } else {
          vnodeToMove = oldCh[idxInOld];
          if (sameVnode(vnodeToMove, newStartVnode)) {
            patchVnode(vnodeToMove, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
            oldCh[idxInOld] = undefined;
            canMove && nodeOps.insertBefore(parentElm, vnodeToMove.elm, oldStartVnode.elm);
          } else {
            // same key but different element. treat as new element
            createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
          }
        }
        newStartVnode = newCh[++newStartIdx];
      }
    }
    if (oldStartIdx > oldEndIdx) {
      refElm = isUndef(newCh[newEndIdx + 1]) ? null : newCh[newEndIdx + 1].elm;
      addVnodes(parentElm, refElm, newCh, newStartIdx, newEndIdx, insertedVnodeQueue);
    } else if (newStartIdx > newEndIdx) {
      removeVnodes(oldCh, oldStartIdx, oldEndIdx);
    }
  }

  function checkDuplicateKeys (children) {
    var seenKeys = {};
    for (var i = 0; i < children.length; i++) {
      var vnode = children[i];
      var key = vnode.key;
      if (isDef(key)) {
        if (seenKeys[key]) {
          warn(
            ("Duplicate keys detected: '" + key + "'. This may cause an update error."),
            vnode.context
          );
        } else {
          seenKeys[key] = true;
        }
      }
    }
  }

  function findIdxInOld (node, oldCh, start, end) {
    for (var i = start; i < end; i++) {
      var c = oldCh[i];
      if (isDef(c) && sameVnode(node, c)) { return i }
    }
  }

  function patchVnode (
    oldVnode,
    vnode,
    insertedVnodeQueue,
    ownerArray,
    index,
    removeOnly
  ) {
    if (oldVnode === vnode) {
      return
    }

    if (isDef(vnode.elm) && isDef(ownerArray)) {
      // clone reused vnode
      vnode = ownerArray[index] = cloneVNode(vnode);
    }

    var elm = vnode.elm = oldVnode.elm;

    if (isTrue(oldVnode.isAsyncPlaceholder)) {
      if (isDef(vnode.asyncFactory.resolved)) {
        hydrate(oldVnode.elm, vnode, insertedVnodeQueue);
      } else {
        vnode.isAsyncPlaceholder = true;
      }
      return
    }

    // reuse element for static trees.
    // note we only do this if the vnode is cloned -
    // if the new node is not cloned it means the render functions have been
    // reset by the hot-reload-api and we need to do a proper re-render.
    if (isTrue(vnode.isStatic) &&
      isTrue(oldVnode.isStatic) &&
      vnode.key === oldVnode.key &&
      (isTrue(vnode.isCloned) || isTrue(vnode.isOnce))
    ) {
      vnode.componentInstance = oldVnode.componentInstance;
      return
    }

    var i;
    var data = vnode.data;
    if (isDef(data) && isDef(i = data.hook) && isDef(i = i.prepatch)) {
      i(oldVnode, vnode);
    }

    var oldCh = oldVnode.children;
    var ch = vnode.children;
    if (isDef(data) && isPatchable(vnode)) {
      for (i = 0; i < cbs.update.length; ++i) { cbs.update[i](oldVnode, vnode); }
      if (isDef(i = data.hook) && isDef(i = i.update)) { i(oldVnode, vnode); }
    }
    if (isUndef(vnode.text)) {
      if (isDef(oldCh) && isDef(ch)) {
        if (oldCh !== ch) { updateChildren(elm, oldCh, ch, insertedVnodeQueue, removeOnly); }
      } else if (isDef(ch)) {
        if (false) {
          checkDuplicateKeys(ch);
        }
        if (isDef(oldVnode.text)) { nodeOps.setTextContent(elm, ''); }
        addVnodes(elm, null, ch, 0, ch.length - 1, insertedVnodeQueue);
      } else if (isDef(oldCh)) {
        removeVnodes(oldCh, 0, oldCh.length - 1);
      } else if (isDef(oldVnode.text)) {
        nodeOps.setTextContent(elm, '');
      }
    } else if (oldVnode.text !== vnode.text) {
      nodeOps.setTextContent(elm, vnode.text);
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.postpatch)) { i(oldVnode, vnode); }
    }
  }

  function invokeInsertHook (vnode, queue, initial) {
    // delay insert hooks for component root nodes, invoke them after the
    // element is really inserted
    if (isTrue(initial) && isDef(vnode.parent)) {
      vnode.parent.data.pendingInsert = queue;
    } else {
      for (var i = 0; i < queue.length; ++i) {
        queue[i].data.hook.insert(queue[i]);
      }
    }
  }

  var hydrationBailed = false;
  // list of modules that can skip create hook during hydration because they
  // are already rendered on the client or has no need for initialization
  // Note: style is excluded because it relies on initial clone for future
  // deep updates (#7063).
  var isRenderedModule = makeMap('attrs,class,staticClass,staticStyle,key');

  // Note: this is a browser-only function so we can assume elms are DOM nodes.
  function hydrate (elm, vnode, insertedVnodeQueue, inVPre) {
    var i;
    var tag = vnode.tag;
    var data = vnode.data;
    var children = vnode.children;
    inVPre = inVPre || (data && data.pre);
    vnode.elm = elm;

    if (isTrue(vnode.isComment) && isDef(vnode.asyncFactory)) {
      vnode.isAsyncPlaceholder = true;
      return true
    }
    // assert node match
    if (false) {
      if (!assertNodeMatch(elm, vnode, inVPre)) {
        return false
      }
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.init)) { i(vnode, true /* hydrating */); }
      if (isDef(i = vnode.componentInstance)) {
        // child component. it should have hydrated its own tree.
        initComponent(vnode, insertedVnodeQueue);
        return true
      }
    }
    if (isDef(tag)) {
      if (isDef(children)) {
        // empty element, allow client to pick up and populate children
        if (!elm.hasChildNodes()) {
          createChildren(vnode, children, insertedVnodeQueue);
        } else {
          // v-html and domProps: innerHTML
          if (isDef(i = data) && isDef(i = i.domProps) && isDef(i = i.innerHTML)) {
            if (i !== elm.innerHTML) {
              /* istanbul ignore if */
              if (false
              ) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('server innerHTML: ', i);
                console.warn('client innerHTML: ', elm.innerHTML);
              }
              return false
            }
          } else {
            // iterate and compare children lists
            var childrenMatch = true;
            var childNode = elm.firstChild;
            for (var i$1 = 0; i$1 < children.length; i$1++) {
              if (!childNode || !hydrate(childNode, children[i$1], insertedVnodeQueue, inVPre)) {
                childrenMatch = false;
                break
              }
              childNode = childNode.nextSibling;
            }
            // if childNode is not null, it means the actual childNodes list is
            // longer than the virtual children list.
            if (!childrenMatch || childNode) {
              /* istanbul ignore if */
              if (false
              ) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('Mismatching childNodes vs. VNodes: ', elm.childNodes, children);
              }
              return false
            }
          }
        }
      }
      if (isDef(data)) {
        var fullInvoke = false;
        for (var key in data) {
          if (!isRenderedModule(key)) {
            fullInvoke = true;
            invokeCreateHooks(vnode, insertedVnodeQueue);
            break
          }
        }
        if (!fullInvoke && data['class']) {
          // ensure collecting deps for deep class bindings for future updates
          traverse(data['class']);
        }
      }
    } else if (elm.data !== vnode.text) {
      elm.data = vnode.text;
    }
    return true
  }

  function assertNodeMatch (node, vnode, inVPre) {
    if (isDef(vnode.tag)) {
      return vnode.tag.indexOf('vue-component') === 0 || (
        !isUnknownElement$$1(vnode, inVPre) &&
        vnode.tag.toLowerCase() === (node.tagName && node.tagName.toLowerCase())
      )
    } else {
      return node.nodeType === (vnode.isComment ? 8 : 3)
    }
  }

  return function patch (oldVnode, vnode, hydrating, removeOnly) {
    if (isUndef(vnode)) {
      if (isDef(oldVnode)) { invokeDestroyHook(oldVnode); }
      return
    }

    var isInitialPatch = false;
    var insertedVnodeQueue = [];

    if (isUndef(oldVnode)) {
      // empty mount (likely as component), create new root element
      isInitialPatch = true;
      createElm(vnode, insertedVnodeQueue);
    } else {
      var isRealElement = isDef(oldVnode.nodeType);
      if (!isRealElement && sameVnode(oldVnode, vnode)) {
        // patch existing root node
        patchVnode(oldVnode, vnode, insertedVnodeQueue, null, null, removeOnly);
      } else {
        if (isRealElement) {
          // mounting to a real element
          // check if this is server-rendered content and if we can perform
          // a successful hydration.
          if (oldVnode.nodeType === 1 && oldVnode.hasAttribute(SSR_ATTR)) {
            oldVnode.removeAttribute(SSR_ATTR);
            hydrating = true;
          }
          if (isTrue(hydrating)) {
            if (hydrate(oldVnode, vnode, insertedVnodeQueue)) {
              invokeInsertHook(vnode, insertedVnodeQueue, true);
              return oldVnode
            } else if (false) {
              warn(
                'The client-side rendered virtual DOM tree is not matching ' +
                'server-rendered content. This is likely caused by incorrect ' +
                'HTML markup, for example nesting block-level elements inside ' +
                '<p>, or missing <tbody>. Bailing hydration and performing ' +
                'full client-side render.'
              );
            }
          }
          // either not server-rendered, or hydration failed.
          // create an empty node and replace it
          oldVnode = emptyNodeAt(oldVnode);
        }

        // replacing existing element
        var oldElm = oldVnode.elm;
        var parentElm = nodeOps.parentNode(oldElm);

        // create new node
        createElm(
          vnode,
          insertedVnodeQueue,
          // extremely rare edge case: do not insert if old element is in a
          // leaving transition. Only happens when combining transition +
          // keep-alive + HOCs. (#4590)
          oldElm._leaveCb ? null : parentElm,
          nodeOps.nextSibling(oldElm)
        );

        // update parent placeholder node element, recursively
        if (isDef(vnode.parent)) {
          var ancestor = vnode.parent;
          var patchable = isPatchable(vnode);
          while (ancestor) {
            for (var i = 0; i < cbs.destroy.length; ++i) {
              cbs.destroy[i](ancestor);
            }
            ancestor.elm = vnode.elm;
            if (patchable) {
              for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
                cbs.create[i$1](emptyNode, ancestor);
              }
              // #6513
              // invoke insert hooks that may have been merged by create hooks.
              // e.g. for directives that uses the "inserted" hook.
              var insert = ancestor.data.hook.insert;
              if (insert.merged) {
                // start at index 1 to avoid re-invoking component mounted hook
                for (var i$2 = 1; i$2 < insert.fns.length; i$2++) {
                  insert.fns[i$2]();
                }
              }
            } else {
              registerRef(ancestor);
            }
            ancestor = ancestor.parent;
          }
        }

        // destroy old node
        if (isDef(parentElm)) {
          removeVnodes([oldVnode], 0, 0);
        } else if (isDef(oldVnode.tag)) {
          invokeDestroyHook(oldVnode);
        }
      }
    }

    invokeInsertHook(vnode, insertedVnodeQueue, isInitialPatch);
    return vnode.elm
  }
}

/*  */

var directives = {
  create: updateDirectives,
  update: updateDirectives,
  destroy: function unbindDirectives (vnode) {
    updateDirectives(vnode, emptyNode);
  }
};

function updateDirectives (oldVnode, vnode) {
  if (oldVnode.data.directives || vnode.data.directives) {
    _update(oldVnode, vnode);
  }
}

function _update (oldVnode, vnode) {
  var isCreate = oldVnode === emptyNode;
  var isDestroy = vnode === emptyNode;
  var oldDirs = normalizeDirectives$1(oldVnode.data.directives, oldVnode.context);
  var newDirs = normalizeDirectives$1(vnode.data.directives, vnode.context);

  var dirsWithInsert = [];
  var dirsWithPostpatch = [];

  var key, oldDir, dir;
  for (key in newDirs) {
    oldDir = oldDirs[key];
    dir = newDirs[key];
    if (!oldDir) {
      // new directive, bind
      callHook$1(dir, 'bind', vnode, oldVnode);
      if (dir.def && dir.def.inserted) {
        dirsWithInsert.push(dir);
      }
    } else {
      // existing directive, update
      dir.oldValue = oldDir.value;
      dir.oldArg = oldDir.arg;
      callHook$1(dir, 'update', vnode, oldVnode);
      if (dir.def && dir.def.componentUpdated) {
        dirsWithPostpatch.push(dir);
      }
    }
  }

  if (dirsWithInsert.length) {
    var callInsert = function () {
      for (var i = 0; i < dirsWithInsert.length; i++) {
        callHook$1(dirsWithInsert[i], 'inserted', vnode, oldVnode);
      }
    };
    if (isCreate) {
      mergeVNodeHook(vnode, 'insert', callInsert);
    } else {
      callInsert();
    }
  }

  if (dirsWithPostpatch.length) {
    mergeVNodeHook(vnode, 'postpatch', function () {
      for (var i = 0; i < dirsWithPostpatch.length; i++) {
        callHook$1(dirsWithPostpatch[i], 'componentUpdated', vnode, oldVnode);
      }
    });
  }

  if (!isCreate) {
    for (key in oldDirs) {
      if (!newDirs[key]) {
        // no longer present, unbind
        callHook$1(oldDirs[key], 'unbind', oldVnode, oldVnode, isDestroy);
      }
    }
  }
}

var emptyModifiers = Object.create(null);

function normalizeDirectives$1 (
  dirs,
  vm
) {
  var res = Object.create(null);
  if (!dirs) {
    // $flow-disable-line
    return res
  }
  var i, dir;
  for (i = 0; i < dirs.length; i++) {
    dir = dirs[i];
    if (!dir.modifiers) {
      // $flow-disable-line
      dir.modifiers = emptyModifiers;
    }
    res[getRawDirName(dir)] = dir;
    dir.def = resolveAsset(vm.$options, 'directives', dir.name, true);
  }
  // $flow-disable-line
  return res
}

function getRawDirName (dir) {
  return dir.rawName || ((dir.name) + "." + (Object.keys(dir.modifiers || {}).join('.')))
}

function callHook$1 (dir, hook, vnode, oldVnode, isDestroy) {
  var fn = dir.def && dir.def[hook];
  if (fn) {
    try {
      fn(vnode.elm, dir, vnode, oldVnode, isDestroy);
    } catch (e) {
      handleError(e, vnode.context, ("directive " + (dir.name) + " " + hook + " hook"));
    }
  }
}

var baseModules = [
  ref,
  directives
];

/*  */

function updateAttrs (oldVnode, vnode) {
  var opts = vnode.componentOptions;
  if (isDef(opts) && opts.Ctor.options.inheritAttrs === false) {
    return
  }
  if (isUndef(oldVnode.data.attrs) && isUndef(vnode.data.attrs)) {
    return
  }
  var key, cur, old;
  var elm = vnode.elm;
  var oldAttrs = oldVnode.data.attrs || {};
  var attrs = vnode.data.attrs || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(attrs.__ob__)) {
    attrs = vnode.data.attrs = extend({}, attrs);
  }

  for (key in attrs) {
    cur = attrs[key];
    old = oldAttrs[key];
    if (old !== cur) {
      setAttr(elm, key, cur);
    }
  }
  // #4391: in IE9, setting type can reset value for input[type=radio]
  // #6666: IE/Edge forces progress value down to 1 before setting a max
  /* istanbul ignore if */
  if ((isIE || isEdge) && attrs.value !== oldAttrs.value) {
    setAttr(elm, 'value', attrs.value);
  }
  for (key in oldAttrs) {
    if (isUndef(attrs[key])) {
      if (isXlink(key)) {
        elm.removeAttributeNS(xlinkNS, getXlinkProp(key));
      } else if (!isEnumeratedAttr(key)) {
        elm.removeAttribute(key);
      }
    }
  }
}

function setAttr (el, key, value) {
  if (el.tagName.indexOf('-') > -1) {
    baseSetAttr(el, key, value);
  } else if (isBooleanAttr(key)) {
    // set attribute for blank value
    // e.g. <option disabled>Select one</option>
    if (isFalsyAttrValue(value)) {
      el.removeAttribute(key);
    } else {
      // technically allowfullscreen is a boolean attribute for <iframe>,
      // but Flash expects a value of "true" when used on <embed> tag
      value = key === 'allowfullscreen' && el.tagName === 'EMBED'
        ? 'true'
        : key;
      el.setAttribute(key, value);
    }
  } else if (isEnumeratedAttr(key)) {
    el.setAttribute(key, convertEnumeratedValue(key, value));
  } else if (isXlink(key)) {
    if (isFalsyAttrValue(value)) {
      el.removeAttributeNS(xlinkNS, getXlinkProp(key));
    } else {
      el.setAttributeNS(xlinkNS, key, value);
    }
  } else {
    baseSetAttr(el, key, value);
  }
}

function baseSetAttr (el, key, value) {
  if (isFalsyAttrValue(value)) {
    el.removeAttribute(key);
  } else {
    // #7138: IE10 & 11 fires input event when setting placeholder on
    // <textarea>... block the first input event and remove the blocker
    // immediately.
    /* istanbul ignore if */
    if (
      isIE && !isIE9 &&
      el.tagName === 'TEXTAREA' &&
      key === 'placeholder' && value !== '' && !el.__ieph
    ) {
      var blocker = function (e) {
        e.stopImmediatePropagation();
        el.removeEventListener('input', blocker);
      };
      el.addEventListener('input', blocker);
      // $flow-disable-line
      el.__ieph = true; /* IE placeholder patched */
    }
    el.setAttribute(key, value);
  }
}

var attrs = {
  create: updateAttrs,
  update: updateAttrs
};

/*  */

function updateClass (oldVnode, vnode) {
  var el = vnode.elm;
  var data = vnode.data;
  var oldData = oldVnode.data;
  if (
    isUndef(data.staticClass) &&
    isUndef(data.class) && (
      isUndef(oldData) || (
        isUndef(oldData.staticClass) &&
        isUndef(oldData.class)
      )
    )
  ) {
    return
  }

  var cls = genClassForVnode(vnode);

  // handle transition classes
  var transitionClass = el._transitionClasses;
  if (isDef(transitionClass)) {
    cls = concat(cls, stringifyClass(transitionClass));
  }

  // set the class
  if (cls !== el._prevClass) {
    el.setAttribute('class', cls);
    el._prevClass = cls;
  }
}

var klass = {
  create: updateClass,
  update: updateClass
};

/*  */

var validDivisionCharRE = /[\w).+\-_$\]]/;

function parseFilters (exp) {
  var inSingle = false;
  var inDouble = false;
  var inTemplateString = false;
  var inRegex = false;
  var curly = 0;
  var square = 0;
  var paren = 0;
  var lastFilterIndex = 0;
  var c, prev, i, expression, filters;

  for (i = 0; i < exp.length; i++) {
    prev = c;
    c = exp.charCodeAt(i);
    if (inSingle) {
      if (c === 0x27 && prev !== 0x5C) { inSingle = false; }
    } else if (inDouble) {
      if (c === 0x22 && prev !== 0x5C) { inDouble = false; }
    } else if (inTemplateString) {
      if (c === 0x60 && prev !== 0x5C) { inTemplateString = false; }
    } else if (inRegex) {
      if (c === 0x2f && prev !== 0x5C) { inRegex = false; }
    } else if (
      c === 0x7C && // pipe
      exp.charCodeAt(i + 1) !== 0x7C &&
      exp.charCodeAt(i - 1) !== 0x7C &&
      !curly && !square && !paren
    ) {
      if (expression === undefined) {
        // first filter, end of expression
        lastFilterIndex = i + 1;
        expression = exp.slice(0, i).trim();
      } else {
        pushFilter();
      }
    } else {
      switch (c) {
        case 0x22: inDouble = true; break         // "
        case 0x27: inSingle = true; break         // '
        case 0x60: inTemplateString = true; break // `
        case 0x28: paren++; break                 // (
        case 0x29: paren--; break                 // )
        case 0x5B: square++; break                // [
        case 0x5D: square--; break                // ]
        case 0x7B: curly++; break                 // {
        case 0x7D: curly--; break                 // }
      }
      if (c === 0x2f) { // /
        var j = i - 1;
        var p = (void 0);
        // find first non-whitespace prev char
        for (; j >= 0; j--) {
          p = exp.charAt(j);
          if (p !== ' ') { break }
        }
        if (!p || !validDivisionCharRE.test(p)) {
          inRegex = true;
        }
      }
    }
  }

  if (expression === undefined) {
    expression = exp.slice(0, i).trim();
  } else if (lastFilterIndex !== 0) {
    pushFilter();
  }

  function pushFilter () {
    (filters || (filters = [])).push(exp.slice(lastFilterIndex, i).trim());
    lastFilterIndex = i + 1;
  }

  if (filters) {
    for (i = 0; i < filters.length; i++) {
      expression = wrapFilter(expression, filters[i]);
    }
  }

  return expression
}

function wrapFilter (exp, filter) {
  var i = filter.indexOf('(');
  if (i < 0) {
    // _f: resolveFilter
    return ("_f(\"" + filter + "\")(" + exp + ")")
  } else {
    var name = filter.slice(0, i);
    var args = filter.slice(i + 1);
    return ("_f(\"" + name + "\")(" + exp + (args !== ')' ? ',' + args : args))
  }
}

/*  */



/* eslint-disable no-unused-vars */
function baseWarn (msg, range) {
  console.error(("[Vue compiler]: " + msg));
}
/* eslint-enable no-unused-vars */

function pluckModuleFunction (
  modules,
  key
) {
  return modules
    ? modules.map(function (m) { return m[key]; }).filter(function (_) { return _; })
    : []
}

function addProp (el, name, value, range, dynamic) {
  (el.props || (el.props = [])).push(rangeSetItem({ name: name, value: value, dynamic: dynamic }, range));
  el.plain = false;
}

function addAttr (el, name, value, range, dynamic) {
  var attrs = dynamic
    ? (el.dynamicAttrs || (el.dynamicAttrs = []))
    : (el.attrs || (el.attrs = []));
  attrs.push(rangeSetItem({ name: name, value: value, dynamic: dynamic }, range));
  el.plain = false;
}

// add a raw attr (use this in preTransforms)
function addRawAttr (el, name, value, range) {
  el.attrsMap[name] = value;
  el.attrsList.push(rangeSetItem({ name: name, value: value }, range));
}

function addDirective (
  el,
  name,
  rawName,
  value,
  arg,
  isDynamicArg,
  modifiers,
  range
) {
  (el.directives || (el.directives = [])).push(rangeSetItem({
    name: name,
    rawName: rawName,
    value: value,
    arg: arg,
    isDynamicArg: isDynamicArg,
    modifiers: modifiers
  }, range));
  el.plain = false;
}

function prependModifierMarker (symbol, name, dynamic) {
  return dynamic
    ? ("_p(" + name + ",\"" + symbol + "\")")
    : symbol + name // mark the event as captured
}

function addHandler (
  el,
  name,
  value,
  modifiers,
  important,
  warn,
  range,
  dynamic
) {
  modifiers = modifiers || emptyObject;
  // warn prevent and passive modifier
  /* istanbul ignore if */
  if (
    false
  ) {
    warn(
      'passive and prevent can\'t be used together. ' +
      'Passive handler can\'t prevent default event.',
      range
    );
  }

  // normalize click.right and click.middle since they don't actually fire
  // this is technically browser-specific, but at least for now browsers are
  // the only target envs that have right/middle clicks.
  if (modifiers.right) {
    if (dynamic) {
      name = "(" + name + ")==='click'?'contextmenu':(" + name + ")";
    } else if (name === 'click') {
      name = 'contextmenu';
      delete modifiers.right;
    }
  } else if (modifiers.middle) {
    if (dynamic) {
      name = "(" + name + ")==='click'?'mouseup':(" + name + ")";
    } else if (name === 'click') {
      name = 'mouseup';
    }
  }

  // check capture modifier
  if (modifiers.capture) {
    delete modifiers.capture;
    name = prependModifierMarker('!', name, dynamic);
  }
  if (modifiers.once) {
    delete modifiers.once;
    name = prependModifierMarker('~', name, dynamic);
  }
  /* istanbul ignore if */
  if (modifiers.passive) {
    delete modifiers.passive;
    name = prependModifierMarker('&', name, dynamic);
  }

  var events;
  if (modifiers.native) {
    delete modifiers.native;
    events = el.nativeEvents || (el.nativeEvents = {});
  } else {
    events = el.events || (el.events = {});
  }

  var newHandler = rangeSetItem({ value: value.trim(), dynamic: dynamic }, range);
  if (modifiers !== emptyObject) {
    newHandler.modifiers = modifiers;
  }

  var handlers = events[name];
  /* istanbul ignore if */
  if (Array.isArray(handlers)) {
    important ? handlers.unshift(newHandler) : handlers.push(newHandler);
  } else if (handlers) {
    events[name] = important ? [newHandler, handlers] : [handlers, newHandler];
  } else {
    events[name] = newHandler;
  }

  el.plain = false;
}

function getRawBindingAttr (
  el,
  name
) {
  return el.rawAttrsMap[':' + name] ||
    el.rawAttrsMap['v-bind:' + name] ||
    el.rawAttrsMap[name]
}

function getBindingAttr (
  el,
  name,
  getStatic
) {
  var dynamicValue =
    getAndRemoveAttr(el, ':' + name) ||
    getAndRemoveAttr(el, 'v-bind:' + name);
  if (dynamicValue != null) {
    return parseFilters(dynamicValue)
  } else if (getStatic !== false) {
    var staticValue = getAndRemoveAttr(el, name);
    if (staticValue != null) {
      return JSON.stringify(staticValue)
    }
  }
}

// note: this only removes the attr from the Array (attrsList) so that it
// doesn't get processed by processAttrs.
// By default it does NOT remove it from the map (attrsMap) because the map is
// needed during codegen.
function getAndRemoveAttr (
  el,
  name,
  removeFromMap
) {
  var val;
  if ((val = el.attrsMap[name]) != null) {
    var list = el.attrsList;
    for (var i = 0, l = list.length; i < l; i++) {
      if (list[i].name === name) {
        list.splice(i, 1);
        break
      }
    }
  }
  if (removeFromMap) {
    delete el.attrsMap[name];
  }
  return val
}

function getAndRemoveAttrByRegex (
  el,
  name
) {
  var list = el.attrsList;
  for (var i = 0, l = list.length; i < l; i++) {
    var attr = list[i];
    if (name.test(attr.name)) {
      list.splice(i, 1);
      return attr
    }
  }
}

function rangeSetItem (
  item,
  range
) {
  if (range) {
    if (range.start != null) {
      item.start = range.start;
    }
    if (range.end != null) {
      item.end = range.end;
    }
  }
  return item
}

/*  */

/**
 * Cross-platform code generation for component v-model
 */
function genComponentModel (
  el,
  value,
  modifiers
) {
  var ref = modifiers || {};
  var number = ref.number;
  var trim = ref.trim;

  var baseValueExpression = '$$v';
  var valueExpression = baseValueExpression;
  if (trim) {
    valueExpression =
      "(typeof " + baseValueExpression + " === 'string'" +
      "? " + baseValueExpression + ".trim()" +
      ": " + baseValueExpression + ")";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }
  var assignment = genAssignmentCode(value, valueExpression);

  el.model = {
    value: ("(" + value + ")"),
    expression: JSON.stringify(value),
    callback: ("function (" + baseValueExpression + ") {" + assignment + "}")
  };
}

/**
 * Cross-platform codegen helper for generating v-model value assignment code.
 */
function genAssignmentCode (
  value,
  assignment
) {
  var res = parseModel(value);
  if (res.key === null) {
    return (value + "=" + assignment)
  } else {
    return ("$set(" + (res.exp) + ", " + (res.key) + ", " + assignment + ")")
  }
}

/**
 * Parse a v-model expression into a base path and a final key segment.
 * Handles both dot-path and possible square brackets.
 *
 * Possible cases:
 *
 * - test
 * - test[key]
 * - test[test1[key]]
 * - test["a"][key]
 * - xxx.test[a[a].test1[key]]
 * - test.xxx.a["asa"][test1[key]]
 *
 */

var len, str, chr, index$1, expressionPos, expressionEndPos;



function parseModel (val) {
  // Fix https://github.com/vuejs/vue/pull/7730
  // allow v-model="obj.val " (trailing whitespace)
  val = val.trim();
  len = val.length;

  if (val.indexOf('[') < 0 || val.lastIndexOf(']') < len - 1) {
    index$1 = val.lastIndexOf('.');
    if (index$1 > -1) {
      return {
        exp: val.slice(0, index$1),
        key: '"' + val.slice(index$1 + 1) + '"'
      }
    } else {
      return {
        exp: val,
        key: null
      }
    }
  }

  str = val;
  index$1 = expressionPos = expressionEndPos = 0;

  while (!eof()) {
    chr = next();
    /* istanbul ignore if */
    if (isStringStart(chr)) {
      parseString(chr);
    } else if (chr === 0x5B) {
      parseBracket(chr);
    }
  }

  return {
    exp: val.slice(0, expressionPos),
    key: val.slice(expressionPos + 1, expressionEndPos)
  }
}

function next () {
  return str.charCodeAt(++index$1)
}

function eof () {
  return index$1 >= len
}

function isStringStart (chr) {
  return chr === 0x22 || chr === 0x27
}

function parseBracket (chr) {
  var inBracket = 1;
  expressionPos = index$1;
  while (!eof()) {
    chr = next();
    if (isStringStart(chr)) {
      parseString(chr);
      continue
    }
    if (chr === 0x5B) { inBracket++; }
    if (chr === 0x5D) { inBracket--; }
    if (inBracket === 0) {
      expressionEndPos = index$1;
      break
    }
  }
}

function parseString (chr) {
  var stringQuote = chr;
  while (!eof()) {
    chr = next();
    if (chr === stringQuote) {
      break
    }
  }
}

/*  */

var warn$1;

// in some cases, the event used has to be determined at runtime
// so we used some reserved tokens during compile.
var RANGE_TOKEN = '__r';
var CHECKBOX_RADIO_TOKEN = '__c';

function model (
  el,
  dir,
  _warn
) {
  warn$1 = _warn;
  var value = dir.value;
  var modifiers = dir.modifiers;
  var tag = el.tag;
  var type = el.attrsMap.type;

  if (false) {
    // inputs with type="file" are read only and setting the input's
    // value will throw an error.
    if (tag === 'input' && type === 'file') {
      warn$1(
        "<" + (el.tag) + " v-model=\"" + value + "\" type=\"file\">:\n" +
        "File inputs are read only. Use a v-on:change listener instead.",
        el.rawAttrsMap['v-model']
      );
    }
  }

  if (el.component) {
    genComponentModel(el, value, modifiers);
    // component v-model doesn't need extra runtime
    return false
  } else if (tag === 'select') {
    genSelect(el, value, modifiers);
  } else if (tag === 'input' && type === 'checkbox') {
    genCheckboxModel(el, value, modifiers);
  } else if (tag === 'input' && type === 'radio') {
    genRadioModel(el, value, modifiers);
  } else if (tag === 'input' || tag === 'textarea') {
    genDefaultModel(el, value, modifiers);
  } else if (!config.isReservedTag(tag)) {
    genComponentModel(el, value, modifiers);
    // component v-model doesn't need extra runtime
    return false
  } else if (false) {
    warn$1(
      "<" + (el.tag) + " v-model=\"" + value + "\">: " +
      "v-model is not supported on this element type. " +
      'If you are working with contenteditable, it\'s recommended to ' +
      'wrap a library dedicated for that purpose inside a custom component.',
      el.rawAttrsMap['v-model']
    );
  }

  // ensure runtime directive metadata
  return true
}

function genCheckboxModel (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  var trueValueBinding = getBindingAttr(el, 'true-value') || 'true';
  var falseValueBinding = getBindingAttr(el, 'false-value') || 'false';
  addProp(el, 'checked',
    "Array.isArray(" + value + ")" +
    "?_i(" + value + "," + valueBinding + ")>-1" + (
      trueValueBinding === 'true'
        ? (":(" + value + ")")
        : (":_q(" + value + "," + trueValueBinding + ")")
    )
  );
  addHandler(el, 'change',
    "var $$a=" + value + "," +
        '$$el=$event.target,' +
        "$$c=$$el.checked?(" + trueValueBinding + "):(" + falseValueBinding + ");" +
    'if(Array.isArray($$a)){' +
      "var $$v=" + (number ? '_n(' + valueBinding + ')' : valueBinding) + "," +
          '$$i=_i($$a,$$v);' +
      "if($$el.checked){$$i<0&&(" + (genAssignmentCode(value, '$$a.concat([$$v])')) + ")}" +
      "else{$$i>-1&&(" + (genAssignmentCode(value, '$$a.slice(0,$$i).concat($$a.slice($$i+1))')) + ")}" +
    "}else{" + (genAssignmentCode(value, '$$c')) + "}",
    null, true
  );
}

function genRadioModel (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  valueBinding = number ? ("_n(" + valueBinding + ")") : valueBinding;
  addProp(el, 'checked', ("_q(" + value + "," + valueBinding + ")"));
  addHandler(el, 'change', genAssignmentCode(value, valueBinding), null, true);
}

function genSelect (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var selectedVal = "Array.prototype.filter" +
    ".call($event.target.options,function(o){return o.selected})" +
    ".map(function(o){var val = \"_value\" in o ? o._value : o.value;" +
    "return " + (number ? '_n(val)' : 'val') + "})";

  var assignment = '$event.target.multiple ? $$selectedVal : $$selectedVal[0]';
  var code = "var $$selectedVal = " + selectedVal + ";";
  code = code + " " + (genAssignmentCode(value, assignment));
  addHandler(el, 'change', code, null, true);
}

function genDefaultModel (
  el,
  value,
  modifiers
) {
  var type = el.attrsMap.type;

  // warn if v-bind:value conflicts with v-model
  // except for inputs with v-bind:type
  if (false) {
    var value$1 = el.attrsMap['v-bind:value'] || el.attrsMap[':value'];
    var typeBinding = el.attrsMap['v-bind:type'] || el.attrsMap[':type'];
    if (value$1 && !typeBinding) {
      var binding = el.attrsMap['v-bind:value'] ? 'v-bind:value' : ':value';
      warn$1(
        binding + "=\"" + value$1 + "\" conflicts with v-model on the same element " +
        'because the latter already expands to a value binding internally',
        el.rawAttrsMap[binding]
      );
    }
  }

  var ref = modifiers || {};
  var lazy = ref.lazy;
  var number = ref.number;
  var trim = ref.trim;
  var needCompositionGuard = !lazy && type !== 'range';
  var event = lazy
    ? 'change'
    : type === 'range'
      ? RANGE_TOKEN
      : 'input';

  var valueExpression = '$event.target.value';
  if (trim) {
    valueExpression = "$event.target.value.trim()";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }

  var code = genAssignmentCode(value, valueExpression);
  if (needCompositionGuard) {
    code = "if($event.target.composing)return;" + code;
  }

  addProp(el, 'value', ("(" + value + ")"));
  addHandler(el, event, code, null, true);
  if (trim || number) {
    addHandler(el, 'blur', '$forceUpdate()');
  }
}

/*  */

// normalize v-model event tokens that can only be determined at runtime.
// it's important to place the event as the first in the array because
// the whole point is ensuring the v-model callback gets called before
// user-attached handlers.
function normalizeEvents (on) {
  /* istanbul ignore if */
  if (isDef(on[RANGE_TOKEN])) {
    // IE input[type=range] only supports `change` event
    var event = isIE ? 'change' : 'input';
    on[event] = [].concat(on[RANGE_TOKEN], on[event] || []);
    delete on[RANGE_TOKEN];
  }
  // This was originally intended to fix #4521 but no longer necessary
  // after 2.5. Keeping it for backwards compat with generated code from < 2.4
  /* istanbul ignore if */
  if (isDef(on[CHECKBOX_RADIO_TOKEN])) {
    on.change = [].concat(on[CHECKBOX_RADIO_TOKEN], on.change || []);
    delete on[CHECKBOX_RADIO_TOKEN];
  }
}

var target$1;

function createOnceHandler$1 (event, handler, capture) {
  var _target = target$1; // save current target element in closure
  return function onceHandler () {
    var res = handler.apply(null, arguments);
    if (res !== null) {
      remove$2(event, onceHandler, capture, _target);
    }
  }
}

// #9446: Firefox <= 53 (in particular, ESR 52) has incorrect Event.timeStamp
// implementation and does not fire microtasks in between event propagation, so
// safe to exclude.
var useMicrotaskFix = isUsingMicroTask && !(isFF && Number(isFF[1]) <= 53);

function add$1 (
  name,
  handler,
  capture,
  passive
) {
  // async edge case #6566: inner click event triggers patch, event handler
  // attached to outer element during patch, and triggered again. This
  // happens because browsers fire microtask ticks between event propagation.
  // the solution is simple: we save the timestamp when a handler is attached,
  // and the handler would only fire if the event passed to it was fired
  // AFTER it was attached.
  if (useMicrotaskFix) {
    var attachedTimestamp = currentFlushTimestamp;
    var original = handler;
    handler = original._wrapper = function (e) {
      if (
        // no bubbling, should always fire.
        // this is just a safety net in case event.timeStamp is unreliable in
        // certain weird environments...
        e.target === e.currentTarget ||
        // event is fired after handler attachment
        e.timeStamp >= attachedTimestamp ||
        // bail for environments that have buggy event.timeStamp implementations
        // #9462 iOS 9 bug: event.timeStamp is 0 after history.pushState
        // #9681 QtWebEngine event.timeStamp is negative value
        e.timeStamp <= 0 ||
        // #9448 bail if event is fired in another document in a multi-page
        // electron/nw.js app, since event.timeStamp will be using a different
        // starting reference
        e.target.ownerDocument !== document
      ) {
        return original.apply(this, arguments)
      }
    };
  }
  target$1.addEventListener(
    name,
    handler,
    supportsPassive
      ? { capture: capture, passive: passive }
      : capture
  );
}

function remove$2 (
  name,
  handler,
  capture,
  _target
) {
  (_target || target$1).removeEventListener(
    name,
    handler._wrapper || handler,
    capture
  );
}

function updateDOMListeners (oldVnode, vnode) {
  if (isUndef(oldVnode.data.on) && isUndef(vnode.data.on)) {
    return
  }
  var on = vnode.data.on || {};
  var oldOn = oldVnode.data.on || {};
  target$1 = vnode.elm;
  normalizeEvents(on);
  updateListeners(on, oldOn, add$1, remove$2, createOnceHandler$1, vnode.context);
  target$1 = undefined;
}

var events = {
  create: updateDOMListeners,
  update: updateDOMListeners
};

/*  */

var svgContainer;

function updateDOMProps (oldVnode, vnode) {
  if (isUndef(oldVnode.data.domProps) && isUndef(vnode.data.domProps)) {
    return
  }
  var key, cur;
  var elm = vnode.elm;
  var oldProps = oldVnode.data.domProps || {};
  var props = vnode.data.domProps || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(props.__ob__)) {
    props = vnode.data.domProps = extend({}, props);
  }

  for (key in oldProps) {
    if (!(key in props)) {
      elm[key] = '';
    }
  }

  for (key in props) {
    cur = props[key];
    // ignore children if the node has textContent or innerHTML,
    // as these will throw away existing DOM nodes and cause removal errors
    // on subsequent patches (#3360)
    if (key === 'textContent' || key === 'innerHTML') {
      if (vnode.children) { vnode.children.length = 0; }
      if (cur === oldProps[key]) { continue }
      // #6601 work around Chrome version <= 55 bug where single textNode
      // replaced by innerHTML/textContent retains its parentNode property
      if (elm.childNodes.length === 1) {
        elm.removeChild(elm.childNodes[0]);
      }
    }

    if (key === 'value' && elm.tagName !== 'PROGRESS') {
      // store value as _value as well since
      // non-string values will be stringified
      elm._value = cur;
      // avoid resetting cursor position when value is the same
      var strCur = isUndef(cur) ? '' : String(cur);
      if (shouldUpdateValue(elm, strCur)) {
        elm.value = strCur;
      }
    } else if (key === 'innerHTML' && isSVG(elm.tagName) && isUndef(elm.innerHTML)) {
      // IE doesn't support innerHTML for SVG elements
      svgContainer = svgContainer || document.createElement('div');
      svgContainer.innerHTML = "<svg>" + cur + "</svg>";
      var svg = svgContainer.firstChild;
      while (elm.firstChild) {
        elm.removeChild(elm.firstChild);
      }
      while (svg.firstChild) {
        elm.appendChild(svg.firstChild);
      }
    } else if (
      // skip the update if old and new VDOM state is the same.
      // `value` is handled separately because the DOM value may be temporarily
      // out of sync with VDOM state due to focus, composition and modifiers.
      // This  #4521 by skipping the unnecessary `checked` update.
      cur !== oldProps[key]
    ) {
      // some property updates can throw
      // e.g. `value` on <progress> w/ non-finite value
      try {
        elm[key] = cur;
      } catch (e) {}
    }
  }
}

// check platforms/web/util/attrs.js acceptValue


function shouldUpdateValue (elm, checkVal) {
  return (!elm.composing && (
    elm.tagName === 'OPTION' ||
    isNotInFocusAndDirty(elm, checkVal) ||
    isDirtyWithModifiers(elm, checkVal)
  ))
}

function isNotInFocusAndDirty (elm, checkVal) {
  // return true when textbox (.number and .trim) loses focus and its value is
  // not equal to the updated value
  var notInFocus = true;
  // #6157
  // work around IE bug when accessing document.activeElement in an iframe
  try { notInFocus = document.activeElement !== elm; } catch (e) {}
  return notInFocus && elm.value !== checkVal
}

function isDirtyWithModifiers (elm, newVal) {
  var value = elm.value;
  var modifiers = elm._vModifiers; // injected by v-model runtime
  if (isDef(modifiers)) {
    if (modifiers.number) {
      return toNumber(value) !== toNumber(newVal)
    }
    if (modifiers.trim) {
      return value.trim() !== newVal.trim()
    }
  }
  return value !== newVal
}

var domProps = {
  create: updateDOMProps,
  update: updateDOMProps
};

/*  */

var parseStyleText = cached(function (cssText) {
  var res = {};
  var listDelimiter = /;(?![^(]*\))/g;
  var propertyDelimiter = /:(.+)/;
  cssText.split(listDelimiter).forEach(function (item) {
    if (item) {
      var tmp = item.split(propertyDelimiter);
      tmp.length > 1 && (res[tmp[0].trim()] = tmp[1].trim());
    }
  });
  return res
});

// merge static and dynamic style data on the same vnode
function normalizeStyleData (data) {
  var style = normalizeStyleBinding(data.style);
  // static style is pre-processed into an object during compilation
  // and is always a fresh object, so it's safe to merge into it
  return data.staticStyle
    ? extend(data.staticStyle, style)
    : style
}

// normalize possible array / string values into Object
function normalizeStyleBinding (bindingStyle) {
  if (Array.isArray(bindingStyle)) {
    return toObject(bindingStyle)
  }
  if (typeof bindingStyle === 'string') {
    return parseStyleText(bindingStyle)
  }
  return bindingStyle
}

/**
 * parent component style should be after child's
 * so that parent component's style could override it
 */
function getStyle (vnode, checkChild) {
  var res = {};
  var styleData;

  if (checkChild) {
    var childNode = vnode;
    while (childNode.componentInstance) {
      childNode = childNode.componentInstance._vnode;
      if (
        childNode && childNode.data &&
        (styleData = normalizeStyleData(childNode.data))
      ) {
        extend(res, styleData);
      }
    }
  }

  if ((styleData = normalizeStyleData(vnode.data))) {
    extend(res, styleData);
  }

  var parentNode = vnode;
  while ((parentNode = parentNode.parent)) {
    if (parentNode.data && (styleData = normalizeStyleData(parentNode.data))) {
      extend(res, styleData);
    }
  }
  return res
}

/*  */

var cssVarRE = /^--/;
var importantRE = /\s*!important$/;
var setProp = function (el, name, val) {
  /* istanbul ignore if */
  if (cssVarRE.test(name)) {
    el.style.setProperty(name, val);
  } else if (importantRE.test(val)) {
    el.style.setProperty(hyphenate(name), val.replace(importantRE, ''), 'important');
  } else {
    var normalizedName = normalize(name);
    if (Array.isArray(val)) {
      // Support values array created by autoprefixer, e.g.
      // {display: ["-webkit-box", "-ms-flexbox", "flex"]}
      // Set them one by one, and the browser will only set those it can recognize
      for (var i = 0, len = val.length; i < len; i++) {
        el.style[normalizedName] = val[i];
      }
    } else {
      el.style[normalizedName] = val;
    }
  }
};

var vendorNames = ['Webkit', 'Moz', 'ms'];

var emptyStyle;
var normalize = cached(function (prop) {
  emptyStyle = emptyStyle || document.createElement('div').style;
  prop = camelize(prop);
  if (prop !== 'filter' && (prop in emptyStyle)) {
    return prop
  }
  var capName = prop.charAt(0).toUpperCase() + prop.slice(1);
  for (var i = 0; i < vendorNames.length; i++) {
    var name = vendorNames[i] + capName;
    if (name in emptyStyle) {
      return name
    }
  }
});

function updateStyle (oldVnode, vnode) {
  var data = vnode.data;
  var oldData = oldVnode.data;

  if (isUndef(data.staticStyle) && isUndef(data.style) &&
    isUndef(oldData.staticStyle) && isUndef(oldData.style)
  ) {
    return
  }

  var cur, name;
  var el = vnode.elm;
  var oldStaticStyle = oldData.staticStyle;
  var oldStyleBinding = oldData.normalizedStyle || oldData.style || {};

  // if static style exists, stylebinding already merged into it when doing normalizeStyleData
  var oldStyle = oldStaticStyle || oldStyleBinding;

  var style = normalizeStyleBinding(vnode.data.style) || {};

  // store normalized style under a different key for next diff
  // make sure to clone it if it's reactive, since the user likely wants
  // to mutate it.
  vnode.data.normalizedStyle = isDef(style.__ob__)
    ? extend({}, style)
    : style;

  var newStyle = getStyle(vnode, true);

  for (name in oldStyle) {
    if (isUndef(newStyle[name])) {
      setProp(el, name, '');
    }
  }
  for (name in newStyle) {
    cur = newStyle[name];
    if (cur !== oldStyle[name]) {
      // ie9 setting to null has no effect, must use empty string
      setProp(el, name, cur == null ? '' : cur);
    }
  }
}

var style = {
  create: updateStyle,
  update: updateStyle
};

/*  */

var whitespaceRE = /\s+/;

/**
 * Add class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function addClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(whitespaceRE).forEach(function (c) { return el.classList.add(c); });
    } else {
      el.classList.add(cls);
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    if (cur.indexOf(' ' + cls + ' ') < 0) {
      el.setAttribute('class', (cur + cls).trim());
    }
  }
}

/**
 * Remove class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function removeClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(whitespaceRE).forEach(function (c) { return el.classList.remove(c); });
    } else {
      el.classList.remove(cls);
    }
    if (!el.classList.length) {
      el.removeAttribute('class');
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    var tar = ' ' + cls + ' ';
    while (cur.indexOf(tar) >= 0) {
      cur = cur.replace(tar, ' ');
    }
    cur = cur.trim();
    if (cur) {
      el.setAttribute('class', cur);
    } else {
      el.removeAttribute('class');
    }
  }
}

/*  */

function resolveTransition (def$$1) {
  if (!def$$1) {
    return
  }
  /* istanbul ignore else */
  if (typeof def$$1 === 'object') {
    var res = {};
    if (def$$1.css !== false) {
      extend(res, autoCssTransition(def$$1.name || 'v'));
    }
    extend(res, def$$1);
    return res
  } else if (typeof def$$1 === 'string') {
    return autoCssTransition(def$$1)
  }
}

var autoCssTransition = cached(function (name) {
  return {
    enterClass: (name + "-enter"),
    enterToClass: (name + "-enter-to"),
    enterActiveClass: (name + "-enter-active"),
    leaveClass: (name + "-leave"),
    leaveToClass: (name + "-leave-to"),
    leaveActiveClass: (name + "-leave-active")
  }
});

var hasTransition = inBrowser && !isIE9;
var TRANSITION = 'transition';
var ANIMATION = 'animation';

// Transition property/event sniffing
var transitionProp = 'transition';
var transitionEndEvent = 'transitionend';
var animationProp = 'animation';
var animationEndEvent = 'animationend';
if (hasTransition) {
  /* istanbul ignore if */
  if (window.ontransitionend === undefined &&
    window.onwebkittransitionend !== undefined
  ) {
    transitionProp = 'WebkitTransition';
    transitionEndEvent = 'webkitTransitionEnd';
  }
  if (window.onanimationend === undefined &&
    window.onwebkitanimationend !== undefined
  ) {
    animationProp = 'WebkitAnimation';
    animationEndEvent = 'webkitAnimationEnd';
  }
}

// binding to window is necessary to make hot reload work in IE in strict mode
var raf = inBrowser
  ? window.requestAnimationFrame
    ? window.requestAnimationFrame.bind(window)
    : setTimeout
  : /* istanbul ignore next */ function (fn) { return fn(); };

function nextFrame (fn) {
  raf(function () {
    raf(fn);
  });
}

function addTransitionClass (el, cls) {
  var transitionClasses = el._transitionClasses || (el._transitionClasses = []);
  if (transitionClasses.indexOf(cls) < 0) {
    transitionClasses.push(cls);
    addClass(el, cls);
  }
}

function removeTransitionClass (el, cls) {
  if (el._transitionClasses) {
    remove(el._transitionClasses, cls);
  }
  removeClass(el, cls);
}

function whenTransitionEnds (
  el,
  expectedType,
  cb
) {
  var ref = getTransitionInfo(el, expectedType);
  var type = ref.type;
  var timeout = ref.timeout;
  var propCount = ref.propCount;
  if (!type) { return cb() }
  var event = type === TRANSITION ? transitionEndEvent : animationEndEvent;
  var ended = 0;
  var end = function () {
    el.removeEventListener(event, onEnd);
    cb();
  };
  var onEnd = function (e) {
    if (e.target === el) {
      if (++ended >= propCount) {
        end();
      }
    }
  };
  setTimeout(function () {
    if (ended < propCount) {
      end();
    }
  }, timeout + 1);
  el.addEventListener(event, onEnd);
}

var transformRE = /\b(transform|all)(,|$)/;

function getTransitionInfo (el, expectedType) {
  var styles = window.getComputedStyle(el);
  // JSDOM may return undefined for transition properties
  var transitionDelays = (styles[transitionProp + 'Delay'] || '').split(', ');
  var transitionDurations = (styles[transitionProp + 'Duration'] || '').split(', ');
  var transitionTimeout = getTimeout(transitionDelays, transitionDurations);
  var animationDelays = (styles[animationProp + 'Delay'] || '').split(', ');
  var animationDurations = (styles[animationProp + 'Duration'] || '').split(', ');
  var animationTimeout = getTimeout(animationDelays, animationDurations);

  var type;
  var timeout = 0;
  var propCount = 0;
  /* istanbul ignore if */
  if (expectedType === TRANSITION) {
    if (transitionTimeout > 0) {
      type = TRANSITION;
      timeout = transitionTimeout;
      propCount = transitionDurations.length;
    }
  } else if (expectedType === ANIMATION) {
    if (animationTimeout > 0) {
      type = ANIMATION;
      timeout = animationTimeout;
      propCount = animationDurations.length;
    }
  } else {
    timeout = Math.max(transitionTimeout, animationTimeout);
    type = timeout > 0
      ? transitionTimeout > animationTimeout
        ? TRANSITION
        : ANIMATION
      : null;
    propCount = type
      ? type === TRANSITION
        ? transitionDurations.length
        : animationDurations.length
      : 0;
  }
  var hasTransform =
    type === TRANSITION &&
    transformRE.test(styles[transitionProp + 'Property']);
  return {
    type: type,
    timeout: timeout,
    propCount: propCount,
    hasTransform: hasTransform
  }
}

function getTimeout (delays, durations) {
  /* istanbul ignore next */
  while (delays.length < durations.length) {
    delays = delays.concat(delays);
  }

  return Math.max.apply(null, durations.map(function (d, i) {
    return toMs(d) + toMs(delays[i])
  }))
}

// Old versions of Chromium (below 61.0.3163.100) formats floating pointer numbers
// in a locale-dependent way, using a comma instead of a dot.
// If comma is not replaced with a dot, the input will be rounded down (i.e. acting
// as a floor function) causing unexpected behaviors
function toMs (s) {
  return Number(s.slice(0, -1).replace(',', '.')) * 1000
}

/*  */

function enter (vnode, toggleDisplay) {
  var el = vnode.elm;

  // call leave callback now
  if (isDef(el._leaveCb)) {
    el._leaveCb.cancelled = true;
    el._leaveCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data)) {
    return
  }

  /* istanbul ignore if */
  if (isDef(el._enterCb) || el.nodeType !== 1) {
    return
  }

  var css = data.css;
  var type = data.type;
  var enterClass = data.enterClass;
  var enterToClass = data.enterToClass;
  var enterActiveClass = data.enterActiveClass;
  var appearClass = data.appearClass;
  var appearToClass = data.appearToClass;
  var appearActiveClass = data.appearActiveClass;
  var beforeEnter = data.beforeEnter;
  var enter = data.enter;
  var afterEnter = data.afterEnter;
  var enterCancelled = data.enterCancelled;
  var beforeAppear = data.beforeAppear;
  var appear = data.appear;
  var afterAppear = data.afterAppear;
  var appearCancelled = data.appearCancelled;
  var duration = data.duration;

  // activeInstance will always be the <transition> component managing this
  // transition. One edge case to check is when the <transition> is placed
  // as the root node of a child component. In that case we need to check
  // <transition>'s parent for appear check.
  var context = activeInstance;
  var transitionNode = activeInstance.$vnode;
  while (transitionNode && transitionNode.parent) {
    context = transitionNode.context;
    transitionNode = transitionNode.parent;
  }

  var isAppear = !context._isMounted || !vnode.isRootInsert;

  if (isAppear && !appear && appear !== '') {
    return
  }

  var startClass = isAppear && appearClass
    ? appearClass
    : enterClass;
  var activeClass = isAppear && appearActiveClass
    ? appearActiveClass
    : enterActiveClass;
  var toClass = isAppear && appearToClass
    ? appearToClass
    : enterToClass;

  var beforeEnterHook = isAppear
    ? (beforeAppear || beforeEnter)
    : beforeEnter;
  var enterHook = isAppear
    ? (typeof appear === 'function' ? appear : enter)
    : enter;
  var afterEnterHook = isAppear
    ? (afterAppear || afterEnter)
    : afterEnter;
  var enterCancelledHook = isAppear
    ? (appearCancelled || enterCancelled)
    : enterCancelled;

  var explicitEnterDuration = toNumber(
    isObject(duration)
      ? duration.enter
      : duration
  );

  if (false) {
    checkDuration(explicitEnterDuration, 'enter', vnode);
  }

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(enterHook);

  var cb = el._enterCb = once(function () {
    if (expectsCSS) {
      removeTransitionClass(el, toClass);
      removeTransitionClass(el, activeClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, startClass);
      }
      enterCancelledHook && enterCancelledHook(el);
    } else {
      afterEnterHook && afterEnterHook(el);
    }
    el._enterCb = null;
  });

  if (!vnode.data.show) {
    // remove pending leave element on enter by injecting an insert hook
    mergeVNodeHook(vnode, 'insert', function () {
      var parent = el.parentNode;
      var pendingNode = parent && parent._pending && parent._pending[vnode.key];
      if (pendingNode &&
        pendingNode.tag === vnode.tag &&
        pendingNode.elm._leaveCb
      ) {
        pendingNode.elm._leaveCb();
      }
      enterHook && enterHook(el, cb);
    });
  }

  // start enter transition
  beforeEnterHook && beforeEnterHook(el);
  if (expectsCSS) {
    addTransitionClass(el, startClass);
    addTransitionClass(el, activeClass);
    nextFrame(function () {
      removeTransitionClass(el, startClass);
      if (!cb.cancelled) {
        addTransitionClass(el, toClass);
        if (!userWantsControl) {
          if (isValidDuration(explicitEnterDuration)) {
            setTimeout(cb, explicitEnterDuration);
          } else {
            whenTransitionEnds(el, type, cb);
          }
        }
      }
    });
  }

  if (vnode.data.show) {
    toggleDisplay && toggleDisplay();
    enterHook && enterHook(el, cb);
  }

  if (!expectsCSS && !userWantsControl) {
    cb();
  }
}

function leave (vnode, rm) {
  var el = vnode.elm;

  // call enter callback now
  if (isDef(el._enterCb)) {
    el._enterCb.cancelled = true;
    el._enterCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data) || el.nodeType !== 1) {
    return rm()
  }

  /* istanbul ignore if */
  if (isDef(el._leaveCb)) {
    return
  }

  var css = data.css;
  var type = data.type;
  var leaveClass = data.leaveClass;
  var leaveToClass = data.leaveToClass;
  var leaveActiveClass = data.leaveActiveClass;
  var beforeLeave = data.beforeLeave;
  var leave = data.leave;
  var afterLeave = data.afterLeave;
  var leaveCancelled = data.leaveCancelled;
  var delayLeave = data.delayLeave;
  var duration = data.duration;

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(leave);

  var explicitLeaveDuration = toNumber(
    isObject(duration)
      ? duration.leave
      : duration
  );

  if (false) {
    checkDuration(explicitLeaveDuration, 'leave', vnode);
  }

  var cb = el._leaveCb = once(function () {
    if (el.parentNode && el.parentNode._pending) {
      el.parentNode._pending[vnode.key] = null;
    }
    if (expectsCSS) {
      removeTransitionClass(el, leaveToClass);
      removeTransitionClass(el, leaveActiveClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, leaveClass);
      }
      leaveCancelled && leaveCancelled(el);
    } else {
      rm();
      afterLeave && afterLeave(el);
    }
    el._leaveCb = null;
  });

  if (delayLeave) {
    delayLeave(performLeave);
  } else {
    performLeave();
  }

  function performLeave () {
    // the delayed leave may have already been cancelled
    if (cb.cancelled) {
      return
    }
    // record leaving element
    if (!vnode.data.show && el.parentNode) {
      (el.parentNode._pending || (el.parentNode._pending = {}))[(vnode.key)] = vnode;
    }
    beforeLeave && beforeLeave(el);
    if (expectsCSS) {
      addTransitionClass(el, leaveClass);
      addTransitionClass(el, leaveActiveClass);
      nextFrame(function () {
        removeTransitionClass(el, leaveClass);
        if (!cb.cancelled) {
          addTransitionClass(el, leaveToClass);
          if (!userWantsControl) {
            if (isValidDuration(explicitLeaveDuration)) {
              setTimeout(cb, explicitLeaveDuration);
            } else {
              whenTransitionEnds(el, type, cb);
            }
          }
        }
      });
    }
    leave && leave(el, cb);
    if (!expectsCSS && !userWantsControl) {
      cb();
    }
  }
}

// only used in dev mode
function checkDuration (val, name, vnode) {
  if (typeof val !== 'number') {
    warn(
      "<transition> explicit " + name + " duration is not a valid number - " +
      "got " + (JSON.stringify(val)) + ".",
      vnode.context
    );
  } else if (isNaN(val)) {
    warn(
      "<transition> explicit " + name + " duration is NaN - " +
      'the duration expression might be incorrect.',
      vnode.context
    );
  }
}

function isValidDuration (val) {
  return typeof val === 'number' && !isNaN(val)
}

/**
 * Normalize a transition hook's argument length. The hook may be:
 * - a merged hook (invoker) with the original in .fns
 * - a wrapped component method (check ._length)
 * - a plain function (.length)
 */
function getHookArgumentsLength (fn) {
  if (isUndef(fn)) {
    return false
  }
  var invokerFns = fn.fns;
  if (isDef(invokerFns)) {
    // invoker
    return getHookArgumentsLength(
      Array.isArray(invokerFns)
        ? invokerFns[0]
        : invokerFns
    )
  } else {
    return (fn._length || fn.length) > 1
  }
}

function _enter (_, vnode) {
  if (vnode.data.show !== true) {
    enter(vnode);
  }
}

var transition = inBrowser ? {
  create: _enter,
  activate: _enter,
  remove: function remove$$1 (vnode, rm) {
    /* istanbul ignore else */
    if (vnode.data.show !== true) {
      leave(vnode, rm);
    } else {
      rm();
    }
  }
} : {};

var platformModules = [
  attrs,
  klass,
  events,
  domProps,
  style,
  transition
];

/*  */

// the directive module should be applied last, after all
// built-in modules have been applied.
var modules = platformModules.concat(baseModules);

var patch = createPatchFunction({ nodeOps: nodeOps, modules: modules });

/**
 * Not type checking this file because flow doesn't like attaching
 * properties to Elements.
 */

/* istanbul ignore if */
if (isIE9) {
  // http://www.matts411.com/post/internet-explorer-9-oninput/
  document.addEventListener('selectionchange', function () {
    var el = document.activeElement;
    if (el && el.vmodel) {
      trigger(el, 'input');
    }
  });
}

var directive = {
  inserted: function inserted (el, binding, vnode, oldVnode) {
    if (vnode.tag === 'select') {
      // #6903
      if (oldVnode.elm && !oldVnode.elm._vOptions) {
        mergeVNodeHook(vnode, 'postpatch', function () {
          directive.componentUpdated(el, binding, vnode);
        });
      } else {
        setSelected(el, binding, vnode.context);
      }
      el._vOptions = [].map.call(el.options, getValue);
    } else if (vnode.tag === 'textarea' || isTextInputType(el.type)) {
      el._vModifiers = binding.modifiers;
      if (!binding.modifiers.lazy) {
        el.addEventListener('compositionstart', onCompositionStart);
        el.addEventListener('compositionend', onCompositionEnd);
        // Safari < 10.2 & UIWebView doesn't fire compositionend when
        // switching focus before confirming composition choice
        // this also fixes the issue where some browsers e.g. iOS Chrome
        // fires "change" instead of "input" on autocomplete.
        el.addEventListener('change', onCompositionEnd);
        /* istanbul ignore if */
        if (isIE9) {
          el.vmodel = true;
        }
      }
    }
  },

  componentUpdated: function componentUpdated (el, binding, vnode) {
    if (vnode.tag === 'select') {
      setSelected(el, binding, vnode.context);
      // in case the options rendered by v-for have changed,
      // it's possible that the value is out-of-sync with the rendered options.
      // detect such cases and filter out values that no longer has a matching
      // option in the DOM.
      var prevOptions = el._vOptions;
      var curOptions = el._vOptions = [].map.call(el.options, getValue);
      if (curOptions.some(function (o, i) { return !looseEqual(o, prevOptions[i]); })) {
        // trigger change event if
        // no matching option found for at least one value
        var needReset = el.multiple
          ? binding.value.some(function (v) { return hasNoMatchingOption(v, curOptions); })
          : binding.value !== binding.oldValue && hasNoMatchingOption(binding.value, curOptions);
        if (needReset) {
          trigger(el, 'change');
        }
      }
    }
  }
};

function setSelected (el, binding, vm) {
  actuallySetSelected(el, binding, vm);
  /* istanbul ignore if */
  if (isIE || isEdge) {
    setTimeout(function () {
      actuallySetSelected(el, binding, vm);
    }, 0);
  }
}

function actuallySetSelected (el, binding, vm) {
  var value = binding.value;
  var isMultiple = el.multiple;
  if (isMultiple && !Array.isArray(value)) {
    "production" !== 'production' && warn(
      "<select multiple v-model=\"" + (binding.expression) + "\"> " +
      "expects an Array value for its binding, but got " + (Object.prototype.toString.call(value).slice(8, -1)),
      vm
    );
    return
  }
  var selected, option;
  for (var i = 0, l = el.options.length; i < l; i++) {
    option = el.options[i];
    if (isMultiple) {
      selected = looseIndexOf(value, getValue(option)) > -1;
      if (option.selected !== selected) {
        option.selected = selected;
      }
    } else {
      if (looseEqual(getValue(option), value)) {
        if (el.selectedIndex !== i) {
          el.selectedIndex = i;
        }
        return
      }
    }
  }
  if (!isMultiple) {
    el.selectedIndex = -1;
  }
}

function hasNoMatchingOption (value, options) {
  return options.every(function (o) { return !looseEqual(o, value); })
}

function getValue (option) {
  return '_value' in option
    ? option._value
    : option.value
}

function onCompositionStart (e) {
  e.target.composing = true;
}

function onCompositionEnd (e) {
  // prevent triggering an input event for no reason
  if (!e.target.composing) { return }
  e.target.composing = false;
  trigger(e.target, 'input');
}

function trigger (el, type) {
  var e = document.createEvent('HTMLEvents');
  e.initEvent(type, true, true);
  el.dispatchEvent(e);
}

/*  */

// recursively search for possible transition defined inside the component root
function locateNode (vnode) {
  return vnode.componentInstance && (!vnode.data || !vnode.data.transition)
    ? locateNode(vnode.componentInstance._vnode)
    : vnode
}

var show = {
  bind: function bind (el, ref, vnode) {
    var value = ref.value;

    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    var originalDisplay = el.__vOriginalDisplay =
      el.style.display === 'none' ? '' : el.style.display;
    if (value && transition$$1) {
      vnode.data.show = true;
      enter(vnode, function () {
        el.style.display = originalDisplay;
      });
    } else {
      el.style.display = value ? originalDisplay : 'none';
    }
  },

  update: function update (el, ref, vnode) {
    var value = ref.value;
    var oldValue = ref.oldValue;

    /* istanbul ignore if */
    if (!value === !oldValue) { return }
    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    if (transition$$1) {
      vnode.data.show = true;
      if (value) {
        enter(vnode, function () {
          el.style.display = el.__vOriginalDisplay;
        });
      } else {
        leave(vnode, function () {
          el.style.display = 'none';
        });
      }
    } else {
      el.style.display = value ? el.__vOriginalDisplay : 'none';
    }
  },

  unbind: function unbind (
    el,
    binding,
    vnode,
    oldVnode,
    isDestroy
  ) {
    if (!isDestroy) {
      el.style.display = el.__vOriginalDisplay;
    }
  }
};

var platformDirectives = {
  model: directive,
  show: show
};

/*  */

var transitionProps = {
  name: String,
  appear: Boolean,
  css: Boolean,
  mode: String,
  type: String,
  enterClass: String,
  leaveClass: String,
  enterToClass: String,
  leaveToClass: String,
  enterActiveClass: String,
  leaveActiveClass: String,
  appearClass: String,
  appearActiveClass: String,
  appearToClass: String,
  duration: [Number, String, Object]
};

// in case the child is also an abstract component, e.g. <keep-alive>
// we want to recursively retrieve the real component to be rendered
function getRealChild (vnode) {
  var compOptions = vnode && vnode.componentOptions;
  if (compOptions && compOptions.Ctor.options.abstract) {
    return getRealChild(getFirstComponentChild(compOptions.children))
  } else {
    return vnode
  }
}

function extractTransitionData (comp) {
  var data = {};
  var options = comp.$options;
  // props
  for (var key in options.propsData) {
    data[key] = comp[key];
  }
  // events.
  // extract listeners and pass them directly to the transition methods
  var listeners = options._parentListeners;
  for (var key$1 in listeners) {
    data[camelize(key$1)] = listeners[key$1];
  }
  return data
}

function placeholder (h, rawChild) {
  if (/\d-keep-alive$/.test(rawChild.tag)) {
    return h('keep-alive', {
      props: rawChild.componentOptions.propsData
    })
  }
}

function hasParentTransition (vnode) {
  while ((vnode = vnode.parent)) {
    if (vnode.data.transition) {
      return true
    }
  }
}

function isSameChild (child, oldChild) {
  return oldChild.key === child.key && oldChild.tag === child.tag
}

var isNotTextNode = function (c) { return c.tag || isAsyncPlaceholder(c); };

var isVShowDirective = function (d) { return d.name === 'show'; };

var Transition = {
  name: 'transition',
  props: transitionProps,
  abstract: true,

  render: function render (h) {
    var this$1 = this;

    var children = this.$slots.default;
    if (!children) {
      return
    }

    // filter out text nodes (possible whitespaces)
    children = children.filter(isNotTextNode);
    /* istanbul ignore if */
    if (!children.length) {
      return
    }

    // warn multiple elements
    if (false) {
      warn(
        '<transition> can only be used on a single element. Use ' +
        '<transition-group> for lists.',
        this.$parent
      );
    }

    var mode = this.mode;

    // warn invalid mode
    if (false
    ) {
      warn(
        'invalid <transition> mode: ' + mode,
        this.$parent
      );
    }

    var rawChild = children[0];

    // if this is a component root node and the component's
    // parent container node also has transition, skip.
    if (hasParentTransition(this.$vnode)) {
      return rawChild
    }

    // apply transition data to child
    // use getRealChild() to ignore abstract components e.g. keep-alive
    var child = getRealChild(rawChild);
    /* istanbul ignore if */
    if (!child) {
      return rawChild
    }

    if (this._leaving) {
      return placeholder(h, rawChild)
    }

    // ensure a key that is unique to the vnode type and to this transition
    // component instance. This key will be used to remove pending leaving nodes
    // during entering.
    var id = "__transition-" + (this._uid) + "-";
    child.key = child.key == null
      ? child.isComment
        ? id + 'comment'
        : id + child.tag
      : isPrimitive(child.key)
        ? (String(child.key).indexOf(id) === 0 ? child.key : id + child.key)
        : child.key;

    var data = (child.data || (child.data = {})).transition = extractTransitionData(this);
    var oldRawChild = this._vnode;
    var oldChild = getRealChild(oldRawChild);

    // mark v-show
    // so that the transition module can hand over the control to the directive
    if (child.data.directives && child.data.directives.some(isVShowDirective)) {
      child.data.show = true;
    }

    if (
      oldChild &&
      oldChild.data &&
      !isSameChild(child, oldChild) &&
      !isAsyncPlaceholder(oldChild) &&
      // #6687 component root is a comment node
      !(oldChild.componentInstance && oldChild.componentInstance._vnode.isComment)
    ) {
      // replace old child transition data with fresh one
      // important for dynamic transitions!
      var oldData = oldChild.data.transition = extend({}, data);
      // handle transition mode
      if (mode === 'out-in') {
        // return placeholder node and queue update when leave finishes
        this._leaving = true;
        mergeVNodeHook(oldData, 'afterLeave', function () {
          this$1._leaving = false;
          this$1.$forceUpdate();
        });
        return placeholder(h, rawChild)
      } else if (mode === 'in-out') {
        if (isAsyncPlaceholder(child)) {
          return oldRawChild
        }
        var delayedLeave;
        var performLeave = function () { delayedLeave(); };
        mergeVNodeHook(data, 'afterEnter', performLeave);
        mergeVNodeHook(data, 'enterCancelled', performLeave);
        mergeVNodeHook(oldData, 'delayLeave', function (leave) { delayedLeave = leave; });
      }
    }

    return rawChild
  }
};

/*  */

var props = extend({
  tag: String,
  moveClass: String
}, transitionProps);

delete props.mode;

var TransitionGroup = {
  props: props,

  beforeMount: function beforeMount () {
    var this$1 = this;

    var update = this._update;
    this._update = function (vnode, hydrating) {
      var restoreActiveInstance = setActiveInstance(this$1);
      // force removing pass
      this$1.__patch__(
        this$1._vnode,
        this$1.kept,
        false, // hydrating
        true // removeOnly (!important, avoids unnecessary moves)
      );
      this$1._vnode = this$1.kept;
      restoreActiveInstance();
      update.call(this$1, vnode, hydrating);
    };
  },

  render: function render (h) {
    var tag = this.tag || this.$vnode.data.tag || 'span';
    var map = Object.create(null);
    var prevChildren = this.prevChildren = this.children;
    var rawChildren = this.$slots.default || [];
    var children = this.children = [];
    var transitionData = extractTransitionData(this);

    for (var i = 0; i < rawChildren.length; i++) {
      var c = rawChildren[i];
      if (c.tag) {
        if (c.key != null && String(c.key).indexOf('__vlist') !== 0) {
          children.push(c);
          map[c.key] = c
          ;(c.data || (c.data = {})).transition = transitionData;
        } else if (false) {
          var opts = c.componentOptions;
          var name = opts ? (opts.Ctor.options.name || opts.tag || '') : c.tag;
          warn(("<transition-group> children must be keyed: <" + name + ">"));
        }
      }
    }

    if (prevChildren) {
      var kept = [];
      var removed = [];
      for (var i$1 = 0; i$1 < prevChildren.length; i$1++) {
        var c$1 = prevChildren[i$1];
        c$1.data.transition = transitionData;
        c$1.data.pos = c$1.elm.getBoundingClientRect();
        if (map[c$1.key]) {
          kept.push(c$1);
        } else {
          removed.push(c$1);
        }
      }
      this.kept = h(tag, null, kept);
      this.removed = removed;
    }

    return h(tag, null, children)
  },

  updated: function updated () {
    var children = this.prevChildren;
    var moveClass = this.moveClass || ((this.name || 'v') + '-move');
    if (!children.length || !this.hasMove(children[0].elm, moveClass)) {
      return
    }

    // we divide the work into three loops to avoid mixing DOM reads and writes
    // in each iteration - which helps prevent layout thrashing.
    children.forEach(callPendingCbs);
    children.forEach(recordPosition);
    children.forEach(applyTranslation);

    // force reflow to put everything in position
    // assign to this to avoid being removed in tree-shaking
    // $flow-disable-line
    this._reflow = document.body.offsetHeight;

    children.forEach(function (c) {
      if (c.data.moved) {
        var el = c.elm;
        var s = el.style;
        addTransitionClass(el, moveClass);
        s.transform = s.WebkitTransform = s.transitionDuration = '';
        el.addEventListener(transitionEndEvent, el._moveCb = function cb (e) {
          if (e && e.target !== el) {
            return
          }
          if (!e || /transform$/.test(e.propertyName)) {
            el.removeEventListener(transitionEndEvent, cb);
            el._moveCb = null;
            removeTransitionClass(el, moveClass);
          }
        });
      }
    });
  },

  methods: {
    hasMove: function hasMove (el, moveClass) {
      /* istanbul ignore if */
      if (!hasTransition) {
        return false
      }
      /* istanbul ignore if */
      if (this._hasMove) {
        return this._hasMove
      }
      // Detect whether an element with the move class applied has
      // CSS transitions. Since the element may be inside an entering
      // transition at this very moment, we make a clone of it and remove
      // all other transition classes applied to ensure only the move class
      // is applied.
      var clone = el.cloneNode();
      if (el._transitionClasses) {
        el._transitionClasses.forEach(function (cls) { removeClass(clone, cls); });
      }
      addClass(clone, moveClass);
      clone.style.display = 'none';
      this.$el.appendChild(clone);
      var info = getTransitionInfo(clone);
      this.$el.removeChild(clone);
      return (this._hasMove = info.hasTransform)
    }
  }
};

function callPendingCbs (c) {
  /* istanbul ignore if */
  if (c.elm._moveCb) {
    c.elm._moveCb();
  }
  /* istanbul ignore if */
  if (c.elm._enterCb) {
    c.elm._enterCb();
  }
}

function recordPosition (c) {
  c.data.newPos = c.elm.getBoundingClientRect();
}

function applyTranslation (c) {
  var oldPos = c.data.pos;
  var newPos = c.data.newPos;
  var dx = oldPos.left - newPos.left;
  var dy = oldPos.top - newPos.top;
  if (dx || dy) {
    c.data.moved = true;
    var s = c.elm.style;
    s.transform = s.WebkitTransform = "translate(" + dx + "px," + dy + "px)";
    s.transitionDuration = '0s';
  }
}

var platformComponents = {
  Transition: Transition,
  TransitionGroup: TransitionGroup
};

/*  */

// install platform specific utils
Vue.config.mustUseProp = mustUseProp;
Vue.config.isReservedTag = isReservedTag;
Vue.config.isReservedAttr = isReservedAttr;
Vue.config.getTagNamespace = getTagNamespace;
Vue.config.isUnknownElement = isUnknownElement;

// install platform runtime directives & components
extend(Vue.options.directives, platformDirectives);
extend(Vue.options.components, platformComponents);

// install platform patch function
Vue.prototype.__patch__ = inBrowser ? patch : noop;

// public mount method
Vue.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && inBrowser ? query(el) : undefined;
  return mountComponent(this, el, hydrating)
};

// devtools global hook
/* istanbul ignore next */
if (inBrowser) {
  setTimeout(function () {
    if (config.devtools) {
      if (devtools) {
        devtools.emit('init', Vue);
      } else if (
        false
      ) {
        console[console.info ? 'info' : 'log'](
          'Download the Vue Devtools extension for a better development experience:\n' +
          'https://github.com/vuejs/vue-devtools'
        );
      }
    }
    if (false
    ) {
      console[console.info ? 'info' : 'log'](
        "You are running Vue in development mode.\n" +
        "Make sure to turn on production mode when deploying for production.\n" +
        "See more tips at https://vuejs.org/guide/deployment.html"
      );
    }
  }, 0);
}

/*  */

var defaultTagRE = /\{\{((?:.|\r?\n)+?)\}\}/g;
var regexEscapeRE = /[-.*+?^${}()|[\]\/\\]/g;

var buildRegex = cached(function (delimiters) {
  var open = delimiters[0].replace(regexEscapeRE, '\\$&');
  var close = delimiters[1].replace(regexEscapeRE, '\\$&');
  return new RegExp(open + '((?:.|\\n)+?)' + close, 'g')
});



function parseText (
  text,
  delimiters
) {
  var tagRE = delimiters ? buildRegex(delimiters) : defaultTagRE;
  if (!tagRE.test(text)) {
    return
  }
  var tokens = [];
  var rawTokens = [];
  var lastIndex = tagRE.lastIndex = 0;
  var match, index, tokenValue;
  while ((match = tagRE.exec(text))) {
    index = match.index;
    // push text token
    if (index > lastIndex) {
      rawTokens.push(tokenValue = text.slice(lastIndex, index));
      tokens.push(JSON.stringify(tokenValue));
    }
    // tag token
    var exp = parseFilters(match[1].trim());
    tokens.push(("_s(" + exp + ")"));
    rawTokens.push({ '@binding': exp });
    lastIndex = index + match[0].length;
  }
  if (lastIndex < text.length) {
    rawTokens.push(tokenValue = text.slice(lastIndex));
    tokens.push(JSON.stringify(tokenValue));
  }
  return {
    expression: tokens.join('+'),
    tokens: rawTokens
  }
}

/*  */

function transformNode (el, options) {
  var warn = options.warn || baseWarn;
  var staticClass = getAndRemoveAttr(el, 'class');
  if (false) {
    var res = parseText(staticClass, options.delimiters);
    if (res) {
      warn(
        "class=\"" + staticClass + "\": " +
        'Interpolation inside attributes has been removed. ' +
        'Use v-bind or the colon shorthand instead. For example, ' +
        'instead of <div class="{{ val }}">, use <div :class="val">.',
        el.rawAttrsMap['class']
      );
    }
  }
  if (staticClass) {
    el.staticClass = JSON.stringify(staticClass);
  }
  var classBinding = getBindingAttr(el, 'class', false /* getStatic */);
  if (classBinding) {
    el.classBinding = classBinding;
  }
}

function genData (el) {
  var data = '';
  if (el.staticClass) {
    data += "staticClass:" + (el.staticClass) + ",";
  }
  if (el.classBinding) {
    data += "class:" + (el.classBinding) + ",";
  }
  return data
}

var klass$1 = {
  staticKeys: ['staticClass'],
  transformNode: transformNode,
  genData: genData
};

/*  */

function transformNode$1 (el, options) {
  var warn = options.warn || baseWarn;
  var staticStyle = getAndRemoveAttr(el, 'style');
  if (staticStyle) {
    /* istanbul ignore if */
    if (false) {
      var res = parseText(staticStyle, options.delimiters);
      if (res) {
        warn(
          "style=\"" + staticStyle + "\": " +
          'Interpolation inside attributes has been removed. ' +
          'Use v-bind or the colon shorthand instead. For example, ' +
          'instead of <div style="{{ val }}">, use <div :style="val">.',
          el.rawAttrsMap['style']
        );
      }
    }
    el.staticStyle = JSON.stringify(parseStyleText(staticStyle));
  }

  var styleBinding = getBindingAttr(el, 'style', false /* getStatic */);
  if (styleBinding) {
    el.styleBinding = styleBinding;
  }
}

function genData$1 (el) {
  var data = '';
  if (el.staticStyle) {
    data += "staticStyle:" + (el.staticStyle) + ",";
  }
  if (el.styleBinding) {
    data += "style:(" + (el.styleBinding) + "),";
  }
  return data
}

var style$1 = {
  staticKeys: ['staticStyle'],
  transformNode: transformNode$1,
  genData: genData$1
};

/*  */

var decoder;

var he = {
  decode: function decode (html) {
    decoder = decoder || document.createElement('div');
    decoder.innerHTML = html;
    return decoder.textContent
  }
};

/*  */

var isUnaryTag = makeMap(
  'area,base,br,col,embed,frame,hr,img,input,isindex,keygen,' +
  'link,meta,param,source,track,wbr'
);

// Elements that you can, intentionally, leave open
// (and which close themselves)
var canBeLeftOpenTag = makeMap(
  'colgroup,dd,dt,li,options,p,td,tfoot,th,thead,tr,source'
);

// HTML5 tags https://html.spec.whatwg.org/multipage/indices.html#elements-3
// Phrasing Content https://html.spec.whatwg.org/multipage/dom.html#phrasing-content
var isNonPhrasingTag = makeMap(
  'address,article,aside,base,blockquote,body,caption,col,colgroup,dd,' +
  'details,dialog,div,dl,dt,fieldset,figcaption,figure,footer,form,' +
  'h1,h2,h3,h4,h5,h6,head,header,hgroup,hr,html,legend,li,menuitem,meta,' +
  'optgroup,option,param,rp,rt,source,style,summary,tbody,td,tfoot,th,thead,' +
  'title,tr,track'
);

/**
 * Not type-checking this file because it's mostly vendor code.
 */

// Regular Expressions for parsing tags and attributes
var attribute = /^\s*([^\s"'<>\/=]+)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
var dynamicArgAttribute = /^\s*((?:v-[\w-]+:|@|:|#)\[[^=]+\][^\s"'<>\/=]*)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
var ncname = "[a-zA-Z_][\\-\\.0-9_a-zA-Z" + (unicodeRegExp.source) + "]*";
var qnameCapture = "((?:" + ncname + "\\:)?" + ncname + ")";
var startTagOpen = new RegExp(("^<" + qnameCapture));
var startTagClose = /^\s*(\/?)>/;
var endTag = new RegExp(("^<\\/" + qnameCapture + "[^>]*>"));
var doctype = /^<!DOCTYPE [^>]+>/i;
// #7298: escape - to avoid being passed as HTML comment when inlined in page
var comment = /^<!\--/;
var conditionalComment = /^<!\[/;

// Special Elements (can contain anything)
var isPlainTextElement = makeMap('script,style,textarea', true);
var reCache = {};

var decodingMap = {
  '&lt;': '<',
  '&gt;': '>',
  '&quot;': '"',
  '&amp;': '&',
  '&#10;': '\n',
  '&#9;': '\t',
  '&#39;': "'"
};
var encodedAttr = /&(?:lt|gt|quot|amp|#39);/g;
var encodedAttrWithNewLines = /&(?:lt|gt|quot|amp|#39|#10|#9);/g;

// #5992
var isIgnoreNewlineTag = makeMap('pre,textarea', true);
var shouldIgnoreFirstNewline = function (tag, html) { return tag && isIgnoreNewlineTag(tag) && html[0] === '\n'; };

function decodeAttr (value, shouldDecodeNewlines) {
  var re = shouldDecodeNewlines ? encodedAttrWithNewLines : encodedAttr;
  return value.replace(re, function (match) { return decodingMap[match]; })
}

function parseHTML (html, options) {
  var stack = [];
  var expectHTML = options.expectHTML;
  var isUnaryTag$$1 = options.isUnaryTag || no;
  var canBeLeftOpenTag$$1 = options.canBeLeftOpenTag || no;
  var index = 0;
  var last, lastTag;
  while (html) {
    last = html;
    // Make sure we're not in a plaintext content element like script/style
    if (!lastTag || !isPlainTextElement(lastTag)) {
      var textEnd = html.indexOf('<');
      if (textEnd === 0) {
        // Comment:
        if (comment.test(html)) {
          var commentEnd = html.indexOf('-->');

          if (commentEnd >= 0) {
            if (options.shouldKeepComment) {
              options.comment(html.substring(4, commentEnd), index, index + commentEnd + 3);
            }
            advance(commentEnd + 3);
            continue
          }
        }

        // http://en.wikipedia.org/wiki/Conditional_comment#Downlevel-revealed_conditional_comment
        if (conditionalComment.test(html)) {
          var conditionalEnd = html.indexOf(']>');

          if (conditionalEnd >= 0) {
            advance(conditionalEnd + 2);
            continue
          }
        }

        // Doctype:
        var doctypeMatch = html.match(doctype);
        if (doctypeMatch) {
          advance(doctypeMatch[0].length);
          continue
        }

        // End tag:
        var endTagMatch = html.match(endTag);
        if (endTagMatch) {
          var curIndex = index;
          advance(endTagMatch[0].length);
          parseEndTag(endTagMatch[1], curIndex, index);
          continue
        }

        // Start tag:
        var startTagMatch = parseStartTag();
        if (startTagMatch) {
          handleStartTag(startTagMatch);
          if (shouldIgnoreFirstNewline(startTagMatch.tagName, html)) {
            advance(1);
          }
          continue
        }
      }

      var text = (void 0), rest = (void 0), next = (void 0);
      if (textEnd >= 0) {
        rest = html.slice(textEnd);
        while (
          !endTag.test(rest) &&
          !startTagOpen.test(rest) &&
          !comment.test(rest) &&
          !conditionalComment.test(rest)
        ) {
          // < in plain text, be forgiving and treat it as text
          next = rest.indexOf('<', 1);
          if (next < 0) { break }
          textEnd += next;
          rest = html.slice(textEnd);
        }
        text = html.substring(0, textEnd);
      }

      if (textEnd < 0) {
        text = html;
      }

      if (text) {
        advance(text.length);
      }

      if (options.chars && text) {
        options.chars(text, index - text.length, index);
      }
    } else {
      var endTagLength = 0;
      var stackedTag = lastTag.toLowerCase();
      var reStackedTag = reCache[stackedTag] || (reCache[stackedTag] = new RegExp('([\\s\\S]*?)(</' + stackedTag + '[^>]*>)', 'i'));
      var rest$1 = html.replace(reStackedTag, function (all, text, endTag) {
        endTagLength = endTag.length;
        if (!isPlainTextElement(stackedTag) && stackedTag !== 'noscript') {
          text = text
            .replace(/<!\--([\s\S]*?)-->/g, '$1') // #7298
            .replace(/<!\[CDATA\[([\s\S]*?)]]>/g, '$1');
        }
        if (shouldIgnoreFirstNewline(stackedTag, text)) {
          text = text.slice(1);
        }
        if (options.chars) {
          options.chars(text);
        }
        return ''
      });
      index += html.length - rest$1.length;
      html = rest$1;
      parseEndTag(stackedTag, index - endTagLength, index);
    }

    if (html === last) {
      options.chars && options.chars(html);
      if (false) {
        options.warn(("Mal-formatted tag at end of template: \"" + html + "\""), { start: index + html.length });
      }
      break
    }
  }

  // Clean up any remaining tags
  parseEndTag();

  function advance (n) {
    index += n;
    html = html.substring(n);
  }

  function parseStartTag () {
    var start = html.match(startTagOpen);
    if (start) {
      var match = {
        tagName: start[1],
        attrs: [],
        start: index
      };
      advance(start[0].length);
      var end, attr;
      while (!(end = html.match(startTagClose)) && (attr = html.match(dynamicArgAttribute) || html.match(attribute))) {
        attr.start = index;
        advance(attr[0].length);
        attr.end = index;
        match.attrs.push(attr);
      }
      if (end) {
        match.unarySlash = end[1];
        advance(end[0].length);
        match.end = index;
        return match
      }
    }
  }

  function handleStartTag (match) {
    var tagName = match.tagName;
    var unarySlash = match.unarySlash;

    if (expectHTML) {
      if (lastTag === 'p' && isNonPhrasingTag(tagName)) {
        parseEndTag(lastTag);
      }
      if (canBeLeftOpenTag$$1(tagName) && lastTag === tagName) {
        parseEndTag(tagName);
      }
    }

    var unary = isUnaryTag$$1(tagName) || !!unarySlash;

    var l = match.attrs.length;
    var attrs = new Array(l);
    for (var i = 0; i < l; i++) {
      var args = match.attrs[i];
      var value = args[3] || args[4] || args[5] || '';
      var shouldDecodeNewlines = tagName === 'a' && args[1] === 'href'
        ? options.shouldDecodeNewlinesForHref
        : options.shouldDecodeNewlines;
      attrs[i] = {
        name: args[1],
        value: decodeAttr(value, shouldDecodeNewlines)
      };
      if (false) {
        attrs[i].start = args.start + args[0].match(/^\s*/).length;
        attrs[i].end = args.end;
      }
    }

    if (!unary) {
      stack.push({ tag: tagName, lowerCasedTag: tagName.toLowerCase(), attrs: attrs, start: match.start, end: match.end });
      lastTag = tagName;
    }

    if (options.start) {
      options.start(tagName, attrs, unary, match.start, match.end);
    }
  }

  function parseEndTag (tagName, start, end) {
    var pos, lowerCasedTagName;
    if (start == null) { start = index; }
    if (end == null) { end = index; }

    // Find the closest opened tag of the same type
    if (tagName) {
      lowerCasedTagName = tagName.toLowerCase();
      for (pos = stack.length - 1; pos >= 0; pos--) {
        if (stack[pos].lowerCasedTag === lowerCasedTagName) {
          break
        }
      }
    } else {
      // If no tag name is provided, clean shop
      pos = 0;
    }

    if (pos >= 0) {
      // Close all the open elements, up the stack
      for (var i = stack.length - 1; i >= pos; i--) {
        if (false
        ) {
          options.warn(
            ("tag <" + (stack[i].tag) + "> has no matching end tag."),
            { start: stack[i].start, end: stack[i].end }
          );
        }
        if (options.end) {
          options.end(stack[i].tag, start, end);
        }
      }

      // Remove the open elements from the stack
      stack.length = pos;
      lastTag = pos && stack[pos - 1].tag;
    } else if (lowerCasedTagName === 'br') {
      if (options.start) {
        options.start(tagName, [], true, start, end);
      }
    } else if (lowerCasedTagName === 'p') {
      if (options.start) {
        options.start(tagName, [], false, start, end);
      }
      if (options.end) {
        options.end(tagName, start, end);
      }
    }
  }
}

/*  */

var onRE = /^@|^v-on:/;
var dirRE = /^v-|^@|^:|^#/;
var forAliasRE = /([\s\S]*?)\s+(?:in|of)\s+([\s\S]*)/;
var forIteratorRE = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/;
var stripParensRE = /^\(|\)$/g;
var dynamicArgRE = /^\[.*\]$/;

var argRE = /:(.*)$/;
var bindRE = /^:|^\.|^v-bind:/;
var modifierRE = /\.[^.\]]+(?=[^\]]*$)/g;

var slotRE = /^v-slot(:|$)|^#/;

var lineBreakRE = /[\r\n]/;
var whitespaceRE$1 = /\s+/g;

var invalidAttributeRE = /[\s"'<>\/=]/;

var decodeHTMLCached = cached(he.decode);

var emptySlotScopeToken = "_empty_";

// configurable state
var warn$2;
var delimiters;
var transforms;
var preTransforms;
var postTransforms;
var platformIsPreTag;
var platformMustUseProp;
var platformGetTagNamespace;
var maybeComponent;

function createASTElement (
  tag,
  attrs,
  parent
) {
  return {
    type: 1,
    tag: tag,
    attrsList: attrs,
    attrsMap: makeAttrsMap(attrs),
    rawAttrsMap: {},
    parent: parent,
    children: []
  }
}

/**
 * Convert HTML string to AST.
 */
function parse (
  template,
  options
) {
  warn$2 = options.warn || baseWarn;

  platformIsPreTag = options.isPreTag || no;
  platformMustUseProp = options.mustUseProp || no;
  platformGetTagNamespace = options.getTagNamespace || no;
  var isReservedTag = options.isReservedTag || no;
  maybeComponent = function (el) { return !!el.component || !isReservedTag(el.tag); };

  transforms = pluckModuleFunction(options.modules, 'transformNode');
  preTransforms = pluckModuleFunction(options.modules, 'preTransformNode');
  postTransforms = pluckModuleFunction(options.modules, 'postTransformNode');

  delimiters = options.delimiters;

  var stack = [];
  var preserveWhitespace = options.preserveWhitespace !== false;
  var whitespaceOption = options.whitespace;
  var root;
  var currentParent;
  var inVPre = false;
  var inPre = false;
  var warned = false;

  function warnOnce (msg, range) {
    if (!warned) {
      warned = true;
      warn$2(msg, range);
    }
  }

  function closeElement (element) {
    trimEndingWhitespace(element);
    if (!inVPre && !element.processed) {
      element = processElement(element, options);
    }
    // tree management
    if (!stack.length && element !== root) {
      // allow root elements with v-if, v-else-if and v-else
      if (root.if && (element.elseif || element.else)) {
        if (false) {
          checkRootConstraints(element);
        }
        addIfCondition(root, {
          exp: element.elseif,
          block: element
        });
      } else if (false) {
        warnOnce(
          "Component template should contain exactly one root element. " +
          "If you are using v-if on multiple elements, " +
          "use v-else-if to chain them instead.",
          { start: element.start }
        );
      }
    }
    if (currentParent && !element.forbidden) {
      if (element.elseif || element.else) {
        processIfConditions(element, currentParent);
      } else {
        if (element.slotScope) {
          // scoped slot
          // keep it in the children list so that v-else(-if) conditions can
          // find it as the prev node.
          var name = element.slotTarget || '"default"'
          ;(currentParent.scopedSlots || (currentParent.scopedSlots = {}))[name] = element;
        }
        currentParent.children.push(element);
        element.parent = currentParent;
      }
    }

    // final children cleanup
    // filter out scoped slots
    element.children = element.children.filter(function (c) { return !(c).slotScope; });
    // remove trailing whitespace node again
    trimEndingWhitespace(element);

    // check pre state
    if (element.pre) {
      inVPre = false;
    }
    if (platformIsPreTag(element.tag)) {
      inPre = false;
    }
    // apply post-transforms
    for (var i = 0; i < postTransforms.length; i++) {
      postTransforms[i](element, options);
    }
  }

  function trimEndingWhitespace (el) {
    // remove trailing whitespace node
    if (!inPre) {
      var lastNode;
      while (
        (lastNode = el.children[el.children.length - 1]) &&
        lastNode.type === 3 &&
        lastNode.text === ' '
      ) {
        el.children.pop();
      }
    }
  }

  function checkRootConstraints (el) {
    if (el.tag === 'slot' || el.tag === 'template') {
      warnOnce(
        "Cannot use <" + (el.tag) + "> as component root element because it may " +
        'contain multiple nodes.',
        { start: el.start }
      );
    }
    if (el.attrsMap.hasOwnProperty('v-for')) {
      warnOnce(
        'Cannot use v-for on stateful component root element because ' +
        'it renders multiple elements.',
        el.rawAttrsMap['v-for']
      );
    }
  }

  parseHTML(template, {
    warn: warn$2,
    expectHTML: options.expectHTML,
    isUnaryTag: options.isUnaryTag,
    canBeLeftOpenTag: options.canBeLeftOpenTag,
    shouldDecodeNewlines: options.shouldDecodeNewlines,
    shouldDecodeNewlinesForHref: options.shouldDecodeNewlinesForHref,
    shouldKeepComment: options.comments,
    outputSourceRange: options.outputSourceRange,
    start: function start (tag, attrs, unary, start$1, end) {
      // check namespace.
      // inherit parent ns if there is one
      var ns = (currentParent && currentParent.ns) || platformGetTagNamespace(tag);

      // handle IE svg bug
      /* istanbul ignore if */
      if (isIE && ns === 'svg') {
        attrs = guardIESVGBug(attrs);
      }

      var element = createASTElement(tag, attrs, currentParent);
      if (ns) {
        element.ns = ns;
      }

      if (false) {
        if (options.outputSourceRange) {
          element.start = start$1;
          element.end = end;
          element.rawAttrsMap = element.attrsList.reduce(function (cumulated, attr) {
            cumulated[attr.name] = attr;
            return cumulated
          }, {});
        }
        attrs.forEach(function (attr) {
          if (invalidAttributeRE.test(attr.name)) {
            warn$2(
              "Invalid dynamic argument expression: attribute names cannot contain " +
              "spaces, quotes, <, >, / or =.",
              {
                start: attr.start + attr.name.indexOf("["),
                end: attr.start + attr.name.length
              }
            );
          }
        });
      }

      if (isForbiddenTag(element) && !isServerRendering()) {
        element.forbidden = true;
        "production" !== 'production' && warn$2(
          'Templates should only be responsible for mapping the state to the ' +
          'UI. Avoid placing tags with side-effects in your templates, such as ' +
          "<" + tag + ">" + ', as they will not be parsed.',
          { start: element.start }
        );
      }

      // apply pre-transforms
      for (var i = 0; i < preTransforms.length; i++) {
        element = preTransforms[i](element, options) || element;
      }

      if (!inVPre) {
        processPre(element);
        if (element.pre) {
          inVPre = true;
        }
      }
      if (platformIsPreTag(element.tag)) {
        inPre = true;
      }
      if (inVPre) {
        processRawAttrs(element);
      } else if (!element.processed) {
        // structural directives
        processFor(element);
        processIf(element);
        processOnce(element);
      }

      if (!root) {
        root = element;
        if (false) {
          checkRootConstraints(root);
        }
      }

      if (!unary) {
        currentParent = element;
        stack.push(element);
      } else {
        closeElement(element);
      }
    },

    end: function end (tag, start, end$1) {
      var element = stack[stack.length - 1];
      // pop stack
      stack.length -= 1;
      currentParent = stack[stack.length - 1];
      if (false) {
        element.end = end$1;
      }
      closeElement(element);
    },

    chars: function chars (text, start, end) {
      if (!currentParent) {
        if (false) {
          if (text === template) {
            warnOnce(
              'Component template requires a root element, rather than just text.',
              { start: start }
            );
          } else if ((text = text.trim())) {
            warnOnce(
              ("text \"" + text + "\" outside root element will be ignored."),
              { start: start }
            );
          }
        }
        return
      }
      // IE textarea placeholder bug
      /* istanbul ignore if */
      if (isIE &&
        currentParent.tag === 'textarea' &&
        currentParent.attrsMap.placeholder === text
      ) {
        return
      }
      var children = currentParent.children;
      if (inPre || text.trim()) {
        text = isTextTag(currentParent) ? text : decodeHTMLCached(text);
      } else if (!children.length) {
        // remove the whitespace-only node right after an opening tag
        text = '';
      } else if (whitespaceOption) {
        if (whitespaceOption === 'condense') {
          // in condense mode, remove the whitespace node if it contains
          // line break, otherwise condense to a single space
          text = lineBreakRE.test(text) ? '' : ' ';
        } else {
          text = ' ';
        }
      } else {
        text = preserveWhitespace ? ' ' : '';
      }
      if (text) {
        if (!inPre && whitespaceOption === 'condense') {
          // condense consecutive whitespaces into single space
          text = text.replace(whitespaceRE$1, ' ');
        }
        var res;
        var child;
        if (!inVPre && text !== ' ' && (res = parseText(text, delimiters))) {
          child = {
            type: 2,
            expression: res.expression,
            tokens: res.tokens,
            text: text
          };
        } else if (text !== ' ' || !children.length || children[children.length - 1].text !== ' ') {
          child = {
            type: 3,
            text: text
          };
        }
        if (child) {
          if (false) {
            child.start = start;
            child.end = end;
          }
          children.push(child);
        }
      }
    },
    comment: function comment (text, start, end) {
      // adding anything as a sibling to the root node is forbidden
      // comments should still be allowed, but ignored
      if (currentParent) {
        var child = {
          type: 3,
          text: text,
          isComment: true
        };
        if (false) {
          child.start = start;
          child.end = end;
        }
        currentParent.children.push(child);
      }
    }
  });
  return root
}

function processPre (el) {
  if (getAndRemoveAttr(el, 'v-pre') != null) {
    el.pre = true;
  }
}

function processRawAttrs (el) {
  var list = el.attrsList;
  var len = list.length;
  if (len) {
    var attrs = el.attrs = new Array(len);
    for (var i = 0; i < len; i++) {
      attrs[i] = {
        name: list[i].name,
        value: JSON.stringify(list[i].value)
      };
      if (list[i].start != null) {
        attrs[i].start = list[i].start;
        attrs[i].end = list[i].end;
      }
    }
  } else if (!el.pre) {
    // non root node in pre blocks with no attributes
    el.plain = true;
  }
}

function processElement (
  element,
  options
) {
  processKey(element);

  // determine whether this is a plain element after
  // removing structural attributes
  element.plain = (
    !element.key &&
    !element.scopedSlots &&
    !element.attrsList.length
  );

  processRef(element);
  processSlotContent(element);
  processSlotOutlet(element);
  processComponent(element);
  for (var i = 0; i < transforms.length; i++) {
    element = transforms[i](element, options) || element;
  }
  processAttrs(element);
  return element
}

function processKey (el) {
  var exp = getBindingAttr(el, 'key');
  if (exp) {
    if (false) {
      if (el.tag === 'template') {
        warn$2(
          "<template> cannot be keyed. Place the key on real elements instead.",
          getRawBindingAttr(el, 'key')
        );
      }
      if (el.for) {
        var iterator = el.iterator2 || el.iterator1;
        var parent = el.parent;
        if (iterator && iterator === exp && parent && parent.tag === 'transition-group') {
          warn$2(
            "Do not use v-for index as key on <transition-group> children, " +
            "this is the same as not using keys.",
            getRawBindingAttr(el, 'key'),
            true /* tip */
          );
        }
      }
    }
    el.key = exp;
  }
}

function processRef (el) {
  var ref = getBindingAttr(el, 'ref');
  if (ref) {
    el.ref = ref;
    el.refInFor = checkInFor(el);
  }
}

function processFor (el) {
  var exp;
  if ((exp = getAndRemoveAttr(el, 'v-for'))) {
    var res = parseFor(exp);
    if (res) {
      extend(el, res);
    } else if (false) {
      warn$2(
        ("Invalid v-for expression: " + exp),
        el.rawAttrsMap['v-for']
      );
    }
  }
}



function parseFor (exp) {
  var inMatch = exp.match(forAliasRE);
  if (!inMatch) { return }
  var res = {};
  res.for = inMatch[2].trim();
  var alias = inMatch[1].trim().replace(stripParensRE, '');
  var iteratorMatch = alias.match(forIteratorRE);
  if (iteratorMatch) {
    res.alias = alias.replace(forIteratorRE, '').trim();
    res.iterator1 = iteratorMatch[1].trim();
    if (iteratorMatch[2]) {
      res.iterator2 = iteratorMatch[2].trim();
    }
  } else {
    res.alias = alias;
  }
  return res
}

function processIf (el) {
  var exp = getAndRemoveAttr(el, 'v-if');
  if (exp) {
    el.if = exp;
    addIfCondition(el, {
      exp: exp,
      block: el
    });
  } else {
    if (getAndRemoveAttr(el, 'v-else') != null) {
      el.else = true;
    }
    var elseif = getAndRemoveAttr(el, 'v-else-if');
    if (elseif) {
      el.elseif = elseif;
    }
  }
}

function processIfConditions (el, parent) {
  var prev = findPrevElement(parent.children);
  if (prev && prev.if) {
    addIfCondition(prev, {
      exp: el.elseif,
      block: el
    });
  } else if (false) {
    warn$2(
      "v-" + (el.elseif ? ('else-if="' + el.elseif + '"') : 'else') + " " +
      "used on element <" + (el.tag) + "> without corresponding v-if.",
      el.rawAttrsMap[el.elseif ? 'v-else-if' : 'v-else']
    );
  }
}

function findPrevElement (children) {
  var i = children.length;
  while (i--) {
    if (children[i].type === 1) {
      return children[i]
    } else {
      if (false) {
        warn$2(
          "text \"" + (children[i].text.trim()) + "\" between v-if and v-else(-if) " +
          "will be ignored.",
          children[i]
        );
      }
      children.pop();
    }
  }
}

function addIfCondition (el, condition) {
  if (!el.ifConditions) {
    el.ifConditions = [];
  }
  el.ifConditions.push(condition);
}

function processOnce (el) {
  var once$$1 = getAndRemoveAttr(el, 'v-once');
  if (once$$1 != null) {
    el.once = true;
  }
}

// handle content being passed to a component as slot,
// e.g. <template slot="xxx">, <div slot-scope="xxx">
function processSlotContent (el) {
  var slotScope;
  if (el.tag === 'template') {
    slotScope = getAndRemoveAttr(el, 'scope');
    /* istanbul ignore if */
    if (false) {
      warn$2(
        "the \"scope\" attribute for scoped slots have been deprecated and " +
        "replaced by \"slot-scope\" since 2.5. The new \"slot-scope\" attribute " +
        "can also be used on plain elements in addition to <template> to " +
        "denote scoped slots.",
        el.rawAttrsMap['scope'],
        true
      );
    }
    el.slotScope = slotScope || getAndRemoveAttr(el, 'slot-scope');
  } else if ((slotScope = getAndRemoveAttr(el, 'slot-scope'))) {
    /* istanbul ignore if */
    if (false) {
      warn$2(
        "Ambiguous combined usage of slot-scope and v-for on <" + (el.tag) + "> " +
        "(v-for takes higher priority). Use a wrapper <template> for the " +
        "scoped slot to make it clearer.",
        el.rawAttrsMap['slot-scope'],
        true
      );
    }
    el.slotScope = slotScope;
  }

  // slot="xxx"
  var slotTarget = getBindingAttr(el, 'slot');
  if (slotTarget) {
    el.slotTarget = slotTarget === '""' ? '"default"' : slotTarget;
    el.slotTargetDynamic = !!(el.attrsMap[':slot'] || el.attrsMap['v-bind:slot']);
    // preserve slot as an attribute for native shadow DOM compat
    // only for non-scoped slots.
    if (el.tag !== 'template' && !el.slotScope) {
      addAttr(el, 'slot', slotTarget, getRawBindingAttr(el, 'slot'));
    }
  }

  // 2.6 v-slot syntax
  {
    if (el.tag === 'template') {
      // v-slot on <template>
      var slotBinding = getAndRemoveAttrByRegex(el, slotRE);
      if (slotBinding) {
        if (false) {
          if (el.slotTarget || el.slotScope) {
            warn$2(
              "Unexpected mixed usage of different slot syntaxes.",
              el
            );
          }
          if (el.parent && !maybeComponent(el.parent)) {
            warn$2(
              "<template v-slot> can only appear at the root level inside " +
              "the receiving component",
              el
            );
          }
        }
        var ref = getSlotName(slotBinding);
        var name = ref.name;
        var dynamic = ref.dynamic;
        el.slotTarget = name;
        el.slotTargetDynamic = dynamic;
        el.slotScope = slotBinding.value || emptySlotScopeToken; // force it into a scoped slot for perf
      }
    } else {
      // v-slot on component, denotes default slot
      var slotBinding$1 = getAndRemoveAttrByRegex(el, slotRE);
      if (slotBinding$1) {
        if (false) {
          if (!maybeComponent(el)) {
            warn$2(
              "v-slot can only be used on components or <template>.",
              slotBinding$1
            );
          }
          if (el.slotScope || el.slotTarget) {
            warn$2(
              "Unexpected mixed usage of different slot syntaxes.",
              el
            );
          }
          if (el.scopedSlots) {
            warn$2(
              "To avoid scope ambiguity, the default slot should also use " +
              "<template> syntax when there are other named slots.",
              slotBinding$1
            );
          }
        }
        // add the component's children to its default slot
        var slots = el.scopedSlots || (el.scopedSlots = {});
        var ref$1 = getSlotName(slotBinding$1);
        var name$1 = ref$1.name;
        var dynamic$1 = ref$1.dynamic;
        var slotContainer = slots[name$1] = createASTElement('template', [], el);
        slotContainer.slotTarget = name$1;
        slotContainer.slotTargetDynamic = dynamic$1;
        slotContainer.children = el.children.filter(function (c) {
          if (!c.slotScope) {
            c.parent = slotContainer;
            return true
          }
        });
        slotContainer.slotScope = slotBinding$1.value || emptySlotScopeToken;
        // remove children as they are returned from scopedSlots now
        el.children = [];
        // mark el non-plain so data gets generated
        el.plain = false;
      }
    }
  }
}

function getSlotName (binding) {
  var name = binding.name.replace(slotRE, '');
  if (!name) {
    if (binding.name[0] !== '#') {
      name = 'default';
    } else if (false) {
      warn$2(
        "v-slot shorthand syntax requires a slot name.",
        binding
      );
    }
  }
  return dynamicArgRE.test(name)
    // dynamic [name]
    ? { name: name.slice(1, -1), dynamic: true }
    // static name
    : { name: ("\"" + name + "\""), dynamic: false }
}

// handle <slot/> outlets
function processSlotOutlet (el) {
  if (el.tag === 'slot') {
    el.slotName = getBindingAttr(el, 'name');
    if (false) {
      warn$2(
        "`key` does not work on <slot> because slots are abstract outlets " +
        "and can possibly expand into multiple elements. " +
        "Use the key on a wrapping element instead.",
        getRawBindingAttr(el, 'key')
      );
    }
  }
}

function processComponent (el) {
  var binding;
  if ((binding = getBindingAttr(el, 'is'))) {
    el.component = binding;
  }
  if (getAndRemoveAttr(el, 'inline-template') != null) {
    el.inlineTemplate = true;
  }
}

function processAttrs (el) {
  var list = el.attrsList;
  var i, l, name, rawName, value, modifiers, syncGen, isDynamic;
  for (i = 0, l = list.length; i < l; i++) {
    name = rawName = list[i].name;
    value = list[i].value;
    if (dirRE.test(name)) {
      // mark element as dynamic
      el.hasBindings = true;
      // modifiers
      modifiers = parseModifiers(name.replace(dirRE, ''));
      // support .foo shorthand syntax for the .prop modifier
      if (modifiers) {
        name = name.replace(modifierRE, '');
      }
      if (bindRE.test(name)) { // v-bind
        name = name.replace(bindRE, '');
        value = parseFilters(value);
        isDynamic = dynamicArgRE.test(name);
        if (isDynamic) {
          name = name.slice(1, -1);
        }
        if (
          false
        ) {
          warn$2(
            ("The value for a v-bind expression cannot be empty. Found in \"v-bind:" + name + "\"")
          );
        }
        if (modifiers) {
          if (modifiers.prop && !isDynamic) {
            name = camelize(name);
            if (name === 'innerHtml') { name = 'innerHTML'; }
          }
          if (modifiers.camel && !isDynamic) {
            name = camelize(name);
          }
          if (modifiers.sync) {
            syncGen = genAssignmentCode(value, "$event");
            if (!isDynamic) {
              addHandler(
                el,
                ("update:" + (camelize(name))),
                syncGen,
                null,
                false,
                warn$2,
                list[i]
              );
              if (hyphenate(name) !== camelize(name)) {
                addHandler(
                  el,
                  ("update:" + (hyphenate(name))),
                  syncGen,
                  null,
                  false,
                  warn$2,
                  list[i]
                );
              }
            } else {
              // handler w/ dynamic event name
              addHandler(
                el,
                ("\"update:\"+(" + name + ")"),
                syncGen,
                null,
                false,
                warn$2,
                list[i],
                true // dynamic
              );
            }
          }
        }
        if ((modifiers && modifiers.prop) || (
          !el.component && platformMustUseProp(el.tag, el.attrsMap.type, name)
        )) {
          addProp(el, name, value, list[i], isDynamic);
        } else {
          addAttr(el, name, value, list[i], isDynamic);
        }
      } else if (onRE.test(name)) { // v-on
        name = name.replace(onRE, '');
        isDynamic = dynamicArgRE.test(name);
        if (isDynamic) {
          name = name.slice(1, -1);
        }
        addHandler(el, name, value, modifiers, false, warn$2, list[i], isDynamic);
      } else { // normal directives
        name = name.replace(dirRE, '');
        // parse arg
        var argMatch = name.match(argRE);
        var arg = argMatch && argMatch[1];
        isDynamic = false;
        if (arg) {
          name = name.slice(0, -(arg.length + 1));
          if (dynamicArgRE.test(arg)) {
            arg = arg.slice(1, -1);
            isDynamic = true;
          }
        }
        addDirective(el, name, rawName, value, arg, isDynamic, modifiers, list[i]);
        if (false) {
          checkForAliasModel(el, value);
        }
      }
    } else {
      // literal attribute
      if (false) {
        var res = parseText(value, delimiters);
        if (res) {
          warn$2(
            name + "=\"" + value + "\": " +
            'Interpolation inside attributes has been removed. ' +
            'Use v-bind or the colon shorthand instead. For example, ' +
            'instead of <div id="{{ val }}">, use <div :id="val">.',
            list[i]
          );
        }
      }
      addAttr(el, name, JSON.stringify(value), list[i]);
      // #6887 firefox doesn't update muted state if set via attribute
      // even immediately after element creation
      if (!el.component &&
          name === 'muted' &&
          platformMustUseProp(el.tag, el.attrsMap.type, name)) {
        addProp(el, name, 'true', list[i]);
      }
    }
  }
}

function checkInFor (el) {
  var parent = el;
  while (parent) {
    if (parent.for !== undefined) {
      return true
    }
    parent = parent.parent;
  }
  return false
}

function parseModifiers (name) {
  var match = name.match(modifierRE);
  if (match) {
    var ret = {};
    match.forEach(function (m) { ret[m.slice(1)] = true; });
    return ret
  }
}

function makeAttrsMap (attrs) {
  var map = {};
  for (var i = 0, l = attrs.length; i < l; i++) {
    if (
      false
    ) {
      warn$2('duplicate attribute: ' + attrs[i].name, attrs[i]);
    }
    map[attrs[i].name] = attrs[i].value;
  }
  return map
}

// for script (e.g. type="x/template") or style, do not decode content
function isTextTag (el) {
  return el.tag === 'script' || el.tag === 'style'
}

function isForbiddenTag (el) {
  return (
    el.tag === 'style' ||
    (el.tag === 'script' && (
      !el.attrsMap.type ||
      el.attrsMap.type === 'text/javascript'
    ))
  )
}

var ieNSBug = /^xmlns:NS\d+/;
var ieNSPrefix = /^NS\d+:/;

/* istanbul ignore next */
function guardIESVGBug (attrs) {
  var res = [];
  for (var i = 0; i < attrs.length; i++) {
    var attr = attrs[i];
    if (!ieNSBug.test(attr.name)) {
      attr.name = attr.name.replace(ieNSPrefix, '');
      res.push(attr);
    }
  }
  return res
}

function checkForAliasModel (el, value) {
  var _el = el;
  while (_el) {
    if (_el.for && _el.alias === value) {
      warn$2(
        "<" + (el.tag) + " v-model=\"" + value + "\">: " +
        "You are binding v-model directly to a v-for iteration alias. " +
        "This will not be able to modify the v-for source array because " +
        "writing to the alias is like modifying a function local variable. " +
        "Consider using an array of objects and use v-model on an object property instead.",
        el.rawAttrsMap['v-model']
      );
    }
    _el = _el.parent;
  }
}

/*  */

function preTransformNode (el, options) {
  if (el.tag === 'input') {
    var map = el.attrsMap;
    if (!map['v-model']) {
      return
    }

    var typeBinding;
    if (map[':type'] || map['v-bind:type']) {
      typeBinding = getBindingAttr(el, 'type');
    }
    if (!map.type && !typeBinding && map['v-bind']) {
      typeBinding = "(" + (map['v-bind']) + ").type";
    }

    if (typeBinding) {
      var ifCondition = getAndRemoveAttr(el, 'v-if', true);
      var ifConditionExtra = ifCondition ? ("&&(" + ifCondition + ")") : "";
      var hasElse = getAndRemoveAttr(el, 'v-else', true) != null;
      var elseIfCondition = getAndRemoveAttr(el, 'v-else-if', true);
      // 1. checkbox
      var branch0 = cloneASTElement(el);
      // process for on the main node
      processFor(branch0);
      addRawAttr(branch0, 'type', 'checkbox');
      processElement(branch0, options);
      branch0.processed = true; // prevent it from double-processed
      branch0.if = "(" + typeBinding + ")==='checkbox'" + ifConditionExtra;
      addIfCondition(branch0, {
        exp: branch0.if,
        block: branch0
      });
      // 2. add radio else-if condition
      var branch1 = cloneASTElement(el);
      getAndRemoveAttr(branch1, 'v-for', true);
      addRawAttr(branch1, 'type', 'radio');
      processElement(branch1, options);
      addIfCondition(branch0, {
        exp: "(" + typeBinding + ")==='radio'" + ifConditionExtra,
        block: branch1
      });
      // 3. other
      var branch2 = cloneASTElement(el);
      getAndRemoveAttr(branch2, 'v-for', true);
      addRawAttr(branch2, ':type', typeBinding);
      processElement(branch2, options);
      addIfCondition(branch0, {
        exp: ifCondition,
        block: branch2
      });

      if (hasElse) {
        branch0.else = true;
      } else if (elseIfCondition) {
        branch0.elseif = elseIfCondition;
      }

      return branch0
    }
  }
}

function cloneASTElement (el) {
  return createASTElement(el.tag, el.attrsList.slice(), el.parent)
}

var model$1 = {
  preTransformNode: preTransformNode
};

var modules$1 = [
  klass$1,
  style$1,
  model$1
];

/*  */

function text (el, dir) {
  if (dir.value) {
    addProp(el, 'textContent', ("_s(" + (dir.value) + ")"), dir);
  }
}

/*  */

function html (el, dir) {
  if (dir.value) {
    addProp(el, 'innerHTML', ("_s(" + (dir.value) + ")"), dir);
  }
}

var directives$1 = {
  model: model,
  text: text,
  html: html
};

/*  */

var baseOptions = {
  expectHTML: true,
  modules: modules$1,
  directives: directives$1,
  isPreTag: isPreTag,
  isUnaryTag: isUnaryTag,
  mustUseProp: mustUseProp,
  canBeLeftOpenTag: canBeLeftOpenTag,
  isReservedTag: isReservedTag,
  getTagNamespace: getTagNamespace,
  staticKeys: genStaticKeys(modules$1)
};

/*  */

var isStaticKey;
var isPlatformReservedTag;

var genStaticKeysCached = cached(genStaticKeys$1);

/**
 * Goal of the optimizer: walk the generated template AST tree
 * and detect sub-trees that are purely static, i.e. parts of
 * the DOM that never needs to change.
 *
 * Once we detect these sub-trees, we can:
 *
 * 1. Hoist them into constants, so that we no longer need to
 *    create fresh nodes for them on each re-render;
 * 2. Completely skip them in the patching process.
 */
function optimize (root, options) {
  if (!root) { return }
  isStaticKey = genStaticKeysCached(options.staticKeys || '');
  isPlatformReservedTag = options.isReservedTag || no;
  // first pass: mark all non-static nodes.
  markStatic$1(root);
  // second pass: mark static roots.
  markStaticRoots(root, false);
}

function genStaticKeys$1 (keys) {
  return makeMap(
    'type,tag,attrsList,attrsMap,plain,parent,children,attrs,start,end,rawAttrsMap' +
    (keys ? ',' + keys : '')
  )
}

function markStatic$1 (node) {
  node.static = isStatic(node);
  if (node.type === 1) {
    // do not make component slot content static. this avoids
    // 1. components not able to mutate slot nodes
    // 2. static slot content fails for hot-reloading
    if (
      !isPlatformReservedTag(node.tag) &&
      node.tag !== 'slot' &&
      node.attrsMap['inline-template'] == null
    ) {
      return
    }
    for (var i = 0, l = node.children.length; i < l; i++) {
      var child = node.children[i];
      markStatic$1(child);
      if (!child.static) {
        node.static = false;
      }
    }
    if (node.ifConditions) {
      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
        var block = node.ifConditions[i$1].block;
        markStatic$1(block);
        if (!block.static) {
          node.static = false;
        }
      }
    }
  }
}

function markStaticRoots (node, isInFor) {
  if (node.type === 1) {
    if (node.static || node.once) {
      node.staticInFor = isInFor;
    }
    // For a node to qualify as a static root, it should have children that
    // are not just static text. Otherwise the cost of hoisting out will
    // outweigh the benefits and it's better off to just always render it fresh.
    if (node.static && node.children.length && !(
      node.children.length === 1 &&
      node.children[0].type === 3
    )) {
      node.staticRoot = true;
      return
    } else {
      node.staticRoot = false;
    }
    if (node.children) {
      for (var i = 0, l = node.children.length; i < l; i++) {
        markStaticRoots(node.children[i], isInFor || !!node.for);
      }
    }
    if (node.ifConditions) {
      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
        markStaticRoots(node.ifConditions[i$1].block, isInFor);
      }
    }
  }
}

function isStatic (node) {
  if (node.type === 2) { // expression
    return false
  }
  if (node.type === 3) { // text
    return true
  }
  return !!(node.pre || (
    !node.hasBindings && // no dynamic bindings
    !node.if && !node.for && // not v-if or v-for or v-else
    !isBuiltInTag(node.tag) && // not a built-in
    isPlatformReservedTag(node.tag) && // not a component
    !isDirectChildOfTemplateFor(node) &&
    Object.keys(node).every(isStaticKey)
  ))
}

function isDirectChildOfTemplateFor (node) {
  while (node.parent) {
    node = node.parent;
    if (node.tag !== 'template') {
      return false
    }
    if (node.for) {
      return true
    }
  }
  return false
}

/*  */

var fnExpRE = /^([\w$_]+|\([^)]*?\))\s*=>|^function(?:\s+[\w$]+)?\s*\(/;
var fnInvokeRE = /\([^)]*?\);*$/;
var simplePathRE = /^[A-Za-z_$][\w$]*(?:\.[A-Za-z_$][\w$]*|\['[^']*?']|\["[^"]*?"]|\[\d+]|\[[A-Za-z_$][\w$]*])*$/;

// KeyboardEvent.keyCode aliases
var keyCodes = {
  esc: 27,
  tab: 9,
  enter: 13,
  space: 32,
  up: 38,
  left: 37,
  right: 39,
  down: 40,
  'delete': [8, 46]
};

// KeyboardEvent.key aliases
var keyNames = {
  // #7880: IE11 and Edge use `Esc` for Escape key name.
  esc: ['Esc', 'Escape'],
  tab: 'Tab',
  enter: 'Enter',
  // #9112: IE11 uses `Spacebar` for Space key name.
  space: [' ', 'Spacebar'],
  // #7806: IE11 uses key names without `Arrow` prefix for arrow keys.
  up: ['Up', 'ArrowUp'],
  left: ['Left', 'ArrowLeft'],
  right: ['Right', 'ArrowRight'],
  down: ['Down', 'ArrowDown'],
  // #9112: IE11 uses `Del` for Delete key name.
  'delete': ['Backspace', 'Delete', 'Del']
};

// #4868: modifiers that prevent the execution of the listener
// need to explicitly return null so that we can determine whether to remove
// the listener for .once
var genGuard = function (condition) { return ("if(" + condition + ")return null;"); };

var modifierCode = {
  stop: '$event.stopPropagation();',
  prevent: '$event.preventDefault();',
  self: genGuard("$event.target !== $event.currentTarget"),
  ctrl: genGuard("!$event.ctrlKey"),
  shift: genGuard("!$event.shiftKey"),
  alt: genGuard("!$event.altKey"),
  meta: genGuard("!$event.metaKey"),
  left: genGuard("'button' in $event && $event.button !== 0"),
  middle: genGuard("'button' in $event && $event.button !== 1"),
  right: genGuard("'button' in $event && $event.button !== 2")
};

function genHandlers (
  events,
  isNative
) {
  var prefix = isNative ? 'nativeOn:' : 'on:';
  var staticHandlers = "";
  var dynamicHandlers = "";
  for (var name in events) {
    var handlerCode = genHandler(events[name]);
    if (events[name] && events[name].dynamic) {
      dynamicHandlers += name + "," + handlerCode + ",";
    } else {
      staticHandlers += "\"" + name + "\":" + handlerCode + ",";
    }
  }
  staticHandlers = "{" + (staticHandlers.slice(0, -1)) + "}";
  if (dynamicHandlers) {
    return prefix + "_d(" + staticHandlers + ",[" + (dynamicHandlers.slice(0, -1)) + "])"
  } else {
    return prefix + staticHandlers
  }
}

function genHandler (handler) {
  if (!handler) {
    return 'function(){}'
  }

  if (Array.isArray(handler)) {
    return ("[" + (handler.map(function (handler) { return genHandler(handler); }).join(',')) + "]")
  }

  var isMethodPath = simplePathRE.test(handler.value);
  var isFunctionExpression = fnExpRE.test(handler.value);
  var isFunctionInvocation = simplePathRE.test(handler.value.replace(fnInvokeRE, ''));

  if (!handler.modifiers) {
    if (isMethodPath || isFunctionExpression) {
      return handler.value
    }
    return ("function($event){" + (isFunctionInvocation ? ("return " + (handler.value)) : handler.value) + "}") // inline statement
  } else {
    var code = '';
    var genModifierCode = '';
    var keys = [];
    for (var key in handler.modifiers) {
      if (modifierCode[key]) {
        genModifierCode += modifierCode[key];
        // left/right
        if (keyCodes[key]) {
          keys.push(key);
        }
      } else if (key === 'exact') {
        var modifiers = (handler.modifiers);
        genModifierCode += genGuard(
          ['ctrl', 'shift', 'alt', 'meta']
            .filter(function (keyModifier) { return !modifiers[keyModifier]; })
            .map(function (keyModifier) { return ("$event." + keyModifier + "Key"); })
            .join('||')
        );
      } else {
        keys.push(key);
      }
    }
    if (keys.length) {
      code += genKeyFilter(keys);
    }
    // Make sure modifiers like prevent and stop get executed after key filtering
    if (genModifierCode) {
      code += genModifierCode;
    }
    var handlerCode = isMethodPath
      ? ("return " + (handler.value) + "($event)")
      : isFunctionExpression
        ? ("return (" + (handler.value) + ")($event)")
        : isFunctionInvocation
          ? ("return " + (handler.value))
          : handler.value;
    return ("function($event){" + code + handlerCode + "}")
  }
}

function genKeyFilter (keys) {
  return (
    // make sure the key filters only apply to KeyboardEvents
    // #9441: can't use 'keyCode' in $event because Chrome autofill fires fake
    // key events that do not have keyCode property...
    "if(!$event.type.indexOf('key')&&" +
    (keys.map(genFilterCode).join('&&')) + ")return null;"
  )
}

function genFilterCode (key) {
  var keyVal = parseInt(key, 10);
  if (keyVal) {
    return ("$event.keyCode!==" + keyVal)
  }
  var keyCode = keyCodes[key];
  var keyName = keyNames[key];
  return (
    "_k($event.keyCode," +
    (JSON.stringify(key)) + "," +
    (JSON.stringify(keyCode)) + "," +
    "$event.key," +
    "" + (JSON.stringify(keyName)) +
    ")"
  )
}

/*  */

function on (el, dir) {
  if (false) {
    warn("v-on without argument does not support modifiers.");
  }
  el.wrapListeners = function (code) { return ("_g(" + code + "," + (dir.value) + ")"); };
}

/*  */

function bind$1 (el, dir) {
  el.wrapData = function (code) {
    return ("_b(" + code + ",'" + (el.tag) + "'," + (dir.value) + "," + (dir.modifiers && dir.modifiers.prop ? 'true' : 'false') + (dir.modifiers && dir.modifiers.sync ? ',true' : '') + ")")
  };
}

/*  */

var baseDirectives = {
  on: on,
  bind: bind$1,
  cloak: noop
};

/*  */





var CodegenState = function CodegenState (options) {
  this.options = options;
  this.warn = options.warn || baseWarn;
  this.transforms = pluckModuleFunction(options.modules, 'transformCode');
  this.dataGenFns = pluckModuleFunction(options.modules, 'genData');
  this.directives = extend(extend({}, baseDirectives), options.directives);
  var isReservedTag = options.isReservedTag || no;
  this.maybeComponent = function (el) { return !!el.component || !isReservedTag(el.tag); };
  this.onceId = 0;
  this.staticRenderFns = [];
  this.pre = false;
};



function generate (
  ast,
  options
) {
  var state = new CodegenState(options);
  var code = ast ? genElement(ast, state) : '_c("div")';
  return {
    render: ("with(this){return " + code + "}"),
    staticRenderFns: state.staticRenderFns
  }
}

function genElement (el, state) {
  if (el.parent) {
    el.pre = el.pre || el.parent.pre;
  }

  if (el.staticRoot && !el.staticProcessed) {
    return genStatic(el, state)
  } else if (el.once && !el.onceProcessed) {
    return genOnce(el, state)
  } else if (el.for && !el.forProcessed) {
    return genFor(el, state)
  } else if (el.if && !el.ifProcessed) {
    return genIf(el, state)
  } else if (el.tag === 'template' && !el.slotTarget && !state.pre) {
    return genChildren(el, state) || 'void 0'
  } else if (el.tag === 'slot') {
    return genSlot(el, state)
  } else {
    // component or element
    var code;
    if (el.component) {
      code = genComponent(el.component, el, state);
    } else {
      var data;
      if (!el.plain || (el.pre && state.maybeComponent(el))) {
        data = genData$2(el, state);
      }

      var children = el.inlineTemplate ? null : genChildren(el, state, true);
      code = "_c('" + (el.tag) + "'" + (data ? ("," + data) : '') + (children ? ("," + children) : '') + ")";
    }
    // module transforms
    for (var i = 0; i < state.transforms.length; i++) {
      code = state.transforms[i](el, code);
    }
    return code
  }
}

// hoist static sub-trees out
function genStatic (el, state) {
  el.staticProcessed = true;
  // Some elements (templates) need to behave differently inside of a v-pre
  // node.  All pre nodes are static roots, so we can use this as a location to
  // wrap a state change and reset it upon exiting the pre node.
  var originalPreState = state.pre;
  if (el.pre) {
    state.pre = el.pre;
  }
  state.staticRenderFns.push(("with(this){return " + (genElement(el, state)) + "}"));
  state.pre = originalPreState;
  return ("_m(" + (state.staticRenderFns.length - 1) + (el.staticInFor ? ',true' : '') + ")")
}

// v-once
function genOnce (el, state) {
  el.onceProcessed = true;
  if (el.if && !el.ifProcessed) {
    return genIf(el, state)
  } else if (el.staticInFor) {
    var key = '';
    var parent = el.parent;
    while (parent) {
      if (parent.for) {
        key = parent.key;
        break
      }
      parent = parent.parent;
    }
    if (!key) {
      "production" !== 'production' && state.warn(
        "v-once can only be used inside v-for that is keyed. ",
        el.rawAttrsMap['v-once']
      );
      return genElement(el, state)
    }
    return ("_o(" + (genElement(el, state)) + "," + (state.onceId++) + "," + key + ")")
  } else {
    return genStatic(el, state)
  }
}

function genIf (
  el,
  state,
  altGen,
  altEmpty
) {
  el.ifProcessed = true; // avoid recursion
  return genIfConditions(el.ifConditions.slice(), state, altGen, altEmpty)
}

function genIfConditions (
  conditions,
  state,
  altGen,
  altEmpty
) {
  if (!conditions.length) {
    return altEmpty || '_e()'
  }

  var condition = conditions.shift();
  if (condition.exp) {
    return ("(" + (condition.exp) + ")?" + (genTernaryExp(condition.block)) + ":" + (genIfConditions(conditions, state, altGen, altEmpty)))
  } else {
    return ("" + (genTernaryExp(condition.block)))
  }

  // v-if with v-once should generate code like (a)?_m(0):_m(1)
  function genTernaryExp (el) {
    return altGen
      ? altGen(el, state)
      : el.once
        ? genOnce(el, state)
        : genElement(el, state)
  }
}

function genFor (
  el,
  state,
  altGen,
  altHelper
) {
  var exp = el.for;
  var alias = el.alias;
  var iterator1 = el.iterator1 ? ("," + (el.iterator1)) : '';
  var iterator2 = el.iterator2 ? ("," + (el.iterator2)) : '';

  if (false
  ) {
    state.warn(
      "<" + (el.tag) + " v-for=\"" + alias + " in " + exp + "\">: component lists rendered with " +
      "v-for should have explicit keys. " +
      "See https://vuejs.org/guide/list.html#key for more info.",
      el.rawAttrsMap['v-for'],
      true /* tip */
    );
  }

  el.forProcessed = true; // avoid recursion
  return (altHelper || '_l') + "((" + exp + ")," +
    "function(" + alias + iterator1 + iterator2 + "){" +
      "return " + ((altGen || genElement)(el, state)) +
    '})'
}

function genData$2 (el, state) {
  var data = '{';

  // directives first.
  // directives may mutate the el's other properties before they are generated.
  var dirs = genDirectives(el, state);
  if (dirs) { data += dirs + ','; }

  // key
  if (el.key) {
    data += "key:" + (el.key) + ",";
  }
  // ref
  if (el.ref) {
    data += "ref:" + (el.ref) + ",";
  }
  if (el.refInFor) {
    data += "refInFor:true,";
  }
  // pre
  if (el.pre) {
    data += "pre:true,";
  }
  // record original tag name for components using "is" attribute
  if (el.component) {
    data += "tag:\"" + (el.tag) + "\",";
  }
  // module data generation functions
  for (var i = 0; i < state.dataGenFns.length; i++) {
    data += state.dataGenFns[i](el);
  }
  // attributes
  if (el.attrs) {
    data += "attrs:" + (genProps(el.attrs)) + ",";
  }
  // DOM props
  if (el.props) {
    data += "domProps:" + (genProps(el.props)) + ",";
  }
  // event handlers
  if (el.events) {
    data += (genHandlers(el.events, false)) + ",";
  }
  if (el.nativeEvents) {
    data += (genHandlers(el.nativeEvents, true)) + ",";
  }
  // slot target
  // only for non-scoped slots
  if (el.slotTarget && !el.slotScope) {
    data += "slot:" + (el.slotTarget) + ",";
  }
  // scoped slots
  if (el.scopedSlots) {
    data += (genScopedSlots(el, el.scopedSlots, state)) + ",";
  }
  // component v-model
  if (el.model) {
    data += "model:{value:" + (el.model.value) + ",callback:" + (el.model.callback) + ",expression:" + (el.model.expression) + "},";
  }
  // inline-template
  if (el.inlineTemplate) {
    var inlineTemplate = genInlineTemplate(el, state);
    if (inlineTemplate) {
      data += inlineTemplate + ",";
    }
  }
  data = data.replace(/,$/, '') + '}';
  // v-bind dynamic argument wrap
  // v-bind with dynamic arguments must be applied using the same v-bind object
  // merge helper so that class/style/mustUseProp attrs are handled correctly.
  if (el.dynamicAttrs) {
    data = "_b(" + data + ",\"" + (el.tag) + "\"," + (genProps(el.dynamicAttrs)) + ")";
  }
  // v-bind data wrap
  if (el.wrapData) {
    data = el.wrapData(data);
  }
  // v-on data wrap
  if (el.wrapListeners) {
    data = el.wrapListeners(data);
  }
  return data
}

function genDirectives (el, state) {
  var dirs = el.directives;
  if (!dirs) { return }
  var res = 'directives:[';
  var hasRuntime = false;
  var i, l, dir, needRuntime;
  for (i = 0, l = dirs.length; i < l; i++) {
    dir = dirs[i];
    needRuntime = true;
    var gen = state.directives[dir.name];
    if (gen) {
      // compile-time directive that manipulates AST.
      // returns true if it also needs a runtime counterpart.
      needRuntime = !!gen(el, dir, state.warn);
    }
    if (needRuntime) {
      hasRuntime = true;
      res += "{name:\"" + (dir.name) + "\",rawName:\"" + (dir.rawName) + "\"" + (dir.value ? (",value:(" + (dir.value) + "),expression:" + (JSON.stringify(dir.value))) : '') + (dir.arg ? (",arg:" + (dir.isDynamicArg ? dir.arg : ("\"" + (dir.arg) + "\""))) : '') + (dir.modifiers ? (",modifiers:" + (JSON.stringify(dir.modifiers))) : '') + "},";
    }
  }
  if (hasRuntime) {
    return res.slice(0, -1) + ']'
  }
}

function genInlineTemplate (el, state) {
  var ast = el.children[0];
  if (false) {
    state.warn(
      'Inline-template components must have exactly one child element.',
      { start: el.start }
    );
  }
  if (ast && ast.type === 1) {
    var inlineRenderFns = generate(ast, state.options);
    return ("inlineTemplate:{render:function(){" + (inlineRenderFns.render) + "},staticRenderFns:[" + (inlineRenderFns.staticRenderFns.map(function (code) { return ("function(){" + code + "}"); }).join(',')) + "]}")
  }
}

function genScopedSlots (
  el,
  slots,
  state
) {
  // by default scoped slots are considered "stable", this allows child
  // components with only scoped slots to skip forced updates from parent.
  // but in some cases we have to bail-out of this optimization
  // for example if the slot contains dynamic names, has v-if or v-for on them...
  var needsForceUpdate = el.for || Object.keys(slots).some(function (key) {
    var slot = slots[key];
    return (
      slot.slotTargetDynamic ||
      slot.if ||
      slot.for ||
      containsSlotChild(slot) // is passing down slot from parent which may be dynamic
    )
  });

  // #9534: if a component with scoped slots is inside a conditional branch,
  // it's possible for the same component to be reused but with different
  // compiled slot content. To avoid that, we generate a unique key based on
  // the generated code of all the slot contents.
  var needsKey = !!el.if;

  // OR when it is inside another scoped slot or v-for (the reactivity may be
  // disconnected due to the intermediate scope variable)
  // #9438, #9506
  // TODO: this can be further optimized by properly analyzing in-scope bindings
  // and skip force updating ones that do not actually use scope variables.
  if (!needsForceUpdate) {
    var parent = el.parent;
    while (parent) {
      if (
        (parent.slotScope && parent.slotScope !== emptySlotScopeToken) ||
        parent.for
      ) {
        needsForceUpdate = true;
        break
      }
      if (parent.if) {
        needsKey = true;
      }
      parent = parent.parent;
    }
  }

  var generatedSlots = Object.keys(slots)
    .map(function (key) { return genScopedSlot(slots[key], state); })
    .join(',');

  return ("scopedSlots:_u([" + generatedSlots + "]" + (needsForceUpdate ? ",null,true" : "") + (!needsForceUpdate && needsKey ? (",null,false," + (hash(generatedSlots))) : "") + ")")
}

function hash(str) {
  var hash = 5381;
  var i = str.length;
  while(i) {
    hash = (hash * 33) ^ str.charCodeAt(--i);
  }
  return hash >>> 0
}

function containsSlotChild (el) {
  if (el.type === 1) {
    if (el.tag === 'slot') {
      return true
    }
    return el.children.some(containsSlotChild)
  }
  return false
}

function genScopedSlot (
  el,
  state
) {
  var isLegacySyntax = el.attrsMap['slot-scope'];
  if (el.if && !el.ifProcessed && !isLegacySyntax) {
    return genIf(el, state, genScopedSlot, "null")
  }
  if (el.for && !el.forProcessed) {
    return genFor(el, state, genScopedSlot)
  }
  var slotScope = el.slotScope === emptySlotScopeToken
    ? ""
    : String(el.slotScope);
  var fn = "function(" + slotScope + "){" +
    "return " + (el.tag === 'template'
      ? el.if && isLegacySyntax
        ? ("(" + (el.if) + ")?" + (genChildren(el, state) || 'undefined') + ":undefined")
        : genChildren(el, state) || 'undefined'
      : genElement(el, state)) + "}";
  // reverse proxy v-slot without scope on this.$slots
  var reverseProxy = slotScope ? "" : ",proxy:true";
  return ("{key:" + (el.slotTarget || "\"default\"") + ",fn:" + fn + reverseProxy + "}")
}

function genChildren (
  el,
  state,
  checkSkip,
  altGenElement,
  altGenNode
) {
  var children = el.children;
  if (children.length) {
    var el$1 = children[0];
    // optimize single v-for
    if (children.length === 1 &&
      el$1.for &&
      el$1.tag !== 'template' &&
      el$1.tag !== 'slot'
    ) {
      var normalizationType = checkSkip
        ? state.maybeComponent(el$1) ? ",1" : ",0"
        : "";
      return ("" + ((altGenElement || genElement)(el$1, state)) + normalizationType)
    }
    var normalizationType$1 = checkSkip
      ? getNormalizationType(children, state.maybeComponent)
      : 0;
    var gen = altGenNode || genNode;
    return ("[" + (children.map(function (c) { return gen(c, state); }).join(',')) + "]" + (normalizationType$1 ? ("," + normalizationType$1) : ''))
  }
}

// determine the normalization needed for the children array.
// 0: no normalization needed
// 1: simple normalization needed (possible 1-level deep nested array)
// 2: full normalization needed
function getNormalizationType (
  children,
  maybeComponent
) {
  var res = 0;
  for (var i = 0; i < children.length; i++) {
    var el = children[i];
    if (el.type !== 1) {
      continue
    }
    if (needsNormalization(el) ||
        (el.ifConditions && el.ifConditions.some(function (c) { return needsNormalization(c.block); }))) {
      res = 2;
      break
    }
    if (maybeComponent(el) ||
        (el.ifConditions && el.ifConditions.some(function (c) { return maybeComponent(c.block); }))) {
      res = 1;
    }
  }
  return res
}

function needsNormalization (el) {
  return el.for !== undefined || el.tag === 'template' || el.tag === 'slot'
}

function genNode (node, state) {
  if (node.type === 1) {
    return genElement(node, state)
  } else if (node.type === 3 && node.isComment) {
    return genComment(node)
  } else {
    return genText(node)
  }
}

function genText (text) {
  return ("_v(" + (text.type === 2
    ? text.expression // no need for () because already wrapped in _s()
    : transformSpecialNewlines(JSON.stringify(text.text))) + ")")
}

function genComment (comment) {
  return ("_e(" + (JSON.stringify(comment.text)) + ")")
}

function genSlot (el, state) {
  var slotName = el.slotName || '"default"';
  var children = genChildren(el, state);
  var res = "_t(" + slotName + (children ? ("," + children) : '');
  var attrs = el.attrs || el.dynamicAttrs
    ? genProps((el.attrs || []).concat(el.dynamicAttrs || []).map(function (attr) { return ({
        // slot props are camelized
        name: camelize(attr.name),
        value: attr.value,
        dynamic: attr.dynamic
      }); }))
    : null;
  var bind$$1 = el.attrsMap['v-bind'];
  if ((attrs || bind$$1) && !children) {
    res += ",null";
  }
  if (attrs) {
    res += "," + attrs;
  }
  if (bind$$1) {
    res += (attrs ? '' : ',null') + "," + bind$$1;
  }
  return res + ')'
}

// componentName is el.component, take it as argument to shun flow's pessimistic refinement
function genComponent (
  componentName,
  el,
  state
) {
  var children = el.inlineTemplate ? null : genChildren(el, state, true);
  return ("_c(" + componentName + "," + (genData$2(el, state)) + (children ? ("," + children) : '') + ")")
}

function genProps (props) {
  var staticProps = "";
  var dynamicProps = "";
  for (var i = 0; i < props.length; i++) {
    var prop = props[i];
    var value = transformSpecialNewlines(prop.value);
    if (prop.dynamic) {
      dynamicProps += (prop.name) + "," + value + ",";
    } else {
      staticProps += "\"" + (prop.name) + "\":" + value + ",";
    }
  }
  staticProps = "{" + (staticProps.slice(0, -1)) + "}";
  if (dynamicProps) {
    return ("_d(" + staticProps + ",[" + (dynamicProps.slice(0, -1)) + "])")
  } else {
    return staticProps
  }
}

// #3895, #4268
function transformSpecialNewlines (text) {
  return text
    .replace(/\u2028/g, '\\u2028')
    .replace(/\u2029/g, '\\u2029')
}

/*  */



// these keywords should not appear inside expressions, but operators like
// typeof, instanceof and in are allowed
var prohibitedKeywordRE = new RegExp('\\b' + (
  'do,if,for,let,new,try,var,case,else,with,await,break,catch,class,const,' +
  'super,throw,while,yield,delete,export,import,return,switch,default,' +
  'extends,finally,continue,debugger,function,arguments'
).split(',').join('\\b|\\b') + '\\b');

// these unary operators should not be used as property/method names
var unaryOperatorsRE = new RegExp('\\b' + (
  'delete,typeof,void'
).split(',').join('\\s*\\([^\\)]*\\)|\\b') + '\\s*\\([^\\)]*\\)');

// strip strings in expressions
var stripStringRE = /'(?:[^'\\]|\\.)*'|"(?:[^"\\]|\\.)*"|`(?:[^`\\]|\\.)*\$\{|\}(?:[^`\\]|\\.)*`|`(?:[^`\\]|\\.)*`/g;

// detect problematic expressions in a template
function detectErrors (ast, warn) {
  if (ast) {
    checkNode(ast, warn);
  }
}

function checkNode (node, warn) {
  if (node.type === 1) {
    for (var name in node.attrsMap) {
      if (dirRE.test(name)) {
        var value = node.attrsMap[name];
        if (value) {
          var range = node.rawAttrsMap[name];
          if (name === 'v-for') {
            checkFor(node, ("v-for=\"" + value + "\""), warn, range);
          } else if (name === 'v-slot' || name[0] === '#') {
            checkFunctionParameterExpression(value, (name + "=\"" + value + "\""), warn, range);
          } else if (onRE.test(name)) {
            checkEvent(value, (name + "=\"" + value + "\""), warn, range);
          } else {
            checkExpression(value, (name + "=\"" + value + "\""), warn, range);
          }
        }
      }
    }
    if (node.children) {
      for (var i = 0; i < node.children.length; i++) {
        checkNode(node.children[i], warn);
      }
    }
  } else if (node.type === 2) {
    checkExpression(node.expression, node.text, warn, node);
  }
}

function checkEvent (exp, text, warn, range) {
  var stripped = exp.replace(stripStringRE, '');
  var keywordMatch = stripped.match(unaryOperatorsRE);
  if (keywordMatch && stripped.charAt(keywordMatch.index - 1) !== '$') {
    warn(
      "avoid using JavaScript unary operator as property name: " +
      "\"" + (keywordMatch[0]) + "\" in expression " + (text.trim()),
      range
    );
  }
  checkExpression(exp, text, warn, range);
}

function checkFor (node, text, warn, range) {
  checkExpression(node.for || '', text, warn, range);
  checkIdentifier(node.alias, 'v-for alias', text, warn, range);
  checkIdentifier(node.iterator1, 'v-for iterator', text, warn, range);
  checkIdentifier(node.iterator2, 'v-for iterator', text, warn, range);
}

function checkIdentifier (
  ident,
  type,
  text,
  warn,
  range
) {
  if (typeof ident === 'string') {
    try {
      new Function(("var " + ident + "=_"));
    } catch (e) {
      warn(("invalid " + type + " \"" + ident + "\" in expression: " + (text.trim())), range);
    }
  }
}

function checkExpression (exp, text, warn, range) {
  try {
    new Function(("return " + exp));
  } catch (e) {
    var keywordMatch = exp.replace(stripStringRE, '').match(prohibitedKeywordRE);
    if (keywordMatch) {
      warn(
        "avoid using JavaScript keyword as property name: " +
        "\"" + (keywordMatch[0]) + "\"\n  Raw expression: " + (text.trim()),
        range
      );
    } else {
      warn(
        "invalid expression: " + (e.message) + " in\n\n" +
        "    " + exp + "\n\n" +
        "  Raw expression: " + (text.trim()) + "\n",
        range
      );
    }
  }
}

function checkFunctionParameterExpression (exp, text, warn, range) {
  try {
    new Function(exp, '');
  } catch (e) {
    warn(
      "invalid function parameter expression: " + (e.message) + " in\n\n" +
      "    " + exp + "\n\n" +
      "  Raw expression: " + (text.trim()) + "\n",
      range
    );
  }
}

/*  */

var range = 2;

function generateCodeFrame (
  source,
  start,
  end
) {
  if ( start === void 0 ) start = 0;
  if ( end === void 0 ) end = source.length;

  var lines = source.split(/\r?\n/);
  var count = 0;
  var res = [];
  for (var i = 0; i < lines.length; i++) {
    count += lines[i].length + 1;
    if (count >= start) {
      for (var j = i - range; j <= i + range || end > count; j++) {
        if (j < 0 || j >= lines.length) { continue }
        res.push(("" + (j + 1) + (repeat$1(" ", 3 - String(j + 1).length)) + "|  " + (lines[j])));
        var lineLength = lines[j].length;
        if (j === i) {
          // push underline
          var pad = start - (count - lineLength) + 1;
          var length = end > count ? lineLength - pad : end - start;
          res.push("   |  " + repeat$1(" ", pad) + repeat$1("^", length));
        } else if (j > i) {
          if (end > count) {
            var length$1 = Math.min(end - count, lineLength);
            res.push("   |  " + repeat$1("^", length$1));
          }
          count += lineLength + 1;
        }
      }
      break
    }
  }
  return res.join('\n')
}

function repeat$1 (str, n) {
  var result = '';
  if (n > 0) {
    while (true) { // eslint-disable-line
      if (n & 1) { result += str; }
      n >>>= 1;
      if (n <= 0) { break }
      str += str;
    }
  }
  return result
}

/*  */



function createFunction (code, errors) {
  try {
    return new Function(code)
  } catch (err) {
    errors.push({ err: err, code: code });
    return noop
  }
}

function createCompileToFunctionFn (compile) {
  var cache = Object.create(null);

  return function compileToFunctions (
    template,
    options,
    vm
  ) {
    options = extend({}, options);
    var warn$$1 = options.warn || warn;
    delete options.warn;

    /* istanbul ignore if */
    if (false) {
      // detect possible CSP restriction
      try {
        new Function('return 1');
      } catch (e) {
        if (e.toString().match(/unsafe-eval|CSP/)) {
          warn$$1(
            'It seems you are using the standalone build of Vue.js in an ' +
            'environment with Content Security Policy that prohibits unsafe-eval. ' +
            'The template compiler cannot work in this environment. Consider ' +
            'relaxing the policy to allow unsafe-eval or pre-compiling your ' +
            'templates into render functions.'
          );
        }
      }
    }

    // check cache
    var key = options.delimiters
      ? String(options.delimiters) + template
      : template;
    if (cache[key]) {
      return cache[key]
    }

    // compile
    var compiled = compile(template, options);

    // check compilation errors/tips
    if (false) {
      if (compiled.errors && compiled.errors.length) {
        if (options.outputSourceRange) {
          compiled.errors.forEach(function (e) {
            warn$$1(
              "Error compiling template:\n\n" + (e.msg) + "\n\n" +
              generateCodeFrame(template, e.start, e.end),
              vm
            );
          });
        } else {
          warn$$1(
            "Error compiling template:\n\n" + template + "\n\n" +
            compiled.errors.map(function (e) { return ("- " + e); }).join('\n') + '\n',
            vm
          );
        }
      }
      if (compiled.tips && compiled.tips.length) {
        if (options.outputSourceRange) {
          compiled.tips.forEach(function (e) { return tip(e.msg, vm); });
        } else {
          compiled.tips.forEach(function (msg) { return tip(msg, vm); });
        }
      }
    }

    // turn code into functions
    var res = {};
    var fnGenErrors = [];
    res.render = createFunction(compiled.render, fnGenErrors);
    res.staticRenderFns = compiled.staticRenderFns.map(function (code) {
      return createFunction(code, fnGenErrors)
    });

    // check function generation errors.
    // this should only happen if there is a bug in the compiler itself.
    // mostly for codegen development use
    /* istanbul ignore if */
    if (false) {
      if ((!compiled.errors || !compiled.errors.length) && fnGenErrors.length) {
        warn$$1(
          "Failed to generate render function:\n\n" +
          fnGenErrors.map(function (ref) {
            var err = ref.err;
            var code = ref.code;

            return ((err.toString()) + " in\n\n" + code + "\n");
        }).join('\n'),
          vm
        );
      }
    }

    return (cache[key] = res)
  }
}

/*  */

function createCompilerCreator (baseCompile) {
  return function createCompiler (baseOptions) {
    function compile (
      template,
      options
    ) {
      var finalOptions = Object.create(baseOptions);
      var errors = [];
      var tips = [];

      var warn = function (msg, range, tip) {
        (tip ? tips : errors).push(msg);
      };

      if (options) {
        if (false) {
          // $flow-disable-line
          var leadingSpaceLength = template.match(/^\s*/)[0].length;

          warn = function (msg, range, tip) {
            var data = { msg: msg };
            if (range) {
              if (range.start != null) {
                data.start = range.start + leadingSpaceLength;
              }
              if (range.end != null) {
                data.end = range.end + leadingSpaceLength;
              }
            }
            (tip ? tips : errors).push(data);
          };
        }
        // merge custom modules
        if (options.modules) {
          finalOptions.modules =
            (baseOptions.modules || []).concat(options.modules);
        }
        // merge custom directives
        if (options.directives) {
          finalOptions.directives = extend(
            Object.create(baseOptions.directives || null),
            options.directives
          );
        }
        // copy other options
        for (var key in options) {
          if (key !== 'modules' && key !== 'directives') {
            finalOptions[key] = options[key];
          }
        }
      }

      finalOptions.warn = warn;

      var compiled = baseCompile(template.trim(), finalOptions);
      if (false) {
        detectErrors(compiled.ast, warn);
      }
      compiled.errors = errors;
      compiled.tips = tips;
      return compiled
    }

    return {
      compile: compile,
      compileToFunctions: createCompileToFunctionFn(compile)
    }
  }
}

/*  */

// `createCompilerCreator` allows creating compilers that use alternative
// parser/optimizer/codegen, e.g the SSR optimizing compiler.
// Here we just export a default compiler using the default parts.
var createCompiler = createCompilerCreator(function baseCompile (
  template,
  options
) {
  var ast = parse(template.trim(), options);
  if (options.optimize !== false) {
    optimize(ast, options);
  }
  var code = generate(ast, options);
  return {
    ast: ast,
    render: code.render,
    staticRenderFns: code.staticRenderFns
  }
});

/*  */

var ref$1 = createCompiler(baseOptions);
var compile = ref$1.compile;
var compileToFunctions = ref$1.compileToFunctions;

/*  */

// check whether current browser encodes a char inside attribute values
var div;
function getShouldDecode (href) {
  div = div || document.createElement('div');
  div.innerHTML = href ? "<a href=\"\n\"/>" : "<div a=\"\n\"/>";
  return div.innerHTML.indexOf('&#10;') > 0
}

// #3663: IE encodes newlines inside attribute values while other browsers don't
var shouldDecodeNewlines = inBrowser ? getShouldDecode(false) : false;
// #6828: chrome encodes content in a[href]
var shouldDecodeNewlinesForHref = inBrowser ? getShouldDecode(true) : false;

/*  */

var idToTemplate = cached(function (id) {
  var el = query(id);
  return el && el.innerHTML
});

var mount = Vue.prototype.$mount;
Vue.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && query(el);

  /* istanbul ignore if */
  if (el === document.body || el === document.documentElement) {
    "production" !== 'production' && warn(
      "Do not mount Vue to <html> or <body> - mount to normal elements instead."
    );
    return this
  }

  var options = this.$options;
  // resolve template/el and convert to render function
  if (!options.render) {
    var template = options.template;
    if (template) {
      if (typeof template === 'string') {
        if (template.charAt(0) === '#') {
          template = idToTemplate(template);
          /* istanbul ignore if */
          if (false) {
            warn(
              ("Template element not found or is empty: " + (options.template)),
              this
            );
          }
        }
      } else if (template.nodeType) {
        template = template.innerHTML;
      } else {
        if (false) {
          warn('invalid template option:' + template, this);
        }
        return this
      }
    } else if (el) {
      template = getOuterHTML(el);
    }
    if (template) {
      /* istanbul ignore if */
      if (false) {
        mark('compile');
      }

      var ref = compileToFunctions(template, {
        outputSourceRange: "production" !== 'production',
        shouldDecodeNewlines: shouldDecodeNewlines,
        shouldDecodeNewlinesForHref: shouldDecodeNewlinesForHref,
        delimiters: options.delimiters,
        comments: options.comments
      }, this);
      var render = ref.render;
      var staticRenderFns = ref.staticRenderFns;
      options.render = render;
      options.staticRenderFns = staticRenderFns;

      /* istanbul ignore if */
      if (false) {
        mark('compile end');
        measure(("vue " + (this._name) + " compile"), 'compile', 'compile end');
      }
    }
  }
  return mount.call(this, el, hydrating)
};

/**
 * Get outerHTML of elements, taking care
 * of SVG elements in IE as well.
 */
function getOuterHTML (el) {
  if (el.outerHTML) {
    return el.outerHTML
  } else {
    var container = document.createElement('div');
    container.appendChild(el.cloneNode(true));
    return container.innerHTML
  }
}

Vue.compile = compileToFunctions;

/* harmony default export */ __webpack_exports__["a"] = (Vue);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4), __webpack_require__(18).setImmediate))

/***/ }),
/* 4 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]());

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(25),
  /* template */
  __webpack_require__(28),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(26),
  /* template */
  __webpack_require__(27),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(0);

function encode(val) {
  return encodeURIComponent(val).
    replace(/%40/gi, '@').
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    var hashmarkIndex = url.indexOf('#');
    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }

    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var utils = __webpack_require__(0);
var normalizeHeaderName = __webpack_require__(35);

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__(12);
  } else if (typeof process !== 'undefined' && Object.prototype.toString.call(process) === '[object process]') {
    // For node use HTTP adapter
    adapter = __webpack_require__(12);
  }
  return adapter;
}

var defaults = {
  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Accept');
    normalizeHeaderName(headers, 'Content-Type');
    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data)) {
      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
      return JSON.stringify(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    /*eslint no-param-reassign:0*/
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (e) { /* Ignore */ }
    }
    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};

defaults.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(0);
var settle = __webpack_require__(36);
var buildURL = __webpack_require__(9);
var buildFullPath = __webpack_require__(38);
var parseHeaders = __webpack_require__(41);
var isURLSameOrigin = __webpack_require__(42);
var createError = __webpack_require__(13);

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password || '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    var fullPath = buildFullPath(config.baseURL, config.url);
    request.open(config.method.toUpperCase(), buildURL(fullPath, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    // Listen for ready state
    request.onreadystatechange = function handleLoad() {
      if (!request || request.readyState !== 4) {
        return;
      }

      // The request errored out and we didn't get a response, this will be
      // handled by onerror instead
      // With one exception: request that using file: protocol, most browsers
      // will return status as 0 even though it's a successful request
      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
        return;
      }

      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
      var response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(resolve, reject, response);

      // Clean up request
      request = null;
    };

    // Handle browser request cancellation (as opposed to a manual cancellation)
    request.onabort = function handleAbort() {
      if (!request) {
        return;
      }

      reject(createError('Request aborted', config, 'ECONNABORTED', request));

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      var timeoutErrorMessage = 'timeout of ' + config.timeout + 'ms exceeded';
      if (config.timeoutErrorMessage) {
        timeoutErrorMessage = config.timeoutErrorMessage;
      }
      reject(createError(timeoutErrorMessage, config, 'ECONNABORTED',
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      var cookies = __webpack_require__(43);

      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath)) && config.xsrfCookieName ?
        cookies.read(config.xsrfCookieName) :
        undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (!utils.isUndefined(config.withCredentials)) {
      request.withCredentials = !!config.withCredentials;
    }

    // Add responseType to request if needed
    if (config.responseType) {
      try {
        request.responseType = config.responseType;
      } catch (e) {
        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
        if (config.responseType !== 'json') {
          throw e;
        }
      }
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }

        request.abort();
        reject(cancel);
        // Clean up request
        request = null;
      });
    }

    if (requestData === undefined) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var enhanceError = __webpack_require__(37);

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(0);

/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */
module.exports = function mergeConfig(config1, config2) {
  // eslint-disable-next-line no-param-reassign
  config2 = config2 || {};
  var config = {};

  var valueFromConfig2Keys = ['url', 'method', 'params', 'data'];
  var mergeDeepPropertiesKeys = ['headers', 'auth', 'proxy'];
  var defaultToConfig2Keys = [
    'baseURL', 'url', 'transformRequest', 'transformResponse', 'paramsSerializer',
    'timeout', 'withCredentials', 'adapter', 'responseType', 'xsrfCookieName',
    'xsrfHeaderName', 'onUploadProgress', 'onDownloadProgress',
    'maxContentLength', 'validateStatus', 'maxRedirects', 'httpAgent',
    'httpsAgent', 'cancelToken', 'socketPath'
  ];

  utils.forEach(valueFromConfig2Keys, function valueFromConfig2(prop) {
    if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    }
  });

  utils.forEach(mergeDeepPropertiesKeys, function mergeDeepProperties(prop) {
    if (utils.isObject(config2[prop])) {
      config[prop] = utils.deepMerge(config1[prop], config2[prop]);
    } else if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    } else if (utils.isObject(config1[prop])) {
      config[prop] = utils.deepMerge(config1[prop]);
    } else if (typeof config1[prop] !== 'undefined') {
      config[prop] = config1[prop];
    }
  });

  utils.forEach(defaultToConfig2Keys, function defaultToConfig2(prop) {
    if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    } else if (typeof config1[prop] !== 'undefined') {
      config[prop] = config1[prop];
    }
  });

  var axiosKeys = valueFromConfig2Keys
    .concat(mergeDeepPropertiesKeys)
    .concat(defaultToConfig2Keys);

  var otherKeys = Object
    .keys(config2)
    .filter(function filterAxiosKeys(key) {
      return axiosKeys.indexOf(key) === -1;
    });

  utils.forEach(otherKeys, function otherKeysDefaultToConfig2(prop) {
    if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    } else if (typeof config1[prop] !== 'undefined') {
      config[prop] = config1[prop];
    }
  });

  return config;
};


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

module.exports = Cancel;


/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuetify__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_shortkey__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_shortkey___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_shortkey__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_touch__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_touch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_touch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_resource__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_analytics__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_analytics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_analytics__);
/*jshint esversion: 6 */
/* The Vue build version to load with the `import` command
(runtime-only or standalone) has been set in webpack.base.conf with an alias. */

var path = __webpack_require__(17);










__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vuetify___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_vue_shortkey___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_6_vue_resource__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_5_vue_touch___default.a.config.swipe = {
  direction: 'horizontal',
  threshold: 10,
  velocity: 0.3,
  pointers: 1
};

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5_vue_touch___default.a, { name: 'v-touch' });

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_7_vue_analytics___default.a, {
  id: ['UA-137347938-1', 'UA-64435914-1'],
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  autoTracking: {
    pageviewTemplate: function pageviewTemplate(route) {
      return {
        page: path.join(window.location.pathname, route.path),
        title: document.title,
        location: window.location.href
      };
    }
  },
  debug: {
    enabled: false
  }
});

var app = new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  data: {},
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_1__App___default.a);
  }
}).$mount('#app');

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {// .dirname, .basename, and .extname methods are extracted from Node.js v8.11.1,
// backported and transplited with Babel, with backwards-compat fixes

// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// resolves . and .. elements in a path array with directory names there
// must be no slashes, empty elements, or device names (c:\) in the array
// (so also no leading and trailing slashes - it does not distinguish
// relative and absolute paths)
function normalizeArray(parts, allowAboveRoot) {
  // if the path tries to go above the root, `up` ends up > 0
  var up = 0;
  for (var i = parts.length - 1; i >= 0; i--) {
    var last = parts[i];
    if (last === '.') {
      parts.splice(i, 1);
    } else if (last === '..') {
      parts.splice(i, 1);
      up++;
    } else if (up) {
      parts.splice(i, 1);
      up--;
    }
  }

  // if the path is allowed to go above the root, restore leading ..s
  if (allowAboveRoot) {
    for (; up--; up) {
      parts.unshift('..');
    }
  }

  return parts;
}

// path.resolve([from ...], to)
// posix version
exports.resolve = function() {
  var resolvedPath = '',
      resolvedAbsolute = false;

  for (var i = arguments.length - 1; i >= -1 && !resolvedAbsolute; i--) {
    var path = (i >= 0) ? arguments[i] : process.cwd();

    // Skip empty and invalid entries
    if (typeof path !== 'string') {
      throw new TypeError('Arguments to path.resolve must be strings');
    } else if (!path) {
      continue;
    }

    resolvedPath = path + '/' + resolvedPath;
    resolvedAbsolute = path.charAt(0) === '/';
  }

  // At this point the path should be resolved to a full absolute path, but
  // handle relative paths to be safe (might happen when process.cwd() fails)

  // Normalize the path
  resolvedPath = normalizeArray(filter(resolvedPath.split('/'), function(p) {
    return !!p;
  }), !resolvedAbsolute).join('/');

  return ((resolvedAbsolute ? '/' : '') + resolvedPath) || '.';
};

// path.normalize(path)
// posix version
exports.normalize = function(path) {
  var isAbsolute = exports.isAbsolute(path),
      trailingSlash = substr(path, -1) === '/';

  // Normalize the path
  path = normalizeArray(filter(path.split('/'), function(p) {
    return !!p;
  }), !isAbsolute).join('/');

  if (!path && !isAbsolute) {
    path = '.';
  }
  if (path && trailingSlash) {
    path += '/';
  }

  return (isAbsolute ? '/' : '') + path;
};

// posix version
exports.isAbsolute = function(path) {
  return path.charAt(0) === '/';
};

// posix version
exports.join = function() {
  var paths = Array.prototype.slice.call(arguments, 0);
  return exports.normalize(filter(paths, function(p, index) {
    if (typeof p !== 'string') {
      throw new TypeError('Arguments to path.join must be strings');
    }
    return p;
  }).join('/'));
};


// path.relative(from, to)
// posix version
exports.relative = function(from, to) {
  from = exports.resolve(from).substr(1);
  to = exports.resolve(to).substr(1);

  function trim(arr) {
    var start = 0;
    for (; start < arr.length; start++) {
      if (arr[start] !== '') break;
    }

    var end = arr.length - 1;
    for (; end >= 0; end--) {
      if (arr[end] !== '') break;
    }

    if (start > end) return [];
    return arr.slice(start, end - start + 1);
  }

  var fromParts = trim(from.split('/'));
  var toParts = trim(to.split('/'));

  var length = Math.min(fromParts.length, toParts.length);
  var samePartsLength = length;
  for (var i = 0; i < length; i++) {
    if (fromParts[i] !== toParts[i]) {
      samePartsLength = i;
      break;
    }
  }

  var outputParts = [];
  for (var i = samePartsLength; i < fromParts.length; i++) {
    outputParts.push('..');
  }

  outputParts = outputParts.concat(toParts.slice(samePartsLength));

  return outputParts.join('/');
};

exports.sep = '/';
exports.delimiter = ':';

exports.dirname = function (path) {
  if (typeof path !== 'string') path = path + '';
  if (path.length === 0) return '.';
  var code = path.charCodeAt(0);
  var hasRoot = code === 47 /*/*/;
  var end = -1;
  var matchedSlash = true;
  for (var i = path.length - 1; i >= 1; --i) {
    code = path.charCodeAt(i);
    if (code === 47 /*/*/) {
        if (!matchedSlash) {
          end = i;
          break;
        }
      } else {
      // We saw the first non-path separator
      matchedSlash = false;
    }
  }

  if (end === -1) return hasRoot ? '/' : '.';
  if (hasRoot && end === 1) {
    // return '//';
    // Backwards-compat fix:
    return '/';
  }
  return path.slice(0, end);
};

function basename(path) {
  if (typeof path !== 'string') path = path + '';

  var start = 0;
  var end = -1;
  var matchedSlash = true;
  var i;

  for (i = path.length - 1; i >= 0; --i) {
    if (path.charCodeAt(i) === 47 /*/*/) {
        // If we reached a path separator that was not part of a set of path
        // separators at the end of the string, stop now
        if (!matchedSlash) {
          start = i + 1;
          break;
        }
      } else if (end === -1) {
      // We saw the first non-path separator, mark this as the end of our
      // path component
      matchedSlash = false;
      end = i + 1;
    }
  }

  if (end === -1) return '';
  return path.slice(start, end);
}

// Uses a mixed approach for backwards-compatibility, as ext behavior changed
// in new Node.js versions, so only basename() above is backported here
exports.basename = function (path, ext) {
  var f = basename(path);
  if (ext && f.substr(-1 * ext.length) === ext) {
    f = f.substr(0, f.length - ext.length);
  }
  return f;
};

exports.extname = function (path) {
  if (typeof path !== 'string') path = path + '';
  var startDot = -1;
  var startPart = 0;
  var end = -1;
  var matchedSlash = true;
  // Track the state of characters (if any) we see before our first dot and
  // after any path separator we find
  var preDotState = 0;
  for (var i = path.length - 1; i >= 0; --i) {
    var code = path.charCodeAt(i);
    if (code === 47 /*/*/) {
        // If we reached a path separator that was not part of a set of path
        // separators at the end of the string, stop now
        if (!matchedSlash) {
          startPart = i + 1;
          break;
        }
        continue;
      }
    if (end === -1) {
      // We saw the first non-path separator, mark this as the end of our
      // extension
      matchedSlash = false;
      end = i + 1;
    }
    if (code === 46 /*.*/) {
        // If this is our first dot, mark it as the start of our extension
        if (startDot === -1)
          startDot = i;
        else if (preDotState !== 1)
          preDotState = 1;
    } else if (startDot !== -1) {
      // We saw a non-dot and non-path separator before our dot, so we should
      // have a good chance at having a non-empty extension
      preDotState = -1;
    }
  }

  if (startDot === -1 || end === -1 ||
      // We saw a non-dot character immediately before the dot
      preDotState === 0 ||
      // The (right-most) trimmed path component is exactly '..'
      preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) {
    return '';
  }
  return path.slice(startDot, end);
};

function filter (xs, f) {
    if (xs.filter) return xs.filter(f);
    var res = [];
    for (var i = 0; i < xs.length; i++) {
        if (f(xs[i], i, xs)) res.push(xs[i]);
    }
    return res;
}

// String.prototype.substr - negative index don't work in IE8
var substr = 'ab'.substr(-1) === 'b'
    ? function (str, start, len) { return str.substr(start, len) }
    : function (str, start, len) {
        if (start < 0) start = str.length + start;
        return str.substr(start, len);
    }
;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
            (typeof self !== "undefined" && self) ||
            window;
var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(scope, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(19);
// On some exotic environments, it's not clear which object `setimmediate` was
// able to install onto.  Search each possibility in the same order as the
// `setimmediate` library.
exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
                       (typeof global !== "undefined" && global.setImmediate) ||
                       (this && this.setImmediate);
exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
                         (typeof global !== "undefined" && global.clearImmediate) ||
                         (this && this.clearImmediate);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4), __webpack_require__(2)))

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(21)
  __webpack_require__(22)
  __webpack_require__(23)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(24),
  /* template */
  __webpack_require__(46),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 21 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 22 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 23 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Reader_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Reader_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Reader_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Settings_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Settings_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Settings_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__event_hub_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    pageNum: {
      type: Number,
      default: 0
    },
    ttlPages: {
      type: Number,
      default: 0
    }
  },
  data: function data() {
    return {
      pageNumber: this.pageNum,
      totalPages: this.ttlPages,
      info: false,
      buyBar: true,
      buyMenu: false,
      socialMenu: false,
      otherBooks: false,
      focused: false,
      dialogBuy: false,
      dialogShare: false,
      notifications: false,
      sound: true,
      widgets: false,
      show: false,
      iSize: 50,
      selectBook: "Books",
      home: this.$route.path,
      drawer: false,
      drawerRight: false,
      items: [],
      books: [],
      booksChanged: '',
      socials: [{
        title: "LinkedIn",
        img: "static/img/linkedin-logo.svg",
        url: "https://www.linkedin.com/shareArticle?mini=true&url=https://textcafe.co/books/pNPbtW/%3F1731381766916&title=Los%20principios%20de%20Jes%C3%BAs&summary=Vive%20una%20vida%20que%20ni%20la%20muerte%20puede%20detener%20Tu%20mayor%20ministerio%20es%20hacia%20las%20personas%20que%20te%20rodean.%20La%20verdadera%20influencia%20deber%EF%BF%BDa%20aumentar%20a%20trav%EF%BF%BDs%20de%20las%20vidas%20de%20aquellos%20en%20quienes%20has%20invertido%2C%20incluso%20despu%EF%BF%BDs%20de%20que%20hayas%20fallecido.%20Nuestro%20mejo&source=LinkedIn",
        icon: "ion-social-linkedin"
      }, {
        title: "Facebook",
        img: "static/img/facebook-logo.svg",
        url: "https://www.facebook.com/sharer/sharer.php?u=https://textcafe.co/books/pNPbtW/%3F1731381766916",
        icon: "ion-social-facebook"
      }, {
        title: "Twitter",
        img: "static/img/twitter-logo-silhouette.svg",
        url: "https://twitter.com/intent/tweet?text=Vive%20una%20vida%20que%20ni%20la%20muerte%20puede%20detener%20Tu%20mayor%20ministerio%20es%20hacia%20las%20personas%20que%20te%20rodean.%20La%20verdadera%20influencia%20deber%EF%BF%BDa%20aumentar%20a%0Dhttps://textcafe.co/books/pNPbtW/%3F1731381766916&amp;via=textcafecom",
        icon: "ion-social-twitter"
      }, {
        title: "Tumblr",
        img: "static/img/tumblr-letter-logo.svg",
        url: "https://www.tumblr.com/widgets/share/tool?canonicalUrl=https://textcafe.co/books/pNPbtW/%3F1731381766916&posttype=link&caption=Vive%20una%20vida%20que%20ni%20la%20muerte%20puede%20detener%20Tu%20mayor%20ministerio%20es%20hacia%20las%20personas%20que%20te%20rodean.%20La%20verdadera%20influencia%20deber%EF%BF%BDa%20aumentar%20a%20trav%EF%BF%BDs%20de%20las%20vidas%20de%20aquellos%20en%20quienes%20has%20invertido%2C%20incluso%20despu%EF%BF%BDs%20de%20que%20hayas%20fallecido.%20Nuestro%20mejo",
        icon: "ion-social-tumblr"
      }, {
        title: "Pinterest",
        img: "static/img/pinterest-logo.svg",
        url: "http://www.pinterest.com/pin/create/button/?url=https://textcafe.co/books/pNPbtW/%3F1731381766916&description=Vive%20una%20vida%20que%20ni%20la%20muerte%20puede%20detener%20Tu%20mayor%20ministerio%20es%20hacia%20las%20personas%20que%20te%20rodean.%20La%20verdadera%20influencia%20deber%EF%BF%BDa%20aumentar%20a%20trav%EF%BF%BDs%20de%20las%20vidas%20de%20aquellos%20en%20quienes%20has%20invertido%2C%20incluso%20despu%EF%BF%BDs%20de%20que%20hayas%20fallecido.%20Nuestro%20mejo&media=https://textcafe.co/books/pNPbtW/tc-custom/9781960436535.jpg",
        icon: "ion-social-pinterest"
      }],
      buys: [{
        title: 'Amazon US',
        img: 'https://textcafe.co/domain-icons/Amazon.com_A_Smile.svg',
        url: 'https://www.amazon.com/s?k=9781960436535&i=stripbooks&linkCode=qs&tag=mobilebookcom-20',
        alt: 'None'
      }, {
        title: 'Google Play',
        img: 'https://textcafe.co/global-css/img/Google_Play_symbol.svg',
        url: 'https://play.google.com/store/books/details?id=ix_9EAAAQBAJ&amp;rdid=book-ix_9EAAAQBAJ&amp;rdot=1&amp;source=gbs_atb&amp;pcampaignid=books_booksearch_atb&gl=us',
        alt: 'None'
      }],
      right: null,
      left: null
    };
  },
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('https://www.textcafe.com/widget/get-samples.json?related=9781960436535').then(function (response) {
      return _this.books = response.data.map(function (item) {
        return {
          title: item.title,
          img: item.coverImagePath,
          url: item.socialUrl,
          alt: "This image is the cover for the book " + item.title
        };
      });
    }).catch(function (error) {
      return (
        // handle error
        console.log(error)
      );
    });
  },

  created: function created() {
    var _this2 = this;

    this.$router.options.routes.forEach(function (route) {
      _this2.items.push({
        path: route.path,
        name: route.name,
        component: route.component,
        //image: "static/img/ilG6Mf.jpg"
        image: '/books/pNPbtW/tc-custom/9781960436535.jpg?1731381766916',
        alt: 'Los principios de Jesús'
      });
    });
    __WEBPACK_IMPORTED_MODULE_2__event_hub_js__["a" /* default */].$on("pageNum", function (newValue) {
      _this2.pageNum = newValue;
    });
    __WEBPACK_IMPORTED_MODULE_2__event_hub_js__["a" /* default */].$on("ttlPages", function (newValue) {
      _this2.ttlPages = newValue;
    });
  },
  watch: {
    $route: function $route(to, from) {
      if (to.path === "/") {
        this.home = this.$route.path;
      } else {
        this.home = null;
      }
    },

    iSize: function iSize(newValue) {
      __WEBPACK_IMPORTED_MODULE_2__event_hub_js__["a" /* default */].$emit("iSizeChanged", newValue);
    },
    books: function books(newValue) {
      __WEBPACK_IMPORTED_MODULE_2__event_hub_js__["a" /* default */].$emit("booksChanged", Date.now());
    }
  },
  methods: {
    resetScroll: function resetScroll() {
      var page = this.$el.querySelector(".book-page");
      page.scrollLeft = 0;
    },
    onBlur: function onBlur() {
      if (this.show === true) {
        this.show = false;
        this.$emit("blur");
      }
    },
    onFocus: function onFocus() {
      if (this.show === false) {
        this.show = true;
        this.$el.querySelector(".book-page").$emit("focus");
      }
    },
    buyClick: function buyClick(url) {
      //const url = '/foo/bar'
      // this.$ga.query('send', 'event', 'outbound', 'click', url, {
      //     transport: 'beacon',
      //     hitCallback () {
      //        //document.location = url
      //     }
      // })
      this.$ga.event({
        eventCategory: 'purchase',
        eventAction: 'click',
        eventLabel: url
        // eventValue: 123
      });
    },
    shareClick: function shareClick(network) {
      this.$ga.event({
        eventCategory: 'share',
        eventAction: 'click',
        eventLabel: network
        // eventValue: 123
      });
    }
  },
  components: {
    settings: __WEBPACK_IMPORTED_MODULE_1__components_Settings_vue___default.a,
    reader: __WEBPACK_IMPORTED_MODULE_0__components_Reader_vue___default.a
  }
});

/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__event_hub_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Settings__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Settings___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Settings__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var SLIDE_TIME = document.documentElement.clientWidth > 480 ? 500 : 300;

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "reader",
  props: {
    value1: {
      type: Number,
      default: 22
    },
    selected: {
      type: String
    },
    ex8: {
      type: String,
      default: "Auto"
    },
    value2: {
      type: Number
    },
    value3: {
      type: Number,
      default: 100
    }
  },
  data: function data() {
    return {
      pageNum: 0,
      pageNumber: 1,
      ttlPages: 0,
      totalPages: 0,
      home: false,
      div: 0,
      prevX: null,
      xDownEnd: null,
      fontSize: this.value1,
      fontFamily: this.selected,
      columns: this.ex8,
      widthSize: this.value2,
      brightness: this.value3,
      currentColor: "#f3f3f3",
      cols: "2 220px",
      position: { scrollTop: 0, scrollLeft: 0 },
      offset: null,
      height: 0,
      isOver: false,
      routeNames: ["home", "cover", "9781960436535", "last"],
      routeTransition: "slide-left",
      rest: true,
      selectedView: "Book1",
      progress: 0,
      hiddenEl: false,
      brandReaderUrl: "",
      brandLogoUrl: "",
      currentUrl: "https://textcafe.co/books/pNPbtW/",
      waiting: false
    };
  },

  created: function created() {
    var _this = this;

    document.addEventListener("mousewheel", this.onScroll, false);
    window.addEventListener('resize', this.resize);
    this.resize();
    this.getTtlPages();

    if (document.documentElement.offsetWidth >= 768) {
      this.hiddenEl = true;
    } else {
      this.hiddenEl = false;
    }

    this.$router.options.routes.forEach(function (route) {
      _this.routeNames.push(route.name);
    });
    __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$on("fontSizeChanged", function (newValue) {
      _this.fontSize = newValue;
    });
    __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$on("fontFamilyChanged", function (newValue) {
      _this.fontFamily = newValue;
    });
    __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$on("columnsCountChanged", function (newValue) {
      _this.columns = newValue;
      if (_this.columns === "Single") {
        _this.cols = "1 auto";
      } else if (_this.columns === "Auto") {
        _this.cols = "2 220px";
      }
    });
    __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$on("widthChanged", function (newValue) {
      _this.widthSize = newValue;
    });
    __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$on("brightnessChanged", function (newValue) {
      _this.brightness = newValue;
    });
  },

  destroyed: function destroyed() {
    document.removeEventListener("mousewheel", this.onScroll, false);
    document.removeEventListener("resize", this.resize, false);
  },
  updated: function updated() {
    this.getTtlPages();
    this.resize();
    var links = document.getElementsByTagName("a");
    for (var i = 0; i < links.length; i++) {
      var that = this;
      var url = "/" + document.location.hash.split("#/")[1];
      if (links[i].href.split("#")[1] === url) {
        links[i].style.textDecoration = "underline";
        links[i].style.textDecorationStyle = "dotted";
        links[i].onclick = function (e) {
          e.preventDefault();
          var refr = this.href.split("#")[2];
          that.linkTo(refr);
        };
      };
    };
  },
  mounted: function mounted() {
    this.resize();

    var links = document.getElementsByTagName("a");
    for (var i = 0; i < links.length; i++) {
      var that = this;
      var url = "/" + document.location.hash.split("#/")[1];
      if (links[i].href.split("#")[1] === url) {
        links[i].style.textDecoration = "underline";
        links[i].style.textDecorationStyle = "dotted";
        links[i].onclick = function (e) {
          e.preventDefault();
          var refr = this.href.split("#")[2];
          that.linkTo(refr);
        };
      };
    };

    this.getTtlPages();

    var bgColor = document.getElementsByClassName("book-content")[0].style.backgroundColor,
        hexDigits = new Array("0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "a", "b", "c", "d", "e", "f");
    function rgb2hex(rgb) {
      rgb = rgb.match(/^rgb\((\d+),\s*(\d+),\s*(\d+)\)$/);
      return "#" + hex(rgb[1]) + hex(rgb[2]) + hex(rgb[3]);
    }
    function hex(x) {
      return isNaN(x) ? "00" : hexDigits[(x - x % 16) / 16] + hexDigits[x % 16];
    }
    this.currentColor = rgb2hex(bgColor);
  },

  watch: {
    $route: function $route(to, from, next) {
      var toDepth = this.routeNames.indexOf(to.name);
      var fromDepth = this.routeNames.indexOf(from.name);
      this.routeTransition = toDepth < fromDepth ? "slide-right" : "slide-left";

      this.progress = 0;
      this.pageNumber = 1;
    },

    pageNum: function pageNum(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("pageNum", newValue);
    },
    ttlPages: function ttlPages(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("ttlPages", newValue);
    }
  },
  methods: {
    resize: function resize() {
      this.height = document.documentElement.clientHeight;
    },
    linkTo: function linkTo(refName) {
      var element = document.getElementById(refName);
      var elementOffset = Math.ceil(element.offsetLeft);
      var page = this.$el.querySelector(".book-page");
      var gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10);
      var onStart = Math.ceil(page.scrollLeft);
      var destinationOffset = Math.floor(elementOffset / (page.offsetWidth + gap));
      var target = destinationOffset * (page.offsetWidth + gap) - onStart;
      if (destinationOffset + 1 !== this.pageNumber) {
        this.scrollIt(target, 300, "easeOutQuad", false);
        var scrollArea = page.scrollWidth - page.offsetWidth;
        var pctScrolled = Math.floor(destinationOffset * (page.offsetWidth + gap) / scrollArea * 100);
        this.progress = pctScrolled;
        this.pageNumber = destinationOffset + 1;
      }
    },
    getTtlPages: function getTtlPages() {
      this.$nextTick(function () {
        var page = this.$el.querySelector(".book-page");

        var gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10);

        var scrollArea = page.scrollWidth - page.offsetWidth;
        var ttlPages = Math.round(scrollArea / (page.offsetWidth + gap));
        this.ttlPages = ttlPages;
        this.totalPages = this.ttlPages + 1;
      });
    },
    tapped: function tapped() {
      var el = this.$el.querySelector(".touch-swipe");
      this.hiddenEl = !this.hiddenEl;
    },
    tappedIn: function tappedIn() {
      var el = this.$el.querySelector(".touch-swipe");
      this.hiddenEl = !this.hiddenEl;
    },
    scrollIt: function scrollIt(destination) {
      var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 200;

      var _this2 = this;

      var easing = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "easeInOutQuart";
      var callback = arguments[3];

      var easings = {
        linear: function linear(t) {
          return t;
        },
        easeInQuad: function easeInQuad(t) {
          return t * t;
        },
        easeOutQuad: function easeOutQuad(t) {
          return t * (2 - t);
        },
        easeInOutQuad: function easeInOutQuad(t) {
          return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
        },
        easeInCubic: function easeInCubic(t) {
          return t * t * t;
        },
        easeOutCubic: function easeOutCubic(t) {
          return --t * t * t + 1;
        },
        easeInOutCubic: function easeInOutCubic(t) {
          return t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
        },
        easeInQuart: function easeInQuart(t) {
          return t * t * t * t;
        },
        easeOutQuart: function easeOutQuart(t) {
          return 1 - --t * t * t * t;
        },
        easeInOutQuart: function easeInOutQuart(t) {
          return t < 0.5 ? 8 * t * t * t * t : 1 - 8 * --t * t * t * t;
        },
        easeInQuint: function easeInQuint(t) {
          return t * t * t * t * t;
        },
        easeOutQuint: function easeOutQuint(t) {
          return 1 + --t * t * t * t * t;
        },
        easeInOutQuint: function easeInOutQuint(t) {
          return t < 0.5 ? 16 * t * t * t * t * t : 1 + 16 * --t * t * t * t * t;
        }
      };

      var page = this.$el.querySelector(".book-page");
      var gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10),
          offset = page.offsetWidth + gap;

      var start = Math.ceil(page.scrollLeft);

      var startTime = "now" in window.performance ? performance.now() : new Date().getTime();

      var documentWidth = Math.max(page.scrollWidth || page.offsetWidth || page.clientWidth);

      var windowWidth = window.innerWidth || window.clientWidth;

      var destinationOffsetToScroll = start + destination;

      function scroll() {
        var now = "now" in window.performance ? performance.now() : new Date().getTime();
        var time = Math.min(1, (now - startTime) / duration);
        var timeFunction = easings[easing](time);
        page.scroll(Math.ceil(timeFunction * (destinationOffsetToScroll - start) + start), 0);
        if (timeFunction === 1 || start === destinationOffsetToScroll) {
          if (callback) {
            callback();
          }
          return;
        }
        requestAnimationFrame(scroll);
      }
      scroll();
      setTimeout(function () {
        _this2.waiting = false;
      }, 250);
    },


    next: function next(e) {
      var el = this.$el.querySelector(".touch-swipe");
      if (el) el.style.pointerEvents = "auto";
      var book = this.$el.querySelector(".book-content");
      var page = this.$el.querySelector(".book-page"),
          gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10),
          offset = page.offsetWidth + gap,
          index = this.routeNames.indexOf(this.$route.name);

      var scrollArea = page.scrollWidth - page.offsetWidth;
      var windowWidth = window.innerWidth || window.clientWidth;
      var trackLength = scrollArea - (page.offsetWidth + gap);

      // var pageNum = Math.floor(page.scrollLeft / (page.offsetWidth + gap));
      var scrollLeft = Math.ceil(page.scrollLeft);
      var pageNum = Math.floor(scrollLeft / (page.offsetWidth + gap));

      this.pageNum = pageNum;

      pageNum += 1;

      this.pageNumber += 1;

      if (page.scrollWidth - (scrollLeft + page.offsetWidth) !== 0 && pctScrolled !== 100) {
        var currentPage = Math.floor(pageNum * (page.offsetWidth + gap));

        var nextPage = Math.floor(pageNum * (page.offsetWidth + gap));

        var destination = nextPage - scrollLeft;

        this.scrollIt(destination, 300, "easeOutQuad", false);
      } else {
        this.$router.push({ name: this.routeNames[index + 1] });

        this.pageNumber = 1;
        pageNum = 0;
        var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
        this.progress = pctScrolled;
      }
      var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
      this.progress = pctScrolled;
    },
    prev: function prev(e) {
      var el = this.$el.querySelector(".touch-swipe");
      if (el) el.style.pointerEvents = "auto";

      var page = this.$el.querySelector(".book-page"),
          gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10),
          offset = page.offsetWidth + gap,
          index = this.routeNames.indexOf(this.$route.name);

      var scrollArea = page.scrollWidth - page.offsetWidth;

      var scrollLeft = Math.ceil(page.scrollLeft);
      var pageNum = Math.round(scrollLeft / (page.offsetWidth + gap));
      var ttlPages = Math.round(scrollArea / (page.offsetWidth + gap));

      this.pageNum = pageNum;

      this.pageNumber -= 1;

      var currentPage = Math.floor(pageNum * (page.offsetWidth + gap));

      if (scrollLeft !== 0 && pageNum !== 0) {
        var pageNum = Math.round(scrollLeft / (page.offsetWidth + gap));
        var pageNumber = Math.floor(scrollLeft / (page.offsetWidth + gap));

        pageNum -= 1;
        var prevPage = Math.floor(pageNum * (page.offsetWidth + gap));

        var destination = -1 * (scrollLeft - prevPage);

        this.scrollIt(destination, 300, "easeOutQuad", false);
      } else {
        this.$router.push({ name: this.routeNames[index - 1] });

        this.pageNumber = 1;

        pageNum = 0;
        var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
        this.progress = pctScrolled;
      }
      var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
      this.progress = pctScrolled;
    },
    over: function over() {
      this.isOver = true;
    },
    out: function out() {
      this.isOver = false;
    },
    onScroll: function onScroll(e, position) {
      this.position = position;
      if (this.isOver === true) {
        var page = this.$el.querySelector(".book-page"),
            gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10),
            deltaX = Math.max(-1, Math.min(1, e.wheelDelta || -e.detail)),
            end = page.scrollWidth - (page.scrollLeft + page.offsetWidth),
            offset = page.offsetWidth + gap;

        var scrollArea = page.scrollWidth - page.offsetWidth;
        var pageNum = Math.round(page.scrollLeft / (page.offsetWidth + gap));

        var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
        this.progress = pctScrolled;

        if (deltaX === 1) {
          if (page.scrollLeft !== 0) {
            if (this.waiting) {
              return;
            }
            this.waiting = true;

            pageNum -= 1;

            this.pageNumber -= 1;
            var prevPage = Math.floor(pageNum * (page.offsetWidth + gap));

            var destination = -1 * (page.scrollLeft - prevPage);

            this.scrollIt(destination, 300, "easeOutQuad", false);

            var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
            this.progress = pctScrolled;
          }
        } else if (deltaX === -1) {
          if (page.scrollWidth - (page.scrollLeft + page.offsetWidth) !== 0) {
            if (this.waiting) {
              return;
            }
            this.waiting = true;

            pageNum += 1;

            this.pageNumber += 1;
            var nextPage = Math.floor(pageNum * (page.offsetWidth + gap));

            var destination = nextPage - page.scrollLeft;

            this.scrollIt(destination, 300, "easeOutQuad", false);

            var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
            this.progress = pctScrolled;
          }
        }
      } else {
        return;
      }
    },
    fadeIn: function fadeIn() {
      var page = this.$el.querySelector(".book-page");
      page.style.opacity = 0;
      var last = +new Date();
      var tick = function tick() {
        page.style.opacity = +page.style.opacity + (new Date() - last) / 400;
        last = +new Date();
        if (+page.style.opacity < 1) {
          window.requestAnimationFrame && requestAnimationFrame(tick) || setTimeout(tick, 16);
        }
      };
      tick();
    },

    resetScroll: function resetScroll() {
      var page = this.$el.querySelector(".book-page");
      page.scrollLeft = 0;
    }
  },
  computed: {
    isMobile: function isMobile() {
      var check = false;
      (function (a) {
        if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true;
      })(navigator.userAgent || navigator.vendor || window.opera);
      return check;
    }
  },
  components: {
    Settings: __WEBPACK_IMPORTED_MODULE_1__components_Settings___default.a
  }
});

/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__event_hub_js__ = __webpack_require__(5);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: "settings",
  data: function data() {
    return {
      events: [],
      value1: 22,
      value2: 70,
      value3: 100,
      ex8: "Auto",
      selected: "Old-Cabin",
      fonts: ["Old-Cabin", "Raleway-Bitter", "Ubuntu-Abel", "Droid-Abril", "Garamond-Clicker", "Alice-Playfair", "Judson-Quando"],
      classes: ["white", "black", "sepia"]
    };
  },

  watch: {
    value1: function value1(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("fontSizeChanged", newValue);
    },
    selected: function selected(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("fontFamilyChanged", newValue);
    },
    ex8: function ex8(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("columnsCountChanged", newValue);
    },
    value2: function value2(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("widthChanged", newValue);
    },
    value3: function value3(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("brightnessChanged", newValue);
    }
  },
  methods: {
    reloadBook: function reloadBook() {
      window.location.reload(true);
    },
    changeClassWhite: function changeClassWhite() {
      var el = document.getElementsByClassName("book-content")[0];
      var el2 = document.getElementsByClassName("nav-btn")[0];
      var el3 = document.getElementsByClassName("nav-btn")[1];
      var el4 = document.getElementsByTagName("footer")[0];
      console.log(document.getElementsByTagName("footer")[0]);
      if (el.classList && el2.classList && el3.classList && el4.classList) {
        el.classList.remove("black");
        el2.classList.remove("black");
        el3.classList.remove("black");
        el4.classList.remove("black");
        el.classList.remove("sepia");
        el2.classList.remove("sepia");
        el3.classList.remove("sepia");
        el4.classList.remove("sepia");
        el.classList.add("white");
        el2.classList.add("white");
        el3.classList.add("white");
        el4.classList.add("white");
      } else {
        el.className += " white";
        el2.className += " white";
        el3.className += " white";
        el4.className += " white";
      }
    },
    changeClassBlack: function changeClassBlack() {
      var el = document.getElementsByClassName("book-content")[0];
      var el2 = document.getElementsByClassName("nav-btn")[0];
      var el3 = document.getElementsByClassName("nav-btn")[1];
      var el4 = document.getElementsByTagName("footer")[0];
      if (el.classList && el2.classList && el3.classList && el4.classList) {
        el.classList.remove("white");
        el2.classList.remove("white");
        el3.classList.remove("white");
        el4.classList.remove("white");
        el.classList.remove("sepia");
        el2.classList.remove("sepia");
        el3.classList.remove("sepia");
        el4.classList.remove("sepia");
        el.classList.add("black");
        el2.classList.add("black");
        el3.classList.add("black");
        el4.classList.add("black");
      } else {
        el.className += " black";
        el2.className += " black";
        el3.className += " black";
        el4.className += " black";
      }
    },
    changeClassSepia: function changeClassSepia() {
      var el = document.getElementsByClassName("book-content")[0];
      var el2 = document.getElementsByClassName("nav-btn")[0];
      var el3 = document.getElementsByClassName("nav-btn")[1];
      var el4 = document.getElementsByTagName("footer")[0];
      if (el.classList && el2.classList && el3.classList && el4.classList) {
        el.classList.remove("black");
        el2.classList.remove("black");
        el3.classList.remove("black");
        el4.classList.remove("black");
        el.classList.remove("white");
        el2.classList.remove("white");
        el3.classList.remove("white");
        el4.classList.remove("white");
        el.classList.add("sepia");
        el2.classList.add("sepia");
        el3.classList.add("sepia");
        el4.classList.add("sepia");
      } else {
        el.className += " sepia";
        el2.className += " sepia";
        el3.className += " sepia";
        el4.className += " sepia";
      }
    }
  }
});

/***/ }),
/* 27 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "settings"
  }, [_c('ul', {
    staticClass: "settings-list"
  }, [_c('li', [_c('span', [_vm._v("Reload book: ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "id": "reloadBookBtn",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.reloadBook()
      }
    }
  }, [_c('v-icon', [_vm._v("ion-ios-loop-strong")])], 1)], 1), _vm._v(" "), _c('li', [_c('span', [_vm._v("Font:")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "items": _vm.fonts,
      "overflow": "",
      "single-line": "",
      "return-objectauto": "",
      "append-icon": "ion-ios-arrow-down",
      "hide-details": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawerRight = true
      }
    },
    model: {
      value: (_vm.selected),
      callback: function($$v) {
        _vm.selected = $$v
      },
      expression: "selected"
    }
  })], 1), _vm._v(" "), _c('li', [_c('span', [_vm._v("Font size:")]), _vm._v(" "), _c('p', {
    staticClass: "bold-font",
    domProps: {
      "innerHTML": _vm._s(_vm.value1 + 'px' || null)
    }
  }), _vm._v(" "), _c('v-slider', {
    attrs: {
      "min": 17,
      "max": 27,
      "step": 1
    },
    model: {
      value: (_vm.value1),
      callback: function($$v) {
        _vm.value1 = $$v
      },
      expression: "value1"
    }
  })], 1), _vm._v(" "), _c('li', {
    staticClass: "columns-setting"
  }, [_c('span', [_vm._v("Page columns:")]), _c('br'), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "Auto",
      "value": "Auto",
      "flat": "",
      "ripple": false,
      "prepend-icon": ""
    },
    model: {
      value: (_vm.ex8),
      callback: function($$v) {
        _vm.ex8 = $$v
      },
      expression: "ex8"
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "Single",
      "value": "Single",
      "flat": "",
      "ripple": false,
      "prepend-icon": ""
    },
    model: {
      value: (_vm.ex8),
      callback: function($$v) {
        _vm.ex8 = $$v
      },
      expression: "ex8"
    }
  })], 1), _vm._v(" "), _c('li', {
    staticClass: "width-setting"
  }, [_c('span', [_vm._v("Page width:")]), _vm._v(" "), _c('p', {
    staticClass: "bold-font",
    domProps: {
      "innerHTML": _vm._s(_vm.value2 + '%' || null)
    }
  }), _vm._v(" "), _c('v-slider', {
    attrs: {
      "min": 50,
      "max": 90
    },
    model: {
      value: (_vm.value2),
      callback: function($$v) {
        _vm.value2 = $$v
      },
      expression: "value2"
    }
  })], 1), _vm._v(" "), _c('li', [_c('span', [_vm._v("Brightness:")]), _vm._v(" "), _c('p', {
    staticClass: "bold-font",
    domProps: {
      "innerHTML": _vm._s((_vm.value3 - 100) + '%' || null)
    }
  }), _vm._v(" "), _c('v-slider', {
    attrs: {
      "step": 1,
      "min": 0,
      "max": 200
    },
    model: {
      value: (_vm.value3),
      callback: function($$v) {
        _vm.value3 = $$v
      },
      expression: "value3"
    }
  })], 1), _vm._v(" "), _c('li', [_c('span', [_vm._v("Color mode:")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    attrs: {
      "id": "colors"
    }
  }, [_c('v-btn', {
    attrs: {
      "flat": "",
      "id": "white",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.changeClassWhite()
      }
    }
  }, [_vm._v("\n          White\n        ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "id": "black",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.changeClassBlack()
      }
    }
  }, [_vm._v("\n          Black\n        ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "id": "sepia",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.changeClassSepia()
      }
    }
  }, [_vm._v("\n          Sepia\n        ")])], 1)])])])
},staticRenderFns: []}

/***/ }),
/* 28 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrap",
    style: ({
      'filter': 'brightness(' + _vm.brightness + '%)',
      'height': _vm.height - 49 + 'px'
    })
  }, [_c('v-progress-linear', {
    model: {
      value: (_vm.progress),
      callback: function($$v) {
        _vm.progress = $$v
      },
      expression: "progress"
    }
  }), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "shortkey",
      rawName: "v-shortkey",
      value: (['arrowleft']),
      expression: "['arrowleft']"
    }],
    staticClass: "nav-btn left",
    style: ({
      width: (100 - _vm.widthSize) + '%'
    }),
    attrs: {
      "ripple": false
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.prev($event)
      },
      "shortkey": _vm.prev
    }
  }, [_c('v-icon', {
    style: ({
      'left': (_vm.widthSize / 3.5) + '%'
    })
  }, [_vm._v("ion-ios-arrow-left")])], 1), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "shortkey",
      rawName: "v-shortkey",
      value: (['arrowright']),
      expression: "['arrowright']"
    }],
    staticClass: "nav-btn right",
    style: ({
      width: (100 - _vm.widthSize) + '%'
    }),
    attrs: {
      "ripple": false
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.next($event)
      },
      "shortkey": _vm.next
    }
  }, [_c('v-icon', {
    style: ({
      'right': (_vm.widthSize / 3.5) + '%'
    })
  }, [_vm._v("ion-ios-arrow-right")])], 1), _vm._v(" "), _c('div', {
    staticClass: "book-content",
    style: ({
      'width': _vm.widthSize + '%',
      'background-color': _vm.currentColor,
      'height': _vm.height - 78 + 'px'
    }),
    on: {
      "mouseenter": _vm.over,
      "mouseleave": _vm.out
    }
  }, [(_vm.isMobile) ? _c('v-touch', {
    staticClass: "touch-swipe",
    class: {
      active: _vm.hiddenEl
    },
    on: {
      "swipeleft": _vm.next,
      "swiperight": _vm.prev,
      "tap": _vm.tapped
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    key: _vm.div,
    staticClass: "book-page",
    class: _vm.fontFamily,
    style: ({
      'font-size': _vm.fontSize + 'px',
      'columns': _vm.cols
    }),
    attrs: {
      "enable-resize-watcher": ""
    },
    on: {
      "tap": _vm.tappedIn,
      "swipe": _vm.tappedIn,
      "click": _vm.tappedIn
    }
  }, [_c('transition', {
    attrs: {
      "name": _vm.routeTransition,
      "mode": "out-in"
    }
  }, [_c('router-view', {
    key: _vm.$route.name,
    staticClass: "view"
  })], 1)], 1)], 1), _vm._v(" "), _c('footer', {
    class: _vm.fontFamily,
    style: ({
      'font-size': (_vm.fontSize - 5) + 'px'
    })
  }, [(_vm.brandReaderUrl) ? _c('div', [_c('v-btn', {
    staticClass: "HC-footer-button",
    attrs: {
      "flat": "",
      "ripple": false,
      "tag": "a",
      "href": _vm.brandReaderUrl,
      "target": "_blank"
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawer = false, _vm.info = false, _vm.buyMenu = false, _vm.socialMenu = false, _vm.drawerRight = false, _vm.otherBooks = false
      }
    }
  }, [_c('i', [_c('img', {
    attrs: {
      "src": _vm.brandLogoUrl
    }
  })])])], 1) : _vm._e(), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('div', {
    staticClass: "foots"
  }, [_c('span', [_c('em', [_vm._v(_vm._s(this.$route.name))])]), _vm._v(" - page "), _c('span', [_c('em', [_vm._v(_vm._s(this.pageNumber))])]), _vm._v(" "), (this.totalPages > 1) ? _c('span', [_c('em', [_vm._v(_vm._s("/ " + this.totalPages))])]) : _vm._e()]), _vm._v(" "), _c('v-spacer')], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(30);

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(0);
var bind = __webpack_require__(8);
var Axios = __webpack_require__(31);
var mergeConfig = __webpack_require__(14);
var defaults = __webpack_require__(11);

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Factory for creating new instances
axios.create = function create(instanceConfig) {
  return createInstance(mergeConfig(axios.defaults, instanceConfig));
};

// Expose Cancel & CancelToken
axios.Cancel = __webpack_require__(15);
axios.CancelToken = __webpack_require__(44);
axios.isCancel = __webpack_require__(10);

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__(45);

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports.default = axios;


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(0);
var buildURL = __webpack_require__(9);
var InterceptorManager = __webpack_require__(32);
var dispatchRequest = __webpack_require__(33);
var mergeConfig = __webpack_require__(14);

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = arguments[1] || {};
    config.url = arguments[0];
  } else {
    config = config || {};
  }

  config = mergeConfig(this.defaults, config);

  // Set config.method
  if (config.method) {
    config.method = config.method.toLowerCase();
  } else if (this.defaults.method) {
    config.method = this.defaults.method.toLowerCase();
  } else {
    config.method = 'get';
  }

  // Hook up interceptors middleware
  var chain = [dispatchRequest, undefined];
  var promise = Promise.resolve(config);

  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    chain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    chain.push(interceptor.fulfilled, interceptor.rejected);
  });

  while (chain.length) {
    promise = promise.then(chain.shift(), chain.shift());
  }

  return promise;
};

Axios.prototype.getUri = function getUri(config) {
  config = mergeConfig(this.defaults, config);
  return buildURL(config.url, config.params, config.paramsSerializer).replace(/^\?/, '');
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, data, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

module.exports = Axios;


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(0);

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(0);
var transformData = __webpack_require__(34);
var isCancel = __webpack_require__(10);
var defaults = __webpack_require__(11);

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData(
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData(
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData(
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(0);

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn(data, headers);
  });

  return data;
};


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(0);

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var createError = __webpack_require__(13);

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  if (!validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError(
      'Request failed with status code ' + response.status,
      response.config,
      null,
      response.request,
      response
    ));
  }
};


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */
module.exports = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }

  error.request = request;
  error.response = response;
  error.isAxiosError = true;

  error.toJSON = function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: this.config,
      code: this.code
    };
  };
  return error;
};


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isAbsoluteURL = __webpack_require__(39);
var combineURLs = __webpack_require__(40);

/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */
module.exports = function buildFullPath(baseURL, requestedURL) {
  if (baseURL && !isAbsoluteURL(requestedURL)) {
    return combineURLs(baseURL, requestedURL);
  }
  return requestedURL;
};


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(0);

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(0);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
    (function standardBrowserEnv() {
      var msie = /(msie|trident)/i.test(navigator.userAgent);
      var urlParsingNode = document.createElement('a');
      var originURL;

      /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
      function resolveURL(url) {
        var href = url;

        if (msie) {
        // IE needs attribute set twice to normalize properties
          urlParsingNode.setAttribute('href', href);
          href = urlParsingNode.href;
        }

        urlParsingNode.setAttribute('href', href);

        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
          href: urlParsingNode.href,
          protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
          host: urlParsingNode.host,
          search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
          hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
          hostname: urlParsingNode.hostname,
          port: urlParsingNode.port,
          pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
            urlParsingNode.pathname :
            '/' + urlParsingNode.pathname
        };
      }

      originURL = resolveURL(window.location.href);

      /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
      return function isURLSameOrigin(requestURL) {
        var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
        return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
      };
    })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return function isURLSameOrigin() {
        return true;
      };
    })()
);


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(0);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
    (function standardBrowserEnv() {
      return {
        write: function write(name, value, expires, path, domain, secure) {
          var cookie = [];
          cookie.push(name + '=' + encodeURIComponent(value));

          if (utils.isNumber(expires)) {
            cookie.push('expires=' + new Date(expires).toGMTString());
          }

          if (utils.isString(path)) {
            cookie.push('path=' + path);
          }

          if (utils.isString(domain)) {
            cookie.push('domain=' + domain);
          }

          if (secure === true) {
            cookie.push('secure');
          }

          document.cookie = cookie.join('; ');
        },

        read: function read(name) {
          var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
          return (match ? decodeURIComponent(match[3]) : null);
        },

        remove: function remove(name) {
          this.write(name, '', Date.now() - 86400000);
        }
      };
    })() :

  // Non standard browser env (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return {
        write: function write() {},
        read: function read() { return null; },
        remove: function remove() {}
      };
    })()
);


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Cancel = __webpack_require__(15);

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};


/***/ }),
/* 46 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', {
    attrs: {
      "toolbar": ""
    }
  }, [_c('v-dialog', {
    attrs: {
      "fullscreen": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.info = !_vm.info
      }
    },
    model: {
      value: (_vm.info),
      callback: function($$v) {
        _vm.info = $$v
      },
      expression: "info"
    }
  }, [_c('v-card', {
    staticClass: "infoDialog"
  }, [_c('div', {
    staticClass: "menuIns"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-navicon")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-ios-browsers-outline")])], 1), _vm._v(" "), _c('div', {
    staticClass: "menuInsTip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Contents")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Navigate to book chapters")])]), _vm._v(" "), _c('div', {
    staticClass: "menuInsTip2"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Related Books")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Other books you might like")])]), _vm._v(" "), _c('div', {
    staticClass: "socMenu"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-social-linkedin")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-social-facebook")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-social-twitter")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-social-tumblr")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-social-pinterest")])], 1), _vm._v(" "), _c('div', {
    staticClass: "socMenuMob"
  }, [_c('v-icon', [_vm._v("ion-android-share-alt")])], 1), _vm._v(" "), _c('div', {
    staticClass: "socMenuTip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Share Book")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Share book to your social network")])]), _vm._v(" "), _c('div', {
    staticClass: "resize-settings"
  }, [_c('v-icon', [_vm._v("ion-ios-gear-outline")])], 1), _vm._v(" "), _c('div', {
    staticClass: "resize-settings-tip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Settings button")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Change colors and fonts")])]), _vm._v(" "), _c('div', {
    staticClass: "left-button"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-ios-arrow-left")])], 1), _vm._v(" "), _c('div', {
    staticClass: "left-button-tip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Left/Previous")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Go to previous page or chapter in book view."), _c('br'), _vm._v("On touch screen swipe right.")])]), _vm._v(" "), _c('div', {
    staticClass: "right-button"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-ios-arrow-right")])], 1), _vm._v(" "), _c('div', {
    staticClass: "right-button-tip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Right/Next")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Go to next page or chapter in book view."), _c('br'), _vm._v("On touch screen swipe left.")])]), _vm._v(" "), _c('div', {
    staticClass: "buy-buttons"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-bag")])], 1), _vm._v(" "), _c('div', {
    staticClass: "buy-buttons-mob"
  }, [_c('v-icon', [_vm._v("ion-bag")])], 1), _vm._v(" "), _c('div', {
    staticClass: "buy-buttons-tip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Buy Book")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Click to stores where you can buy this book")])]), _vm._v(" "), _c('div', {
    staticClass: "headline"
  }, [_vm._v("Instructions")]), _vm._v(" "), _c('v-btn', {
    staticClass: "closeDialog",
    attrs: {
      "flat": "",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.info = false
      }
    }
  }, [_vm._v("Close")])], 1)], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "menu",
    attrs: {
      "temporary": "",
      "hide-overlay": "",
      "clipped": "",
      "enable-resize-watcher": "",
      "disable-route-watcher": "",
      "touchless": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawer = !_vm.drawer
      }
    },
    model: {
      value: (_vm.drawer),
      callback: function($$v) {
        _vm.drawer = $$v
      },
      expression: "drawer"
    }
  }, [_c('v-list', _vm._l((_vm.items), function(item) {
    return _c('v-list-tile', {
      key: item.name,
      attrs: {
        "href": item.path,
        "to": item.path,
        "exact": "",
        "ripple": false,
        "width": "100%"
      }
    }, [_c('v-list-tile-action', [_c('img', {
      attrs: {
        "height": "55px",
        "alt": item.alt,
        "src": item.image
      }
    })]), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
      attrs: {
        "active": ""
      }
    }, [_vm._v(_vm._s(item.name))])], 1)], 1)
  }), 1)], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "otherBooks",
    attrs: {
      "temporary": "",
      "hide-overlay": "",
      "clipped": "",
      "enable-resize-watcher": "",
      "disable-route-watcher": "",
      "touchless": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.otherBooks = !_vm.otherBooks
      }
    },
    model: {
      value: (_vm.otherBooks),
      callback: function($$v) {
        _vm.otherBooks = $$v
      },
      expression: "otherBooks"
    }
  }, [_c('v-list', [_c('h6', [_vm._v("Other books you might like:")]), _vm._v(" "), _vm._l((_vm.books), function(book) {
    return _c('v-list-tile', {
      key: book.title,
      attrs: {
        "href": book.url,
        "target": "_blank",
        "ripple": false,
        "width": "100%"
      }
    }, [_c('v-list-tile-action', [_c('img', {
      attrs: {
        "alt": book.alt,
        "src": book.img
      }
    })]), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
      attrs: {
        "active": ""
      }
    }, [_vm._v(_vm._s(book.title))])], 1)], 1)
  })], 2)], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "settings-drawer",
    attrs: {
      "temporary": "",
      "hide-overlay": "",
      "clipped": "",
      "right": "",
      "enable-resize-watcher": "",
      "touchless": ""
    },
    model: {
      value: (_vm.drawerRight),
      callback: function($$v) {
        _vm.drawerRight = $$v
      },
      expression: "drawerRight"
    }
  }, [_c('v-list', [_c('settings')], 1)], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "mini-bar",
    attrs: {
      "mini-variant": "",
      "enable-resize-watcher": "",
      "touchless": ""
    },
    model: {
      value: (_vm.buyBar),
      callback: function($$v) {
        _vm.buyBar = $$v
      },
      expression: "buyBar"
    }
  }, [_c('v-list', {
    attrs: {
      "ripple": false
    }
  }, [_vm._v("Shop:\n      "), _vm._l((_vm.buys), function(buy) {
    return _c('v-list-tile', {
      key: buy.title,
      attrs: {
        "href": buy.url,
        "target": "_blank"
      },
      on: {
        "click": function($event) {
          return _vm.buyClick(buy.url)
        }
      }
    }, [_c('img', {
      attrs: {
        "alt": buy.alt,
        "src": buy.img
      }
    })])
  })], 2)], 1), _vm._v(" "), _c('v-toolbar', {
    staticClass: "main-menu",
    attrs: {
      "fixed": "",
      "persistent": ""
    }
  }, [_c('v-btn', {
    staticClass: "main-menu-button",
    attrs: {
      "flat": "",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawer = !_vm.drawer, _vm.info = false, _vm.buyMenu = false, _vm.socialMenu = false, _vm.drawerRight = false, _vm.otherBooks = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-navicon")])], 1), _vm._v(" "), (_vm.books.length > 0) ? _c('v-btn', {
    key: _vm.booksChanged,
    staticClass: "otherBooks-button",
    attrs: {
      "flat": "",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.otherBooks = !_vm.otherBooks, _vm.info = false, _vm.buyMenu = false, _vm.socialMenu = false, _vm.drawerRight = false, _vm.drawer = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-ios-browsers-outline")])], 1) : _vm._e(), _vm._v(" "), _c('v-toolbar', {
    staticClass: "desktop-social-btn",
    staticStyle: {
      "margin-left": "5%"
    }
  }, _vm._l((_vm.socials), function(social) {
    return _c('v-btn', {
      key: social.title,
      attrs: {
        "flat": "",
        "href": social.url,
        "target": "_blank",
        "ripple": false
      },
      on: {
        "click": function($event) {
          return _vm.shareClick(social.title)
        }
      }
    }, [_c('v-icon', [_vm._v(_vm._s(social.icon))])], 1)
  }), 1), _vm._v(" "), _c('v-btn', {
    staticClass: "mobile-buy-btn",
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.buyMenu = !_vm.buyMenu, _vm.info = false, _vm.drawer = false, _vm.socialMenu = false, _vm.drawerRight = false, _vm.otherBooks = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-bag")])], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "buy-menu",
    attrs: {
      "width": "100vw",
      "height": "auto",
      "hide-overlay": "",
      "temporary": "",
      "clipped": "",
      "disable-route-watcher": "",
      "touchless": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.buyMenu = !_vm.buyMenu
      }
    },
    model: {
      value: (_vm.buyMenu),
      callback: function($$v) {
        _vm.buyMenu = $$v
      },
      expression: "buyMenu"
    }
  }, [_c('v-list', [_c('span', [_vm._v("Purchase this book: ")]), _vm._v(" "), _vm._l((_vm.buys), function(buy) {
    return _c('v-list-tile', {
      key: buy.title,
      attrs: {
        "href": buy.url,
        "target": "_blank"
      },
      on: {
        "click": function($event) {
          return _vm.buyClick(buy.url)
        }
      }
    }, [_c('v-list-tile-action', [_c('img', {
      attrs: {
        "alt": buy.alt,
        "src": buy.img
      }
    })]), _vm._v(" "), _c('v-list-tile-title', {
      domProps: {
        "innerHTML": _vm._s(buy.title)
      }
    })], 1)
  })], 2)], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "mobile-social-btn",
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.socialMenu = !_vm.socialMenu, _vm.info = false, _vm.buyMenu = false, _vm.drawer = false, _vm.drawerRight = false, _vm.otherBooks = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-android-share-alt")])], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "social-menu",
    attrs: {
      "width": "100vw",
      "height": "auto",
      "hide-overlay": "",
      "temporary": "",
      "clipped": "",
      "disable-route-watcher": "",
      "persistent": "",
      "touchless": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.socialMenu = !_vm.socialMenu
      }
    },
    model: {
      value: (_vm.socialMenu),
      callback: function($$v) {
        _vm.socialMenu = $$v
      },
      expression: "socialMenu"
    }
  }, [_c('v-list', [_c('span', [_vm._v("Share this book: ")]), _vm._v(" "), _vm._l((_vm.socials), function(social) {
    return _c('v-list-tile', {
      key: social.title,
      attrs: {
        "href": social.url,
        "target": "_blank"
      },
      on: {
        "click": function($event) {
          return _vm.shareClick(social.title)
        }
      }
    }, [_c('v-list-tile-action', [_c('v-icon', [_vm._v(_vm._s(social.icon))])], 1), _vm._v(" "), _c('v-list-tile-title', {
      domProps: {
        "innerHTML": _vm._s(social.title)
      }
    })], 1)
  })], 2)], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "info-btn",
    attrs: {
      "flat": "",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.info = !_vm.info, _vm.drawer = false, _vm.buyMenu = false, _vm.socialMenu = false, _vm.drawerRight = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-ios-information-outline")])], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "settings-button",
    attrs: {
      "flat": "",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawerRight = !_vm.drawerRight, _vm.info = false, _vm.buyMenu = false, _vm.socialMenu = false, _vm.drawer = false, _vm.otherBooks = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-ios-gear-outline")])], 1)], 1), _vm._v(" "), _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('reader')], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Reader__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Reader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Reader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_home__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_home___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_home__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_cover__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_cover___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_cover__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_9781960436535__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_9781960436535___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_9781960436535__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_last__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_last___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_last__);
/*jshint esversion: 6 */









__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    "path": "/",
    "name": "home",
    "component": __WEBPACK_IMPORTED_MODULE_3__components_home___default.a
  }, {
    "path": "/cover",
    "name": "cover",
    "component": __WEBPACK_IMPORTED_MODULE_4__components_cover___default.a
  }, {
    "path": "/9781960436535",
    "name": "9781960436535",
    "component": __WEBPACK_IMPORTED_MODULE_5__components_9781960436535___default.a
  }, {
    "path": "/last",
    "name": "last",
    "component": __WEBPACK_IMPORTED_MODULE_6__components_last___default.a
  }]
}));

/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
  * vue-router v2.8.1
  * (c) 2017 Evan You
  * @license MIT
  */
/*  */

function assert (condition, message) {
  if (!condition) {
    throw new Error(("[vue-router] " + message))
  }
}

function warn (condition, message) {
  if (false) {
    typeof console !== 'undefined' && console.warn(("[vue-router] " + message));
  }
}

function isError (err) {
  return Object.prototype.toString.call(err).indexOf('Error') > -1
}

var View = {
  name: 'router-view',
  functional: true,
  props: {
    name: {
      type: String,
      default: 'default'
    }
  },
  render: function render (_, ref) {
    var props = ref.props;
    var children = ref.children;
    var parent = ref.parent;
    var data = ref.data;

    data.routerView = true;

    // directly use parent context's createElement() function
    // so that components rendered by router-view can resolve named slots
    var h = parent.$createElement;
    var name = props.name;
    var route = parent.$route;
    var cache = parent._routerViewCache || (parent._routerViewCache = {});

    // determine current view depth, also check to see if the tree
    // has been toggled inactive but kept-alive.
    var depth = 0;
    var inactive = false;
    while (parent && parent._routerRoot !== parent) {
      if (parent.$vnode && parent.$vnode.data.routerView) {
        depth++;
      }
      if (parent._inactive) {
        inactive = true;
      }
      parent = parent.$parent;
    }
    data.routerViewDepth = depth;

    // render previous view if the tree is inactive and kept-alive
    if (inactive) {
      return h(cache[name], data, children)
    }

    var matched = route.matched[depth];
    // render empty node if no matched route
    if (!matched) {
      cache[name] = null;
      return h()
    }

    var component = cache[name] = matched.components[name];

    // attach instance registration hook
    // this will be called in the instance's injected lifecycle hooks
    data.registerRouteInstance = function (vm, val) {
      // val could be undefined for unregistration
      var current = matched.instances[name];
      if (
        (val && current !== vm) ||
        (!val && current === vm)
      ) {
        matched.instances[name] = val;
      }
    }

    // also register instance in prepatch hook
    // in case the same component instance is reused across different routes
    ;(data.hook || (data.hook = {})).prepatch = function (_, vnode) {
      matched.instances[name] = vnode.componentInstance;
    };

    // resolve props
    var propsToPass = data.props = resolveProps(route, matched.props && matched.props[name]);
    if (propsToPass) {
      // clone to prevent mutation
      propsToPass = data.props = extend({}, propsToPass);
      // pass non-declared props as attrs
      var attrs = data.attrs = data.attrs || {};
      for (var key in propsToPass) {
        if (!component.props || !(key in component.props)) {
          attrs[key] = propsToPass[key];
          delete propsToPass[key];
        }
      }
    }

    return h(component, data, children)
  }
};

function resolveProps (route, config) {
  switch (typeof config) {
    case 'undefined':
      return
    case 'object':
      return config
    case 'function':
      return config(route)
    case 'boolean':
      return config ? route.params : undefined
    default:
      if (false) {
        warn(
          false,
          "props in \"" + (route.path) + "\" is a " + (typeof config) + ", " +
          "expecting an object, function or boolean."
        );
      }
  }
}

function extend (to, from) {
  for (var key in from) {
    to[key] = from[key];
  }
  return to
}

/*  */

var encodeReserveRE = /[!'()*]/g;
var encodeReserveReplacer = function (c) { return '%' + c.charCodeAt(0).toString(16); };
var commaRE = /%2C/g;

// fixed encodeURIComponent which is more conformant to RFC3986:
// - escapes [!'()*]
// - preserve commas
var encode = function (str) { return encodeURIComponent(str)
  .replace(encodeReserveRE, encodeReserveReplacer)
  .replace(commaRE, ','); };

var decode = decodeURIComponent;

function resolveQuery (
  query,
  extraQuery,
  _parseQuery
) {
  if ( extraQuery === void 0 ) extraQuery = {};

  var parse = _parseQuery || parseQuery;
  var parsedQuery;
  try {
    parsedQuery = parse(query || '');
  } catch (e) {
    "production" !== 'production' && warn(false, e.message);
    parsedQuery = {};
  }
  for (var key in extraQuery) {
    parsedQuery[key] = extraQuery[key];
  }
  return parsedQuery
}

function parseQuery (query) {
  var res = {};

  query = query.trim().replace(/^(\?|#|&)/, '');

  if (!query) {
    return res
  }

  query.split('&').forEach(function (param) {
    var parts = param.replace(/\+/g, ' ').split('=');
    var key = decode(parts.shift());
    var val = parts.length > 0
      ? decode(parts.join('='))
      : null;

    if (res[key] === undefined) {
      res[key] = val;
    } else if (Array.isArray(res[key])) {
      res[key].push(val);
    } else {
      res[key] = [res[key], val];
    }
  });

  return res
}

function stringifyQuery (obj) {
  var res = obj ? Object.keys(obj).map(function (key) {
    var val = obj[key];

    if (val === undefined) {
      return ''
    }

    if (val === null) {
      return encode(key)
    }

    if (Array.isArray(val)) {
      var result = [];
      val.forEach(function (val2) {
        if (val2 === undefined) {
          return
        }
        if (val2 === null) {
          result.push(encode(key));
        } else {
          result.push(encode(key) + '=' + encode(val2));
        }
      });
      return result.join('&')
    }

    return encode(key) + '=' + encode(val)
  }).filter(function (x) { return x.length > 0; }).join('&') : null;
  return res ? ("?" + res) : ''
}

/*  */


var trailingSlashRE = /\/?$/;

function createRoute (
  record,
  location,
  redirectedFrom,
  router
) {
  var stringifyQuery$$1 = router && router.options.stringifyQuery;

  var query = location.query || {};
  try {
    query = clone(query);
  } catch (e) {}

  var route = {
    name: location.name || (record && record.name),
    meta: (record && record.meta) || {},
    path: location.path || '/',
    hash: location.hash || '',
    query: query,
    params: location.params || {},
    fullPath: getFullPath(location, stringifyQuery$$1),
    matched: record ? formatMatch(record) : []
  };
  if (redirectedFrom) {
    route.redirectedFrom = getFullPath(redirectedFrom, stringifyQuery$$1);
  }
  return Object.freeze(route)
}

function clone (value) {
  if (Array.isArray(value)) {
    return value.map(clone)
  } else if (value && typeof value === 'object') {
    var res = {};
    for (var key in value) {
      res[key] = clone(value[key]);
    }
    return res
  } else {
    return value
  }
}

// the starting route that represents the initial state
var START = createRoute(null, {
  path: '/'
});

function formatMatch (record) {
  var res = [];
  while (record) {
    res.unshift(record);
    record = record.parent;
  }
  return res
}

function getFullPath (
  ref,
  _stringifyQuery
) {
  var path = ref.path;
  var query = ref.query; if ( query === void 0 ) query = {};
  var hash = ref.hash; if ( hash === void 0 ) hash = '';

  var stringify = _stringifyQuery || stringifyQuery;
  return (path || '/') + stringify(query) + hash
}

function isSameRoute (a, b) {
  if (b === START) {
    return a === b
  } else if (!b) {
    return false
  } else if (a.path && b.path) {
    return (
      a.path.replace(trailingSlashRE, '') === b.path.replace(trailingSlashRE, '') &&
      a.hash === b.hash &&
      isObjectEqual(a.query, b.query)
    )
  } else if (a.name && b.name) {
    return (
      a.name === b.name &&
      a.hash === b.hash &&
      isObjectEqual(a.query, b.query) &&
      isObjectEqual(a.params, b.params)
    )
  } else {
    return false
  }
}

function isObjectEqual (a, b) {
  if ( a === void 0 ) a = {};
  if ( b === void 0 ) b = {};

  // handle null value #1566
  if (!a || !b) { return a === b }
  var aKeys = Object.keys(a);
  var bKeys = Object.keys(b);
  if (aKeys.length !== bKeys.length) {
    return false
  }
  return aKeys.every(function (key) {
    var aVal = a[key];
    var bVal = b[key];
    // check nested equality
    if (typeof aVal === 'object' && typeof bVal === 'object') {
      return isObjectEqual(aVal, bVal)
    }
    return String(aVal) === String(bVal)
  })
}

function isIncludedRoute (current, target) {
  return (
    current.path.replace(trailingSlashRE, '/').indexOf(
      target.path.replace(trailingSlashRE, '/')
    ) === 0 &&
    (!target.hash || current.hash === target.hash) &&
    queryIncludes(current.query, target.query)
  )
}

function queryIncludes (current, target) {
  for (var key in target) {
    if (!(key in current)) {
      return false
    }
  }
  return true
}

/*  */

// work around weird flow bug
var toTypes = [String, Object];
var eventTypes = [String, Array];

var Link = {
  name: 'router-link',
  props: {
    to: {
      type: toTypes,
      required: true
    },
    tag: {
      type: String,
      default: 'a'
    },
    exact: Boolean,
    append: Boolean,
    replace: Boolean,
    activeClass: String,
    exactActiveClass: String,
    event: {
      type: eventTypes,
      default: 'click'
    }
  },
  render: function render (h) {
    var this$1 = this;

    var router = this.$router;
    var current = this.$route;
    var ref = router.resolve(this.to, current, this.append);
    var location = ref.location;
    var route = ref.route;
    var href = ref.href;

    var classes = {};
    var globalActiveClass = router.options.linkActiveClass;
    var globalExactActiveClass = router.options.linkExactActiveClass;
    // Support global empty active class
    var activeClassFallback = globalActiveClass == null
            ? 'router-link-active'
            : globalActiveClass;
    var exactActiveClassFallback = globalExactActiveClass == null
            ? 'router-link-exact-active'
            : globalExactActiveClass;
    var activeClass = this.activeClass == null
            ? activeClassFallback
            : this.activeClass;
    var exactActiveClass = this.exactActiveClass == null
            ? exactActiveClassFallback
            : this.exactActiveClass;
    var compareTarget = location.path
      ? createRoute(null, location, null, router)
      : route;

    classes[exactActiveClass] = isSameRoute(current, compareTarget);
    classes[activeClass] = this.exact
      ? classes[exactActiveClass]
      : isIncludedRoute(current, compareTarget);

    var handler = function (e) {
      if (guardEvent(e)) {
        if (this$1.replace) {
          router.replace(location);
        } else {
          router.push(location);
        }
      }
    };

    var on = { click: guardEvent };
    if (Array.isArray(this.event)) {
      this.event.forEach(function (e) { on[e] = handler; });
    } else {
      on[this.event] = handler;
    }

    var data = {
      class: classes
    };

    if (this.tag === 'a') {
      data.on = on;
      data.attrs = { href: href };
    } else {
      // find the first <a> child and apply listener and href
      var a = findAnchor(this.$slots.default);
      if (a) {
        // in case the <a> is a static node
        a.isStatic = false;
        var extend = _Vue.util.extend;
        var aData = a.data = extend({}, a.data);
        aData.on = on;
        var aAttrs = a.data.attrs = extend({}, a.data.attrs);
        aAttrs.href = href;
      } else {
        // doesn't have <a> child, apply listener to self
        data.on = on;
      }
    }

    return h(this.tag, data, this.$slots.default)
  }
};

function guardEvent (e) {
  // don't redirect with control keys
  if (e.metaKey || e.altKey || e.ctrlKey || e.shiftKey) { return }
  // don't redirect when preventDefault called
  if (e.defaultPrevented) { return }
  // don't redirect on right click
  if (e.button !== undefined && e.button !== 0) { return }
  // don't redirect if `target="_blank"`
  if (e.currentTarget && e.currentTarget.getAttribute) {
    var target = e.currentTarget.getAttribute('target');
    if (/\b_blank\b/i.test(target)) { return }
  }
  // this may be a Weex event which doesn't have this method
  if (e.preventDefault) {
    e.preventDefault();
  }
  return true
}

function findAnchor (children) {
  if (children) {
    var child;
    for (var i = 0; i < children.length; i++) {
      child = children[i];
      if (child.tag === 'a') {
        return child
      }
      if (child.children && (child = findAnchor(child.children))) {
        return child
      }
    }
  }
}

var _Vue;

function install (Vue) {
  if (install.installed && _Vue === Vue) { return }
  install.installed = true;

  _Vue = Vue;

  var isDef = function (v) { return v !== undefined; };

  var registerInstance = function (vm, callVal) {
    var i = vm.$options._parentVnode;
    if (isDef(i) && isDef(i = i.data) && isDef(i = i.registerRouteInstance)) {
      i(vm, callVal);
    }
  };

  Vue.mixin({
    beforeCreate: function beforeCreate () {
      if (isDef(this.$options.router)) {
        this._routerRoot = this;
        this._router = this.$options.router;
        this._router.init(this);
        Vue.util.defineReactive(this, '_route', this._router.history.current);
      } else {
        this._routerRoot = (this.$parent && this.$parent._routerRoot) || this;
      }
      registerInstance(this, this);
    },
    destroyed: function destroyed () {
      registerInstance(this);
    }
  });

  Object.defineProperty(Vue.prototype, '$router', {
    get: function get () { return this._routerRoot._router }
  });

  Object.defineProperty(Vue.prototype, '$route', {
    get: function get () { return this._routerRoot._route }
  });

  Vue.component('router-view', View);
  Vue.component('router-link', Link);

  var strats = Vue.config.optionMergeStrategies;
  // use the same hook merging strategy for route hooks
  strats.beforeRouteEnter = strats.beforeRouteLeave = strats.beforeRouteUpdate = strats.created;
}

/*  */

var inBrowser = typeof window !== 'undefined';

/*  */

function resolvePath (
  relative,
  base,
  append
) {
  var firstChar = relative.charAt(0);
  if (firstChar === '/') {
    return relative
  }

  if (firstChar === '?' || firstChar === '#') {
    return base + relative
  }

  var stack = base.split('/');

  // remove trailing segment if:
  // - not appending
  // - appending to trailing slash (last segment is empty)
  if (!append || !stack[stack.length - 1]) {
    stack.pop();
  }

  // resolve relative path
  var segments = relative.replace(/^\//, '').split('/');
  for (var i = 0; i < segments.length; i++) {
    var segment = segments[i];
    if (segment === '..') {
      stack.pop();
    } else if (segment !== '.') {
      stack.push(segment);
    }
  }

  // ensure leading slash
  if (stack[0] !== '') {
    stack.unshift('');
  }

  return stack.join('/')
}

function parsePath (path) {
  var hash = '';
  var query = '';

  var hashIndex = path.indexOf('#');
  if (hashIndex >= 0) {
    hash = path.slice(hashIndex);
    path = path.slice(0, hashIndex);
  }

  var queryIndex = path.indexOf('?');
  if (queryIndex >= 0) {
    query = path.slice(queryIndex + 1);
    path = path.slice(0, queryIndex);
  }

  return {
    path: path,
    query: query,
    hash: hash
  }
}

function cleanPath (path) {
  return path.replace(/\/\//g, '/')
}

var isarray = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};

/**
 * Expose `pathToRegexp`.
 */
var pathToRegexp_1 = pathToRegexp;
var parse_1 = parse;
var compile_1 = compile;
var tokensToFunction_1 = tokensToFunction;
var tokensToRegExp_1 = tokensToRegExp;

/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */
var PATH_REGEXP = new RegExp([
  // Match escaped characters that would otherwise appear in future matches.
  // This allows the user to escape special characters that won't transform.
  '(\\\\.)',
  // Match Express-style parameters and un-named parameters with a prefix
  // and optional suffixes. Matches appear as:
  //
  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g');

/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */
function parse (str, options) {
  var tokens = [];
  var key = 0;
  var index = 0;
  var path = '';
  var defaultDelimiter = options && options.delimiter || '/';
  var res;

  while ((res = PATH_REGEXP.exec(str)) != null) {
    var m = res[0];
    var escaped = res[1];
    var offset = res.index;
    path += str.slice(index, offset);
    index = offset + m.length;

    // Ignore already escaped sequences.
    if (escaped) {
      path += escaped[1];
      continue
    }

    var next = str[index];
    var prefix = res[2];
    var name = res[3];
    var capture = res[4];
    var group = res[5];
    var modifier = res[6];
    var asterisk = res[7];

    // Push the current path onto the tokens.
    if (path) {
      tokens.push(path);
      path = '';
    }

    var partial = prefix != null && next != null && next !== prefix;
    var repeat = modifier === '+' || modifier === '*';
    var optional = modifier === '?' || modifier === '*';
    var delimiter = res[2] || defaultDelimiter;
    var pattern = capture || group;

    tokens.push({
      name: name || key++,
      prefix: prefix || '',
      delimiter: delimiter,
      optional: optional,
      repeat: repeat,
      partial: partial,
      asterisk: !!asterisk,
      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
    });
  }

  // Match any characters still remaining.
  if (index < str.length) {
    path += str.substr(index);
  }

  // If the path exists, push it onto the end.
  if (path) {
    tokens.push(path);
  }

  return tokens
}

/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */
function compile (str, options) {
  return tokensToFunction(parse(str, options))
}

/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */
function encodeURIComponentPretty (str) {
  return encodeURI(str).replace(/[\/?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */
function encodeAsterisk (str) {
  return encodeURI(str).replace(/[?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction (tokens) {
  // Compile all the tokens into regexps.
  var matches = new Array(tokens.length);

  // Compile all the patterns before compilation.
  for (var i = 0; i < tokens.length; i++) {
    if (typeof tokens[i] === 'object') {
      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$');
    }
  }

  return function (obj, opts) {
    var path = '';
    var data = obj || {};
    var options = opts || {};
    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent;

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i];

      if (typeof token === 'string') {
        path += token;

        continue
      }

      var value = data[token.name];
      var segment;

      if (value == null) {
        if (token.optional) {
          // Prepend partial segment prefixes.
          if (token.partial) {
            path += token.prefix;
          }

          continue
        } else {
          throw new TypeError('Expected "' + token.name + '" to be defined')
        }
      }

      if (isarray(value)) {
        if (!token.repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
        }

        if (value.length === 0) {
          if (token.optional) {
            continue
          } else {
            throw new TypeError('Expected "' + token.name + '" to not be empty')
          }
        }

        for (var j = 0; j < value.length; j++) {
          segment = encode(value[j]);

          if (!matches[i].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
          }

          path += (j === 0 ? token.prefix : token.delimiter) + segment;
        }

        continue
      }

      segment = token.asterisk ? encodeAsterisk(value) : encode(value);

      if (!matches[i].test(segment)) {
        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
      }

      path += token.prefix + segment;
    }

    return path
  }
}

/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */
function escapeString (str) {
  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
}

/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */
function escapeGroup (group) {
  return group.replace(/([=!:$\/()])/g, '\\$1')
}

/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */
function attachKeys (re, keys) {
  re.keys = keys;
  return re
}

/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */
function flags (options) {
  return options.sensitive ? '' : 'i'
}

/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */
function regexpToRegexp (path, keys) {
  // Use a negative lookahead to match only capturing groups.
  var groups = path.source.match(/\((?!\?)/g);

  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
      });
    }
  }

  return attachKeys(path, keys)
}

/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function arrayToRegexp (path, keys, options) {
  var parts = [];

  for (var i = 0; i < path.length; i++) {
    parts.push(pathToRegexp(path[i], keys, options).source);
  }

  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options));

  return attachKeys(regexp, keys)
}

/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function stringToRegexp (path, keys, options) {
  return tokensToRegExp(parse(path, options), keys, options)
}

/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */
function tokensToRegExp (tokens, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options);
    keys = [];
  }

  options = options || {};

  var strict = options.strict;
  var end = options.end !== false;
  var route = '';

  // Iterate over the tokens and create our regexp string.
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i];

    if (typeof token === 'string') {
      route += escapeString(token);
    } else {
      var prefix = escapeString(token.prefix);
      var capture = '(?:' + token.pattern + ')';

      keys.push(token);

      if (token.repeat) {
        capture += '(?:' + prefix + capture + ')*';
      }

      if (token.optional) {
        if (!token.partial) {
          capture = '(?:' + prefix + '(' + capture + '))?';
        } else {
          capture = prefix + '(' + capture + ')?';
        }
      } else {
        capture = prefix + '(' + capture + ')';
      }

      route += capture;
    }
  }

  var delimiter = escapeString(options.delimiter || '/');
  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter;

  // In non-strict mode we allow a slash at the end of match. If the path to
  // match already ends with a slash, we remove it for consistency. The slash
  // is valid at the end of a path match, not in the middle. This is important
  // in non-ending mode, where "/test/" shouldn't match "/test//route".
  if (!strict) {
    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?';
  }

  if (end) {
    route += '$';
  } else {
    // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)';
  }

  return attachKeys(new RegExp('^' + route, flags(options)), keys)
}

/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */
function pathToRegexp (path, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options);
    keys = [];
  }

  options = options || {};

  if (path instanceof RegExp) {
    return regexpToRegexp(path, /** @type {!Array} */ (keys))
  }

  if (isarray(path)) {
    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
  }

  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
}

pathToRegexp_1.parse = parse_1;
pathToRegexp_1.compile = compile_1;
pathToRegexp_1.tokensToFunction = tokensToFunction_1;
pathToRegexp_1.tokensToRegExp = tokensToRegExp_1;

/*  */

// $flow-disable-line
var regexpCompileCache = Object.create(null);

function fillParams (
  path,
  params,
  routeMsg
) {
  try {
    var filler =
      regexpCompileCache[path] ||
      (regexpCompileCache[path] = pathToRegexp_1.compile(path));
    return filler(params || {}, { pretty: true })
  } catch (e) {
    if (false) {
      warn(false, ("missing param for " + routeMsg + ": " + (e.message)));
    }
    return ''
  }
}

/*  */

function createRouteMap (
  routes,
  oldPathList,
  oldPathMap,
  oldNameMap
) {
  // the path list is used to control path matching priority
  var pathList = oldPathList || [];
  // $flow-disable-line
  var pathMap = oldPathMap || Object.create(null);
  // $flow-disable-line
  var nameMap = oldNameMap || Object.create(null);

  routes.forEach(function (route) {
    addRouteRecord(pathList, pathMap, nameMap, route);
  });

  // ensure wildcard routes are always at the end
  for (var i = 0, l = pathList.length; i < l; i++) {
    if (pathList[i] === '*') {
      pathList.push(pathList.splice(i, 1)[0]);
      l--;
      i--;
    }
  }

  return {
    pathList: pathList,
    pathMap: pathMap,
    nameMap: nameMap
  }
}

function addRouteRecord (
  pathList,
  pathMap,
  nameMap,
  route,
  parent,
  matchAs
) {
  var path = route.path;
  var name = route.name;
  if (false) {
    assert(path != null, "\"path\" is required in a route configuration.");
    assert(
      typeof route.component !== 'string',
      "route config \"component\" for path: " + (String(path || name)) + " cannot be a " +
      "string id. Use an actual component instead."
    );
  }

  var pathToRegexpOptions = route.pathToRegexpOptions || {};
  var normalizedPath = normalizePath(
    path,
    parent,
    pathToRegexpOptions.strict
  );

  if (typeof route.caseSensitive === 'boolean') {
    pathToRegexpOptions.sensitive = route.caseSensitive;
  }

  var record = {
    path: normalizedPath,
    regex: compileRouteRegex(normalizedPath, pathToRegexpOptions),
    components: route.components || { default: route.component },
    instances: {},
    name: name,
    parent: parent,
    matchAs: matchAs,
    redirect: route.redirect,
    beforeEnter: route.beforeEnter,
    meta: route.meta || {},
    props: route.props == null
      ? {}
      : route.components
        ? route.props
        : { default: route.props }
  };

  if (route.children) {
    // Warn if route is named, does not redirect and has a default child route.
    // If users navigate to this route by name, the default child will
    // not be rendered (GH Issue #629)
    if (false) {
      if (route.name && !route.redirect && route.children.some(function (child) { return /^\/?$/.test(child.path); })) {
        warn(
          false,
          "Named Route '" + (route.name) + "' has a default child route. " +
          "When navigating to this named route (:to=\"{name: '" + (route.name) + "'\"), " +
          "the default child route will not be rendered. Remove the name from " +
          "this route and use the name of the default child route for named " +
          "links instead."
        );
      }
    }
    route.children.forEach(function (child) {
      var childMatchAs = matchAs
        ? cleanPath((matchAs + "/" + (child.path)))
        : undefined;
      addRouteRecord(pathList, pathMap, nameMap, child, record, childMatchAs);
    });
  }

  if (route.alias !== undefined) {
    var aliases = Array.isArray(route.alias)
      ? route.alias
      : [route.alias];

    aliases.forEach(function (alias) {
      var aliasRoute = {
        path: alias,
        children: route.children
      };
      addRouteRecord(
        pathList,
        pathMap,
        nameMap,
        aliasRoute,
        parent,
        record.path || '/' // matchAs
      );
    });
  }

  if (!pathMap[record.path]) {
    pathList.push(record.path);
    pathMap[record.path] = record;
  }

  if (name) {
    if (!nameMap[name]) {
      nameMap[name] = record;
    } else if (false) {
      warn(
        false,
        "Duplicate named routes definition: " +
        "{ name: \"" + name + "\", path: \"" + (record.path) + "\" }"
      );
    }
  }
}

function compileRouteRegex (path, pathToRegexpOptions) {
  var regex = pathToRegexp_1(path, [], pathToRegexpOptions);
  if (false) {
    var keys = Object.create(null);
    regex.keys.forEach(function (key) {
      warn(!keys[key.name], ("Duplicate param keys in route with path: \"" + path + "\""));
      keys[key.name] = true;
    });
  }
  return regex
}

function normalizePath (path, parent, strict) {
  if (!strict) { path = path.replace(/\/$/, ''); }
  if (path[0] === '/') { return path }
  if (parent == null) { return path }
  return cleanPath(((parent.path) + "/" + path))
}

/*  */


function normalizeLocation (
  raw,
  current,
  append,
  router
) {
  var next = typeof raw === 'string' ? { path: raw } : raw;
  // named target
  if (next.name || next._normalized) {
    return next
  }

  // relative params
  if (!next.path && next.params && current) {
    next = assign({}, next);
    next._normalized = true;
    var params = assign(assign({}, current.params), next.params);
    if (current.name) {
      next.name = current.name;
      next.params = params;
    } else if (current.matched.length) {
      var rawPath = current.matched[current.matched.length - 1].path;
      next.path = fillParams(rawPath, params, ("path " + (current.path)));
    } else if (false) {
      warn(false, "relative params navigation requires a current route.");
    }
    return next
  }

  var parsedPath = parsePath(next.path || '');
  var basePath = (current && current.path) || '/';
  var path = parsedPath.path
    ? resolvePath(parsedPath.path, basePath, append || next.append)
    : basePath;

  var query = resolveQuery(
    parsedPath.query,
    next.query,
    router && router.options.parseQuery
  );

  var hash = next.hash || parsedPath.hash;
  if (hash && hash.charAt(0) !== '#') {
    hash = "#" + hash;
  }

  return {
    _normalized: true,
    path: path,
    query: query,
    hash: hash
  }
}

function assign (a, b) {
  for (var key in b) {
    a[key] = b[key];
  }
  return a
}

/*  */


function createMatcher (
  routes,
  router
) {
  var ref = createRouteMap(routes);
  var pathList = ref.pathList;
  var pathMap = ref.pathMap;
  var nameMap = ref.nameMap;

  function addRoutes (routes) {
    createRouteMap(routes, pathList, pathMap, nameMap);
  }

  function match (
    raw,
    currentRoute,
    redirectedFrom
  ) {
    var location = normalizeLocation(raw, currentRoute, false, router);
    var name = location.name;

    if (name) {
      var record = nameMap[name];
      if (false) {
        warn(record, ("Route with name '" + name + "' does not exist"));
      }
      if (!record) { return _createRoute(null, location) }
      var paramNames = record.regex.keys
        .filter(function (key) { return !key.optional; })
        .map(function (key) { return key.name; });

      if (typeof location.params !== 'object') {
        location.params = {};
      }

      if (currentRoute && typeof currentRoute.params === 'object') {
        for (var key in currentRoute.params) {
          if (!(key in location.params) && paramNames.indexOf(key) > -1) {
            location.params[key] = currentRoute.params[key];
          }
        }
      }

      if (record) {
        location.path = fillParams(record.path, location.params, ("named route \"" + name + "\""));
        return _createRoute(record, location, redirectedFrom)
      }
    } else if (location.path) {
      location.params = {};
      for (var i = 0; i < pathList.length; i++) {
        var path = pathList[i];
        var record$1 = pathMap[path];
        if (matchRoute(record$1.regex, location.path, location.params)) {
          return _createRoute(record$1, location, redirectedFrom)
        }
      }
    }
    // no match
    return _createRoute(null, location)
  }

  function redirect (
    record,
    location
  ) {
    var originalRedirect = record.redirect;
    var redirect = typeof originalRedirect === 'function'
        ? originalRedirect(createRoute(record, location, null, router))
        : originalRedirect;

    if (typeof redirect === 'string') {
      redirect = { path: redirect };
    }

    if (!redirect || typeof redirect !== 'object') {
      if (false) {
        warn(
          false, ("invalid redirect option: " + (JSON.stringify(redirect)))
        );
      }
      return _createRoute(null, location)
    }

    var re = redirect;
    var name = re.name;
    var path = re.path;
    var query = location.query;
    var hash = location.hash;
    var params = location.params;
    query = re.hasOwnProperty('query') ? re.query : query;
    hash = re.hasOwnProperty('hash') ? re.hash : hash;
    params = re.hasOwnProperty('params') ? re.params : params;

    if (name) {
      // resolved named direct
      var targetRecord = nameMap[name];
      if (false) {
        assert(targetRecord, ("redirect failed: named route \"" + name + "\" not found."));
      }
      return match({
        _normalized: true,
        name: name,
        query: query,
        hash: hash,
        params: params
      }, undefined, location)
    } else if (path) {
      // 1. resolve relative redirect
      var rawPath = resolveRecordPath(path, record);
      // 2. resolve params
      var resolvedPath = fillParams(rawPath, params, ("redirect route with path \"" + rawPath + "\""));
      // 3. rematch with existing query and hash
      return match({
        _normalized: true,
        path: resolvedPath,
        query: query,
        hash: hash
      }, undefined, location)
    } else {
      if (false) {
        warn(false, ("invalid redirect option: " + (JSON.stringify(redirect))));
      }
      return _createRoute(null, location)
    }
  }

  function alias (
    record,
    location,
    matchAs
  ) {
    var aliasedPath = fillParams(matchAs, location.params, ("aliased route with path \"" + matchAs + "\""));
    var aliasedMatch = match({
      _normalized: true,
      path: aliasedPath
    });
    if (aliasedMatch) {
      var matched = aliasedMatch.matched;
      var aliasedRecord = matched[matched.length - 1];
      location.params = aliasedMatch.params;
      return _createRoute(aliasedRecord, location)
    }
    return _createRoute(null, location)
  }

  function _createRoute (
    record,
    location,
    redirectedFrom
  ) {
    if (record && record.redirect) {
      return redirect(record, redirectedFrom || location)
    }
    if (record && record.matchAs) {
      return alias(record, location, record.matchAs)
    }
    return createRoute(record, location, redirectedFrom, router)
  }

  return {
    match: match,
    addRoutes: addRoutes
  }
}

function matchRoute (
  regex,
  path,
  params
) {
  var m = path.match(regex);

  if (!m) {
    return false
  } else if (!params) {
    return true
  }

  for (var i = 1, len = m.length; i < len; ++i) {
    var key = regex.keys[i - 1];
    var val = typeof m[i] === 'string' ? decodeURIComponent(m[i]) : m[i];
    if (key) {
      params[key.name] = val;
    }
  }

  return true
}

function resolveRecordPath (path, record) {
  return resolvePath(path, record.parent ? record.parent.path : '/', true)
}

/*  */


var positionStore = Object.create(null);

function setupScroll () {
  // Fix for #1585 for Firefox
  window.history.replaceState({ key: getStateKey() }, '');
  window.addEventListener('popstate', function (e) {
    saveScrollPosition();
    if (e.state && e.state.key) {
      setStateKey(e.state.key);
    }
  });
}

function handleScroll (
  router,
  to,
  from,
  isPop
) {
  if (!router.app) {
    return
  }

  var behavior = router.options.scrollBehavior;
  if (!behavior) {
    return
  }

  if (false) {
    assert(typeof behavior === 'function', "scrollBehavior must be a function");
  }

  // wait until re-render finishes before scrolling
  router.app.$nextTick(function () {
    var position = getScrollPosition();
    var shouldScroll = behavior(to, from, isPop ? position : null);

    if (!shouldScroll) {
      return
    }

    if (typeof shouldScroll.then === 'function') {
      shouldScroll.then(function (shouldScroll) {
        scrollToPosition((shouldScroll), position);
      }).catch(function (err) {
        if (false) {
          assert(false, err.toString());
        }
      });
    } else {
      scrollToPosition(shouldScroll, position);
    }
  });
}

function saveScrollPosition () {
  var key = getStateKey();
  if (key) {
    positionStore[key] = {
      x: window.pageXOffset,
      y: window.pageYOffset
    };
  }
}

function getScrollPosition () {
  var key = getStateKey();
  if (key) {
    return positionStore[key]
  }
}

function getElementPosition (el, offset) {
  var docEl = document.documentElement;
  var docRect = docEl.getBoundingClientRect();
  var elRect = el.getBoundingClientRect();
  return {
    x: elRect.left - docRect.left - offset.x,
    y: elRect.top - docRect.top - offset.y
  }
}

function isValidPosition (obj) {
  return isNumber(obj.x) || isNumber(obj.y)
}

function normalizePosition (obj) {
  return {
    x: isNumber(obj.x) ? obj.x : window.pageXOffset,
    y: isNumber(obj.y) ? obj.y : window.pageYOffset
  }
}

function normalizeOffset (obj) {
  return {
    x: isNumber(obj.x) ? obj.x : 0,
    y: isNumber(obj.y) ? obj.y : 0
  }
}

function isNumber (v) {
  return typeof v === 'number'
}

function scrollToPosition (shouldScroll, position) {
  var isObject = typeof shouldScroll === 'object';
  if (isObject && typeof shouldScroll.selector === 'string') {
    var el = document.querySelector(shouldScroll.selector);
    if (el) {
      var offset = shouldScroll.offset && typeof shouldScroll.offset === 'object' ? shouldScroll.offset : {};
      offset = normalizeOffset(offset);
      position = getElementPosition(el, offset);
    } else if (isValidPosition(shouldScroll)) {
      position = normalizePosition(shouldScroll);
    }
  } else if (isObject && isValidPosition(shouldScroll)) {
    position = normalizePosition(shouldScroll);
  }

  if (position) {
    window.scrollTo(position.x, position.y);
  }
}

/*  */

var supportsPushState = inBrowser && (function () {
  var ua = window.navigator.userAgent;

  if (
    (ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) &&
    ua.indexOf('Mobile Safari') !== -1 &&
    ua.indexOf('Chrome') === -1 &&
    ua.indexOf('Windows Phone') === -1
  ) {
    return false
  }

  return window.history && 'pushState' in window.history
})();

// use User Timing api (if present) for more accurate key precision
var Time = inBrowser && window.performance && window.performance.now
  ? window.performance
  : Date;

var _key = genKey();

function genKey () {
  return Time.now().toFixed(3)
}

function getStateKey () {
  return _key
}

function setStateKey (key) {
  _key = key;
}

function pushState (url, replace) {
  saveScrollPosition();
  // try...catch the pushState call to get around Safari
  // DOM Exception 18 where it limits to 100 pushState calls
  var history = window.history;
  try {
    if (replace) {
      history.replaceState({ key: _key }, '', url);
    } else {
      _key = genKey();
      history.pushState({ key: _key }, '', url);
    }
  } catch (e) {
    window.location[replace ? 'replace' : 'assign'](url);
  }
}

function replaceState (url) {
  pushState(url, true);
}

/*  */

function runQueue (queue, fn, cb) {
  var step = function (index) {
    if (index >= queue.length) {
      cb();
    } else {
      if (queue[index]) {
        fn(queue[index], function () {
          step(index + 1);
        });
      } else {
        step(index + 1);
      }
    }
  };
  step(0);
}

/*  */

function resolveAsyncComponents (matched) {
  return function (to, from, next) {
    var hasAsync = false;
    var pending = 0;
    var error = null;

    flatMapComponents(matched, function (def, _, match, key) {
      // if it's a function and doesn't have cid attached,
      // assume it's an async component resolve function.
      // we are not using Vue's default async resolving mechanism because
      // we want to halt the navigation until the incoming component has been
      // resolved.
      if (typeof def === 'function' && def.cid === undefined) {
        hasAsync = true;
        pending++;

        var resolve = once(function (resolvedDef) {
          if (isESModule(resolvedDef)) {
            resolvedDef = resolvedDef.default;
          }
          // save resolved on async factory in case it's used elsewhere
          def.resolved = typeof resolvedDef === 'function'
            ? resolvedDef
            : _Vue.extend(resolvedDef);
          match.components[key] = resolvedDef;
          pending--;
          if (pending <= 0) {
            next();
          }
        });

        var reject = once(function (reason) {
          var msg = "Failed to resolve async component " + key + ": " + reason;
          "production" !== 'production' && warn(false, msg);
          if (!error) {
            error = isError(reason)
              ? reason
              : new Error(msg);
            next(error);
          }
        });

        var res;
        try {
          res = def(resolve, reject);
        } catch (e) {
          reject(e);
        }
        if (res) {
          if (typeof res.then === 'function') {
            res.then(resolve, reject);
          } else {
            // new syntax in Vue 2.3
            var comp = res.component;
            if (comp && typeof comp.then === 'function') {
              comp.then(resolve, reject);
            }
          }
        }
      }
    });

    if (!hasAsync) { next(); }
  }
}

function flatMapComponents (
  matched,
  fn
) {
  return flatten(matched.map(function (m) {
    return Object.keys(m.components).map(function (key) { return fn(
      m.components[key],
      m.instances[key],
      m, key
    ); })
  }))
}

function flatten (arr) {
  return Array.prototype.concat.apply([], arr)
}

var hasSymbol =
  typeof Symbol === 'function' &&
  typeof Symbol.toStringTag === 'symbol';

function isESModule (obj) {
  return obj.__esModule || (hasSymbol && obj[Symbol.toStringTag] === 'Module')
}

// in Webpack 2, require.ensure now also returns a Promise
// so the resolve/reject functions may get called an extra time
// if the user uses an arrow function shorthand that happens to
// return that Promise.
function once (fn) {
  var called = false;
  return function () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    if (called) { return }
    called = true;
    return fn.apply(this, args)
  }
}

/*  */

var History = function History (router, base) {
  this.router = router;
  this.base = normalizeBase(base);
  // start with a route object that stands for "nowhere"
  this.current = START;
  this.pending = null;
  this.ready = false;
  this.readyCbs = [];
  this.readyErrorCbs = [];
  this.errorCbs = [];
};

History.prototype.listen = function listen (cb) {
  this.cb = cb;
};

History.prototype.onReady = function onReady (cb, errorCb) {
  if (this.ready) {
    cb();
  } else {
    this.readyCbs.push(cb);
    if (errorCb) {
      this.readyErrorCbs.push(errorCb);
    }
  }
};

History.prototype.onError = function onError (errorCb) {
  this.errorCbs.push(errorCb);
};

History.prototype.transitionTo = function transitionTo (location, onComplete, onAbort) {
    var this$1 = this;

  var route = this.router.match(location, this.current);
  this.confirmTransition(route, function () {
    this$1.updateRoute(route);
    onComplete && onComplete(route);
    this$1.ensureURL();

    // fire ready cbs once
    if (!this$1.ready) {
      this$1.ready = true;
      this$1.readyCbs.forEach(function (cb) { cb(route); });
    }
  }, function (err) {
    if (onAbort) {
      onAbort(err);
    }
    if (err && !this$1.ready) {
      this$1.ready = true;
      this$1.readyErrorCbs.forEach(function (cb) { cb(err); });
    }
  });
};

History.prototype.confirmTransition = function confirmTransition (route, onComplete, onAbort) {
    var this$1 = this;

  var current = this.current;
  var abort = function (err) {
    if (isError(err)) {
      if (this$1.errorCbs.length) {
        this$1.errorCbs.forEach(function (cb) { cb(err); });
      } else {
        warn(false, 'uncaught error during route navigation:');
        console.error(err);
      }
    }
    onAbort && onAbort(err);
  };
  if (
    isSameRoute(route, current) &&
    // in the case the route map has been dynamically appended to
    route.matched.length === current.matched.length
  ) {
    this.ensureURL();
    return abort()
  }

  var ref = resolveQueue(this.current.matched, route.matched);
    var updated = ref.updated;
    var deactivated = ref.deactivated;
    var activated = ref.activated;

  var queue = [].concat(
    // in-component leave guards
    extractLeaveGuards(deactivated),
    // global before hooks
    this.router.beforeHooks,
    // in-component update hooks
    extractUpdateHooks(updated),
    // in-config enter guards
    activated.map(function (m) { return m.beforeEnter; }),
    // async components
    resolveAsyncComponents(activated)
  );

  this.pending = route;
  var iterator = function (hook, next) {
    if (this$1.pending !== route) {
      return abort()
    }
    try {
      hook(route, current, function (to) {
        if (to === false || isError(to)) {
          // next(false) -> abort navigation, ensure current URL
          this$1.ensureURL(true);
          abort(to);
        } else if (
          typeof to === 'string' ||
          (typeof to === 'object' && (
            typeof to.path === 'string' ||
            typeof to.name === 'string'
          ))
        ) {
          // next('/') or next({ path: '/' }) -> redirect
          abort();
          if (typeof to === 'object' && to.replace) {
            this$1.replace(to);
          } else {
            this$1.push(to);
          }
        } else {
          // confirm transition and pass on the value
          next(to);
        }
      });
    } catch (e) {
      abort(e);
    }
  };

  runQueue(queue, iterator, function () {
    var postEnterCbs = [];
    var isValid = function () { return this$1.current === route; };
    // wait until async components are resolved before
    // extracting in-component enter guards
    var enterGuards = extractEnterGuards(activated, postEnterCbs, isValid);
    var queue = enterGuards.concat(this$1.router.resolveHooks);
    runQueue(queue, iterator, function () {
      if (this$1.pending !== route) {
        return abort()
      }
      this$1.pending = null;
      onComplete(route);
      if (this$1.router.app) {
        this$1.router.app.$nextTick(function () {
          postEnterCbs.forEach(function (cb) { cb(); });
        });
      }
    });
  });
};

History.prototype.updateRoute = function updateRoute (route) {
  var prev = this.current;
  this.current = route;
  this.cb && this.cb(route);
  this.router.afterHooks.forEach(function (hook) {
    hook && hook(route, prev);
  });
};

function normalizeBase (base) {
  if (!base) {
    if (inBrowser) {
      // respect <base> tag
      var baseEl = document.querySelector('base');
      base = (baseEl && baseEl.getAttribute('href')) || '/';
      // strip full URL origin
      base = base.replace(/^https?:\/\/[^\/]+/, '');
    } else {
      base = '/';
    }
  }
  // make sure there's the starting slash
  if (base.charAt(0) !== '/') {
    base = '/' + base;
  }
  // remove trailing slash
  return base.replace(/\/$/, '')
}

function resolveQueue (
  current,
  next
) {
  var i;
  var max = Math.max(current.length, next.length);
  for (i = 0; i < max; i++) {
    if (current[i] !== next[i]) {
      break
    }
  }
  return {
    updated: next.slice(0, i),
    activated: next.slice(i),
    deactivated: current.slice(i)
  }
}

function extractGuards (
  records,
  name,
  bind,
  reverse
) {
  var guards = flatMapComponents(records, function (def, instance, match, key) {
    var guard = extractGuard(def, name);
    if (guard) {
      return Array.isArray(guard)
        ? guard.map(function (guard) { return bind(guard, instance, match, key); })
        : bind(guard, instance, match, key)
    }
  });
  return flatten(reverse ? guards.reverse() : guards)
}

function extractGuard (
  def,
  key
) {
  if (typeof def !== 'function') {
    // extend now so that global mixins are applied.
    def = _Vue.extend(def);
  }
  return def.options[key]
}

function extractLeaveGuards (deactivated) {
  return extractGuards(deactivated, 'beforeRouteLeave', bindGuard, true)
}

function extractUpdateHooks (updated) {
  return extractGuards(updated, 'beforeRouteUpdate', bindGuard)
}

function bindGuard (guard, instance) {
  if (instance) {
    return function boundRouteGuard () {
      return guard.apply(instance, arguments)
    }
  }
}

function extractEnterGuards (
  activated,
  cbs,
  isValid
) {
  return extractGuards(activated, 'beforeRouteEnter', function (guard, _, match, key) {
    return bindEnterGuard(guard, match, key, cbs, isValid)
  })
}

function bindEnterGuard (
  guard,
  match,
  key,
  cbs,
  isValid
) {
  return function routeEnterGuard (to, from, next) {
    return guard(to, from, function (cb) {
      next(cb);
      if (typeof cb === 'function') {
        cbs.push(function () {
          // #750
          // if a router-view is wrapped with an out-in transition,
          // the instance may not have been registered at this time.
          // we will need to poll for registration until current route
          // is no longer valid.
          poll(cb, match.instances, key, isValid);
        });
      }
    })
  }
}

function poll (
  cb, // somehow flow cannot infer this is a function
  instances,
  key,
  isValid
) {
  if (instances[key]) {
    cb(instances[key]);
  } else if (isValid()) {
    setTimeout(function () {
      poll(cb, instances, key, isValid);
    }, 16);
  }
}

/*  */


var HTML5History = (function (History$$1) {
  function HTML5History (router, base) {
    var this$1 = this;

    History$$1.call(this, router, base);

    var expectScroll = router.options.scrollBehavior;

    if (expectScroll) {
      setupScroll();
    }

    var initLocation = getLocation(this.base);
    window.addEventListener('popstate', function (e) {
      var current = this$1.current;

      // Avoiding first `popstate` event dispatched in some browsers but first
      // history route not updated since async guard at the same time.
      var location = getLocation(this$1.base);
      if (this$1.current === START && location === initLocation) {
        return
      }

      this$1.transitionTo(location, function (route) {
        if (expectScroll) {
          handleScroll(router, route, current, true);
        }
      });
    });
  }

  if ( History$$1 ) HTML5History.__proto__ = History$$1;
  HTML5History.prototype = Object.create( History$$1 && History$$1.prototype );
  HTML5History.prototype.constructor = HTML5History;

  HTML5History.prototype.go = function go (n) {
    window.history.go(n);
  };

  HTML5History.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      pushState(cleanPath(this$1.base + route.fullPath));
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HTML5History.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      replaceState(cleanPath(this$1.base + route.fullPath));
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HTML5History.prototype.ensureURL = function ensureURL (push) {
    if (getLocation(this.base) !== this.current.fullPath) {
      var current = cleanPath(this.base + this.current.fullPath);
      push ? pushState(current) : replaceState(current);
    }
  };

  HTML5History.prototype.getCurrentLocation = function getCurrentLocation () {
    return getLocation(this.base)
  };

  return HTML5History;
}(History));

function getLocation (base) {
  var path = window.location.pathname;
  if (base && path.indexOf(base) === 0) {
    path = path.slice(base.length);
  }
  return (path || '/') + window.location.search + window.location.hash
}

/*  */


var HashHistory = (function (History$$1) {
  function HashHistory (router, base, fallback) {
    History$$1.call(this, router, base);
    // check history fallback deeplinking
    if (fallback && checkFallback(this.base)) {
      return
    }
    ensureSlash();
  }

  if ( History$$1 ) HashHistory.__proto__ = History$$1;
  HashHistory.prototype = Object.create( History$$1 && History$$1.prototype );
  HashHistory.prototype.constructor = HashHistory;

  // this is delayed until the app mounts
  // to avoid the hashchange listener being fired too early
  HashHistory.prototype.setupListeners = function setupListeners () {
    var this$1 = this;

    var router = this.router;
    var expectScroll = router.options.scrollBehavior;
    var supportsScroll = supportsPushState && expectScroll;

    if (supportsScroll) {
      setupScroll();
    }

    window.addEventListener(supportsPushState ? 'popstate' : 'hashchange', function () {
      var current = this$1.current;
      if (!ensureSlash()) {
        return
      }
      this$1.transitionTo(getHash(), function (route) {
        if (supportsScroll) {
          handleScroll(this$1.router, route, current, true);
        }
        if (!supportsPushState) {
          replaceHash(route.fullPath);
        }
      });
    });
  };

  HashHistory.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      pushHash(route.fullPath);
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HashHistory.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      replaceHash(route.fullPath);
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HashHistory.prototype.go = function go (n) {
    window.history.go(n);
  };

  HashHistory.prototype.ensureURL = function ensureURL (push) {
    var current = this.current.fullPath;
    if (getHash() !== current) {
      push ? pushHash(current) : replaceHash(current);
    }
  };

  HashHistory.prototype.getCurrentLocation = function getCurrentLocation () {
    return getHash()
  };

  return HashHistory;
}(History));

function checkFallback (base) {
  var location = getLocation(base);
  if (!/^\/#/.test(location)) {
    window.location.replace(
      cleanPath(base + '/#' + location)
    );
    return true
  }
}

function ensureSlash () {
  var path = getHash();
  if (path.charAt(0) === '/') {
    return true
  }
  replaceHash('/' + path);
  return false
}

function getHash () {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var index = href.indexOf('#');
  return index === -1 ? '' : href.slice(index + 1)
}

function getUrl (path) {
  var href = window.location.href;
  var i = href.indexOf('#');
  var base = i >= 0 ? href.slice(0, i) : href;
  return (base + "#" + path)
}

function pushHash (path) {
  if (supportsPushState) {
    pushState(getUrl(path));
  } else {
    window.location.hash = path;
  }
}

function replaceHash (path) {
  if (supportsPushState) {
    replaceState(getUrl(path));
  } else {
    window.location.replace(getUrl(path));
  }
}

/*  */


var AbstractHistory = (function (History$$1) {
  function AbstractHistory (router, base) {
    History$$1.call(this, router, base);
    this.stack = [];
    this.index = -1;
  }

  if ( History$$1 ) AbstractHistory.__proto__ = History$$1;
  AbstractHistory.prototype = Object.create( History$$1 && History$$1.prototype );
  AbstractHistory.prototype.constructor = AbstractHistory;

  AbstractHistory.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    this.transitionTo(location, function (route) {
      this$1.stack = this$1.stack.slice(0, this$1.index + 1).concat(route);
      this$1.index++;
      onComplete && onComplete(route);
    }, onAbort);
  };

  AbstractHistory.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    this.transitionTo(location, function (route) {
      this$1.stack = this$1.stack.slice(0, this$1.index).concat(route);
      onComplete && onComplete(route);
    }, onAbort);
  };

  AbstractHistory.prototype.go = function go (n) {
    var this$1 = this;

    var targetIndex = this.index + n;
    if (targetIndex < 0 || targetIndex >= this.stack.length) {
      return
    }
    var route = this.stack[targetIndex];
    this.confirmTransition(route, function () {
      this$1.index = targetIndex;
      this$1.updateRoute(route);
    });
  };

  AbstractHistory.prototype.getCurrentLocation = function getCurrentLocation () {
    var current = this.stack[this.stack.length - 1];
    return current ? current.fullPath : '/'
  };

  AbstractHistory.prototype.ensureURL = function ensureURL () {
    // noop
  };

  return AbstractHistory;
}(History));

/*  */

var VueRouter = function VueRouter (options) {
  if ( options === void 0 ) options = {};

  this.app = null;
  this.apps = [];
  this.options = options;
  this.beforeHooks = [];
  this.resolveHooks = [];
  this.afterHooks = [];
  this.matcher = createMatcher(options.routes || [], this);

  var mode = options.mode || 'hash';
  this.fallback = mode === 'history' && !supportsPushState && options.fallback !== false;
  if (this.fallback) {
    mode = 'hash';
  }
  if (!inBrowser) {
    mode = 'abstract';
  }
  this.mode = mode;

  switch (mode) {
    case 'history':
      this.history = new HTML5History(this, options.base);
      break
    case 'hash':
      this.history = new HashHistory(this, options.base, this.fallback);
      break
    case 'abstract':
      this.history = new AbstractHistory(this, options.base);
      break
    default:
      if (false) {
        assert(false, ("invalid mode: " + mode));
      }
  }
};

var prototypeAccessors = { currentRoute: { configurable: true } };

VueRouter.prototype.match = function match (
  raw,
  current,
  redirectedFrom
) {
  return this.matcher.match(raw, current, redirectedFrom)
};

prototypeAccessors.currentRoute.get = function () {
  return this.history && this.history.current
};

VueRouter.prototype.init = function init (app /* Vue component instance */) {
    var this$1 = this;

  "production" !== 'production' && assert(
    install.installed,
    "not installed. Make sure to call `Vue.use(VueRouter)` " +
    "before creating root instance."
  );

  this.apps.push(app);

  // main app already initialized.
  if (this.app) {
    return
  }

  this.app = app;

  var history = this.history;

  if (history instanceof HTML5History) {
    history.transitionTo(history.getCurrentLocation());
  } else if (history instanceof HashHistory) {
    var setupHashListener = function () {
      history.setupListeners();
    };
    history.transitionTo(
      history.getCurrentLocation(),
      setupHashListener,
      setupHashListener
    );
  }

  history.listen(function (route) {
    this$1.apps.forEach(function (app) {
      app._route = route;
    });
  });
};

VueRouter.prototype.beforeEach = function beforeEach (fn) {
  return registerHook(this.beforeHooks, fn)
};

VueRouter.prototype.beforeResolve = function beforeResolve (fn) {
  return registerHook(this.resolveHooks, fn)
};

VueRouter.prototype.afterEach = function afterEach (fn) {
  return registerHook(this.afterHooks, fn)
};

VueRouter.prototype.onReady = function onReady (cb, errorCb) {
  this.history.onReady(cb, errorCb);
};

VueRouter.prototype.onError = function onError (errorCb) {
  this.history.onError(errorCb);
};

VueRouter.prototype.push = function push (location, onComplete, onAbort) {
  this.history.push(location, onComplete, onAbort);
};

VueRouter.prototype.replace = function replace (location, onComplete, onAbort) {
  this.history.replace(location, onComplete, onAbort);
};

VueRouter.prototype.go = function go (n) {
  this.history.go(n);
};

VueRouter.prototype.back = function back () {
  this.go(-1);
};

VueRouter.prototype.forward = function forward () {
  this.go(1);
};

VueRouter.prototype.getMatchedComponents = function getMatchedComponents (to) {
  var route = to
    ? to.matched
      ? to
      : this.resolve(to).route
    : this.currentRoute;
  if (!route) {
    return []
  }
  return [].concat.apply([], route.matched.map(function (m) {
    return Object.keys(m.components).map(function (key) {
      return m.components[key]
    })
  }))
};

VueRouter.prototype.resolve = function resolve (
  to,
  current,
  append
) {
  var location = normalizeLocation(
    to,
    current || this.history.current,
    append,
    this
  );
  var route = this.match(location, current);
  var fullPath = route.redirectedFrom || route.fullPath;
  var base = this.history.base;
  var href = createHref(base, fullPath, this.mode);
  return {
    location: location,
    route: route,
    href: href,
    // for backwards compat
    normalizedTo: location,
    resolved: route
  }
};

VueRouter.prototype.addRoutes = function addRoutes (routes) {
  this.matcher.addRoutes(routes);
  if (this.history.current !== START) {
    this.history.transitionTo(this.history.getCurrentLocation());
  }
};

Object.defineProperties( VueRouter.prototype, prototypeAccessors );

function registerHook (list, fn) {
  list.push(fn);
  return function () {
    var i = list.indexOf(fn);
    if (i > -1) { list.splice(i, 1); }
  }
}

function createHref (base, fullPath, mode) {
  var path = mode === 'hash' ? '#' + fullPath : fullPath;
  return base ? cleanPath(base + '/' + path) : path
}

VueRouter.install = install;
VueRouter.version = '2.8.1';

if (inBrowser && window.Vue) {
  window.Vue.use(VueRouter);
}

/* harmony default export */ __webpack_exports__["a"] = (VueRouter);


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(50),
  /* template */
  __webpack_require__(51),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import Navigation from '@/components/Navigation'
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'home',
  data: function data() {
    return {};
  },

  components: {
    // 'navigation': Navigation
  }
});

/***/ }),
/* 51 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/pNPbtW/tc-custom/9781960436535.jpg?1731381766916",
      "alt": "This image is the cover for the book Los principios de Jesús"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Los principios de Jesús\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Vive una vida que ni la muerte puede detener Tu mayor ministerio es hacia las personas que te rodean. La verdadera influencia debería aumentar a través de las vidas de aquellos en quienes has invertido, incluso después de que hayas fallecido. Nuestro mejor ejemplo de esto es Jesús. Él nunca escribió un libro ni viajó fuera de Israel, pero pudo utilizar a un grupo de once seguidores para crear el movimiento más grande y más influyente que el mundo haya visto. Jesús no tenía sirvientes, sin embargo, lo llamaban Maestro. No tenía medicinas, sin embargo, lo llamaban Sanador. No tenía un ejército, sin embargo, los reyes lo temían. No ganó batallas militares, sin embargo, conquistó el mundo. No cometió ningún crimen, sin embargo, lo crucificaron. Fue enterrado en una tumba, sin embargo, vive hoy. Además, los seguidores de Jesús hicieron obras aún más grandes después de que Él los dejara. Los libros de Mateo, Marcos, Lucas y Juan no solo son compilaciones de narrativa sagrada sobre la vida de Jesús, sino que también contienen principios que nos permiten pasar del potencial al cumplimiento del propósito. En Los Principios de Jesús, Joseph Mattera te ayuda a desatar la grandeza en ti mismo, pero aún más importante, en tu círculo de influencia: tu cónyuge, hijos, amigos y familia. Deja un legado de ayudar a otros a alcanzar su propio potencial para que después de tu partida, aún sigas hablando. Conviértete en parte de una gran nube de testigos que ayudan a liberar el llamado divino en los demás.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Joseph Mattera\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])])
}]}

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(53),
  /* template */
  __webpack_require__(54),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 54 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "epub:type": "cover"
    }
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "los_principios_de_jesus_CVR.jpg",
      "src": "image/los_principios_de_jesus_CVR.jpg"
    }
  })])])])
}]}

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(56),
  /* template */
  __webpack_require__(57),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 57 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer000"
    }
  }, [_c('p', {
    staticClass: "_-Indice_ENDORSE"
  }, [_vm._v("Conozco a mi buen amigo Joe Mattera desde hace más de dos décadas y todavía puedo recordar claramente nuestro primer encuentro en Queens, Nueva York. Lo evoco por una razón: porque en ese entonces me estaba ayudando a mejorar para alcanzar un mayor potencial. En su libro "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Los principios de Jesús")]), _vm._v(", lo explica con autenticidad y transparencia. Esta obra no es una construcción teórica, sino lo que es Joe Mattera: un constructor de personas.")]), _vm._v(" "), _c('p', {
    staticClass: "_-Indice_ENDORSE-RF",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("—Sam Chand")]), _vm._v(" "), _c('p', {
    staticClass: "_-Indice_ENDORSE-RF",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Consultor de liderazgo, autor de "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1",
    attrs: {
      "xml:lang": "es-ES"
    }
  }, [_vm._v("Piensa diferente, vive diferente, ")]), _c('a', {
    attrs: {
      "href": "http://www.samchand.com",
      "target": "_blank"
    }
  }, [_vm._v("www.samchand.com")])]), _vm._v(" "), _c('p', {
    staticClass: "_-Indice_ENDORSE"
  }, [_vm._v("El arduo trabajo de formar líderes se está convirtiendo en un arte olvidado. Los perfiles de personas externas han cobrado más importancia que el proceso de discipulado interno. He visto a mi padre capacitar líderes durante décadas y constantemente relato historias de la manera en que eso sucede. Este libro destila, de modo experto, años de práctica en sabiduría útil para los líderes que desean discipular como lo hizo Cristo.")]), _vm._v(" "), _c('p', {
    staticClass: "_-Indice_ENDORSE-RF",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("—Justin Mattera")]), _vm._v(" "), _c('p', {
    staticClass: "_-Indice_ENDORSE-RF",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Propietario Mattera Management")]), _vm._v(" "), _c('p', {
    staticClass: "_-Indice_ENDORSE"
  }, [_vm._v("La mayoría de los libros describen los frutos de comportamientos y prácticas que pueden funcionar durante una temporada en una cultura o contexto particular. Este va a las raíces que producen esos frutos en cada generación, cultura y contexto. Esta diferencia clave se debe a que su autor, el Dr. Joseph Mattera, es un experimentado líder de pensamiento, practicante y formador de cultura reconocido mundialmente y que conoce el corazón de Dios y los tiempos en los que estamos llamados a influir. Predigo que esta lectura tendrá una de las vidas útiles más largas en su biblioteca porque fue hecha para durar. ")]), _vm._v(" "), _c('p', {
    staticClass: "_-Indice_ENDORSE-RF",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("—Dr. José Umidi, vicepresidente ejecutivo de Regent University, fundador, coaching de liderazgo formador de vida")]), _vm._v(" "), _c('p', {
    staticClass: "_-Indice_ENDORSE"
  }, [_vm._v("El ministerio y los escritos del obispo Mattera me han alentado profundamente. Él posee una extraña combinación de insondable visión teológica, ministerio práctico y corazón de pastor. En "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Los principios de Jesús")]), _vm._v(" reúne esta integración de manera profunda. Creo que este libro, lleno de verdad y sabiduría, e inmensamente relevante para nuestro momento cultural, fortalecerá y equipará a los que sirven a la iglesia.")]), _vm._v(" "), _c('p', {
    staticClass: "_-Indice_ENDORSE-RF",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("—Jon Tyson, pastor principal de Church of the City New York, autor de "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1",
    attrs: {
      "xml:lang": "es-ES"
    }
  }, [_vm._v("The Burden Is Light")])]), _vm._v(" "), _c('p', {
    staticClass: "_-Indice_ENDORSE"
  }, [_vm._v("¿Está buscando un libro para refrescar su relación con Jesús? ¿Quiere reavivar su fuego por seguir a Cristo? ¿Es nuevo en la fe cristiana y quiere profundizar más rápido en su crecimiento? "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Los principios de Jesús,")]), _vm._v(" del Dr. Joseph Mattera, es una herramienta extraordinaria que le ayudará a lograr todo ello. ¡El Dr. Mattera vuelve a destacarse con este libro poderoso y práctico que le desafiará y le empoderará en su caminar con Cristo! Como pastor, quiero poner uno de estos ejemplares en las manos de todos los miembros de mi iglesia, tanto los antiguos como los que asisten por primera vez (¡lo que sé que usted también hará!). ¡Necesita leer "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Los principios de Jesús")]), _vm._v(", al igual que cualquier otro seguidor de Cristo que conozca!")]), _vm._v(" "), _c('p', {
    staticClass: "_-Indice_ENDORSE-RF",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("—Dr. Greg Williamson, pastor principal de la congregación Valley Christian Church; presidente de Connexus Leadership Network ")]), _vm._v(" "), _c('p', {
    staticClass: "_-Indice_ENDORSE"
  }, [_vm._v("Una vez más, el obispo Joe vuelve a sobresalir. Ha escrito un libro que es bíblicamente fuerte y habla del momento en el que está la iglesia actualmente y en cuanto a dónde debe estar. "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Los principios de Jesús")]), _vm._v(" lo reenfocarán y lo liberarán para regresar al trabajo principal de cambiar al mundo, que es a través de una relación auténtica y un discipulado intencional. Este libro ayuda a recuperar la verdadera misión de la iglesia, el movimiento de Jesús que invierte en las personas más que en los programas. Es práctico e inspirador a la vez. Lo recomiendo para pastores, líderes de iglesias, de mercado y todos los seguidores de Jesús que quieran hacer discípulos.")]), _vm._v(" "), _c('p', {
    staticClass: "_-Indice_ENDORSE-RF",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("—John Hammer, pastor principal de la congregación Sonrise Christian Center ("), _c('a', {
    attrs: {
      "href": "http://isonrise.org",
      "target": "_blank"
    }
  }, [_vm._v("isonrise.org")]), _vm._v("), cofundador de Represent Movement ("), _c('a', {
    attrs: {
      "href": "http://representmovement.com",
      "target": "_blank"
    }
  }, [_vm._v("representmovement.com")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "_-Indice_ENDORSE"
  }, [_vm._v("Estuve sin padre espiritual cuatro años después de que el Dr. Elias Malki, mi amado mentor, se fue a la gloria. Entonces nuestro misericordioso Rey Yahweh me llevó al obispo Joseph Mattera. El conocimiento, la comprensión y la sabiduría que fluyen a través de él me han desafiado e iluminado mucho como hombre de Dios. El obispo Mattera es un teólogo del siglo veintiuno, una auténtica voz apostólica, no un eco. Es esa voz especial la que clama e impacta a través de cada página de este libro diciendo: “Preparen el camino para el Señor, háganle sendas derechas” (Mateo 3:3). Esta obra lo guiará del éxito a la trascendencia con una pasión renovada por parecerse más a Cristo. Aumentará su celo por permanecer en la vid y llegará a ser un verdadero discípulo. Conocerá la verdad y la verdad le hará libre.")]), _vm._v(" "), _c('p', {
    staticClass: "_-Indice_ENDORSE-RF",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("—Apóstol Rafael Najem, pastor principal de CCF Ministries, presidente de Somebody Cares New England y de Greater Lowell Citywide Ministries Network.")]), _vm._v(" "), _c('p', {
    staticClass: "_-Indice_ENDORSE"
  }, [_vm._v("En "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Los principios de Jesús")]), _vm._v(", el obispo Joseph Mattera nos ayuda a aprender —con claridad— no solo cómo ser líderes, sino también la manera de discipular líderes. Esta obra es ideal para cada individuo en cualquier etapa de su crecimiento espiritual, en la que es conformado a la imagen de Cristo. El obispo Mattera, con sus años de experiencia, se destaca impartiendo la verdad bíblica combinada con sus vivencias personales para ayudarnos a convertirnos en los líderes que Dios ha ideado que seamos, líderes que harán avanzar el reino de Dios. Así que le animo no solo a leer esta obra, sino también a aplicar esos principios a su vida y a la de aquellos a quienes están liderando. Si se toma en serio lo de ser discípulo y ayudar a otros a convertirse en discípulos, esta es una lectura imprescindible.")]), _vm._v(" "), _c('p', {
    staticClass: "_-Indice_ENDORSE-RF",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("—Terry Moore, pastor principal de la congregación Sojourn Church")]), _vm._v(" "), _c('p', {
    staticClass: "_-Indice_ENDORSE"
  }, [_vm._v("El libro del Dr. Joseph Mattera, "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Los principios de Jesús")]), _vm._v(", es un modelo cautivador y motivador para cada persona que desea desarrollar su potencial innato, su pasión y el propósito de su vida.")]), _vm._v(" "), _c('p', {
    staticClass: "_-Indice_ENDORSE-RF",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("—Steve Fedyski, director ejecutivo de Cloudburst Entertainment")]), _vm._v(" "), _c('p', {
    staticClass: "_-Indice_ENDORSE"
  }, [_c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Los principios de Jesús,")]), _vm._v(" escrito por Joseph Mattera, es un libro que debería estar en la biblioteca de todo líder. Usted querrá leerlo y luego revisarlo una y otra vez. Mattera usa las Escrituras y su experiencia para discutir los conceptos más importantes que los líderes necesitan cada día. Comenzando con la identidad y siguiendo con las actitudes, las habilidades, los hábitos y —sobre todo— las relaciones, aplica todo eso a su vida de una manera muy sencilla y práctica. "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Los principios de Jesús")]), _vm._v(" ayudarán a guiar al líder emergente y refrescará al líder ya establecido. Animo a todos a que lean y apliquen "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Los principios de Jesús.")])]), _vm._v(" "), _c('p', {
    staticClass: "_-Indice_ENDORSE-RF",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("—Dr. Tim Hamon, director ejecutivo de Christian International, doctor de Regent University")]), _vm._v(" "), _c('p', {
    staticClass: "_-Indice_ENDORSE"
  }, [_vm._v("El obispo Mattera nos ha guiado pacientemente, a mi esposo y a mí, a través de numerosas temporadas de descubrimiento espiritual. Lo ha hecho con gracia, intelecto, aliento y —en ocasiones— corrección. Como soy líder de mercado en la ciudad de Nueva York, nuestras vidas son bastante distintas. Su capacidad para cambiar instantáneamente entre los negocios y la iglesia ejemplifica claramente su llamado a dar forma a la cultura y a hablar sobre lo que es relevante hoy. Este libro ofrece una sinopsis renovada de cómo debe uno ejecutar el llamado de Dios sin importar dónde se encuentre en su caminar. Mattera presenta a la perfección la verdadera misión de la iglesia de una manera didáctica, pero inspiradora. Se nos recuerda a lo largo del libro que somos un solo cuerpo, bajo un solo Dios, llamados únicamente y de acuerdo a su voluntad y su plan para gobernar el mundo en concordancia con su Palabra. ¡Este libro es un guardián!")]), _vm._v(" "), _c('p', {
    staticClass: "_-Indice_ENDORSE-RF _idGenParaOverride-1",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("—Kristina Hosch, presidenta de Krislen Management, directora ejecutiva de Christ Covenant Coalition and The Revolving Door, Inc., autora de "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1",
    attrs: {
      "xml:lang": "es-ES"
    }
  }, [_vm._v("#90secswithgod")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "IMAGEN-RELATIVO-AL-FLUJO-DE-TXT",
    attrs: {
      "id": "_idContainer001"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/5.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "IMAGEN-RELATIVO-AL-FLUJO-DE-TXT",
    attrs: {
      "id": "_idContainer002"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/6.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "Marco-de-texto-b-sico",
    attrs: {
      "id": "_idContainer003"
    }
  }, [_c('p', {
    staticClass: "_-Indice_DEDICATION _idGenParaOverride-1",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "ITAL _idGenCharOverride-1",
    attrs: {
      "xml:lang": "es-ES"
    }
  }, [_c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _vm._v("Dedico este libro a mi amada esposa, Joyce, y a mis hijos biológicos y espirituales, así como a la familia de familias llamada Resurrection Church, en la que aprendí a caminar según los principios de Jesús.")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer004"
    }
  }, [_c('p', {
    staticClass: "CHAP-TITLE",
    attrs: {
      "id": "_idParaDest-1"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor000"
    }
  }), _vm._v("Prefacio")]), _vm._v(" "), _c('p', {
    staticClass: "pf"
  }, [_c('span', {
    staticClass: "SM-CAP",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Si usted es ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("como la mayoría de los líderes ministeriales que conozco, es probable que esté en una búsqueda constante de modelos de discipulado y desarrollo de liderazgo. Tal vez haya intentado tantas cosas diferentes que hasta se sienta cansado o con cierto cinismo con respecto a este tema. Si ese es su caso, me contenta mucho que esté leyendo este libro puesto que proporciona ideas, ejemplos de la vida real y una teología centrada en Cristo para desarrollar líderes.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("El libro que tiene en sus manos posee el potencial de alterar el curso de su vida, liderazgo y su ministerio. Es una afirmación fuerte pero, a medida que pase las páginas, estoy seguro de que concordará conmigo. Es una experiencia extraña cuando un libro puede ampliar su pensamiento y mover su corazón a la vez. Ese tipo de libros ocupan un lugar especial en mi biblioteca, pero los que amplían nuestro pensamiento, mueven nuestros corazones y mejoran nuestras habilidades ministeriales merecen su propio estante. Son verdaderamente invaluables, ya que unen ideas profundas con verdades que despiertan nuestros corazones y son herramientas prácticas que hacen que nuestras manos sean eficaces para la obra de Dios.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Aunque recién se está enterando de este libro, lo conozco desde hace más de veinte años. Lo vi desplegarse ante mis ojos desde el momento en que llegué a Cristo a la edad de catorce años en la iglesia del obispo Mattera, y poco después me uní a un grupo de discipulado que él formó.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("El grupo se llamaba Men in Training (MIT) y se reunía los domingos por la mañana antes de nuestras reuniones de adoración corporativa. El obispo seleccionó a esos hombres y los instó a asumir un alto nivel de compromiso con el discipulado y el liderazgo en nuestra iglesia. Para mi joven mente, este grupo era ¡como los Navy SEAL de nuestra iglesia! Quería ser como esos hombres con cada fibra de mi ser. Eran esposos, padres y líderes en nuestra comunidad y, como un joven que creció en un hogar monoparental, mi estima por ellos no podría haber sido mayor. Dado ese contexto, no puedo exagerar que uno de los momentos de mayor orgullo de mi joven vida fue cuando el obispo me invitó, en mi adolescencia, a unirme al grupo. Hizo un espacio para un adolescente dentro de un grupo de hombres porque vio potencial en mí y estaba dispuesto a invertir en mí a largo plazo.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Ahora, a los treinta y nueve años de edad, casado por doce años con mi maravillosa esposa, Erin, disfrutando de nuestros tres hijos y sirviendo como pastor principal de Hope Astoria, me asombra que toda mi vida haya cambiado como resultado de esa invitación. Durante esas reuniones del MIT, el obispo nos enseñó la Palabra de Dios, infundió sed por la presencia de Dios y nos desafió a crecer en carácter. Fuimos inspirados y equipados para crecer como líderes en nuestros hogares, la iglesia, nuestros negocios y nuestras carreras. Todavía tengo los cuadernos de esos tiempos de enseñanza y tengo diarios llenos de reflexiones y conocimientos que adquirí.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("A pesar de lo transformadoras que fueron esas clases, lo que realmente cambió mi vida fue cuando el obispo me invitó a vivir con su familia. Vivir con ellos fue la mayor oportunidad de discipulado que jamás me habrían ofrecido. Vi cómo vivía fuera del púlpito, cómo amaba a su esposa y cuidaba de su familia. Íbamos a comprar comida juntos, salíamos de vacaciones en familia y hacíamos las tareas de la casa juntos. Comíamos juntos, discutíamos y resolvíamos conflictos, y nos reíamos muchísimo. Pero también vi al obispo orar como un hombre de otro planeta, devorar las Escrituras, ayunar durante semanas y priorizar las devociones familiares en medio de una vida intensamente ocupada.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Lo que este libro proporciona a los líderes y las iglesias es un contenido y una visión nuevos para el entorno de nuestro salón de clases, pero su verdadera genialidad es el llamado a nosotros como líderes a ofrecer nuestra vida diaria con el objetivo de crear una cultura de discipulado. Todo lo que necesita para desarrollar líderes y liberar el potencial humano en el contexto de su ministerio está precisamente frente a usted, es decir, en su vida cotidiana. Su casa, sus quehaceres, sus ritmos familiares y mil otras situaciones normales por las que pasamos todos los días son potentes herramientas en las manos de Dios para desatar una revolución de discipulado.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("El verdadero regalo de este libro no solo son los vistazos, tras bastidores, a la vida de un líder de la cual todos podemos aprender, sino principalmente la forma en que nos insta a modelar la vida de Jesús. ¡No tenemos que reinventar la rueda! Jesús discipuló y desató el potencial humano mejor que nadie en la historia. Este libro nos llama a mirar de nuevo a nuestro Señor y traducir su vida y modelo a nuestros contextos, a medida que aprendemos de la vida y el ministerio de un líder fructífero. El obispo fue pionero en una iglesia y un ministerio en una de las ciudades más difíciles para ejercer el ministerio en el mundo, sin recursos, durante la epidemia de crack de los años 80 y 90. No solo discipuló a los pobres, a los quebrantados y a los que luchaban contra las adicciones; también capacitó a personas educadas y ricas. Fue complicado, no fue sencillo, pero estaba armado con el modelo y la vida de Jesús, ¡Dios hizo cosas asombrosas!")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("¡Que este libro le impulse a ver el potencial en usted mismo y en los demás a través de unos ojos redentores! Agarre las herramientas, los conocimientos y la inspiración que encontrará aquí y póngalos en práctica. Comience en alguna parte pero, simplemente, ¡comience! Estoy seguro de que si hacemos eso, veremos a Dios hacer cosas asombrosas en el transcurso de nuestras vidas.")]), _vm._v(" "), _c('p', {
    staticClass: "_-Indice_ENDORSE-RF _idGenParaOverride-1",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("—Kristian Hernández, pastor principal de Hope Astoria. Fundador de Kerygma Group; autor de "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1",
    attrs: {
      "xml:lang": "es-ES"
    }
  }, [_vm._v("Beholding and proclaiming ")])]), _vm._v(" "), _c('p', {
    staticClass: "CHAP-TITLE",
    attrs: {
      "id": "_idParaDest-2"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor001"
    }
  }), _vm._v("Introducción")]), _vm._v(" "), _c('p', {
    staticClass: "pf"
  }, [_c('span', {
    staticClass: "SM-CAP",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Jesús les dijo ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("a sus discípulos que la única manera de encontrar la vida era perdiéndola (Marcos 8:35), que la vida solo valía la pena si se está dispuesto a morir por algo más grande que uno mismo. Esta fue solo una de las muchas enseñanzas contraculturales de Jesús. Sus instrucciones son tan controvertidas hoy, en nuestra cultura estadounidense, como lo fueron para la cultura judía del primer siglo. Sin embargo, frente a una gran oposición, Jesús pudo tomar a doce hombres y crear el movimiento más grande e influyente que el mundo jamás haya visto. Llevó una vida extraordinaria y dejó un legado eterno a través de sus discípulos. La verdadera influencia debe aumentar a través de las vidas de aquellos en quienes nos vertemos, aun después de que fallezcamos. Nuestro mayor ejemplo de esto es, por supuesto, Jesús, cuyos seguidores hicieron obras mayores que las que él hizo después de su resurrección y ascensión.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Jesús nunca escribió un libro ni viajó más allá de la región de Israel, donde nació y creció. No tenía sirvientes, pero muchos lo llamaban “Amo”. No tenía título, pero lo llamaban “Maestro”. No tenía medicinas, pero lo llamaban “Sanador”. No tenía ejército, pero los reyes le temían. No ganó batallas militares, pero conquistó el mundo. No cometió ningún crimen, pero lo crucificaron. Fue sepultado en una tumba, pero hoy vive. Jesús se mantuvo firme en la voluntad de Dios el Padre con su vida, sin sufrir nunca lo que yo llamo “desvío de la misión”, lo que ocurre cuando nos vemos atrapados en problemas que nos impiden alcanzar nuestro máximo potencial. Este potencial implica infundir la grandeza en nuestros cónyuges, hijos, amigos y familias, dejando así un legado perdurable para las futuras generaciones. Podemos hacer esto siguiendo los principios que Jesús usó para liberar el potencial humano y poner el mundo patas arriba.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Este libro es una invitación a que me acompañe en un viaje para liberar su propósito a través de los principios de Jesús. Antes de comenzar esta travesía, tengo siete preguntas para usted. Sus respuestas servirán como indicadores del estado actual de su propósito y le ayudarán a comprender hasta qué punto está experimentando un desvío de la misión. Dios no tiene la intención de que viva a la deriva. Él quiere que tenga vida, y vida abundante; que viva con propósito para que los que vengan después de usted puedan salir adelante con el legado que ha de dejarles.")]), _vm._v(" "), _c('p', {
    staticClass: "sbttl"
  }, [_vm._v("1. ¿Experimenta frustración constante?")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("La frustración constante es una de las señales más obvias de que no está caminando en dirección a lo que Dios programó, internamente, que usted persiguiera. En efecto, su frustración puede ser una señal que Dios le da para animarlo a que siga la verdadera pasión y el propósito que él tiene para usted. Si sufre desvío de la misión, estará yendo en contra de los impulsos internos de Dios que le brindan deleite. Ir en contra de esos impulsos internos significa que está haciendo cosas que no coinciden con sus dones, su pasión ni su gracia. Si está luchando contra la frustración constante, es hora de detenerse y reflexionar sobre las razones de ello y en cómo puede alinearse con el propósito de Dios para su vida. No desperdicie años transitando en la dirección equivocada.")]), _vm._v(" "), _c('p', {
    staticClass: "sbttl"
  }, [_vm._v("2. ¿Está sufriendo de agotamiento?")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Otra señal reveladora de que usted sufre de desvío de la misión es que tiene que trabajar duro para lograr las cosas por su propio esfuerzo. Cuando hace eso por mucho tiempo, siente agotamiento. Cuando navega a la deriva de la misión, no está caminando en obediencia al Señor. Por lo tanto, no está siendo sostenido por su gracia y, en cambio, está trabajando meramente con la fuerza carnal. Esto puede conducir pronto a un agotamiento emocional o espiritual si no se reajusta. Jesús le ha llamado a entrar en su reposo y a dejar de esforzarse por su propia cuenta (Mateo 11:28-30; "), _c('br'), _vm._v("Hebreos 4:9-11).")]), _vm._v(" "), _c('p', {
    staticClass: "sbttl"
  }, [_vm._v("3. ¿Falta fruto en su vida?")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Una persona a la deriva de la misión no maximiza su eficacia, lo que resulta en una falta de frutos. Usted es único y tiene una vocación como ninguna otra. Cuando está en su mejor momento, con respecto a su llamado, hace cosas que pocos pueden igualar, dando en el blanco de su propósito y llevando mucho fruto como Jesús nos instó a hacer (Juan 15:8).")]), _vm._v(" "), _c('p', {
    staticClass: "sbttl"
  }, [_vm._v("4. ¿Cómo permanece fiel al llamado original de Dios a su vida?")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("De vez en cuando reviso mi diario profético para asegurarme de que todavía estoy siguiendo el llamado original que Dios me dio cuando comencé a servirle hace más de treinta años. Los métodos pueden cambiar a medida que madure, pero la misión sigue siendo la misma ya que Dios nos eligió a cada uno de nosotros antes de la fundación del mundo y nos dio un propósito aun antes de que naciéramos (Efesios 1:4; 2 Timoteo 1:9). Cuando usted está a la deriva de la misión, se ha desviado del llamado original que Dios le hizo.")]), _vm._v(" "), _c('p', {
    staticClass: "sbttl"
  }, [_vm._v("5. ¿Está perdiendo el enfoque?")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("La actividad no necesariamente resulta en productividad. Muchas personas están muy ocupadas enfocándose en trivialidades y descuidando las cosas principales a las que Dios les ha llamado. No digo que deba descuidar las rutinas mundanas y ordinarias de su vida, sino que debe asegurarse de priorizar y administrar su tiempo en el marco de esas rutinas, de tal manera que las cosas más importantes se realicen primero. Si usted no prioriza su tiempo, sus actividades no coincidirán con su propósito.")]), _vm._v(" "), _c('p', {
    staticClass: "sbttl"
  }, [_vm._v("6. ¿Con qué frecuencia antepone las cosas a las personas?")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("El reino de Dios se construye sobre relaciones, no sobre el ministerio ni el trabajo. Todos somos llamados a invertir en relaciones clave, ya sea la familia inmediata, los hijos espirituales, los mentores o las personas indispensables con las que está llamado a “hacer vida”. Al enemigo le encantaría que antepusiera los programas a las personas, porque a fin de cuentas lo único que se llevará a la eternidad son las vivencias con esas personas, no los programas, los bienes raíces, el dinero ni las cosas materiales de la vida. Si usted no tiene tiempo de calidad para esas relaciones clave, lo más probable es que esté sufriendo un desvío de la misión. Necesita buscar proactivamente a aquellas personas que son más importantes para usted.")]), _vm._v(" "), _c('p', {
    staticClass: "sbttl"
  }, [_vm._v("7. ¿Qué tan bueno es usted para mantener lo principal como eso, lo principal?")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("El enemigo de lo “mejor” suele ser algo bueno. El enemigo no viene con un traje rojo y un tridente; viene como un ángel de luz. Por lo tanto, una de sus mejores estrategias es hacer que usted se concentre tanto en hacer algo bueno para Dios o su familia que se ciegue a lo que es mejor. Para evitar el desvío de la misión, siempre debe mantener primero lo primero y lo principal como lo principal.")]), _vm._v(" "), _c('p', {
    staticClass: "p _idGenParaOverride-1"
  }, [_vm._v("Mientras insista y reflexione en sus respuestas a estas siete preguntas, oro para que el Espíritu Santo lo convenza de su necesidad de explorar los principios que Jesús usó para liberar el propósito en sus seguidores. Lo que funcionó para sus discípulos funcionará para usted porque “Jesucristo es el mismo ayer, hoy y por los siglos” (Hebreos 13:8).")]), _vm._v(" "), _c('p', {
    staticClass: "CHAP--",
    attrs: {
      "id": "_idParaDest-3"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor002"
    }
  }), _vm._v("Capítulo 1")]), _vm._v(" "), _c('p', {
    staticClass: "CHAP-TITLE",
    attrs: {
      "id": "_idParaDest-4"
    }
  }, [_vm._v("Comprenda la identidad que Dios le dio")]), _vm._v(" "), _c('p', {
    staticClass: "pf"
  }, [_c('span', {
    staticClass: "SM-CAP",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("A través de ")]), _vm._v("muchas "), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("décadas de trabajar con personas, he descubierto que muchos simplemente no pueden darse cuenta de quiénes son en realidad. A menudo, esto se debe a que pasaron muchos años complaciendo a la gente y fingiendo ser lo que fuera para que los aceptaran en ese momento. Le digo que no se preocupe por lo que es, en vez de eso decida quién quiere ser y conviértase en esa persona. Le recuerdo que todos tenemos opciones y que Dios promete en Filipenses 4:13 que podemos hacer todas las cosas si le pedimos a Jesús que nos dé la fuerza.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Las personas están tan acostumbradas a ser dominadas y controladas que les da un gran alivio percatarse de cuánta libertad tenemos realmente como cristianos. A los egoístas les molesta que el cristianismo limite su capacidad de pecar, pero si usted se detiene y lo medita, cada pecado que podría cometer ha de dañar a alguien. ¿Por qué alguien querría pasar su vida usando y lastimando a las personas?")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Hace unos años escuché la historia de una empleada de una tienda de la cadena de supermercados Tom Thumb que, accidentalmente, le devolvió veinte dólares de más a un cliente. Cuando el hombre entró de nuevo a devolverle el cambio, la empleada se sorprendió mucho y dijo que nadie le había devuelto un dinero de más antes. Cuando ella le preguntó por qué lo hizo, él le dijo que valorarse a sí mismo por ser un hombre bueno y honesto valía mucho más que veinte dólares.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Cuando comencé a asesorar a un joven llamado Kristian con respecto a su potencial, propósito y llamado, nuestro tiempo juntos inició un proceso interno de recalibración, lo que provocó que su identidad cambiara gradualmente. Esto fue crucial en su vida porque uno debe cambiar la forma en que se ve a sí mismo antes de poder cambiar de comportamiento y, en última instancia, liberar su potencial para así lograr su propósito. Mientras usted crecía, su imagen propia puede haber sido empañada por palabras negativas que se dijeron sobre usted, ya sea en casa con sus padres y hermanos o en la escuela con sus amigos y compañeros de clase. Su nombre puede ser Joe o John, Susan o Christine, pero en su interior puede pensar que su nombre es “imbécil”, “idiota”, “fracasado” o “tonto”. Las palabras negativas que otros han dicho sobre usted lo marcan con una identidad negativa que tiene más poder e influencia que el nombre que le otorga su certificado de nacimiento. El poder de las palabras dichas sobre una vida no puede ser exagerado. Proverbios 18:21 enseña que “la muerte y la vida están en poder de la lengua”.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll-1"
  }, [_vm._v("Reciba su nuevo nombre")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Una de las cosas más importantes que deben ocurrir para que su potencial humano se libere es que su “nombre” interno debe cambiar. El hecho de que opte por seguir a Cristo y vencer las tentaciones de la carne le lleva a un punto en el que Jesús puede darle un nuevo nombre. Es por eso que una de las primeras cosas que hizo para liberar el potencial de Pedro fue cambiar su nombre de nacimiento, Simón, por su nombre divino, Pedro, que significa roca o piedra."), _c('sup', {
    staticClass: "sup _idGenCharOverride-2"
  }, [_vm._v("1")]), _vm._v(" En Mateo 16:18 vemos este proceso, aun más amplio, cuando Jesús dijo que edificaría su iglesia sobre la roca o "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("petra")]), _vm._v(", vocablo que en este contexto se refiere a una roca grande e inamovible."), _c('sup', {
    staticClass: "sup _idGenCharOverride-2"
  }, [_vm._v("2")]), _vm._v(" Jesús cambió el nombre de Pedro para que su imagen propia igualara el especial llamado a su vida y liberara su vasto potencial humano a fin de establecer la iglesia como el cuerpo de Cristo.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("También vemos este principio poderosamente ilustrado en la historia del gran patriarca Abraham. Cuando Dios cambió su nombre Abram, que simplemente significa “padre exaltado”, a Abraham —o “padre de multitudes”—"), _c('sup', {
    staticClass: "sup _idGenCharOverride-2"
  }, [_vm._v("3")]), _vm._v(" desató su fe para que su destino —bendecir a las naciones— pudiera realizarse. Tuvo que pasar de saberse padre a entender que Dios quería que fuera patriarca de muchas naciones, a pesar de que él y su esposa —Sarai (Sara)— eran ancianos, estériles y no tenían posibilidad natural de procrear hijos. Puedo imaginarme a ese hombre de noventa y nueve años, sin hijos, ordenando a sus más de trescientos sirvientes y a su esposa estéril que lo llamaran por la nueva identidad que Dios le concedió, ¡aunque pareciera una tontería a la luz de sus condiciones en ese tiempo!")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Romanos 4:16-22 afirma que Abraham pudo hacer eso al no considerar “su propio cuerpo, que estaba como muerto”, ni pensar en la esterilidad de la matriz de Sara; al contrario, creyó y habló lo que la Palabra de Dios decía acerca de ellos y no como el mundo natural los vio. Cuando Abraham aceptó su cambio de nombre y creyó lo que Dios le dijo, Sara y él pudieron tener el hijo de la promesa; a pesar de que él tenía cien años y Sara ya no estaba en edad de procrear hijos.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("En 2 Corintios, el apóstol Pablo nos advierte que consideremos a las personas según su identidad divina y no de acuerdo a su identidad carnal o terrenal.")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("Así que de ahora en adelante no consideramos a nadie según criterios meramente humanos [en términos de estándares naturales de valor]. Aunque antes conocimos a Cristo de esta manera, ya [tenemos tal conocimiento de él que] no lo conocemos así [en términos de la carne]. Por lo tanto, si alguno está [injertado] en Cristo [el Mesías], es una nueva creación [totalmente nueva criatura]. ¡Lo viejo [la condición moral y espiritual anterior] ha pasado, ha llegado ya lo nuevo!")]), _vm._v(" "), _c('p', {
    staticClass: "RIGHT-FLUSH",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("—2 Corintios 5:16-17")]), _vm._v(" "), _c('p', {
    staticClass: "paa"
  }, [_vm._v("Saulo persiguió a los cristianos porque juzgó a Jesús y a sus seguidores según la carne, como cualquier otro ser humano. Sin embargo, después de su conversión recibió su nuevo nombre —Pablo— y una nueva identidad que desató no solo su potencial humano sino el de incontables millones de personas años después de su vida natural.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Cuando vi a Kristian entrar a nuestra iglesia, no vi a un adolescente hispano sin padre ni propósito. Vi a un líder emergente con potencial para cambiar el mundo. También sabía que había sido asignado para guiarlo y desarrollar su potencial; por lo tanto, hablé de la identidad que Dios le dio, ¡la que lo ayudó a convertirse en la imagen de Cristo ante mis ojos! La gran noticia acerca de la salvación es que cuando usted entrega su vida a Cristo, se convierte en una nueva creación: lo viejo pasó y todas las cosas son nuevas. Aunque su apariencia física siga siendo la misma, ¡su verdadera identidad cambia instantáneamente a medida que Dios comienza a revelar su propósito divino y su llamado para su vida! Apocalipsis 2:17 promete que Jesús le dará “una piedrecita blanca en la que está escrito un nombre nuevo que solo conoce quien la recibe”. Este será un nuevo nombre especial y secreto que solo Jesús y usted entenderán.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Para liberar el potencial de los demás, debemos dejar de juzgar a las personas, según la carne, y comenzar a verlas con los ojos de Dios. En lo natural, puedo ver a una persona borracha o drogadicta, sin hogar o empobrecida, deprimida o fracasada en los negocios. No obstante, como creyente, soy llamado a ver a cada individuo con la identidad que Dios le ha dado para que pueda cambiar su nombre, reparar su propia imagen y liberar su vasto potencial humano. Como líder, estoy especialmente llamado a proyectar una visión a aquellos a quienes sirvo al traerles a la mente un sentido de su futuro para motivarlos a comenzar a liberar su potencial a partir de hoy.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll-1"
  }, [_vm._v("Cultive su vida espiritual")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("He descubierto que el hábito más importante que puedo ayudar a inculcar en otros para liberar su potencial es meditar en la Palabra de Dios. Las Escrituras enseñan que la transformación personal solo llega cuando la mente se renueva (Romanos 12:1-2). Aunque usted es una nueva creación al nacer de lo alto (2 Corintios 5:17), su mente y sus emociones tienen que pasar por un proceso de reprogramación de su patrón de pensamiento, lo cual puede llevar muchos años. Esto no es para salvación, sino para madurez y santificación.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Solo la Palabra de Dios puede limpiar y reconfigurar la mente humana para que sea santificada (Juan 17:17). Únicamente al reflexionar en los pensamientos de Cristo, puede usted romper las fortalezas que le ponen en prisiones internas y limitan su capacidad de crecimiento (2 Corintios 10: 3-5). Solo al conocer y entender la Palabra de Dios puede comprender si los pensamientos, ideas, conceptos y paradigmas que ha abrazado lo han limitado. ¡Es solo por la Palabra de Cristo que usted puede ordenar que esos pensamientos y conceptos eliminen su control sobre su persona!")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Es por eso que el apóstol Pablo le dijo a la iglesia de Filipos que la clave para vencer la ansiedad y caminar en paz era cultivar la vida espiritual (Filipenses 4:6-7) y caminar en un patrón de pensamiento saludable: “Por lo demás, hermanos, todo lo que es verdadero, todo lo honesto, todo lo justo, todo lo puro, todo lo amable, todo lo que es de buen nombre; si hay virtud alguna, si algo digno de alabanza, en esto pensad” (Filipenses 4:8 RVR1960). Los psicólogos de hoy conocen la ciencia subyacente a lo que Pablo escribió aquí. Un artículo de "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Psychology Today")]), _vm._v(" señala:")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("Todo pensamiento libera químicos cerebrales. Enfocarse en pensamientos negativos, efectivamente, le quita al cerebro su contundencia positiva, lo ralentiza y puede llegar a atenuar la capacidad de su funcionamiento, al punto que genere depresión. Por otro lado, tener pensamientos positivos, felices, esperanzados, optimistas y alegres disminuye el cortisol y produce serotonina, que crea una sensación de bienestar. Esto ayuda a que su cerebro funcione al máximo de su capacidad."), _c('sup', {
    staticClass: "sup _idGenCharOverride-2"
  }, [_vm._v("4")])]), _vm._v(" "), _c('p', {
    staticClass: "paa"
  }, [_vm._v("El artículo también señala que “el pensamiento negativo ralentiza la coordinación cerebral, lo que dificulta procesar los pensamientos y hallar soluciones”. El miedo afecta la actividad en el cerebelo, ralentizando “la capacidad del cerebro para procesar nueva información, lo que limita su capacidad para practicar la resolución creativa de problemas”. Sus pensamientos también pueden “reconectar potencialmente su cerebro al crear vías neuronales y sinapsis más fuertes. Lo que usted piensa y siente en cuanto a cierta situación o cosa puede estar tan profundamente arraigado que tendrá que trabajar fuerte a fin de desmantelar las conexiones negativas y volver a configurar su cerebro para tener menos miedo, pensar positivamente, creer que los sueños pueden hacerse realidad y confiar en que sus esfuerzos tendrán éxito”."), _c('sup', {
    staticClass: "sup _idGenCharOverride-2"
  }, [_vm._v("5")])]), _vm._v(" "), _c('p', {
    staticClass: "sbtll-1"
  }, [_vm._v("Medite en la Palabra de Dios")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Cuando Dios llamó a Josué para que tomara el lugar de Moisés como líder de la nación de Israel, le dijo que la clave de su éxito era meditar y proclamar la Palabra escrita del Señor. Así que le instruyó: “Nunca se apartará de tu boca este libro de la ley, sino que de día y de noche meditarás en él, para que guardes y hagas conforme a todo lo que en él está escrito; porque entonces harás prosperar tu camino, y todo te saldrá bien” (Josué 1:8 RVR1960). La orden que se le dio a Josué de meditar tenía que ver con susurrar las palabras divinas, reflexionar en esas palabras y considerarlas en su corazón para que pudiera verse a sí mismo y al mundo de la manera en que Dios lo hace para cumplir con su misión divina.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("El salmista dijo respecto de Dios: “He guardado tu "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("palabra")]), _vm._v(" en mi corazón, para no pecar contra ti” (Salmos 119:11 NTV). En otro lugar dijo: “Lámpara es a mis pies tu "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("palabra")]), _vm._v(", y lumbrera a mi camino” (Salmos 119:105 RVR1960). El apóstol Pablo, al asesorar a su protegido Timoteo, lo exhortó a seguir aprendiendo las Escrituras, las que le darían sabiduría para la salvación ya que “Toda la Escritura es inspirada por Dios, y útil para enseñar, para redargüir, para corregir, para instruir en justicia, a fin de que el hombre de Dios sea perfecto, enteramente preparado para toda buena obra” (2 Timoteo 3:16-17 RVR1960).")]), _vm._v(" "), _c('p', {
    staticClass: "CHAP--",
    attrs: {
      "id": "_idParaDest-5"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor003"
    }
  }), _vm._v("Capítulo 2")]), _vm._v(" "), _c('p', {
    staticClass: "CHAP-TITLE",
    attrs: {
      "id": "_idParaDest-6"
    }
  }, [_vm._v("Libere su potencial")]), _vm._v(" "), _c('p', {
    staticClass: "pf"
  }, [_c('span', {
    staticClass: "SM-CAP",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Kristian solo tenía ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("catorce años cuando entregó su vida al Señor y comenzó a asistir a nuestra iglesia. Su testimonio es poderoso.")])]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("Nací como resultado de una aventura adúltera que causó gran escándalo. Mi hermana fue la primera en nacer en esa circunstancia. Su nacimiento causó un gran revuelo, por lo que mi mamá decidió que la relación entre mi padre y ella debía terminar. Papá se negó a permitir que eso sucediera. Él decía: “Arruinaste mi vida; no puedes salir de esto tan fácil. Así que se acaba cuando yo lo diga”. De modo que irrumpía en su apartamento y la esperaba al final de su turno laboral o la acosaba todo el camino a casa desde el trabajo. Al fin, se unieron de nuevo y fui concebido. Cuando mi papá se enteró, estaba decidido a que lo ocurrido con mi hermana no volviera a suceder, así que llevó a mi mamá a la clínica de aborto tres veces. Cada vez que se trataba el caso, mi madre mentía y decía que estaba siguiendo las instrucciones. Cuando papá se daba cuenta de que ella le mentía, la golpeaba para forzarla a tener un aborto espontáneo. La tercera vez que mi madre fue a la clínica de abortos, una mujer la detuvo en el estacionamiento y le dijo: “No mates a este bebé. Dios tiene un plan para este niño”. Mamá se derrumbó y lloró. Esa noche abordó un avión y se dirigió a Puerto Rico con mi hermana. Así que me dio a luz en Puerto Rico y, a los seis meses de mi nacimiento, murió mi papá. Nunca lo conocí.")]), _vm._v(" "), _c('p', {
    staticClass: "paa"
  }, [_vm._v("Kris era el típico joven sin padre que vivía en las rudas y tumultuosas calles de Sunset Park en Brooklyn, Nueva York. Aunque fue criado por una heroica madre soltera que trató de mantenerlo en control, Kristian tenía un vacío emocional en su vida. No importa cuán capaz sea una madre, todos los hombres jóvenes necesitan una figura paterna en la cual apoyarse. De forma que cuando lo conocí vi un gran potencial en él. Entonces lo invité a vivir con mi familia para que pudiera tener la influencia de un padre, no solo la de un pastor los domingos. Durante los siete u ocho años que vivió con nosotros, se convirtió en parte de la familia; fue tratado como uno de mis hijos y aceptado por mis cinco hijos biológicos como su hermano.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Hice lo mejor que pude para aceptar a Kristian tal como era y no presionarlo en ninguna dirección en particular, dejando que él y Dios trataran sus asuntos. A los pocos años, manifestó su deseo de trabajar en el ministerio, por lo que se convirtió en uno de los líderes de la iglesia como asistente del director de jóvenes. Hasta que, en cierto momento, lo encargué de la juventud. ¡Pero después de unos meses sintió que eso era demasiado para él, por lo que sufrió un ligero colapso y dejó de asistir a los servicios! En vez de renunciar a él, me di cuenta de que le había asignado funciones de liderazgo prematuramente, así que lo puse de nuevo como asistente del ex director de la juventud.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("En otro momento de su proceso de crecimiento, se fue de Nueva York y se mudó a otro estado para vivir con un ministro amigo mío por seis meses. Durante ese momento difícil, me entristecí porque sentí que estaba huyendo en vez de lidiar con los problemas de su vida. Por dicha, Dios contestó mis oraciones y Kristian regresó a vivir con nosotros. Un año más tarde, a petición suya, volví a asignarlo como encargado de nuestro ministerio juvenil e hizo un trabajo extraordinario. Permaneció como director de nuestra juventud hasta que se la delegó a mi hijo menor, Justin, a quien ayudó a asesorar como mentor para que se encargara de ese ministerio.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Poco después, Kristian fue nombrado pastor y director de ministerios en nuestra iglesia, y resultó ser uno de los jóvenes líderes más sabios, más equilibrados y más talentosos que he visto. Comenzó a sustituirme en la predicación cuando yo me ausentaba de la iglesia e incluso entrenó a los líderes de nuestros ministerios. Finalmente, fue enviado desde nuestra iglesia para ayudar a plantar otra congregación. Poco después se convirtió en el pastor principal y elemento clave de un próspero movimiento de plantación de iglesias que surgió de su congregación local y que ha resultado en más de media docena de iglesias plantadas en solo unos pocos años, ¡algo inaudito en la ciudad de Nueva York! En verdad, hay varios flujos y reflujos en el desarrollo humano así como muchos picos y valles involucrados entre aquellos que cultivan el crecimiento y aquellos a quienes ayudan a liberar el potencial. En el caso de Kristian y el mío, todos los años de dolor y proceso han valido la pena."), _c('sup', {
    staticClass: "sup _idGenCharOverride-2"
  }, [_vm._v("1")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Como pastor y ministro desde 1984, he centrado la mayor parte de mi tiempo en el desarrollo del liderazgo. Uno de los aspectos más importantes en cuanto a desarrollar líderes, y uno de los más difíciles de lograr en el mundo, es hacer que las personas reconozcan y liberen el potencial humano que Dios les ha dado. Se ha dicho que el desayuno de los campeones no es cereal sino lucha. Liberar el potencial implica comprender y trabajar con los dones naturales de la persona: su tarea única y su vocación particular en la vida, así como las experiencias pasadas que han enmarcado su perspectiva de la vida. Muchas de las personas que acuden a nuestra iglesia provienen de familias destrozadas. El mayor obstáculo que tienen para liberar y maximizar sus dones y sus talentos es su propio miedo al fracaso, combinado —a menudo— con sentimientos profundamente arraigados de baja autoestima. Las malas experiencias y la información negativa que han recibido en el marco de las relaciones clave les dificultan creer en sí mismos.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Lograr que las personas crean en ellas mismas, a medida que comienzan a descubrir las habilidades que Dios les ha dado, es uno de los aspectos más importantes y gratificantes en lo referente a ayudar a liberar el potencial. Es interesante notar que Jesús, que es el mayor desarrollador de personas que jamás haya existido, dijo que sus discípulos se convertirían en pescadores de hombres. Convertirse, lo que significa cambiar o transformarse en algo, es un proceso por el que toda persona debe pasar si quiere liberar su potencial, aunque a menudo puede ser un viaje largo y difícil que requiere determinación y constancia.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll-1"
  }, [_vm._v("El proceso")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("No puedo explicar por qué Dios permite que haya tanto sufrimiento en este mundo pecaminoso, pero sé que consintió que su propio Hijo, Jesús, padeciera el más agudo dolor que cualquier otro ser humano haya sentido jamás. Es más, la Biblia afirma que Jesús sufrió y fue tentado en todas las formas que podamos suponer. Inmediatamente después de ser bautizado por Juan y que Dios lo declarara como su Hijo —en quien tenía complacencia—, el Espíritu Santo lo llevó a que protagonizara su propia experiencia en el desierto. Cada uno de nosotros enfrentará su propia experiencia en el desierto como parte del proceso para desarrollar nuestro potencial humano. La forma en que tratamos con esa experiencia determina hasta qué punto se ha de liberar nuestro potencial. Dios quiere que entendamos que el proceso es tan importante como el producto.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Sabemos que los hijos de Israel fueron guiados por Dios a través de su experiencia en el desierto con el expreso propósito de probarlos y exponer lo que realmente había en sus corazones, no hacia Dios sino hacia todos y cada uno de ellos. El apóstol Pablo, que escribió la mayor parte del Nuevo Testamento, testificó de muchas experiencias arduas y difíciles en el desierto mientras viajaba por Europa y Asia en sus muchas travesías misioneras. Sabemos, por sus poderosas cartas, que Dios había hecho una gran obra en él, transformándolo —del gran perseguidor que se nos presenta en Hechos capítulo 9— en el autor inspirado de la mayoría de las epístolas del Nuevo Testamento. Pablo escribió: “He sido crucificado con Cristo, y ya no vivo yo, sino que Cristo vive en mí. Lo que ahora vivo en el cuerpo, lo vivo por la fe en el Hijo de Dios, quien me amó y dio su vida por mí” (Gálatas 2:20).")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Con respecto al proceso que trae madurez a la persona, muchos en el cuerpo de Cristo están en una constante experiencia en el desierto, incluso en este día y época. El desierto es un lugar en Cristo en el que usted está fuera de la casa de la servidumbre, pero no está del todo en la tierra prometida. La tierra prometida es cuando camina en la plenitud del Espíritu y de propósito en Cristo Jesús. El desierto es un gran momento de prueba, confusión y frustración que puede sacar el lado oscuro de nuestras almas, porque constantemente nos enfrentamos a nuestro falso yo, que se manifiesta más mientras estamos en el fuego. Muchos santos de la antigüedad han llamado a este período “la oscura noche del alma”.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll-1"
  }, [_vm._v("Tentaciones comunes a todos")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Jesús, como el segundo Adán, no pecó en medio de la tentación, aun cuando sintió hambre y estaba en el desierto. Eso contrasta con el primer Adán, que pecó al comer del fruto prohibido mientras estaba en el paraíso con todas sus necesidades satisfechas.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Hay cuatro tentaciones principales por las que cada uno de nosotros pasa, basadas en la épica competencia entre Satanás y Jesús cuando estaba en el desierto, como se ve en las narraciones del evangelio (Lucas 4:1-13). Veamos cada una individualmente.")]), _vm._v(" "), _c('p', {
    staticClass: "sbttl"
  }, [_vm._v("Primera tentación: “Si eres Hijo de Dios”, es decir, la prueba de la identidad.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Una de las mayores pruebas que enfrentamos en el desierto es cuando comenzamos a dudar de nuestra identidad en Cristo. Satanás le dijo a Jesús: “"), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Si")]), _vm._v(" eres Hijo de Dios...” (Lucas 4:1, énfasis añadido). Cuando afrontamos tiempos de grandes pruebas y tribulaciones, el enemigo trata de hacernos dudar de nuestra salvación, de nuestra posición en Cristo como hijos y hasta de la realidad del cristianismo. Si puede hacer que perdamos nuestra identidad, entonces puede enmarcarnos en otra distinta. Por ejemplo, nuestra cultura o etnia puede convertirse en nuestra principal identidad y razón de existencia. En el transcurso de las pruebas, aun de las más severas, necesitamos centrarnos en Dios y escondernos e internarnos en él por nuestro nombre e identidad, si es que vamos a progresar, en vez de retroceder. (Ver Colosenses 3:3).")]), _vm._v(" "), _c('p', {
    staticClass: "sbttl"
  }, [_vm._v("Segunda tentación: “Convierte estas piedras en pan”, es decir, actuar.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("El enemigo trata de meternos en la trampa de la actuación o el desempeño, es decir, que debemos hacer buenas obras para probarnos a nosotros mismos y a Dios que merecemos la salvación y la gracia, o que intentamos lograr grandes cosas para Dios a fin de probarle a él y a nosotros que tenemos un valor intrínseco. El problema con esto es que todos estamos destituidos de la gloria de Dios. Una mentalidad así es como una pendiente resbaladiza que conduce a un punto en el que nunca estamos completamente satisfechos. No podemos ganarnos el amor de Dios con nuestros logros. Siempre quedarán muchas cosas sin hacer, o no hechas de la manera correcta, ya que somos humanos, seres falibles y pecadores. Cuando estamos acorralados en la trampa del desempeño, nos la pasamos trabajando cada vez más para agradar a Dios, aunque nos sentimos cada vez peor con nosotros mismos. Algunos incluso se sienten peor consigo mismos cuando oran y leen la Biblia más y más horas porque están tratando de ganarse el amor de Dios por medio de las obras.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Dado que no somos salvos por las obras, la única forma en que podemos agradar a Dios es estando en Cristo, que se ha convertido en nuestra sabiduría, redención y justicia (Efesios 2:8-9; 1 Corintios 1:30).")]), _vm._v(" "), _c('p', {
    staticClass: "sbttl"
  }, [_vm._v("Tercera tentación: “Salta del techo porque Dios te protegerá”, es decir, presunción.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("A menudo, cuando estamos en el desierto, se nos dificulta escuchar claramente la voz de Dios debido a la ansiedad y la frustración. Para compensar esa sensación, realizamos nuestras propias actividades con el fin de lograr algo para Dios. Sin embargo, necesitamos aprender la diferencia entre fe y presunción. Esta última es cuando hacemos nuestros propios planes y, después que están en marcha, le pedimos a Dios que los bendiga. Esto se debe a que hay una raíz de orgullo y cierto grado de independencia de Dios. El Salmo 19:13 incluye una oración que le pide a Dios que nos guarde de los pecados de presunción o soberbia: “Preserva también a tu siervo de las soberbias; que no se enseñoreen de mí; entonces seré íntegro, y estaré limpio de gran rebelión.”")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Muchos cristianos toman decisiones importantes sin obtener el consejo adecuado y sin esperar en el Señor para conocer su voluntad. Algunos se van del estado, dejan sus trabajos por otras posiciones o incluso se casan rápidamente sin orientación ni consejería matrimonial. Luego esperan que la iglesia y Dios bendigan sus decisiones, y cuando Dios no los bendice, se enojan con él y se apartan (Proverbios 19:3).")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Cuando fallamos en someter de manera congruente nuestros corazones a los designios de Dios y no usamos periódicamente su Palabra, nos comportamos de manera presuntuosa puesto que estamos fuera de su voluntad revelada.")]), _vm._v(" "), _c('p', {
    staticClass: "sbttl"
  }, [_vm._v("Cuarta tentación: “Inclínate ante mí y te daré el reino” o el pecado de esperar poder sin proceso ni dolor.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Satanás le ofreció todos los reinos del mundo a Jesús, en un instante, porque sabía que su objetivo final era que todos los reinos y reyes de la tierra vinieran a él y se inclinaran ante él en adoración. (Ver Daniel 7:13-14). La tentación de Jesús consistió en que recibiría en un instante lo que le hubiera llevado más de tres años y mucho dolor lograr. ¡Dios nunca pasa por alto el proceso y el dolor que viene con el proceso porque lo que se hace en usted, a menudo, es más importante que lo que se hace a través de usted!")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Dios siempre determina que el poder y el propósito deben estar rodeados de problemas y dolor para que cuando tengamos ese poder, ¡no anhelemos la gloria que viene con él! Cuando algo llegue con demasiada facilidad o si parece demasiado bueno para ser verdad, ¡probablemente no sea verdad o no sea bueno para usted! Muchos de nosotros queremos soluciones rápidas y respuestas instantáneas a nuestras situaciones, pero eso es solo como experimentar una subida de azúcar, que le estimula rápidamente por un corto tiempo, pero luego se siente cansado y necesita otra dosis de azúcar. En última instancia, lo arruina físicamente. En consecuencia, si está en el desierto, preste atención a las cuatro pruebas principales que Dios le permitirá experimentar. Después que Jesús pasó esas pruebas, estuvo listo para caminar hacia su destino y su propósito. Si hubiera fallado en una de esas pruebas, no habría sido apto para el ministerio y no habría podido redimirnos.")]), _vm._v(" "), _c('p', {
    staticClass: "p _idGenParaOverride-1"
  }, [_vm._v("En las temporadas difíciles de la vida, debemos imitar las respuestas de Cristo cuando fue probado en el desierto, de forma que podamos atravesarlo y entrar en nuestra tierra prometida. Buscar ser conformado a la imagen de Jesús implica desarrollar la actitud y la sabiduría de Jesús para que se pueda desatar más potencial. Para convertirnos en discípulos de Cristo, debemos permitir que él nos procese a fin de que podamos convertirnos en pescadores de hombres y en sus embajadores ante todas las personas con las que nos relacionemos. Mientras caminamos voluntariamente a través de nuestras experiencias en el desierto, pidiéndole a Dios que nos fortalezca y nos equipe aún más en lugar de rescatarnos, nos acercamos más y más a liberar todo nuestro potencial. “Así que, somos embajadores en nombre de Cristo, como si Dios rogase por medio de nosotros; os rogamos en nombre de Cristo: Reconciliaos con Dios” "), _c('br'), _vm._v("(2 Corintios 5:20 RVR1960).")]), _vm._v(" "), _c('p', {
    staticClass: "CHAP--",
    attrs: {
      "id": "_idParaDest-7"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor004"
    }
  }), _vm._v("Capítulo 3")]), _vm._v(" "), _c('p', {
    staticClass: "CHAP-TITLE",
    attrs: {
      "id": "_idParaDest-8"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor005"
    }
  }), _vm._v("De camino a Jerusalén")]), _vm._v(" "), _c('p', {
    staticClass: "pf"
  }, [_c('span', {
    staticClass: "SM-CAP",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("C")]), _c('span', {
    staticClass: "SM-CAP",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("uando comencé a ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("escribir este libro, me di cuenta de lo contracultural que era con respecto a la cosmovisión típica de la mayoría de los hombres estadounidenses. Aunque no solo es para hombres, como tal me relaciono más con lo que ellos luchan, de ahí este enfoque introductorio. En consecuencia, los hombres, en particular (creo que las damas pueden no luchar con los mismos desafíos culturales porque están configuradas de manera diferente), encontrarán que los principios de este libro son tanto un desafío para su mentalidad como revolucionarios con respecto al enfoque y la función de su vida. La razón para decir esto es que muchos individuos con los que me cruzo están deprimidos y tienen un deseo desmesurado de realizarse mediante los deportes, por lo que viven indirectamente a través de otros hombres a los que consideran héroes. Esto se debe a que en los deportes hay ganadores y perdedores claros, de modo que así satisfacen el deseo masculino de conquistar, a través del dominio de una habilidad. Además, debido a que se sienten sin propósito, los hombres necesitan desarrollar sus vidas a través de otros hombres o de un equipo con el que puedan identificarse, intentando llenar el vacío que tienen en sus corazones.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Parte de la razón por la que los hombres luchamos es por la perspectiva cultural estadounidense en que vemos la masculinidad, que se basa en un concepto individualista del destino que hemos adoptado del individualismo tosco que hemos heredado de personas como Thomas Jefferson y otros. También influye la búsqueda individualista del hombre perfecto o superhombre (por ejemplo, héroes mitológicos griegos como Atlas) que conquista el mundo para siempre, un concepto que hemos adoptado en este país y reflejado en nuestros héroes cinematográficos, como Superman, Batman, Daredevil, Black Panther, Spider-Man y otros. Esta búsqueda individualista del hombre perfecto o superhombre proviene de la influencia de la cultura griega en la occidental. El adulterio es otro síntoma del aburrimiento de un hombre consigo mismo que proviene de no tener un propósito general que guíe cada una de sus decisiones.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("En la cultura actual hay un énfasis en la nacionalidad, que se manifiesta en los desfiles y los estudios académicos étnicos, principalmente porque la cultura de uno se convierte en el reemplazo de la falta de un propósito general que trascienda esta vida física. Un síntoma obvio de esta falta de propósito general es la prevalencia del adulterio que tiene sus raíces en el aburrimiento del hombre consigo mismo. Desde mi perspectiva, primero soy cristiano y segundo estadounidense (o italiano o hispano, etc.). Para que entendamos cómo cumplir bíblicamente nuestro propósito, necesitamos “ir a Jerusalén”, lo que significa desear a Dios por encima de todo, incluso de la propia vida. Y necesitamos leer la Biblia con la mentalidad hebraica, en vez de interpretar al mundo a través de “Atenas” (el centro de la cultura griega hace dos mil años y el centro de la apologética —con filósofos cristianos del siglo tercero, como Clemente y Orígenes—, que influyó mucho en la iglesia con una cosmovisión helenista).")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll-1"
  }, [_vm._v("Rasgos de los principios de Jesús")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Como tesis de este libro, debemos entender los principios que Jesús usó para desplegar la grandeza en la humanidad, de manera que podamos pasar de ser personas ordinarias a individuos extraordinarios. Los principios de Jesús, verdaderamente, implican rasgos contraculturales que debemos adoptar si queremos cumplir nuestro destino. Examinemos cada uno de los cuatro que estudiaremos individualmente.")]), _vm._v(" "), _c('p', {
    staticClass: "sbttl"
  }, [_vm._v("Ser jugador de equipo")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Muchos hombres quieren que sus dones individuales resplandezcan. Sin embargo, a la hora de cumplir el destino, tenemos que parecernos más a un piloto del baloncesto —como Steve Nash, de los antiguos Phoenix Suns o Magic Johnson de los antiguos Angeles Lakers—, que a un golfista profesional, como Tiger Woods. El golf, a diferencia de la vida, es un deporte de una sola persona. Para tener éxito, los hombres necesitan aprender a aprovechar sus vidas rodeándose de personas que tengan fortalezas que ellos no tienen para compensar sus debilidades.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Ninguna persona tiene todos los dones —sabiduría, poder y otras habilidades— ni toda la experiencia que se requiere para triunfar en la vida. Dios ha dispuesto las circunstancias en nuestras vidas de cierta manera para que nos veamos obligados a depender del “equipo de ensueño” que él ya nos ha dado; solo debemos abrir los ojos de la fe y encontrar a los otros miembros del equipo. Primera de Corintios 12:8 enseña que Dios ha dado a unos una “palabra” de sabiduría, a otros una “palabra” de conocimiento porque —como individuos— todo lo que tenemos son fragmentos. Son los dones y talentos colectivos de un equipo que busca a Dios, mientras comparten notas, escuchan y hacen lo que el Espíritu dice, lo que podrá habilitar los destinos individuales.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("No es casualidad que Jesús escogiera a doce hombres, no solo a uno o dos, para que fueran sus apóstoles. Tampoco lo es que esos doce hayan tenido que aprender a caminar juntos, a crecer juntos, a desafiarse y levantarse como equipo para seguir a Jesús. Al igual que con los deportes en equipo, es a través de la red de dinámicas relacionales que aprendemos a madurar con nuestros dones y convertirnos en personas extraordinarias. Como hombres, necesitamos caminar en el destino corporativo para cumplir con nuestro destino individual.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("En la Biblia, los únicos que pueden cumplir su destino son los que se conectan a una iglesia local o a algún cuerpo corporativo; ella fue escrita para una nación (Antiguo Testamento) y para las iglesias de la ciudad (Nuevo Testamento). En la mentalidad judía era impensable estar fuera del campamento y seguir caminando en las promesas de Dios. En Números 12:14 vemos que el hecho de estar fuera del campamento era señal de maldición. ¡Sin embargo, hay aproximadamente cuarenta millones de cristianos estadounidenses que intentan servir a Dios sin conectarse a una iglesia local! Esto sería tan insensato como alguien que piensa que puede ir a Irak y derrotar a los terroristas solo. Pasajes bíblicos como Santiago 4:7 y Efesios 6:10-18 eran advertencias para que la iglesia local resistiera al diablo, no solo para los individuos. Los hombres deben llegar a un lugar donde dejen de lado su individualismo extremo para maximizar corporativamente su propósito en la vida.")]), _vm._v(" "), _c('p', {
    staticClass: "sbttl"
  }, [_vm._v("Construir y experimentar relaciones de pacto")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Muchos hombres estadounidenses y occidentales tienen dificultades para mostrar sus emociones o admitir cuando tienen una debilidad. ¡Es casi poco varonil llorar o admitir que uno no puede hacer algo!")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Con respecto a mostrar emociones, el hombre más grande que jamás haya existido —Jesucristo— fue una persona totalmente en contacto con sus emociones. En el Evangelio de Juan 11:35, Jesús lloró franca y profusamente; en Marcos 1:41, se compadeció; en Marcos 3:5, miró a la gente con ira; en Lucas 10:21, se llenó de alegría y en Juan 12:27 y Mateo 26:38 dijo que su alma (asiento de sus emociones) estaba muy triste.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Los hombres necesitan aprender que estar en contacto con los demás y expresar sus emociones, en realidad, los hace más capaces como varones, no menos varoniles. Los hombres sabios saben que necesitan relaciones responsables en las que puedan recibir consejo y aliento para seguir adelante. Por eso es importante que construyan y experimenten relaciones de pacto con otros hombres que estén dispuestos y sean capaces de ser vulnerables unos con otros. Tales relaciones son la clave principal que permite al individuo perseverar en su propósito. Fue algo liberador cuando vine a Cristo y comenzó a mostrarme que ha asignado a otros que me ministren y me ayuden cuando esté débil. He notado que aquellos que se aíslan, cuando empiezan a luchar, ya no están en la fe que he guardado, por su gracia, desde 1978.")]), _vm._v(" "), _c('p', {
    staticClass: "sbttl"
  }, [_vm._v("Honrar a los padres espirituales")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("La Biblia nos enseña a levantarnos en presencia de los ancianos (Levítico 19:32). En Oriente tienden a honrar a las personas mayores, pero en la cultura estadounidense el mercadeo de la mayoría de los productos y programas televisivos es para personas de entre dieciocho y treinta y cinco años (excepto los anuncios farmacéuticos) porque en esta nación glorificamos tres cosas: ¡el sexo, el poder y el glamur! Durante mucho tiempo hemos alentado a los hombres mayores a dejar de trabajar y retirarse al Estado de Florida para pasar el resto de sus vidas jugando al golf y viendo televisión. Esta mentalidad incluso está incrustada en los trabajos municipales y federales de algunos lugares. Hace poco estuve con un hombre que se vio obligado a jubilarse del Departamento de Policía de Nueva York solo porque cumplió sesenta y dos años, a pesar de que estaba sano y activo en su trabajo por más de treinta y cinco años y pese a que tenía una gran experiencia que compartir con los hombres y mujeres de azul más jóvenes.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("No existe tal cosa como la jubilación en las Escrituras. En términos bíblicos, cuanto más envejece la persona, más entiende de Dios y más experiencia tiene para compartir con los demás. Dios me mostró, hace años, que mi mayor ministerio comenzará cuando cumpla sesenta y cinco años. Tengo muchas ganas de envejecer porque entiendo que los mejores años de mi vida, con respecto al impacto que tendré en este mundo, están delante de mí, no detrás. Los hombres estadounidenses necesitan rodearse de pares mayores a los que puedan respetar y honrar para que puedan construir sobre sus hombros y hacerlo aun mejor en vez de menospreciarlos y dejarlos de lado. Verdaderamente todos los hombres necesitan mentores mayores, maduros y semejantes a Cristo que los asesoren para que alcancen su destino. Aunque Jesús solo tenía treinta años cuando comenzó a ministrar (Lucas 3:23), en realidad, existió antes que Abraham (Juan 8:58) y dio entrada a sus doce como el Anciano de Días (Daniel 7:9-10; Apocalipsis 1:13-15). Fue solo después de que sus discípulos caminaron con él, varios años, que ascendió al cielo y les confió la construcción de su iglesia.")]), _vm._v(" "), _c('p', {
    staticClass: "sbttl"
  }, [_vm._v("Vivir con propósito")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Los hombres que no tienen un propósito en la vida tienden a entregarse a los deseos de la carne y son los más miserables de todas las personas. He encontrado que mi mayor alegría es cuando termino el trabajo que el Señor me ha dado en cuanto a una tarea en particular. Entonces, cuando me sereno, ¡me llena un sentimiento espiritual eufórico que es mayor que cualquier placer físico (Juan 17:4)! Todos los hombres nacieron con un deseo innato de nutrir y proteger a sus familias, empoderar a los desamparados y morir por una causa mayor que ellos mismos. Aquellos a quienes les falte aunque sea uno de estos elementos en sus vidas, caminarán deprimidos por sentir falta de realización interior o serán adictos a algún placer porque tratan de medicarse para ahogar la poderosa voz de Dios que los insta a cumplir su vocación en la vida.")]), _vm._v(" "), _c('p', {
    staticClass: "sbttl"
  }, [_vm._v("La importancia de la paciencia")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Uno de los atributos más importantes que se necesitan para liberar el potencial es la paciencia. A medida que avanzamos en el proceso de edificación de Dios, debemos ser pacientes con nosotros mismos y con aquellos a quienes estamos llamados a dirigir o guiar. Leemos en Números 14:20-38 que toda una generación de los hijos de Israel no logró alcanzar su potencial y entrar en la tierra prometida porque se llenaron de incredulidad y cedieron a murmurar y quejarse contra el Señor. Se impacientaron con el proceso de Dios y perdieron su herencia.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("En lugar de destruir a toda la nación por su pecado e incredulidad, Dios esperó pacientemente hasta que la siguiente generación estuviera lista para tomar la tierra prometida. Esto nos enseña que Dios no nos promoverá a menos que pasemos las pruebas de fe y paciencia en nuestras experiencias por el desierto. También nos recuerda que los propósitos de Dios no se pueden frustrar, ni siquiera por nuestra impaciencia. Si no estamos dispuestos a hacer lo que sea necesario para cumplir los planes de Dios, estos se harán realidad a través de la próxima generación.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Cuando Jesús escogió a sus futuros líderes, sabía que le tomaría varios años de trabajo llevarlos al punto donde pudieran caminar en su propósito divino. Tuvo que ejercitar gran paciencia con aquellos que eligió para que lo siguieran. Pedro, por ejemplo, era un pescador rudo y compulsivo dado a los arrebatos emocionales. Juan el amado, que escribió los grandes pasajes sobre el amor en 1 Juan 3 y 4, inicialmente tenía tan mal genio que Jesús le dio a él y a su hermano Santiago el nombre de “hijos del trueno”.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Durante tres años, los discípulos fueron testigos directos del poderoso potencial disponible para aquellos que siguieron el ejemplo del Maestro. Cuando Jesús los envió de dos en dos para poner en práctica las lecciones que habían aprendido a sus pies, regresaron con gran gozo, anunciándoles que aun los demonios se les sometían cuando ejercían su autoridad en su nombre. Sin embargo, a medida que Jesús se acercaba al momento de su arresto y crucifixión, encontró a todos sus discípulos durmiendo y no orando. Un miembro de su círculo íntimo, Judas, lo traicionó ante sus enemigos y luego se ahorcó debido a su culpa.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Los otros discípulos lo dejaron y huyeron atemorizados cuando fue arrestado. Pedro, la roca sobre la cual Jesús iba a edificar su iglesia, incluso negó conocer a Jesús. ¡Realmente se necesita mucha paciencia para ayudar a otros a darse cuenta y liberar su potencial! También es cierto que no hay un trabajo más significativo al que se nos convoque que comprometernos con el éxito de otra persona y ayudarla en su búsqueda para caminar en el propósito de ella. Recuerde que cuando fallamos, también necesitamos paciencia con nosotros mismos. Proverbios 24:16 dice: “Aunque los justos caigan siete veces, se levantarán de nuevo”.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Debido a que la iglesia a la que ayudé a ser pionera estuvo, en cierto momento, en una comunidad de bajos ingresos; tuvimos que nutrir a los líderes servidores indígenas en vez de contratar ministros ya establecidos. Eso resultó ser una gran bendición para mí, en lo personal, porque me ha obligado a concentrarme en la madurez de los líderes antes que buscar personas experimentadas que sirven por un salario y no comparten mi visión o carecen de un corazón leal a nuestra iglesia y nuestra misión. He tenido que aprender a resolver desafíos de liderazgo revisando primero los que ya teníamos con nosotros. La mayoría de las veces, los recursos humanos que necesitamos para cualquier situación los tenemos a nuestra disposición. Solo tenía que aprender a liberar el potencial.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Por más difícil que sea ayudar a la gente a madurar, observo que el maestro aprende tanto o más que el alumno. En el proceso de ayudar a las personas con sus desafíos, me encontré estirado y forzado a practicar lo que les he estado predicando a otros. Hay obstáculos comunes a todos nosotros en el proceso de crecimiento y aprendizaje. Mientras dirijo a otros, tengo que superar continuamente esos obstáculos en mí mismo para mantener el nivel de mis propias habilidades lo suficientemente alto como para empoderar a otros para que alcancen su potencial “máximo”. Si voy a atraer a aquellos con el potencial de una influencia de alto impacto, entonces tengo que mantenerme a la vanguardia del juego y continuar creciendo y liberando mi propio potencial. Muchos pastores y líderes organizacionales pierden a su gente más productiva porque han dejado de crecer en lo personal. Cuando los que están debajo de ellos al fin los superen y descubran que ya no pueden crecer, buscarán —en otra parte— oportunidades para desarrollarse y liberar más de su propio potencial.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Si me llaman para ayudar a una persona que se ha puesto limitaciones a sí misma por baja autoestima y experiencias negativas pasadas, tengo que asegurarme de que no me estoy limitando por mi pasado. Si la persona a la que estoy asesorando no es emocionalmente madura y no tiene la disciplina y el enfoque necesarios para sostener el crecimiento personal a largo plazo, necesito ser muy maduro emocionalmente para caminar en amor y no reaccionar de manera exagerada ante su descamación o falta de disciplina. Cada vez que invertimos nuestro tiempo en otras personas, deberíamos crecer en el proceso. Proverbios 11:25 dice que “el que riega, él mismo será regado”.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll-1"
  }, [_vm._v("Cinco etapas del desarrollo espiritual")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Al reflexionar sobre mi propia travesía, además de observar las vidas de muchos otros creyentes, he llegado a la conclusión de que hay al menos cinco etapas principales de desarrollo espiritual. Baso esto en casi cuatro décadas de ministerio en la iglesia y el mercado, lo que incluye servir como pastor principal desde 1984. Es importante que entendamos estas cinco etapas para que no nos confundamos cuando hacemos la transición de una etapa a la siguiente. Sin embargo, hay algunos que atrofian su propio desarrollo por la desobediencia a su llamado. Esto da como resultado que no experimente nada más allá de la segunda etapa. Además, no hay un tiempo establecido para cada etapa, y dado que estoy usando un trazo amplio, cada etapa puede superponerse a otras. Dicho esto, hay verdad en estas observaciones generales. Mi objetivo es animar a los creyentes a avanzar a través de las cinco etapas, sin importar lo difícil que sean.")]), _vm._v(" "), _c('p', {
    staticClass: "sbttl"
  }, [_vm._v("1. La etapa de la luna de miel")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Esta es la etapa en la que estamos entusiasmados con nuestra salvación recién encontrada. Jesús nos dijo que nos regocijáramos porque nuestros nombres están escritos en el Libro de la Vida (Lucas 10:17-20). En esta fase no estamos pensando en nuestro llamado; simplemente estamos emocionados porque encontramos una nueva vida en Cristo. ¡Nada más importa, excepto Jesús! Es como cuando alguien se enamora por primera vez de esa persona especial, y los sentimientos románticos —junto con la piel de gallina— le asombran tanto que no puede imaginar que algún desaparezca. Sin embargo, por muy buena que sea esta etapa, Dios nos impulsa a pasar a la siguiente, que es la experiencia.")]), _vm._v(" "), _c('p', {
    staticClass: "sbttl"
  }, [_vm._v("2. La etapa experiencial")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("En esta fase comenzamos a descubrir cómo caminar con Dios y empezamos a aprender cómo procesar nuestra fe ante los desafíos y las minucias de la vida cotidiana. Es aquí, en la etapa experiencial, que aprendemos cómo aplicar la fe a nuestra propia vida, a la familia, a nuestras esferas de influencia y responsabilidades. Esta es también la fase en la que aprendemos a responder y arrepentirnos en medio de nuestras propias faltas y pecados. En este nivel también comenzamos a aprender cómo “ocuparnos en [nuestra] salvación con temor y temblor” (Filipenses 2:12). Por lo general, en esta fase las pruebas son útiles para revelar nuestro corazón, nuestras motivaciones y el nivel de compromiso con Cristo. Esta es la etapa que Jesús enseñó en la parábola del sembrador y la semilla, que ilustra cómo se apartan las personas de él porque no tienen raíces fuertes debido a la persecución y la falta de comprensión de la Palabra de Dios (Marcos 4).")]), _vm._v(" "), _c('p', {
    staticClass: "sbttl"
  }, [_vm._v("3. La etapa de descubrimiento")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Esta es la fase en la que, por primera vez, nos damos cuenta de que tenemos un propósito y un llamado en Cristo. Es una etapa emocionante, ya que nos damos cuenta de que no solo fuimos salvos para ir al cielo, sino para caminar en un propósito divino. Aquí es cuando nos damos cuenta, por primera vez, de que Dios nos ha llamado a hacer un gran impacto en nuestras esferas de influencia, ya sea con pocos o con muchos. Aquí, en la etapa de descubrimiento, el Espíritu de Dios nos desafiará a ser responsables como sus mayordomos para manifestar su reino en la tierra como lo es en el cielo (Lucas 11:2-4).")]), _vm._v(" "), _c('p', {
    staticClass: "sbttl"
  }, [_vm._v("4. La etapa de la pasión por caminar con propósito e identidad")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Después que descubrimos el hecho de que tenemos un propósito, casi nos obsesionamos con identificarlo a través del análisis de nuestros dones, habilidades y personalidad naturales, así como por medio de lo que sentimos que Dios nos insta a hacer. Esta es la etapa en la que aprendemos a llevar una vida con propósito y comenzamos a invertir nuestro tiempo en aprender y crecer en nuestra capacidad como seguidores de Cristo. Esta es también la fase en la que empezamos a filtrar nuestros compromisos y nuestras relaciones para que podamos optimizar nuestro enfoque y dar en el blanco de nuestro llamado divino. Aunque es apasionante, no es la más importante. Hasta hace poco pensé que esta, en particular, era la más gratificante y la más alta de todas las etapas; sin embargo, la siguiente es, por mucho, la más importante.")]), _vm._v(" "), _c('p', {
    staticClass: "sbttl"
  }, [_vm._v("5. La etapa del unísono")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Esta quinta etapa es cuando experimentamos tal unidad con Cristo que ya no nos obsesionamos con nuestro propósito o identidad porque hemos perdido nuestra vida funcional en él (Gálatas 2:19-21). La oración de Jesús al Padre fue que sus seguidores fueran “uno” con el Padre y con él (Juan 17:20-24). Aunque hay un elemento posicional y legal en la unidad que no tiene nada que ver con nosotros, mi experiencia me ha demostrado que también hay una unidad existencial y experiencial. Algunos incluso pueden etiquetar esta etapa como mística. Me he referido a ella como “unísono” porque describe la realidad de perderse uno mismo en él hasta el punto en que nuestros deseos, planes y pasiones emanan de su corazón y su voluntad. En esta etapa usted está caminando en libertad y en una comunión casi ininterrumpida con él mientras está aun más consciente de sus propias deficiencias, sus motivaciones y sus deseos impíos. En esta etapa, no solo atesora sus momentos de alabanza y adoración a Dios, sino que comienza a aprender a deleitarse en hacer su voluntad, sin importar cuán dolorosa y triste pueda parecer en ese momento (Hebreos 12:1-2).")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("En esta fase aprendemos que la expresión más alta de amar a Dios no es solo disfrutar de la persona y la presencia suya, sino el hecho de poner nuestro cuerpo —nuestra carne— en la cruz y obedecerle sin quejas ni remordimientos (Lucas 22:42; Romanos 6:6-9). En esta etapa vivimos para expresar únicamente a Cristo, por lo que todo lo demás —incluido nuestro propósito individual—, se vuelve aburrido y poco atractivo en comparación con su esplendor y su majestad.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Descubrí la etapa del unísono inicialmente por la preocupación de que me había aburrido pensando en mi propósito e identidad. No era que ya no me interesara mi llamado; al contrario, ¡ahora estoy más apasionado que nunca por servir a Cristo! Fue que me encontré tan consumido, enamorado e identificado con Jesús que intuitivamente supe que mi llamado se desarrollaría en forma orgánica mientras continuaba caminando en sus pasos. ¡He descubierto que Cristo es todo (Colosenses 1:16-19)!")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Al reflexionar también descubrí que cuando nos obsesionamos o apasionamos por nuestro propósito divino, es posible que todo se trate de nosotros y no de él. Además, apasionarnos por nuestro propósito muestra aun más madurez espiritual que las primeras tres etapas, pero no es el nivel más alto de fe y práctica. Las Escrituras nos informan que el apóstol Pablo dijo que el supremo llamamiento de Dios era conocer a Cristo Jesús al punto que consideremos todas las cosas como basura, a fin de ganar a Cristo (Filipenses 3:4-11).")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("La tentación aquí, por supuesto, es pensar que usted ya está en la quinta etapa porque su espíritu salta cuando lo lee y su mente racional está de acuerdo con el concepto. Sin embargo, se necesitan años de quebrantamiento, internamiento en las Escrituras y crecimiento tanto emocional como espiritual antes de que comience a captar este grado unísono. Por supuesto, nadie llegará completamente a la etapa del unísono, porque sondear las profundidades del conocimiento y el amor de Dios es una tarea para toda la eternidad. Todo lo que digo es que ahora estoy consciente y experimentando esta etapa porque en verdad no me impresionan y me aburren todas las nociones de engreimiento, logros y cualquier cosa menos que conformarme a su imagen (Romanos 8:29-30).")]), _vm._v(" "), _c('p', {
    staticClass: "p _idGenParaOverride-1"
  }, [_vm._v("En conclusión, mi oración es que las verdades sobre el proceso de madurez en Cristo nos animen a todos a continuar avanzando en el conocimiento del Señor (Oseas 6:3) y “que os dé, conforme a las riquezas de su gloria, el ser fortalecidos con poder en el hombre interior por su Espíritu; para que habite Cristo por la fe en vuestros corazones, a fin de que, arraigados y cimentados en amor, seáis plenamente capaces de comprender con todos los santos cuál sea la anchura, la longitud, la profundidad y la altura, y de conocer el amor de Cristo, que excede a todo conocimiento, para que seáis llenos de toda la plenitud de Dios” (Efesios 3:16-19 RVR1960).")]), _vm._v(" "), _c('p', {
    staticClass: "CHAP--",
    attrs: {
      "id": "_idParaDest-9"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor006"
    }
  }), _vm._v("Capítulo 4")]), _vm._v(" "), _c('p', {
    staticClass: "CHAP-TITLE",
    attrs: {
      "id": "_idParaDest-10"
    }
  }, [_vm._v("Cómo entender la afirmación")]), _vm._v(" "), _c('p', {
    staticClass: "pf"
  }, [_c('span', {
    staticClass: "SM-CAP",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("H")]), _c('span', {
    staticClass: "SM-CAP"
  }, [_vm._v("e observado que ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("la mayoría de los comentarios que recibimos a diario son negativos. Ya sean los horribles reportes a los que estamos expuestos con los medios o las interacciones que tenemos con la familia, los compañeros de trabajo y los jefes, la gran mayoría de la información que recibimos es negativa, ya sea sobre otra persona o sobre nosotros mismos. El autor y experto en crecimiento personal, Shad Helmstetter, dijo: “Hasta el 77 % o más de todo lo que se registra y almacena en nuestra mente subconsciente es contraproducente y funciona en contra nuestra; en resumen, la mayoría estamos programados para no tener éxito”.")]), _c('sup', {
    staticClass: "sup CharOverride-2"
  }, [_vm._v("1")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v(" Por tanto, ¿cómo enfrentamos el pensamiento negativo? Podemos hacerlo con la afirmación. Esta ayuda a neutralizar la negatividad. He oído decir que se necesitan treinta palabras de afirmación para neutralizar un golpe negativo a la autoestima de una persona. La Biblia habla claramente sobre el poder de las palabras. “Del fruto de la boca del hombre se llenará su vientre; se saciará del producto de sus labios. La muerte y la vida están en poder de la lengua, y el que la ama comerá de sus frutos” (Proverbios 18:20-21 RVR1960).")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Los líderes tienen la capacidad de motivar a las personas para que se comprometan a largo plazo (con una causa) basándose en la comunicación de una visión convincente. Jesús nos mostró esto de una manera maravillosa. Por lo tanto, la visión permite que las personas visualicen un futuro mejor que el que ellos mismos poseen y crean mediante la asignación y utilización adecuada de sus dones y talentos.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Cuando Kristian vino por primera vez a nuestra iglesia, lo único que vio y sintió fue el perdón de Dios y el gozo de la salvación. No estaba pensando en nada más que en el hecho de que estaba en camino al cielo. Pero cuando lo vi, no solo observé a un nuevo creyente; también sentí su llamado a ser predicador del evangelio y líder prominente. Parecía muy dotado en esas áreas y tenía un claro deseo de ayudar a los demás. Como pastor, uno de los trabajos más importantes que tengo es descubrir y declarar el futuro de las personas, aunque ellas mismas no puedan verlo por ignorancia espiritual o por sus autolimitaciones.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("De inmediato llevé a Kristian a uno de mis grupos de mentores, comencé a pasar mucho tiempo con él y lo hice viajar conmigo cuando iba a ministrar en otras iglesias. Aunque no entendía lo que estaba pasando, lo estaba asesorando y preparando para su futuro; primero como hombre y, segundo, como ministro del evangelio.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("No mucho después de su conversión, comencé a declararle lo que veía en su futuro para que comenzara a creerlo y tuviera algo por lo cual trabajar en su vida. Aunque lo que le dije no eran palabras que nadie más le hubiera dicho, él las recibió porque simplemente estaba haciendo eco de lo que Dios ya había incrustado en su alma. Cuando le conté sobre su llamado especial y lo afirmé en sus dones y talentos, comenzó a abrazar la visión de lo que podría llegar a ser. A medida que esa visión se hizo real para él, comenzó a liberar su potencial. Empezó a compartir el evangelio en la calle y a ganar personas para Cristo. En un año se convirtió en un líder de grupo pequeño seguro y eficaz, ayudando a otros a crecer y liberar su potencial. Su asombroso paso de un típico adolescente sin padre, sin propósito en la vida, a un líder relevante comenzó con palabras de afirmación y fe que le dieron una visión de su futuro.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Cuando Jesús conoció por primera vez a Simón Pedro, Santiago y Juan, estaban asociados en un negocio de pesca, creyendo que su único propósito en la vida era trabajar duro todo el día para ganarse el sustento para sus familias. Para que Jesús desencadenara su llamado superior, que era convertirse en pescadores de hombres para el reino de Dios, no podía simplemente predicarles. Tenía que entrar en su mundo, por lo que abordó su bote y navegó con ellos. Jesús vio los pensamientos más íntimos de ellos y lo que iban a ser en el futuro cuando se desatara su potencial. Después de demostrar que él era el Señor del reino animal y que podía pescar más peces en un momento que los que ellos podrían capturar toda esa noche, proveyendo más que adecuadamente para ellos y sus familias, estuvieron listos para escuchar lo que él tenía que decirles. Jesús, entonces, podía hablarles en visión y, como resultado, abandonaron sus negocios para seguirlo y aprender de él.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Pero esto fue solo el comienzo del proceso que Jesús usaría para liberar el potencial humano de sus discípulos. Tuvo que seguir recordándoles su llamado, corrigiéndolos, afirmándolos y guiándolos por el camino correcto. Tuvo que enseñarles pacientemente y modelarles cómo ser pobres en espíritu y llorar los pecados de los demás. Tuvieron que aprender a ser pacificadores amables y misericordiosos que pudieran soportar la persecución por causa de la justicia. Jesús les demostró cómo llevar una vida de obediencia a la Palabra de Dios para que pudieran traer luz a un mundo en tinieblas y ser sal para aquellos que necesitaban sanidad física, emocional y espiritual. Jesús habló a sus vidas, diciéndoles que algún día harían obras mayores que las que él hizo.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll-1"
  }, [_vm._v("Equilibre la corrección con la afirmación")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Uno de los ingredientes clave que usó Jesús para desplegar el potencial de sus discípulos fue equilibrar la corrección con la afirmación. Incluso él mismo no comenzó su ministerio hasta que su Padre lo afirmó. Leemos en el Evangelio de Mateo que el Padre dijo: “Este es mi Hijo amado, en quien tengo complacencia” (3:17). Esta afirmación del Padre preparó a Jesús para enfrentar la tentación de Satanás y entrar en el ministerio de tiempo completo. Una de las razones por la que muchos fracasan en sus vidas y en su llamado es que no han recibido afirmación de sus mentores, lo que los prepara para la guerra espiritual y la tentación que seguramente vendrá. Sin la afirmación adecuada, la baja autoestima y la falta de confianza pueden hacer que muchos vacilen y renuncien cuando los tiempos se pongan difíciles. Recordar palabras de afirmación y saber que nuestros mentores están de nuestro lado nos da el coraje que necesitamos para continuar con las experiencias de nuestra vida a pesar de todas las tentaciones y pruebas que enfrentemos en el camino.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Jesús ejercitó esto con sus discípulos. Por ejemplo, cuando vio a Natanael venir a él, Jesús le dijo que era un israelita que no tenía engaño (Juan 1:47). Del mismo modo, llamó a Simón la “roca” sobre la cual edificaría su iglesia (Mateo 16:18-19) a pesar del hecho de que Simón era impetuoso e iba a traicionar a Jesús en un futuro cercano. El Señor usó palabras para ayudar a moldear, motivar y formar a sus seguidores, lo que los liberó a su propósito a través del poder de la afirmación.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("También hay numerosos ejemplos de la manera en que Jesús usó el poder de las palabras de afirmación (y, a veces, el poder de un toque físico) para sanar a una persona:")]), _vm._v(" "), _c('ul', [_c('li', {
    staticClass: "BULLET-1"
  }, [_vm._v("Jesús echó fuera muchas malas influencias de demonios con una palabra (Mateo 8:16).")]), _vm._v(" "), _c('li', {
    staticClass: "BULLET-2"
  }, [_vm._v("Jesús sanó a un leproso con una palabra de afirmación y un toque personal (Marcos 1:40-45; Lucas 5:12-16).")]), _vm._v(" "), _c('li', {
    staticClass: "BULLET-2"
  }, [_vm._v("Jesús pronunció una palabra y le dijo a un mendigo ciego que podía recibir la vista (Marcos 10:46-52).")]), _vm._v(" "), _c('li', {
    staticClass: "BULLET-2"
  }, [_vm._v("Jesús dijo una palabra y expulsó el espíritu de debilidad de una mujer encorvada por dieciocho años (Lucas 13:11-13).")]), _vm._v(" "), _c('li', {
    staticClass: "BULLET-2"
  }, [_vm._v("Jesús cambió la vida de la mujer junto al pozo ofreciéndole agua viva (Juan 4:7-30).")]), _vm._v(" "), _c('li', {
    staticClass: "BULLET-2"
  }, [_vm._v("Jesús le dijo a un hombre enfermo con espíritu de víctima que se levantara, recogiera su camilla y caminara (Juan 5:1-9).")])]), _vm._v(" "), _c('p', {
    staticClass: "paa"
  }, [_vm._v("En lo personal, he sentido el impacto del poder de las palabras pronunciadas sobre mi vida por mentores y supervisores. En mi condición de joven que maduraba en mi llamado ministerial, recuerdo cómo las palabras de mi padre espiritual tenían el poder de traer gran gozo a mi vida o gran confusión y depresión.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Una forma en que pude intuir quién era mi padre espiritual fue cuando me preocupé por lo que un supervisor en particular pensaba de mí. Esa fue una señal de que Dios nos conectó en una relación padre-hijo. Esto se debe a que sabía que parte del papel del padre es dar la afirmación que tanto se necesita, así como el Señor Jesús necesitaba la afirmación de su Padre antes de ministrar (Lucas 3).")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Recuerdo una vez que pasé horas conduciendo para pasar tiempo con mi supervisor original, que se había mudado del pastorado en el que servía. Cuando llegué allí, sus planes cambiaron y me dio dinero para que pudiera comprarme algo para cenar. Aunque tenía buenas intenciones, no entendía cómo su falta de atención hacia mí me aplastaba emocionalmente. En ese momento supe que ya no era una prioridad para él (debido a que se mudó fuera del estado), y comencé a orar para encontrar otro supervisor que también me sirviera como padre espiritual. Por la providencia de Dios, finalmente me conecté con mi supervisor actual, John Kelly, que ha sido un extraordinario padre espiritual para mí desde 1989. Dios lo ha usado tremendamente para moldearme y formarme a través de sus palabras, habilidades estratégicas y ministerio poderoso. ¡Yo no estaría donde estoy hoy sin su función como padre espiritual!")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("El poder de afirmar palabras y acciones también ha sido integrado biológicamente por Dios para afectar a toda la persona, incluso según la ciencia. Tomemos por ejemplo la forma estratégica en que Dios diseñó el cerebro humano, integrando todas sus partes. Hablando en términos biológicos, Dios creó nuestros cerebros para que tuvieran una parte intelectual, la corteza cerebral, y una parte emocional, el sistema límbico (con la forma parecida a una salchicha que va desde la frente hasta la parte posterior de la cabeza, debajo de la materia gris, a la que estamos acostumbrados a ver cuando observamos imágenes del cerebro). Según el Centre for Neuro Skills, “el tronco encefálico juega un papel vital en la atención básica, la excitación y la conciencia. Toda la información hacia y desde nuestro cuerpo pasa a través del tronco encefálico en el camino hacia o desde el cerebro”."), _c('sup', {
    staticClass: "sup _idGenCharOverride-2"
  }, [_vm._v("2")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Hay millones de conexiones entre las tres partes de nuestro cerebro. Algunas personas son demasiado emocionales y no usan su parte intelectual, haciendo lo que sea que sus impulsos emocionales los lleven a hacer. Otros son demasiado intelectuales y no están en contacto con los sentimientos, causando todo tipo de problemas emocionales y espirituales inconscientes, sin siquiera percatarse del componente emocional en ellos.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Jesús usó todo su cerebro y quiere que nosotros hagamos lo mismo. Él dio un ejemplo perfecto, no solo por tener una inteligencia sobrenatural, sino también por mostrarnos su lado emocional, que incluye llorar, afligirse, enojarse y amar a su querida familia y a sus amigos. La Biblia enseña que si vemos llorar a nuestros seres queridos, no debemos acercarnos a ellos y animarlos a que dejen de llorar, sino que debemos darles un abrazo y “llorar con los que lloran” (Romanos 12:15). Jesús empleó su profunda sensibilidad hacia la condición humana para impartir palabras y toques que impactaron la función cerebral de otros, logrando así no solo sanidad física, sino también emocional. Fue un artífice en la reconfiguración interna y la recalibración para cada persona que lo encontró en la fe.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Incluso la ciencia nos enseña que las palabras tienen el poder de alterar positivamente el cerebro, que a su vez alterará todo el organismo.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("En mi propia investigación, descubrí que las palabras tienen el poder de alterar los genes que regulan nuestro estrés emocional y físico. Las palabras positivas involucran los componentes motivacionales de nuestro cerebro, lo que cataliza la acción. Además, el razonamiento cognitivo aumenta y nuestros lóbulos frontales se fortalecen cuando decimos y escuchamos palabras positivas. Por el contrario, las palabras negativas inhiben los neuroquímicos que controlan el estrés. En realidad, liberan hormonas productoras de estrés en nuestros sistemas neurológicos y biológicos. En consecuencia, el miedo que liberan las palabras negativas perturba nuestra capacidad de razonar al limitar la funcionalidad de nuestros lóbulos frontales. (Para obtener más detalles sobre este tema, lea "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Words Can Change Your Brain ")]), _vm._v("[Las palabras pueden cambiar su cerebro], por los doctores Andrew Newberg y Mark Robert Waldman).")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("En resumen, la clave para cambiar todas las demás áreas de nuestro cerebro es concentrarnos en cosas positivas. Incluso la sección del cerebro llamada tálamo, que afecta la forma en que percibimos la realidad, puede verse alterada por nuestras palabras.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll-1"
  }, [_vm._v("El método del sándwich")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Sabemos, por supuesto, que a menudo también se necesita corrección a medida que avanzamos en este camino hacia el potencial desencadenante. He oído decir que por cada corrección que damos a nuestros hijos, ¡debemos darles diez palabras de afirmación y aliento! También debemos hacer eso con aquellos a quienes estamos asesorando a medida que avanzan hacia el cumplimiento de su destino. Una manera fácil de recordar esto es utilizar el “método del sándwich” para equilibrar la afirmación y la corrección. El “método del sándwich” es este: los pedazos de pan, en la parte exterior del sándwich, representan las metáforas para comenzar y terminar su conversación con elogios o alguna forma de afirmación positiva. La carne que va en el medio del sándwich es la corrección. Por simple o tonto que parezca, en realidad es que es bastante efectivo porque es fácil de recordar y, si se sigue, nos permite mantener una perspectiva adecuada cuando existe la necesidad de una corrección constructiva. Liberar el potencial de una persona es mucho más efectivo cuando equilibramos nuestro enfoque con los rasgos positivos de una persona y no solo con las acciones negativas que estamos ayudando a superar.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Junto con el método del sándwich para la corrección, debemos practicar el hábito del análisis constante. Cuando sus discípulos regresaron después de que los envió a predicar y ministrar, Jesús los llevó aparte, en privado, para analizarlos y corregirlos (Lucas 9:1-27). Proverbios 27:6 nos enseña que “Más se puede confiar en el amigo que hiere que en el enemigo que besa” (DHH). Esto significa que tiene que haber lugar para la corrección en toda relación verdadera; de lo contrario, es superficial y falsa. Si realmente amo a una persona y quiero ayudarla a alcanzar su potencial, tengo que ser franco y mostrar corrección cuando sea necesario, tal como lo hizo Jesús.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Proverbios 9:8 declara que si usted reprende o corrige a un hombre sabio, le amará por ello. Pero si reprende a un necio, le odiará por ello, así que no pierda su tiempo con él. Si habla cuidadosamente con la verdad en amor, dando reprimendas precisas —pero educadas y respetuosas a aquellos a quienes está asesorando, y utiliza el método del sándwich para equilibrar la afirmación con la corrección—, obtendrá buenos resultados. Sin embargo, si la persona a la que está asesorando cree que es perfecta y se niega a aceptar la corrección, deje de asesorarla y dedique su tiempo a alguien que pueda aprender.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Recuerde que Dios nos da opciones. Tres cosas determinan cuánto potencial liberaremos: nuestros genes, nuestro entorno (especialmente en los años de crecimiento) y nuestras decisiones. Los genes malos, por lo general, se pueden superar con una dieta adecuada y, a veces, con medicamentos. Un mal ambiente infantil se puede sanear con un buen asesoramiento cristiano y una buena tutoría. Sin embargo, el factor más importante en nuestras vidas son las decisiones que tomamos. Conozco personas que heredaron excelentes genes, tuvieron padres extraordinarios y asistieron a una iglesia saludable, y aun así terminaron en lugares horribles emocional y espiritualmente, debido a las malas decisiones que tomaron en el camino.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Como padres, todos cometemos errores, pero cuando nuestros hijos crezcan, tenemos que seguir entregándolos a Dios y no culparnos por las decisiones que ellos tomen. Lo mismo se aplica a aquellos a quienes asesoramos. Jesús ofreció su amor incondicional, enseñó principios sólidos y llevó una vida ejemplar ante todos sus discípulos. Sin embargo, Judas tomó malas decisiones y se quitó la vida en vez de desarrollar su verdadero potencial. Los hijos de Israel no obedecieron la Palabra del Señor ni entraron a su tierra prometida porque se vieron a sí mismos como langostas y a sus oponentes como gigantes. ¡Su baja autoestima alimentó su incredulidad y destruyó su destino! En la vida de Kristian, las palabras que le hablé y las Escrituras que leyó borraron gradualmente la imagen que tenía de sí mismo. ¡Su disposición a crecer permitió que el Espíritu de Dios pintara una imagen completamente nueva de él en el lienzo de su corazón! Dios quiere hacer lo mismo por todos nosotros.")]), _vm._v(" "), _c('p', {
    staticClass: "CHAP--",
    attrs: {
      "id": "_idParaDest-11"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor007"
    }
  }), _vm._v("Capítulo 5")]), _vm._v(" "), _c('p', {
    staticClass: "CHAP-TITLE",
    attrs: {
      "id": "_idParaDest-12"
    }
  }, [_vm._v("Amar y ser amado")]), _vm._v(" "), _c('p', {
    staticClass: "pf"
  }, [_c('span', {
    staticClass: "SM-CAP",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Los humanos somos ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("la única especie viva en el planeta tierra que se dice que está hecha a imagen y semejanza de Dios; por lo tanto, ¡tenemos un potencial casi ilimitado ("), _c('a', {
    attrs: {
      "id": "_idTextAnchor008"
    }
  }), _vm._v("Génesis 1:26)! Romanos 8:29 dice que el propósito de Dios con nosotros es que seamos conformados a la imagen de Cristo. El apóstol en 1 Juan 4:17 nos enseña que así como es Jesús, deben ser los creyentes en este mundo. Eso no significa que el propósito de Dios para nosotros sea que vistamos con túnica, que usemos barba, que tengamos un ministerio público y que muramos en una cruz. Jesús personificó el amor de Dios por nosotros al dejar de lado todo lo que significaba ser Dios para venir a la tierra como hombre. Su amor desinteresado y sacrificado se mostró para que todos lo vieran cuando murió de una forma tortuosa en la cruz, de modo que la humanidad pudiera ser perdonada por aquellas cosas que hacemos en la vida que lastiman a otros o a nosotros mismos.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Conformarnos a la imagen de Jesús significa que tenemos la oportunidad de mejorar en cuanto a amar y aceptar el amor de los demás. Cuanto más amamos, desarrollamos una actitud centrada en los demás y aplicamos la sabiduría de Jesús, y más se desata nuestro potencial humano. Como Jesús, estamos llamados a hacer cosas grandes y amorosas ahora, mientras estemos vivos.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("He descubierto que a la mayoría de las personas no les importa mi educación, mis títulos ni la amistad que tengo con celebridades y personas poderosas. La verdad es que a la gente no le importa cuánto sabe usted. Solo quieren saber cuánto les importa. Si voy a ayudar a otros a liberar su potencial humano, tengo que ser mucho más que un miembro profesional del clero o un consultor de liderazgo. Tengo que ser un mentor, en unos casos un entrenador, y en otros —más excepcionales— debo ser un padre espiritual o de crianza. A veces, el potencial humano de un individuo se atrofia hasta que intervengo y ayudo a sanar las heridas causadas por la ausencia o el abandono de un padre o tutor terrenal.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("En el Nuevo Pacto, Dios se nos revela de manera personal, no como “el gran apóstol” o “el general”, sino como nuestro “Padre celestial”. Fue nuestro Padre celestial el que nos creó y nos asignó a cada uno de nosotros los dones y habilidades que determinan nuestro potencial. Luego nos dio un padre terrenal para ayudarnos a liberar ese potencial. A menudo se nos da tanto un padre natural como un padre espiritual para guiarnos a través del proceso necesario para alcanzar nuestro máximo potencial. Aunque he sido consagrado obispo y he obtenido un doctorado, el título más importante que tengo es cuando los hombres y mujeres de la iglesia me llaman “papá” o “papi”. Ser padre espiritual es posiblemente el llamado más alto de cualquier mentor, entrenador o líder potencial puesto que en esa función ejemplificamos verdaderamente el amor de Dios.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Esto es especialmente importante en nuestra actual sociedad huérfana, en la que muchos jóvenes han venido a nuestras iglesias con “un espíritu huérfano” por haber sido abandonados por sus padres naturales. Dios puede usar padres espirituales como padres sustitutos para ayudar a sanar sus heridas de rechazo y abrir una puerta para que el amor de Dios Padre sane sus heridas y los restaure emocionalmente a un lugar sano.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Jesús nos dijo que Dios nos ha llamado a todos y cada uno de nosotros para continuar su obra aquí en la tierra. Él nos promete que Dios nos ha capacitado no solo para hacer lo que hizo, sino también para lograr cosas aun mayores (Juan 14:12). Liberar su potencial humano significa cumplir la Gran Comisión y ejemplificar el Gran Mandamiento (Mateo 28:19; 22:37-40).")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll-1"
  }, [_vm._v("La danza del amor")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Cumplir la Gran Comisión y ejemplificar el gran mandamiento solo se puede lograr sirviendo a Dios y a su prójimo, llevando una vida equilibrada para resguardar su cordura y dejando este mundo como un lugar un poco mejor de lo que hubiera sido si usted nunca hubiera nacido. La mayoría de las personas desperdician sus vidas en una tonta carrera de ratas. Todos nosotros, en mayor o menor grado, pasamos por la vida sintiéndonos “nadie” a la vez que tratamos de demostrarle al mundo que somos “alguien”. Qué superficial sería la vida si no tuviéramos un propósito mayor que simplemente existir hasta que se complete nuestro tiempo en la tierra. Liberar su potencial humano comienza con dedicar su vida a servir, reír y llorar con sus seres queridos.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("La experiencia y la investigación me han convencido de que las únicas personas en el mundo que tienen verdadera felicidad y significado son las que desarrollan el don de amar y dejarse amar. Dado que existen altas tasas de suicidio incluso entre los más ricos, pensar que el éxito financiero es la clave para ser extraordinario y liberar su verdadero potencial podría ser el peor error que cometa.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Les deseo éxito financiero a todos ustedes, siempre y cuando lo mantengan en perspectiva. Amar y ser amado por Dios y usar sus dones y sus talentos para servirle a él y a los demás, cumpliendo así el gran mandamiento es mil veces más importantes que su patrimonio neto.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Conozco a muchas personas ricas que usan su tiempo y su dinero para servir a Dios y ayudar a la humanidad, y son bastante felices. La Biblia habla de Abraham y Job, que siguieron siendo hombres piadosos a pesar de que eran los más ricos de la tierra en su momento. En el Libro de Eclesiastés, el rey Salomón anima a los ricos a disfrutar de su riqueza pero no a vivir para ella. Sin embargo, un mayor porcentaje de personas ricas ha cometido el error de vivir en busca del oro de los tontos en vez del verdadero, por lo que sufren una gran soledad y falta de sentido al final de sus vidas. El verdadero oro proviene de comprender el gran mandamiento y usarlo para bailar con el mundo, esparciendo el amor de Dios alrededor.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("La Gran Comisión, en Mateo 28:19-20, que nos anima a ir a todo el mundo para difundir el evangelio del amor y la redención de Dios (en el tiempo imperativo pasivo del griego original, para que se traduzca con mayor precisión) dice: “Mientras vayas por el mundo, propaga las buenas nuevas”. A medida que avanzamos en el mundo, somos llamados a ser las cartas de amor de Dios para todas las personas con las que tengamos contacto.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("El apóstol Pablo, que escribió la mayoría de las epístolas del Nuevo Testamento, elogió a aquellos a quienes había discipulado personalmente en Corinto por el amor que mostraron al resto del mundo a través de sus actos y comportamientos rebosantes de amor genuino. En 2 Corintios 3:2-3, les hizo el mayor cumplido que podría expresarle a alguien, y describió a esos discípulos como epístolas o cartas de amor de Jesús al mundo. “Es evidente que son una carta de Cristo que muestra el resultado de nuestro ministerio entre ustedes. Esta ‘carta’ no está escrita con pluma y tinta, sino con el Espíritu del Dios viviente. No está tallada en tablas de piedra, sino en corazones humanos” (NTV). Dios no nos llama a todos a convertirnos en misioneros extranjeros profesionales de tiempo completo, pero sí nos llama a todos a ser representantes de su amor de tiempo completo.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll-1"
  }, [_vm._v("El toque personal")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Se ha citado a Mark Twain diciendo: “Por lo general, no es lo que comes lo que te da indigestión, ¡es lo que te está comiendo!”. Si vamos a tener éxito ayudando a otros a ser extraordinarios, entonces debemos comprometernos personalmente con ellos y descubrir la causa raíz de cualquier cosa que perturbe la maximización del propósito. La simple colocación de una persona en algún tipo de programa oficial nunca puede reemplazar el toque personal que cada individuo necesita. Un artículo reciente del "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("New York Times")]), _vm._v(" indicó que ahora hay evidencia científica relacionada con cómo el contacto físico personal, en realidad, mejora el rendimiento y la actitud de las personas."), _c('sup', {
    staticClass: "sup _idGenCharOverride-2"
  }, [_vm._v("1")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Los investigadores han dicho con respecto al contacto físico: “Los toques momentáneos, dicen, ya sea chocar los cinco dedos con entusiasmo, una mano cálida en el hombro o un toque espeluznante en el brazo, pueden comunicar una gama aun más amplia de emociones que los gestos o las expresiones y, a veces, hacerlo de forma más rápida y precisa que las palabras… La evidencia de que tales mensajes pueden conducir a cambios claros y casi inmediatos en la forma en que las personas piensan y se comportan se está acumulando rápidamente.”"), _c('sup', {
    staticClass: "sup _idGenCharOverride-2"
  }, [_vm._v("2")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Se está investigando que el contacto físico puede incluso mejorar el rendimiento en competencias atléticas. “Para ver si un rico vocabulario de toque de apoyo está realmente relacionado con el rendimiento, los científicos de Berkeley analizaron —hace poco— las interacciones en uno de los escenarios físicamente más expresivos del mundo: el baloncesto profesional. Michael W. Kraus dirigió un equipo de investigación que codificó cada golpe, abrazo y choque de cinco en un solo partido jugado por cada equipo en la Asociación Nacional de Baloncesto a principios de la temporada pasada”. Los resultados del estudio indicaron que “los buenos equipos tendían a ser más afectuosos que los malos”."), _c('sup', {
    staticClass: "sup _idGenCharOverride-2"
  }, [_vm._v("3")]), _vm._v(" Realmente hay poder en el contacto físico. Por supuesto, los depredadores también pueden usar el contacto físico y los abrazos de manera pecaminosa, así que tenga cuidado con quién abraza, cuándo y dónde.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll-1"
  }, [_vm._v("Un enfoque integral")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Algunas víctimas de diversas formas de abuso infantil están llenas de voces negativas internas, una baja opinión errónea de sí mismos y un miedo a la intimidad con las personas amorosas que los rodean. Algunos tienen una variedad de factores genéticos que los hacen más propensos a desarrollar síntomas no deseados, como el trastorno bipolar, el trastorno obsesivo-compulsivo, el TDAH o varios tipos de depresiones genéticas. Algunos tienen factores genéticos que les hacen sufrir dolor emocional y fatiga. Otros tienen factores nutricionales que contribuyen a su depresión. La mala nutrición afecta a miles de millones en todo el mundo, incluso a los estadounidenses ricos que viven consumiendo alimentos poco saludables.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Para liberar el potencial humano, debemos emplear un enfoque integral, analizando todos y cada uno de los factores que pueden estar contribuyendo a los síntomas no deseados que sofocan la capacidad de la persona para liberar su potencial. También están aquellos que son pasivos y controlados por otros que necesitan ser más asertivos e independientes. Otras personas están cargadas de ira reprimida por varios tipos de abuso y al fin pueden desatar esa ira de maneras poco saludables que destruyen las relaciones.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Usted puede afirmar verbalmente a alguien con elogios por un trabajo bien hecho, pero también puede hacerlo con una palmada en la espalda, un cálido apretón de manos y un abrazo respetuoso. Cuando estudiamos la vida de Jesús, vemos cuán cálido y cariñoso era al tocar y ser tocado por quienes lo rodeaban. Creo que una de las cosas más importantes que hizo para desatar el vasto potencial de sus discípulos fue conducirse de manera informal y personal con ellos. En la Última Cena vemos al apóstol Juan apoyado en el pecho de Cristo, lo que muestra la correlación entre el amor, la aceptación, el toque personal y el desarrollo del liderazgo. Jesús llamaba a sus discípulos más cercanos “amigos”, no “siervos”. Fue franco, auténtico con ellos, y les reveló las cosas íntimas que el Padre le dijo en privado. Jesús trató a sus discípulos de la misma manera que Dios trató a Moisés, a quien conoció cara a cara, y a Abraham, a quien llamó amigo. Mientras pendía de la cruz, una de las últimas cosas que hizo fue elegir a Juan para que tomara su lugar como hijo de María y cuidara de ella. En cierto sentido, Jesús estaba mostrando que también veía a Juan y sus discípulos como sus hermanos, no solo como miembros de una orden religiosa.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Siguiendo el ejemplo de Cristo, me di cuenta hace mucho tiempo de que mi trabajo principal como pastor es desarrollar hijos e hijas, no solo empleados y miembros de la iglesia. Mi toque personal y afirmarlos como parte de mi familia espiritual los motivará a convertirse en todo lo que pueden ser. Ellos, a su vez, se comportarán con los demás de la misma manera personal. Por el contrario, cuando los mentores y líderes no son sinceros con las personas que están capacitando, muestran que son socialmente disfuncionales o que tienen problemas para confiar en los demás. Sus seguidores perpetuarán aun más esta disfunción entre aquellos a quienes están entrenando, enseñando y asesorando.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Por lo general, recomiendo que los pastores, mentores y líderes tengan amigos cercanos que sean compañeros que se alienten mutuamente. A menudo, otro pastor, mentor o líder en un área similar es una buena persona con la que se puede asociar. Las únicas personas que tienen alegría y significado en esta vida son aquellas que poseen algunos amigos a los que pueden amar incondicionalmente y ser amados de la misma manera.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Tratar a los individuos como amigos significa que compartes cosas íntimas con ellos, les muestras el corazón y el alma, pasas tiempo con ellos, te diviertes con ellos y disfrutas de su compañía en medio de todo el trabajo que realizan juntos. Esto contrasta con un arreglo comercial de contratación de jefes en el que las personas sirven en un trabajo. Los empleados ingresan a las 9:00 de la mañana y se van a las 5:00 de la tarde en punto, aun cuando haya cosas urgentes sin hacer, porque no les importa el trabajo que realizan. Cuando los líderes tratan a las personas como amigos, demuestran que la relación es la base de su trabajo conjunto, lo que engendra un espíritu de propiedad y comienza a liberar el potencial dentro de los demás.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Mire lo que lograron los discípulos de Jesús en un mundo sin automóviles, aviones, teléfonos ni computadoras después de menos de tres años bajo su tutoría. ¿Puede imaginarse el potencial que se puede liberar en aquellos a quienes estamos llamados a liderar y guiar con todo lo que está a nuestra disposición en el mundo de hoy?")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll-1"
  }, [_vm._v("Religión o relación")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Una de las cosas más penetrantes en el mundo de la iglesia actual es ese cristianismo basado en el desempeño que es más religioso en naturaleza que relacional. Esta expresión del cristianismo prevalece en culturas eclesiásticas repletas de prácticas religiosas pero carentes de relaciones transparentes y genuinas. Al leer el Nuevo Testamento, encuentro que el reino de Dios no es edificado por el ministerio sino por las relaciones.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Por desdicha, muchos líderes espirituales solo saben cómo influir en las personas desde detrás de su púlpito y se sienten incómodos cuando se relacionan informalmente con ellas en entornos sociales. Estos líderes casi siempre son distantes y se incomodan en cualquier entorno en el que no estén en una posición de poder mientras ministran a los demás. Aunque el ministerio del púlpito es de vital importancia para ayudar a las personas maduras en la fe, el potencial de una persona quedará sin explotar fuera de la relación. Aquellos que reciben mentoría necesitan conexiones intencionales e informales con sus líderes espirituales.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Los jóvenes de hoy anhelan especialmente una experiencia cristiana genuina, informal y relacional porque dudan del modelo eclesiástico institucional, religioso y plagado de escándalos. Aunque el término general usado para describir a los seguidores de Cristo ha sido “cristianos”, los creyentes solo fueron llamados así tres veces en el Nuevo Testamento (Hechos 11:26; 26:28; 1 Pedro 4:16).")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("En contraste, Jesús se llamó a sí mismo “el camino” (Juan 14:6), y la iglesia primitiva fue descrita por otros como “el Camino”, como está registrado en el Libro de los Hechos (9:2; 19:9, 23; 24:14, 22), y también como “esta vida” (Hechos 5:20). En consecuencia, si deseamos los mismos resultados que Jesús y la iglesia primitiva, debemos promover una cultura de fe que sea más un estilo de vida (que se integre orgánicamente a la perfección en nuestra vida privada, familiar, laboral y eclesiástica) y no la cultura religiosa actual que reserva tiempos específicos para la práctica y el comportamiento religiosos.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("En otras palabras, en el siglo veintiuno necesitamos retroceder, volver al camino de Cristo y sus apóstoles, antes de que podamos avanzar y experimentar una transformación personal completa, alcanzando así nuestro potencial como lo diseñó Dios. Por supuesto, para comprender completamente la metodología del Nuevo Testamento y cómo liberó Jesús el potencial humano e hizo extraordinarios a sus discípulos, es vital que entendamos el trasfondo cultural y religioso de todos ellos. Con esto presente, es útil para nosotros comprender el método de discipulado común de los rabinos judíos en los tiempos de Jesús y contrastarlo con el método de Cristo para que podamos obtener una mayor apreciación de su enfoque radical basado en la afirmación de su señorío.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("En apariencia, no parece haber una diferencia esencial entre los métodos de discipulado de Jesús y los de los rabinos de su tiempo. Por ejemplo, tanto Jesús como los rabinos tenían discípulos o estudiantes que se unían personalmente a ellos. Sin embargo, un examen más detallado muestra que existían diferencias fundamentales entre estos dos enfoques. A continuación se muestran esos contrastes:")]), _vm._v(" "), _c('ul', [_c('li', {
    staticClass: "BULLET-1"
  }, [_vm._v("Los "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("talmidim")]), _vm._v(" (discípulos de los rabinos) elegían a su propio maestro. Jesús escogió a sus propios discípulos (Lucas 9:57-62; Juan 15:16). Marcos 5:18-19 muestra cómo hasta Jesús rechazó a algunos que querían seguirlo. Él fue deliberado e intencional en cuanto a con quién se conectaría.")]), _vm._v(" "), _c('li', {
    staticClass: "BULLET-2"
  }, [_vm._v("Los "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("talmidim")]), _vm._v(" elegían al rabino en base a su conocimiento de la Torá (las escrituras del Antiguo Testamento) porque la ley era el centro del judaísmo. El rabino solo tenía autoridad en la medida en que conocía la Torá; la autoridad pertenecía a la Torá, no a ningún rabino individual. En contraste, Jesús esperaba que sus discípulos renunciaran a todo, no por causa de la Torá, sino solo por su causa (Mateo 10:38). En el Nuevo Pacto, Jesús es el centro del universo, no la Torá (o la Biblia). Lea Juan 5:39-40 y Colosenses 1:17. Por supuesto, las Escrituras dan testimonio de Cristo si se leen con un corazón descubierto. (Ver 2 Corintios 3:15-18).")]), _vm._v(" "), _c('li', {
    staticClass: "BULLET-2"
  }, [_vm._v("En el judaísmo, ser discípulo era algo transitorio, un medio para un fin, con el objetivo de convertirse en rabino. Para los discípulos de Jesús, el discipulado no era un paso hacia una carrera prometedora. Seguir a Jesús era en sí mismo el cumplimiento del destino (Romanos 8:29-30). En otras palabras, no existe una graduación o título oficial que complete nuestro proceso de discipulado. Es un proceso constante que continúa hasta nuestro último aliento en esta vida y más allá (Filipenses 3:7-14; 2 Pedro 3:18).")]), _vm._v(" "), _c('li', {
    staticClass: "BULLET-2"
  }, [_vm._v("Los discípulos de los rabinos eran solo sus estudiantes, nada más. Los discípulos de Jesús también fueron sus siervos que se comprometieron a obedecerle y sufrir por su causa (Mat. 16:24-25; Juan 12:26).")]), _vm._v(" "), _c('li', {
    staticClass: "BULLET-2"
  }, [_vm._v("Los discípulos de los rabinos simplemente transmitían sus enseñanzas. Los discípulos de Jesús fueron llamados a estar con él (Marcos 3:14) y a ser sus testigos (Hechos 1:8).")]), _vm._v(" "), _c('li', {
    staticClass: "BULLET-2"
  }, [_vm._v("Los discípulos de los rabinos trataban de recuperar la antigua gloria de la nación de Israel. Los discípulos de Jesús fueron (y aún son) la vanguardia del reino venidero y esperan el segundo regreso corporal del Rey Jesús.")]), _vm._v(" "), _c('li', {
    staticClass: "BULLET-2"
  }, [_vm._v("Para los discípulos del judaísmo rabínico, seguir la letra de las 613 leyes y las interpretaciones rabínicas de la Torá era de suma importancia. Pero para Jesús, seguir las minucias de la ley ceremonial no era tan importante como cuidar el alma humana (Marcos 2:1-12; 3:1-6).")]), _vm._v(" "), _c('li', {
    staticClass: "BULLET-2"
  }, [_vm._v("Los rabinos judíos enfatizaban la separación de los no judíos y de aquellos que eran impuros. Jesús enseñó que amar a nuestro prójimo es igual a amar a Dios, independientemente de si la persona es judía (Mateo 22:37-40; Lucas 10:30-37)."), _c('sup', {
    staticClass: "sup _idGenCharOverride-2"
  }, [_vm._v("4")])])]), _vm._v(" "), _c('p', {
    staticClass: "paa"
  }, [_vm._v("El hecho de que Jesús siempre tuvo la intención de que sus seguidores continuaran con su ministerio terrenal de hacer que las personas desarrollaran su potencial al máximo y hacer avanzar su reino, queda claro al referirse al comienzo del Libro de los Hechos, en el que Lucas afirma que la narración de su evangelio registró todo lo que Jesús comenzó a hacer y decir hasta que fue llevado al cielo, después de lo cual —por medio del Espíritu Santo— dio instrucciones a los apóstoles que había elegido (Hechos 1:1-2). En otras palabras, Jesús pasó su obra a sus apóstoles antes de ascender al cielo porque la narración de Lucas es simplemente un registro de lo que Jesús “comenzó a hacer”. Por implicación, su obra continuó a través de la iglesia, como se registra en la narración de los Hechos. Por lo tanto, si verdaderamente vamos a caminar en nuestro potencial y cumplir con nuestra misión, debemos estudiar la vida de Jesús, andar como él anduvo e invertir en los demás tal como él lo hizo.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll-1"
  }, [_vm._v("Empodere a otros")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Permítame concluir con un extracto ligeramente parafraseado basado en el capítulo 11 de mi libro "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("An Anthology of Essays on Cutting Edge Leadership")]), _vm._v("."), _c('sup', {
    staticClass: "sup _idGenCharOverride-2"
  }, [_vm._v("5")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Las siguientes son formas en que podemos empoderar a otros para que alcancen su potencial:")]), _vm._v(" "), _c('p', {
    staticClass: "sbttl"
  }, [_vm._v("Empoderar a las personas permite que otros cometan errores.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Algunas personas se preocupan más por hacer un trabajo correctamente que por capacitar a los individuos para que aprendan a hacerlo. Cuando todo lo que nos importa es hacer bien el trabajo, no delegaremos verdaderamente la autoridad a otros para que realicen la tarea. Esto se debe a que vemos a las personas simplemente como una extensión de nuestros brazos y nuestras piernas, pero no de nuestro cerebro. No dejamos que otros piensen por sí mismos. Al contrario, le damos a la persona una tarea para que la realice y luego la corregimos constantemente a medida que la va haciendo. Por otro lado, empoderar a las personas a menudo permite que aquellos a quienes se asignan las tareas cometan errores y luego los critican con gracia después de completar cada una de ellas.")]), _vm._v(" "), _c('p', {
    staticClass: "sbttl"
  }, [_vm._v("Empoderar a las personas no tiene que ver con microgestión.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("La microgestión solo se debe realizar si un líder está trabajando con una persona que no está capacitada ni calificada para una tarea en particular. Este tipo de acuerdo laboral solo debe ser temporal porque a nadie se le debe asignar una tarea para la cual no tiene la habilidad potencial. Una vez que se completa la transición a la competencia laboral, el líder debe permitir que el trabajador realice tareas con solo una supervisión macro.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("La microgestión genera una atmósfera de desconfianza y comunica a la persona encargada de la tarea que el líder, realmente, no confía en ella. Los microgerentes habituales, por lo general, no tienen ni idea de qué es empoderar a otros.")]), _vm._v(" "), _c('p', {
    staticClass: "sbttl"
  }, [_vm._v("Empoderar a las personas tiene que ver con enfocarse en los rasgos positivos de los demás.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Todos tropezamos en muchas maneras. Todos solemos fallar en las tareas al menos el diez por ciento del tiempo, dependiendo de cuánto trabajo extra tengamos. Además de eso, siempre habrá errores en cierto porcentaje de las tareas que realizamos. Más aun, una persona tiende a hacer un trabajo de manera diferente a la siguiente. En consecuencia, siempre tendremos la oportunidad de señalar cosas que la persona no hace correctamente. Por lo tanto, debemos intentar concentrarnos más en lo que el individuo al que se le asignó la tarea hizo correctamente y en los resultados del trabajo realizado, no en los errores. Por supuesto, la excepción a esto es si alguien arruina totalmente una tarea o no sigue las pautas dadas.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Cuando nos enfocamos en las contribuciones positivas de los demás, les infundimos confianza y los motivamos a continuar desempeñándose a un alto nivel.")]), _vm._v(" "), _c('p', {
    staticClass: "sbttl"
  }, [_vm._v("Empoderar a las personas implica dar críticas constructivas, no destructivas.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Debe haber tiempos programados periódicamente después de que se complete cada tarea principal con el fin de revisar el trabajo y evaluar si se cumplieron los objetivos. Esto debe basarse en los criterios dados antes de que se intentara la tarea para que haya una forma objetiva de medir si se realizó con excelencia. El interrogatorio usual permite que la persona a la que se le asigna una tarea comprenda si está progresando en el trabajo y cuál es su posición con respecto a su empleo.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("No es justo decirles a las personas, un año después de haber comenzado un trabajo, que no se están desempeñando bien. En ese momento, su trabajo ya está en peligro y ni siquiera se les ha dado la oportunidad de mejorar porque no recibieron comentarios.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Aquellos que desean trabajar con un espíritu de excelencia, por lo general agradecen la crítica constante y constructiva. Por supuesto, cuando los líderes menosprecian a las personas, las insultan, las menosprecian o hablan de manera condescendiente, están dispensando críticas que pueden destruir, no edificar, a quienes trabajan para ellos. ")]), _vm._v(" "), _c('p', {
    staticClass: "sbttl"
  }, [_vm._v("Empoderar a las personas brinda pautas, objetivos y resultados esperados.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Empoderar a las personas (líderes, gerentes en este contexto) les da, a quienes trabajan para ellos, las pautas generales para los puestos y los objetivos de las tareas, junto con el resultado final que buscan. Esto permite a las personas a las que se les asignan las tareas “avanzar con determinación y creatividad hacia una meta u objetivo” sin una supervisión excesiva ni la constante preocupación por cometer errores, por lo que pueden desempeñarse mejor y con mayor confianza.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Restarles poder a las personas asignándoles tareas únicamente, solo proporciona pautas, metas y objetivos ambiguos que hacen que nadie, excepto el líder, sepa realmente si el trabajo se está haciendo bien o mal. Cuando los líderes hacen eso, es una señal de que no tienen objetivos reales para una tarea o que simplemente están tratando de ejercer control psicológico sobre sus trabajadores.")]), _vm._v(" "), _c('p', {
    staticClass: "sbttl"
  }, [_vm._v("Empoderar a las personas ayuda a conectar a otros con su pasión, sus dones y su vocación.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Empoderar a las personas intenta cuadrar a las personas con las tareas de acuerdo a sus dones, su pasión y sus habilidades. Los que restan poder a otros no tienen en cuenta esas cosas y, a menudo, tratan de aplicar soluciones no adecuadas. Los que empoderan se enorgullecen de poder ayudar a las personas a volar como águilas a alturas inimaginables, mientras que los que restan poder se preocupan más por realizar las tareas que por liberar el potencial humano. Las personas que empoderan también son sensibles y conducen a cada persona de manera diferente según su experiencia, personalidad y temperamento.")]), _vm._v(" "), _c('p', {
    staticClass: "sbttl"
  }, [_vm._v("Empoderar a las personas se enfoca en inspirar a las personas más que en obligarlas a actuar.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("El empoderamiento de las personas proyecta una visión que inspira a sus seguidores a realizar grandes cosas, mientras que los que restan poder —a menudo— simplemente dan órdenes y exigen resultados. Cuando usted inspira a las personas, estas se desempeñan a un nivel mucho mayor porque se les permite tomar sus propias decisiones para servir y tienen un mayor compromiso, mientras que aquellos que simplemente siguen órdenes harán lo suficiente para complacer al líder y, por lo general, no aprovechará mucho sus capacidades creativas.")]), _vm._v(" "), _c('p', {
    staticClass: "sbttl"
  }, [_vm._v("Las personas empoderadas participan en el diálogo, pero los que no empoderan dictan sus deseos e ideas.")]), _vm._v(" "), _c('p', {
    staticClass: "p _idGenParaOverride-1"
  }, [_vm._v("Las personas empoderadas intentan permitir un diálogo fluido entre sus seguidores y ellos en proyectos relacionados con el trabajo. Estos líderes entienden la importancia de recibir retroalimentación periódica de sus subordinados para que comprendan mejor cómo realizar las tareas. Por el contrario, las personas que quitan poder a los demás no suelen entablar diálogos, sino que simplemente dictan qué y cómo quieren que se haga un proyecto. Las personas bajo este tipo de líderes, de una u otra forma, pierden la motivación para pensar; por lo que, simplemente, siguen órdenes como si fueran robots porque saben que sus opiniones realmente no importan. Los líderes dictatoriales casi nunca multiplican líderes; simplemente retienen a los seguidores que han permitido que se limite su creatividad.")]), _vm._v(" "), _c('p', {
    staticClass: "CHAP--",
    attrs: {
      "id": "_idParaDest-13"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor009"
    }
  }), _vm._v("Capítulo 6")]), _vm._v(" "), _c('p', {
    staticClass: "CHAP-TITLE",
    attrs: {
      "id": "_idParaDest-14"
    }
  }, [_vm._v("Cómo liberar el potencial de los demás")]), _vm._v(" "), _c('p', {
    staticClass: "pf"
  }, [_c('span', {
    staticClass: "SM-CAP",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Jesús siempre modeló ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("el liderazgo (Lucas 11:1; Juan 13:4-15). Uno de los mayores obstáculos para las personas es cuando ven que sus líderes tienen un doble rasero. Cuando viven con estándares más bajos que el mensaje que predican, invalidan su enseñanza y generan falta de respeto y animosidad hacia ellos entre sus seguidores. Tenemos que poseer algo más que buena oratoria y retórica, y hacer más que simples sermones si vamos a ayudar a liberar el potencial de las personas. Verdaderamente, la herramienta más efectiva para liberar el potencial es la tutoría y convertirse en un modelo a seguir. Jesús motivó a sus discípulos a alcanzar la grandeza encarnando un estilo de liderazgo de servicio en el que nunca le pidió a nadie que hiciera algo que él no lo hubiera modelado primero. El Libro de Juan dice:")])]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("Sabía Jesús que el Padre había puesto todas las cosas bajo su dominio, y que había salido de Dios y a él volvía; así que se levantó de la mesa, se quitó el manto y se ató una toalla a la cintura. Luego echó agua en un recipiente y comenzó a lavarles los pies a sus discípulos y a secárselos con la toalla que llevaba a la cintura.")]), _vm._v(" "), _c('p', {
    staticClass: "BLOCK-2"
  }, [_vm._v("Cuando llegó a Simón Pedro, este dijo:")]), _vm._v(" "), _c('p', {
    staticClass: "BLOCK-2"
  }, [_vm._v("—¿Y tú, Señor, me vas a lavar los pies a mí?")]), _vm._v(" "), _c('p', {
    staticClass: "BLOCK-2"
  }, [_vm._v("—Ahora no entiendes lo que estoy haciendo —respondió Jesús—, pero lo entenderás más tarde.")]), _vm._v(" "), _c('p', {
    staticClass: "BLOCK-2"
  }, [_vm._v("—¡No! —protestó Pedro—. ¡Jamás me lavarás los pies!")]), _vm._v(" "), _c('p', {
    staticClass: "BLOCK-2"
  }, [_vm._v("Jesús contestó:")]), _vm._v(" "), _c('p', {
    staticClass: "BLOCK-2"
  }, [_vm._v("—Si no te los lavo, no tendrás parte conmigo.")]), _vm._v(" "), _c('p', {
    staticClass: "BLOCK-2"
  }, [_vm._v("Simón Pedro dijo:")]), _vm._v(" "), _c('p', {
    staticClass: "BLOCK-2"
  }, [_vm._v("—Entonces, Señor, ¡no solo los pies, sino también las manos y la cabeza!")]), _vm._v(" "), _c('p', {
    staticClass: "BLOCK-2"
  }, [_vm._v("—El que ya se ha bañado no necesita lavarse más que los pies —le contestó Jesús—; pues ya todo su cuerpo está limpio. Y ustedes ya están limpios, aunque no todos.")]), _vm._v(" "), _c('p', {
    staticClass: "BLOCK-2"
  }, [_vm._v("Jesús sabía quién lo iba a traicionar y por eso dijo que no todos estaban limpios.")]), _vm._v(" "), _c('p', {
    staticClass: "BLOCK-2"
  }, [_vm._v("Cuando terminó de lavarles los pies, se puso el manto y volvió a su lugar. Entonces les dijo:")]), _vm._v(" "), _c('p', {
    staticClass: "BLOCK-2"
  }, [_vm._v("—¿Entienden lo que he hecho con ustedes? Ustedes me llaman Maestro y Señor y dicen bien, porque lo soy. Pues, si yo, el Señor y el Maestro, les he lavado los pies, también ustedes deben lavarse los pies los unos a los otros. Les he puesto el ejemplo, para que hagan lo mismo que yo he hecho con ustedes. Les aseguro que ningún siervo es más que su amo y ningún mensajero es más que el que lo envió. ¿Entienden esto? Dichosos serán si lo ponen en práctica.")]), _vm._v(" "), _c('p', {
    staticClass: "RIGHT-FLUSH",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("—Juan 13:3-17")]), _vm._v(" "), _c('p', {
    staticClass: "paa"
  }, [_vm._v("Al humillarse y lavar los pies sucios, malolientes, llenos de estiércol y lodo de sus discípulos, Jesús estaba ejemplificando la forma más alta de liderazgo: la de convertirse en un líder servidor. Los líderes servidores son muy efectivos porque este estilo de liderazgo logra tres cosas importantes. Su servicio satisface las necesidades sentidas de las personas que lideran. Da a los líderes de servicio la oportunidad de utilizar sus dones y habilidades para ayudar a las personas a las que sirven. También da como resultado un alto nivel de confianza entre aquellos a quienes sirven porque la humildad de poner las necesidades de otra persona primero genera aun más confianza y gratitud, lo que resulta en una mayor disposición para recibir instrucción e impartición para el crecimiento. Esto va en contra del enfoque de arriba a abajo que muchos líderes intentan emplear tanto en el mundo religioso como en el mercado. A veces, incluso los líderes religiosos modelan lo opuesto al estilo de liderazgo de servicio de Cristo al ser inaccesibles para aquellos a quienes están entrenando y al dar la impresión de que las ovejas solo son para servir al pastor y no al revés.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Este tipo de estilo de liderazgo de arriba hacia abajo —autocrático y distante— casi siempre nutre solo a los seguidores, personas que no piensan por sí mismas, que solo siguen órdenes. Por lo tanto, no están capacitados para participar en el tipo de pensamiento crítico necesario para desarrollar el tipo de capacidad para la resolución de problemas y la habilidad que libera el potencial. Al servir a otros en las áreas que estamos enseñando, nos hacemos responsables de practicar algo antes de intentar predicar sobre ello. He descubierto que tengo mayor autoridad para instruir a otros en las áreas que ya he puesto en práctica con éxito.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Hechos 1:1 afirma que Jesús trabajaba con lo que iba a enseñar antes de implementarlo. La mayoría de nosotros tenemos ese orden inverso: intentamos enseñar a otros sobre áreas de nuestras vidas que nosotros mismos aún no dominamos. Sin embargo, si vamos a aprender a liberar el potencial como lo hizo Jesús, tenemos que “hacer y enseñar”.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Jesús es el Buen Pastor, que dio su vida por sus ovejas sirviéndolas con su vida, muerte y resurrección. En el Evangelio de Juan, Jesucristo dice:")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("Yo soy el buen pastor. El buen pastor da su vida por las ovejas. El asalariado no es el pastor, y a él no le pertenecen las ovejas. Cuando ve que el lobo se acerca, abandona las ovejas y huye; entonces el lobo ataca al rebaño y lo dispersa. Y ese hombre huye porque es un asalariado, no le importan las ovejas.")]), _vm._v(" "), _c('p', {
    staticClass: "RIGHT-FLUSH",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("—Juan 10:11-13")]), _vm._v(" "), _c('p', {
    staticClass: "paa"
  }, [_vm._v("El Libro de Ezequiel dice esto sobre los pastores que usan y abusan de las ovejas para servirse a sí mismas y no lo contrario:")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("Hijo de hombre, profetiza contra los pastores de Israel; profetiza y adviérteles que así dice el Señor y Dios: “¡Ay de ustedes, pastores de Israel, que solo se cuidan a sí mismos! ¿Acaso los pastores no deben cuidar al rebaño? Ustedes se beben la leche, se visten con la lana y matan las ovejas más gordas, pero no cuidan del rebaño. No fortalecen a la débil, no cuidan de la enferma ni curan a la herida. No han traído a la descarriada ni buscan a la perdida. Al contrario, tratan al rebaño con crueldad y violencia. Por eso las ovejas se han dispersado: ¡por falta de pastor! Y cuando se dispersaron se convirtieron en alimento de las bestias del campo. Mis ovejas vagan por montes y colinas, dispersas por toda la tierra, sin que nadie se preocupe por buscarlas”.")]), _vm._v(" "), _c('p', {
    staticClass: "RIGHT-FLUSH",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("—Ezequiel 34:2-6")]), _vm._v(" "), _c('p', {
    staticClass: "paa"
  }, [_vm._v("Con respecto a este estilo de liderazgo, me impactó particularmente a fines de la década de 1980, el modelo de liderazgo de servicio de mi supervisor, John Kelly, que me visitó para pasar tiempo conmigo y los líderes de mi iglesia a pesar de que era el supervisor de una gran red de congregaciones y yo solo tenía unos treinta años con una nueva iglesia nueva en el centro de la ciudad. En dos ocasiones separadas pasó más de una semana conmigo, impartiéndome conocimiento, estrategia y desarrollando una amistad conmigo. Los efectos de su ministerio fueron profundos porque fue accesible y franco; compartió su vida conmigo, ¡no solo su ministerio profesional! Incluso pasó un tiempo llevándome a una tienda en Brooklyn, Nueva York, que vendía ropa de hombre y me enseñó cómo comprar ropa buena.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Luego me acompañó a casa y observó todas mis corbatas, por lo que deseché la mayoría de ellas y compré un guardarropa completamente nuevo, tanto de trajes como de corbatas. Su ayuda personal hizo que florecieran mis habilidades latentes como estratega y me ayudó dramáticamente en mi influencia en toda la ciudad e incluso en la administración y gestión de Resurrection Church of New York y de una coalición regional que superviso. Me enseñó cómo crece una organización, principalmente a través de una buena administración, no solo por la predicación ungida; además de que me capacitó en cuanto a que el enfoque de liderazgo de servicio triunfa sobre el método ministerial distante y de arriba hacia abajo con respecto a la liberación del potencial humano.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll-1"
  }, [_vm._v("Principios de liderazgo de Jesús")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Por supuesto, la esencia de este libro es aprender del Señor Jesucristo y cómo desarrollar el potencial de las personas. Con ese fin, hay al menos siete principios primarios que Jesús utilizó para que las personas hicieran la transición de una vida ordinaria a una extraordinaria llena de propósito y cumplimiento divinos. Jesús no produjo discípulos ni transformó vidas simplemente predicando, sino llevando una vida ejemplar que aquellos cercanos a él emularían. Las siguientes son las principales formas en que Jesús empoderó y liberó el propósito en sí mismo y en los demás.")]), _vm._v(" "), _c('p', {
    staticClass: "sbttl"
  }, [_vm._v("Jesús planteaba preguntas.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Más que, simplemente, dar respuestas a las preguntas de la vida, Jesús demostró que la mejor manera de enseñar a las personas era haciéndoles preguntas. De hecho, hizo más de trescientas y solo dio respuestas a tres de ellas."), _c('sup', {
    staticClass: "sup _idGenCharOverride-2"
  }, [_vm._v("1")]), _vm._v(" Cuando permitimos que las personas respondan preguntas, eso revela cuánto saben realmente y lo que en verdad hay en sus corazones; lo que los involucra en el proceso de descubrimiento, permitiéndoles recordar y aprender mejor.")]), _vm._v(" "), _c('p', {
    staticClass: "sbttl"
  }, [_vm._v("Jesús fijó metas y objetivos.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Si las personas no tienen objetivos o resultados específicos, nunca sabrán si han tenido éxito. Si no tienen una visión o una misión, no tienen idea de cuál se supone que es su destino final. Por el contrario, cuando Jesús comenzó su ministerio en Nazaret, lo primero que hizo fue anunciar la declaración de su visión, que se encuentra en las palabras del profeta Isaías (Isaías 61:1-2; Lucas 4:18).")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Además, Jesús operó con objetivos y metas que le permitieron cumplir su misión y su visión con un entendimiento diario de qué, cuándo y cómo funcionar (Lucas 13:32).")]), _vm._v(" "), _c('p', {
    staticClass: "sbttl"
  }, [_vm._v("Jesús invirtió tiempo con aquellos que dieron fruto.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("El principio de Pareto nos enseña que el 80 % del trabajo realizado lo realiza sólo el 20 % de las personas en cualquier iglesia u organización dada."), _c('sup', {
    staticClass: "sup _idGenCharOverride-2"
  }, [_vm._v("2")]), _vm._v(" Jesús entendió este principio mucho antes que Pareto. El Señor fue sabio e invirtió la mayor parte de su tiempo con discípulos que dieron mucho fruto y no con las multitudes. Juan 15:1-7 muestra que Jesús esperaba que sus seguidores dieran mucho fruto si permanecían en él. Sabía que obtendría la mayor cantidad de resultados si se concentraba en unos pocos en vez de enfocarse en muchos. Aunque ministró a las multitudes, los evangelios muestran claramente que invirtió la mayor parte de su tiempo con sus doce apóstoles y luego con los otros setenta (Lucas 9:1; 10:1).")]), _vm._v(" "), _c('p', {
    staticClass: "sbttl"
  }, [_vm._v("Jesús confrontó la religión superficial.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("A Jesús no le gustaba la religión superficial, por lo que atacó a los líderes religiosos que tergiversaban la voluntad de su Padre (Mateo 23). Insistió en que los líderes religiosos permitieran que, antes que todo, Dios limpiara al hombre interior para enfocarse en los rituales y la religión externos (Mateo 23:26; Marcos 7:15). Jesús también enseñó que la tradición religiosa, a menudo, anula la Palabra de Dios (Marcos 7:13). Como enfrentó la religión superficial en lugar de aplacarla, pudo levantar poderosos hombres de Dios que demostraron la verdad con señales y prodigios (Hechos 3:6-7).")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Jesús pudo aprovechar el hecho de que la mayoría de la gente desea una fe genuina y una verdadera relación con Dios y con los demás. No están interesados en meros rituales superficiales y actos religiosos. Incluso la generación joven de hoy está harta y cansada de actuaciones falsas basadas en la religión institucional. Anhelan relaciones y comunidades de fe reales y centradas en Cristo.")]), _vm._v(" "), _c('p', {
    staticClass: "sbttl"
  }, [_vm._v("Jesús se enfrentó al poder político.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Cuando Jesús estaba con Pilato, confesó que su propósito principal era ser reconocido como Rey (Juan 18:37). No temía ofender a los leales a César (que fue la razón principal por la que cual lo crucificaron). Entendió que las cosas que gobernaban la cultura externa tenían que pasar a otro rey y a diferentes guardianes si se iba a producir un verdadero cambio sistémico. Además, le dijo a Pilato que el poder de su reino no emanaba de Roma sino de su Padre, Dios (v. 36). Jesús no dijo que su reino no está en este mundo sino que no era de este mundo.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Incluso las personas en la sociedad actual anhelan una fe que sea relevante en la plaza pública, algo que sea práctico, no meramente místico. Si predicamos y mostramos una fe en Cristo que pueda influir positivamente en el mundo que nos rodea, la próxima generación vendrá a nuestras iglesias en masa.")]), _vm._v(" "), _c('p', {
    staticClass: "sbttl"
  }, [_vm._v("Jesús fue motivado por la compasión.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Jesús no sanaba simplemente para demostrar su señorío, sino porque era movido a compasión (Marcos 1:41). Fue grande en parte porque tuvo empatía y se conectó con el dolor de quienes lo rodeaban (Hebreos 4:15). Cualquier líder sin fuertes sentimientos de amor por su pueblo no estará motivado para servir y liberar la grandeza de los que dirige. La gente no está buscando simplemente otro programa de la iglesia. Están hambrientos de aquellos que se derramen en ellos y los ayuden a descubrir quiénes son y cómo pueden cumplir con su llamado en la vida.")]), _vm._v(" "), _c('p', {
    staticClass: "sbttl"
  }, [_vm._v("Jesús estaba dispuesto a morir por su propósito.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("No vale la pena vivir si no hay un propósito trascendente por el que valga la pena morir. Jesús no solo creyó en su misión, sino que también estuvo dispuesto a morir en la cruz para cumplirla (Hebreos 12:2). En consecuencia, pudo inculcar e inspirar tal pasión en sus seguidores que la mayoría de los doce apóstoles originales murieron como mártires mientras predicaban el evangelio."), _c('sup', {
    staticClass: "sup _idGenCharOverride-2"
  }, [_vm._v("3")]), _vm._v(" Verdaderamente, la semilla de la iglesia primitiva fue la sangre de los mártires del primero y segundo siglos. Incluso hoy, dos mil años después, miles de seguidores de Cristo continúan muriendo por su causa, que es la razón principal por la que el cristianismo se convirtió en el movimiento más grande y formidable en la historia del mundo.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll-1"
  }, [_vm._v("Cómo liberar la grandeza")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Hay algunos principios prácticos que podemos aplicar de la vida de Cristo en nuestro intento por liberar la grandeza en los demás. Al repasar los evangelios, podemos decir que —sin duda— el enfoque principal de Jesús en su ministerio terrenal no fue predicar, enseñar, sanar ni ministrar a las multitudes, sino derramarse en sus doce hombres y hacerlos sus discípulos.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("En el Nuevo Testamento, la palabra discípulo se usó para describir a los seguidores de Cristo mucho más que la palabra cristiano. Jesús ordena a la iglesia hacer discípulos, no solo evangelizar a los perdidos (Mateo 28:19). A pesar de este enfoque desequilibrado, el discipulado no siempre es la norma en la iglesia contemporánea. Los siguientes once principios indispensables son cosas que he aprendido como pastor y hacedor de discípulos durante casi cuatro décadas.")]), _vm._v(" "), _c('p', {
    staticClass: "sbttl"
  }, [_vm._v("Aprenda a ser padre espiritual.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("En estos tiempos de familias rotas, muchos nuevos creyentes no tienen ninguna referencia para someterse a la autoridad, comprender el amor de un Padre, guardar un pacto y tener un hogar piadoso. Dado que la iglesia es una familia de familias y funciona como casa de Dios, una función principal de una iglesia en ciertos contextos debe ser “re-criar” a los nuevos creyentes, lo cual suele ser un proceso muy largo. En consecuencia, para hacer discípulos, a veces tenemos que funcionar como padres espirituales más que simplemente como dispensadores de la verdad bíblica.")]), _vm._v(" "), _c('p', {
    staticClass: "sbttl"
  }, [_vm._v("No se concentre en las multitudes, el marketing ni los presupuestos.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Muchas iglesias contemporáneas se enfocan principalmente en reunir multitudes a través del marketing y brindar una gran experiencia dominical. Sin embargo, para poder hacer discípulos, las iglesias deben priorizar la entrega de creyentes serios que estén comprometidos con la causa de Cristo. ¡La iglesia hará avanzar el reino a través de una minoría santa, no por medio de una mayoría comprometida!")]), _vm._v(" "), _c('p', {
    staticClass: "sbttl"
  }, [_vm._v("Enfóquese en las personas más que en los programas.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("El discipulado no se puede hacer meramente con un programa institucional. No puede darse solo desde el púlpito o con un evento semanal. El apóstol Pablo no solo predicó el evangelio; también vertió su vida en los discípulos. Los discípulos hacen vida juntos, no solo asisten a reuniones y estudios bíblicos.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("En consecuencia, una de las cosas más exitosas que hago para hacer discípulos es que ciertos hombres viajen conmigo cuando ministro para que podamos pasar tiempo juntos y puedan observar cómo interactúo y ministro a aquellos fuera del contexto de nuestra iglesia los domingos. Descubrí que pasar tiempo de calidad con un hombre durante una semana en un viaje ministerial equivale a seis meses de ellos yendo a estudios bíblicos semanales; por lo tanto, acelera grandemente su desarrollo espiritual.")]), _vm._v(" "), _c('p', {
    staticClass: "sbttl"
  }, [_vm._v("Tenga un paradigma relacional más que institucional.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Junto con el punto anterior, el discipulado serio involucra un enfoque muy informal con aquellos que están siendo asesorados; no depende simplemente de las estructuras formales de la iglesia. Muchos pastores intentan hacer discípulos simplemente enviando líderes potenciales a una escuela bíblica o creando un instituto bíblico dentro de su congregación. Estos métodos pueden ser buenos para darle a la gente conocimiento intelectual, pero no producirán hijos e hijas espirituales maduros. Proveer conocimiento intelectual sin una conexión personal afirma una construcción mundana que puede resultar en la creación de líderes dotados sin carácter piadoso. Muchos de estos modelos producen divisiones en la iglesia porque se instalan líderes no probados que no tienen integridad.")]), _vm._v(" "), _c('p', {
    staticClass: "sbttl"
  }, [_vm._v("Adopte el patrón del Nuevo Testamento para la vida de la iglesia.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("El patrón del Nuevo Testamento para la iglesia involucra al pastor principal que está comprometido con una región hasta que se levanten suficientes líderes para servir mejor a la congregación. La asignación del pastor principal se basa en la dirección del Señor, no en la política ni en la burocracia. El modelo eclesial del Nuevo Testamento también da lugar para que se desarrollen ancianos y diáconos además del pastor principal; por lo tanto, este no tiene que hacer todo el trabajo del ministerio. Además, el Nuevo Testamento también enseña que el cuerpo de Cristo debe ser edificado en amor, por lo que cada miembro aporta (Efesios 4:15-16) para que el ministerio no quede relegado meramente al clero profesional. Todo esto abre espacio para el discipulado puesto que da oportunidad para que las personas maduren en Cristo sirviendo a la familia de Dios y más allá.")]), _vm._v(" "), _c('p', {
    staticClass: "sbttl"
  }, [_vm._v("Abrace la vida de la iglesia, no la cultura religiosa de ella.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("La iglesia, a veces, se mueve en muchos contextos tan religiosos que no engendran relaciones genuinas y necesarias para discipular a otros. Las culturas religiosas en las congregaciones producen relaciones superficiales, políticas eclesiásticas e hipocresía en los seguidores en lugar de verdaderos discípulos. Dado que no podemos desconectar la dinámica relacional de la formación de discípulos, el espíritu religioso es una forma segura de perturbar una cultura formativa de discípulos en la congregación.")]), _vm._v(" "), _c('p', {
    staticClass: "sbttl"
  }, [_vm._v("Concéntrese en desarrollar un carácter piadoso más que en promover personas talentosas.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Muchas iglesias se ven tentadas a elevar a cantantes carnales, músicos y predicadores dotados para suplir una necesidad en su congregación. Sin embargo, para nutrir discípulos maduros, la iglesia necesita enfocarse en desarrollar un carácter semejante al de Cristo antes de que a la persona se le permita ministrar en público. Cuando permitimos que los bebés espirituales funcionen en posiciones de liderazgo, pueden verse tentados a enorgullecerse y caer en la trampa satánica (1 Timoteo 3:5-7).")]), _vm._v(" "), _c('p', {
    staticClass: "sbttl"
  }, [_vm._v("Desarrolle equipos de liderazgo para anclar al pastor principal.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Muchos pastores principales se enfocan en apagar incendios, visitar a los enfermos y aconsejar a los heridos, así como en manejar gran parte de la administración de la congregación. Además de todo esto, se espera que prediquen una o dos veces por semana.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Esto deja al pastor sin energía para verterse en líderes potenciales e impide el proceso de hacer discípulos. En consecuencia, la única forma en que una iglesia puede producir discípulos normalmente es que el pastor principal se concentre en formar equipos de liderazgo que lleven la carga del ministerio con él para que puedan enfocarse en el ministerio de la Palabra, la formación de discípulos y la oración (Hechos 6:2-4). Aparte de tener equipos de liderazgo fuertes alrededor de pastores líderes, el discipulado es casi imposible.")]), _vm._v(" "), _c('p', {
    staticClass: "sbttl"
  }, [_vm._v("Adopte el modelo padre-hijo para contrarrestar el espíritu de orfandad en las iglesias.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("El modelo trinitario “Padre, Hijo y Espíritu” es el ejemplo bíblico de unidad, unicidad y hogar. A la luz de esto, tanto el Antiguo como el Nuevo Testamento son modelos de una casa modelo bajo el liderazgo de los ancianos (o padres). Hebreos 1:1 enseña que los profetas hablaron en el pasado a los padres, no a los reyes ni a los sacerdotes, porque los padres tenían la máxima autoridad terrenal. En el Nuevo Testamento, la calificación requerida para los ancianos (o líderes espirituales) era que pudieran administrar bien sus propios hogares (1 Timoteo 3:5), no que fueran grandes predicadores. ¿Por qué? Porque la iglesia es orgánicamente una casa modelo, o una familia a imitar, tal como lo era la nación de Israel en el Antiguo Testamento; por lo tanto, la iglesia necesita adoptar esta estructura padre-hijo. El Espíritu Santo actúa maternalmente como el Consolador de la iglesia. Este es el único modelo en el que la iglesia puede funcionar que tiene el poder de quebrantar el espíritu de orfandad sobre los discípulos potenciales que no pueden funcionar de manera óptima hasta que se rompan sus maldiciones generacionales de huérfanos (Malaquías 4:6).")]), _vm._v(" "), _c('p', {
    staticClass: "sbttl"
  }, [_vm._v("Practique la oración corporativa constante para la vitalidad espiritual en la iglesia.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("A lo largo de los años, he observado que los discípulos más importantes que desarrollé tenían un hambre intensa de buscar a Dios, no solo de decir sus oraciones. La oración guiada por el Espíritu abre al individuo al Espíritu de Dios, que deposita en esa persona la pasión, el poder y la guía divinos. Dado que Jesús solo ministró a través del Espíritu Santo (Hechos 1:1-2), los verdaderos discípulos son aquellos capacitados y dotados por el Espíritu para ministrar. La mejor manera de aprender a orar es participando en poderosas reuniones de oración. La oración se capta más que enseñarse. Hechos 1 ilustra cómo la nació iglesia primitiva y cómo fue fortalecida por un tiempo prolongado de búsqueda y espera en Dios. Si la iglesia primitiva vivía y respiraba oración para liberar el propósito del reino, ¿cómo puede la iglesia de hoy esperar producir discípulos que transformen la cultura sin la oración ferviente? (Ver Santiago 5:16-18).")]), _vm._v(" "), _c('p', {
    staticClass: "sbttl"
  }, [_vm._v("Edifique sobre el paradigma de la iglesia local, no sobre el paradigma paraeclesiástico para hacer discípulos.")]), _vm._v(" "), _c('p', {
    staticClass: "p _idGenParaOverride-1"
  }, [_vm._v("En conclusión, hay muchos ministerios paraeclesiásticos bien intencionados que intentan hacer discípulos sin la participación de la iglesia local. Son fuertes en cuanto a misión pero débiles en cuanto a eclesiología. Probablemente razonen inconscientemente lo siguiente: “Jesús hizo doce discípulos antes de que existiera una iglesia, para que nosotros podamos hacer lo mismo”. Sin embargo, aun una lectura superficial de los evangelios muestra que la iglesia siempre fue el objetivo de los planes de Jesús para hacer discípulos. (Ver Juan 14—17 como ejemplo). Como alguien que vivía dentro de la estructura trinitaria Padre e Hijo, Jesús sabía que la única manera de hacer avanzar su reino era produciendo una familia modelo que finalmente cumpliría la promesa que el Padre hizo a Abraham: que en él serían benditas todas las familias de la tierra (Génesis 12:1-3). Por lo tanto, el mandato cultural original se cumpliría al empoderar a las familias espirituales y biológicas (Génesis 1:27-28). Por supuesto, esto implica mucho más que simplemente reunir a los hombres para un estudio bíblico semanal. He aprendido que a menos que la familia biológica de una persona esté conectada a una familia espiritual de familias, su capacidad para cumplir el propósito de Dios será muy limitada.")]), _vm._v(" "), _c('p', {
    staticClass: "CHAP--",
    attrs: {
      "id": "_idParaDest-15"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor010"
    }
  }), _vm._v("Capítulo 7")]), _vm._v(" "), _c('p', {
    staticClass: "CHAP-TITLE",
    attrs: {
      "id": "_idParaDest-16"
    }
  }, [_vm._v("Camine en su asignación")]), _vm._v(" "), _c('p', {
    staticClass: "pf"
  }, [_c('span', {
    staticClass: "SM-CAP",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Una de las ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("mayores falacias en la iglesia es que el creyente puede ser cualquier cosa que desee. Filipenses 4:13, que dice: “Todo lo puedo en Cristo que me fortalece”, a veces se saca de contexto para indicar que el creyente puede decidir convertirse en lo que desee o hacer lo que se le antoje. Sin embargo, el pasaje se refiere a que Pablo continúa con su ministerio a pesar de los desafíos financieros que enfrentó. Si un creyente, de alguna manera, puede ser o hacer lo que quiera, entonces Jesús habría ordenado a miles de personas como sus apóstoles para que se pudieran plantar más iglesias. Pero después de pasar toda la noche en oración, escogió solo a doce para servir al reino como apóstoles. Esa elección no se basó en ningún rasgo biológico ni psicológico, ni porque estuvieran cerca de él. Se basó en el llamado de Dios y en los dones y habilidades que vio en esos doce hombres. Por lo tanto, el Padre tenía ciertos criterios que debían cumplirse para que su Hijo ordenara a una persona.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Aunque no sabemos mucho sobre los antecedentes de algunos de los apóstoles, una cosa que posiblemente todos tenían en común era que trabajaban en diversas áreas. Algunos de ellos tenían sus propios negocios de pesca: Santiago, Juan, Andrés y Pedro (Mateo 4:18-22); otro era recaudador de impuestos (Mateo 9:9); y otro, Simón el Zelote, estaba involucrado en la política (Marcos 3:18). Jesús no eligió personas perezosas ni que estuvieran sin hacer nada. Escogió principalmente hombres activos en la comunidad empresarial, individuos que al menos estaban ocupados usando sus dones y habilidades. Curiosamente, no hay registro directo de que haya elegido a un levita, sacerdote o líder religioso para ser apóstol.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Como pastor, he aprendido que si quiero algo, ¡lo asigno a las personas más ocupadas de la iglesia! Debido a que las necesidades de la congregación y la familia son grandes, los que tienen mucho tiempo libre suelen ser perezosos y eluden sus responsabilidades. Por eso, una de las cosas más importantes en las que debe pensar cuando está considerando a quién debe intentar asesorar es si esa persona ya es fiel con las tareas que tiene por delante. Si una persona no puede ser fiel con las cosas materiales en esta vida, ¿quién le va a confiar las verdaderas riquezas? Si una persona no puede ser fiel sirviendo a otra, ¿quién le confiará sus propios bienes para que los administre? (Así lo dijo Jesús en Lucas 16:10-12).")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Otro de los mayores obstáculos para las personas que andan en el nivel más alto de su potencial es cuando intentan triunfar en un área ajena a su vocación y sus dones. Dios le dio a cada persona tareas específicas en su reino basadas en sus dones y sus habilidades. Por lo tanto, si no las cumplimos, no maximizaremos el potencial que Dios nos otorgó. Uno de los días más tristes de la eternidad será cuando los creyentes comparezcan ante el tribunal de Cristo y descubran que no hicieron lo que Dios los llamó a hacer, haya sido por temor al fracaso, incredulidad o pereza, o porque trabajaron duro para triunfar en un área laboral a la que nunca fueron llamados (2 Corintios 5:10). En verdad, una vida productiva y con un propósito no proviene de la mera actividad o la gestión del tiempo, sino de la gestión de la atención relacionada con nuestra tarea principal en la vida.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("En los últimos treinta años he conocido a numerosas personas que fueron engañadas pensando que fueron llamadas a cantar (sin ningún talento en esa área) o fueron llamadas a ser pastores o ministros, aunque no tenían gracia ni fruto para respaldar sus afirmaciones. Para alcanzar nuestro potencial en la vida, tenemos que ser honestos con nosotros mismos y no intentar hacer algo o ser alguien que no estamos llamados a hacer o ser.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("¡La gran noticia es que Dios nos hizo a cada uno de manera maravillosa y asombrosa (Salmos 139:13-14) y que nunca ha habido ni habrá otro ser como usted en toda la eternidad! Usted (y cualquier otra persona que haya nacido) necesita descansar en el hecho de que es más valioso que todos los metales preciosos, piedras y joyas del mundo porque solo hay uno como usted entre miles de millones de personas en la tierra. Jesús dijo que nuestra alma vale más que el mundo entero. (Ver Marcos 8:36). No estoy tratando de ser el próximo T. D. Jakes porque sé que nunca podré ser como T. D., así como tampoco él podrá ser yo. Cuanto más acepto quién soy, más fácil será para mí desarrollar la autoconciencia, lo que dará como resultado que todos mis dones y habilidades se liberen en la tierra.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("En cuanto a nuestra singularidad, debemos recordar que, dado que Dios nos formó en el vientre de nuestras madres, su obra no solo comenzó en nosotros después de la conversión, sino que fue antes del nacimiento, según escrituras como el Salmo 139, Jeremías 1:5 y Efesios 1:4. Los dones naturales, las habilidades, la personalidad y la forma en que estamos conectados emocional, mental y físicamente, juegan un papel importante en la determinación de nuestro propósito en la vida. Por lo tanto, nuestras habilidades, personalidades y dones naturales tienen que alinearse con nuestros dones espirituales y motivacionales para determinar nuestro propósito y liberar nuestro potencial.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Como ya se mencionó, si sentimos que Dios nos ha llamado a cantar para él, podemos asumir correctamente que Dios no solo nos ungirá cuando cantemos, sino que nos otorgará una voz especial que sea agradable al oído. Si alguien siente que Dios lo ha llamado a jugar para la NBA, para usarlo como una plataforma a fin de predicar el evangelio, entonces es mejor que dicha persona tenga la altura natural, el cuerpo atlético y la habilidad correspondiente, así como un buen historial en la escuela secundaria y la universidad para adaptarse a la trayectoria de un jugador de baloncesto profesional.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("En otras palabras, Dios no es tonto. Si designa a alguien para que haga algo, no solo lo ungirá, sino que también lo equipará con las habilidades espirituales y naturales necesarias para realizar dicha asignación. En consecuencia, es absolutamente esencial que tengamos sabiduría divina y un sentido intuitivo de cómo preparar y ubicar a la persona de forma acorde a su llamado, si es que vamos a ayudarla a liberar su potencial. Si tratamos de hacer de todos un predicador o un cantante a nuestra propia imagen, frustraremos, desalentaremos e incluso destruiremos la fe de aquellos a quienes estamos preparando para el fracaso.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Por supuesto, en el contexto de Lucas 6:12-13, Jesús pasó toda la noche en oración, lo que significa que nosotros, como aprendices, somos responsables de escuchar a Dios en cuanto a dónde debemos ubicar a quienes estamos equipando. En las etapas iniciales, toda persona debe involucrarse en el ministerio de ayuda, es decir, colaborar en las cosas materiales y en los servicios que se requieran antes de que se le otorgue algo de mayor importancia. Este es un gran campo de pruebas que permite a los mentores probar y desarrollar a aquellos a quienes están asesorando para ver qué tipo de habilidades, fidelidad y actitud tienen las personas.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Incluso Jesús probó y entrenó a sus doce apóstoles de esta manera. Por ejemplo, antes de que los llamara para trabajar como apóstoles, fungieron como diáconos, haciendo cosas como ayudar a sentar a las personas en grupos de cincuenta y cien cuando Jesús estaba alimentando a los cinco mil (Marcos 6:33-44), comprando comida mientras ministraba a las necesidades espirituales de otros (Juan 4), consiguiendo un burro para montar (Lucas 19:29-35), preparando el aposento alto para su Última Cena (Lucas 22:8-13) y así sucesivamente.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll-1"
  }, [_vm._v("Dios, el gran distribuidor")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Una vez escuché decir que la clave para crear un movimiento es la distribución del trabajo. Creo que eso es cierto. La Biblia habla de la distribución divina del trabajo que ha resultado en el movimiento más grande y poderoso de la historia del mundo en los últimos dos milenios: el cristianismo. Tanto en las cartas a los Corintios como a los Romanos encontramos algo de lo que dice la Escritura acerca de esta distribución divina del trabajo.")]), _vm._v(" "), _c('p', {
    staticClass: "sbttl"
  }, [_vm._v("Los dones espirituales (1 Corintios 12:4-6)")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("El apóstol Pablo nos enseña en la Primera Epístola a los Corintios que hay variedad de dones, pero un mismo Espíritu; que hay variedad de ministerios, pero un mismo Señor y que hay variedad de manifestaciones o efectos pero un mismo Dios que obra en todos. Así que aquí vemos que Dios toma una variedad de dones, ministerios y manifestaciones del Espíritu dentro de los creyentes individuales y distribuye su trabajo en la iglesia como lo considera adecuado.")]), _vm._v(" "), _c('p', {
    staticClass: "sbttl"
  }, [_vm._v("Las manifestaciones espirituales (1 Corintios 12:7-10)")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Pablo también menciona nueve manifestaciones del Espíritu que operan en los individuos que Dios concede para el bien común de todos.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Los nueve dones mencionados se pueden dividir en tres categorías:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "NUMBER-1",
    attrs: {
      "value": "1"
    }
  }, [_c('span', {
    staticClass: "NUMBER",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Los ")]), _vm._v("dones hablados de lenguas, la interpretación de lenguas y la profecía.")]), _vm._v(" "), _c('li', {
    staticClass: "NUMBER-2 ParaOverride-1"
  }, [_c('span', {
    staticClass: "NUMBER CharOverride-1"
  }, [_vm._v("Los ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("dones de revelación como las palabras de sabiduría, conocimiento y discernimiento de espíritus.")])]), _vm._v(" "), _c('li', {
    staticClass: "NUMBER-2 ParaOverride-1"
  }, [_c('span', {
    staticClass: "NUMBER CharOverride-1"
  }, [_vm._v("Los ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("dones poderosos de sanidad, milagros y fe.")])])]), _vm._v(" "), _c('p', {
    staticClass: "paa"
  }, [_vm._v("Todos estos dones son divinos, dones momentáneos que le llegan a una persona; no deben confundirse con habilidades residuales como la sabiduría que una persona ha acumulado en la experiencia de la vida o el conocimiento que una persona ha adquirido al leer libros o la fe que una persona ha desarrollado por escuchar y obedecer la Palabra de Dios, como se muestra en 2 Tesalonicenses 1:3. El propósito de este capítulo no es explicar cada uno de estos dones y funciones, sino demostrar cómo coloca Dios a las personas en la iglesia de manera que cada individuo pueda mostrar cierto aspecto de la obra de Dios en la iglesia y el mundo.")]), _vm._v(" "), _c('p', {
    staticClass: "sbttl"
  }, [_vm._v("Los dones ministeriales en la iglesia (1 Corintios 12:28)")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Pablo, entonces, mencionó (aparentemente de forma jerárquica) en qué orden coloca a los líderes con dones ministeriales en la iglesia, diciéndonos que Dios ha puesto en la iglesia primero apóstoles, luego profetas, lo tercero maestros, luego milagros, luego dones de sanidades, ayudas y administraciones. Por lo tanto, Dios es muy práctico, ya que une equipos con personas que tienen dones ministeriales junto con aquellos que tienen el ministerio de ayuda o el de administración. En consecuencia, no es suficiente que una iglesia tenga líderes ministeriales ungidos. También tiene que tener personas que operen en fuertes dones de servicio y administración para aprovechar la unción y que sea una congregación eficaz.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("La enseñanza de Pablo en esta parte de Corintios es similar a otro conjunto de dones ministeriales que Jesús envió a la iglesia, como se encuentra en la carta de Pablo a la iglesia en Efesios. En esta carta, Pablo dice que Dios también ha asignado a unos apóstoles, a otros profetas, a otros evangelistas, a otros pastores y maestros, a fin de perfeccionar a los santos para la obra del ministerio para edificación del cuerpo de Cristo (Efesios 4:11-12).")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Por lo tanto, en esta lista los apóstoles y profetas ocupan el primer y el segundo lugar, el maestro figura en tercer puesto. Luego, en vez de usar la palabra evangelista, se mencionan los que hacen milagros, sanidades, lo que algunos estudiosos afirman que es otra forma de decir evangelista, ya que el evangelista bíblico (como se ve en el ministerio de Felipe a Samaria, en Hechos 8) trabaja con grandes señales, prodigios y curaciones. Además, algunos han argumentado que en Efesios el idioma griego original muestra al pastor-maestro como una sola función. Por lo tanto, los cinco se mencionan de manera diferente en ambas listas de dones ministeriales (1 Corintios 12:28; Efesios 4:11).")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Note también que el propósito de estos conjuntos de dones, como se ven en Efesios, no es hacer la obra del ministerio sino ayudar a equipar y colocar a los santos para la obra del ministerio (4:12), lo que muestra que la vocación principal de cada llamado “ministro de los cinco ministerios” o de cada don ministerial es ser mentor y capacitador, no simplemente un predicador ministro.")]), _vm._v(" "), _c('p', {
    staticClass: "sbttl"
  }, [_vm._v("Dones motivacionales (Romanos 12:3-8)")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Por último, Pablo enumera una lista más que vale la pena notar si queremos entender cómo ubicar a las personas apropiadamente en la iglesia. Pablo comienza como yo empecé este capítulo, diciendo que no necesitamos pensar más de nosotros mismos de lo que deberíamos, sino con autoconciencia y sobriedad para comprender los dones que Dios nos ha dado de acuerdo a nuestra medida de fe.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Luego Pablo enumera lo que muchos denominan “dones motivacionales” para distinguirlos de los dones mencionados en sus otras epístolas (1 Corintios 12; Efesios 4), ya que parecen estar también agrupados con cosas que son claramente motivacionales y residuales (por ejemplo, la misericordia y la generosidad financiera con los demás). Estos dones motivacionales deben distinguirse de las manifestaciones del Espíritu mencionadas en 1 Corintios 12, como la palabra de conocimiento y sabiduría. Nótese que no dice enciclopedia ni mensaje de sabiduría y conocimiento. Estas manifestaciones del Espíritu están claramente destinadas a ser experiencias inconclusas de un otorgamiento divino de su gracia para un tiempo y una tarea específicos.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Los dones motivacionales mencionados muestran cómo ha configurado Dios a los creyentes individuales en la iglesia para que estén motivados a funcionar de cierta manera con un don en particular.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Los dones enumerados aquí son:")]), _vm._v(" "), _c('ul', [_c('li', {
    staticClass: "BULLET-1"
  }, [_vm._v("Profecía: algunos tienen una motivación profética, no solo un don de profecía, que les llega a veces, como se encuentra en 1 Corintios 12; 14.")]), _vm._v(" "), _c('li', {
    staticClass: "BULLET-2"
  }, [_vm._v("Servicio")]), _vm._v(" "), _c('li', {
    staticClass: "BULLET-2"
  }, [_vm._v("Enseñanza")]), _vm._v(" "), _c('li', {
    staticClass: "BULLET-2"
  }, [_vm._v("Exhortación")]), _vm._v(" "), _c('li', {
    staticClass: "BULLET-2"
  }, [_vm._v("Dar: puesto que a todos se les ordena dar diezmos y ofrendas, esto se refiere a la persona altamente motivada y asignada por Dios con el objeto de que cree riqueza para el reino a fin de apoyar el evangelio.")]), _vm._v(" "), _c('li', {
    staticClass: "BULLET-2"
  }, [_vm._v("Liderazgo")]), _vm._v(" "), _c('li', {
    staticClass: "BULLET-2"
  }, [_vm._v("Misericordia: dado que todos los creyentes son llamados a tener compasión por otras personas, esto obviamente se refiere a alguien que es motivado por un don de misericordia, que probablemente tendrá un fuerte alcance compasivo o un ministerio que ayude a otras personas constantemente, en contraposición a la misericordia que se muestra esporádicamente o cuando surge una oportunidad.")])]), _vm._v(" "), _c('p', {
    staticClass: "paa"
  }, [_vm._v("En resumen, según Pablo, tenemos varias administraciones y distribuciones de nueve manifestaciones del Espíritu (1 Corintios 12), junto con siete dones motivacionales (Romanos 12) que vienen a través de todo el cuerpo de Cristo bajo el liderazgo de los cinco grupos de dones (Efesios 4:11). Somos llamados a reconocer estos dones en las personas, de manera que podamos equiparlos y ubicarlos adecuadamente (v. 12).")]), _vm._v(" "), _c('p', {
    staticClass: "p _idGenParaOverride-1"
  }, [_vm._v("Por último, a medida que hagamos lo que Dios nos ha llamado a hacer, todos seremos edificados, bendecidos y habrá un lugar para que todos en la iglesia ministren, porque se necesita todo el cuerpo para funcionar adecuadamente y liberar cada parte individual (1 Corintios 12:12-27).")]), _vm._v(" "), _c('p', {
    staticClass: "CHAP--",
    attrs: {
      "id": "_idParaDest-17"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor011"
    }
  }), _vm._v("Capítulo 8")]), _vm._v(" "), _c('p', {
    staticClass: "CHAP-TITLE",
    attrs: {
      "id": "_idParaDest-18"
    }
  }, [_vm._v("El poder del fracaso")]), _vm._v(" "), _c('p', {
    staticClass: "pf"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("¡")]), _vm._v("U"), _c('span', {
    staticClass: "SM-CAP",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("na de las ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("grandes libertades humanas es la de fallar y volver a intentarlo! He oído decir que antes de que Abraham Lincoln se convirtiera en presidente de Estados Unidos, sufrió bancarrota y perdió varias elecciones locales y nacionales. Para liberar el potencial, debemos estar dispuestos a permitir que las personas fracasen. Controlar a otros no libera su potencial; confiar en ellos aunque cometan errores y aprender de estos sí lo hace.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Jesús pudo liberar el potencial mejor que nadie, aunque tuvo que trabajar con personas que eran líderes rudos, sin pulir e inexpertos que a menudo cometían fallas. Eso se debió a que Jesús permitió que las personas fracasaran como parte de su proceso de discipulado. Si Jesús fuera un fanático del control de la microgestión que esperaba la perfección de sus seguidores, habría fallado en su misión de iniciar un movimiento global. Al leer los evangelios, observamos cómo todas las personas clave fueron investidas con liderazgo, a pesar de tener sus imperfecciones y a veces cometer errores en la toma de decisiones. Por ejemplo, Jesús tuvo que corregir a los apóstoles Santiago y Juan por querer hacer descender fuego del cielo para destruir la ciudad de Samaria puesto que sus habitantes no querían recibir a Jesús (Lucas 9:51-56).")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("El apóstol Pedro fue inicialmente tan impredecible que en cuestión de minutos pasó de ser la primera persona en recibir la revelación de Dios Padre de que Jesús era el Mesías prometido a intentar disuadir a este Mesías de cumplir su misión principal: morir en la cruz por los pecados del mundo. Jesús, en realidad, se dirigió a Pedro como Satanás porque estaba bajo la influencia del maligno (Mateo 16:13-23). ¡En un episodio, Pedro pasó de ser influenciado por Dios a ser un vocero del diablo!")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("La mayoría de nosotros probablemente nos habríamos rendido con una persona tan impredecible. Pero Jesús se quedó allí con Pedro. Después de su ascensión, lo usó como el vocero de su iglesia aun después de que este cedió a la tentación y negó haber conocido a Jesús (Mateo 26:69-75). En consecuencia, Jesús restauró a Pedro al ministerio después de que resucitó de entre los muertos (Juan 21:15-17) y se demostró que estaba en lo correcto, porque en solo unas pocas semanas Pedro se convirtió en el líder de la iglesia recién formada y predicó ese gran mensaje en ¡el día de Pentecostés que llevó a tres mil personas a comprometerse a seguir a Cristo!")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Recuerdo cuando comencé nuestro ministerio en 1980. Teníamos un joven, recién salido de la escuela bíblica, que sentía una gran pasión por Dios y atendió al llamado de predicar el evangelio. Tenía falta de confianza, la que se manifestaba a través de un tartamudeo excesivo. Aunque difícilmente podía sacar una frase de su boca sin tartamudear, le permití predicar de vez en cuando y seguí alentándolo a pesar de sus obvias limitaciones. Nunca le dije que tartamudeaba y, a pesar de lo doloroso que era en esos días iniciales escucharlo, el Señor me seguía mostrando que le permitiera predicar. De modo que comenzó a transformarse ante mis ojos y en pocos años ya casi no tartamudeaba. ¡Con el tiempo se mudó a otro país con su familia e hizo una obra misional tan poderosa que toda una nación se vio impactada por su ministerio a los líderes de la iglesia!")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Hasta el día de hoy tiene un ministerio fuerte y viable que habría estado en peligro si lo hubiera corregido por su tartamudeo excesivo y le hubiera dicho que no podía predicar a menos que superara su impedimento del habla. La mayoría de la gente olvida que Michael Jordan, posiblemente el mejor jugador de baloncesto de todos los tiempos, fue eliminado del equipo de su escuela secundaria y no ganó su primer campeonato (de seis) con los Chicago Bulls hasta que tuvo veintiocho años y en la liga durante unos siete años. Los Bulls se volvieron tan dominantes que la mayoría de la gente pensaba que ganar un campeonato era algo automático para ellos, pero tuvieron que sufrir muchos años de fracasos en las competencias antes de alcanzar su potencial.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("De hecho, el fracaso puede conducir al éxito y a la liberación de nuestro potencial si aprendemos de nuestro pasado y nos volvemos más sabios para el futuro. Cuando aprendemos de nuestras experiencias, ellas se convierten en una herramienta de crecimiento. Si nos negamos a evaluar francamente nuestra vida y aprender de nuestros fracasos, estamos condenados a seguir repitiendo los mismos errores una y otra vez, con lo que desperdiciaremos años de nuestra existencia. Necesitamos ver el fracaso de la misma manera que los científicos. Aunque nuestra cultura glorifica el éxito y ama a sus ganadores, como se ilustra en la forma en que exaltamos a nuestros héroes deportivos, los mayores avances en ciencia y tecnología se produjeron en la historia occidental porque los científicos veían el fracaso en los experimentos como un proceso más en sus esfuerzos por demostrar sus hipótesis. Por lo tanto, cada fracaso era parte de ese proceso y lo tomaban como algo que reducía las posibilidades y los acercaba a la verdadera hipótesis. Si viéramos el fracaso como lo hacen los científicos y no como se ve en los deportes (con un enfoque de que el ganador se lo lleva todo), entonces avanzaríamos constantemente en nuestros intentos por liberar nuestro potencial.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Otra forma de ver el fracaso desde una perspectiva positiva es percatarnos de que a veces fallamos porque asumimos responsabilidades nuevas y mayores que desafían nuestras capacidades mentales, espirituales y físicas. Por ejemplo, los "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("powerlifters")]), _vm._v(" —deportistas que alzan pesas en tres ejercicios específicos— intentan levantar un peso que nunca antes han alzado con éxito a fin de aumentar su fortaleza y su resistencia muscular. A menudo son incapaces de levantarlo por sí mismos, por lo que hay una persona —asistente— que los observa y coloca un dedo en el peso para ayudarlos a completar una repetición completa. Si solo levantaran pesas con las que se sintieran cómodos y no forzaran sus músculos, nunca pasarían al siguiente nivel. Por otro lado, cuando aprendí a montar bicicleta, me caía continuamente; pasaron tres días antes que pude mantener el equilibrio y andar con éxito. Otro caso, un bebé tiene que caerse varias veces antes de aprender a caminar y tiene que dominar la marcha antes de que pueda empezar a correr.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Cierta vez estaba animando a un hombre que pensaba que estaba decayendo en su fe y retrocediendo porque estaba fallando en algunas de las pruebas y tentaciones que se le presentaban. Le dije que no estaba perdiendo terreno espiritualmente porque ahora tenía más responsabilidad que nunca y estaba fallando simplemente porque las pruebas se volvían cada vez más difíciles y revelaban debilidades en su carácter que tenía que superar para seguir madurando. Tenemos que recordar que cuando lleguemos a un nuevo nivel, habrá un demonio nuevo y más grande que ha d encontrarnos y ponernos a prueba.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Cuando terminé de escribir este capítulo, sorprendentemente, me topé con una entrevista con Nick Foles, el mariscal de campo del equipo de futbol americano Philadelphia Eagles. Decía cosas en el artículo que se alinean con los principios de este capítulo. Quiero citar un fragmento de su entrevista:")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("Creo que lo más importante es no tener miedo a fallar”, dijo Foles. Creo que en nuestra sociedad actual… Instagram… Twitter… son como presentadores de los mejores momentos. Todo lo que ves son cosas buenas. Pero cuando lo comparas con lo difícil que te fue en el día, piensas: “Mi vida no es tan buena”, y crees que estás fallando.")]), _vm._v(" "), _c('p', {
    staticClass: "BLOCK-2"
  }, [_vm._v("El fracaso es parte de la vida. Es parte de la formación del carácter y el crecimiento. Sin fracaso, ¿quién serías? No estaría aquí arriba si no me hubiera caído miles de veces. Si no hubiera cometido errores.")]), _vm._v(" "), _c('p', {
    staticClass: "BLOCK-2"
  }, [_vm._v("Todos somos humanos, todos tenemos debilidades, y creo que a lo largo de esto (ha sido importante) poder hablar de eso y ser transparente. Sé que cuando escucho a la gente hablar y compartir sus debilidades, estoy escuchando. Porque eso resuena.")]), _vm._v(" "), _c('p', {
    staticClass: "BLOCK-2"
  }, [_vm._v("Así que no soy perfecto. No soy Superman. Podría estar en la Liga Nacional de Futbol Americano, podría haber ganado un Super Bowl, pero bueno, todavía enfrento batallas diarias, luchas cotidianas. Y ahí es donde entra en escena mi fe, ahí es donde surge mi familia.")]), _vm._v(" "), _c('p', {
    staticClass: "BLOCK-2"
  }, [_vm._v("Creo que cuando observas la lucha en tu vida, debes saber que solo es una oportunidad para que tu carácter crezca. Y ese ha sido el mensaje. Simple. ¿Qué hacer si algo te pasa y tienes que luchar? Abraza eso. Porque estás creciendo."), _c('sup', {
    staticClass: "sup _idGenCharOverride-2"
  }, [_vm._v("1")])]), _vm._v(" "), _c('p', {
    staticClass: "paa"
  }, [_vm._v("Para resumir lo que he aprendido sobre el fracaso en la vida, los siguientes son doce principios que quiero dejar al final de este capítulo. Estos principios son esenciales si vamos a asumir la actitud necesaria tanto para enseñar como para animar a las personas a desatar su potencial y caminar en su destino divino. ¿Por qué? Porque todos serán probados por el fracaso, unos más que otros. La forma en que las personas reaccionen y respondan al fracaso personal determinará si serán ordinarias o extraordinarias.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll-1"
  }, [_vm._v("Aprenda de los errores")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Escuché decir una vez que “el fracaso es el padre de la innovación”. Esta es una afirmación muy cierta ya que antes de cada carrera o esfuerzo exitoso suele haber una multitud de fracasos.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Todos tenemos que aprender a fallar en nuestro avance. Cada vez que ingresamos a un nuevo año, debemos reflexionar sobre los éxitos y fracasos del que acaba de pasar, usando los dos periodos como parte de la trayectoria que nos lleva a una experiencia más productiva en el futuro. Cuando hablo de éxito me refiero a llevar una vida que da fruto para la gloria de Dios. Por fracaso me refiero a cualquier cosa que iniciamos o en la que participamos que no da gloria al nombre de Jesús ni produjo ningún fruto inmediato y perceptible. El fracaso también se puede definir como cuando un paradigma, estrategia de vida o ministerio ya no está produciendo los resultados que nos propusimos conseguir.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("El 10 de enero de 2019, celebré mi aniversario como creyente y seguidor de Jesucristo. He servido en el ministerio eclesiástico oficial de tiempo completo desde noviembre de 1980; por lo tanto, he tenido que tratar constantemente con numerosas personas con una plétora de desafíos en el contexto de una metrópolis compleja como la ciudad de Nueva York. En el trayecto, he pasado por muchas etapas y ciclos de vida y he experimentado tanto el éxito como el fracaso. He aprendido por las malas a aceptar el fracaso como parte del proceso normal de aprendizaje. Cuanto más envejezco, acumulo más experiencia y espero tener lecciones de fracaso menos intensas en mi travesía.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Aunque Cristo es el redentor de todo fracaso y cada pecado, la Biblia está repleta de historias de éxito, pero tiene una narración que habla sobre la forma de utilizar el fracaso y el mal para bien. Por ejemplo, después de que el patriarca José fue vendido como esclavo por sus hermanos biológicos, muchos años después fue ascendido —providencialmente— a segundo al mando en Egipto. Después de encontrarse con José como su líder político, sus hermanos temieron que les cobrar su injuria. Sin embargo, José les dijo que lo que ellos entendían por mal, Dios lo encaminó para bien (Génesis 50:20). El apóstol Santiago escribió que debemos tener por puro gozo cuando nos encontramos en diversas pruebas porque el resultado de ellas desarrolla nuestro carácter (Santiago 1:2-4). Además, el sufrimiento de Jesús resultó en su gloriosa resurrección (Filipenses 2:5-11). No importa lo que el diablo intente hacer, ¡Dios lo supera y le da la vuelta!")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Por lo tanto, la Biblia tiene una teología del éxito que puede surgir de cualquier fracaso que experimentemos, si respondemos a Dios con fe y humildad. Además, Romanos 8:28 nos enseña que a los que aman a Dios, todas las cosas les ayudan a bien. Uno de los mayores descubrimientos que he hecho es que no puedo perder como seguidor de Cristo. ¡Aun cuando fracase, puedo aprovechar el revés como una oportunidad para un mayor crecimiento y poder alcanzar otro nivel de éxito!")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Toda situación y circunstancia, por difícil que sea, ¡puede redimirse para bien! Tenemos que darnos cuenta de que, dado que todos somos pecadores que no alcanzamos la gloria de Dios, el fracaso —en alguna modalidad— es inevitable para cada uno de nosotros. Esto no quiere decir que dejemos de intentar triunfar o que tengamos una mentalidad derrotista; simplemente significa que tenemos que tener la perspectiva correcta si vamos a abrirnos paso hacia el éxito.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Por ejemplo, Abraham Lincoln, posiblemente el mejor presidente de esta nación, tuvo una larga lista de fracasos en su currículum antes de llegar a la cima. El siguiente fue su camino a la presidencia:")]), _vm._v(" "), _c('ul', [_c('li', {
    staticClass: "BULLET-1"
  }, [_vm._v("Fracasó en los negocios a los 21 años.")]), _vm._v(" "), _c('li', {
    staticClass: "BULLET-2"
  }, [_vm._v("Fue derrotado en una elección legislativa a los 22 años.")]), _vm._v(" "), _c('li', {
    staticClass: "BULLET-2"
  }, [_vm._v("Volvió a fracasar en los negocios a los 24 años.")]), _vm._v(" "), _c('li', {
    staticClass: "BULLET-2"
  }, [_vm._v("Superó la muerte de su amada a los 26 años.")]), _vm._v(" "), _c('li', {
    staticClass: "BULLET-2"
  }, [_vm._v("Tuvo una crisis nerviosa a los 27 años.")]), _vm._v(" "), _c('li', {
    staticClass: "BULLET-2"
  }, [_vm._v("Perdió la elección de un escaño al Congreso a los 34 años, perdió otra carrera por el Congreso a los 36 años y luego otra por el Senado a los 45 años.")]), _vm._v(" "), _c('li', {
    staticClass: "BULLET-2"
  }, [_vm._v("No se convirtió en vicepresidente a los 47 años y perdió una carrera por el Senado a los 47 años.")]), _vm._v(" "), _c('li', {
    staticClass: "BULLET-2"
  }, [_vm._v("Para conmoción y sorpresa de muchos, fue elegido presidente de los Estados Unidos a los 52 años."), _c('sup', {
    staticClass: "sup _idGenCharOverride-2"
  }, [_vm._v("2")])])]), _vm._v(" "), _c('p', {
    staticClass: "paa"
  }, [_vm._v("El Salmo 37:23-24 dice: “Por Jehová son ordenados los pasos del hombre, y él aprueba su camino. Cuando el hombre cayere, no quedará postrado, porque Jehová sostiene su mano” (RVR1960). Proverbios 24:16 afirma: “porque siete veces podrá caer el justo, pero otras tantas se levantará; los malvados, en cambio, se hundirán en la desgracia”.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Cualquiera que piense que estará exento de severas pruebas y fracasos solo porque sirve a Dios, se equivoca. Todo lo que tiene que hacer es leer el Libro de los Salmos, que está repleto de historias de personas que han experimentado tanto el fracaso como el éxito, junto con depresión emocional y alegría exultante. A la luz de eso, es extremadamente importante que cada persona entienda cómo convertir cada fracaso en un éxito (eventual).")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll-1"
  }, [_vm._v("Doce formas de convertir el fracaso en éxito")]), _vm._v(" "), _c('p', {
    staticClass: "sbttl"
  }, [_vm._v("1. Cambie lo que se dice a sí mismo.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Lo primero y más importante que debemos hacer después del fracaso es volver a levantarnos. Eso lo hacemos silenciando toda voz negativa dentro de nuestras cabezas. Tener pensamientos negativos lleva a la desesperanza, al desánimo e incluso a la depresión. La importancia de eso no se puede exagerar. Proverbios 23:7 dice: “Cual es su pensamiento en su corazón, tal es él” (RVR1960). Nos convertimos en la acumulación de nuestros pensamientos ya que ellos conducen a acciones y estas llevan a formar hábitos, que luego determinan nuestro destino. Cuanto más tiempo nos revolquemos en este tipo de “pensamiento pestilente”, más difícil será salir de nuestro pozo emocional. Dado que nos hablamos a nosotros mismos más que a cualquier otra persona, es de vital importancia que controlemos lo que pensamos.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("En Números 13:33 vemos que los hijos de Israel pensaban que eran como langostas en comparación con los gigantes en la tierra prometida. ¡Esto los llenó de incredulidad e hizo que toda una generación no alcanzara el propósito de Dios! Necesitamos cambiar nuestras conversaciones internas y decirnos a nosotros mismos que “somos más que vencedores por medio de aquel que nos amó” (Romanos 8:37) y que todo lo podemos en Cristo que nos fortalece (Filipenses 4:13). También debemos comprometernos a hablar y pensar solo en palabras que liberen la fe, la verdad y el propósito. Filipenses 4:8 nos dice: “Todo lo que es verdadero, todo lo que es honorable, todo lo que es justo, todo lo que es puro, todo lo que es amable, todo lo que es digno de elogio, si hay alguna excelencia, si algo digno de alabanza, en estas cosas pensad”. Todos podríamos hacer las cosas bien y recuperarnos de cualquier fracaso si obedeciéramos este pasaje.")]), _vm._v(" "), _c('p', {
    staticClass: "sbttl"
  }, [_vm._v("2. Aprenda de sus errores pasados.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Si los científicos e innovadores en tecnología trataran el fracaso como lo hace la mayoría de la gente, ¡el progreso científico y tecnológico se detendría! Los que están en los campos de investigación entienden que por cada experimento fallido, están más cerca de probar o refutar sus hipótesis. El fracaso siempre debe servir como un catalizador para que recalibremos la forma en que operamos y seamos más eficientes. Incluso las correcciones en la economía de mercado, durante los últimos años, son parte de un ciclo normal que permite que lo que realmente funciona salga a la luz y corrige algunos de los males sistémicos relacionados con nuestros hábitos comerciales culturales. ¿Qué significa todo esto? El fracaso es el proceso natural de aprender a tener éxito, solo si reflexionamos y aprendemos de los errores que conducen al fracaso.")]), _vm._v(" "), _c('p', {
    staticClass: "sbttl"
  }, [_vm._v("3. Examine sus prioridades.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Una de las mejores lecciones que he aprendido en la vida es percatarme de que saber qué "), _c('span', {
    staticClass: "ITAL CharOverride-4"
  }, [_vm._v("no")]), _vm._v(" hacer es tan importante como saber qué hacer. Muchas personas dotadas que conozco nunca logran nada sustancial porque están desorientadas y no se enfocan. Sus horarios siempre están llenos de numerosas actividades desde la mañana hasta la noche. Por ejemplo, recibo numerosas oportunidades e invitaciones para ministrar a nivel local, nacional e internacional. Si aprovecho todas las buenas oportunidades que se me presenten, incluso aquellas que parecen encajar con mi misión y propósito en la vida, perdería mi centro de gravedad y me volvería menos eficaz en mis relaciones clave con la familia y el ministerio.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("He aprendido que es un error equiparar la mera actividad con el significado. El fracaso ha ayudado a dar forma a mis prioridades fundamentales en la vida, las cuales se centran en la búsqueda de Dios, el estudio personal, las relaciones familiares y la tutoría de líderes clave y emergentes. Todo lo demás tiene que pasar a un segundo plano. Sea fiel a sus valores fundamentales y priorice todo lo que le rodea. No se permitas participar en cosas que no son guiadas por el Espíritu y que son contrarias a las más importantes de su vida. Por supuesto, esto no significa que solo hagamos las cosas que nos gustan; eso sería narcisista y egoísta.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Todos tenemos irrupciones inesperadas que perturban nuestras vidas e interfieren con nuestros horarios habituales. Cuando sucedan cosas inesperadas, simplemente sea fiel, cumpla con sus responsabilidades y vuelva a la normalidad lo antes posible. No deje que las emergencias le saquen de su ritmo divino y le lleven a patrones de malos hábitos. El apóstol Pablo lo dijo mejor: “Así que tengan cuidado de su manera de vivir. No vivan como necios, sino como sabios, aprovechando al máximo cada momento oportuno, porque los días son malos. Por tanto, no sean insensatos, sino entiendan cuál es la voluntad del Señor” (Efesios 5:15-17).")]), _vm._v(" "), _c('p', {
    staticClass: "sbttl"
  }, [_vm._v("4. Rodéese de personas espiritualmente maduras.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Como líder joven, esperaba que Dios me usara para traer un gran avivamiento a la ciudad de Nueva York. Pero varios años después de nuestro joven ministerio, fui al infierno y volví (en sentido figurado) y experimenté mucho sufrimiento debido a fallas en mis propias relaciones clave y mi ministerio. Después de varios años de intenso trauma, salí de esas pruebas con el claro entendimiento de cuánto necesitaba relacionarme con mis compañeros en el ministerio. Eso resultó en un intenso deseo de conectar líderes e iglesias clave de toda la ciudad, lo que dio origen a iniciativas como “Oración por toda la ciudad”, a partir de 1991, en las que más de mil personas y más de cincuenta iglesias y líderes se reunían para celebrar un día de ayuno y oración por nuestra comunidad. A esto le siguieron muchas otras iniciativas en toda la ciudad, demasiado numerosas para mencionarlas. (Lea mi libro "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Kingdom Awakening")]), _vm._v(" para obtener más información sobre esas iniciativas). Todo eso fue precipitado por mi experiencia con los fracasos en múltiples áreas.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("La lección más grande que aprendí durante ese tiempo (además de haber comprobado una vez más la fidelidad de Dios) fue rodearme de amigos piadosos y creyentes maduros con pasión por Dios, lo que puede contribuir a levantarme cuando me siento deprimido. En verdad, Dios dijo que no es bueno que el hombre esté solo (Génesis 2:18). La Escritura también dice: “Mejor son dos que uno, porque obtienen más fruto de su esfuerzo. Si caen, el uno levanta al otro. ¡Ay del que cae y no tiene quien lo levante! Si dos se acuestan juntos, entrarán en calor; uno solo ¿cómo va a calentarse? Uno solo puede ser vencido, pero dos pueden resistir. ¡La cuerda de tres hilos no se rompe fácilmente!” (Eclesiastés 4:9-12).")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Muchos creyentes cometen el error de reunirse con personas solo porque asisten a la misma iglesia, pero Pablo, al escribirle a Timoteo en el contexto de la iglesia local, le dijo: “esmérate en seguir la justicia, la fe, el amor y la paz, junto con "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("los que invocan al Señor con un corazón limpio")]), _vm._v("” (2 Timoteo 2:22, énfasis añadido). No todas las personas en la iglesia son buenas para pasar el rato cuando está luchando con el fracaso. Algunos en realidad alentarán su fracaso porque los hace sentir bien con sus propias deficiencias. Tenga cuidado, sea selectivo, pero busque creyentes maduros con un buen historial que hayan demostrado ser fieles y exitosos a través de los desafíos difíciles de la vida. Ellos son los únicos que pueden ayudarle a llevarle a donde pertenece. Siempre puedo decir cuán exitosas serán las personas en el futuro por el tipo de individuos con los que se reúnen e incluyen en su círculo íntimo.")]), _vm._v(" "), _c('p', {
    staticClass: "sbttl"
  }, [_vm._v("5. Consiga mentores que lo ayuden a pasar al siguiente nivel.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Pídale a Dios que le proporcione un mentor que ya haya estado donde usted desea ir, que haya superado las tormentas de la vida y que tenga un historial comprobado. Toda persona necesita un mentor, alguien que lo asesore y al que le rinda cuentas en un área específica de su vida.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Escuchar los consejos de un buen mentor puede ahorrarle años de aprendizaje y evitar que pierda un tiempo precioso. ¿Por qué reinventar la rueda? Recuerde, sin Moisés nunca hubiéramos tenido un Josué; sin Elías no hubiéramos tenido a Eliseo; sin el apóstol Bernabé quizás nunca hubiéramos tenido un apóstol Pablo; sin el apóstol Pablo nunca hubiéramos tenido un apóstol Timoteo. (Consulte Números 27:18-23; "), _c('br'), _vm._v("1 Reyes 19:19-21; Hechos 9:26-27; y Hechos 16:1-3). Todos necesitan que alguien más los lleve a donde deben ir.")]), _vm._v(" "), _c('p', {
    staticClass: "sbttl"
  }, [_vm._v("6. Deje que sus fracasos forjen en usted un carácter piadoso.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Dios ha usado el fracaso para acercarme a él y ayudarme a confiar más en él en cuanto a mi bienestar, mi identidad y mi éxito. Cuando era más joven, solo podía alcanzar cierto punto de humildad por mi esfuerzo, basado en la lectura de la Biblia y la devoción privada. Dios tuvo que usar las pruebas de fuego de la experiencia que vienen a través del tiempo para trabajar un nivel más profundo de humildad en mi alma. Lo peor que podemos hacer cuando experimentamos un fracaso es culpar a otras personas por lo que pasó. Hacer eso detiene el proceso de crecimiento interno. Las únicas personas que crecen y salen mejor del otro lado del fracaso son las que se han humillado y asumido la responsabilidad de su parte en el revés. En tiempos difíciles podemos amargarnos o mejorar, huir de Dios o correr hacia él. ¡Recuerde, lo que le sucede nunca es tan importante como lo que sucede dentro de usted! Las circunstancias nunca le destruirán. Es cómo responde a ellas lo que determina su destino en la vida.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Las luchas con mis propios hijos y mi familia han generado en mí más compasión por los padres y los cónyuges cristianos que tienen sus propios desafíos familiares. Si yo mismo no hubiera enfrentado esos desafíos, es muy probable que hubiera juzgado a aquellos que han experimentado el fracaso familiar. Por lo tanto, mis propias luchas han producido en mí la compasión necesaria para empatizar con los demás. Además, he descubierto que tengo mucha más autoridad para hablar y ministrar a las personas en las áreas en las que he experimentado la mayoría de los desafíos. Mi corazón y mis emociones ahora pueden resonar con personas que están pasando por las mismas batallas que yo he experimentado. En relación con eso, he aprendido que el mayor punto de ataque demoníaco en mi contra me indica cuál es el principal llamado en mi vida. Nuestro primordial llamado siempre está escondido debajo de nuestro punto de resistencia primario y de nuestros desafíos. He descubierto que mi desorden puede producir compasión en mí y convertirse en el mensaje que puede ser de gran beneficio para otros con las mismas luchas (2 Corintios 1:3-7). Siempre hay un propósito para todo. Cada fracaso puede ser un maestro escolar que nos prepare para pasar al siguiente nivel de éxito e influencia.")]), _vm._v(" "), _c('p', {
    staticClass: "sbttl"
  }, [_vm._v("7. Sea más consciente de sí mismo y menos defensivo.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Uno de los beneficios que obtuve del fracaso es que me hizo más consciente de lo que soy y qué es lo que realmente me motiva. Empecé a descubrir, con mayor agudeza, cuándo me impulsan las ambiciones carnales y personales, y cuándo me dirige el Señor. Es muy importante, después o durante un fracaso, que nos tomemos el tiempo para reflexionar y permitir que el Señor nos revele las cosas que hicimos para contribuir al lío en el que estamos. Necesitamos darnos cuenta cuando estamos operando con presunción y adelantándonos al Señor. Cada vez que experimentamos un fracaso, debemos usarlo como una oportunidad para reflexionar y aprender cómo y por qué hicimos lo que hicimos para no repetir los mismos errores. Además, parte del proceso de volverse consciente de sí mismo es escuchar la reprensión y la corrección de otras personas que Dios envía a nuestras vidas. Lo peor que podemos hacer después del fracaso es aislarnos de los demás o ponernos a la defensiva cuando alguien intente hablarnos. “Oirá el sabio, y aumentará el saber” (Proverbios 1:5) y “El sabio de corazón acata los mandamientos” (Proverbios 10:8).")]), _vm._v(" "), _c('p', {
    staticClass: "sbttl"
  }, [_vm._v("8. Deje que su espiritualidad se base en la realidad.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("A veces el éxito puede conducir al fracaso. He descubierto que más personas han caído por el éxito que por el fracaso. Esto se debe a que, a menudo, cuando pasamos de un esfuerzo exitoso a otro, perdemos nuestro sentido de la realidad y comenzamos a dar las cosas por hechas (como hacer la debida diligencia antes de tomar decisiones importantes y asumir compromisos con los demás). El fracaso nos sacude y nos acerca más al nivel básico de cómo funciona realmente el mundo. También puede ser el impulso para adquirir más discernimiento para futuras decisiones.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Además, algunas personas son tan místicas en su enfoque del cristianismo que nunca toman en consideración las realidades, los desafíos y las complejidades de su entorno. No solo somos llamados a orar; también estamos llamados a pensar y a actuar. Somos llamados a tener encuentros poderosos con Dios para poder involucrarnos exitosamente en la tierra con su poder y su fuerza. Jesús no se quedó en la cima del Monte de la Transfiguración. Bajó al valle para encontrarse con los espíritus malignos que afligían a la humanidad (Mateo 17:1-18). Fue empoderado y fortalecido para poder lidiar con éxito con la traición de sus discípulos, su agonía en el Huerto de Getsemaní y soportar el dolor insoportable de la crucifixión.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("No intentó usar la oración ni la espiritualidad para escapar de las realidades terrenales. Al contrario, dependió de sus encuentros poderosos con el Padre para obtener la sabiduría y la fuerza necesarias a fin de cumplir su propósito en la tierra.")]), _vm._v(" "), _c('p', {
    staticClass: "sbttl"
  }, [_vm._v("9. Comparta las lecciones que aprende a través del fracaso.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Paso mucho tiempo asesorando a jóvenes. Algunos de los momentos más fructíferos que tengo en esas sesiones ocurren cuando cuento mis fracasos y las razones que me llevaron a ellos. Sin estas historias convincentes, no estaría equipado con la sabiduría que necesito para alentar y exhortar a esas personas más jóvenes y menos experimentadas. No desperdicie su fracaso simplemente consigo mismo. Utilice esas experiencias para capacitar a la próxima generación y bendiga a otros con las lecciones que ha aprendido. En verdad, he encontrado que el maestro siempre aprende más que el alumno. Cuando compartimos nuestras lecciones de vida con otros, eso nos ayuda a obtener más información.")]), _vm._v(" "), _c('p', {
    staticClass: "sbttl"
  }, [_vm._v("10. Aprenda a construir un mejor modelo para que otros lo sigan.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("En última instancia, nuestras vidas son nuestro legado. En consecuencia, cada fracaso debe convertirse en un elemento básico para que construyamos un mejor modelo de la manera en que vivimos. El fracaso puede obligarnos a hacer una pausa en este mundo agitado para que luchemos por el equilibrio y el ritmo adecuado. Eso puede permitirnos ver lo que realmente funciona en oposición a lo que es un concepto inviable.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Cuando las personas con poca experiencia tienen un éxito inmediato, me duele verlos convertirse en mentores o entrenadores antes de saber si su modelo es sostenible a largo plazo. Por ejemplo, hay algunos pastores que tienen un enorme crecimiento de la iglesia y escriben libros para aconsejar a una nueva generación de líderes, pero lideran iglesias que tienen menos de diez años. Es demasiado pronto para saber si su modelo puede resistir la prueba del tiempo en cuanto al agotamiento del ministerio, la rotación de líderes y el éxito multigeneracional en el desarrollo de familias saludables que mantendrán a sus hijos y perpetuarán la fe. No creo que podamos confiar en modelos y filosofías de vida o ministerio hasta que hayan experimentado las pruebas de fuego y salgan con éxito del otro lado.")]), _vm._v(" "), _c('p', {
    staticClass: "sbttl"
  }, [_vm._v("11. Motívese para que crezca en la fe.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("El pasaje bíblico de Zacarías 4:6 es más real para mí hoy que nunca. Verdaderamente he encontrado que cuando todo está dicho y hecho, no es por mi poder ni mi fuerza. Se necesita el Espíritu de Dios para cumplir su voluntad y su propósito en la tierra. El fracaso me ha enseñado las grandes limitaciones de depender de mis dones y habilidades naturales para cumplir el propósito de mi reino. Cuando choco con una pared y no tengo soluciones, ¡Dios me recuerda que se necesitará fe en su capacidad para intervenir y realizar un milagro a fin de cumplir su voluntad!")]), _vm._v(" "), _c('p', {
    staticClass: "sbttl"
  }, [_vm._v("12. Concédale la oportunidad a Dios, todos los días, para que le instruya.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Cuanto más vivo, más me doy cuenta de que nunca obtendré los resultados que quiero en la vida sin buscar a Dios fervientemente. Necesitamos darle espacio para que nos moldee y nos hable. Descubrí que cuando inicio algo significativo basado únicamente en mi propia planificación, mis dones naturales y mis habilidades, depende de mí mantener eso en marcha con mi propia fuerza. ¡Dios no está obligado a empoderar lo que él nunca quiso que existiera! Una de las mayores claves del éxito de Jesús fue el hecho de que él solo hizo lo que vio hacer a su padre (Juan 5:19).")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Cuanto más envejezco, más trato de no involucrarme en nada a menos que se ajuste a mi propósito y mi misión, y que esté acompañado por un fuerte testimonio —en mi espíritu— de la dirección de Dios. ¡Por supuesto que he llegado a esta conclusión después de pasar por la escuela de los golpes y estar a punto de sufrir agotamiento en varias ocasiones!")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("En conclusión, mi objetivo es alentarle a no darse por vencido y ayudarle a comprender que el fracaso es uno de los peldaños clave para el éxito. Ruego que reflexione sobre cada uno de los doce puntos presentados aquí para que pueda aplicar estas verdades eternas a su vida. Si lo hace, confío en que tendrá muchas más posibilidades de convertir sus fracasos en éxitos. Los doce puntos son guías esenciales tanto para el mentor como para el aprendiz, para el maestro y el alumno, con respecto a la actitud adecuada que debemos asumir cuando experimentemos el fracaso. ¡El fracaso no es el fin del mundo, puede convertirse en el comienzo de algo grandioso! He descubierto que cada crisis es realmente una oportunidad oculta para que Dios cambie nuestros paradigmas y nos dé soluciones a los desafíos que nunca hubiéramos recibido si todo hubiera ido bien. La crisis que surge del fracaso, muchas veces, nos impulsa a buscar a Dios para que él pueda iniciar cambios en las estrategias, métodos e incluso en nuestros planes vocacionales.")]), _vm._v(" "), _c('p', {
    staticClass: "p _idGenParaOverride-1"
  }, [_vm._v("Como mentores maduros dedicados a empodera a otras personas para que cumplan su llamado, debemos inculcar estos principios en aquellos que nos miran para que no se rindan cuando las cosas se pongan difíciles y experimenten el fracaso. Enséñeles que el fracaso puede ser, en realidad, lo que enseña las lecciones de vida que necesitan para el éxito a largo plazo.")]), _vm._v(" "), _c('p', {
    staticClass: "CHAP--",
    attrs: {
      "id": "_idParaDest-19"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor012"
    }
  }), _vm._v("Capítulo 9")]), _vm._v(" "), _c('p', {
    staticClass: "CHAP-TITLE",
    attrs: {
      "id": "_idParaDest-20"
    }
  }, [_vm._v("El poder de delegar")]), _vm._v(" "), _c('p', {
    staticClass: "pf"
  }, [_c('span', {
    staticClass: "SM-CAP",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("No mucho después ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("de que Jesús escogió a doce apóstoles de su grupo más grande de discípulos (Lucas 6:12-13), les dio potestad y autoridad sobre todos los demonios, además de poder para sanar enfermedades. Luego los envió a proclamar el reino de Dios y a sanar (Lucas 9:1-2). Claramente, Jesús entendió lo que significaba delegar responsabilidad (Lucas 9:1-2; 10:1). De hecho, su objetivo era causar un impacto duradero en cuanto a la proclamación del reino.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("En Lucas 9:2 la palabra "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("enviados")]), _vm._v(" proviene del griego "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("apostelló")]), _vm._v(", que significa “enviar o despachar”."), _c('sup', {
    staticClass: "sup _idGenCharOverride-2"
  }, [_vm._v("1")]), _vm._v(" Es una palabra compuesta: apo, “de, lejos de”,"), _c('sup', {
    staticClass: "sup _idGenCharOverride-2"
  }, [_vm._v("2")]), _vm._v(" y "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("stéll")]), _c('span', {
    staticClass: "ITAL CharOverride-5"
  }, [_vm._v("ō")]), _vm._v(", “preparar … despachar … enviar”."), _c('sup', {
    staticClass: "sup _idGenCharOverride-2"
  }, [_vm._v("3")]), _vm._v(" Esta misma palabra también se usa cuando Jesús envía a los setenta (Lucas 10:1). Por lo tanto, esto significa que la palabra "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("enviado")]), _vm._v(" no se limita a los doce apóstoles originales, sino que puede usarse para enviar a otros. La vemos usarse en otros lugares en el Nuevo Testamento (Hechos 13:2). De modo que, Jesús estaba llevando el movimiento a otro nivel en vez de permitir que dependiera únicamente de él. Delegó poder y autoridad a otros para que el movimiento pudiera multiplicarse.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Las Escrituras muestran a los apóstoles recibiendo tanto poder (griego "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("dunamis")]), _vm._v(") como autoridad (griego "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("exousia")]), _vm._v("). Estos son conceptos similares aunque diferentes:")]), _vm._v(" "), _c('ul', [_c('li', {
    staticClass: "BULLET-1"
  }, [_vm._v("Poder: "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("dunamis")]), _vm._v(" significa “poder, fuerza, fortaleza … potencia … habilidad”."), _c('sup', {
    staticClass: "sup _idGenCharOverride-2"
  }, [_vm._v("4")]), _vm._v(" Se refiere a la potencia bruta necesaria para realizar una tarea.")]), _vm._v(" "), _c('li', {
    staticClass: "BULLET-2"
  }, [_vm._v("Autoridad: "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("exousia")]), _vm._v(" se refiere a “autoridad, poder absoluto, autorización”,"), _c('sup', {
    staticClass: "sup _idGenCharOverride-2"
  }, [_vm._v("5")]), _vm._v(" “el poder ejercido por gobernantes u otros en una alta posición en virtud de su cargo”."), _c('sup', {
    staticClass: "sup _idGenCharOverride-2"
  }, [_vm._v("6")])])]), _vm._v(" "), _c('p', {
    staticClass: "paa"
  }, [_vm._v("Por ejemplo, un oficial de policía tiene la autoridad legal para detener un automóvil pero no el poder para pararlo. Un hombre con un arma puede tener el poder de matar a alguien pero no la autoridad legal para matar a alguien. Por lo tanto, "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("dunamis")]), _vm._v(" es el poder puro; "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("exousia")]), _vm._v(" es la autoridad para usar ese poder.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Por tanto, vemos la sorprendente verdad de que Jesús les dio a sus apóstoles tanto el poder puro como la autoridad legal para predicar, sanar y expulsar demonios. Jesús le otorga poder y autoridad similares a todos los creyentes, como vemos en otros pasajes, por ejemplo Marcos 16:15-18 y Santiago 5:14-15. También vemos cómo, después de que regresaron, dieron cuenta de todo lo que hicieron a Jesús como una forma de informar, comparar notas para ser corregidos y animados, si fuese necesario. (Ver Lucas 9:10).")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Como último Adán (1 Corintios 15:45), Jesús ahora se estaba multiplicando a sí mismo, tal como se le ordenó al primer Adán que hiciera (Génesis 1:28). Por supuesto, el primer Adán solo pudo multiplicarse biológicamente. Jesús, por el contrario, se estaba multiplicando a sí mismo en espíritu y en verdad. Dado el hecho de que a Jesús no le quedaba mucho tiempo en la tierra, estaba totalmente enfocado en aumentar su capacidad para difundir la enseñanza y promover el movimiento antes de ascender al cielo. En consecuencia, después de facultar a doce de los discípulos, vemos que nombró a otros setenta para proclamar el reino y sanar a los enfermos (Lucas 10:1-16).")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Estos discípulos también regresaron para darle un informe a Jesús y los encontramos emocionados porque hasta los demonios se les sometieron en el nombre del Señor (vv. 17-19). Su respuesta fue instruirlos para que no se emocionaran por echar fuera demonios, sino que lo hicieran porque sus nombres estaban escritos en los cielos (v. 20). Como maestro liberador de potencial y maestro en convertir hombres ordinarios en líderes extraordinarios, Jesús entendió que la mera enseñanza no era suficiente para desarrollar el potencial en los demás. Sabía que a menos que les diera trabajo que hacer, no continuarían creciendo. Por lo tanto, su fórmula era algo como esto:")]), _vm._v(" "), _c('ul', [_c('li', {
    staticClass: "BULLET-1"
  }, [_vm._v("Jesús elegiría a alguien para que estuviera con él, para que hiciera vida con él, no solo para que lo escuchara predicar en reuniones religiosas.")]), _vm._v(" "), _c('li', {
    staticClass: "BULLET-2"
  }, [_vm._v("Jesús les daría tiempo para vincularse con él y con otros en el equipo.")]), _vm._v(" "), _c('li', {
    staticClass: "BULLET-2"
  }, [_vm._v("Jesús sería un modelo de liderazgo y ministerio para ellos.")]), _vm._v(" "), _c('li', {
    staticClass: "BULLET-2"
  }, [_vm._v("Luego, Jesús los enviaría a hacer lo que él hizo una vez que sintiera que tenían suficiente entrenamiento.")]), _vm._v(" "), _c('li', {
    staticClass: "BULLET-2"
  }, [_vm._v("Luego, Jesús los llamaría a un lado para informar, comparar notas y corregirlos según fuera necesario.")])]), _vm._v(" "), _c('p', {
    staticClass: "paa"
  }, [_vm._v("Una vez que se estableció el equipo inicial, Jesús amplió el grupo y repitió el mismo proceso para que el movimiento tuviera una base más grande de líderes a fin de perpetuar el reino de Dios. Jesús entendió y demostró tres principios importantes. Primero, el movimiento nunca debe depender del liderazgo y las habilidades de una sola persona. Segundo, aquellos a los que estaba discipulando nunca crecerían con simples enseñanzas y reuniones. Se les tenía que dar la responsabilidad de poner en práctica lo impartido. Tercero, el movimiento solo podía crecer y mantenerse en función de lo grande que fuera la base de liderazgo que lo sustentaba.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("De la misma manera, Jesús desarrolló a las personas y desató su potencial a través del principio de delegación y mayordomía. Debemos hacer lo mismo si queremos iguales resultados. Descubrí que las personas solo pueden crecer a través de la enseñanza en los primeros seis meses a un año después de llegar a Cristo. Después de eso, a menos que sean voluntarios o sirvan en la iglesia, no seguirán creciendo. Jesús les dijo a sus discípulos que su comida era hacer la voluntad de Aquel que lo envió (Juan 4:32-34). En otras palabras, nos alimentamos al “hacer” la Palabra de Dios, no solo al escucharla.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Por lo tanto, es esencial que nosotros —que queremos hacer que otros maduren en Cristo— aprendamos a delegar responsabilidades a los que estamos asesorando. Esto genera confianza, brinda la oportunidad de ver las fortalezas y debilidades de la persona a la que está asesorando y le brinda la capacidad de criticar y perfeccionar las habilidades de su aprendiz.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Este es el mismo método que seguí con Kristian. Después de que fue creyente durante casi un año, comencé a confiarle ciertas responsabilidades en la iglesia, lo que lo llevó a convertirse en el líder de jóvenes unos cinco años después. Eso me dio una gran oportunidad para hablarle, así como para desarrollar sus dones y habilidades como comunicador bíblico y líder emergente. En conjunto, todas estas cosas finalmente llevaron a Kristian a convertirse en el pastor principal de su propia congregación.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll-1"
  }, [_vm._v("Tres etapas de la asesoría")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Descubrí que una de las cosas más importantes acerca de la delegación es caminar a través de tres etapas con aquellos a quienes estoy asesorando, para permitir tanto el crecimiento del individuo como la responsabilidad adecuada en el proceso. La primera etapa consiste en dar a la persona que está asesorando alguna responsabilidad como parte de su tarea. Eso brinda pautas que incluyen metas, plazos y objetivos para que la persona conozca la misión general de la tarea y los resultados que está buscando. La segunda etapa viene una vez que se completa la tarea. Es entonces cuando tiene un tiempo para reunirse con su aprendiz para evaluar qué se hizo, cómo se hizo y si se cumplieron las metas, los objetivos y los plazos. La tercera etapa es el momento de alentar, corregir y afinar antes de que la persona esté lista para la siguiente tarea, a menos que no haya logrado realizarla correctamente, en cuyo caso se le debe dar otra oportunidad para intentar otra tarea.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Si se descuida cualquiera de estas tres etapas, entonces no se está discipulando adecuadamente a las personas nuevas, lo que a su vez les roba la oportunidad de crecer en verdad y liberar su potencial. En consecuencia, delegar no significa simplemente asignar tareas sin ningún seguimiento o rendición de cuentas, sobre todo en el caso de que a alguien se le asigne una tarea nueva o desconocida. Alguien tiene que supervisar de cerca al aprendiz en las etapas iniciales y luego informar a esa persona una vez que se completa la tarea. Cuanto más familiarizada y experimentada se vuelva la persona con la tarea, menos supervisión necesitará y más libertad se le debe dar. A fin de cuentas, deberíamos llegar a un punto en el que solo le demos pautas a la persona, junto con plazos y objetivos, ¡y luego la dejemos en paz! Si bien la misión general sigue siendo la misma, las formas en que la persona cumple la misión y los métodos que usa pueden diferir de los del maestro, según los dones, las habilidades y la personalidad.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Permitir que las personas tengan libertad en el marco de las pautas es quizás la mejor manera de desarrollar sus habilidades y liberarlos para que sean personas extraordinarias. La microgestión, decirle a alguien cómo hacer las cosas y respirarle encima del hombro después de que haya sido entrenado y probado, solo lo frustrará y hará que renuncie. Los líderes que no saben cómo capacitar, delegar y liberar a otros limitarán el crecimiento de su organización, así como la capacidad de crecimiento de las personas que están tratando de madurar como seguidores de Cristo.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Doy gracias a Dios que mi pastor original, Ben Crandell, no temió permitirme crecer en el ministerio cuando era joven. Había sido creyente durante solo seis meses cuando organicé mi primer gran evento evangelístico en un parque público de la ciudad de Nueva York. En cierto momento, me pusieron a cargo de transportar a muchas personas a nuestra iglesia, además de ser el líder de sección de unos doce líderes de grupos celulares que se reunían conmigo una vez al mes para orar e instruirlos. En este punto, ¡había sido creyente por solo unos tres años!")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Mi pastor no tuvo miedo de arriesgarse conmigo a pesar de que solo tenía veintidós años cuando comenzó a darme mucha responsabilidad. Sin embargo, fue a través de esos años formativos organizando reuniones, rutas de autobuses y ayudando a los líderes de grupos celulares que pude perfeccionar mis habilidades como organizador, líder y maestro, lo que me permitió convertirme en pastor líder a los veinticinco años de edad. Si mi pastor hubiera sido inseguro e incapaz de delegar la responsabilidad a un joven líder emergente no probado como yo, nunca habría crecido como líder ni estaría equipado para lo que estoy haciendo actualmente. Mi experiencia personal ilustra la importancia de delegar como parte del proceso de equipamiento para liberar el potencial de los demás. Sin el proceso de delegación incorporado a nuestros métodos de discipulado, no existe una matriz para demostrar el crecimiento y la capacidad de una persona. Cuando digo crecimiento me refiero no solo a la habilidad sino también al carácter que se pondrá a prueba en medio de las tareas asignadas.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Para usar un ejemplo cotidiano a fin de ilustrar aun más las tres etapas necesarias para el desarrollo, ¿puede imaginar lo insensato de otorgar una licencia a una persona para practicar medicina o realizar cirugías solo porque obtuvo altas calificaciones académicas en la escuela? Imagínese si una persona pudiera convertirse en cirujano sin antes trabajar con otro médico como interno. ¿Qué pasaría si le diéramos a la gente una licencia para conducir un automóvil solo porque pudieron pasar la prueba del permiso escrito? Por desdicha, la iglesia tiene un historial en cuanto a ordenar personas al ministerio eclesiástico de tiempo completo o incluso como pastores principales simplemente porque fueron a un seminario y recibieron una maestría en divinidad. Qué insensato y antibíblico es eso.")]), _vm._v(" "), _c('p', {
    staticClass: "p _idGenParaOverride-1"
  }, [_vm._v("Al concluir este capítulo, creo sinceramente que todo nuestro entrenamiento y trabajo aquí en la tierra nos está preparando —en última instancia— para el día en que discipulemos a naciones enteras como Jesús ordenó en Mateo 28:19. La palabra "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("naciones")]), _vm._v(" aquí tiene que ver con grupos de personas, no simplemente con una persona de una etnia individual. Pablo alude a esto en su Primera Carta a los Corintios cuando reprende a la iglesia diciendo que un día los santos juzgarán a los ángeles (1 Corintios 6:3), así que ¿cuánto más podremos administrar los asuntos de esta vida? Por lo tanto, Dios no solo está preparando a los creyentes individuales, sino también iglesias enteras para administrar las cosas de este mundo, ¡para que un día se nos confíe la construcción de comunidades y el pastoreo de naciones! Después de todo, somos coherederos con Cristo (Romanos 8:17), que ha sido comisionado por el Padre para heredar las naciones y los confines de la tierra como su posesión (Salmos 2). En consecuencia, todo lo que deleguemos a otra persona y todo lo que el Señor nos delegue es un campo de entrenamiento para una mayor responsabilidad que finalmente nos preparará para gobernar y reinar con el Señor Jesús (Apocalipsis. 2:26-27).")]), _vm._v(" "), _c('p', {
    staticClass: "CHAP--",
    attrs: {
      "id": "_idParaDest-21"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor013"
    }
  }), _vm._v("Capítulo 10")]), _vm._v(" "), _c('p', {
    staticClass: "CHAP-TITLE",
    attrs: {
      "id": "_idParaDest-22"
    }
  }, [_vm._v("El poder de priorizar")]), _vm._v(" "), _c('p', {
    staticClass: "pf"
  }, [_c('span', {
    staticClass: "SM-CAP",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Hasta un examen ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("superficial de los evangelios muestra que Jesús favoreció a ciertos individuos más que a otros. Es decir, intencionalmente invirtió más de su tiempo con determinadas personas. Aunque ministró a las multitudes, extrajo de ellas sus discípulos, aquellos que se comprometieron a seguirlo (Lucas 14:25-26). De esos discípulos, Jesús escogió a doce (Lucas 6:13), cuya tarea principal era pasar tiempo con él (Marcos 3:14) antes de ser enviados a predicar y sanar a los enfermos. Por lo tanto, el plan principal de Jesús en la tierra no fue ministrar a las multitudes sino invertir su tiempo en capacitar a los doce. También vemos, al examinar las narraciones del evangelio, que de los doce Jesús tenía un círculo íntimo de tres: Santiago, Juan y Pedro, que pasaban la mayor parte del tiempo con él (Mateo 26:36-38). De esos tres, parecía que Juan, el hijo de Zebedeo, era el amigo más íntimo de Jesús (Juan 21:20).")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Jesús siguió algo que se hizo famoso en la filosofía de gestión empresarial y se conoce como el Principio de Pareto:")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("El principio de Pareto (también conocido como la regla 80/20 o el principio de los pocos vitales y muchos triviales) establece que, en muchos casos, aproximadamente el 80 % de los efectos provienen del 20 % de las causas. El consultor de gestión Joseph M. Juran sugirió el principio y le dio nombre en honor al economista italiano Vilfredo Pareto, que notó la conexión 80/20 mientras estaba en la Universidad de Lausana en 1896, como se publicó en su primer artículo, "), _c('span', {
    staticClass: "ITAL CharOverride-4"
  }, [_vm._v("Cours d’économie politique")]), _vm._v(". En esencia, Pareto mostró que aproximadamente el 80 % de la tierra en Italia era propiedad del 20% de la población.")]), _vm._v(" "), _c('p', {
    staticClass: "paa"
  }, [_vm._v("Es un axioma de la gestión empresarial que “el 80 % de las ventas provienen del 20 % de los clientes”. Richard Koch es autor del libro "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("El principio 80/20")]), _vm._v(", que ilustra una serie de aplicaciones prácticas del principio de Pareto en la gestión empresarial y en la vida. Siguiendo el trabajo fundamental de Koch, muchos ejecutivos de negocios han citado la regla 80/20 como una herramienta para maximizar la eficiencia empresarial."), _c('sup', {
    staticClass: "sup _idGenCharOverride-2"
  }, [_vm._v("1")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("En la lengua vernácula, esto significa que alrededor del 80 % de la producción de cualquier organización provendrá de solo alrededor del 20 % de las personas. He descubierto que esto es cierto no solo en los negocios sino también en el ambiente de la iglesia. Como pastor, he observado que solo alrededor del 20 % de las personas de la congregación dan la mayor parte de los diezmos y las ofrendas y hacen la mayor parte del voluntariado en la iglesia. Esta es simplemente la naturaleza humana. El 80 % de la gente está aquí simplemente por pasear, y solo un remanente de alrededor del 20 % cree verdaderamente el mensaje del evangelio y lo pone en práctica con todo su corazón.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("El apóstol Pablo también mostró que siguió este principio cuando instruyó a su protegido, Timoteo, para que escogiera de la multitud a hombres fieles que tuvieran la capacidad de enseñarles y confiarles la Palabra (2 Timoteo 2:2). Cuando los pastores o las empresas simplemente se enfocan en las multitudes en vez de centrar su atención en aquellos que tienen más probabilidades de generar el mayor retorno de su inversión de tiempo, están siendo mayordomos imprudentes y no entienden cómo priorizar de la manera en que lo hicieron Jesús y Pablo.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Como ya mencioné en otro capítulo, Jesús eligió personas con potencial (todas tenían sus propios negocios o ya estaban ocupadas en el liderazgo) y no perdió el tiempo con personas que eran flojas o que querían discutir con él. No pasó la mayor parte de su tiempo con los líderes religiosos que se le oponían, sino con aquellos que tenían hambre y sed de él, y que también tenían el mayor potencial de liderazgo.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("En consecuencia, esto puede ser un "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("shock")]), _vm._v(" para aquellos en el cuerpo de Cristo que ven la Biblia con una óptica democrática en vez de una lente teocrática, ¡pero a Dios no le gusta el igualitarismo! Dios no trata a todas las personas igual. Unos tienen un llamado mayor que otros, y aun otros tendrán más encuentros divinos con Dios que otras personas. Además, no toda persona está llamada a ser un ministro quíntuple (Efesios 4:11). Solo algunos son llamados a funcionar como líderes del ministerio quíntuple en la iglesia. Además, no todos los ministros quíntuples tienen la misma medida de este don de Cristo. (Ver Efesios 4:7, 11.)")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("El contexto de 2 Timoteo 2:2 es que Pablo, como líder extra local —un líder apostólico— estaba invirtiendo su tiempo en Timoteo como otro líder extra local (apostólico) que a su vez fue alentado por Pablo a identificar e invertir su tiempo con otros posibles líderes extra locales (apostólicos) que a su vez podrían ayudar a dirigir otras congregaciones florecientes y plantar otras nuevas. Note que en este pasaje Pablo le dijo a Timoteo que diferenciara entre aquellos que escucharon el mensaje en medio de muchos testigos y los que fueron fieles y capaces de enseñar a otros.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Por lo tanto, le dijo a Timoteo que dividiera la multitud en segmentos más pequeños de creyentes individuales que tuvieran un potencial de alta capacidad para que Timoteo pudiera esforzarse por invertir en esos individuos y luego autorizarlos para el ministerio. Al enfocarse en unos pocos, en vez de la multitud, Timoteo no estaba siendo cruel sino sabio, porque —como ya se mencionó—, solo alrededor del 20 % de la gente hará alrededor del 80 % del ministerio. Es decir, al enfocarse en los fieles, en los pocos capaces más que en los muchos, habría una mayor posibilidad de que el movimiento tuviera un futuro sostenible porque habría más personas capaces de ministrar y perpetuar el mensaje del evangelio.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Cuando inicié Resurrection Church en 1984, mi lema y método clave para edificar la iglesia se basó en el modelo de Pablo y Timoteo de 2 Timoteo 2:2. Empecé seleccionando a unos ocho hombres con los que me reunía una vez por semana durante unas horas. Los llamé mi “grupo Timoteo”. Posteriormente, a medida que la iglesia crecía, me reunía con unos treinta hombres durante tres horas a la semana y lo llamé Hombres en Entrenamiento (MIT, por sus siglas en inglés). Al fin, aproximadamente un año después, me reunía con ellos cada dos semanas y comencé otro grupo de treinta hombres llamado Junior MIT. Durante muchos años me reuní con esos hombres. Revisamos libros juntos, oramos juntos y creamos estrategias juntos. ¡Se convirtieron en mis mejores líderes! Algunos de ellos (como Kristian) se convirtieron en mis ancianos, líderes y pastores, y enviamos a muchos de ellos para que iniciaran iglesias o su propia misión evangelística. Verdaderamente, el MIT se convirtió en la piedra angular de la congregación Resurrection Church y la razón principal por la que desde 1984 la iglesia sigue creciendo, expandiéndose a otros recintos y nutriendo y enviando líderes de alto nivel para hacer avanzar el reino de Dios.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Antes de concluir este capítulo, quiero que examinemos más de cerca la manera en que Jesús escogió a sus amigos, aquellos en los que invirtió la mayor parte de su tiempo. Con el evangelio confuso que se predica hoy, y con la visión actual de Jesús actuando como un hippie de los años 1960, que andaba diciendo “Paz y amor” a todos los que se cruzaban en su camino, los siguientes puntos a considerar serán impactantes para la mayoría en la iglesia que piensa que Jesús actuó como un gurú espiritual brindando igualdad de oportunidades y que se hizo amigo e invirtió su tiempo de la misma manera con todos.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll-1"
  }, [_vm._v("Cómo escogió Jesús a sus amigos")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Cuando la mayoría de la gente piensa en cómo elegir a sus amigos, usan un concepto más mundano e informal que bíblico. En Juan 15:15, Jesús les dijo a sus discípulos que los consideraba amigos y no siervos. Dado que el reino de Dios se basa en la relación y no en el ministerio, es importante que sepamos elegir sabiamente a nuestros amigos. Muchas iglesias, e incluso cristianos, intentan engendrar amistades simplemente para tener un buen compañerismo. Sin embargo, la verdadera comunión del reino debe tener el objetivo final de acercarse a alguien para promover los propósitos del reino. La mayoría de las personas son demasiado rápidas para llamar a alguien amigo o elegirlo como tal solo porque tienen algunas cosas en común. Elegir amigos debería ser mucho más importante que escoger a alguien como amigo con el que solo trabaja o disfruta viendo un partido de futbol. Simplemente gustar de alguien no debería ser el único criterio para la amistad.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Hay muchas personas con las que me gustaría estar constantemente, pero cuando se trata del reino, el asunto es más que eso. Tengo que preguntarme si estoy llamado a construir con alguien antes de hacer un compromiso a largo plazo. La razón es obvia: el destino de un individuo a menudo lo determinan las personas más cercanas a él en cuanto a la calidad del tiempo invertido, las metas mutuas y el propósito común. Usted es tal como la persona con quien elige pasar más tiempo. Los siguientes son algunos de los criterios que usó Jesús para elegir a sus amigos.")]), _vm._v(" "), _c('p', {
    staticClass: "sbttl"
  }, [_vm._v("Jesús oraba antes de elegir a sus amigos.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("En Lucas 6:12-13, Jesús oró toda la noche antes de elegir a las doce personas que serían más cercanas a él. Esto muestra que esa elección suya no fue fortuita; la nuestra tampoco debería serlo.")]), _vm._v(" "), _c('p', {
    staticClass: "sbttl"
  }, [_vm._v("Los amigos de Jesús llevaban vidas de obediencia a Dios.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("En Juan 15:14 Jesús dijo: “Ustedes son mis amigos si hacen lo que yo les mando”. Sería una tontería que los creyentes hicieran de sus amigos más cercanos y confidentes personas que viven sin propósito delante del Señor. Eso no quiere decir que no podamos tener amigos que no sigan a Cristo. Jesús, a veces, pasaba tiempo con los pecadores (Lucas 7:34). Sin embargo, no se juntaba con ellos simplemente para pasar un buen rato, sino para ganárselos para su Padre de modo que al fin pudieran tener una vida de obediencia.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Además, esos pecadores no eran con quienes él invertía más tiempo, a menos que se convirtieran en sus discípulos. Pablo animó a Timoteo a “seguir la justicia, la fe, el amor y la paz, junto con los que invocan al Señor con un corazón limpio” (2 Timoteo 2:22). En consecuencia, no debemos ser amigos cercanos de alguien a menos que se tome en serio las cosas de Dios.")]), _vm._v(" "), _c('p', {
    staticClass: "sbttl"
  }, [_vm._v("Jesús escogió a sus amigos para que estuvieran con él, para luego enviarlos.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Marcos 3:14 enseña que la principal expectativa que Jesús tenía al principio con aquellos a quienes eligió como amigos era pasar tiempo juntos. Tuvieron que aprender a “hacer vida” juntos, no solo realizar estudios bíblicos y asistir a la sinagoga. Sin embargo, el resultado final de su proximidad con él fue que serían enviados a predicar. Después de todo, ¿cómo podrían proclamar a un Jesús que no conocían y cómo podrían conocerlo a menos que pasaran tiempo valioso con él? Nadie debe apresurarse a llamar amigo a alguien antes de haber pasado bastante tiempo de calidad con esa persona y conocerla a fondo.")]), _vm._v(" "), _c('p', {
    staticClass: "sbttl"
  }, [_vm._v("Jesús escogía amigos con los que podía compartir su corazón.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Juan 15:15 nos enseña que Jesús compartió su corazón con los amigos que lo entendieron. En Mateo 13:11, Jesús les dijo a sus amigos: “A ustedes se les ha concedido conocer los misterios del reino de los cielos; pero a ellos [no amigos] no”. Si alguien no puede entender su corazón o creer en su visión, será difícil que esa persona sea un verdadero amigo del reino.")]), _vm._v(" "), _c('p', {
    staticClass: "sbttl"
  }, [_vm._v("Jesús escogió proactivamente a sus amigos.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("En el contexto de cómo eligió a los amigos, Juan 15:16 nos enseña que las personas no lo eligieron a él, sino lo contrario. Aunque este pasaje también se refiere a la salvación, muestra que su metodología para elegir amigos fue proactiva (no reactiva) y basada en su llamado a construir con él. En consecuencia, debemos determinar en nuestro corazón a quién deberíamos buscar como amigos. No elija simplemente a aquellos que desean estar cerca de usted; escoja proactivamente a las personas en base a la dirección del Señor. No todos los que querían estar cerca de Jesús tenían ese acceso. De las multitudes, tenía un círculo interno de solo tres, luego doce y luego setenta. Los demás solo tuvieron acceso a él durante breves momentos de sus vidas. Si va a ser fructífero en el reino, no puede pasar mucho tiempo con cada persona que conozca. Por ejemplo, no me siento culpable por no responder cada mensaje de Facebook o correo electrónico que me envían. Si lo hiciera, sufriría agotamiento, dejaría trabajo importante sin hacer o perdería mi enfoque principal y perdería mi vocación.")]), _vm._v(" "), _c('p', {
    staticClass: "sbttl"
  }, [_vm._v("Los amigos de Jesús recibieron sus duros dichos.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("En Juan 6:66-68, ¡muchos de sus discípulos lo dejaron porque no podían recibir el alimento de la Palabra! Sus verdaderos amigos fueron así separados de aquellos que eran meramente conocidos temporales. Los verdaderos amigos de usted estarán a su lado aun cuando Dios le diga algo duro o lo llame a hacer algo que muchas otras personas no entienden.")]), _vm._v(" "), _c('p', {
    staticClass: "sbttl"
  }, [_vm._v("Los amigos de Jesús fueron aquellos que estuvieron a su lado durante sus pruebas.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Lucas 22:28-29 muestra que sus amigos más cercanos fueron los que aguantaron con él durante sus pruebas terrenales. Dios, a menudo, le permitirá pasar por una prueba personal o ministerial severa para probar a los que lo rodean y demostrar quiénes son sus verdaderos amigos. Solo puede construir con aquellos que le son fieles en los momentos difíciles y no solo cuando las cosas van bien.")]), _vm._v(" "), _c('p', {
    staticClass: "p _idGenParaOverride-1"
  }, [_vm._v("En conclusión, Jesús integró su necesidad social de tener amigos con su llamado al reino. Él nunca separó las dos cosas, nosotros tampoco deberíamos hacerlo. Por lo tanto, debemos elegir proactivamente a nuestros amigos más cercanos para que sean aquellos con los que Dios nos insta a construir su reino. Eso no significa que actuemos como algunas sectas que prohíben a sus seguidores socializar con los llamados no creyentes y amar y servir a su familia inmediata. Además, nosotros, que estamos llamados a ayudar a liberar el potencial de otras personas, debemos priorizar a nuestros aprendices para que la mayor parte de nuestro tiempo invertido sea con aquellos que producirán la mayor cantidad de frutos para la gloria de Dios.")]), _vm._v(" "), _c('p', {
    staticClass: "CHAP--",
    attrs: {
      "id": "_idParaDest-23"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor014"
    }
  }), _vm._v("Capítulo 11")]), _vm._v(" "), _c('p', {
    staticClass: "CHAP-TITLE",
    attrs: {
      "id": "_idParaDest-24"
    }
  }, [_vm._v("El poder de la comunidad")]), _vm._v(" "), _c('p', {
    staticClass: "pf"
  }, [_c('span', {
    staticClass: "SM-CAP",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Una de las ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("cosas más importantes que he descubierto en mi estudio de las Escrituras es el hecho de que fueron escritas con una mentalidad hebraica. Antes de eso, descubrí que la mayor parte del tiempo estaba imponiendo mi perspectiva individualista y cultural estadounidense sobre los pasajes bíblicos, lo que negaba la forma correcta de interpretar las Escrituras. Como resultado, individualizaría muchas de las promesas de las Escrituras y no entendía cómo Jesús, siendo judío, nunca hubiera concebido intentar liberar el potencial de un seguidor aparte de la comunidad de fe que estaba construyendo.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Mi imposición cultural de la sapiencia estadounidense en cuanto a la Biblia no es nada nuevo. Ha estado ocurriendo al menos desde que la iglesia se alejó de la influencia de Jerusalén hacia la helenística mentalidad grecorromana a partir del segundo siglo,"), _c('sup', {
    staticClass: "sup _idGenCharOverride-2"
  }, [_vm._v("1")]), _vm._v(" cuando gran parte de la cristiandad abrazó una interpretación individualista de la vida y la fe. Numerosas organizaciones paraeclesiásticas cometen el mismo error al intentar hacer discípulos sin que la iglesia local esté al frente y al centro de su misión y su metodología. Razonan que dado que Jesús formó doce discípulos que se convirtieron en apóstoles, antes de la iglesia, pueden imitarlo y hacer discípulos “uno a uno” sin la participación de la iglesia local.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Lo que estas organizaciones no notan es que Jesús siempre pensó en la iglesia cuando invirtió tiempo en sus discípulos. Por ejemplo, en su discurso final les dijo que no los dejaría huérfanos sino que enviaría al Espíritu Santo, que continuaría su ministerio a través de ellos. De la misma manera que Jesús ministró por el poder del Espíritu Santo, ellos también lo harían por el Espíritu (Juan 14:16-18). Incluso les dijo: “Cuando venga el Consolador que yo les enviaré de parte del Padre, el Espíritu de verdad que procede del Padre, él testificará acerca de mí. Y también ustedes darán testimonio porque han estado conmigo desde el principio” (Juan 15:26-27). Dijo además a sus discípulos:")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("Pero cuando venga el Espíritu de la verdad, él los guiará a toda la verdad, porque no hablará por su propia cuenta, sino que dirá solo lo que oiga y les anunciará las cosas por venir. Él me glorificará porque tomará de lo mío y se lo dará a conocer a ustedes. Todo cuanto tiene el Padre es mío. Por eso les dije que el Espíritu tomará de lo mío y se lo dará a conocer a ustedes.")]), _vm._v(" "), _c('p', {
    staticClass: "RIGHT-FLUSH",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("—Juan 16:13-15")]), _vm._v(" "), _c('p', {
    staticClass: "paa"
  }, [_vm._v("Además, vemos al comienzo de la narración de Hechos que el historiador Lucas conectó a la iglesia con el ministerio de Jesús cuando inició su declaración afirmando que su evangelio (el Evangelio de Lucas) trata sobre “todo lo que Jesús comenzó a hacer y enseñar”. (Ver Hechos 1:1). Al decir que registró “todo lo que Jesús comenzó a hacer y enseñar”, ¡estaba enmarcando la narración de Hechos como una continuación del ministerio de Jesús a través de la iglesia! Es decir, tener un modelo de discipulado sin pensar en la iglesia es un gran error. Mi propia experiencia como pastor me ha demostrado que además de la predicación de la Palabra y la adoración, la forma principal en que una persona aprende a caminar en su propósito divino es sirviendo en una congregación local. He aprendido que el proceso de hacerse uno con otros hermanos y hermanas en la iglesia es la clave para aprender a amar, perdonar, ser paciente, empoderar a los débiles, usar los dones espirituales; recibir fuerza, esperanza y aliento; y aprender las principales formas que Dios diseñó para usarlo a usted. Por ejemplo, una persona puede decir todo lo que quiera acerca de su llamado al pastorado exclusivo de una iglesia. Sin embargo, si el resto de la congregación no escucha ni siente la voz del pastor en él, entonces eso es una señal de que no está llamado a ejercer esa función.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Cuando las personas me preguntan por qué necesitan participar en una iglesia local para ser seguidores de Jesús, uso ejemplos mundanos para expresar mi punto. Les pregunto: “¿Puede usted aprender a jugar béisbol, futbol americano, baloncesto, tenis, balompié y hockey sin unirse a un equipo?”. ¡Por supuesto, la respuesta es no!")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("El apóstol Pablo presenta un caso aún más relevante a favor de la participación corporativa cuando compara la iglesia con un cuerpo biológico. Él dice:")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("Ahora bien, el cuerpo no consta de un solo miembro, sino de muchos. Si el pie dijera: “Como no soy mano, no soy del cuerpo”, no por eso dejaría de ser parte del cuerpo. Y si la oreja dijera: “Como no soy ojo, no soy del cuerpo”, no por eso dejaría de ser parte del cuerpo. Si todo el cuerpo fuera ojo, ¿qué sería del oído? Si todo el cuerpo fuera oído, ¿qué sería del olfato? En realidad, Dios colocó cada miembro del cuerpo como mejor le pareció. Si todos ellos fueran un solo miembro, ¿qué sería del cuerpo? Lo cierto es que hay muchos miembros, pero el cuerpo es uno solo. El ojo no puede decirle a la mano: “No te necesito”. Ni puede la cabeza decirles a los pies: “No los necesito”.")]), _vm._v(" "), _c('p', {
    staticClass: "RIGHT-FLUSH",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("—1 Corintios 12:14-21")]), _vm._v(" "), _c('p', {
    staticClass: "paa"
  }, [_vm._v("De modo que, cuando las personas me preguntan si necesitan una iglesia local para seguir a Jesús, les digo: “Puedes ir al cielo sin participar en una iglesia, pero no puedes funcionar correctamente sin la iglesia de la misma manera que si me corto un dedo, que ya no puede funcionar por sí solo; debe estar conectado a la mano que, a su vez, está conectada a la muñeca y al brazo”. En otras palabras, uno necesita del otro para operar adecuadamente.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll-1"
  }, [_vm._v("El Dios Triuno es nuestro modelo para la comunidad")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Jesús presentó el caso más poderoso para participar en el cuerpo de Cristo cuando nos enseñó en su oración sacerdotal (Juan 17) que los creyentes son llamados a ser uno con el otro de la misma manera que el Padre y el Hijo lo son. Es decir, los creyentes están llamados a funcionar juntos —en unidad— de la misma manera que el Padre, el Hijo y el Espíritu Santo trabajan unidos. La comunión que tiene el Dios trino no es solamente compañerismo. Es una unidad con propósito que resultó en la creación del universo y en la cual se desarrolló el magnánimo plan de redención en Cristo.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Enfoquémonos juntos en un aspecto de esta oración como se registra en el Evangelio de Juan. Jesús oró:")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("No ruego solo por estos. Ruego también por los que han de creer en mí por el mensaje de ellos, para que todos sean uno. Padre, así como tú estás en mí y yo en ti, permite que ellos también estén en nosotros, para que el mundo crea que tú me has enviado. Yo les he dado la gloria que me diste, para que sean uno, así como nosotros somos uno: yo en ellos y tú en mí. Permite que alcancen la perfección en la unidad, y así el mundo reconozca que tú me enviaste y que los has amado a ellos tal como me has amado a mí. Padre, quiero que los que me has dado estén conmigo donde yo estoy. Que vean mi gloria, la gloria que me has dado porque me amaste desde antes de la creación del mundo.")]), _vm._v(" "), _c('p', {
    staticClass: "RIGHT-FLUSH",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("—Juan 17:20-24")]), _vm._v(" "), _c('p', {
    staticClass: "paa"
  }, [_vm._v("Esta poderosa oración de Jesús muestra que el tipo de unidad que Dios espera de su iglesia está modelada por la que existe entre el Padre y el Hijo. Esto debería obligar a cada seguidor de Cristo a tener una fuerte unidad funcional con los hermanos de la iglesia. Jesús incluso dijo que la efectividad de la evangelización mundial depende de la calidad de la unidad funcional en la que camina la iglesia."), _c('sup', {
    staticClass: "sup _idGenCharOverride-2"
  }, [_vm._v("2")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Entonces Jesús oró para que la iglesia tuviera la misma gloria que el Padre le dio al Hijo, de manera que ¡seamos uno con los demás y con el Padre! Esto es bastante sorprendente ya que cuando pensamos en la gloria de Dios, por lo general, lo limitamos a la nube que cae en una reunión repleta de personas que se salvan y sanan. Sin embargo, en este contexto, Jesús está diciendo que otro aspecto de la gloria de Dios es cuando él une los corazones y las mentes como uno solo en su persona. Verdaderamente, la unidad es tan difícil para la humanidad que cuando los individuos pueden unirse en un solo corazón y mente en Cristo, ¡es un acto de Dios!")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Por último, Jesús afirma que seremos perfeccionados en la unidad para que el mundo sepa que él fue enviado por el Padre. Esta poderosa frase, "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("perfección en la unidad")]), _vm._v(", muestra que es imposible que una persona madure en Cristo sin caminar en unidad con los demás miembros de la iglesia. La palabra "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("perfección ")]), _vm._v("aquí no se refiere a la perfección sin pecado sino a la madurez; por lo tanto, lo que Jesús está diciendo aquí es que el proceso de tener unidad con otros miembros del cuerpo de Cristo —que a menudo implica perdonar y ser bondadoso, servirse unos a otros, empoderarse de manera mutua, soportando las faltas y debilidades de los demás, y así sucesivamente— es el único proceso que puede obrar para que maduremos como seguidores de Cristo.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("En consecuencia, es mucho más fácil ser un cristiano fuerte que lee la Biblia y ora solo en su habitación que aprender a caminar con su fe en el contexto de las personas con las que puede tener diferencias étnicas, culturales, de personalidad y de valores, y en el que puede haber un choque de egos y ambiciones, junto con la proyección del falso yo disfrazado de actuación religiosa. Jesús está diciendo que si usted puede aprender a andar en unidad con su pueblo, ¡entonces esa es la prueba de que la gloria de Dios está obrando en usted para que madure y sea semejante a Cristo!")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Jesús no trabajó individualmente con cada discípulo, sino que los puso a todos en el caldero de un intenso ministerio en equipo en el contexto de multitudes enfocadas en sí mismas compitiendo por su atención y su ayuda. Reunió a doce hombres con diversos antecedentes económicos y vocacionales, junto con varias intenciones y planes en sus corazones. No fue fácil ministrar juntos como equipo, aun con Jesús operando como su líder. Por ejemplo, cada vez que pienso que estoy teniendo un mal día, todo lo que tengo que hacer es ir a la porción de las Escrituras que muestra lo que sucedió la última noche que Jesús vivió antes de su crucifixión. Encontramos en la narración de Lucas que la misma noche que Jesús compartió su Última Cena con los Doce, sucedió todo lo siguiente:")]), _vm._v(" "), _c('ul', [_c('li', {
    staticClass: "BULLET-1"
  }, [_vm._v("Uno de los doce traicionó a Jesús (ver Lucas 22:21).")]), _vm._v(" "), _c('li', {
    staticClass: "BULLET-2"
  }, [_vm._v("El resto de los doce discutían entre sí sobre cuál de ellos era el mayor en el reino de Dios (ver Lucas 22:24-27).")]), _vm._v(" "), _c('li', {
    staticClass: "BULLET-2"
  }, [_vm._v("Satanás trató de hacer que Pedro, el líder del floreciente movimiento de Cristo, se apartara de la fe (ver Lucas 22:31, 34).")]), _vm._v(" "), _c('li', {
    staticClass: "BULLET-2"
  }, [_vm._v("Sus tres discípulos más cercanos se quedaron dormidos por la tristeza y la depresión, y ni siquiera pudieron orar con Jesús en su hora más oscura (ver Lucas 22:44-46).")]), _vm._v(" "), _c('li', {
    staticClass: "BULLET-2"
  }, [_vm._v("Uno de los doce lideró un ejército de antagonistas que arrestaron a Jesús y lo llevaron a su muerte final (ver Lucas 22:47-53).")])]), _vm._v(" "), _c('p', {
    staticClass: "paa _idGenParaOverride-1"
  }, [_vm._v("En conclusión, está claro que si queremos liberar el potencial de las personas, necesitamos de una u otra forma lograr que sirvan a Dios en el contexto de una congregación local. Jesús enseñó a sus discípulos a cumplir la voluntad de Dios aprendiendo a trabajar juntos como equipo, no como individuos. Fueron este tipo de experiencias que vivieron juntos las que los prepararon para las pruebas y tribulaciones mucho más duras que les esperaban una vez que la iglesia, que debían dirigir, naciera poco después en el día de Pentecostés (ver Hechos 2).")]), _vm._v(" "), _c('p', {
    staticClass: "CHAP--",
    attrs: {
      "id": "_idParaDest-25"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor015"
    }
  }), _vm._v("Capítulo 12")]), _vm._v(" "), _c('p', {
    staticClass: "CHAP-TITLE",
    attrs: {
      "id": "_idParaDest-26"
    }
  }, [_vm._v("El poder del liderazgo seguro")]), _vm._v(" "), _c('p', {
    staticClass: "pf"
  }, [_c('span', {
    staticClass: "SM-CAP",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("A lo largo ")]), _vm._v("de "), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("los años, he observado el hecho de que cuanto más insegura es una persona, menos dispuesta y menos capaz está de liberar el potencial de alto nivel en los demás. Por el contrario, cuanto más segura es, más dispuesta y capaz está de reconocer y liberar un gran potencial en los demás. Si una persona se siente pequeña por dentro, pensará que todos son gigantes que intentan matarla. Cuando nuestro yo interior es fuerte, nos sentimos cómodos con los demás, lo que nos permite actuar a gran capacidad. Una de las cosas que hizo de Jesús el mayor liberador de potencial que jamás haya existido fue el hecho de que estaba muy seguro de sí mismo. Nunca caminó tenso tratando de probarse a sí mismo ante otras personas.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Un encuentro que tuvo con los líderes religiosos que se le opusieron destaca su seguridad interna como persona:")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("Una vez más Jesús se dirigió a la gente y dijo:")]), _vm._v(" "), _c('p', {
    staticClass: "BLOCK-2"
  }, [_vm._v("—Yo soy la luz del mundo. El que me sigue no andará en oscuridad, sino que tendrá la luz de la vida.")]), _vm._v(" "), _c('p', {
    staticClass: "BLOCK-2"
  }, [_vm._v("—Tú te presentas como tu propio testigo —alegaron los fariseos—, así que tu testimonio no es válido.")]), _vm._v(" "), _c('p', {
    staticClass: "BLOCK-2"
  }, [_vm._v("—Aunque yo sea mi propio testigo —respondió Jesús—, mi testimonio es válido, porque sé de dónde he venido y a dónde voy. Pero ustedes no saben de dónde vengo ni a dónde voy. Ustedes juzgan según criterios humanos; yo, en cambio, no juzgo a nadie. Y si lo hago, mis juicios son válidos porque no los emito por mi cuenta, sino en unión con el Padre que me envió.")]), _vm._v(" "), _c('p', {
    staticClass: "RIGHT-FLUSH",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("—Juan 8:12-16")]), _vm._v(" "), _c('p', {
    staticClass: "paa"
  }, [_vm._v("En este encuentro es evidente que Jesús no necesitaba la afirmación de otros hombres porque ya tenía la de su Padre. Observe que no tuvo ningún problema con declarar la verdad acerca de sí mismo cuando dijo que él era la luz del mundo. Esto se debe a que las personas seguras pueden hablar francamente sobre sí mismas sin sucumbir a la falsa humildad o al orgullo. Jesús insinuó que la confianza y la fuerza que tenía para testificar acerca de su propia persona procedían del hecho de que sabía de dónde venía y hacia dónde iba. Es decir, él estaba cimentado y establecido en su identidad original, lo que aseguraba que tenía un camino fijo por delante que su Padre le había dado para que ningún ser humano pudiera impedir que su futuro deseado se cumpliera.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Dicho esto, uno de los llamados que tenemos para ser como Cristo es estar seguros en él de la misma manera que él lo estuvo en su Padre. Cuanto más seguros estemos en Cristo, más podremos ayudar a asegurar y establecer a otros en la fe y en su capacidad para desatar su potencial. Esto se debe a que cuanto más seguros estemos en Cristo, más discernimiento tendremos para reconocer el potencial en los demás sin sentirnos amenazados o inseguros por ello. Cuanto más seguros estemos en Cristo, más podremos ayudar a otros a sentirse asegurados en él para que ellos también puedan continuar el ciclo de ayudar a cimentar a otros en Cristo. Después de todo, cuanto más profundas sean las raíces de un árbol, más alto puede crecer. Las alturas que podemos alcanzar en Cristo están determinadas por la profundidad de nuestras raíces en Cristo. Cuanto menos arraigados en Cristo estemos, menos arraigados en Cristo estarán nuestros discípulos.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Los siguientes son algunos de los rasgos de las personas seguras:")]), _vm._v(" "), _c('ul', [_c('li', {
    staticClass: "BULLET-1"
  }, [_vm._v("Las personas seguras no temen al potencial de alto nivel de otras personas.")]), _vm._v(" "), _c('li', {
    staticClass: "BULLET-2"
  }, [_vm._v("Las personas seguras no tienen miedo de ayudar a otras personas a realizar obras mayores que las que ellos mismos han realizado.")]), _vm._v(" "), _c('li', {
    staticClass: "BULLET-2"
  }, [_vm._v("Las personas seguras son capaces de mantener los límites adecuados porque son individuos centrados que no están dando vueltas ignorando los límites personales y familiares o tratando de crear oportunidades para elevarse.")]), _vm._v(" "), _c('li', {
    staticClass: "BULLET-2"
  }, [_vm._v("Las personas seguras poseen más sabiduría para impartir a los demás porque cuando están seguros, están más tranquilos ante el Señor y menos ansiosos, lo que les facilita discernir la voluntad de Dios para ellos y para los demás.")]), _vm._v(" "), _c('li', {
    staticClass: "BULLET-2"
  }, [_vm._v("Las personas seguras pueden impartir fe y equilibrio a otros individuos.")]), _vm._v(" "), _c('li', {
    staticClass: "BULLET-2"
  }, [_vm._v("Las personas seguras dejan espacio para que otros resplandezcan. Cuanto más segura es un individuo, más fácil le resulta celebrar genuinamente los éxitos de los demás. Las personas inseguras anhelan atención constante y absorben el aire de cada espacio en el que entran. Anhelan ser la novia en cada boda y el cadáver en cada funeral. No pueden soportar que alguien o algo más, aparte de ellos mismos, sea el centro de atención.")]), _vm._v(" "), _c('li', {
    staticClass: "BULLET-2"
  }, [_vm._v("Las personas seguras viven para preparar a otros, de modo que continúen con su legado. Son individuos que se esfuerzan por quedarse sin trabajo y se regocijan cuando otra persona puede hacer uno tan bueno o mejor que ellos.")])]), _vm._v(" "), _c('p', {
    staticClass: "paa"
  }, [_vm._v("No hace falta decir que cuanto más insegura es la persona, menos probable es que tenga éxito en verterse en otros y ayudarlos a liberar su potencial. Estos son algunos de los rasgos de los individuos inseguros:")]), _vm._v(" "), _c('ul', [_c('li', {
    staticClass: "BULLET-1"
  }, [_vm._v("Las personas inseguras se sienten amenazadas por otros elementos más fuertes y dotados. En lugar de derramar el fuego de Dios sobre los demás, intentan verter agua fría sobre ellos para apagar su celo y su pasión por Dios.")]), _vm._v(" "), _c('li', {
    staticClass: "BULLET-2"
  }, [_vm._v("Las personas inseguras rara vez delegan y, a menudo, microgestionan con los demás.")]), _vm._v(" "), _c('li', {
    staticClass: "BULLET-2"
  }, [_vm._v("Las personas inseguras rara vez atraen a otros elementos con un gran potencial.")]), _vm._v(" "), _c('li', {
    staticClass: "BULLET-2"
  }, [_vm._v("Las personas inseguras se rodean de hombres y mujeres que solo dicen sí porque se sienten amenazados por los que piensan por ellos mismos.")]), _vm._v(" "), _c('li', {
    staticClass: "BULLET-2"
  }, [_vm._v("Las personas inseguras rara vez celebran el éxito de los demás.")]), _vm._v(" "), _c('li', {
    staticClass: "BULLET-2"
  }, [_vm._v("Las personas inseguras se enfocan en liberar su propio potencial más que el de los otros.")]), _vm._v(" "), _c('li', {
    staticClass: "BULLET-2"
  }, [_vm._v("Las personas inseguras solo son jugadores de equipo cuando son los jefes.")]), _vm._v(" "), _c('li', {
    staticClass: "BULLET-2"
  }, [_vm._v("Las personas inseguras solo se esfuerzan cuando lideran y reciben el crédito por ello.")]), _vm._v(" "), _c('li', {
    staticClass: "BULLET-2"
  }, [_vm._v("Las personas inseguras son impulsadas por el éxito más que guiadas por el Espíritu Santo.")]), _vm._v(" "), _c('li', {
    staticClass: "BULLET-2"
  }, [_vm._v("Las personas inseguras casi siempre se sienten incómodas en entornos sociales íntimos.")]), _vm._v(" "), _c('li', {
    staticClass: "BULLET-2"
  }, [_vm._v("Las personas inseguras se convierten en el cuello de botella de cualquier misión en la que participan.")])]), _vm._v(" "), _c('p', {
    staticClass: "paa"
  }, [_vm._v("Al cerrar este capítulo, no puedo exagerar la importancia que tiene para aquellos que desean liberar el potencial de los demás el hecho de asegurarse de que ellos mismos estén tratando de encontrar su seguridad, realización e identidad en el Señor Jesús. Si no, siempre limitarán tanto su eficacia como la de los que les rodean.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll-1"
  }, [_vm._v("Cómo comprender su propósito para liberar el potencial de los demás")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Jesús conocía su misión y la articuló antes de ministrar en una nueva ciudad. Encontramos un ejemplo de esto en la narración de Lucas, cuando Jesús predicó por primera vez en su ciudad natal de Nazaret. En la sinagoga abrió el rollo del profeta Isaías y leyó las siguientes palabras:")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("El Espíritu del Señor está sobre mí, por cuanto me ha ungido para anunciar buenas noticias a los pobres. Me ha enviado a proclamar libertad a los cautivos y dar vista a los ciegos, a poner en libertad a los oprimidos, a pregonar el año del favor del Señor.")]), _vm._v(" "), _c('p', {
    staticClass: "RIGHT-FLUSH",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("—Lucas 4:18-19")]), _vm._v(" "), _c('p', {
    staticClass: "paa"
  }, [_vm._v("Jesús sabía de dónde venía y hacia dónde se dirigía en el futuro. (Ver Juan 8:14). Tenía metas tanto a corto como a largo plazo, tal cual podemos ver en las Escrituras. “Él contestó: Vayan y díganle a ese zorro: ‘Mira, hoy y mañana seguiré expulsando demonios y sanando a la gente. Al tercer día terminaré lo que debo hacer’” (Lucas 13:32). Lo que sostuvo a Jesús en la cruz fue “el gozo puesto delante de él” (Hebreos 12:2 RVR1960). También entendió y articuló el propósito principal que tenía al venir al mundo, lo que salió a relucir en una conversación con Pilato durante su juicio antes de su subsiguiente crucifixión. “Así que Pilato preguntó a Jesús: ‘¿Eres tú el rey de los judíos?’. ‘Tú mismo lo dices’, respondió” (Lucas 23:3).")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("A la luz de esto, me di cuenta de que Jesús nunca mostró prisa cuando anduvo entre nosotros, a menudo tomaba tiempo para ministrar a alguien mientras iba de camino a ministrar a otra persona (Marcos 5:21-43). Esto es extraño para muchos de nosotros que probamos metodologías de gestión de tiempo en vez de usar principios de gestión de vida en los que cada día se centra en una agenda o categoría principal en lugar de tener que planificar cada minuto. Cuanto más concentrada esté la persona, menos apresurada y agobiada se conducirá. Esto se debe a que el enfoque disminuye la posibilidad de que el individuo se involucre en actividades innecesarias que consumen tiempo. La regla general es que cuanto más se desenfoque de la actividad, menos productividad, ganancias y tiempo tendrá para la renovación personal, de la familia y de un ministerio valioso. Por lo tanto, cuanto más desenfocada esté el elemento, menos eficaz será para ayudar a liberar el potencial de otros seres.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Si vamos a ayudar a las personas a pasar de una vida ordinaria a otra extraordinaria, debemos aprender de Jesús y tener un propósito como el de él. Si vamos a volcar nuestras vidas en los demás, entonces no podemos vivir la nuestras de manera caótica, siempre de prisa. Cuanto más intencionales seamos, más significativas serán nuestras vidas, menos prisas tendremos y más tiempo poseeremos para dedicarnos a guiar a otros.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Concluyamos este capítulo con un resumen de los principios de poder de Jesús que lo convirtieron en un gran maestro y mentor.")]), _vm._v(" "), _c('p', {
    staticClass: "sbttl"
  }, [_vm._v("Jesús conocía su propósito.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("En Juan 18:37, Jesús le dijo a Pilato que él era el Rey: “¡Así que eres rey!”, le dijo Pilato. Jesús contestó: “Eres tú quien dice que soy rey. Yo para esto nací y para esto vine al mundo: para dar testimonio de la verdad. Todo el que está de parte de la verdad escucha mi voz”.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("No había nada ambiguo en cuanto a Jesús. Él sabía el "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("qué")]), _vm._v(" y el "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("por qué")]), _vm._v(" de su nacimiento y su propósito en la tierra.")]), _vm._v(" "), _c('p', {
    staticClass: "sbttl"
  }, [_vm._v("Jesús conocía su misión.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Lucas 4:18-19 ilustra que Jesús tuvo una visión con respecto a lo que se suponía que debía hacer en el ministerio para cumplir su misión.")]), _vm._v(" "), _c('p', {
    staticClass: "sbttl"
  }, [_vm._v("Jesús tenía metas específicas.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Lucas 13:31-33 muestra que el Señor tenía una meta en cuanto a dónde y cuándo iba a estar en sus viajes.")]), _vm._v(" "), _c('p', {
    staticClass: "sbttl"
  }, [_vm._v("Jesús pasó mucho tiempo diariamente en oración y solo hizo lo que vio hacer a su Padre.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Este principio se ilustra claramente en Isaías 50:4-7 y Juan 5:18-19.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Harald Bredesen dijo una vez a un grupo de pastores: “Si los ministros se concentraran en hacer solo lo que agrada al Señor y pusieran eso en primer lugar, entonces todos los que se supone que deben complacer estarán complacidos y los ministros no sufrirían agotamiento”.")]), _vm._v(" "), _c('p', {
    staticClass: "sbttl"
  }, [_vm._v("Jesús se enfocó en las personas, no en los programas.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Mateo 9:36 nos muestra que Jesús conocía a las personas y sentía compasión por ellas. En Mateo 23:2-4, nos enseña en contra de poner cargas pesadas sobre las personas sin ayudarlas. También en Mateo 23:23, el Señor menospreció a los líderes que enfatizaban el diezmo sin considerar también la justicia y la misericordia para las personas.")]), _vm._v(" "), _c('p', {
    staticClass: "sbttl"
  }, [_vm._v("Jesús se concentró en captar hombres y en desarrollarlos en cuanto al liderazgo más que en deberes administrativos.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Jesús únicamente se enfocó en lo que él y sus doce (y luego sus setenta) podían lograr. No se complicaba con mucha administración puesto que delegó en sus discípulos todo lo necesario para liberarse y concentrarse en predicar, enseñar y discipular.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("La mayoría de las iglesias prosperarían si intentaran acabar con todo ministerio que no se centre en la evangelización y en hacer discípulos.")]), _vm._v(" "), _c('p', {
    staticClass: "sbttl"
  }, [_vm._v("Jesús sabía de dónde venía y hacia dónde iba.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("En Juan 8:14 Jesús les dijo a los judíos que su testimonio era verdadero porque sabía de dónde venía y a dónde iba.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Si las personas no saben de dónde vienen (el génesis de la vida revela el propósito y el viaje de la vida), entonces, ¿cómo van a saber por qué están aquí y a dónde se supone que deben ir?")]), _vm._v(" "), _c('p', {
    staticClass: "sbttl"
  }, [_vm._v("Jesús no fue impulsado por el ego; la compasión lo movió a ministrar (Marcos 1:41-44).")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Los líderes que son impulsados, más que guiados por el Señor, a menudo son competitivos, inseguros y egocéntricos con respecto a su ministerio. Pueden trabajar fuerte, pero su baja autoestima los impulsa mucho en la búsqueda de su significado.")]), _vm._v(" "), _c('p', {
    staticClass: "sbttl"
  }, [_vm._v("Jesús sabía cuándo terminaría su ministerio.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Juan 19:30 muestra que Jesús sabía cuándo finalizó su ministerio, por lo que dijo: “Consumado es”, antes de entregar su espíritu y morir. Muchas personas no terminan bien, no finalizan su propósito ni permanecen en un puesto mucho después de que deberían haberlo entregado a un líder más joven o más talentoso para cumplir adecuadamente la misión corporativa.")]), _vm._v(" "), _c('p', {
    staticClass: "sbttl"
  }, [_vm._v("Jesús no ministró aparte de su asignación.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Marcos 7:27 muestra que Jesús no le iba a ministrar a la mujer sirofenicia porque ella no estaba bajo el pacto con Dios y no se ajustaba al público que era su objetivo. Además, instruyó a sus discípulos a no ir a ninguno de los gentiles o samaritanos; quería que se mantuvieran enfocados y decididos (Mateo 10:5-6). Cuando usted se aparta de la tarea que Dios le ha asignado, se aleja de su gracia y de su favor, por lo que ministra desde de la carne. Esto lleva al agotamiento ministerial.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("No podemos ser el salvador de todos. No somos la respuesta de todos a la oración. Usted no está llamado a ayudar a todas las personas que conozca. A veces, Satanás enviará personas que tratarán de que usted se agote. Así que manténgase en el marco de su asignación y prosperará, por lo que se sentirá satisfecho.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("En nuestra iglesia me niego a iniciar un ministerio, aunque haya una gran necesidad, hasta que Dios me provea un líder calificado para ejercerlo. La razón de ello es que si no tengo un líder para administrar el ministerio, entonces el personal de mi oficina o yo tendremos que desarrollar el nuevo ministerio, lo que ejercerá una tensión indebida en nosotros.")]), _vm._v(" "), _c('p', {
    staticClass: "sbttl"
  }, [_vm._v("Jesús no perdió su tiempo en conversaciones sin sentido.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Juan 12:20-23 registra que Jesús nunca honró el pedido de los griegos que querían verlo, así que los ignoró y continuó en la siguiente fase de su ministerio. No estoy obligado a devolver la llamada telefónica o el correo electrónico de todos, ni a reunirme con cada persona que quiera estar conmigo. No puedo satisfacer la agenda que todos tienen con mi vida. Solo estoy obligado a agradar al Señor y hacer lo que veo que mi Padre me ordena hacer.")]), _vm._v(" "), _c('p', {
    staticClass: "sbttl"
  }, [_vm._v("Jesús actuó fuera de su círculo íntimo y les delegó el ministerio de ayuda, lo que lo liberó para enfocarse en predicar, enseñar, orar y cumplir su propósito.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Jesús tenía a sus tres, sus doce y sus setenta ministros para él y por él. Los relatos de los evangelios muestran que fueron sus discípulos los que compraron comida (Juan 4:8), lo cual lo dejó en libertad para ministrar a Samaria. Además, fueron sus discípulos los que organizaron e hicieron que las multitudes se sentaran para que él pudiera darles de comer (Juan 6:10). A Pedro y a Juan les dijeron que prepararan el Aposento Alto para que Jesús dirigiera la famosa Última Cena (Lucas 22:8-13). Jesús estaba dormido en una barca mientras sus discípulos lo llevaban a su próximo destino (Marcos 4:35-41).")]), _vm._v(" "), _c('p', {
    staticClass: "p _idGenParaOverride-1"
  }, [_vm._v("En conclusión, si vamos a ser mentores eficientes que liberan el potencial de los demás, debemos tener vidas con propósito que nos den la capacidad para enfocarnos y prosperar, de modo que podamos liberar a otros para que alcancen su destino y su llamamiento.")]), _vm._v(" "), _c('p', {
    staticClass: "CHAP--",
    attrs: {
      "id": "_idParaDest-27"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor016"
    }
  }), _vm._v("Capítulo 13")]), _vm._v(" "), _c('p', {
    staticClass: "CHAP-TITLE",
    attrs: {
      "id": "_idParaDest-28"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor017"
    }
  }), _vm._v("Cómo entender la lucha")]), _vm._v(" "), _c('p', {
    staticClass: "pf"
  }, [_c('span', {
    staticClass: "SM-CAP",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Antes de que ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("resucitara, Jesús fue a la cruz; experimentó un gran dolor antes de ser resucitado con poder. Sin embargo, en última instancia, su dolor fue para ganancia nuestra. Por tanto, para ser como Jesús (no para nuestra redención), también tenemos que aprender a permitir que el dolor nos moldee de modo que podamos andar en la humildad y la sabiduría de Cristo y convertirnos en sanadores heridos como lo fue él (Isaías 53:4-6).")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("En mis casi cuarenta años como líder cristiano, he notado que la mayor parte de mi crecimiento emocional y espiritual se ha producido en momentos de intenso dolor y desafíos para mi liderazgo. Si bien a la mayoría de nosotros nos encantaría crecer simplemente a partir de la acumulación de información, la verdad es que necesitamos experimentar la iluminación para que el conocimiento transforme nuestro ser interior. Es por eso que a menudo le digo a la gente: “No podemos crecer solo asistiendo a estudios bíblicos y orando; ¡debemos vivir esos estudios y aplicar esas oraciones a nuestras vidas para que podamos apreciar el crecimiento!”.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("No obstante hay una tendencia creciente, en el mundo académico, a combinar la práctica con el conocimiento, ya que los profesionales tienen más comprensión de sus temas que aquellos que solo ven datos todo el día en las computadoras. La investigación profesional produce el único tipo de datos en los que podemos confiar. Esto es similar a lo que ocurre con los generales y los ejércitos que solo pueden volverse hábiles y obtener verdaderas destrezas de batalla si participan en combates reales. Los médicos nunca aprenderán con solo tomar clases; deben practicar con personas de verdad para ser competentes. Usted nunca querría ser el primer paciente al que un médico opere para adiestrarse. Es por eso que los médicos nunca les dirán a sus pacientes qué tipo de experiencia real tienen hasta que posean un buen historial de práctica y vivencias con el paciente.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Por otro lado, con respecto al dolor, hay algo en el cerebro humano —específicamente, la sensación de dolor y placer— que conecta esas experiencias para hacer que elijamos ciertos patrones de comportamiento. Cuando era niño y toqué una estufa encendida, ¡aprendí, por medio de esa dolorosa experiencia, que nunca más volvería a tocarla cuando estuviera encendida! No importa cuántas veces mis padres me dijeron que no hiciera eso, tuve que aprender por las malas.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Como seguidor de Cristo he aprendido que cuando pongo el reino de Dios primero en mi vida, todas las cosas que necesito me son dadas en forma sobrenatural. Pero cuando antepongo mis deseos carnales, las cosas no salen bien y pago las consecuencias. Estas experiencias negativas tienen el propósito de ayudarme en mi crecimiento espiritual. A veces Dios permite que ocurran esas cosas en nuestras vidas aunque no hayamos hecho nada malo porque él sabe que es parte de la preparación para llevarnos al siguiente nivel. El corazón humano es engañosamente perverso y desesperadamente enfermo (Jeremías 17:9) a causa de nuestra naturaleza pecaminosa. Por desdicha, la única forma en que los humanos pecadores andaremos en el quebrantamiento y la humildad es aprendiendo a través del sufrimiento en nuestra carne (Daniel 11:35).")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Rara vez he conocido a un ministro joven que no pensara que estaba listo para ser un gran líder por tener un título acreditado. Pero he conocido a bastantes ministros mayores y más sabios que han aprendido a renunciar al objetivo de alcanzar un gran estatus de celebridad ministerial porque han aprendido —a través del dolor— lo verdaderamente efímeras que son todas esas cosas que el mundo considera exitosas. Un caso bíblico en cuestión lo vemos en el rey David. Este fue ungido rey de Israel, como lo afirma 1 Samuel 16, pero en realidad no se le dio el título ni la función hasta después de una década, tras la muerte del rey Saúl. (En 2 Samuel 2, David fue ungido rey de Judá y, en el capítulo 5, fue ungido como monarca sobre todo Israel). David tenía los dones, las habilidades y la unción para ser rey a sus diecisiete años, pero no fue hasta haber sufrido dolor durante trece años —debido a la persecución de un rey egocéntrico impulsado por la carne— que estuvo emocionalmente listo para ascender al trono.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("A menudo, los jóvenes se sienten frustrados porque creen que tienen la capacidad de ocupar determinada posición que alguien más tiene por encima de ellos. Pero esos jóvenes no entienden que debido a nuestra naturaleza pecaminosa, Dios tiene que usar la escuela del dolor para prepararnos y luego promovernos. No creo que Dios me haya ascendido alguna vez cuando pensé que estaba listo. Gracias a él que esperó hasta que supo que yo estaba listo para asumir más responsabilidades.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Dios amaba tanto a David que no quería que fuera un rey hasta que le quitaran toda apariencia de control carnal. Ha sido mi experiencia que antes de que Dios me promueva al siguiente nivel, ya estoy caminando en esa unción y autoridad superior aunque sin la posición y el título. Puede que primero tenga la unción, pero luego viene una serie de pruebas desafiantes destinadas a obligarme a vencer la carne para someterla, para que no explote de orgullo cuando llegue al siguiente nivel. La transición tiene que suceder internamente antes de que se manifieste externamente.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Antes de que una mujer dé a luz, debe cargar a un hermoso bebé que vive dentro de ella durante nueve meses. No solo eso, sino que justo antes de que nazca el pequeño, ¡el mayor trauma para la madre ocurre cuando puja para que ese bebé abra sus ojos ante el mundo! Muchos creyentes renuncian mientras están en la mesa de parto; el dolor hace que se rindan antes de que lo que están dando a luz haya tenido la oportunidad de formarse por completo y salir adelante. Que Dios nos ayude a superar el dolor por completo hasta que llegue el ascenso.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Un día, estaba pensando que todos los líderes con mucha influencia —que conozco— parecen tener algo en común: todos han sufrido mucho en sus vidas. De hecho, cada uno de ellos tiene una cruz particular que cargar o han pasado por terribles temporadas de dolor y sufrimiento que fueron parte de un proceso divino que los convirtió —y continúa moldeándolos— en los líderes altamente eficientes que son hoy. Esos desafíos pueden ser problemas relacionales con su cónyuge, hijos, otros líderes, etc., o pueden ser conflictos personales relacionados con su bienestar espiritual, emocional o físico. Vemos esto ilustrado en el Libro de los Hechos cuando Dios le dice a Ananías que Pablo tenía que sufrir mucho por el nombre de Jesús. (Ver Hechos 9:16). Podemos leer el propio testimonio de Pablo acerca de sí mismo con respecto a la razón de su sufrimiento en 2 Corintios:")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("Me veo obligado a jactarme, aunque nada se gane con ello. Paso a referirme a las visiones y revelaciones del Señor. Conozco a un seguidor de Cristo que hace catorce años fue llevado al tercer cielo. No sé si en el cuerpo o fuera del cuerpo; Dios lo sabe. Y sé que este hombre —no sé si en el cuerpo o aparte del cuerpo, Dios lo sabe— fue llevado al paraíso y escuchó cosas indecibles que a los humanos no se nos permite expresar. De tal hombre podría presumir, pero de mí no haré alarde sino de mis debilidades. Sin embargo, no sería insensato si decidiera jactarme, porque estaría diciendo la verdad. Pero no lo hago, para que nadie suponga que soy más de lo que aparento o de lo que digo. Para evitar que me volviera presumido por estas sublimes revelaciones, una espina me fue clavada en el cuerpo, es decir, un mensajero de Satanás, para que me atormentara. Tres veces rogué al Señor que me la quitara; pero él me dijo: “Te basta con mi gracia, pues mi poder se perfecciona en la debilidad”. Por lo tanto, gustosamente presumiré más bien de mis debilidades, para que permanezca sobre mí el poder de Cristo. Por eso me regocijo en debilidades, insultos, privaciones, persecuciones y dificultades que sufro por Cristo; porque, cuando soy débil, entonces soy fuerte.")]), _vm._v(" "), _c('p', {
    staticClass: "RIGHT-FLUSH",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("—2 Corintios 12:1-10")]), _vm._v(" "), _c('p', {
    staticClass: "paa"
  }, [_vm._v("De acuerdo con este pasaje, podemos ver que el sufrimiento de Pablo se relacionaba con su capacidad para el liderazgo y su gran llamado, lo cual tenía que ser moderado a través de su sufrimiento y de la naturaleza humana pecaminosa que hace que tengamos cierta propensión a jactarnos de lo que logramos en la vida. Dios tiene que permitir que el dolor nos azote para mantenernos dependientes de él, puesto que todos nacemos en pecado con tendencias carnales tan naturales como jactarnos de nuestros propios logros y confiar en nuestros propios dones, habilidades y en carne mas no en su gracia.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Al considerar mi propia vida y las de otros que conozco personalmente, puedo ver que las mismas cosas que nos hacen exitosos se conectan con nuestra naturaleza pecaminosa, tan bien, que pueden llevarnos de vuelta a iguales pecados o muy parecidos. Por ejemplo, el caso mío es que la terquedad, la perseverancia y la tendencia a seguir adelante por causa de Cristo —a pesar de todos los obstáculos— se relacionan con la manera en que —en mi niñez— lidié con el rechazo, el aislamiento y el dolor para hacerme un nombre por mí mismo sobresaliendo en peleas callejeras, deportes y música, así como en otras áreas de la vida. Todo eso fue en un esfuerzo por forjarme un prestigio y una identidad para que mis compañeros me elogiaran, respetaran y celebraran. Aunque eso desarrolló en mí cualidades de perseverancia en medio del dolor y el sufrimiento, ¡fue para mi gloria y no para la gloria de Dios!")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Por lo tanto, el desarrollo de las cualidades que utilizo hasta el día de hoy son parte de mi cartera de liderazgo. Mis dones y habilidades están directamente conectados con los hábitos y patrones que desarrollé a partir de mi naturaleza pecaminosa y mi deseo de forjarme un nombre por el bien de mi propia valía y mi autoestima. Esto me muestra que Dios incluso usó mis pecados para su gloria. En consecuencia, los dones y las habilidades que uso hoy como líder en el cuerpo de Cristo fueron originalmente inspirados, moldeados y desarrollados en el horno de fuego de la autosupervivencia en mi niñez. ¡Mis dones y mi llamado están inextricablemente conectados con la misma naturaleza pecaminosa por la que Jesús tuvo que morir! Es por eso que Dios tiene que permitir constantemente grandes desafíos, dolor y sufrimiento en mi vida como una forma de moderar mi tendencia a depender de mí mismo, honrarme y confiar en mí para obtener resultados.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Cuanto más grandes son los líderes, más tercos tienen que ser para resistir la tentación, mantenerse enfocados y tener éxito, aunque esta misma terquedad se haya desarrollado originalmente y emanado de su rebelión personal contra Dios antes de ser salvos. Por lo tanto, siempre hay una delgada línea entre nuestras grandes cualidades de liderazgo y nuestras tendencias pecaminosas a rebelarnos contra Dios y construir nuestros propios reinos. Esto también explica por qué los grandes líderes a menudo caen en escándalos, sobre todo si permiten que sus agitados horarios desplacen su continua necesidad de formación espiritual en la presencia de Dios.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Volviendo al apóstol Pablo, a medida que maduraba, en realidad se jactaba más de sus debilidades que de sus logros para que el poder de Cristo pudiera descansar sobre él. Qué lejos está eso de algunos de los predicadores de hoy que constantemente se jactan de cuánta victoria, poder y logros tienen en sus ministerios. En realidad, cuanto más espiritualmente inmaduros sean los líderes, más se jactarán de sus logros. Cuanto más maduros sean, más se jactarán de sus debilidades y glorificarán la gracia de Cristo que los fortalece. Comprender estos conceptos debería ayudarnos en dos aspectos. Primero, en vez de desalentar a los seguidores de Cristo, esto debería ser una gran fuente de aliento. Muchos creyentes sufren en silencio porque se sienten avergonzados y piensan que son los únicos que siempre enfrentan problemas dolorosos. Satanás usará esto para hacer que la persona renuncie por puro desánimo y la sensación de fracaso. Debemos animarnos y saber que no estamos solos en nuestro dolor. En la medida en que las personas tengan influencia, tendrán que soportar el proceso del dolor para que sus dones y habilidades puedan redimirse continuamente para la gloria y la honra de Dios.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("La clave para descubrir y lidiar con los problemas pecaminosos dominantes en nuestras vidas es reflexionar con franqueza sobre nuestros talentos, dones y habilidades, y cómo hemos confiado en ellos para manipular a otros, controlar nuestro entorno para disfrutar de autonomía y forjarnos un nombre o un prestigio. Así pasó con Lucifer cuando intentó hacer lo suyo y su orgullo lo motivó a tratar de exaltarse por encima del trono de Dios para su propia autonomía y la glorificación propia (Isaías 14:12-14). Entender esto nos permite tener una mayor percepción y aprecio por las profundidades y riquezas del amor y la gracia de Dios, que usará las mismas habilidades que están conectadas con nuestra autoglorificación y preservación carnal a fin de modelarnos y formarnos para sus propósitos. Dios rodea el poder con problemas para que cuando tengamos potestad e influencia, estemos tan quebrantados, humildes y dependientes de él que no seamos tan rápidos para atribuirnos la gloria por los grandes logros que surgen de nuestros débiles esfuerzos y no dársela a él.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll-1"
  }, [_vm._v("El creyente y la guerra espiritual")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Hay algunos creyentes que creen falsamente que si tienen mucha fe, no pasarán por ningún sufrimiento, pruebas severas o ataques satánicos. ¡Nada más lejos de la verdad! En realidad, lo contrario es cierto. Por ejemplo, en el Libro de Job, capítulos 1 y 2, Dios le pregunta a Satanás qué pensaba acerca de su siervo Job. Por lo tanto, Dios llamó la atención de Satanás sobre Job, no porque este estuviera en pecado, sino porque era el principal siervo de Dios en la tierra en ese momento (Job 1:6-12; 2:3-6).")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Hay otros ejemplos en las Escrituras. Hechos 19:15 ilustra que el apóstol Pablo era conocido no solo en el cielo sino también en el infierno. ¡Todos estaban pendientes de él! Es por eso que Pablo declara que le rogó al Señor que se llevara al mensajero de Satanás que lo perseguía (2 Corintios 12:1-8). Este mensajero no era una enfermedad sino acoso, como vemos al leer el contexto en 2 Corintios 11:17-34. La Primera Epístola de Pedro, 5:8-9, enseña que Satanás vaga por la tierra buscando a quien devorar, lo que también va junto con la narración de Job (Job 1:7). Cuando leemos el contexto de todos estos pasajes, especialmente con respecto al enfoque satánico tanto en Pablo como en Job, podemos llegar a la conclusión de que el objetivo principal del diablo es frustrar, desviar, distraer y desarmar a los siervos de Dios que promueven el gobierno de Dios en la tierra como lo es en el cielo. El cielo es el único reino en el universo donde todo está perfectamente alineado bajo el Rey Jesús porque el diablo fue desplazado del cielo (Apocalipsis 12:7-12). En consecuencia, cuando alguien quiere traer la influencia del reino de Dios a la tierra como impera en el cielo, ¡Satanás estalla de miedo e ira contra esa persona porque no quiere ser arrojado de otro lugar!")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Es por eso que parece que la persona que sigue la voluntad de Dios a veces padece las pruebas, tribulaciones y resistencias más difíciles, a diferencia de algunos santos que son buscadores casuales de Dios. Satanás no es tonto. ¿Por qué debería atacar a un cristiano que es un mal ejemplo para los demás y que ya está engañado y en sus garras? ¡Él se enfocará más en aquellos que son las mayores amenazas a su deseo de tomar el poder de Dios sobre el reino de la tierra! Recuerde, Dios le dio a Adán una comisión para que gobernara toda la tierra (Génesis 1:28), e inmediatamente después vino el diablo y convenció tanto a Adán como a Eva de desobedecer a Dios y abandonar sus puestos como ayudantes de Dios en la tierra (Génesis 3:1-8).")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Desde entonces, Satanás ha estado celosamente tratando de proteger su control sobre el reino terrenal que robó al subvertir a Adán, incluidos sus sistemas de gobierno, comercio, medios de comunicación, las artes, la ciencia y la educación. Aquellos que intentan llevar la influencia de Dios a esos reinos muy probablemente experimentarán algunos de los niveles más altos de resistencia satánica. El apóstol Pablo tuvo un mensajero de Satanás que lo seguía a todas partes y causaba disturbios y persecuciones (2 Corintios 12: 1-8), solo porque estaba trastornando el sistema mundial de ese tiempo (Hechos 17).")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("De modo que, si está entregado a Dios, no se desanime cuando le ataquen ni se deje engañar al pensar que la única razón por la que está en una intensa guerra espiritual o tribulación es porque es posible que se haya alejado de Dios. Puede ser lo contrario. ¡Está siendo atacado porque está en el blanco divino! Por eso Pablo exhortó a los creyentes a permanecer firmes en el Señor: “Fortalézcanse con el gran poder del Señor. Pónganse toda la armadura de Dios para que puedan hacer frente a las artimañas del diablo. Porque "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("nuestra lucha")]), _vm._v(" no es contra seres humanos, sino contra poderes, contra autoridades, contra potestades que dominan este mundo de tinieblas, contra fuerzas espirituales malignas en las regiones celestiales. Por lo tanto, pónganse toda la armadura de Dios, para que cuando llegue el día malo puedan resistir hasta el fin con firmeza” (Efesios 6:10-13). Note que Pablo dijo “nuestra lucha”, lo que significa que se estaba incluyendo a sí mismo en esta batalla. Cada vez que había una puerta abierta para el ministerio, tenía muchos adversarios. Este es un principio bíblico (1 Corintios 16:9).")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Nunca piense que solo porque Dios le está llamando a hacer algo, va a ser fácil. Jesús hizo la voluntad de Dios y fue crucificado. La historia de la iglesia nos dice que Pablo fue decapitado. ¡Lo que importa no es cuántos años vivimos sino lo que hacemos con los años que vivimos! Entonces, ¿qué hacemos cuando estamos en un tiempo de guerra espiritual que Pablo llama “el día malo” en Efesios 6:13? Pablo nos dice en este pasaje que seamos fuertes en el Señor y que estemos firmes; en otras palabras, no se rinda (vv. 10-13). El apóstol Pedro también nos dice que resistamos al diablo, estando firmes en la fe (1 Pedro 5:9). Pedro sabe por experiencia que la fe en Dios es la clave para mantenerse firme en medio del día malo porque cuando negó a Cristo tres veces, Jesús oró por él para que su “fe” no fallara (Lucas 22:31-32). Por lo tanto, no tema cuando padezca tribulación porque ¡Jesús ya venció al mundo (Juan 16:33)!")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Todos los seguidores de Cristo, especialmente aquellos que se esfuerzan por liberar el potencial de los demás, serán resistidos e incluso atacados por el enemigo de nuestras almas. Sin embargo, quiero reforzar la importancia de que los mentores cristianos tengan perseverancia y la actitud adecuada con el dolor y el sufrimiento, especialmente el tipo de dolor que es tanto emocional como psicológico.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll-1"
  }, [_vm._v("El dolor lo prospera")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("El dolor es inevitable en este mundo. Insisto, el principal tipo de dolor al que me refiero es el emocional, el mental y el psicológico. Jesús nos aseguró que en el mundo sufriremos tribulación (Juan 16:33), lo que incluye tanto en lo físico como en lo emocional y este contexto. Hay muchas razones para el dolor. Parte del mismo es autoinfligido, parte es causada por tragedias inesperadas como accidentes, parte es debido al comportamiento de otras personas, por trauma mental y emocional, y además —como se registra en el Libro de Job—, a veces es por pruebas divinas. Deje usted de contar. Independientemente de la causa, todo dolor tiene un detalle en común: el potencial redentor para mejorar al individuo, a la familia o al equipo de líderes para que funcionen mejor como comunidad.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Nadie quiere el dolor y la mayoría de la gente intenta evitarlo o huir de él. A pesar de ello, es indispensable para que el propósito de Dios se cumpla en la tierra. También es indispensable para liberar el potencial en nuestras vidas. Muchos de los que intentan evitar el dolor tratan de medicarse con mucha actividad, la búsqueda de numerosas relaciones o el abuso de sustancias como las drogas y el alcohol. Yo también preferiría evitarlo, pero cuando siento un dolor intenso, eso me hace reflexionar en sus causas fundamentales, lo que me hace ser más consciente de mí mismo. Dado que el dolor es la experiencia común de todo ser humano, puede marcarnos con un agudo sentido de empatía por los demás seres humanos que sufren situaciones similares a las que hemos experimentado (2 Corintios 1:3-7). Una simple comprensión intelectual de la Biblia no puede lograr esto.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("El dolor puede motivarnos a profundizar en nuestras relaciones clave y a sentir menos motivación para las superficiales. Puede hacer que busquemos al Señor como nunca antes para llegar a ser más como Cristo y soportar el sufrimiento con su poder y su fuerza (Filipenses 4:13). El dolor puede estimularnos a priorizar nuestro tiempo y nuestras energías para que nos concentremos más en cumplir nuestro propósito divino en la vida. Puede motivarnos a adentrarnos en el universo mental y emocional de los demás para experimentar una fusión de horizontes que potencie nuestras relaciones clave. El dolor nos motiva a hacer las cosas mejor la próxima vez para no volver a sentirlo igual. A través del dolor conocemos la paciencia, la obediencia, la perseverancia y la fidelidad de Dios en medio de nuestro sufrimiento. El dolor nos enseña humildad para que podamos ser agradecidos por las cosas más pequeñas de la vida y odiar la autopromoción. El dolor nos lleva a descubrir que quizás la principal bendición del mundo no son las posesiones, los títulos o la fama, sino la paz interior, el contentamiento y el gozo del Señor. A través del dolor podemos apreciar la guía del Señor, el carácter y la mente de Dios, y la mansedumbre y la ternura de Cristo (Salmos 32:8-9; 2 Corintios 10:1).")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Al procesar el dolor en el poder del Espíritu Santo, aumentamos nuestra capacidad espiritual y emocional para procesarlo, lo que a su vez aumenta nuestra capacidad de liderazgo. El libro de Samuel Chand, "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Leadership Pain,")]), _vm._v(" muestra la forma en que el umbral de dolor de una persona determina su capacidad de influencia."), _c('sup', {
    staticClass: "sup _idGenCharOverride-2"
  }, [_vm._v("1")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("El dolor le ayuda a percatarse de por qué vale la pena sufrir y a apreciar a las personas y las cosas que más valora en la vida. Usted no estará dispuesto a sufrir por las personas y entidades que no le apasionan, razón por la cual algunas de nuestras relaciones no duran mucho.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("El dolor hace que nos concentremos en nuestro principal llamado en la vida, que es lo único que puede motivarnos a seguir adelante (Hebreos 12:1-2). Puede amargarnos o hacernos mejores, capacitarnos para apreciar lo bueno del conflicto o huir de él, hacer que culpemos a otros o crecer internamente, convertirnos en víctimas o ser victoriosos, vencedores o resentidos. Dios permitió que los hijos de Israel vivieran la guerra para probarlos y enseñarlos a enfrentarlas (Jueces 3:1-4). Apocalipsis 2-3 enseña a la iglesia que solo los vencedores heredarán las bendiciones de Dios. Vencer implica un gran desafío, aun con el dolor que lo acompañe.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Nuestras circunstancias en la vida nunca son las que nos destruyen; es nuestra respuesta a ellas lo que determina nuestra trayectoria. Dios espera que venzamos y continuemos en el propósito de su reino a pesar de la realidad inmanente de intenso dolor y tribulación. (Ver Apocalipsis 1:9). Jesús, el hombre más grande que jamás haya existido, fue descrito como el siervo sufriente en Isaías 53: “varón de dolores, experimentado en quebranto” (v. 3). Fue traicionado por alguien cercano a él (Judas) y abandonado por todos sus seguidores, abandonado cuando sufrió la cruz. ¡Observe que la cruz vino antes de la resurrección! Jesús aprendió la obediencia a través de lo que sufrió (Hebreos 5:8) y fue hecho Sumo Sacerdote fiel y grande, tanto que puede interceder por nosotros a causa de los sufrimientos y las pruebas que soportó (Hebreos 4:15-16). Así que, si está experimentando un gran dolor, ¡tiene una gran compañía! El Señor Jesucristo lo padeció antes que usted. Ya experimentó más dolor del que cualquiera de nosotros jamás experimentará, lo que significa que él sabe cómo sostenernos en sus poderosas manos. (Ver Isaías 41:10; 43:2, 4). Finalmente, el llamado más grande que cualquiera de nosotros jamás tendrá es el de ser conformado a la imagen de Jesucristo, lo que también implica compartir sus sufrimientos (Filipenses 3:10; Romanos 8:29-30). Que todos crezcamos a su imagen y tengamos la misma mente que tuvo Jesús, como afirma Filipenses 2:4-11.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll-1"
  }, [_vm._v("El dolor para prosperar a otros")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Cuando tratamos de liberar el potencial de los demás, tenemos que aprender de Jesús ya que una de las mejores oportunidades que tendremos para vincularnos con los demás y desarrollar su potencial es compartir con ellos nuestra propia travesía dolorosa. Si ellos piensan que nunca sufrimos, entonces aquellos a los que asesore no podrán relacionarse con usted. Al examinar los evangelios, vemos que Jesús expuso a sus discípulos al conflicto y compartió su dolor. Eso se ilustra en las narraciones relacionadas con la Última Cena y la experiencia de Jesús en el huerto de Getsemaní, así como en la pasión que lo condujo a la cruz.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Él les dijo a sus discípulos que si permanecían con él durante sus pruebas, después les conferiría un reino (Lucas 22:28-30). Por lo tanto, parte de lo que desató el desarrollo del potencial de sus discípulos fue hacerlos conscientes de la realidad de que el dolor era necesario para propagar el reino de Dios. Incluso el propio Pablo dijo que debemos pasar por muchas tribulaciones para entrar en el reino de Dios (Hechos 14:22). Como alguien que ha discipulado personas durante casi cuatro décadas, les diré que uno de los momentos más poderosos que tengo con mis hombres es cuando comparto mi dolor con ellos. Ya sea personal o dolor ministerial, eso sigue siendo eficaz.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Mi disposición a ser vulnerable revela un nivel de confianza con mis hombres que crea un vínculo poderoso que no se puede romper fácilmente. También me permite entrenarlos y equiparlos a medida que ven cómo respondo a mis propias experiencias dolorosas, lo que les permite comprender mi humanidad como persona para que no me pongan en un pedestal en sus propios corazones y mentes. Aunque el enemigo intenta usar el dolor para destruirme, Dios lo usa para su gloria y para desatar la fe, la esperanza y el potencial en otras personas y así hacer avanzar su reino para su gloria.")]), _vm._v(" "), _c('p', {
    staticClass: "CHAP--",
    attrs: {
      "id": "_idParaDest-29"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor018"
    }
  }), _vm._v("Capítulo 14")]), _vm._v(" "), _c('p', {
    staticClass: "CHAP-TITLE",
    attrs: {
      "id": "_idParaDest-30"
    }
  }, [_vm._v("Entienda el futuro ")]), _vm._v(" "), _c('p', {
    staticClass: "pf"
  }, [_c('span', {
    staticClass: "SM-CAP",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Algunas de las ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("cosas que atrajeron a los seguidores de Jesús fueron el hecho de que entendió los tiempos en los que vivía, se enfrentó a la falsedad y dio una guía clara sobre el camino a seguir. En otras palabras, Jesús tenía presciencia, no solo presencia. Entendió lo nuevo que Dios estaba anunciando y, al mismo tiempo, sabía que había odres viejos que tenían que ser abandonados. Comprendió y honró a Juan el Bautista. Sin embargo, también entendió que Juan representaba la ley y los profetas, no el nuevo pacto que estaba anunciando (Mateo 11:7-14). Jesús honró el pasado pero, al mismo tiempo, no se quedó atascado en él y, por lo tanto, limitó el futuro. Las Escrituras ilustran cómo entendió el futuro.")])]), _vm._v(" "), _c('ul', [_c('li', {
    staticClass: "BULLET-1"
  }, [_vm._v("Jesús sabía que iba a ser crucificado, por lo que preparó a sus discípulos para ese evento traumático (Marcos 8:31-34).")]), _vm._v(" "), _c('li', {
    staticClass: "BULLET-2"
  }, [_vm._v("Jesús predijo que resucitaría (Marcos 8:31).")]), _vm._v(" "), _c('li', {
    staticClass: "BULLET-2"
  }, [_vm._v("Jesús sabía que moriría en Jerusalén (Lucas 13:33).")]), _vm._v(" "), _c('li', {
    staticClass: "BULLET-2"
  }, [_vm._v("Jesús sabía de antemano que Satanás iba a tentar a Pedro (Lucas 22:31-34).")]), _vm._v(" "), _c('li', {
    staticClass: "BULLET-2"
  }, [_vm._v("Jesús sabía quién lo iba a traicionar (Juan 13:21-26).")]), _vm._v(" "), _c('li', {
    staticClass: "BULLET-2"
  }, [_vm._v("Jesús sabía que el Espíritu Santo tomaría su lugar después de su ascensión y daría poder a sus discípulos (Juan 14-16).")]), _vm._v(" "), _c('li', {
    staticClass: "BULLET-2"
  }, [_vm._v("Sus discípulos creían que él sabía todas las cosas que estaban por suceder (Juan 16:30).")]), _vm._v(" "), _c('li', {
    staticClass: "BULLET-2"
  }, [_vm._v("Jesús sabía cómo iba a morir Pedro, el líder emergente del movimiento (Juan 21:18-19).")])]), _vm._v(" "), _c('p', {
    staticClass: "paa"
  }, [_vm._v("En general, Jesús mantuvo a sus discípulos al tanto de lo que estaba por suceder para que creyeran en él (Juan 14:29). Por supuesto, nadie espera que un mentor sepa todo lo que está a punto de suceder como lo hizo Jesús, pero todos los líderes efectivos tienen una sensación general de hacia dónde se dirige Dios, las tendencias actuales y lo que él quiere lograr en el futuro.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Además, Jesús les prometió a sus seguidores que una de las funciones del Espíritu Santo sería mostrarles las cosas por venir (Juan 16:13). Por lo tanto, debemos esperar que el Señor nos revele cosas permanentes para que podamos estar a la vanguardia y preparar a su pueblo para lo que ha de venir. La Escritura nos enseña que el prudente prevé el mal y se esconde, pero el necio sigue adelante y sufre las consecuencias (Proverbios 22:3). De forma que Dios espera que todos sus seguidores tengan una especie de presciencia. De lo contrario, ¿cómo podemos caminar con sabiduría y planificar con anticipación?")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Cuando se trata de empoderar y liberar el potencial de los demás, también debemos funcionar como los hijos de Isacar, que eran hombres que comprendían los tiempos (la cultura y los acontecimientos de su época) y sabían qué hacer al respecto (1 Crónicas 12:32). Cuanta más capacidad de liderazgo vea en alguien a quien está asesorando, mayor responsabilidad tendrá de comprender los tiempos en los que vivimos, no solo los cronológicos, sino también los momentos "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("kairos")]), _vm._v(", o los tiempos y estaciones divinos que Dios está orquestando sobre la tierra, para que pueda verterlo en aquellos llamados a influir en sus comunidades y más allá. Si no entendemos las tendencias geopolíticas, económicas y culturales actuales, ¿cómo podemos verternos en líderes de alta capacidad y ayudarlos a liberar su potencial?")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Sin embargo, aun cuando estemos asesorando a alguien para que sea un buen padre, una buena madre o un buen trabajador (y no un "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("influencer")]), _vm._v(" de alta capacidad), somos responsables de ayudar a preparar a esa persona para lo que está sucediendo en la sociedad, así como enseñarla a discernir la voluntad de Dios para su propio futuro. En la medida en que nos preparemos y articulemos el futuro, aquellos a quienes asesoramos e influimos confiarán en nuestro juicio y nuestro conocimiento práctico acerca de la obra de Dios hoy.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Durante los años que he invertido en los hombres, he podido escuchar a Dios por muchos de ellos y advertirles de las trampas en las que estaban a punto de caer o incluso decirles lo que estaba pasando en sus vidas, aunque nunca le dijeron nada a nadie. Eso me concedió una influencia extraordinaria con ellos porque sabían que me interesaban lo suficiente como para ir a la sala del trono y que Dios me hablara por ellos y sus familias. Por supuesto, las personas no siempre escuchan a sus mentores. He advertido a la gente en el espíritu acerca de los movimientos geográficos (aunque no sabía nada al respecto de forma natural), las relaciones en las que se estaban involucrando y las empresas comerciales que estaban persiguiendo. En la mayoría de los casos, cuando alguien ya ha tomado una decisión, no escuchará a su mentor aunque sepa que Dios le habló a través de esa persona. En la mayoría de esos casos (si no en todos), la falta de atención a la palabra de advertencia del Señor resulta en un desastre.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Por eso cuido de no enseñorearme con la vida de nadie y rara vez extiendo palabras proféticas en cuanto a la dirección de la vida de alguna persona. Sin embargo, a veces Dios deja caer algo en mi espíritu por una persona, y le entrego la palabra, ya sea buena o no muy buena. En la mayoría de los casos, la persona me respeta por darle la palabra, aunque en definitiva no se alinee con ella. A menudo, cuando alguien no quiere escuchar una palabra fuerte, solo oro por ese individuo y le pido a Dios que se ocupe de su corazón, confiando en que se recuperará antes de que se produzca un daño permanente.")]), _vm._v(" "), _c('p', {
    staticClass: "p _idGenParaOverride-1"
  }, [_vm._v("El punto de todo esto es el hecho de que cuando Dios nos encomienda guiar a otros y desatar el potencial de ellos, parte de nuestra responsabilidad es ser sensibles al corazón y la mente de Dios en cuanto a esas personas. Así es como Jesús actuó con sus discípulos. El conocimiento previo que tenía de que Satanás deseaba zarandear a Pedro como el trigo, puso a Jesús delante de la curva, permitiéndole orar por Pedro. Las oraciones de Jesús restauraron a Pedro a la fe en él. Como resultado, Pedro se convirtió en el primer vocero y líder de la iglesia primitiva (Lucas 22:31-34). Cuando somos responsables de nutrir y equipar a las personas, Dios nos hará responsables de escuchar de él por ellos para que sepamos cómo, cuándo y dónde ubicarlos, así como advertirles de lo que vendrá para que puedan prepararse y escapar de las asechanzas que el enemigo les tienda.")]), _vm._v(" "), _c('p', {
    staticClass: "CHAP--",
    attrs: {
      "id": "_idParaDest-31"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor019"
    }
  }), _vm._v("Capítulo 15")]), _vm._v(" "), _c('p', {
    staticClass: "CHAP-TITLE",
    attrs: {
      "id": "_idParaDest-32"
    }
  }, [_vm._v("Comprenda la autoridad espiritual")]), _vm._v(" "), _c('p', {
    staticClass: "pf"
  }, [_c('span', {
    staticClass: "SM-CAP",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Una de las ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("cosas más sorprendentes que la gente descubre cuando lee acerca de la vida de Cristo, tal como se encuentra en los evangelios, es la forma en que Jesús sometió cada palabra, pensamiento y acción a su Padre. Esto es aun más sorprendente dado el hecho de que el propio Jesús es parte de la Deidad y, como tal, es extraordinariamente dotado, inteligente y poderoso; por lo tanto, él no parece ser la persona típica que necesite supervisión. Sin embargo, incluso un rápido vistazo a los evangelios muestra cuán completamente dependía del Padre y cuán obediente le era. Las palabras de Jesús en el Evangelio de Juan ilustran esto:")])]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("“El que cree en mí —clamó Jesús con voz fuerte—, cree no solo en mí, sino en el que me envió … Y el que me ve a mí ve al que me envió … Yo no he hablado por mi propia cuenta; el Padre que me envió me ordenó qué decir y cómo decirlo. Y sé muy bien que su mandato es vida eterna. Así que todo lo que digo es lo que el Padre me ha ordenado decir”.")]), _vm._v(" "), _c('p', {
    staticClass: "RIGHT-FLUSH",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("—Juan 12:44-45, 49-50")]), _vm._v(" "), _c('p', {
    staticClass: "paa"
  }, [_vm._v("En Filipenses 2:1-12, el apóstol Pablo usó la vida de sumisión ejemplificada por Jesús como un modelo a seguir para los creyentes en todas partes, cuando exhortó a la iglesia a que “Haya, pues, en vosotros este sentir que hubo también en Cristo Jesús” (v. 5 RVR1960). En consecuencia, si vamos a ser como Jesús y empoderar a otros, también debemos someternos a aquellos que tienen autoridad espiritual sobre nosotros. Si no podemos someternos a la autoridad espiritual, ¿cómo podemos esperar que aquellos a quienes estamos asesorando se sometan a nuestro liderazgo? Necesitamos tener una comprensión más bíblica de este tema antes de que podamos entender la necesidad de ello en nuestras propias vidas. Esto es especialmente importante en esta época en que tantos creyentes jóvenes rechazan todo vestigio de autoridad institucional, tanto espiritual como política, a causa de los abusos del pasado, así como a la naturaleza rebelde de nuestro ambiente cultural actual.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll-1"
  }, [_vm._v("La necesidad de la autoridad espiritual")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("La autoridad espiritual se estableció desde el principio de la historia humana, cuando Dios les dijo a Adán y a Eva que cuidaran el planeta (Génesis 1:26-28). El hecho de que Adán representó a toda la raza humana está claro en Romanos 5:12, que dice que cuando él pecó, todos pecaron; por eso somos —por naturaleza— objetos de la ira de Dios, como vemos en Efesios 2:1-3. A esto se le llama “liderazgo federal” y puede entenderse en la sociedad contemporánea cuando todas las personas de una nación se ven afectadas para bien o para mal por las decisiones de su líder. Por ejemplo, una nación puede ir a la guerra contra otra por causa de sus dirigentes. Por lo tanto, los jóvenes que no tienen nada que ver con esas decisiones pueden morir en el campo de batalla debido a que sus líderes decidieron ir a la guerra.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Por otra parte, Jesús habló de la autoridad delegada cuando dijo: “Quien los recibe a ustedes me recibe a mí y quien me recibe a mí recibe al que me envió” (Mateo 10:40). Por lo tanto, Jesús impartió no solo su poder sino también su autoridad delegada a sus líderes para que su reino pudiera alinearse en forma adecuada. Es por eso que les dio el poder de atar y desatar cosas en la tierra (Mateo 16:19). En lenguaje sencillo, cuando una persona es incapaz de someterse a la autoridad espiritual, no puede sujetarse al liderazgo de Jesús. La iglesia, en verdad, es la comunidad visible del Dios trino invisible. La Biblia deja muy claro que en la iglesia hay líderes. Pablo indica que los apóstoles y los profetas son el fundamento de la iglesia (Efesios 2:20). Efesios 4:13 implica que todavía necesitamos apóstoles y profetas así como todos los dones del ministerio quíntuple para madurar.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Efesios 4:7-12 enseña que la gracia de Dios a fin de ser equipado para su propósito en Cristo no le viene directamente del cielo a usted, sino a través del ministerio quíntuple. Si no está sentado bajo los cinco dones, no madurará, aun cuando sea salvo. Esto ilustra cuán importantes son sus líderes espirituales y la iglesia a la que asiste. La medida de gracia que usted recibe se basa en la medida de gracia que el líder le imparte.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Otros líderes de la iglesia son los ancianos y los diáconos. Los primeros ayudan a pastorear, llevan la carga de la iglesia y toman decisiones con el pastor principal. Juntos forman un equipo de ancianos (Números 11:16-17). Los segundos son siervos reconocidos, como vemos en Hechos 6:1-7, cuyo enfoque se dirige más a satisfacer las necesidades materiales de la familia de la iglesia. La Biblia aclara muy bien que debemos rendir cuentas a los líderes espirituales para poder crecer. El quinto mandamiento nos enseña a honrar a nuestros padres y nuestras madres, lo que implica tanto a los padres espirituales como a los biológicos que Dios le ha concedido (Deuteronomio 5:16). Hebreos 13:17 también nos enseña a someternos a nuestros líderes espirituales. La Biblia habla claramente sobre la importancia de recibir instrucciones de los líderes, no solo de Dios (Proverbios 10:8, 17; 29:1).")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Incluso el apóstol Pablo sometió su ministerio y lo que predicaba a los principales apóstoles en Jerusalén, como vemos en Gálatas 2:1-2. Además, es importante acudir a creyentes mayores y maduros para resolver conflictos, como observamos en Mateo 18:15-18. Los jóvenes necesitan el aporte de los creyentes mayores y experimentados para lidiar con ciertos problemas relacionales y desafíos en la vida, por lo que esto nos indica que se lo digamos a los ancianos. No debemos chismear, calumniar ni exponer a nuestros líderes, como se demuestra en Génesis 9:20-27, cuando uno de los hijos de Noé fue maldecido por descubrir la desnudez de su padre en vez de cubrirlo y protegerlo. Dios hizo responsable a ese hijo, a pesar de que Noé erró al emborracharse y acostarse desnudo en su habitación.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Somos llamados no solo a andar individualmente con Dios, sino también a caminar en comunidad con su pueblo, que está dirigido por los líderes espirituales que él asigna. Si no podemos sujetarnos a ellos, eso muestra que tenemos problemas para someternos a Dios. En un sentido práctico, he descubierto que cada persona necesita al menos tres áreas funcionales de cobertura o supervisión para estar completo.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll-1"
  }, [_vm._v("La necesidad de cobertura personal")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Algo que muchos creyentes, incluidos los líderes, tienen en común es la falta de una cobertura personal funcional para sus vidas y sus ministerios. Al hablar de “cobertura personal” me refiero a tener un mentor o guía espiritual individual que sirva como supervisor y que también tenga la autoridad para destituirlo o abogar por usted en un momento de falla moral o crisis. Por lo general, no uso el término "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("cubrir")]), _vm._v(", sino "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("supervisar")]), _vm._v(" o "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("vigilar")]), _vm._v(" porque son los vocablos más bíblicos. Pero por el bien del lenguaje común con mi audiencia, empleo el término "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("cubrir")]), _vm._v(" en este capítulo.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Muchos líderes, incluido yo, tienen una persona principal que sirve como cobertura, que también es parte de un grupo de líderes que sirven como su presbiterio. Es la persona que responsabiliza al líder y puede actuar como mediador en caso de que se cuestione su posición como dirigente principal, o si surge alguna necesidad de mediación entre ellos y su junta directiva o con el equipo de liderazgo.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Este tipo de cobertura personal tiene que ser relacional. Esto significa que solo funcionará si la persona mantiene un diálogo habitual con su supervisor y es sincera con respecto a sus desafíos personales. Un ministro importante que cayó en un escándalo, hace un par de años, en realidad tenía muchas relaciones cercanas e incluso oraba todas las mañanas con un buen amigo mío. El problema fue que nunca se sinceró por completo con respecto a su lado oscuro y sus inclinaciones sexuales. Por lo tanto, tener una relación personal cercana con su supervisor nunca es suficiente si no es franco y transparente con él. Es por eso que estoy usando el modificador "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("funcional")]), _vm._v(" con “cobertura personal”.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Cuando una persona no tiene una relación sincera, franca y transparente con alguien que sirve como cobertura principal, puede ser un desastre que está por suceder. Todos los creyentes, incluidos los líderes, pasan por tiempos difíciles y necesitan una persona que pueda corregirlos, alentarlos, reprenderlos o exhortarlos a continuar buscando el llamado de Dios en sus vidas. Incluso si un pastor principal nunca cae en pecado, puede ser acusado de un acto pecaminoso, y la iglesia u organización puede requerir de un supervisor externo o un presbiterio en el que pueda confiar para investigar o mediar entre ambas partes, para ayudar a discernir lo que es verdadero de lo que es falso y qué pasos estratégicos deben darse por el bien de la organización.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("¡Ay de la persona que no tiene en quien confiar, pedir consejo, apartarlo o abogar en un momento de crisis! En ese contexto, casi puede ver la cobertura como un seguro contra incendios: nunca sabe si alguna vez la necesitará, pero cuando surge una situación grave que puede amenazar su posición en la iglesia u organización, estará agradecido por haber tenido el conocimiento previo para adquirirla.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("La apremiante necesidad de cobertura de los pastores principales es una de las razones primarias por las que comencé la Coalición del Pacto de Cristo en 1999."), _c('sup', {
    staticClass: "sup _idGenCharOverride-2"
  }, [_vm._v("1")]), _vm._v(" Podemos proporcionar presbiterios personales para pastores principales en crisis, así como una invaluable tutoría tanto cobertura vertical como horizontal.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll-1"
  }, [_vm._v("La necesidad de cobertura organizacional")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Relacionado con esto, creo que cada persona necesita tener una cobertura organizacional, la cual es proporcionada —casi siempre— por los ancianos o fideicomisarios de una organización. En este sentido, siempre que se tome una decisión importante relacionada con la visión o las finanzas, cada líder principal debe procesarla primero con líderes de mucha confianza. Conozco a muchos líderes que no hicieron eso y cometieron importantes errores estratégicos o financieros que en algunos casos les costaron sus ministerios, todo porque no permitieron que su junta directiva participara en las decisiones importantes que se estaban tomando. Varios pastores principales que conozco se arriesgaron a comprar edificaciones porque “el Señor les dijo”, decidiendo por su cuenta, sin consultar a sus ancianos o fideicomisarios. Por desdicha, en la mayoría de los casos como este, los líderes cometieron grandes errores e incluso se arriesgaron a perder todos sus ministerios al hundir su trabajo en una gran deuda porque no recibieron el consejo de su equipo de líderes de confianza. Aunque creo en un líder principal que actúa como el primero entre iguales y que puede tener la última palabra en asuntos importantes, también creo en liderar desde el consenso con su equipo principal tanto como sea posible, de modo que se proteja a la organización y al líder de cometer errores que ocurren cuando se funciona de forma aislada, sin la cooperación de sus líderes principales. Además, cuando se trata de comprar un edificio en el que se convocará a toda la congregación para financiar la visión, creo que también sería prudente que el pastor principal celebrara una reunión congregacional y recibiera la bendición de toda la iglesia antes de seguir adelante con un programa de construcción a gran escala.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll-1"
  }, [_vm._v("Necesidad de la cobertura de oración")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Otro tipo de cobertura que es esencial para cada persona es la de la oración. Tengo un equipo de personas en nuestra iglesia que están comprometidas a orar diariamente por mi esposa, mi familia y por mí. Esto ha sido esencial en las últimas dos décadas con respecto a nuestra capacidad de perseverar en medio de los desafíos de la vida. Bíblicamente también encontramos que una de las partes principales de la armadura de Dios es tener a los santos perseverando en la oración unos por otros, así como Pablo solicitó oraciones de los santos para su ministerio (Efesios 6:18-20).")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Hace poco, el Señor me habló sobre la necesidad de aumentar mi apoyo en oración debido a una nueva esfera de influencia y ministerio en la que estoy entrando. Con cada nuevo nivel viene con un demonio superior. Por lo tanto, necesitamos orar y tener una intercesión acorde con el llamado de Dios a nuestras vidas. Aunque por lo general paso mucho tiempo solo buscando a Dios todas las mañanas, sé que necesito ayuda externa, lo que incluye la ayuda de aquellos que funcionan a un nivel muy alto en la intercesión a escala nacional, para protegerme a mí y a mi familia, y permitirme presionar en cada área de oportunidad que Dios abre para mí y mi equipo.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Por ejemplo, recuerdo haber leído la autobiografía del evangelista del siglo pasado, Charles Finney, y me impresionó que tuviera intercesores personales (como el Padre Nash y Abel Carly) que iban delante de él a cada pueblo y se encerraban en una habitación durante días, intercediendo y gimiendo en el Espíritu con palabras que no se pueden pronunciar en un discurso articulado, dando a luz con dolores de parto por un avivamiento. Esto se hizo a pesar de que el propio Finney solía pasar horas todos los días buscando a Dios e intercediendo por su ministerio. ¡Este hecho poco conocido es una de las principales razones por las que Finney se convirtió en el más grande avivador que los Estados Unidos y quizás el mundo haya visto jamás!")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Propongo que eso se haga realidad para cada creyente, necesitamos tener al menos tres niveles de cobertura: supervisión personal, control organizacional y una cobertura de oración que trascienda nuestra propia vida de oración. Si los líderes funcionan con este nivel de responsabilidad, sus posibilidades de fallar o caer se verán muy reducidas.")]), _vm._v(" "), _c('p', {
    staticClass: "sbttl"
  }, [_vm._v("Se necesitan tres niveles relacionales de autoridad")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("En esta línea de sumisión y supervisión, también creo que cada persona necesita tener tres niveles de autoridad espiritual operando en su vida, al igual que una familia biológica. Después de todo, el cuerpo de Cristo es una familia de familias bajo Cristo.")]), _vm._v(" "), _c('p', {
    staticClass: "sbttl"
  }, [_vm._v("Todo el mundo necesita un padre espiritual.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Al igual que con la familia biológica, todos necesitan tener una persona que funcione como padre espiritual en su vida para estar saludables. Si no hay nadie que pueda responsabilizarlo, hablarle francamente e incluso sacarlo de un ministerio, entonces ya está pisando aguas peligrosas.")]), _vm._v(" "), _c('p', {
    staticClass: "sbttl"
  }, [_vm._v("Todos necesitamos hermanos y hermanas en quienes se pueda confiar.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Similar a una familia biológica, es saludable para todas las personas tener compañeros o hermanos y hermanas como amigos y confidentes en los que pueda confiar y comunicarle cosas. Tener padres espirituales sin hermanos y hermanas puede ser muy solitario, no saludable. Tener hermanos y hermanas sin un supervisor espiritual tampoco lo es.")]), _vm._v(" "), _c('p', {
    staticClass: "sbttl"
  }, [_vm._v("Todo el mundo necesita hijos e hijas en los cuales invertir.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Por último, todos deben tener al menos una persona a la que estén asesorando y en la que inviertan, ya sea que la persona se considere un niño espiritual o no.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Cuando tenemos estos tres niveles operando al mismo tiempo, tenemos equilibrio y estamos saludables en los espiritual, lo emocional y lo material.")]), _vm._v(" "), _c('p', {
    staticClass: "p _idGenParaOverride-1"
  }, [_vm._v("Para concluir este capítulo, si tiene un mentor sin un supervisor personal, tiene derecho a preguntarle por qué carece de ello. Si es porque no quiere someterse personalmente a nadie, en mi opinión este no es el tipo de persona que debería tener como mentor. Además, si intenta asesorar a una persona que no desea una verdadera responsabilidad y supervisión, está perdiendo el tiempo porque no se puede liberar el potencial y tener éxito a largo plazo sin que se aproveche mediante las estructuras de responsabilidad establecidas.")]), _vm._v(" "), _c('p', {
    staticClass: "CHAP--",
    attrs: {
      "id": "_idParaDest-33"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor020"
    }
  }), _vm._v("Capítulo 16")]), _vm._v(" "), _c('p', {
    staticClass: "CHAP-TITLE",
    attrs: {
      "id": "_idParaDest-34"
    }
  }, [_vm._v("El poder de la oración")]), _vm._v(" "), _c('p', {
    staticClass: "pf"
  }, [_c('span', {
    staticClass: "SM-CAP",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Al examinar los ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("evangelios, veo fascinante que en ninguna parte encontremos un registro de alguno de los discípulos de Jesús preguntándole cómo predicar, sanar o expulsar demonios. Sin embargo, los vemos pidiéndole que los enseñe a orar (Lucas 11:1). Creo que la razón de eso es simple: ellos se dieron cuenta de que el secreto de su poder eran todas las horas que pasaba solo orando y estando en comunión con su Padre. Por lo general, se encontraba con Dios antes de toparse con los hombres, levantándose a orar antes de que amaneciera (Marcos 1:35-36). Por lo tanto, estaba continuamente lleno del Espíritu y de la mente de su Padre para poder hacer las obras de este.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Isaías profetizó acerca del Mesías:")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("Mi Señor y Dios me ha concedido tener una lengua instruida,")]), _vm._v(" "), _c('p', {
    staticClass: "BLOCK-2"
  }, [_vm._v("    para sostener con mi palabra al fatigado.")]), _vm._v(" "), _c('p', {
    staticClass: "BLOCK-2"
  }, [_vm._v("Todas las mañanas me despierta,")]), _vm._v(" "), _c('p', {
    staticClass: "BLOCK-2"
  }, [_vm._v("    y también me despierta el oído,")]), _vm._v(" "), _c('p', {
    staticClass: "BLOCK-2"
  }, [_vm._v("    para que escuche como los discípulos.")]), _vm._v(" "), _c('p', {
    staticClass: "BLOCK-2"
  }, [_vm._v("El Señor y Dios me ha abierto los oídos")]), _vm._v(" "), _c('p', {
    staticClass: "BLOCK-2"
  }, [_vm._v("    y no he sido rebelde")]), _vm._v(" "), _c('p', {
    staticClass: "BLOCK-2"
  }, [_vm._v("    ni me he vuelto atrás.")]), _vm._v(" "), _c('p', {
    staticClass: "RIGHT-FLUSH",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("—Isaías 50:4-5")]), _vm._v(" "), _c('p', {
    staticClass: "paa"
  }, [_vm._v("Jesús pudo desatar el potencial en los demás porque siempre estaba lleno del Espíritu Santo y siempre caminaba en el nivel más alto de su propio potencial y su poder. En consecuencia, si vamos a ayudar a liberar el potencial de los demás, debemos estar siempre llenos del Espíritu Santo (Efesios 5:18) y tener una vida de oración robusta buscando a Dios constantemente. Si no alcanzamos nuestro máximo rendimiento, ¿cómo podemos esperar capacitar a otros para que sigan su propósito divino?")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Jesús no solo oró para entender el poder y la voluntad del Padre, también llevó una vida de oración por sus discípulos. Hasta el día de hoy, como nuestro Sumo Sacerdote, ora continuamente por todos los creyentes. Como dice el autor de Hebreos: “[Él] vive siempre para interceder por [nosotros]” (7:25). No solo eso, sino que fue orando toda la noche que Jesús supo a quién elegir como sus discípulos (Marcos 3:13-15). Fue el tener una vida de oración por sus discípulos lo que le permitió adquirir la sabiduría para ministrarlos y sostenerlos. En un capítulo anterior aludimos al hecho de que Jesús pudo orar proféticamente por Pedro puesto que sabía, en el espíritu, que Satanás estaba a punto de tentarlo para que dejara de seguir a Cristo (Lucas 22:31). Se dio cuenta de que al orar continuamente por sus discípulos, podía discernir no solo la voluntad de Dios sino también los planes del maligno para frustrarlo.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Además, al mantener a sus discípulos cerca cuando oraba, Jesús pudo enseñarles cómo orar y sobrevivir durante los momentos más difíciles de sus vidas. El hecho de que impresionó a sus discípulos con el ejemplo de su vida de oración se ve claramente como una de las descripciones más profundas que escribió el autor de la Carta a los Hebreos cuando dijo acerca de Jesús: “En los días de su vida mortal, Jesús ofreció oraciones y súplicas con fuerte clamor y lágrimas al que podía salvarlo de la muerte y fue escuchado por su temor reverente” (Hebreos 5:7). Esto probablemente se remonte a su intensa oración en el huerto de Getsemaní, cuando Lucas dice acerca de él: “Pero como estaba angustiado, se puso a orar con más fervor y su sudor era como gotas de sangre que caían a tierra” (Lucas 22:44). Allí enseñó a sus discípulos a velar y orar para no caer en tentación, porque el espíritu está dispuesto, pero la carne es débil (Mateo 26:41).")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("He descubierto que la mejor manera de enseñar a una persona a orar es que ella ore con uno o que asista a poderosas reuniones de oración. ¡Verdaderamente la oración se capta más que enseñarse! Podemos ver que el ejemplo de la vida de oración de Jesús se grabó en la de los apóstoles por la forma en que condujeron a la iglesia primitiva. De la misma manera, Jesús pasó tiempo orando durante las severas pruebas de su vida; los apóstoles también oraron hasta que la casa en la que se reunían se estremeció después de haber sido amenazados (Hechos 4:24-31).")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Además, incluso antes de que naciera la iglesia, los discípulos pasaron diez días completos orando, esperando en Dios y examinando las Escrituras en el Aposento Alto, lo que dio como resultado que el Espíritu Santo cayera sobre la nueva iglesia el día de Pentecostés (Hechos 1—2). Los numerosos casos difundidos a lo largo de la narración de Hechos, que conectan la oración colectiva e individual con la propagación milagrosa del evangelio, son tan profundos que casi podemos llamarlo “el libro de la oración” en lugar del Libro de los Hechos. Por ejemplo, una de las primeras descripciones de la iglesia primitiva fue que “se dedicaban a la enseñanza de los apóstoles y a la comunión, al partimiento del pan y a la oración” (Hechos 2:42).")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Fue cuando Pedro y Juan iban al templo, durante la hora de oración, que se encontraron en la puerta con el hombre cojo que posteriormente fue sanado, lo que operó como catalizador para que muchos miles oyeran la palabra y fueran salvos (Hechos 3—4). Fue la insistencia del apóstol Pedro en que los apóstoles se dedicaran a la oración y al ministerio de la Palabra, lo que resultó en una mayor delegación del ministerio y el nacimiento del oficio de diácono, lo que resultó en la multiplicación de la Palabra del Señor y el número del aumento de discípulos (Hechos 6:1-7). Fue la oración de Cornelio, junto con el hábito de oración de Pedro, lo que les permitió a ambos recibir una palabra del Señor que extendió el evangelio a los creyentes no judíos (Hechos 10—11). Fue cuando los líderes de la iglesia en Antioquía ministraron al Señor y ayunaron que el Espíritu les habló para enviar a Bernabé y a Saulo a las misiones apostólicas, lo que se convirtió en el comienzo del gran movimiento de plantación de iglesias que difundió el cristianismo en Europa y cambió el mundo (Hechos 13:1-2).")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Cuando Pablo y Silas fueron a un lugar de oración, conocieron a una mujer llamada Lidia y la ganaron para el Señor, lo que abrió la puerta para que la iglesia comenzara en Europa occidental. También fue cuando Pablo y Silas fueron arrestados; adoraron y oraron, que el Señor envió un terremoto que abrió las puertas de la prisión, dando como resultado que el carcelero y toda su familia vinieran a Cristo. (Ver Hechos 16).")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Esta es solo una instantánea de cómo la iglesia primitiva integró el poder de la oración a su vida diaria, tanto individual como corporativamente y como iglesia. Después de leer estos relatos, junto con la devoción de Jesús a la oración, pensar que podemos desatar el potencial en los demás sin incorporar la oración es ridículo. Dar a la gente estudios bíblicos y hacer que vayan a la iglesia los domingos no es suficiente. ¡Tenemos que orar por ellos! Al orar por aquellos a quienes asesoramos, nos conectamos con su destino y podemos ayudarlos a discernir la voluntad de Dios y su llamado. Al orar por ellos, podemos discernir problemas potenciales en sus vidas, así como ataques espirituales inminentes. Pablo amonesta a la iglesia: “Oren en el Espíritu en todo momento, con peticiones y ruegos. Manténganse alertas y perseveren en oración por todos los creyente” (Efesios 6:18).")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Orar por los demás le conecta al espíritu de ellos, en vez de solo ver sus acciones. Por lo tanto, sin oración no podremos discernir los verdaderos motivos y la condición espiritual de aquellos a quienes asesoramos. Cada vez que me preocupo por una persona a la que estoy orientando, o cuando estoy a punto de tener una conversación seria con ella, primero busco al Señor para entender la situación y la persona, y él siempre me da la perspectiva adecuada. A menudo, Dios también me da una perspectiva profética para extenderla a esa persona, lo que descubre conceptos erróneos, mentiras demoníacas y engaños, así como planes presuntuosos que está haciendo y que pueden descarrilarlo a él y su destino. A menudo escribo las cosas que el Señor me muestra antes de reunirme con la persona a quien aconsejo, especialmente si me preocupa. La mayoría de las veces lo que anoto es exactamente lo que esa persona está pensando con respecto a una situación o decisión importante en su vida. Cuando le muestro lo que el Señor me revela, a menudo se sorprende y se aleja de lo que le induce a cometer el error. Como mencioné en un capítulo anterior, a veces las personas rechazan la Palabra del Señor y hacen lo que quieren de todos modos, lo que resulta en grandes errores en sus vidas.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Por supuesto, estamos llamados a orar por nuestra familia y nuestros seres queridos, no solo por aquellos a quienes estamos asesorando. En mi libro "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Travail to Prevail")]), _vm._v(" cuento numerosas historias de la manera en que estaba orando por uno de mis hijos y Dios me dio algunas advertencias proféticas sobre ciertas situaciones peligrosas que estaban por ocurrir; por lo que pude frustrarlas, en el espíritu, antes de que se manifestaran. ¡Sabía que era una verdadera advertencia de Dios porque las situaciones se desarrollaron tal como dije que lo harían, pero con buenos resultados en vez de malos! En consecuencia, con el enfoque que mi esposa, Joyce, y yo tenemos en la oración, mis hijos también han cultivado una fuerte vida de oración como resultado. Siempre oramos con la familia habitualmente como parte de nuestra rutina pero, además de eso, nuestros hijos ven y escuchan cómo oramos Joyce y yo hasta obtener la victoria en cada crisis.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("¡También han sido testigos de curaciones milagrosas y respuestas a oraciones a lo largo de los años que han sostenido a nuestra familia! Recientemente, a uno de mis hijos y su esposa les dijeron que uno de sus mellizos no estaba recibiendo suficiente sangre puesto que la placenta no funcionaba. Querían dar a luz a los gemelos a las veintisiete semanas, lo que podría ser potencialmente peligroso para su supervivencia y su salud. Mi esposa, mi hijo mayor y yo comenzamos a atender docenas de llamadas de oración durante las próximas seis semanas, y cada vez que los médicos revisaban a los bebés, les llegaba una gran cantidad de sangre. Por la gracia y la gloria de Dios, los mellizos no fueron sacados de la matriz hasta que tuvieron casi treinta y tres semanas. Cuando los sacaron, ¡encontraron que no había ni una gota de sangre en las placentas! ¡Dios sostuvo milagrosamente a estos bebés en el útero hasta el momento adecuado para que nacieran!")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Nuestros hijos han estado expuestos a esta y muchas otras historias similares, tanto en la iglesia como en nuestra familia, desde que nacieron; lo que les ha permitido comprender la importancia de tener una vida de oración y fe. El resultado es que cuando tengan sus propias familias (como ya las tienen mis dos hijos), también pasarán este estilo de vida de oración y fe a los hijos de sus hijos, y el ciclo de oración y fe continuará por generaciones.")]), _vm._v(" "), _c('p', {
    staticClass: "p _idGenParaOverride-1"
  }, [_vm._v("Recuerdo un ejemplo destacado de la huella que la oración ha tenido en mis hijos. Cierta vez, una de mis hijas acudió a verme confundida y me preguntó por qué otra familia en la iglesia (a la que pertenecía una amiga de ella) no ayunaba y oraba por sus hijos como lo hacemos nosotros. Como fue criada para vivir de esta manera, pensó que era normal que las familias cristianas oraran juntas con regularidad y creyeran en Dios por sus hijos. Cuando ella no vio que eso se vivía en otra familia creyente, ¡se sorprendió! Si vamos a liberar el potencial de la manera en que lo hizo Jesús, debemos orar y buscar al Padre de la forma en que él lo hizo, que es también la manera en que funcionaba la iglesia primitiva en el Libro de los Hechos. Si seguimos todo lo demás escrito en este libro pero fallamos en este punto, ¡también fallaremos en todos los demás puntos!")]), _vm._v(" "), _c('p', {
    staticClass: "CHAP--",
    attrs: {
      "id": "_idParaDest-35"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor021"
    }
  }), _vm._v("Capítulo 17")]), _vm._v(" "), _c('p', {
    staticClass: "CHAP-TITLE",
    attrs: {
      "id": "_idParaDest-36"
    }
  }, [_vm._v("Termine bien")]), _vm._v(" "), _c('p', {
    staticClass: "pf"
  }, [_c('span', {
    staticClass: "SM-CAP",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Este libro no ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("estaría completo a menos que incluya un capítulo sobre cómo terminar bien. Verdaderamente no es cómo usted comienza sino cómo termina en la vida lo que importa. Una de las cosas más importantes que Jesús enseñó a sus discípulos fue terminar bien, fijar la meta de terminar sus vidas caminando en el propósito divino. Él nunca intentó nutrir a hombres que se convirtieran en “estrellas fugaces”, personas que comienzan con una gran explosión pero ¡se estrellan y se queman tan rápido como suben!")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("En consecuencia, este libro no estaría completo si no incluimos algunos principios para terminar bien el recorrido de nuestra vida. Ha habido grandes libros de liderazgo sobre cómo tener una vida significativa y terminar bien. ("), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Halftime: Moving From Success to Significance,")]), _vm._v(" de Bob Buford, es uno que me viene a la mente.) En este capítulo quiero centrarme especialmente en cómo nosotros, los mentores de otros, podemos terminar bien. Después de todo, si no practicamos los principios pertinentes, ¿cómo vamos a ayudar a otros a alcanzar su potencial y caminar en su propósito y su llamado divino?")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Una de las conversaciones más tristes que he tenido fue con varios líderes mayores que me confiaron que la mayoría de los dirigentes que conocían nunca terminaban bien. Eso hizo que empezara a mirar a mi alrededor y a tener tantas conversaciones como pudiera con líderes principales sobre este tema. Cuando digo “terminar bien”, me refiero a cumplir la obra que Dios nos encomendó (Juan 17:4) para que pasemos satisfechos al otro mundo (Salmos 91:16).")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Pablo dijo con respecto a sus últimos días:")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("Yo, por mi parte, ya estoy a punto de ser ofrecido como un sacrificio, y el tiempo de mi partida ha llegado. He peleado la buena batalla, he terminado la carrera, me he mantenido en la fe. Por lo demás me espera la corona de justicia que el Señor, el Juez justo, me otorgará en aquel día; y no solo a mí, sino también a todos los que con amor hayan esperado su venida.")]), _vm._v(" "), _c('p', {
    staticClass: "RIGHT-FLUSH",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("—2 Timoteo 4:6-8")]), _vm._v(" "), _c('p', {
    staticClass: "paa"
  }, [_vm._v("Los siguientes son algunos principios que nos permiten terminar bien.")]), _vm._v(" "), _c('p', {
    staticClass: "sbttl"
  }, [_vm._v("Deje un legado de fe, coraje e integridad.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Para terminar bien, necesitamos tener vidas de fe y valentía, sin arrepentirnos de que perdimos el propósito de Dios con nosotros porque teníamos miedo de correr riesgos y creerle a Dios. Además, necesitamos cultivar vidas de integridad sin involucrarnos en comportamientos escandalosos, que volverán a afectarnos más adelante, nublando nuestro legado."), _c('sup', {
    staticClass: "sup _idGenCharOverride-2"
  }, [_vm._v("1")])]), _vm._v(" "), _c('p', {
    staticClass: "sbttl"
  }, [_vm._v("Equipe adecuadamente a la próxima generación de líderes que Dios le envíe.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Quizá no haya nada más importante para terminar bien que apartar a las personas con potencial y volcarse en ellas para que siempre se esté reproduciendo en las que tienen capacidad de influir en muchas otras. El plan principal de Jesús era invertir en los doce apóstoles, no en las grandes multitudes que se reunían para escucharlo predicar.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Los pastores que se enfocan en predicar y reunir multitudes en vez de elegir un remanente de personas para equiparlas no terminarán bien; porque, en definitiva, usted quiere que sus discípulos estén haciendo obras más grandes que usted antes de pasar a la próxima vida. Las personas morirán insatisfechas si no ven a sus hijos espirituales sobresaliendo en la vida y el ministerio.")]), _vm._v(" "), _c('p', {
    staticClass: "sbttl"
  }, [_vm._v("Transición exitosa a través de las cuatro etapas de liderazgo en la vida.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Hay al menos cuatro etapas de liderazgo en la vida. La mayoría de las personas nunca pasan de la segunda.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("La primera etapa es ser un líder que otras personas puedan seguir. Esto implica usar sus dones para atraer multitudes, predicar el evangelio y crear una comunidad de personas que sigan a Jesús.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("La segunda etapa es desarrollar líderes que puedan reproducir otros. Por desdicha, la mayoría de los líderes apenas rascan la superficie con respecto a esta etapa porque quieren ser los que prediquen, oren, casen, entierren y visiten hospitales; necesitan sentirse necesitados. Sin embargo, aquellos que no entran en esta segunda etapa transgreden 2 Timoteo 2:2, "), _c('br'), _vm._v("que enseña que debemos concentrarnos en desarrollar a esas pocas personas que pueden enseñar a otros.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("La tercera etapa es permitir que los líderes que ha desarrollado lideren para que puedan desarrollar sus propios dirigentes mientras se enfoca en entrenar a los líderes de los líderes. Esto, generalmente, sucede una vez que un líder tiene cuarenta o cincuenta años, después de convertirse en un veterano con más de dos décadas de experiencia en liderazgo. ¡Cada etapa puede tomar casi una década para moverse!")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("La cuarta y última etapa, durante las últimas dos o tres décadas de la vida, es concentrarse en ser mentor de líderes que supervisan redes, movimientos y líderes que supervisan líderes de líderes. Muy pocos llegan a esta última etapa. También puede ser cierto que solo unos pocos líderes son llamados a alcanzar esta cuarta etapa de liderazgo. Los llamados a hacer la transición a esta etapa no estarán satisfechos en sus últimos días sobre la tierra si no han caminado en este nivel. Lo que puede considerarse exitoso para algunos líderes puede no serlo para otros llamados a niveles más altos de liderazgo.")]), _vm._v(" "), _c('p', {
    staticClass: "sbttl"
  }, [_vm._v("Rodéese de hijos e hijas espirituales que tengan su ADN.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("En definitiva, las multitudes van y vienen, pero aquellos a quienes ha nutrido como hijos e hijas espirituales siempre estarán dedicados a usted. Quizás el mayor arrepentimiento de algunos creyentes es que no criaron adecuadamente a los hijos que Dios les dio, lo que resultó en que no tuvieran hijos espirituales en sus últimos años.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Algunos cristianos mayores incluso han dicho que su principal arrepentimiento fue no pasar más tiempo con personas más jóvenes, porque cuando llegaron a los ochenta, la mayoría —si no todos— de sus compañeros estaban muertos, y se quedaron solos sin verdaderos amigos. Para terminar bien, necesitamos desarrollar y asesorar a jóvenes que llevarán nuestro ADN a la próxima generación.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Escriba adecuadamente en un diario las principales lecciones de vida que ha aprendido, para transmitirlas a los demás.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Quizás una de las cosas que los creyentes pueden hacer para maximizar el impacto que tendrán en el futuro es escribir en un diario sus experiencias para que los futuros líderes puedan aprender de ellas. Por ejemplo, la autobiografía de Charles Finney, los diarios de John Wesley y David Brainerd, los escritos de Jonathan Edwards y otros me han ayudado mucho en mi desarrollo personal. No sé dónde estaría hoy si no tuviera los escritos que documentan sus vidas. Quizás hayan tenido más influencia a través de lo que documentaron para las generaciones futuras que cuando estaban vivos.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Creo que para terminar bien, necesitamos al menos documentar las principales lecciones que hemos aprendido. Muchos también pueden ser llamados a escribir al menos un libro que enseñe su mensaje de vida. Dedicar de cinco a diez minutos al día para escribir en un diario las lecciones aprendidas o las cosas que Dios le habló a su alma puede ser una fuerza poderosa para el bien de sus hijos biológicos y espirituales, quienes clamarán por sus escritos después de que pase al otro mundo.")]), _vm._v(" "), _c('p', {
    staticClass: "sbttl"
  }, [_vm._v("Ame a su cónyuge e hijos biológicos.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Uno de los mayores pesares de los líderes es haber perdido a sus familias ante el mundo porque los descuidaron debido a la enormidad del trabajo que tenían que hacer. Será más fácil terminar bien sabiendo que amamos hasta el extremo a nuestros cónyuges e hijos, que vivimos sacrificialmente por ellos y que nos esforzamos por conducirlos por el camino del reino de Dios.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("¿De qué sirve si ganamos el mundo entero pero perdemos a nuestros hijos para el mundo? No quiero que mis hijos me maldigan junto a mi tumba o se nieguen a ir a mi funeral porque les dejé un sabor amargo a Dios, a la iglesia y a mí mismo, y porque viví hipócritamente fingiendo amor a Dios y a las personas en público mientras los descuidaba a ellos en privado.")]), _vm._v(" "), _c('p', {
    staticClass: "sbttl"
  }, [_vm._v("No guarde rencores.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Para terminar bien, necesitamos hacer borrón y cuenta nueva en nuestros corazones respecto de aquellos con quienes hemos trabajado. Necesitamos tener cuentas breves con los demás y caminar en los principios de Mateo 18:15-17 para que, si tenemos algo en contra de nuestro hermano o hermana, inmediatamente le hablemos e intentemos resolverlo en vez de hablar sobre esa persona y guardar rencor en nuestros corazones.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Los creyentes que no caminan en la luz con otros tendrán asuntos sin resolver que pueden resultar en amargura. No podemos andar con amargura y resentimiento, culpando a otras personas por nuestra falta de éxito o satisfacción en la vida.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("También debemos asegurarnos de no permitir que otras personas controlen nuestras emociones con sus acciones. A pesar de lo que los demás puedan decirnos y hacernos, necesitamos perdonarlos y tener un corazón limpio y puro ante Dios para que podamos pasar a la gloria en paz. Las personas amargadas, por lo general, no terminan bien; ¡terminan enojados e insatisfechos!")]), _vm._v(" "), _c('p', {
    staticClass: "sbttl"
  }, [_vm._v("Dirija a todos hacia a Jesús y no a usted mismo.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Por último, terminar bien depende —en definitiva— de si vivimos para glorificarnos y atraer la atención hacia nosotros o hacia Jesús. Lo mejor que alguien pueda decir sobre nosotros en nuestro funeral será que amamos a Dios y que hicimos que otros amaran a Dios. ¡Más importante que ser conocidos por nuestra predicación, grandes organizaciones, libros o logros es que inspiramos a nuestras familias biológicas, nuestras iglesias y nuestra generación a amar y conocer a Dios apasionadamente!")]), _vm._v(" "), _c('p', {
    staticClass: "p _idGenParaOverride-1"
  }, [_vm._v("Hay muchas más cosas que se pueden escribir sobre terminar bien. Estas son solo algunas de las ideas que he presentado basadas en mi experiencia limitada y mi perspectiva estrecha. ¡Que Dios nos ayude a todos a terminar bien!")]), _vm._v(" "), _c('p', {
    staticClass: "CHAP--",
    attrs: {
      "id": "_idParaDest-37"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor022"
    }
  }), _vm._v("Capítulo 18")]), _vm._v(" "), _c('p', {
    staticClass: "CHAP-TITLE",
    attrs: {
      "id": "_idParaDest-38"
    }
  }, [_vm._v("Preguntas transformadoras que debe hacerse")]), _vm._v(" "), _c('p', {
    staticClass: "CHAP-SUBTITLE",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("(Tanto para el mentor como para el aprendiz)")]), _vm._v(" "), _c('p', {
    staticClass: "pf"
  }, [_c('span', {
    staticClass: "SM-CAP",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Al comenzar a ")]), _vm._v("cerrar este libro, es mejor que se haga una serie de preguntas que puedan ayudarle a descubrir los problemas que deben abordarse. Sin preguntas transformadoras con las cuales trabajar, algo que altere radicalmente su vida, carecerá de autoconciencia y no tendrá pasos prácticos para aplicar los principios de Jesús que aprendió en este libro.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Por supuesto, las siguientes preguntas son importantes tanto para el mentor como para el aprendiz, si vamos a ser conscientes de nosotros mismos y capaces de liberar el potencial de los demás.")]), _vm._v(" "), _c('p', {
    staticClass: "sbttl"
  }, [_vm._v("¿Estoy involucrado en una actividad sin propósito?")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("A veces cometemos el error de pensar que mucha actividad es igual a productividad. Otras veces, las personas más ocupadas pueden ser las menos productivas porque se concentran en las cosas triviales de la vida en vez de en las más importantes. Todos tenemos que discernir entre las "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("cosas buenas")]), _vm._v(" y "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("las cosas que Dios")]), _vm._v(" debe hacer.")]), _vm._v(" "), _c('p', {
    staticClass: "sbttl"
  }, [_vm._v("¿Valoro los programas más que las personas que me rodean? (una pregunta para un pastor principal)")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("A menudo, los líderes tienen una mentalidad tan institucional que concentran la mayor parte de su energía en desarrollar programas en vez de invertir en el desarrollo de las personas que los rodean. Hablando en términos bíblicos, Jesús no construyó una gran organización. Formó un gran equipo de liderazgo que al fin crearía el mayor movimiento que el mundo jamás haya visto.")]), _vm._v(" "), _c('p', {
    staticClass: "sbttl"
  }, [_vm._v("¿Estoy buscando a Dios de acuerdo con el llamado y la asignación divina mi vida?")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Cuanto más influyente sea, más oportunidades se le presentarán que pueden desplazar a Dios de su mundo. ¡Nunca debemos estar demasiado ocupados para orar! Dios solo puede confiarnos una verdadera influencia basada en nuestra comprensión de sus caminos y el conocimiento íntimo de su persona.")]), _vm._v(" "), _c('p', {
    staticClass: "sbttl"
  }, [_vm._v("¿Estoy enfocado únicamente en el mundo exterior —con metas, objetivos y logros— o también estoy prestando atención a mi hombre interior con respecto a mi llamado a crecer en amor, humildad y vivir para la gloria de Dios?")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Dado que la mayoría de la gente desea tener el control siempre, es fácil para ellos vivir obsesionados con los objetivos y los logros como medida para apreciar su valor. La Biblia nos enseña claramente, en 1 Corintios 13, que la búsqueda más grande a tener es la del amor, lo cual supone madurez espiritual y emocional. Esto se logra con solo prestar más atención a nuestros motivos y salud emocional —de los cuales surge la vitalidad espiritual— que a los meros logros y objetivos.")]), _vm._v(" "), _c('p', {
    staticClass: "sbttl"
  }, [_vm._v("¿Estoy invirtiendo suficiente tiempo en las relaciones clave que Dios me ha dado?")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Jesús dijo en Juan 17:12, que de todas las personas que el Padre le dio, no perdió a ninguna. Jesús siempre enfocó la mayor parte de su atención en los doce apóstoles que el Padre le dio para discipularlos.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Para maximizar nuestro propósito, debemos invertir la cantidad adecuada de tiempo en nuestros cónyuges, hijos biológicos, hijos espirituales y personas clave con las que Dios nos ha llamado a construir su reino.")]), _vm._v(" "), _c('p', {
    staticClass: "sbttl"
  }, [_vm._v("¿Reconozco la etapa de la vida en la que me encuentro actualmente?")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Todo el mundo está en una etapa diferente de la vida, aproximadamente, cada veinte años. A menudo, los líderes de setenta y ochenta años todavía están tratando de lograr cosas que los de veinte y treinta años deberían estar haciendo. Los que tienen entre veinte y cincuenta años se enfocan en el éxito, pero los que están en sus últimos años deben enfocarse en la importancia que proviene principalmente de ser mentores de personas más jóvenes.")]), _vm._v(" "), _c('p', {
    staticClass: "sbttl"
  }, [_vm._v("¿Estoy cultivando continuamente los patrones de hábitos necesarios para lograr la máxima eficiencia?")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Nuestro destino está determinado por los patrones de hábitos que hemos cultivado a lo largo de nuestra vida. Tenemos que preguntarnos constantemente si nos estamos enfocando en desarrollar los hábitos conectados con nuestro propósito final en la vida. A menudo, las personas dedican más tiempo a los pasatiempos que les apasionan que a desarrollar los hábitos necesarios para cumplir su destino.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Por ejemplo, puede que le encante jugar al golf, pero si pasa horas todos los días cultivando su juego en vez de hacer lo que debe hacer, entonces está poniendo algo que es simplemente un pasatiempo antes que su propósito en la vida.")]), _vm._v(" "), _c('p', {
    staticClass: "sbttl"
  }, [_vm._v("¿Me preocupo por la salud de mi espíritu, alma y cuerpo?")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("A menudo, los creyentes descuidan un área importante de sus vidas porque se concentran únicamente en otra. He visto a muchos cristianos descuidar su salud con malos hábitos alimenticios, falta de sueño o de ejercicio. Sus consiguientes problemas de salud limitan su capacidad para liberar su potencial o resultan en su muerte prematura. Dios quiere que prestemos la misma atención al desarrollo de buenos hábitos relacionados con nuestra vida espiritual, salud emocional y salud física. Descuidar solo una de esas áreas limitará en gran medida su capacidad para cumplir el propósito de Dios en su vida (1 Tesalonicenses 5:23).")]), _vm._v(" "), _c('p', {
    staticClass: "sbttl"
  }, [_vm._v("¿Soy un buen administrador de mi tiempo, dinero y los dones y talentos que me han sido dados?")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Dios nos ha dado a cada uno de nosotros una medida de dones, talentos y habilidades. Todos seremos juzgados como mayordomos de esos dones que Dios nos ha confiado. A quien mucho se le da, mucho más se le exigirá en el día del juicio. ¡Demasiados cristianos permiten que los grandes dones y talentos que tienen permanezcan dormidos! Sea lo que sea que Dios le esté dando, usted es responsable de desarrollarlo y maximizarlo para su gloria.")]), _vm._v(" "), _c('p', {
    staticClass: "sbttl"
  }, [_vm._v("¿Estoy rodeándome de las personas que pueden llevarme al próximo nivel del propósito de Dios?")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Por lo general, puedo predecir la trayectoria de una persona comprobando a los que tiene más cerca. Los que andan con gente amargada se volverán amargados. Los que andan con gente perezosa se volverán perezosos. Aquellos que se juntan con personas de alto rendimiento, tendrán una mejor oportunidad de maximizar sus habilidades. Lo más importante es rodearse de los mentores y amigos adecuados que lo inspirarán a pasar al siguiente nivel en la vida. Sus confidentes más cercanos deben ser aquellos que invoquen al Señor con un corazón puro y busquen primero su reino y su justicia.")]), _vm._v(" "), _c('p', {
    staticClass: "p _idGenParaOverride-1"
  }, [_vm._v("Para terminar, cada mentor necesita otro par que lo ayude a liberar todo su potencial. Mi oración por todos los que leen este libro es que encuentren un mentor poco común que los ayude a liberar la plenitud de su propósito en la vida, que es llegar a ser como Jesús. Mi oración también es que así como recibe gratuitamente del Señor, también dé gratuitamente a otros para que ellos también puedan caminar en la plenitud de su propósito.")]), _vm._v(" "), _c('p', {
    staticClass: "CHAP--",
    attrs: {
      "id": "_idParaDest-39"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor023"
    }
  }), _vm._v("Apéndice")]), _vm._v(" "), _c('p', {
    staticClass: "CHAP-TITLE",
    attrs: {
      "id": "_idParaDest-40"
    }
  }, [_vm._v("Maneras efectivas de ayudar a los seguidores maduros de Cristo")]), _vm._v(" "), _c('p', {
    staticClass: "pf"
  }, [_c('span', {
    staticClass: "SM-CAP",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Para entrenar a ")]), _vm._v("las personas de la manera en que lo hizo Jesús, necesitamos entender el hecho de que él nunca habilitó ni autorizó a otros que se sentían cómodos en su pecado o en sus malas actitudes. Es decir, fue duro con sus discípulos cuando necesitaba serlo y los corrigió cuando necesitaban corrección. Los mentores deben estar dispuestos a brindar una crítica constructiva a aquellos en quienes están invirtiendo o perderán el papel que Dios les ha dado para ayudar a formar a esas personas en particular. Los mentores que temen la confrontación piadosa o se niegan a corregir a aquellos a quienes están asesorando serán culpables de ayudar a perpetuar patrones de hábitos dañinos en aquellas personas que Dios les ha confiado. Estos son mentores que desean complacer a las personas más que ayudarlas. Esta es una tendencia contra la cual habló el apóstol Pablo (1 Tesalonicenses 2:4).")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Después de más de cuarenta años de enseñar y guiar a otros, he llegado a la conclusión de que hay dos clases de hacedores de discípulos o mentores en el cuerpo de Cristo: los facilitadores y los que discipulan. En la siguiente sección voy a contrastar los facilitadores y los verdaderos hacedores de discípulos para que pueda discernir en qué categoría encaja usted. Si está en la de los facilitadores, mi oración es que después de leer esta sección, se aleje de este estilo de liderazgo y vaya a un verdadero discipulado bíblico. Dado que gran parte del discipulado ocurre en el contexto de grupos pequeños en una iglesia local, he elaborado estos contrastes para que se ajusten a la dinámica de los grupos pequeños. Sin embargo, se pueden aplicar en un entorno de uno a uno, así como en otros ambientes.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll-1"
  }, [_vm._v("Características de un facilitador")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Los facilitadores adaptan su mensaje y enfoque al ministerio en función del nivel de compromiso de su grupo en vez de sostener las normas bíblicas. Por lo tanto, su objetivo es mantener a las personas felices y no incomodar a nadie. El desafío con este enfoque es el hecho de que son los mentores, no los aprendices, quienes deben determinar los estándares y el contenido de las enseñanzas (contenido que siempre se ajusta a las Escrituras).")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("¿Puede imaginarse lo que hubiera sucedido si el Señor Jesús hubiera basado el estándar de sus enseñanzas en el sistema de valores de aquellos a quienes estaba enseñando? Este punto es aún más importante hoy, ya que estamos en medio de un declive cultural y moral y, a menudo, los miembros de la iglesia adoptan valores y puntos de vista que contradicen la Palabra de Dios en vez de ajustarse a ella. Por supuesto, todo mentor, como Jesús, debe usar un lenguaje y ejemplos familiares para aquellos a quienes está enseñando para que les resulte más fácil asimilar y comprender. Cuando Jesús estaba con los que estaban familiarizados con una cultura agraria, hablaba de sembrar semillas, ovejas perdidas y ser un Buen Pastor. Cuando estuvo con la mujer junto al pozo, le habló del agua viva y demás. En consecuencia, un buen mentor debe utilizar el lenguaje de la cultura para hacer un punto sin comprometer los estándares y valores bíblicos. Incluso cuando Jesús estaba comiendo y bebiendo con los pecadores, nunca transigió con su mensaje y su esencia al rebajarse al nivel de comportamiento de ellos. Él fue un constructor de puentes entre los pecadores y el Padre para atraer a la gente a Dios. Siempre fue el “arreglista de la mesa”, no lo opuesto.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Los facilitadores rara vez desafían a aquellos a quienes asesoran, aun cuando han sido salvos por mucho tiempo y no se adhieren a los principios fundamentales de asistir a la iglesia, compartir su fe, diezmar, dar ofrendas, llevar vidas santas y buscar primero el reino de Dios. He conocido líderes de grupos pequeños y a los llamados mentores que nunca marcan la diferencia con respecto al comportamiento y las metas de los aprendices. Por supuesto, al final, creo que cada persona tiene que elegir el tipo de vida que está tratando de llevar. Sin embargo, independientemente de quién los esté asesorando, he visto a algunas personas que son efectivas en cuanto a dar forma y motivar las vidas de las que están asesorando y otras que solo brindan un buen compañerismo sin desafiar el "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("status quo")]), _vm._v(". Los buenos mentores, en la mayoría de los casos, tendrán un impacto positivo en la vida y trayectoria de aquellos a quienes asesoran.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Los facilitadores rara vez integran el ministerio y la visión de su congregación local, sino que potencian el individualismo irresponsable. Los habilitadores tienden a señalarse a sí mismos más que a la visión de la iglesia local. Esto se debe a que lo que más les motiva es conseguir el cariño y el afecto de las personas. En consecuencia, tanto el mentor como el aprendiz o el grupo pequeño desarrollan un vínculo emocional carnal que se vuelve codependiente. El resultado es que el grupo pequeño o los aprendices se comprometen más con su mentor que con la visión de la iglesia y con Jesús. Se convierten en islas en sí mismos, incluso en el contexto de servir en un ministerio de la iglesia.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Las dinámicas codependientes de mentor-asesorado dan como resultado que el primero atraiga discípulos tras sí mismo en vez de integrar su ministerio con la visión de la iglesia local. Por supuesto, cuando hay más de una visión en una iglesia, hay división y los problemas no se quedan atrás.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Otro rasgo de los facilitadores es que constantemente ponen excusas para aquellos a quienes están ministrando cuando están operando fuera de la voluntad de Dios; por ejemplo, están demasiado ocupados para asistir a la iglesia los domingos; el diezmo no es importante porque Dios solo quiere sus corazones primero; etcétera. A decir verdad, siempre habrá una manera de justificar la desobediencia a Dios. ¿Cuándo fue fácil eso para Jesús y los apóstoles originales, o para cualquiera de nosotros? No, aquellos a quienes asesoramos a veces caen en el engaño y la desobediencia a Cristo, y siempre intentan esconderse detrás de buenas excusas y circunstancias difíciles.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Uno de los trabajos principales de un mentor semejante a Cristo es descubrir las razones fundamentales detrás de esas “buenas excusas” y desafiar a los aprendices a servir a Dios incluso en medio de pruebas y dificultades. Por eso el apóstol Pablo le dijo a Timoteo: “Participa en las aflicciones como buen soldado de Cristo Jesús” (2 Timoteo 2:3). Un mentor semejante a Cristo enseñará a los seguidores que Dios permite las dificultades para probar la fe de los creyentes y para ver si realmente quieren servirle a pesar de sus muchos obstáculos y desafíos (Santiago 1:2-4).")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Los facilitadores no solo se identificarán con las pobres excusas de sus aprendices, sino que también se solidarizarán con ellos y afirmarán muchas decisiones perjudiciales para su fe y su llamado. Por lo tanto, debido a que esos habilitadores, quizás sin querer, están reforzando el estilo de vida desobediente de sus aprendices, ya sea por su propia falta de convicción o pasión en estas áreas oscuras o porque el deseo y la necesidad de gustarles supera su motivación para estar en desacuerdo, no confrontan ni ayudan a conformar a los aprendices a la imagen de Cristo. Por supuesto, la confrontación siempre debe hacerse con amor, gracia y misericordia y, sin embargo, tiene que hacerse, o los aprendices se sentirán empoderados en su desobediencia en vez de condenados.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Por último, los facilitadores simpatizan en lugar de empatizar con los aprendices cuando se quejan de la autoridad espiritual y el liderazgo. Este es quizás el rasgo más destructivo de un facilitador. Esto se debe a que han traicionado la confianza que les han dado los líderes espirituales de una iglesia al albergar acusaciones o quejas sobre la autoridad espiritual en su congregación. Todo el mundo sabe que es muy fácil criticar el liderazgo, ya sea político o eclesiástico, cuando no se es la persona responsable de dirigir el barco. Todos podemos dudar de los líderes, criticar sus enseñanzas, su estilo de liderazgo o su interacción con las personas con las que están en conflicto. Los mentores que permiten este tipo de comportamiento funcionan como Absalón, el hijo de David que robó los corazones del pueblo de Israel antes de que se rebelaran contra su rey (2 Samuel 15).")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Es el papel de los mentores entender cómo representar correctamente la autoridad espiritual de una iglesia e indicar a los aprendices lo que dice Mateo 18:15-17 si creen que un líder espiritual los ha agraviado. No promover la transparencia bíblica (1 Juan 1:5-7) con los aprendices es participar voluntariamente en acciones divisivas que pueden perjudicar tanto al aprendiz como a la iglesia.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll-1"
  }, [_vm._v("Rasgos bíblicos de un mentor semejante a Cristo")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Los mentores semejantes a Cristo deben dirigir a las personas a Jesús, no a sí mismos. El objetivo principal de todos los mentores bíblicos es llevar a las personas al lugar correcto con los propósitos de Dios, no que amen a su mentor y estén de acuerdo con esa persona en todo. A veces esto significa que el mentor tiene que sostener conversaciones difíciles con el aprendiz sobre su falta de compromiso con Dios y con las normas bíblicas.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Aun cuando los facilitadores evitarán a toda costa las confrontaciones, los mentores semejantes a Cristo vencen la incomodidad de tener discusiones difíciles por el bien del alma del aprendiz. En consecuencia, los mentores semejantes a Cristo nunca se abstienen intencionadamente de presentar todo el consejo de Dios. Siempre enseñan cosas culturalmente embarazosas, como tener un estilo de vida sexualmente puro, mantener el día del Señor primero en lugar de eventos familiares (relacionados con la participación de la congregación del Señor todos los domingos), y dar diezmos y ofrendas para apoyar la obra de Dios, por nombrar algunos temas típicos.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Los mentores semejantes a Cristo también oran continuamente por su iglesia, su liderazgo espiritual y por la visión de su iglesia en sus reuniones de grupo para que todos los cercanos a ellos estén inextricablemente conectados con la vida y la visión de su iglesia. Además, ocasionalmente (cuando los consideran listos) alientan a los aprendices a que se ofrezcan como voluntarios para servir en el ministerio de la iglesia a fin de que aprendan a usar sus dones y talentos para el Señor.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("También desafían y entrenan a los aprendices en cuanto a practicar una vida devocional privada con el Señor y una vida devocional con su familia. Enseñan, modelan y exhortan a los aprendices a caminar en el perdón y construir relaciones de pacto duraderas con su familia inmediata y la familia de la iglesia (no basadas en una existencia egocéntrica que promueva el “yo, mí, mi”) entrenándolos para seguir poniendo a los demás antes que a sí mismos, tal como lo hizo Jesús, como dice en Filipenses 2:1-8. En última instancia, los mentores semejantes a Cristo capacitan a otros para que se reproduzcan ganando personas para el reino y haciendo discípulos en lugar de simplemente aferrarse al Señor en modo de supervivencia con el objetivo de tener paz en sus vidas, satisfacer sus necesidades y llegar al cielo, como hacen muchos cristianos.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("El objetivo de un mentor semejante a Cristo es, en definitiva, alimentar a los aprendices con carne, no con leche, como lo ordena Pablo en 1 Corintios 3:1-3 y Hebreos 5:12. A pesar de pasajes como Hebreos 6:1-4, ¡algunos de nosotros todavía estamos enseñando a los que han sido salvos durante años como si fueran nuevos cristianos! Finalmente, cuando se trata de establecer convenios y hacer discípulos, somos mayordomos de Cristo y de su evangelio, ¡la responsabilidad más privilegiada y más terrible del mundo! El llamado de la iglesia no es tener un club social no confrontativo como cualquier bar, sino ¡tener un ejército social contracultural de discípulos! Somos llamados a estar al frente de la oración, el ayuno, la evangelización, el discipulado y la transformación social. Lamentablemente, gran parte del cuerpo de Cristo ha estado en la primera línea para satisfacer las necesidades y los deseos que esta cultura obsesionada con el consumo impone a la población. ¡Nuestro llamado no es hacer felices a todos sino exhortarlos a tener un propósito! Aunque somos llamados a ministrar a las necesidades emocionales de las personas, tenemos que hacerlo en los términos de discipulado y compromiso con Dios, no en términos humanistas y egocéntricos que no tienen un objetivo final excepto la autopreservación y el placer.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Es importante que aquellos a quienes asesoramos nos amen. Sin embargo, no siempre les agradaremos en el proceso. Por lo tanto, es más importante agradar a Dios que a los hombres, como dijo Pablo en sus epístolas. Dios está con nosotros, y su Espíritu nos dará poder si somos sus testigos y no testigos de nosotros mismos y de nuestros propios deseos (Hechos 1:8). Si quiere complacer a todas las personas, ¡conviértase en animador, no en líder!")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("En retrospectiva, servir como un mentor semejante a Cristo es quizás el mayor privilegio que cualquiera de nosotros tendrá (además de la adoración) de este lado del cielo. Necesitamos calcular el costo y comprender los requisitos extremadamente grandes de modelar el liderazgo para otros antes de comenzar esta tarea. Debemos estudiar las Escrituras y ver cómo líderes como Moisés, Samuel y David en el Antiguo Testamento, y Jesús y Pablo en el Nuevo Testamento procesaron y maduraron a los creyentes para que podamos seguir sus ejemplos. Necesitamos estudiar pasajes clave relacionados con el liderazgo que puedan servir de guía para nuestras propias vidas y ministerio como mentores."), _c('sup', {
    staticClass: "sup _idGenCharOverride-2"
  }, [_vm._v("1")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Por último, aunque Pablo enseña que los cinco dones del ministerio —apóstol, profeta, pastor, maestro y evangelista—, mencionados en Efesios 4:11, son principalmente ministerios llamados a equipar a los creyentes (v. 12), las Escrituras aclaran que Dios espera que todos los creyentes se reproduzcan y hagan discípulos independientemente de la tarea que tengan en el reino de Dios (Mateo 28:19-20). Todos los creyentes son llamados a estar equipados en la iglesia para que puedan hacer discípulos en el lugar de trabajo además de discipular a sus familias biológicas. Principalmente estamos llamados a enseñar a otros mientras vivimos con ellos (Deuteronomio 6:6-9) porque el cristianismo no es una religión institucional sino que se basa en el camino de Jesús y sus enseñanzas (Juan 14:6). Por lo tanto, si limitamos el hacer discípulos a las reuniones organizadas de la iglesia, perderemos la oportunidad de utilizar el tiempo y el espacio que compartimos con aquellos con quienes pasamos la mayor parte del tiempo en la escuela o en el trabajo.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Todos los creyentes, hayan sido llamados a estar en el ministerio de la iglesia a tiempo completo o no, son llamados a ser sus ministros dondequiera que estén para que puedan equipar a los seguidores de Cristo en todos los sectores de la sociedad. Si cada creyente en el próximo año, simplemente, ganara a una persona y la discipulara, ¡entonces el cristianismo explotaría y duplicaría su tamaño en solo un año!")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Como apéndice de este libro relacionado con ayudar a formar y sacar lo mejor de la vida de los seguidores de Cristo, he resumido mi enseñanza sobre hacer discípulos en diez leyes, para que sea más fácil de seguir. Esto se basa en mis más de cuatro décadas de hacer discípulos, asesorar y ayudar a los creyentes a alcanzar a su destino y desarrollar su llamado divino.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll-1"
  }, [_vm._v("Diez leyes para hacer discípulos de manera efectiva")]), _vm._v(" "), _c('p', {
    staticClass: "sbttl"
  }, [_vm._v("1. Sea relacional.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Una de las mayores necesidades en el cuerpo de Cristo hoy es que los líderes espirituales se relacionen socialmente con aquellos a quienes están asesorando. No es suficiente guiar a las personas en el ambiente típico de una reunión o servicio de la iglesia. A menudo, los líderes espirituales son inaccesibles fuera del contexto del servicio de la iglesia. Descubrí que aquellos que tomo bajo mi ala crecen más rápido cuando invierto tiempo personal con ellos y me dedico a atenderlos.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Cuando los líderes espirituales solo pueden relacionarse con aquellos a quienes están asesorando en el contexto de un servicio religioso organizado, eso puede ser una señal de una disfunción social en el mentor, ya que no es natural relacionarse solo en los entornos religiosos. Por desdicha, algunos líderes son inseguros y solo se sienten cómodos con sus seguidores cuando están detrás del púlpito “bajo la unción” y están en una posición de poder sin la vulnerabilidad de la conversación abierta, el diálogo y la dinámica social impredecible.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Cuando examinamos los evangelios, vemos que pasar tiempo con Jesús fue uno de los principales componentes relacionados con su método de hacer discípulos. En Marcos 3:14 y Juan 1:38-39 vemos cómo invitó Jesús a sus seguidores a pasar tiempo con él para que pudieran ver y experimentar lo que significaba estar con él. Su predicación y su enseñanza fueron solo una parte del método que empleó para hacer discípulos. En realidad, eso solo complementaba su constante proximidad a él. Por eso Juan escribió en su primera epístola acerca de Jesús: “Lo que era desde el principio, lo que hemos oído, lo que hemos visto con nuestros ojos, lo que contemplamos y palpamos con nuestras manos acerca de la palabra de vida” ( 1 Juan 1:1).")]), _vm._v(" "), _c('p', {
    staticClass: "sbttl"
  }, [_vm._v("2. Convivir juntos.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Junto con el primer punto, debemos entender que hacer discípulos se trata realmente de integrar y entretejer vidas para que comencemos a vivir juntos, en armonía. Es decir, para realmente hacer discípulos, necesitamos hacer que aquellos a quienes estamos asesorando sean parte de nuestras vidas. Jesús no enseñaba simplemente a la gente una vez por semana en un servicio religioso; los enseñaba mientras estaba sentado con ellos en una montaña (Mateo 5:1) y mientras caminaba por los campos de trigo (Lucas 6:1). Ejemplificó la fe en la forma en que respondió a una situación que amenazaba la vida (Mateo 8:23-27). Enseñó cómo manejar el fracaso del ministerio por cómo respondió cuando sus líderes fallaron en liberar a un niño de la opresión demoníaca (Marcos 9:14-23), cómo actuó en medio de la traición del liderazgo (Lucas 22:20-34), y cómo actuó cuando su corazón estaba extremadamente cargado por la tristeza (Lucas 22:39-46). Al examinar la vida de Jesús, vemos que quizás su forma más eficaz de hacer madurar a sus seguidores fue simplemente permitiéndoles convivir con él.")]), _vm._v(" "), _c('p', {
    staticClass: "sbttl"
  }, [_vm._v("3. Estar comprometido con el éxito de su aprendiz.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Así como Jesús lavó los pies de sus discípulos (Juan 13:1-20), nosotros estamos llamados a lavar los pies de aquellos a quienes nos dedicamos a disciplinar y orientar comprometiéndonos con su éxito. Por desdicha, la idea de algunos líderes de hacer discípulos se limita a trabajar con aquellos que les permiten alcanzar sus objetivos personales y ministeriales. Por lo tanto, cosifican a las personas y las utilizan en vez de respaldarlas y ayudarlas a alcanzar su potencial.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Descubrí que cuando me comprometo a ayudar a las personas a cumplir con su llamado, la bendición de Dios sobre mí se libera de una manera que activa todos mis dones y habilidades, lo que me lleva al ámbito del favor de Dios, en el que él a su vez envía muchos personas que me ayuden a cumplir con mi llamado y mi propósito. No solo eso, cuando las personas saben que realmente se preocupa por ellos y quiere ayudarlos a cumplir con su llamado, ellos a su vez se preocuparán por usted y le ayudarán a cumplir su visión.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Jesús dijo: “De gracia recibisteis, dad de gracia” (Mateo 10:8 RVR1960), porque hay tantos dones y bendiciones de Dios para repartir que nunca perjudicaremos nuestro propio llamado si nos comprometemos a servir al de otra persona. ¡vocación! ¡Cuanto más fielmente demos, más recibiremos de Dios porque su pozo nunca se seca! (Ver Juan 4:13-14; 7:38).")]), _vm._v(" "), _c('p', {
    staticClass: "sbttl"
  }, [_vm._v("4. No se sienta amenazado por el éxito de su aprendiz.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Quizás el mayor testimonio de nuestro éxito como mentores es cuando nuestros aprendices superan nuestro propio éxito ministerial. Jesús aludió a esto cuando dijo que sus seguidores harían obras aun mayores que las que él hizo (Juan 14:12). La huella más grande de nuestras vidas será el legado de influencia que dejemos a través de nuestros hijos e hijas después de que abandonemos este mundo.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Es lamentable que muchos líderes sean como Absalón, cuyo único legado fue erigir un monumento a sí mismo porque no tenía hijos (2 Samuel 18:18). Algunos pastores y líderes piensan que su mayor legado serán los enormes edificios que construyeron; sin embargo, el principal impacto que jamás tendremos es el depósito de la fe y la visión que inculcamos en nuestros seguidores, los que continuarán la misión de Jesús en las generaciones venideras. Es por eso que Pablo le dijo a Timoteo: “Con fe y amor en Cristo Jesús, sigue el ejemplo de la sana doctrina que de mí aprendiste. Con el poder del Espíritu Santo que vive en nosotros, cuida la buena enseñanza[a] que se te ha confiado” (2 Timoteo 1:13-14). También le dijo a Timoteo: “Lo que me has oído decir en presencia de muchos testigos, encomiéndalo a creyentes dignos de confianza, que a su vez estén capacitados para enseñar a otros” (2 Timoteo 2:2).")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("En consecuencia, el método paulino de hacer discípulos se convirtió en un ciclo interminable de discípulos que hacen discípulos que vuelven a hacer discípulos para las generaciones venideras. ¡Es por eso que la iglesia ha seguido prosperando más de dos milenios después de su creación! La mayor inversión del tiempo de Pablo fue con aquellos en los que invirtió, no en la construcción de grandes edificios, razón por la cual, justo antes de su martirio, los comentarios finales de Pablo a Timoteo incluyeron estas palabras:")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("Tú, en cambio, has seguido paso a paso mis enseñanzas, mi manera de vivir, mi propósito, mi fe, mi paciencia, mi amor, mi constancia, mis persecuciones y mis sufrimientos. Estás enterado de lo que sufrí en Antioquía, Iconio y Listra, y de las persecuciones que soporté. Y de todas ellas me libró el Señor. Así mismo serán perseguidos todos los que quieran llevar una vida piadosa en Cristo Jesús, mientras que esos malvados farsantes irán de mal en peor, engañando y siendo engañados. Pero tú permanece firme en lo que has aprendido y de lo cual estás convencido, pues sabes de quiénes lo aprendiste.")]), _vm._v(" "), _c('p', {
    staticClass: "RIGHT-FLUSH",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("—2 Timoteo 3:10-14")]), _vm._v(" "), _c('p', {
    staticClass: "paa"
  }, [_vm._v("Es obvio que la vida de Pablo fue un modelo para moldear la de innumerables discípulos, que trastornaron al mundo (Hechos 17:6), plantaron miles de iglesias e hicieron que la misión de Jesús floreciera hasta el día de hoy. Estoy seguro de que Pablo no tenía idea del tipo de influencia que haría durante los próximos miles de años, que se produjo principalmente porque preparó a aquellos a quienes asesoró para hacer obras más grandes que las que él hizo, por lo que “aunque murió, todavía habla” (Hebreos 11:4). Para finalizar este punto, Juan dijo que no tuvo mayor gozo que cuando vio a sus hijos andar en la verdad (3 Juan 4). Este es el tipo de actitud que deben tener todos los verdaderos mentores, ya que es la misma exhibida por el Señor Jesús a lo largo de su ministerio.")]), _vm._v(" "), _c('p', {
    staticClass: "sbttl"
  }, [_vm._v("5. Sea un “abridor de puertas” para su aprendiz.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Una de las cosas que me ha asombrado a lo largo de los años es cuántas personas he tomado bajo mi ala que han visto sus vidas y ministerios explotar con impacto e influencia. No puedo nombrar a todos los que conozco cuyos ministerios despegaron después de que se alinearon conmigo a través de la tutoría, y varios incluso se han convertido en nombres familiares. Esto se debe a que, cuando una persona se alinea apostólicamente, sus dones, habilidades y llamamiento se aprovechan para lograr el máximo impacto.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("A menudo noto el potencial en bruto en las personas y, al brindarles orientación, responsabilidad y estructura, pueden florecer. Además, un componente importante de lo que ocurre durante el proceso de alineación conmigo es que pueden conectarse con las personas que pueden ayudarlos a pasar al siguiente nivel en su lugar de trabajo o vocación en la iglesia. A veces les sirvo intencionalmente como “abridor de puertas” al presentarles personas que sé que pueden ayudarlos. O a veces es porque asisten a una conferencia que estoy facilitando (porque están alineados conmigo) y Dios organiza conexiones divinas para ellos porque sabe que ahora puede confiarles la influencia dado que tienen la responsabilidad y la tutoría adecuadas.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Dicho esto, uno de los roles de un buen mentor es que se convierta en un “abridor de puertas” al otorgarles a las personas “el don del acceso”, acceso que he invertido años en desarrollar capital relacional con personas influyentes y que en un instante puedo otorgar a un aprendiz en quien confío permitiéndole usar mi nombre para conectarse con esas personas. Siento una gran alegría cuando puedo conectar a aquellos a quienes asesoro con otros que pueden ayudarlos a cumplir los sueños que Dios les ha dado. Este es absolutamente uno de los roles que todo mentor debería tener.")]), _vm._v(" "), _c('p', {
    staticClass: "sbttl"
  }, [_vm._v("6. En lo referente a discipular, piense más allá de los límites.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("A lo largo de los años, a medida que mi agenda de viajes se volvió más exigente, me di cuenta de que tenía menos tiempo para dedicarme a otros en un entorno local. Para ayudar a compensar esto, comencé a pedirles a los líderes a los que estaba asesorando que me acompañaran en mis viajes, algunos de una semana o más. Descubrí que esa es una forma extraordinariamente efectiva de hacer discípulos porque combina varios elementos cruciales para moldear vidas.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Por ejemplo, pueden escuchar mi enseñanza durante un período prolongado en una conferencia (no solo durante una hora de estudio bíblico o un mensaje dominical). Pueden pasar el rato conmigo mientras viajan y compartimos comidas juntos; pueden analizar las reuniones conmigo; pueden a ayudarme a discernir lo que el Señor estaba diciendo y haciendo en medio de aquellos a quienes estaba ministrando; viven experiencias en culturas extranjeras, lo que los saca de su zona de confort; y llegan a conocer a algunos de los principales líderes y personas más interesantes del mundo, lo que agudiza aún más sus destrezas y acelera su proceso de formación espiritual.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("En consecuencia, he aprendido a pensar más allá de los límites y a adaptar la formación de discípulos a las realidades siempre cambiantes de mi vida. Si fallaba en hacer eso, entonces mi formación de discípulos habría disminuido enormemente cuando comencé a itinerar con el ministerio extra local. Descubrí que una semana viajando conmigo en el ministerio equivalía a más de seis meses de estudios bíblicos semanales y servicios habituales. En vez de abandonar el componente de hacer discípulos de mi vida debido a los viajes excesivos, de alguna manera mi tutoría se ha vuelto más efectiva porque a menudo puedo llevar a una o más personas conmigo en un viaje ministerial y ver qué tan rápido Dios puede transformar la vida de una persona. ")]), _vm._v(" "), _c('p', {
    staticClass: "sbttl"
  }, [_vm._v("7. Procesen decisiones juntos para desarrollar el pensamiento crítico.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Si todo lo que hago es dictar instrucciones a aquellos a quienes asesoro, simplemente produciré seguidores. Sin embargo, si quiero producir y multiplicar otros líderes, tengo que hacerlos parte del proceso de toma de decisiones para que puedan aprender a pensar de manera crítica, lo que a su vez les permitirá resolver problemas, tomar la iniciativa y ser innovadores en su enfoque.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Cuando tengo nuevos creyentes en los que estoy invirtiendo, me limito a observar en qué medida del proceso de toma de decisiones pueden participar hasta que desarrollemos confianza mutua y maduren como seguidores de Cristo. Sin embargo, cuanto más maduran, más trato de permitirles que participen en procesos de toma de decisiones de mayor nivel para que puedan aprender directamente la enormidad de cosas que deben considerar para tomar una decisión informada. También aprenden a operar en el contexto del asesoramiento de un equipo en vez de operar en el vacío del aislamiento. Esto es vital para desarrollar seguidores de Cristo equilibrados y maduros que a su vez se conviertan en líderes y mentores efectivos.")]), _vm._v(" "), _c('p', {
    staticClass: "sbttl"
  }, [_vm._v("8. Procesen la planificación estratégica juntos.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Además de la toma de decisiones, es importante incluir ocasionalmente a los aprendices en un proceso de planificación estratégica. Esto llevará la toma de decisiones a otro nivel y los equipará mejor con respecto a pasar de la A a la Z en todos los aspectos de sus vidas, negocios y ministerio. También es importante, como parte del proceso de formación de discípulos, enseñar a los aprendices la diferencia entre liderazgo y gestión; y cómo distinguir entre propósito, misión, metas, estrategias y tácticas; y el papel de cada uno en el proceso de planificación estratégica.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Descubrí que algunas de las personas más ungidas y dotadas que he conocido estaban limitadas en cuanto a su influencia y productividad porque no sabían cómo hacer realidad su visión. Verdaderamente, tener una visión sin la capacidad de hacerla realidad es desperdiciar creatividad, innovación y sueños. Tenemos que enseñar a los aprendices que una gran visión y unción casi nunca son suficientes sin un buen proceso administrativo que convierta de manera acertada un plan en la construcción deseada.")]), _vm._v(" "), _c('p', {
    staticClass: "sbttl"
  }, [_vm._v("9. Concédale la oportunidad de poner en práctica sus enseñanzas a su aprendiz.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Jesús siempre comenzó “a hacer y a enseñar” (Hechos 1:1). Él nunca enseñaba solamente. Por lo tanto, la verdadera tutoría implica dar a los discípulos la oportunidad de aplicar sus enseñanzas sirviendo en el contexto de la comunidad de Jesús para que pueda haber responsabilidad y mayor instrucción. (Ver este método de Jesús en Lucas 9:1-2, 10; 10:1, 17-20).")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("En el contexto de supervisar una iglesia durante varias décadas, descubrí que un seguidor de Cristo dejará de crecer un año o dos después de su conversión si la persona no se ofrece como voluntaria para servir en el contexto de la congregación. Jesús dijo que su comida era hacer la voluntad del Padre (Juan 4:34). Esto va en contra de la corriente del cristianismo contemporáneo, que a menudo enseña que nuestra “carne” es simplemente escuchar una enseñanza tras otra en lugar de aplicar lo que nos enseñaron. Incluso el apóstol Santiago dijo que la fe sin obras es muerta y que si solo oímos la Palabra sin ser hacedores de ella, nos engañamos a nosotros mismos (Santiago 2:17; 1:22).")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Para concluir este punto, si vamos a hacer discípulos como los hizo Jesús, busquemos la oportunidad para que nuestros aprendices sirvan en alguna función que sea observable, responsable, medible y orientada a objetivos concretos, de modo que podamos medir su crecimiento y maximizar su potencial para la formación espiritual y el servicio en el reino.")]), _vm._v(" "), _c('p', {
    staticClass: "sbttl"
  }, [_vm._v("10. Promueva la transparencia y aplíquela a la relación.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Por último, pero no menos importante, debemos establecer la transparencia en nuestras relaciones de tutoría para producir un entorno de confianza adecuado para el crecimiento. Descubrí que cuanto más confíen los aprendices en sus mentores, más crecerán puesto que no ocultarán sus fallas y se sentirán cómodos revelando los tratos profundos de Dios en sus almas. Cualquier cosa menos que la transparencia no es más que una experiencia religiosa basada en el desempeño que no equivaldrá al verdadero crecimiento y madurez cristianos. De hecho, según las Escrituras, las personas no pueden crecer en Cristo a menos que caminen en la luz como él está en la luz, para que puedan experimentar una verdadera comunión tanto con Dios como con su cuerpo (1 Juan 1:7).")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("He descubierto que no hay nada que desarrolle mayor confianza, lealtad y alineamiento con los discípulos que cuando comparto mis luchas y desafíos, y solicito sinceramente su apoyo y oración colectiva para que juntos podamos cumplir la voluntad de Dios y hacer avanzar su reino. Por supuesto, cuanto más espiritualmente maduro sea un aprendiz, más detalles íntimos puedo compartir y más confianza mutua podemos desarrollar. Esto, a su vez, da como resultado una sinergia asombrosa que surge de nuestra unidad, que seguirá manteniéndose unida por nuestro compromiso continuo de caminar en la transparencia. Sin este componente vital en nuestra relación, la dinámica de tutoría se verá muy obstaculizada y limitada en sus resultados.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Para terminar, mi oración es que estos diez puntos sirvan como guías útiles para acelerar el proceso de hacer discípulos con ustedes y contribuyan a la rápida expansión de la misión de Jesús en la tierra hoy.")]), _vm._v(" "), _c('p', {
    staticClass: "p _idGenParaOverride-1"
  }, [_vm._v("Que el Señor de la mies continúe produciendo mentores semejantes a Cristo a fin de equipar a los santos para la obra del ministerio.")]), _vm._v(" "), _c('p', {
    staticClass: "CHAP-TITLE",
    attrs: {
      "id": "_idParaDest-41"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor024"
    }
  }), _vm._v("Notas")]), _vm._v(" "), _c('p', {
    staticClass: "ENDNOTE-HEAD"
  }, [_vm._v("Capítulo 1:Comprenda la identidad que Dios le dio")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "ENDNOTES-1",
    attrs: {
      "lang": "en-US",
      "value": "1",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Biblia con letras azules, s.v. “Petros”, consultado el 17 de mayo de 2019, "), _c('a', {
    attrs: {
      "href": "http://www.blueletterbible.org",
      "target": "_blank"
    }
  }, [_vm._v("www.blueletterbible.org")]), _vm._v(".")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Biblia con letras azules, s.v. “petra”, consultado el 17 de mayo de 2019, "), _c('a', {
    attrs: {
      "href": "http://www.blueletterbible.org",
      "target": "_blank"
    }
  }, [_vm._v("www.blueletterbible.org")]), _vm._v(".")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Biblia con letras azules, s.v. “‘Abram”, consultado el 17 de mayo de 2019, "), _c('a', {
    attrs: {
      "href": "http://www.blueletterbible.org",
      "target": "_blank"
    }
  }, [_vm._v("www.blueletterbible.org")]), _vm._v(", s.v. “‘Abraham”, consultado el 17 de mayo de 2019, "), _c('a', {
    attrs: {
      "href": "http://www.blueletterbible.org",
      "target": "_blank"
    }
  }, [_vm._v("www.blueletterbible.org")]), _vm._v(".")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Susan Reynolds, “Cerebro feliz, vida feliz”, "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1",
    attrs: {
      "xml:lang": "es-ES"
    }
  }, [_vm._v("Psychology Today")]), _vm._v(", 2 de agosto de 2011, "), _c('a', {
    attrs: {
      "href": "http://www.psychologytoday.com",
      "target": "_blank"
    }
  }, [_vm._v("www.psychologytoday.com")]), _vm._v(".")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Reynolds, “Cerebro feliz, vida feliz”.")])]), _vm._v(" "), _c('p', {
    staticClass: "ENDNOTE-HEAD"
  }, [_vm._v("Capítulo 2: Libere su potencial")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "ENDNOTES-1",
    attrs: {
      "lang": "en-US",
      "value": "1",
      "xml:lang": "en-US"
    }
  }, [_vm._v("El libro de Kristian David Hernández, "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1",
    attrs: {
      "xml:lang": "es-ES"
    }
  }, [_vm._v("Beholding and Proclaiming")]), _vm._v(", se puede encontrar en Amazon: "), _c('a', {
    attrs: {
      "href": "http://www.amazon.com",
      "target": "_blank"
    }
  }, [_vm._v("www.amazon.com")]), _vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "ENDNOTE-HEAD"
  }, [_vm._v("Capítulo 4: Cómo entender la afirmación")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "ENDNOTES-1",
    attrs: {
      "lang": "en-US",
      "value": "1",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Shad Helmstetter, "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1",
    attrs: {
      "xml:lang": "es-ES"
    }
  }, [_vm._v("Qué decir cuando hablas contigo mismo")]), _vm._v(" (Gallery Books, 2017), pp. 26-27.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("“Brain Stem”, Center for Neuro Skills, consultado el 10 de junio de 2019, "), _c('a', {
    attrs: {
      "href": "http://www.neuroskills.com/brain-injury/brain-stem/",
      "target": "_blank"
    }
  }, [_vm._v("www.neuroskills.com/brain-injury/brain-stem/")]), _vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "ENDNOTE-HEAD"
  }, [_vm._v("Capítulo 5: Amar y ser amado")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "ENDNOTES-1",
    attrs: {
      "lang": "en-US",
      "value": "1",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Tara Parker-Pope, “How to Be Better at Stress”, "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1",
    attrs: {
      "xml:lang": "es-ES"
    }
  }, [_vm._v("New York Times")]), _vm._v(", consultado el 6 de junio de 2019, "), _c('a', {
    attrs: {
      "href": "http://www.nytimes.com",
      "target": "_blank"
    }
  }, [_vm._v("www.nytimes.com")]), _vm._v(".")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Benedict Carey, “Evidencia de que los pequeños toques significan tanto”, "), _c('span', {
    staticClass: "ITAL CharOverride-4",
    attrs: {
      "xml:lang": "es-ES"
    }
  }, [_vm._v("New York Times")]), _vm._v(", 22 de febrero de 2010, "), _c('a', {
    attrs: {
      "href": "http://www.nytimes.com",
      "target": "_blank"
    }
  }, [_vm._v("www.nytimes.com")]), _vm._v(".")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Carey, “Evidencia de que los pequeños toques significan mucho”.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Joseph Mattera, "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1",
    attrs: {
      "xml:lang": "es-ES"
    }
  }, [_vm._v("Antología de ensayos sobre liderazgo de vanguardia")]), _vm._v(" (CreateSpace, 2015), pp. 92-94. Para más información sobre los conceptos presentados, lea "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1",
    attrs: {
      "xml:lang": "es-ES"
    }
  }, [_vm._v("The Transforming Mission")]), _vm._v(" de David J. Bosch, pp. 36-39.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Mattera, "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1",
    attrs: {
      "xml:lang": "es-ES"
    }
  }, [_vm._v("Antología de ensayos sobre liderazgo de vanguardia")]), _vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "ENDNOTE-HEAD"
  }, [_vm._v("Capítulo 6: Cómo liberar el potencial de los demás")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "ENDNOTES-1",
    attrs: {
      "lang": "en-US",
      "value": "1",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Martin B. Copenhaver, "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1",
    attrs: {
      "xml:lang": "es-ES"
    }
  }, [_vm._v("Jesús es la pregunta")]), _vm._v(" (Abingdon Press).")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("F. John Reh, “El principio de Pareto o la regla 80/20”, The Balance Careers, actualizado el 22 de marzo de 2019, "), _c('a', {
    attrs: {
      "href": "http://www.thebalancecareers.com",
      "target": "_blank"
    }
  }, [_vm._v("www.thebalancecareers.com")]), _vm._v(".")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Margaret Hunter, “¿Cuándo y cómo murieron los doce apóstoles?”, Amazing Bible Timeline With World History, 29 de abril de 2013, "), _c('a', {
    attrs: {
      "href": "https://amazingbibletimeline.com",
      "target": "_blank"
    }
  }, [_vm._v("https://amazingbibletimeline.com")]), _vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "ENDNOTE-HEAD"
  }, [_vm._v("Capítulo 8: El poder del fracaso")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "ENDNOTES-1",
    attrs: {
      "lang": "en-US",
      "value": "1",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Reuben Frank, “Mensaje inspirador de Nick Foles en un mundo de redes sociales”, NBCUniversal Media, LLC, 5 de febrero de 2018, "), _c('a', {
    attrs: {
      "href": "http://www.nbcphiladelphia.com",
      "target": "_blank"
    }
  }, [_vm._v("www.nbcphiladelphia.com")]), _vm._v(".")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("“Abraham Lincoln Overcoming Failure”, consultado el 12 de junio de 2019, "), _c('a', {
    attrs: {
      "href": "http://www.championshipcoachesnetwork.com",
      "target": "_blank"
    }
  }, [_vm._v("www.championshipcoachesnetwork.com")]), _vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "ENDNOTE-HEAD"
  }, [_vm._v("Capítulo 9: El poder de delegar")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "ENDNOTES-1",
    attrs: {
      "lang": "en-US",
      "value": "1",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Centro de la Biblia, s.v. “apostelló”, consultado el 12 de junio de 2019, "), _c('a', {
    attrs: {
      "href": "https://biblehub.com/greek/649.htm",
      "target": "_blank"
    }
  }, [_vm._v("https://biblehub.com/greek/649.htm")]), _vm._v(".")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Centro de la Biblia, s.v. “apo”, consultado el 12 de junio de 2019, "), _c('a', {
    attrs: {
      "href": "https://biblehub.com/greek/575.htm",
      "target": "_blank"
    }
  }, [_vm._v("https://biblehub.com/greek/575.htm")]), _vm._v(".")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Luz de estudio, s.v. “stéll"), _c('span', {
    staticClass: "CharOverride-6"
  }, [_vm._v("ō")]), _vm._v("”, consultado el 12 de junio de 2019, "), _c('a', {
    attrs: {
      "href": "http://www.studylight.org",
      "target": "_blank"
    }
  }, [_vm._v("www.studylight.org")]), _vm._v(".")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Centro de la Biblia, s.v. “dunamis”, consultado el 12 de junio de 2019, "), _c('a', {
    attrs: {
      "href": "https://biblehub.com",
      "target": "_blank"
    }
  }, [_vm._v("https://biblehub.com")]), _vm._v(".")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Frederick William Danker y Walter Bauer, "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1",
    attrs: {
      "xml:lang": "es-ES"
    }
  }, [_vm._v("Un léxico grecoinglés del Nuevo Testamento y otra literatura cristiana primitiva")]), _vm._v(" (University of Chicago Press, 2000), p. 278.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Danker y Bauer, "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1",
    attrs: {
      "xml:lang": "es-ES"
    }
  }, [_vm._v("Un léxico grecoinglés del Nuevo Testamento y otra literatura cristiana primitiva")]), _vm._v(", s.v. “exousiano”.")])]), _vm._v(" "), _c('p', {
    staticClass: "ENDNOTE-HEAD"
  }, [_vm._v("Capítulo 10: El poder de priorizar")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "ENDNOTES-1",
    attrs: {
      "lang": "en-US",
      "value": "1",
      "xml:lang": "en-US"
    }
  }, [_vm._v("“El principio de Pareto”, Natrainner, 26 de marzo de 2018, "), _c('a', {
    attrs: {
      "href": "https://natrainner.wordpress.com",
      "target": "_blank"
    }
  }, [_vm._v("https://natrainner.wordpress.com")]), _vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "ENDNOTE-HEAD"
  }, [_vm._v("Capítulo 11: El poder de la comunidad")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "ENDNOTES-1",
    attrs: {
      "lang": "en-US",
      "value": "1",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Después de que Jerusalén fue destruida, la iglesia estuvo compuesta principalmente de creyentes gentiles que, en su intento por llegar a los de la sociedad helénica, individualizaron las Escrituras para atraer a aquellos influenciados por la filosofía griega que buscaban al hombre perfecto más que a una comunidad de fe.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("No creo que se esté refiriendo a la unidad institucional u organizativa sino a la unidad que proviene de estar en un solo corazón y una sola mente, es decir, unidad emocional y espiritual. Ver Hechos 1:14; 2:1; 2:44-46; 4:32 para un ejemplo de creyentes que se unen como un solo corazón, una sola mente y una sola alma.")])]), _vm._v(" "), _c('p', {
    staticClass: "ENDNOTE-HEAD"
  }, [_vm._v("Capítulo 13: Cómo entender la lucha")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "ENDNOTES-1",
    attrs: {
      "lang": "en-US",
      "value": "1",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Samuel Chad, "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1",
    attrs: {
      "xml:lang": "es-ES"
    }
  }, [_vm._v("Dolor de liderazgo: el aula para el crecimiento")]), _vm._v(" (Thomas Nelson, 2015).")])]), _vm._v(" "), _c('p', {
    staticClass: "ENDNOTE-HEAD"
  }, [_vm._v("Capítulo 15: Comprenda la autoridad espiritual")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "ENDNOTES-1",
    attrs: {
      "lang": "en-US",
      "value": "1",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Para obtener información sobre la Coalición del Pacto de Cristo, visite "), _c('a', {
    attrs: {
      "href": "http://www.christcovenantcoalition.org",
      "target": "_blank"
    }
  }, [_vm._v("www.christcovenantcoalition.org")]), _vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "ENDNOTE-HEAD"
  }, [_vm._v("Capítulo 17: Termine bien")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "ENDNOTES-1",
    attrs: {
      "lang": "en-US",
      "value": "1",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Por ejemplo, la pasividad de Joe Paterno con respecto a Jerry Sandusky que arruinó su legado en la Universidad Estatal de Pensilvania (Sara Ganim, “CNN Exclusive: Joe Paterno May Have Known of Earlier Jerry Sandusky Abuse Claim, Police Report Reveals”, Cable News Network, 11 de septiembre de 2017 , "), _c('a', {
    attrs: {
      "href": "http://www.cnn.com",
      "target": "_blank"
    }
  }, [_vm._v("www.cnn.com")]), _vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "ENDNOTE-HEAD"
  }, [_vm._v("Apéndice: Maneras efectivas de ayudar a los seguidores maduros de Cristo")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "ENDNOTES-1 _idGenParaOverride-1",
    attrs: {
      "lang": "en-US",
      "value": "1",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Ver Deuteronomio 31; Josué 24; 1 Samuel 12; Mateo 5-7; y Hechos 20:17-34. Estas escrituras son extraordinarias en lo referente a impartir valores de liderazgo, estándares y ejemplos para que los mentores los sigan.")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "IMAGEN-RELATIVO-AL-FLUJO-DE-TXT",
    attrs: {
      "id": "_idContainer005"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/aviso_biblias_55x85-gris.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "IMAGEN-RELATIVO-AL-FLUJO-DE-TXT",
    attrs: {
      "id": "_idContainer006"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Jonathan-Cahn.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "IMAGEN-RELATIVO-AL-FLUJO-DE-TXT",
    attrs: {
      "id": "_idContainer007"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/224.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "IMAGEN-RELATIVO-AL-FLUJO-DE-TXT",
    attrs: {
      "id": "_idContainer008"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/los_principios_de_jesus_contraCVR.jpg"
    }
  })])])])])
}]}

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(59),
  /* template */
  __webpack_require__(60),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 60 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', [_vm._v("Thank you for reading this sample. Here are other books you might like.")]), _c('div', [_c('div', {
    attrs: {
      "id": "textcafe-gallery-widget-container"
    }
  }), _vm._v(" "), _c('script', {
    attrs: {
      "type": "application/javascript"
    }
  }, [_vm._v("\n      TextCafeWidget.config({\n          'type':'related',\n          'id':'9781960436535',\n          'coverImageWidth': '30',\n          'hideDescriptions': true\n      });\n      var textCafeGalleryWidget = TextCafeWidget.widgets.galleryWidget.new({selector:'#textcafe-gallery-widget-container'});\n      textCafeGalleryWidget.render();\n    ")])])])
}]}

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["Vuetify"] = factory();
	else
		root["Vuetify"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 29);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["d"] = createSimpleFunctional;
/* harmony export (immutable) */ __webpack_exports__["e"] = createSimpleTransition;
/* harmony export (immutable) */ __webpack_exports__["b"] = createJavaScriptTransition;
/* harmony export (immutable) */ __webpack_exports__["f"] = directiveConfig;
/* harmony export (immutable) */ __webpack_exports__["a"] = addOnceEventListener;
/* harmony export (immutable) */ __webpack_exports__["g"] = getObjectValueByPath;
/* harmony export (immutable) */ __webpack_exports__["c"] = createRange;
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function createSimpleFunctional(c) {
  var el = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'div';

  return {
    functional: true,

    render: function render(h, _ref) {
      var data = _ref.data,
          children = _ref.children;

      data.staticClass = (c + ' ' + (data.staticClass || '')).trim();

      return h(el, data, children);
    }
  };
}

function createSimpleTransition(name) {
  var origin = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top center 0';
  var mode = arguments[2];

  return {
    functional: true,

    props: {
      origin: {
        type: String,
        default: origin
      }
    },

    render: function render(h, context) {
      context.data = context.data || {};
      context.data.props = { name: name };
      context.data.on = context.data.on || {};

      if (mode) context.data.props.mode = mode;

      context.data.on.beforeEnter = function (el) {
        el.style.transformOrigin = origin;
        el.style.webkitTransformOrigin = origin;
      };

      return h('transition', context.data, context.children);
    }
  };
}

function createJavaScriptTransition(name, functions) {
  var css = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var mode = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'in-out';

  return {
    functional: true,

    props: {
      css: {
        type: Boolean,
        default: css
      },
      mode: {
        type: String,
        default: mode
      }
    },

    render: function render(h, context) {
      var data = {
        props: _extends({}, context.props, {
          name: name
        }),
        on: functions
      };

      return h('transition', data, context.children);
    }
  };
}

function directiveConfig(binding) {
  var defaults = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return Object.assign({}, defaults, binding.modifiers, { value: binding.arg }, binding.value || {});
}

function addOnceEventListener(el, event, cb) {
  var once = function once() {
    cb();
    el.removeEventListener(event, once, false);
  };

  el.addEventListener(event, once, false);
}

function getObjectValueByPath(obj, path) {
  // credit: http://stackoverflow.com/questions/6491463/accessing-nested-javascript-objects-with-string-key#comment55278413_6491621
  if (!path || path.constructor !== String) return;
  path = path.replace(/\[(\w+)\]/g, '.$1'); // convert indexes to properties
  path = path.replace(/^\./, ''); // strip a leading dot
  var a = path.split('.');
  for (var i = 0, n = a.length; i < n; ++i) {
    var k = a[i];
    if (obj instanceof Object && k in obj) {
      obj = obj[k];
    } else {
      return;
    }
  }
  return obj;
}

function createRange(length) {
  return [].concat(_toConsumableArray(Array.from({ length: length }, function (v, k) {
    return k;
  })));
}

/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    dark: Boolean,
    light: Boolean
  }
});

/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isActive: !!this.value
    };
  },


  props: {
    value: {
      required: false
    }
  },

  watch: {
    value: function value(val) {
      this.isActive = !!val;
    },
    isActive: function isActive(val) {
      !!val !== this.value && this.$emit('input', val);
    }
  }
});

/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_contextualable__ = __webpack_require__(8);



/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_contextualable__["a" /* default */]],

  props: {
    disabled: Boolean,
    fa: Boolean,
    mdi: Boolean,
    large: Boolean,
    left: Boolean,
    medium: Boolean,
    right: Boolean,
    xLarge: Boolean
  },

  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        _ref$children = _ref.children,
        children = _ref$children === undefined ? [] : _ref$children;

    if (props.fa || props.mdi) console.warn('The v-icon prop \'fa\' and \'mdi\' will be deprecated in the next release. Use \'fa\' or \'mdi\' prefix in icon name instead.');
    var iconName = '';
    var iconType = 'material-icons';

    if (children.length) {
      iconName = children.pop().text;
    } else if (data.domProps && data.domProps.textContent) {
      iconName = data.domProps.textContent;
      delete data.domProps.textContent;
    } else if (data.domProps && data.domProps.innerHTML) {
      iconName = data.domProps.innerHTML;
      delete data.domProps.innerHTML;
    }

    var thirdPartyIcon = iconName.indexOf('-') > -1;
    if (thirdPartyIcon) iconType = iconName.slice(0, iconName.indexOf('-'));

    // To keep things backwards compatible for now
    iconType = props.fa ? 'fa' : props.mdi ? 'mdi' : iconType;

    data.staticClass = (iconType + ' icon ' + (data.staticClass || '')).trim();
    data.attrs = data.attrs || {};

    var classes = {
      'icon--large': props.large,
      'icon--left': props.left,
      'icon--medium': props.medium,
      'icon--right': props.right,
      'icon--x-large': props.xLarge,
      'primary--text': props.primary,
      'secondary--text': props.secondary,
      'success--text': props.success,
      'info--text': props.info,
      'warning--text': props.warning,
      'error--text': props.error,
      'theme--dark': props.dark,
      'theme--light': props.light
    };

    var iconClasses = Object.keys(classes).filter(function (k) {
      return classes[k];
    }).join(' ');
    iconClasses && (data.staticClass += ' ' + iconClasses);

    // To keep things backwards compatible for now
    if (props.fa || props.mdi) {
      var comparison = props.fa ? 'fa' : 'mdi';

      if (iconName.indexOf(' ') > -1) data.staticClass += ' ' + comparison + '-' + iconName;else data.staticClass += ' ' + comparison + '-' + iconName.split(' ').join('-');
    }

    if (thirdPartyIcon) data.staticClass += ' ' + iconName;
    if (props.disabled) data.attrs.disabled = props.disabled;
    !(thirdPartyIcon || props.fa || props.mdi) && children.push(iconName);

    return h('i', data, children);
  }
});

/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__badge__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__click_outside__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__resize__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ripple__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__scroll__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__tooltip__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__touch__ = __webpack_require__(81);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Badge", function() { return __WEBPACK_IMPORTED_MODULE_0__badge__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ClickOutside", function() { return __WEBPACK_IMPORTED_MODULE_1__click_outside__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Ripple", function() { return __WEBPACK_IMPORTED_MODULE_3__ripple__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Resize", function() { return __WEBPACK_IMPORTED_MODULE_2__resize__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Scroll", function() { return __WEBPACK_IMPORTED_MODULE_4__scroll__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Tooltip", function() { return __WEBPACK_IMPORTED_MODULE_5__tooltip__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Touch", function() { return __WEBPACK_IMPORTED_MODULE_6__touch__["a"]; });










/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_positionable__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_route_link__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_toggleable__ = __webpack_require__(2);






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-btn',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_route_link__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_positionable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_themeable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_toggleable__["a" /* default */]],

  props: {
    activeClass: {
      type: String,
      default: 'btn--active'
    },
    block: Boolean,
    fab: Boolean,
    flat: Boolean,
    icon: Boolean,
    large: Boolean,
    loading: Boolean,
    outline: Boolean,
    ripple: {
      type: [Boolean, Object],
      default: true
    },
    round: Boolean,
    small: Boolean,
    tag: {
      type: String,
      default: 'button'
    },
    type: {
      type: String,
      default: 'button'
    }
  },

  computed: {
    classes: function classes() {
      return {
        'btn': true,
        'btn--absolute': this.absolute,
        'btn--active': this.isActive,
        'btn--block': this.block,
        'btn--bottom': this.bottom,
        'btn--disabled': this.disabled,
        'btn--flat': this.flat,
        'btn--floating': this.fab,
        'btn--fixed': this.fixed,
        'btn--hover': this.hover,
        'btn--icon': this.icon,
        'btn--large': this.large,
        'btn--left': this.left,
        'btn--loader': this.loading,
        'btn--outline': this.outline,
        'btn--raised': !this.flat,
        'btn--right': this.right,
        'btn--round': this.round,
        'btn--small': this.small,
        'btn--top': this.top,
        'theme--dark': this.dark,
        'theme--light': this.light,
        'primary': this.primary && !this.outline,
        'secondary': this.secondary && !this.outline,
        'success': this.success && !this.outline,
        'info': this.info && !this.outline,
        'warning': this.warning && !this.outline,
        'error': this.error && !this.outline,
        'primary--text': this.primary && (this.outline || this.flat),
        'secondary--text': this.secondary && (this.outline || this.flat),
        'success--text': this.success && (this.outline || this.flat),
        'info--text': this.info && (this.outline || this.flat),
        'warning--text': this.warning && (this.outline || this.flat),
        'error--text': this.error && (this.outline || this.flat)
      };
    }
  },

  methods: {
    // Prevent focus to match md spec
    click: function click(e) {
      !this.fab && e.detail && this.$el.blur();

      this.$emit('click', e);
    },
    genContent: function genContent() {
      return this.$createElement('div', { 'class': 'btn__content' }, [this.$slots.default]);
    },
    genLoader: function genLoader() {
      var children = [];

      if (!this.$slots.loader) {
        children.push(this.$createElement('v-progress-circular', {
          props: {
            indeterminate: true,
            size: 26
          }
        }));
      } else {
        children.push(this.$slots.loader);
      }

      return this.$createElement('span', { 'class': 'btn__loading' }, children);
    }
  },

  render: function render(h) {
    var _generateRouteLink = this.generateRouteLink(),
        tag = _generateRouteLink.tag,
        data = _generateRouteLink.data;

    var children = [this.genContent()];

    tag === 'button' && (data.attrs.type = this.type);
    this.loading && children.push(this.genLoader());

    return h(tag, data, children);
  }
});

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VCarouselTransition */
/* unused harmony export VCarouselReverseTransition */
/* unused harmony export VTabTransition */
/* unused harmony export VTabReverseTransition */
/* unused harmony export VMenuTransition */
/* unused harmony export VFabTransition */
/* unused harmony export VDialogTransition */
/* unused harmony export VDialogBottomTransition */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return VFadeTransition; });
/* unused harmony export VScaleTransition */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return VSlideXTransition; });
/* unused harmony export VSlideXReverseTransition */
/* unused harmony export VSlideYTransition */
/* unused harmony export VSlideYReverseTransition */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return VExpandTransition; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__expand_transition__ = __webpack_require__(71);




// Component specific transitions
var VCarouselTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('carousel-transition');
var VCarouselReverseTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('carousel-reverse-transition');
var VTabTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('tab-transition');
var VTabReverseTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('tab-reverse-transition');
var VMenuTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('menu-transition');
var VFabTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('fab-transition', 'center center', 'out-in');

// Generic transitions
var VDialogTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('dialog-transition');
var VDialogBottomTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('dialog-bottom-transition');
var VFadeTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('fade-transition');
var VScaleTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('scale-transition');
var VSlideXTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('slide-x-transition');
var VSlideXReverseTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('slide-x-reverse-transition');
var VSlideYTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('slide-y-transition');
var VSlideYReverseTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('slide-y-reverse-transition');

// JavaScript transitions
var VExpandTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["b" /* createJavaScriptTransition */])('expand-transition', __WEBPACK_IMPORTED_MODULE_1__expand_transition__["a" /* default */]);

/* harmony default export */ __webpack_exports__["d"] = ({
  VCarouselTransition: VCarouselTransition,
  VCarouselReverseTransition: VCarouselReverseTransition,
  VDialogTransition: VDialogTransition,
  VDialogBottomTransition: VDialogBottomTransition,
  VFabTransition: VFabTransition,
  VFadeTransition: VFadeTransition,
  VMenuTransition: VMenuTransition,
  VScaleTransition: VScaleTransition,
  VSlideXTransition: VSlideXTransition,
  VSlideXReverseTransition: VSlideXReverseTransition,
  VSlideYTransition: VSlideYTransition,
  VSlideYReverseTransition: VSlideYReverseTransition,
  VTabReverseTransition: VTabReverseTransition,
  VTabTransition: VTabTransition,
  VExpandTransition: VExpandTransition
});

/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__themeable__ = __webpack_require__(1);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0__themeable__["a" /* default */]],

  data: function data() {
    return {
      errorBucket: [],
      focused: false,
      tabFocused: false,
      lazyValue: this.value
    };
  },


  props: {
    appendIcon: String,
    appendIconCb: Function,
    disabled: Boolean,
    error: Boolean,
    errorMessages: {
      type: [String, Array],
      default: function _default() {
        return [];
      }
    },
    hint: String,
    hideDetails: Boolean,
    label: String,
    persistentHint: Boolean,
    placeholder: String,
    prependIcon: String,
    prependIconCb: Function,
    required: Boolean,
    rules: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    tabindex: {
      default: 0
    },
    value: {
      required: false
    }
  },

  computed: {
    hasError: function hasError() {
      return this.validations.length || this.error;
    },
    inputGroupClasses: function inputGroupClasses() {
      return Object.assign({
        'input-group': true,
        'input-group--focused': this.focused,
        'input-group--dirty': this.isDirty,
        'input-group--tab-focused': this.tabFocused,
        'input-group--disabled': this.disabled,
        'input-group--error': this.hasError,
        'input-group--append-icon': this.appendIcon,
        'input-group--prepend-icon': this.prependIcon,
        'input-group--required': this.required,
        'input-group--hide-details': this.hideDetails,
        'input-group--placeholder': !!this.placeholder,
        'theme--dark': this.dark,
        'theme--light': this.light
      }, this.classes);
    },
    isDirty: function isDirty() {
      return this.inputValue;
    },
    modifiers: function modifiers() {
      var modifiers = {
        lazy: false,
        number: false,
        trim: false
      };

      if (!this.$vnode.data.directives) {
        return modifiers;
      }

      var model = this.$vnode.data.directives.find(function (i) {
        return i.name === 'model';
      });

      if (!model) {
        return modifiers;
      }

      return Object.assign(modifiers, model.modifiers);
    },
    validations: function validations() {
      return (!Array.isArray(this.errorMessages) ? [this.errorMessages] : this.errorMessages).concat(this.errorBucket);
    }
  },

  watch: {
    rules: function rules() {
      this.validate();
    }
  },

  mounted: function mounted() {
    this.validate();
  },


  methods: {
    genLabel: function genLabel() {
      return this.$createElement('label', {
        attrs: {
          for: this.$attrs.id
        }
      }, this.$slots.label || this.label);
    },
    genMessages: function genMessages() {
      var _this = this;

      var messages = [];

      if ((this.hint && this.focused || this.hint && this.persistentHint) && this.validations.length === 0) {
        messages = [this.genHint()];
      } else if (this.validations.length) {
        messages = this.validations.map(function (i) {
          return _this.genError(i);
        });
      }

      return this.$createElement('transition-group', {
        'class': 'input-group__messages',
        props: {
          tag: 'div',
          name: 'slide-y-transition'
        }
      }, messages);
    },
    genHint: function genHint() {
      return this.$createElement('div', {
        'class': 'input-group__hint',
        key: this.hint,
        domProps: { innerHTML: this.hint }
      });
    },
    genError: function genError(error) {
      return this.$createElement('div', {
        'class': 'input-group__error',
        key: error
      }, error);
    },
    genIcon: function genIcon(type) {
      var _class;

      var icon = this[type + 'Icon'];
      var cb = this[type + 'IconCb'];
      var hasCallback = typeof cb === 'function';

      return this.$createElement('v-icon', {
        'class': (_class = {}, _defineProperty(_class, 'input-group__' + type + '-icon', true), _defineProperty(_class, 'input-group__icon-cb', hasCallback), _class),
        on: {
          click: function click(e) {
            hasCallback && cb(e);
          }
        }
      }, icon);
    },
    genInputGroup: function genInputGroup(input) {
      var _this2 = this;

      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var children = [];
      var wrapperChildren = [];
      var detailsChildren = [];

      data = Object.assign({}, {
        'class': this.inputGroupClasses,
        attrs: {
          tabindex: this.tabindex
        },
        on: {
          blur: function blur() {
            return _this2.tabFocused = false;
          },
          click: function click() {
            return _this2.tabFocused = false;
          },
          keyup: function keyup(e) {
            if ([9, 16].includes(e.keyCode)) {
              _this2.tabFocused = true;
            }
          },
          keydown: function keydown(e) {
            if (!_this2.toggle) return;

            if ([13, 32].includes(e.keyCode)) {
              e.preventDefault();
              _this2.toggle();
            }
          }
        }
      }, data);

      if (this.$slots.label || this.label) {
        children.push(this.genLabel());
      }

      wrapperChildren.push(input);

      if (this.prependIcon) {
        wrapperChildren.unshift(this.genIcon('prepend'));
      }

      if (this.appendIcon) {
        wrapperChildren.push(this.genIcon('append'));
      }

      children.push(this.$createElement('div', {
        'class': 'input-group__input'
      }, wrapperChildren));

      detailsChildren.push(this.genMessages());
      this.counter && detailsChildren.push(this.genCounter());

      children.push(this.$createElement('div', {
        'class': 'input-group__details'
      }, detailsChildren));

      return this.$createElement('div', data, children);
    },
    validate: function validate() {
      var _this3 = this;

      this.errorBucket = [];

      this.rules.forEach(function (rule) {
        var valid = typeof rule === 'function' ? rule(_this3.value) : rule;

        if (valid !== true) {
          _this3.errorBucket.push(valid);
        }
      });
    }
  }
});

/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    primary: Boolean,
    secondary: Boolean,
    success: Boolean,
    info: Boolean,
    warning: Boolean,
    error: Boolean
  }
});

/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    append: Boolean,
    disabled: Boolean,
    exact: Boolean,
    href: [String, Object],
    to: [String, Object],
    nuxt: Boolean,
    replace: Boolean,
    router: Boolean,
    ripple: {
      type: Boolean,
      default: true
    },
    tag: String
  },

  methods: {
    click: function click() {},
    generateRouteLink: function generateRouteLink() {
      var exact = this.exact;
      var tag = void 0;

      var data = {
        attrs: { disabled: this.disabled },
        class: this.classes,
        props: {},
        directives: [{
          name: 'ripple',
          value: this.ripple || false
        }],
        on: Object.assign({
          click: this.click
        }, this.$listeners || {})
      };

      if (typeof this.exact === 'undefined') {
        exact = this.to === '/' || this.to === Object(this.to) && this.to.path === '/';
      }

      if (this.to) {
        tag = this.nuxt ? 'nuxt-link' : 'router-link';
        data.props.to = this.to;
        data.props.exact = exact;
        data.props.activeClass = this.activeClass;
        data.props.append = this.append;
        data.props.replace = this.replace;
      } else {
        tag = this.href && 'a' || this.tag || 'a';

        if (tag === 'a') {
          data.attrs.href = this.href || 'javascript:;';
        }
      }

      return { tag: tag, data: data };
    }
  }
});

/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isBooted: false
    };
  },


  watch: {
    isActive: function isActive() {
      this.isBooted = true;
    }
  },

  methods: {
    showLazyContent: function showLazyContent(content) {
      return this.lazy && this.isBooted || !this.lazy ? content : null;
    }
  }
});

/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VListTileActionText */
/* unused harmony export VListTileAvatar */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return VListTileContent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return VListTileTitle; });
/* unused harmony export VListTileSubTitle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VList__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VListGroup__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VListTile__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__VListTileAction__ = __webpack_require__(21);







var VListTileActionText = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('list__tile__action-text', 'span');
var VListTileAvatar = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('list__tile__avatar', 'v-avatar');
var VListTileContent = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('list__tile__content', 'div');
var VListTileTitle = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('list__tile__title', 'div');
var VListTileSubTitle = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('list__tile__sub-title', 'div');

/* harmony default export */ __webpack_exports__["c"] = ({
  VList: __WEBPACK_IMPORTED_MODULE_1__VList__["a" /* default */],
  VListTile: __WEBPACK_IMPORTED_MODULE_3__VListTile__["a" /* default */],
  VListGroup: __WEBPACK_IMPORTED_MODULE_2__VListGroup__["a" /* default */],
  VListTileAction: __WEBPACK_IMPORTED_MODULE_4__VListTileAction__["a" /* default */],
  VListTileActionText: VListTileActionText,
  VListTileAvatar: VListTileAvatar,
  VListTileContent: VListTileContent,
  VListTileTitle: VListTileTitle,
  VListTileSubTitle: VListTileSubTitle
});

/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    absolute: Boolean,
    bottom: Boolean,
    fixed: Boolean,
    left: Boolean,
    right: Boolean,
    top: Boolean
  }
});

/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  props: {
    flat: Boolean,
    height: {
      type: String,
      default: 'auto'
    },
    hover: Boolean,
    img: String,
    raised: Boolean,
    tile: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;

    data.staticClass = ('card ' + (data.staticClass || '')).trim();
    data.style = data.style || {};
    data.style.height = props.height;

    if (props.dark) data.staticClass += ' theme--dark';
    if (props.flat) data.staticClass += ' card--flat';
    if (props.horizontal) data.staticClass += ' card--horizontal';
    if (props.hover) data.staticClass += ' card--hover';
    if (props.light) data.staticClass += ' theme--light';
    if (props.raised) data.staticClass += ' card--raised';
    if (props.tile) data.staticClass += ' card--tile';

    if (props.img) {
      data.style.background = 'url(' + props.img + ') center center / cover no-repeat';
    }

    return h('div', data, children);
  }
});

/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isSaving: false
    };
  },


  props: {
    actions: Boolean,
    autosave: Boolean,
    landscape: Boolean,
    noTitle: Boolean,
    scrollable: Boolean,
    value: {
      required: true
    },
    light: {
      type: Boolean,
      default: true
    },
    dark: Boolean
  },

  methods: {
    save: function save() {},
    cancel: function cancel() {},
    genSlot: function genSlot() {
      return this.$scopedSlots.default({
        save: this.save,
        cancel: this.cancel
      });
    }
  }
});

/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    contentClass: {
      default: ''
    }
  },

  mounted: function mounted() {
    var _this = this;

    this.$vuetify.load(function () {
      if (_this._isDestroyed) return;

      var app = document.querySelector('[data-app]');

      if (!app) {
        return console.warn('Application is missing <v-app> component.');
      }

      app.insertBefore(_this.$refs.content, app.firstChild);
    });
  },
  beforeDestroy: function beforeDestroy() {
    if (!this.$refs.content) return;

    // IE11 Fix
    try {
      this.$refs.content.parentNode.removeChild(this.$refs.content);
    } catch (e) {}
  }
});

/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      overlay: null,
      overlayOffset: 0,
      overlayTransitionDuration: 500
    };
  },


  props: {
    hideOverlay: Boolean
  },

  beforeDestroy: function beforeDestroy() {
    this.removeOverlay();
  },


  methods: {
    genOverlay: function genOverlay() {
      var _this = this;

      if (!this.isActive || this.hideOverlay || this.isActive && this.overlay) return;

      this.overlay = document.createElement('div');
      this.overlay.className = 'overlay';
      this.overlay.onclick = function () {
        if (_this.permanent) return;else if (!_this.persistent) _this.isActive = false;else if (_this.isMobile) _this.isActive = false;
      };

      if (this.absolute) this.overlay.className += ' overlay--absolute';

      this.hideScroll();

      if (this.absolute) {
        // Required for IE11
        var parent = this.$el.parentNode;
        parent.insertBefore(this.overlay, parent.firstChild);
      } else {
        document.querySelector('[data-app]').appendChild(this.overlay);
      }

      this.overlay.clientHeight; // Force repaint
      requestAnimationFrame(function () {
        _this.overlay.className += ' overlay--active';
      });

      return true;
    },
    removeOverlay: function removeOverlay() {
      var _this2 = this;

      if (!this.overlay) {
        return this.showScroll();
      }

      this.overlay.classList.remove('overlay--active');

      setTimeout(function () {
        // IE11 Fix
        try {
          _this2.overlay.parentNode.removeChild(_this2.overlay);
          _this2.overlay = null;
          _this2.showScroll();
        } catch (e) {}
      }, this.overlayTransitionDuration);
    },
    hideScroll: function hideScroll() {
      // Check documentElement first for IE11
      // this.overlayOffset = document.documentElement &&
      //   document.documentElement.scrollTop ||
      //   document.body.scrollTop

      // document.body.style.top = `-${this.overlayOffset}px`
      // document.body.style.position = 'fixed'
      document.documentElement.style.overflow = 'hidden';
    },
    showScroll: function showScroll() {
      document.documentElement.removeAttribute('style');

      // if (!this.overlayOffset) return
      // document.body.scrollTop = this.overlayOffset
      // document.documentElement.scrollTop = this.overlayOffset
    }
  }
});

/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-list',

  provide: function provide() {
    return {
      listClick: this.listClick,
      listClose: this.listClose
    };
  },


  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  data: function data() {
    return {
      uid: null,
      groups: []
    };
  },


  props: {
    dense: Boolean,
    subheader: Boolean,
    threeLine: Boolean,
    twoLine: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'list': true,
        'list--two-line': this.twoLine,
        'list--dense': this.dense,
        'list--three-line': this.threeLine,
        'list--subheader': this.subheader,
        'theme--dark dark--bg': this.dark,
        'theme--light light--bg': this.light
      };
    }
  },

  watch: {
    uid: function uid() {
      var _this = this;

      this.$children.filter(function (i) {
        return i.$options._componentTag === 'v-list-group';
      }).forEach(function (i) {
        return i.toggle(_this.uid);
      });
    }
  },

  methods: {
    listClick: function listClick(uid, force) {
      if (force) {
        this.uid = uid;
      } else {
        this.uid = this.uid === uid ? null : uid;
      }
    },
    listClose: function listClose(uid) {
      if (this.uid === uid) {
        this.uid = null;
      }
    }
  },

  render: function render(h) {
    var data = {
      'class': this.classes,
      attrs: { 'data-uid': this._uid }
    };

    return h('ul', data, [this.$slots.default]);
  }
});

/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_route_link__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__directives__ = __webpack_require__(4);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-list-tile',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_route_link__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__["a" /* default */]],

  directives: {
    Ripple: __WEBPACK_IMPORTED_MODULE_2__directives__["Ripple"]
  },

  inheritAttrs: false,

  props: {
    activeClass: {
      type: String,
      default: 'list__tile--active'
    },
    avatar: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'list__tile': true,
        'list__tile--avatar': this.avatar,
        'list__tile--disabled': this.disabled
      };
    }
  },

  render: function render(h) {
    var _generateRouteLink = this.generateRouteLink(),
        tag = _generateRouteLink.tag,
        data = _generateRouteLink.data;

    data.attrs = Object.assign({}, data.attrs, this.$attrs);

    return h('li', {
      attrs: {
        disabled: this.disabled
      }
    }, [h(tag, data, [this.$slots.default])]);
  }
});

/***/ }),
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function directive(e, el, binding, v) {
  var cb = function cb() {
    return true;
  };

  if (binding.value) cb = binding.value;

  if (v.context.isActive && e && e.target && e.target !== el && !el.contains(e.target) && cb(e)) {
    v.context.isActive = false;
  }
}

/* harmony default export */ __webpack_exports__["a"] = ({
  bind: function bind(el, binding, v) {
    v.context.$vuetify.load(function () {
      var outside = document.querySelector('[data-app]');
      var click = function click(e) {
        return directive(e, el, binding, v);
      };
      outside.addEventListener('click', click, false);
      el._clickOutside = click;
    });
  },
  unbind: function unbind(el) {
    var outside = document.querySelector('[data-app]');
    outside && outside.removeEventListener('click', el._clickOutside, false);
  }
});

/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function style(el, value) {
  ['transform', 'webkitTransform'].forEach(function (i) {
    el.style[i] = value;
  });
}

var ripple = {
  show: function show(e, el, _ref) {
    var _ref$value = _ref.value,
        value = _ref$value === undefined ? {} : _ref$value;

    var container = document.createElement('span');
    var animation = document.createElement('span');

    container.appendChild(animation);
    container.className = 'ripple__container';

    if (value.class) {
      container.className += ' ' + value.class;
    }

    var size = el.clientWidth > el.clientHeight ? el.clientWidth : el.clientHeight;
    animation.className = 'ripple__animation';
    animation.style.width = size * (value.center ? 1 : 2) + 'px';
    animation.style.height = animation.style.width;

    el.appendChild(container);
    var computed = window.getComputedStyle(el);
    if (computed.position !== 'absolute' && computed.position !== 'fixed') el.style.position = 'relative';

    var offset = el.getBoundingClientRect();
    var x = value.center ? '50%' : e.clientX - offset.left + 'px';
    var y = value.center ? '50%' : e.clientY - offset.top + 'px';

    animation.classList.add('ripple__animation--enter');
    animation.classList.add('ripple__animation--visible');
    style(animation, 'translate(-50%, -50%) translate(' + x + ', ' + y + ') scale3d(0.01,0.01,0.01)');
    animation.dataset.activated = Date.now();

    setTimeout(function () {
      animation.classList.remove('ripple__animation--enter');
      style(animation, 'translate(-50%, -50%) translate(' + x + ', ' + y + ')  scale3d(0.99,0.99,0.99)');
    }, 0);
  },

  hide: function hide(el) {
    var ripples = el.getElementsByClassName('ripple__animation');

    if (ripples.length === 0) return;
    var animation = ripples[ripples.length - 1];
    var diff = Date.now() - Number(animation.dataset.activated);
    var delay = 400 - diff;

    delay = delay < 0 ? 0 : delay;

    setTimeout(function () {
      animation.classList.remove('ripple__animation--visible');

      setTimeout(function () {
        // Need to figure out a new way to do this
        try {
          if (ripples.length < 1) el.style.position = null;
          animation.parentNode && el.removeChild(animation.parentNode);
        } catch (e) {}
      }, 300);
    }, delay);
  }
};

function directive(el, binding, v) {
  if (binding.value === false) return;

  if ('ontouchstart' in window) {
    el.addEventListener('touchend', function () {
      return ripple.hide(el);
    }, false);
    el.addEventListener('touchcancel', function () {
      return ripple.hide(el);
    }, false);
  }

  el.addEventListener('mousedown', function (e) {
    return ripple.show(e, el, binding);
  }, false);
  el.addEventListener('mouseup', function () {
    return ripple.hide(el);
  }, false);
  el.addEventListener('mouseleave', function () {
    return ripple.hide(el);
  }, false);
}

function unbind(el, binding) {
  el.removeEventListener('touchstart', function (e) {
    return ripple.show(e, el, binding);
  }, false);
  el.removeEventListener('mousedown', function (e) {
    return ripple.show(e, el, binding);
  }, false);
  el.removeEventListener('touchend', function () {
    return ripple.hide(el);
  }, false);
  el.removeEventListener('touchcancel', function () {
    return ripple.hide(el);
  }, false);
  el.removeEventListener('mouseup', function () {
    return ripple.hide(el);
  }, false);
  el.removeEventListener('mouseleave', function () {
    return ripple.hide(el);
  }, false);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  bind: directive,
  unbind: unbind
});

/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  name: 'list-tile-action',

  render: function render(h, _ref) {
    var data = _ref.data,
        children = _ref.children;

    data.staticClass = data.staticClass ? 'list__tile__action ' + (data.staticClass || '') : 'list__tile__action';
    if ((children || []).length > 1) data.staticClass += ' list__tile__action--stack';

    return h('div', data, children);
  }
});

/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_activator__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_detachable__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_generators__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_position__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_utils__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_toggleable__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_keyable__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__directives__ = __webpack_require__(4);










/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-menu',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_activator__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_detachable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_generators__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__mixins_keyable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_position__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_utils__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__mixins_toggleable__["a" /* default */]],

  directives: {
    ClickOutside: __WEBPACK_IMPORTED_MODULE_7__directives__["ClickOutside"]
  },

  data: function data() {
    return {
      autoIndex: null,
      dimensions: {
        activator: {
          top: 0, left: 0,
          bottom: 0, right: 0,
          width: 0, height: 0,
          offsetTop: 0, scrollHeight: 0
        },
        content: {
          top: 0, left: 0,
          bottom: 0, right: 0,
          width: 0, height: 0,
          offsetTop: 0, scrollHeight: 0
        },
        list: null,
        selected: null
      },
      direction: { vert: 'bottom', horiz: 'right' },
      isContentActive: false,
      isBooted: false,
      maxHeightAutoDefault: '200px',
      resizeTimeout: {},
      startIndex: 3,
      stopIndex: 0,
      tileLength: 0,
      window: {},
      absoluteX: 0,
      absoluteY: 0,
      hasJustFocused: false,
      focusedTimeout: {}
    };
  },


  props: {
    top: Boolean,
    left: Boolean,
    bottom: Boolean,
    right: Boolean,
    fullWidth: Boolean,
    auto: Boolean,
    offsetX: Boolean,
    offsetY: Boolean,
    disabled: Boolean,
    maxHeight: {
      default: 'auto'
    },
    nudgeTop: {
      type: Number,
      default: 0
    },
    nudgeBottom: {
      type: Number,
      default: 0
    },
    nudgeLeft: {
      type: Number,
      default: 0
    },
    nudgeRight: {
      type: Number,
      default: 0
    },
    nudgeWidth: {
      type: Number,
      default: 0
    },
    openOnClick: {
      type: Boolean,
      default: true
    },
    openOnHover: {
      type: Boolean,
      default: false
    },
    lazy: Boolean,
    closeOnClick: {
      type: Boolean,
      default: true
    },
    closeOnContentClick: {
      type: Boolean,
      default: true
    },
    activator: {
      default: null
    },
    origin: {
      type: String,
      default: 'top left'
    },
    transition: {
      type: String,
      default: 'menu-transition'
    },
    positionX: {
      type: Number,
      default: null
    },
    positionY: {
      type: Number,
      default: null
    },
    positionAbsolutely: {
      type: Boolean,
      default: false
    },
    maxWidth: [Number, String],
    minWidth: [Number, String]
  },

  computed: {
    calculatedMinWidth: function calculatedMinWidth() {
      var minWidth = parseInt(this.minWidth) || this.dimensions.activator.width + this.nudgeWidth + (this.auto ? 16 : 0);

      if (!this.maxWidth) return minWidth;

      var maxWidth = parseInt(this.maxWidth);

      return maxWidth < minWidth ? maxWidth : minWidth;
    },
    styles: function styles() {
      return {
        maxHeight: this.auto ? '200px' : isNaN(this.maxHeight) ? this.maxHeight : this.maxHeight + 'px',
        minWidth: this.calculatedMinWidth + 'px',
        maxWidth: parseInt(this.maxWidth) + 'px',
        top: this.calcTop() + 'px',
        left: this.calcLeft() + 'px'
      };
    },
    hasActivator: function hasActivator() {
      return !!this.$slots.activator || this.activator;
    }
  },

  watch: {
    activator: function activator(newActivator, oldActivator) {
      this.removeActivatorEvents(oldActivator);
      this.addActivatorEvents(newActivator);
    },
    disabled: function disabled(val) {
      val && this.deactivate();
    },
    hasJustFocused: function hasJustFocused(val) {
      var _this = this;

      if (!val) return;

      clearTimeout(this.focusedTimeout);
      this.focusedTimeout = setTimeout(function () {
        return _this.hasJustFocused = false;
      }, 550);
    },
    isActive: function isActive(val) {
      if (this.disabled) return;

      val && this.activate() || this.deactivate();
    },
    windowResizeHandler: function windowResizeHandler() {
      this.isBooted = false;
    }
  },

  mounted: function mounted() {
    window.addEventListener('resize', this.onResize, { passive: true });
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.onResize, { passive: true });
    window.removeEventListener('resize', this.windowResizeHandler);
  },


  methods: {
    activate: function activate() {
      if (typeof window === 'undefined') return;
      this.isBooted = true;
      this.getTiles();
      this.updateDimensions();
      requestAnimationFrame(this.startTransition);
      this.$emit('activate');
    },
    deactivate: function deactivate() {
      this.isContentActive = false;
      this.$emit('deactivate');
    },
    onResize: function onResize() {
      clearTimeout(this.resizeTimeout);
      if (!this.isActive) return;
      this.resizeTimeout = setTimeout(this.updateDimensions, 200);
    },
    startTransition: function startTransition() {
      var _this2 = this;

      requestAnimationFrame(function () {
        return _this2.isContentActive = true;
      });
      requestAnimationFrame(this.calculateScroll);
    }
  },

  render: function render(h) {
    var _this3 = this;

    var data = {
      'class': 'menu',
      style: {
        display: this.fullWidth ? 'block' : 'inline-block'
      },
      directives: [{
        name: 'click-outside',
        value: function value() {
          return _this3.closeOnClick;
        }
      }],
      on: {
        keydown: function keydown(e) {
          if (e.keyCode === 27) _this3.isActive = false;else _this3.changeListIndex(e);
        }
      }
    };

    return h('div', data, [this.genActivator(), this.genTransition()]);
  }
});

/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_transitions__ = __webpack_require__(6);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-progress-linear',

  components: {
    VFadeTransition: __WEBPACK_IMPORTED_MODULE_0__components_transitions__["b" /* VFadeTransition */],
    VSlideXTransition: __WEBPACK_IMPORTED_MODULE_0__components_transitions__["c" /* VSlideXTransition */]
  },

  props: {
    active: {
      type: Boolean,
      default: true
    },
    buffer: Boolean,
    bufferValue: Number,
    error: Boolean,
    height: {
      type: [Number, String],
      default: 7
    },
    indeterminate: Boolean,
    info: Boolean,
    secondary: Boolean,
    success: Boolean,
    query: Boolean,
    warning: Boolean,
    value: {
      type: [Number, String],
      default: 0
    },
    colorFront: {
      type: String,
      default: null
    },
    colorBack: {
      type: String,
      default: null
    }
  },

  computed: {
    classes: function classes() {
      return {
        'progress-linear--query': this.query,
        'progress-linear--secondary': this.secondary,
        'progress-linear--success': this.success,
        'progress-linear--info': this.info,
        'progress-linear--warning': this.warning,
        'progress-linear--error': this.error
      };
    },
    styles: function styles() {
      var styles = {};

      if (!this.active) {
        styles.height = 0;
      }

      if (this.buffer) {
        styles.width = this.bufferValue + '%';
      }

      return styles;
    },
    bufferStyles: function bufferStyles() {
      var styles = {};

      if (!this.active) {
        styles.height = 0;
      }

      return styles;
    }
  },

  methods: {
    genDeterminate: function genDeterminate(h) {
      return h('div', {
        ref: 'front',
        class: ['progress-linear__bar__determinate', this.colorFront],
        style: { width: this.value + '%' }
      });
    },
    genBar: function genBar(h, name) {
      return h('div', {
        class: ['progress-linear__bar__indeterminate', name, this.colorFront]
      });
    },
    genIndeterminate: function genIndeterminate(h) {
      return h('div', {
        ref: 'front',
        class: {
          'progress-linear__bar__indeterminate': true,
          'progress-linear__bar__indeterminate--active': this.active
        }
      }, [this.genBar(h, 'long'), this.genBar(h, 'short')]);
    }
  },

  render: function render(h) {
    var fade = h('v-fade-transition', [this.indeterminate && this.genIndeterminate(h)]);
    var slide = h('v-slide-x-transition', [!this.indeterminate && this.genDeterminate(h)]);

    var bar = h('div', { class: ['progress-linear__bar', this.colorBack], style: this.styles }, [fade, slide]);

    return h('div', {
      class: ['progress-linear', this.classes],
      style: { height: this.height + 'px' },
      on: this.$listeners
    }, [bar]);
  }
});

/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_autocomplete__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_filterable__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_generators__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_input__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_cards_VCard__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_selection_controls_VCheckbox__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_icons_VIcon__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_lists_VList__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_lists_VListTile__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_lists_VListTileAction__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_lists__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_menus_VMenu__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__directives_click_outside__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__util_helpers__ = __webpack_require__(0);



















/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-select',

  components: {
    VCard: __WEBPACK_IMPORTED_MODULE_4__components_cards_VCard__["a" /* default */],
    VCheckbox: __WEBPACK_IMPORTED_MODULE_5__components_selection_controls_VCheckbox__["a" /* default */],
    VIcon: __WEBPACK_IMPORTED_MODULE_6__components_icons_VIcon__["a" /* default */],
    VList: __WEBPACK_IMPORTED_MODULE_7__components_lists_VList__["a" /* default */],
    VListTile: __WEBPACK_IMPORTED_MODULE_8__components_lists_VListTile__["a" /* default */],
    VListTileAction: __WEBPACK_IMPORTED_MODULE_9__components_lists_VListTileAction__["a" /* default */],
    VListTileContent: __WEBPACK_IMPORTED_MODULE_10__components_lists__["a" /* VListTileContent */],
    VListTileTitle: __WEBPACK_IMPORTED_MODULE_10__components_lists__["b" /* VListTileTitle */],
    VMenu: __WEBPACK_IMPORTED_MODULE_11__components_menus_VMenu__["a" /* default */]
  },

  directives: {
    clickOutside: __WEBPACK_IMPORTED_MODULE_12__directives_click_outside__["a" /* default */]
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_autocomplete__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_input__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_filterable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_generators__["a" /* default */]],

  data: function data() {
    return {
      content: {},
      hasFocused: false,
      inputValue: this.multiple && !this.value ? [] : this.value,
      isBooted: false,
      lastItem: 20,
      isActive: false,
      searchInputValue: this.searchInput
    };
  },


  props: {
    appendIcon: {
      type: String,
      default: 'arrow_drop_down'
    },
    auto: Boolean,
    autocomplete: Boolean,
    bottom: Boolean,
    chips: Boolean,
    close: Boolean,
    debounce: {
      type: Number,
      default: 200
    },
    items: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    filter: Function,
    itemText: {
      type: String,
      default: 'text'
    },
    itemValue: {
      type: String,
      default: 'value'
    },
    itemDisabled: {
      type: String,
      default: 'disabled'
    },
    maxHeight: {
      type: [Number, String],
      default: 300
    },
    minWidth: {
      type: [Boolean, Number, String],
      default: false
    },
    multiple: Boolean,
    multiLine: Boolean,
    offset: Boolean,
    searchInput: null,
    singleLine: Boolean,
    top: Boolean,
    returnObject: Boolean,
    overflow: Boolean,
    segmented: Boolean,
    editable: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'input-group--text-field input-group--select': true,
        'input-group--auto': this.auto,
        'input-group--overflow': this.overflow,
        'input-group--segmented': this.segmented,
        'input-group--editable': this.editable,
        'input-group--autocomplete': this.autocomplete,
        'input-group--single-line': this.singleLine || this.isDropdown,
        'input-group--multi-line': this.multiLine,
        'input-group--chips': this.chips,
        'input-group--multiple': this.multiple
      };
    },
    computedContentClass: function computedContentClass() {
      var children = [this.auto ? 'menu__content--auto' : '', this.isDropdown ? 'menu__content--dropdown' : ''];

      return children.join(' ');
    },
    filteredItems: function filteredItems() {
      var items = this.autocomplete && this.searchValue ? this.filterSearch() : this.items;

      return !this.auto ? items.slice(0, this.lastItem) : items;
    },
    hasError: function hasError() {
      return this.validations.length || this.error || this.hasFocused && !this.focused && !this.isDirty && this.required;
    },
    isDirty: function isDirty() {
      return this.selectedItems.length;
    },
    isDropdown: function isDropdown() {
      return this.segmented || this.overflow || this.editable;
    },

    searchValue: {
      get: function get() {
        return this.searchInput || this.searchInputValue;
      },
      set: function set(val) {
        this.searchInputValue = val;
        this.$emit('update:searchInput', val);
      }
    },
    selectedItems: function selectedItems() {
      var _this = this;

      if (this.inputValue === null || typeof this.inputValue === 'undefined') return [];

      return this.items.filter(function (i) {
        if (!_this.multiple) {
          return _this.getValue(i) === _this.getValue(_this.inputValue);
        } else {
          // Always return Boolean
          return _this.inputValue.find(function (j) {
            return _this.getValue(j) === _this.getValue(i);
          }) !== undefined;
        }
      });
    }
  },

  watch: {
    inputValue: function inputValue(val) {
      this.$emit('input', val);
    },
    value: function value(val) {
      this.inputValue = val;
      this.validate();
      if (this.autocomplete || this.editable) {
        this.$nextTick(this.$refs.menu.updateDimensions);
      }
    },
    isActive: function isActive(val) {
      this.isBooted = true;
      this.lastItem += !val ? 20 : 0;

      if (!val) this.blur();else this.focus();
    },
    isBooted: function isBooted() {
      var _this2 = this;

      this.$nextTick(function () {
        if (_this2.content) {
          _this2.content.addEventListener('scroll', _this2.onScroll, false);
        }
      });
    },
    searchValue: function searchValue() {
      this.$refs.menu.listIndex = -1;
    }
  },

  mounted: function mounted() {
    var _this3 = this;

    this.$vuetify.load(function () {
      if (_this3._isDestroyed) return;

      _this3.content = _this3.$refs.menu.$refs.content;
    });
  },
  beforeDestroy: function beforeDestroy() {
    if (this.isBooted) {
      if (this.content) {
        this.content.removeEventListener('scroll', this.onScroll, false);
      }
    }
  },


  methods: {
    blur: function blur() {
      var _this4 = this;

      this.$nextTick(function () {
        _this4.focused = false;
        _this4.hasFocused = true;
        _this4.searchValue = null;
        _this4.$el.blur();
      });
    },
    focus: function focus() {
      var _this5 = this;

      this.focused = true;
      this.$refs.input && (this.autocomplete || this.editable) && this.$refs.input.focus();

      if (this.editable && this.inputValue !== null && typeof this.inputValue !== 'undefined') {
        this.$nextTick(function () {
          _this5.$refs.input.value = _this5.getValue(_this5.inputValue);
        });
      }
    },
    genLabel: function genLabel() {
      if (this.searchValue && !this.focused && this.isDirty) return null;

      var data = {};

      if (this.id) data.attrs = { for: this.id };

      return this.$createElement('label', data, this.label);
    },
    getPropertyFromItem: function getPropertyFromItem(item, field) {
      if (item !== Object(item)) return item;

      var value = Object(__WEBPACK_IMPORTED_MODULE_13__util_helpers__["g" /* getObjectValueByPath */])(item, field);

      return typeof value === 'undefined' ? item : value;
    },
    getText: function getText(item) {
      return this.getPropertyFromItem(item, this.itemText);
    },
    getValue: function getValue(item) {
      return this.getPropertyFromItem(item, this.itemValue);
    },
    onScroll: function onScroll() {
      var _this6 = this;

      if (!this.isActive) {
        requestAnimationFrame(function () {
          return _this6.content.scrollTop = 0;
        });
      } else {
        var showMoreItems = this.content.scrollHeight - (this.content.scrollTop + this.content.clientHeight) < 200;

        if (showMoreItems) {
          this.lastItem += 20;
        }
      }
    },
    selectItem: function selectItem(item) {
      var _this7 = this;

      if (!this.multiple) {
        this.inputValue = this.returnObject ? item : this.getValue(item);
      } else {
        var inputValue = this.inputValue.slice();
        var i = this.inputValue.findIndex(function (i) {
          return _this7.getValue(i) === _this7.getValue(item);
        });

        i !== -1 && inputValue.splice(i, 1) || inputValue.push(item);
        this.inputValue = inputValue.map(function (i) {
          return _this7.returnObject ? i : _this7.getValue(i);
        });
      }

      if (this.autocomplete || this.editable) {
        this.$nextTick(function () {
          _this7.searchValue = null;
          _this7.$refs.input && _this7.$refs.input.focus();
        });
      }

      this.$emit('change', this.inputValue);
    }
  },

  render: function render(h) {
    var _this8 = this;

    return this.genInputGroup([this.genSelectionsAndSearch(), this.genMenu()], {
      ref: 'activator',
      directives: [{
        name: 'click-outside',
        value: function value() {
          return _this8.isActive = false;
        }
      }],
      on: {
        keydown: this.onKeyDown // Located in mixins/autocomplete.js
      }
    });
  }
});

/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    noDataText: {
      type: String,
      default: 'No data available'
    }
  }
});

/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_selectable__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__directives_ripple__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_transitions__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_icons_VIcon__ = __webpack_require__(3);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-checkbox',

  components: {
    VFadeTransition: __WEBPACK_IMPORTED_MODULE_2__components_transitions__["b" /* VFadeTransition */],
    VIcon: __WEBPACK_IMPORTED_MODULE_3__components_icons_VIcon__["a" /* default */]
  },

  directives: {
    Ripple: __WEBPACK_IMPORTED_MODULE_1__directives_ripple__["a" /* default */]
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_selectable__["a" /* default */]],

  data: function data() {
    return {
      inputIndeterminate: this.indeterminate
    };
  },


  props: {
    indeterminate: Boolean
  },

  computed: {
    classes: function classes() {
      return this.addColorClassChecks({
        'checkbox': true,
        'input-group--selection-controls': true,
        'input-group--active': this.isActive
      });
    },
    icon: function icon() {
      if (this.inputIndeterminate) {
        return 'indeterminate_check_box';
      } else if (this.isActive) {
        return 'check_box';
      } else {
        return 'check_box_outline_blank';
      }
    }
  },

  render: function render(h) {
    var transition = h('v-fade-transition', [h('v-icon', {
      'class': {
        'icon--checkbox': this.icon === 'check_box'
      },
      key: this.icon
    }, this.icon)]);

    var ripple = h('div', {
      'class': 'input-group--selection-controls__ripple',
      on: Object.assign({}, {
        click: this.toggle
      }, this.$listeners),
      directives: [{
        name: 'ripple',
        value: { center: true }
      }]
    });

    var data = {
      attrs: {
        role: 'checkbox',
        'aria-checked': this.inputIndeterminate && 'mixed' || this.isActive && 'true' || 'false',
        'aria-label': this.label
      }
    };

    return this.genInputGroup([transition, ripple], data);
  }
});

/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colorable__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__input__ = __webpack_require__(7);



/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_1__input__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0__colorable__["a" /* default */]],

  model: {
    prop: 'inputValue',
    event: 'change'
  },

  props: {
    inputValue: null,
    falseValue: null,
    trueValue: null
  },

  computed: {
    isActive: function isActive() {
      if (Array.isArray(this.inputValue)) {
        return this.inputValue.indexOf(this.value) !== -1;
      }

      if (!this.trueValue || !this.falseValue) {
        return this.value ? this.value === this.inputValue : Boolean(this.inputValue);
      }

      return this.inputValue === this.trueValue;
    }
  },

  watch: {
    indeterminate: function indeterminate(val) {
      this.inputIndeterminate = val;
    }
  },

  methods: {
    genLabel: function genLabel() {
      return this.$createElement('label', {
        on: { click: this.toggle },
        attrs: {
          for: this.$attrs.id
        }
      }, this.$slots.label || this.label);
    },
    toggle: function toggle() {
      if (this.disabled) {
        return;
      }

      var input = this.inputValue;
      if (Array.isArray(input)) {
        input = input.slice();
        var i = input.indexOf(this.value);

        if (i === -1) {
          input.push(this.value);
        } else {
          input.splice(i, 1);
        }
      } else if (this.trueValue || this.falseValue) {
        input = input === this.trueValue ? this.falseValue : this.trueValue;
      } else if (this.value) {
        input = this.value === this.inputValue ? null : this.value;
      } else {
        input = !input;
      }

      this.$emit('change', input);
    }
  }
});

/***/ }),
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    color: String
  },
  methods: {
    addColorClassChecks: function addColorClassChecks(classes) {
      var parts = this.color ? this.color.trim().split(' ') : [''];
      var color = parts[0] + '--text';
      if (parts.length > 1) color += ' text--' + parts[1];
      classes[color] = !!this.color;
      return classes;
    }
  }
});

/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__package_json__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__package_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__package_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__directives__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_load__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_semver__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_semver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_semver__);
__webpack_require__(30);







function plugin(Vue) {
  Object.keys(__WEBPACK_IMPORTED_MODULE_1__components__["a" /* default */]).forEach(function (key) {
    Vue.component(key, __WEBPACK_IMPORTED_MODULE_1__components__["a" /* default */][key]);
  });

  Object.keys(__WEBPACK_IMPORTED_MODULE_2__directives__).forEach(function (key) {
    Vue.directive(key, __WEBPACK_IMPORTED_MODULE_2__directives__[key]);
  });

  Vue.prototype.$vuetify = {
    load: __WEBPACK_IMPORTED_MODULE_3__util_load__["a" /* default */]
  };
}

function checkVueVersion() {
  var vueDep = __WEBPACK_IMPORTED_MODULE_0__package_json__["devDependencies"].vue;
  if (!__WEBPACK_IMPORTED_MODULE_4_semver___default.a.satisfies(window.Vue.version, vueDep)) {
    console.warn('Vuetify requires Vue version ' + vueDep);
  }
}

if (typeof window !== 'undefined' && window.Vue) {
  if (window.Vue.version) {
    checkVueVersion();
  }
  window.Vue.use(plugin);
}

/* harmony default export */ __webpack_exports__["default"] = (plugin);

/***/ }),
/* 30 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 31 */
/***/ (function(module, exports) {

module.exports = {
	"name": "vuetify",
	"version": "0.14.10",
	"author": {
		"name": "John Leider",
		"email": "john.j.leider@gmail.com"
	},
	"license": "MIT",
	"homepage": "http://vuetifyjs.com",
	"main": "dist/vuetify.js",
	"types": "index.d.ts",
	"scripts": {
		"watch": "cross-env TARGET=dev webpack --config build/config.js --progress --hide-modules --watch",
		"dev": "cross-env NODE_ENV=development webpack-dev-server --config build/webpack.dev.config.js --open --hot",
		"build": "rimraf dist && cross-env NODE_ENV=production node build/build.js --progress --hide-modules",
		"debug-build": "node --inspect --debug-brk build/build.js",
		"test": "cross-env NODE_ENV=test jest --no-cache --verbose",
		"test-coverage": "cross-env NODE_ENV=test jest --no-cache --coverage --verbose",
		"lint": "eslint --ext .js,.vue src"
	},
	"description": "Vue.js 2 Semantic Component Framework",
	"devDependencies": {
		"autoprefixer": "^6.6.0",
		"avoriaz": "^3.2.0",
		"babel-cli": "^6.24.1",
		"babel-core": "^6.24.1",
		"babel-eslint": "^7.1.1",
		"babel-jest": "^20.0.3",
		"babel-loader": "^7.1.1",
		"babel-plugin-add-filehash": "^6.9.4",
		"babel-plugin-module-resolver": "^2.7.1",
		"babel-plugin-transform-async-to-generator": "^6.24.1",
		"babel-plugin-transform-runtime": "^6.23.0",
		"babel-preset-env": "^1.5.1",
		"babel-preset-es2015": "^6.24.1",
		"babel-preset-stage-2": "^6.24.1",
		"chalk": "^1.1.3",
		"chromedriver": "^2.21.2",
		"cross-env": "^3.1.3",
		"cross-spawn": "^4.0.2",
		"css-loader": "^0.23.1",
		"css-mqpacker": "^6.0.1",
		"cssnano": "^3.10.0",
		"eslint": "^3.7.1",
		"eslint-config-standard": "^6.1.0",
		"eslint-config-vue": "^2.0.2",
		"eslint-friendly-formatter": "^2.0.5",
		"eslint-loader": "^1.6.1",
		"eslint-plugin-html": "^1.3.0",
		"eslint-plugin-promise": "^3.4.0",
		"eslint-plugin-pug": "^1.0.0",
		"eslint-plugin-standard": "^3.0.1",
		"eslint-plugin-vue": "^2.1.0",
		"eventsource-polyfill": "^0.9.6",
		"extract-text-webpack-plugin": "^3.0.0",
		"friendly-errors-webpack-plugin": "^1.6.1",
		"function-bind": "^1.0.2",
		"jest": "^20.0.4",
		"jest-cli": "^20.0.4",
		"jest-css-modules": "^1.1.0",
		"jest-serializer-html": "^4.0.0",
		"jest-vue-preprocessor": "^0.2.0",
		"lolex": "^1.4.0",
		"nightwatch": "^0.9.8",
		"opn": "^4.0.2",
		"optimize-css-assets-webpack-plugin": "^2.0.0",
		"optimize-js-plugin": "^0.0.4",
		"ora": "^0.3.0",
		"phantomjs-prebuilt": "^2.1.3",
		"postcss-loader": "^1.2.1",
		"precss": "^1.4.0",
		"pug": "^2.0.0-beta3",
		"pug-loader": "^2.3.0",
		"ress": "^1.1.1",
		"rimraf": "^2.5.4",
		"selenium-server": "2.53.1",
		"semver": "^5.3.0",
		"serialize-javascript": "^1.3.0",
		"shelljs": "^0.7.4",
		"style-loader": "^0.13.1",
		"stylus": "^0.54.5",
		"stylus-loader": "^2.1.1",
		"uglifyjs-webpack-plugin": "^0.4.6",
		"vue": "^2.4.1",
		"vue-loader": "^10.1.0",
		"vue-router": "^2.7.0",
		"vue-server-renderer": "^2.4.1",
		"vue-template-compiler": "^2.4.1",
		"webpack": "^3.2.0",
		"webpack-bundle-size-analyzer": "^2.7.0",
		"webpack-dev-server": "^2.6.1",
		"webpack-merge": "^4.1.0"
	},
	"dependencies": {},
	"engines": {
		"node": ">= 4.0.0",
		"npm": ">= 3.0.0"
	},
	"jest": {
		"verbose": false,
		"roots": [
			"<rootDir>/src"
		],
		"moduleFileExtensions": [
			"js",
			"vue"
		],
		"moduleDirectories": [
			"node_modules"
		],
		"moduleNameMapper": {
			"src/(.*)": "<rootDir>/src/$1"
		},
		"transform": {
			".*\\.(vue)$": "<rootDir>/node_modules/jest-vue-preprocessor",
			"\\.(styl)$": "<rootDir>/node_modules/jest-css-modules",
			".*\\.(vue|js)$": "<rootDir>/node_modules/babel-jest"
		},
		"transformIgnorePatterns": [
			"node_modules/(?!vue-router)"
		],
		"snapshotSerializers": [
			"jest-serializer-html"
		]
	}
};

/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__alerts__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__app__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__avatars__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__bottom_nav__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__breadcrumbs__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__buttons__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__cards__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__carousel__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__chips__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__pickers__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__dialogs__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__dividers__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__expansion_panel__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__footer__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__grid__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__icons__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__lists__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__menus__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__navigation_drawer__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__toolbar__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__pagination__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__parallax__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__progress__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__selects__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__selection_controls__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__sliders__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__subheaders__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__steppers__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__tables__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__tabs__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__text_fields__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__transitions__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__snackbars__ = __webpack_require__(129);


































/* harmony default export */ __webpack_exports__["a"] = (Object.assign({}, __WEBPACK_IMPORTED_MODULE_0__alerts__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__app__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__avatars__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__bottom_nav__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__breadcrumbs__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__buttons__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__cards__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__carousel__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8__chips__["a" /* default */], __WEBPACK_IMPORTED_MODULE_9__pickers__["a" /* default */], __WEBPACK_IMPORTED_MODULE_10__dialogs__["a" /* default */], __WEBPACK_IMPORTED_MODULE_11__dividers__["a" /* default */], __WEBPACK_IMPORTED_MODULE_12__expansion_panel__["a" /* default */], __WEBPACK_IMPORTED_MODULE_13__footer__["a" /* default */], __WEBPACK_IMPORTED_MODULE_14__grid__["a" /* default */], __WEBPACK_IMPORTED_MODULE_15__icons__["a" /* default */], __WEBPACK_IMPORTED_MODULE_16__lists__["c" /* default */], __WEBPACK_IMPORTED_MODULE_17__menus__["a" /* default */], __WEBPACK_IMPORTED_MODULE_18__navigation_drawer__["a" /* default */], __WEBPACK_IMPORTED_MODULE_19__toolbar__["a" /* default */], __WEBPACK_IMPORTED_MODULE_20__pagination__["a" /* default */], __WEBPACK_IMPORTED_MODULE_21__parallax__["a" /* default */], __WEBPACK_IMPORTED_MODULE_22__progress__["a" /* default */], __WEBPACK_IMPORTED_MODULE_23__selects__["a" /* default */], __WEBPACK_IMPORTED_MODULE_24__selection_controls__["a" /* default */], __WEBPACK_IMPORTED_MODULE_25__sliders__["a" /* default */], __WEBPACK_IMPORTED_MODULE_26__subheaders__["a" /* default */], __WEBPACK_IMPORTED_MODULE_27__steppers__["a" /* default */], __WEBPACK_IMPORTED_MODULE_28__tables__["a" /* default */], __WEBPACK_IMPORTED_MODULE_29__tabs__["a" /* default */], __WEBPACK_IMPORTED_MODULE_30__text_fields__["a" /* default */], __WEBPACK_IMPORTED_MODULE_31__transitions__["d" /* default */], __WEBPACK_IMPORTED_MODULE_32__snackbars__["a" /* default */]));

/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VAlert__ = __webpack_require__(34);


/* harmony default export */ __webpack_exports__["a"] = ({
  VAlert: __WEBPACK_IMPORTED_MODULE_0__VAlert__["a" /* default */]
});

/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_transitionable__ = __webpack_require__(35);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-alert',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_transitionable__["a" /* default */]],

  props: {
    dismissible: Boolean,
    hideIcon: Boolean,
    icon: String
  },

  computed: {
    classes: function classes() {
      return {
        'alert': true,
        'alert--dismissible': this.dismissible,
        'error': this.error,
        'info': this.info,
        'primary': this.primary,
        'secondary': this.secondary,
        'success': this.success,
        'warning': this.warning
      };
    },
    mdIcon: function mdIcon() {
      switch (true) {
        case !!this.icon:
          return this.icon;
        case this.error:
          return 'warning';
        case this.info:
          return 'info';
        case this.success:
          return 'check_circle';
        case this.warning:
          return 'priority_high';
      }
    }
  },

  render: function render(h) {
    var _this = this;

    var children = [h('div', this.$slots.default)];

    if (!this.hideIcon && this.mdIcon) {
      children.unshift(h('v-icon', {
        'class': 'alert__icon'
      }, this.mdIcon));
    }

    if (this.dismissible) {
      var close = h('a', {
        'class': 'alert__dismissible',
        domProps: { href: 'javascript:;' },
        on: { click: function click() {
            return _this.$emit('input', false);
          } }
      }, [h('v-icon', {
        props: { right: true }
      }, 'cancel')]);

      children.push(close);
    }

    var alert = h('div', {
      'class': this.classes,
      directives: [{
        name: 'show',
        value: this.isActive
      }],
      on: this.$listeners
    }, children);

    if (!this.transition) return alert;

    return h('transition', {
      props: {
        name: this.transition,
        origin: this.origin,
        mode: this.mode
      }
    }, [alert]);
  }
});

/***/ }),
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    mode: String,
    origin: String,
    transition: String
  }
});

/***/ }),
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VApp__ = __webpack_require__(37);


/* harmony default export */ __webpack_exports__["a"] = ({
  VApp: __WEBPACK_IMPORTED_MODULE_0__VApp__["a" /* default */]
});

/***/ }),
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  props: {
    fixedFooter: Boolean,
    footer: Boolean,
    id: {
      type: String,
      default: 'app'
    },
    toolbar: Boolean
  },

  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        children = _ref.children;

    data.staticClass = ('application ' + (data.staticClass || '')).trim();
    data.staticClass += ' application--' + (props.dark ? 'dark' : 'light');

    props.footer && (data.staticClass += ' application--footer');
    props.fixedFooter && (data.staticClass += ' application--footer-fixed');
    props.toolbar && (data.staticClass += ' application--toolbar');

    data.attrs = { 'data-app': true };
    data.domProps = { id: props.id };

    return h('div', data, children);
  }
});

/***/ }),
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VAvatar */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


var VAvatar = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('avatar');

/* harmony default export */ __webpack_exports__["a"] = ({
  VAvatar: VAvatar
});

/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VBottomNav__ = __webpack_require__(40);


/* harmony default export */ __webpack_exports__["a"] = ({
  VBottomNav: __WEBPACK_IMPORTED_MODULE_0__VBottomNav__["a" /* default */]
});

/***/ }),
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  props: {
    absolute: Boolean,
    shift: Boolean,
    value: { required: false }
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;

    data.staticClass = ('bottom-nav ' + (data.staticClass || '')).trim();

    if (props.absolute) data.staticClass += ' bottom-nav--absolute';
    if (props.shift) data.staticClass += ' bottom-nav--shift';
    if (props.value) data.staticClass += ' bottom-nav--active';

    return h('div', data, children);
  }
});

/***/ }),
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VBreadcrumbs__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VBreadcrumbsItem__ = __webpack_require__(43);



/* harmony default export */ __webpack_exports__["a"] = ({
  VBreadcrumbs: __WEBPACK_IMPORTED_MODULE_0__VBreadcrumbs__["a" /* default */],
  VBreadcrumbsItem: __WEBPACK_IMPORTED_MODULE_1__VBreadcrumbsItem__["a" /* default */]
});

/***/ }),
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-breadcrumbs',

  provide: function provide() {
    return {
      divider: this.divider
    };
  },


  props: {
    divider: {
      type: String,
      default: '/'
    },
    icons: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'breadcrumbs': true,
        'breadcrumbs--with-icons': this.icons
      };
    }
  },

  render: function render(h) {
    return h('ul', {
      'class': this.classes,
      props: { items: this.items }
    }, this.$slots.default);
  }
});

/***/ }),
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_route_link__ = __webpack_require__(9);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-breadcrumbs-item',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_route_link__["a" /* default */]],

  inject: ['divider'],

  props: {
    activeClass: {
      type: String,
      default: 'breadcrumbs__item--active'
    }
  },

  computed: {
    classes: function classes() {
      var classes = _defineProperty({
        'breadcrumbs__item': true
      }, this.activeClass, !this.disabled);

      return classes;
    }
  },

  render: function render(h) {
    var _generateRouteLink = this.generateRouteLink(),
        tag = _generateRouteLink.tag,
        data = _generateRouteLink.data;

    return h('li', {
      attrs: { 'data-divider': this.divider }
    }, [h(tag, data, this.$slots.default)]);
  }
});

/***/ }),
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VBtn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VBtnToggle__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VSpeedDial__ = __webpack_require__(46);




/* harmony default export */ __webpack_exports__["a"] = ({
  VBtn: __WEBPACK_IMPORTED_MODULE_0__VBtn__["a" /* default */],
  VBtnToggle: __WEBPACK_IMPORTED_MODULE_1__VBtnToggle__["a" /* default */],
  VSpeedDial: __WEBPACK_IMPORTED_MODULE_2__VSpeedDial__["a" /* default */]
});

/***/ }),
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_buttons_VBtn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_icons_VIcon__ = __webpack_require__(3);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-btn-toggle',

  model: {
    prop: 'inputValue',
    event: 'change'
  },

  props: {
    inputValue: {
      required: false
    },
    items: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    mandatory: Boolean,
    multiple: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'btn-toggle': true,
        'btn-toggle--selected': this.inputValue && (!this.multiple || this.inputValue.length)
      };
    }
  },

  methods: {
    isSelected: function isSelected(item) {
      if (!this.multiple) {
        return this.inputValue === item.value;
      }

      return this.inputValue.includes(item.value);
    },
    updateValue: function updateValue(item) {
      if (!this.multiple) {
        if (this.mandatory && this.inputValue === item.value) return;
        return this.$emit('change', this.inputValue === item.value ? null : item.value);
      }

      var items = this.inputValue.slice();

      var i = items.indexOf(item.value);
      if (i > -1) {
        items.length >= 1 && !this.mandatory && items.splice(i, 1);
      } else {
        items.push(item.value);
      }

      this.$emit('change', items);
    }
  },

  render: function render(h) {
    var _this = this;

    var buttons = this.items.map(function (item, index) {
      var children = [];

      item.text && children.push(h('span', item.text));
      item.icon && children.push(h(__WEBPACK_IMPORTED_MODULE_1__components_icons_VIcon__["a" /* default */], item.icon));

      return h(__WEBPACK_IMPORTED_MODULE_0__components_buttons_VBtn__["a" /* default */], {
        key: index,
        props: {
          flat: true
        },
        on: {
          click: function click(e) {
            e.stopPropagation();
            _this.updateValue(item);
          }
        },
        attrs: {
          'data-selected': _this.isSelected(item),
          'data-index': index,
          'data-only-child': _this.isSelected(item) && (!_this.multiple || _this.inputValue.length === 1)
        }
      }, children);
    });

    return h('div', { class: this.classes }, buttons);
  }
});

/***/ }),
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_toggleable__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_positionable__ = __webpack_require__(12);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-speed-dial',

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_positionable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0__mixins_toggleable__["a" /* default */]],

  props: {
    direction: {
      type: String,
      default: 'top',
      validator: function validator(val) {
        return ['top', 'right', 'bottom', 'left'].includes(val);
      }
    },
    hover: Boolean,
    transition: {
      type: String,
      default: 'scale-transition'
    }
  },

  computed: {
    classes: function classes() {
      return _defineProperty({
        'speed-dial': true,
        'speed-dial--top': this.top,
        'speed-dial--right': this.right,
        'speed-dial--bottom': this.bottom,
        'speed-dial--left': this.left,
        'speed-dial--absolute': this.absolute,
        'speed-dial--fixed': this.fixed
      }, 'speed-dial--direction-' + this.direction, true);
    }
  },

  render: function render(h) {
    var _this = this;

    var children = [];
    var data = {
      'class': this.classes,
      directives: [{
        name: 'click-outside'
      }],
      on: {
        click: function click() {
          return _this.isActive = !_this.isActive;
        }
      }
    };

    if (this.hover) {
      data.on.mouseenter = function () {
        return _this.isActive = true;
      };
      data.on.mouseleave = function () {
        return _this.isActive = false;
      };
    }

    if (this.isActive) {
      children = (this.$slots.default || []).map(function (b, i) {
        b.key = i;

        return b;
      });
    }

    var list = h('transition-group', {
      'class': 'speed-dial__list',
      props: {
        name: this.transition,
        tag: 'div'
      }
    }, children);

    return h('div', data, [this.$slots.activator, list]);
  }
});

/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VCard__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VCardMedia__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VCardTitle__ = __webpack_require__(49);





var VCardActions = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('card__actions');
var VCardText = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('card__text');

/* harmony default export */ __webpack_exports__["a"] = ({
  VCard: __WEBPACK_IMPORTED_MODULE_1__VCard__["a" /* default */],
  VCardActions: VCardActions,
  VCardMedia: __WEBPACK_IMPORTED_MODULE_2__VCardMedia__["a" /* default */],
  VCardText: VCardText,
  VCardTitle: __WEBPACK_IMPORTED_MODULE_3__VCardTitle__["a" /* default */]
});

/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-card-media',

  props: {
    contain: Boolean,
    height: {
      type: [Number, String],
      default: 'auto'
    },
    src: {
      type: String
    }
  },

  render: function render(h) {
    var data = {
      'class': 'card__media',
      style: {
        height: !isNaN(this.height) ? this.height + 'px' : this.height
      },
      on: this.$listeners
    };

    var children = [];

    if (this.src) {
      children.push(h('div', {
        'class': 'card__media__background',
        style: {
          background: 'url(' + this.src + ') center center / ' + (this.contain ? 'contain' : 'cover') + ' no-repeat'
        }
      }));
    }

    children.push(h('div', {
      'class': 'card__media__content'
    }, this.$slots.default));

    return h('div', data, children);
  }
});

/***/ }),
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  props: {
    primaryTitle: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;

    data.staticClass = ('card__title ' + (data.staticClass || '')).trim();

    if (props.primaryTitle) data.staticClass += ' card__title--primary';

    return h('div', data, children);
  }
});

/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VCarousel__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VCarouselItem__ = __webpack_require__(52);



/* harmony default export */ __webpack_exports__["a"] = ({
  VCarousel: __WEBPACK_IMPORTED_MODULE_0__VCarousel__["a" /* default */],
  VCarouselItem: __WEBPACK_IMPORTED_MODULE_1__VCarouselItem__["a" /* default */]
});

/***/ }),
/* 51 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_bootable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_buttons_VBtn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_icons_VIcon__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_themeable__ = __webpack_require__(1);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-carousel',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_bootable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_themeable__["a" /* default */]],

  data: function data() {
    return {
      current: null,
      items: [],
      slideInterval: {},
      reverse: false
    };
  },


  props: {
    cycle: {
      type: Boolean,
      default: true
    },
    icon: {
      type: String,
      default: 'fiber_manual_record'
    },
    interval: {
      type: Number,
      default: 6000
    },
    leftControlIcon: {
      type: [Boolean, String],
      default: 'chevron_left'
    },
    rightControlIcon: {
      type: [Boolean, String],
      default: 'chevron_right'
    }
  },

  computed: {
    defaultState: function defaultState() {
      return {
        current: null,
        reverse: false
      };
    }
  },

  watch: {
    current: function current() {
      var _this = this;

      // Evaluate items when current changes to account for
      // dynamic changing of children
      this.items = this.$children.filter(function (i) {
        return i.$el.classList && i.$el.classList.contains('carousel__item');
      });

      this.items.forEach(function (i) {
        return i.open(_this.items[_this.current]._uid, _this.reverse);
      });

      !this.isBooted && this.cycle && this.restartInterval();
      this.isBooted = true;
    },
    cycle: function cycle(val) {
      val && this.restartInterval() || clearInterval(this.slideInterval);
    }
  },

  mounted: function mounted() {
    this.init();
  },


  methods: {
    genControls: function genControls() {
      return this.$createElement('div', {
        staticClass: 'carousel__controls'
      }, this.genItems());
    },
    genIcon: function genIcon(direction, icon, fn) {
      if (!icon) return null;

      return this.$createElement('div', {
        staticClass: 'carousel__' + direction
      }, [this.$createElement(__WEBPACK_IMPORTED_MODULE_1__components_buttons_VBtn__["a" /* default */], {
        props: {
          icon: true,
          dark: this.dark || !this.light,
          light: this.light
        },
        on: { click: fn }
      }, [this.$createElement(__WEBPACK_IMPORTED_MODULE_2__components_icons_VIcon__["a" /* default */], icon)])]);
    },
    genItems: function genItems() {
      var _this2 = this;

      return this.items.map(function (item, index) {
        return _this2.$createElement(__WEBPACK_IMPORTED_MODULE_1__components_buttons_VBtn__["a" /* default */], {
          class: {
            'carousel__controls__item': true,
            'carousel__controls__item--active': index === _this2.current
          },
          props: {
            icon: true,
            dark: _this2.dark || !_this2.light,
            light: _this2.light
          },
          key: index,
          on: { click: _this2.select.bind(_this2, index) }
        }, [_this2.$createElement(__WEBPACK_IMPORTED_MODULE_2__components_icons_VIcon__["a" /* default */], _this2.icon)]);
      });
    },
    restartInterval: function restartInterval() {
      clearInterval(this.slideInterval);
      this.$nextTick(this.startInterval);
    },
    init: function init() {
      this.current = 0;
    },
    next: function next() {
      this.reverse = false;

      if (this.current + 1 === this.items.length) {
        return this.current = 0;
      }

      this.current++;
    },
    prev: function prev() {
      this.reverse = true;

      if (this.current - 1 < 0) {
        return this.current = this.items.length - 1;
      }

      this.current--;
    },
    select: function select(index) {
      this.reverse = index < this.current;
      this.current = index;
    },
    startInterval: function startInterval() {
      this.slideInterval = setInterval(this.next, this.interval);
    }
  },

  render: function render(h) {
    return h('div', {
      staticClass: 'carousel',
      directives: [{
        name: 'touch',
        value: {
          left: this.next,
          right: this.prev
        }
      }]
    }, [this.genIcon('left', this.leftControlIcon, this.prev), this.genIcon('right', this.rightControlIcon, this.next), this.genControls(), this.$slots.default]);
  }
});

/***/ }),
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-carousel-item',

  data: function data() {
    return {
      active: false,
      reverse: false
    };
  },


  props: {
    src: {
      type: String,
      required: true
    },

    transition: {
      type: String,
      default: 'tab-transition'
    },

    reverseTransition: {
      type: String,
      default: 'tab-reverse-transition'
    }
  },

  computed: {
    computedTransition: function computedTransition() {
      return this.reverse ? this.reverseTransition : this.transition;
    },
    styles: function styles() {
      return {
        backgroundImage: 'url(' + this.src + ')'
      };
    }
  },

  methods: {
    open: function open(id, reverse) {
      this.active = this._uid === id;
      this.reverse = reverse;
    }
  },

  render: function render(h) {
    var item = h('div', {
      class: {
        'carousel__item': true,
        'reverse': this.reverse
      },
      style: this.styles,
      on: this.$listeners,
      directives: [{
        name: 'show',
        value: this.active
      }]
    }, [this.$slots.default]);

    return h('transition', { props: { name: this.computedTransition } }, [item]);
  }
});

/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VChip__ = __webpack_require__(54);


/* harmony default export */ __webpack_exports__["a"] = ({
  VChip: __WEBPACK_IMPORTED_MODULE_0__VChip__["a" /* default */]
});

/***/ }),
/* 54 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_toggleable__ = __webpack_require__(2);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-chip',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_toggleable__["a" /* default */]],

  props: {
    close: Boolean,
    label: Boolean,
    outline: Boolean,
    small: Boolean,
    value: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    classes: function classes() {
      return {
        'chip': true,
        'chip--label': this.label,
        'chip--outline': this.outline,
        'chip--small': this.small,
        'chip--removable': this.close
      };
    }
  },

  render: function render(h) {
    var _this = this;

    var children = [this.$slots.default];
    var data = {
      'class': this.classes,
      attrs: { tabindex: -1 },
      directives: [{
        name: 'show',
        value: this.isActive
      }],
      on: this.$listeners
    };

    if (this.close) {
      children.push(h('a', {
        'class': 'chip__close',
        domProps: { href: 'javascript:;' },
        on: {
          click: function click(e) {
            e.stopPropagation();

            _this.$emit('input', false);
          }
        }
      }, [h('v-icon', { props: { right: true } }, 'cancel')]));
    }

    return h('span', data, children);
  }
});

/***/ }),
/* 55 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VDatePicker__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VTimePicker__ = __webpack_require__(61);



/* harmony default export */ __webpack_exports__["a"] = ({
  VDatePicker: __WEBPACK_IMPORTED_MODULE_0__VDatePicker__["a" /* default */],
  VTimePicker: __WEBPACK_IMPORTED_MODULE_1__VTimePicker__["a" /* default */]
});

/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_date_title__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_date_header__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_date_table__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_date_years__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_picker__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_helpers__ = __webpack_require__(0);







var defaultDateFormat = function defaultDateFormat(val) {
  return new Date(val).toISOString().substr(0, 10);
};

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-date-picker',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_date_title__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_date_header__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_date_table__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_date_years__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_picker__["a" /* default */]],

  data: function data() {
    return {
      tableDate: new Date(),
      originalDate: this.value,
      currentDay: null,
      currentMonth: null,
      currentYear: null,
      isSelected: false,
      isReversing: false,
      narrowDays: []
    };
  },


  props: {
    locale: {
      type: String,
      default: 'en-us'
    },
    dateFormat: {
      type: Function,
      default: defaultDateFormat
    },
    titleDateFormat: {
      type: Object,
      default: function _default() {
        return { weekday: 'short', month: 'short', day: 'numeric' };
      }
    },
    headerDateFormat: {
      type: Object,
      default: function _default() {
        return { month: 'long', year: 'numeric' };
      }
    },
    formattedValue: {
      required: false
    },
    allowedDates: {
      type: [Array, Object, Function],
      default: function _default() {
        return null;
      }
    },
    firstDayOfWeek: {
      type: [String, Number],
      default: 0
    },
    yearIcon: String
  },

  computed: {
    firstAllowedDate: function firstAllowedDate() {
      var date = new Date();
      date.setHours(12, 0, 0, 0);

      if (this.allowedDates) {
        var millisecondOffset = 1 * 24 * 60 * 60 * 1000;
        var valid = new Date(date);
        for (var i = 0; i < 31; i++) {
          if (this.isAllowed(valid)) return valid;

          valid.setTime(valid.getTime() + millisecondOffset);
        }
      }

      return date;
    },

    inputDate: {
      get: function get() {
        if (!this.value) return this.firstAllowedDate;
        if (this.value instanceof Date) return this.value;
        if (!isNaN(this.value) || typeof this.value === 'string' && this.value.indexOf(':') !== -1) return new Date(this.value);

        return new Date(this.value + 'T12:00:00');
      },
      set: function set(val) {
        this.$emit('input', val ? defaultDateFormat(val) : this.originalDate);
        this.$emit('update:formattedValue', val ? this.dateFormat(val) : this.dateFormat(this.originalDate));
      }
    },
    day: function day() {
      return this.inputDate.getDate();
    },
    month: function month() {
      return this.inputDate.getMonth();
    },
    year: function year() {
      return this.inputDate.getFullYear();
    },
    tableMonth: function tableMonth() {
      return this.tableDate.getMonth();
    },
    tableYear: function tableYear() {
      return this.tableDate.getFullYear();
    },
    computedTransition: function computedTransition() {
      return this.isReversing ? 'v-tab-reverse-transition' : 'v-tab-transition';
    }
  },

  watch: {
    isSelected: function isSelected(val) {
      var _this = this;

      val && this.$nextTick(function () {
        _this.$refs.years.scrollTop = _this.$refs.years.scrollHeight / 2 - 125;
      });
    },
    tableDate: function tableDate(val, prev) {
      this.isReversing = val < prev;
    },
    value: function value(val) {
      if (val) this.tableDate = this.inputDate;
    }
  },

  methods: {
    save: function save() {
      if (this.originalDate) {
        this.originalDate = this.value;
      } else {
        this.originalDate = this.inputDate;
      }

      if (this.$parent && this.$parent.isActive) this.$parent.isActive = false;
    },
    cancel: function cancel() {
      this.inputDate = this.originalDate;
      if (this.$parent && this.$parent.isActive) this.$parent.isActive = false;
    },
    isAllowed: function isAllowed(date) {
      if (!this.allowedDates) return true;

      if (Array.isArray(this.allowedDates)) {
        return !!this.allowedDates.find(function (allowedDate) {
          var d = new Date(allowedDate);
          d.setHours(12, 0, 0, 0);

          return d - date === 0;
        });
      } else if (this.allowedDates instanceof Function) {
        return this.allowedDates(date);
      } else if (this.allowedDates instanceof Object) {
        var min = new Date(this.allowedDates.min);
        min.setHours(12, 0, 0, 0);
        var max = new Date(this.allowedDates.max);
        max.setHours(12, 0, 0, 0);

        return date >= min && date <= max;
      }

      return true;
    }
  },

  created: function created() {
    var _this2 = this;

    var date = new Date();
    date.setDate(date.getDate() - date.getDay() + parseInt(this.firstDayOfWeek));

    Object(__WEBPACK_IMPORTED_MODULE_5__util_helpers__["c" /* createRange */])(7).forEach(function () {
      var narrow = date.toLocaleString(_this2.locale, { weekday: 'narrow' });
      _this2.narrowDays.push(narrow);

      date.setDate(date.getDate() + 1);
    });
  },
  mounted: function mounted() {
    this.currentDay = this.tableDate.getDate();
    this.currentMonth = this.tableDate.getMonth();
    this.currentYear = this.tableDate.getFullYear();
    this.tableDate = this.inputDate;
  },
  render: function render(h) {
    var children = [];

    !this.noTitle && children.push(this.genTitle());

    if (!this.isSelected) {
      var bodyChildren = [];

      bodyChildren.push(this.genHeader());
      bodyChildren.push(this.genTable());

      children.push(h('div', {
        'class': 'picker__body'
      }, bodyChildren));
    } else {
      children.push(this.genYears());
    }

    this.$scopedSlots.default && children.push(this.genSlot());

    return h('v-card', {
      'class': {
        'picker picker--date': true,
        'picker--landscape': this.landscape,
        'picker--dark': this.dark,
        'picker--light': this.light && !this.dark
      }
    }, children);
  }
});

/***/ }),
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genYearIcon: function genYearIcon() {
      return this.yearIcon ? this.$createElement('v-icon', {
        props: {
          dark: true
        }
      }, this.yearIcon) : null;
    },
    genTitle: function genTitle() {
      var _this = this;

      var date = new Date(this.year, this.month, this.day);
      date = date.toLocaleString(this.locale, this.titleDateFormat);

      if (this.landscape) {
        if (date.indexOf(',') > -1) date = date.replace(',', ',<br>');else if (date.indexOf(' ') > -1) date = date.replace(' ', '<br>');
      }

      var text = this.$createElement('transition', {
        props: {
          name: 'slide-x-transition',
          mode: 'out-in'
        }
      }, [this.$createElement('div', {
        domProps: { innerHTML: date },
        key: date
      })]);

      return this.$createElement('div', {
        'class': 'picker__title'
      }, [this.$createElement('div', {
        'class': {
          'picker--date__title-year': true,
          'active': this.isSelected
        },
        on: {
          click: function click(e) {
            e.stopPropagation();
            _this.isSelected = true;
          }
        }
      }, [this.year, this.genYearIcon()]), this.$createElement('div', {
        'class': {
          'picker--date__title-date': true,
          'active': !this.isSelected
        },
        on: {
          click: function click(e) {
            e.stopPropagation();
            _this.isSelected = false;
          }
        }
      }, [text])]);
    }
  }
});

/***/ }),
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genHeader: function genHeader() {
      return this.$createElement('div', {
        'class': 'picker--date__header'
      }, [this.genSelector()]);
    },
    genBtn: function genBtn(change, children) {
      var _this = this;

      return this.$createElement('v-btn', {
        props: {
          dark: this.dark,
          icon: true
        },
        nativeOn: {
          click: function click(e) {
            e.stopPropagation();
            _this.tableDate = new Date(_this.tableYear, change);
          }
        }
      }, children);
    },
    genSelector: function genSelector() {
      var date = new Date(this.tableYear, this.tableMonth);
      var header = this.$createElement('div', {
        'class': 'picker--date__header-selector-date'
      }, [this.$createElement(this.computedTransition, [this.$createElement('strong', {
        key: this.tableMonth
      }, date.toLocaleString(this.locale, this.headerDateFormat))])]);

      return this.$createElement('div', {
        'class': 'picker--date__header-selector'
      }, [this.genBtn(this.tableMonth - 1, [this.$createElement('v-icon', 'chevron_left')]), header, this.genBtn(this.tableMonth + 1, [this.$createElement('v-icon', 'chevron_right')])]);
    }
  }
});

/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    wheelScroll: function wheelScroll(e) {
      e.preventDefault();

      var month = this.tableMonth;

      if (e.deltaY < 0) month++;else month--;

      this.tableDate = new Date(this.tableYear, month);
    },
    touch: function touch(value) {
      this.tableDate = new Date(this.tableYear, this.tableMonth + value);
    },
    genTable: function genTable() {
      var _this = this;

      var children = [];
      var data = {
        'class': 'picker--date__table',
        directives: [{
          name: 'touch',
          value: {
            left: function left(e) {
              return e.offsetX < -15 && _this.touch(1);
            },
            right: function right(e) {
              return e.offsetX > 15 && _this.touch(-1);
            }
          }
        }]
      };

      if (this.scrollable) {
        data.on = { wheel: this.wheelScroll };
      }

      children.push(this.$createElement('table', {
        key: this.tableMonth
      }, [this.genTHead(), this.genTBody()]));

      return this.$createElement('div', data, [this.$createElement(this.computedTransition, children)]);
    },
    genTHead: function genTHead() {
      var _this2 = this;

      var days = this.narrowDays.map(function (day) {
        return _this2.$createElement('th', day);
      });
      return this.$createElement('thead', this.genTR(days));
    },
    genTBody: function genTBody() {
      var _this3 = this;

      var children = [];
      var rows = [];
      var length = new Date(this.tableYear, this.tableMonth + 1, 0).getDate();

      var day = new Date(this.tableYear, this.tableMonth).getDay() - parseInt(this.firstDayOfWeek);

      for (var i = 0; i < day; i++) {
        rows.push(this.$createElement('td'));
      }

      var _loop = function _loop(_i) {
        var date = new Date(_this3.tableYear, _this3.tableMonth, _i, 12, 0, 0, 0);
        rows.push(_this3.$createElement('td', [_this3.$createElement('button', {
          'class': {
            'btn btn--floating btn--small btn--flat': true,
            'btn--active': _this3.isActive(_i),
            'btn--current': _this3.isCurrent(_i),
            'btn--light': _this3.dark,
            'btn--disabled': !_this3.isAllowed(date)
          },
          attrs: {
            type: 'button'
          },
          domProps: {
            innerHTML: '<span class="btn__content">' + _i + '</span>'
          },
          on: {
            click: function click() {
              var day = _i < 10 ? '0' + _i : _i;
              var tableYear = _this3.tableYear;
              var tableMonth = _this3.tableMonth + 1;
              tableMonth = tableMonth < 10 ? '0' + tableMonth : tableMonth;

              _this3.inputDate = tableYear + '-' + tableMonth + '-' + day + 'T12:00:00';
              _this3.$nextTick(function () {
                return _this3.autosave && _this3.save();
              });
            }
          }
        })]));

        if (rows.length % 7 === 0) {
          children.push(_this3.genTR(rows));
          rows = [];
        }
      };

      for (var _i = 1; _i <= length; _i++) {
        _loop(_i);
      }

      if (rows.length) {
        children.push(this.genTR(rows));
      }

      children.length < 6 && children.push(this.genTR([this.$createElement('td', { domProps: { innerHTML: '&nbsp;' } })]));

      return this.$createElement('tbody', children);
    },
    genTR: function genTR() {
      var children = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      return [this.$createElement('tr', data, children)];
    },
    isActive: function isActive(i) {
      return this.tableYear === this.year && this.tableMonth === this.month && this.day === i;
    },
    isCurrent: function isCurrent(i) {
      return this.currentYear === this.tableYear && this.currentMonth === this.tableMonth && this.currentDay === i;
    }
  }
});

/***/ }),
/* 60 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genYears: function genYears() {
      return this.$createElement('ul', {
        'class': 'picker--date__years',
        ref: 'years'
      }, this.genYearItems());
    },
    genYearItems: function genYearItems() {
      var _this = this;

      var children = [];

      var _loop = function _loop(i, length) {
        children.push(_this.$createElement('li', {
          'class': {
            active: _this.year === i
          },
          on: {
            click: function click(e) {
              e.stopPropagation();

              var tableMonth = _this.tableMonth + 1;
              var day = _this.day;
              tableMonth = tableMonth < 10 ? '0' + tableMonth : tableMonth;
              day = day < 10 ? '0' + day : day;

              _this.inputDate = i + '-' + tableMonth + '-' + day;
              _this.isSelected = false;
            }
          }
        }, i));
      };

      for (var i = this.year + 100, length = this.year - 100; i > length; i--) {
        _loop(i, length);
      }
      return children;
    }
  }
});

/***/ }),
/* 61 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_picker__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_time_title__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_time_body__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_helpers__ = __webpack_require__(0);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-time-picker',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_picker__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_time_body__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_time_title__["a" /* default */]],

  data: function data() {
    return {
      isDragging: false,
      rotate: 0,
      originalTime: this.value,
      period: 'am',
      selectingHour: true,
      ranges: {
        hours: Object(__WEBPACK_IMPORTED_MODULE_3__util_helpers__["c" /* createRange */])(24),
        minutes: Object(__WEBPACK_IMPORTED_MODULE_3__util_helpers__["c" /* createRange */])(60)
      }
    };
  },


  props: {
    format: {
      type: String,
      default: 'ampm',
      validator: function validator(val) {
        return ['ampm', '24hr'].includes(val);
      }
    },
    allowedHours: {
      type: [Array, Object, Function],
      default: function _default() {
        return null;
      }
    },
    allowedMinutes: {
      type: [Array, Object, Function],
      default: function _default() {
        return null;
      }
    }
  },

  computed: {
    is24hr: function is24hr() {
      return this.format !== 'ampm';
    },
    is24hrAfter12: function is24hrAfter12() {
      return this.selectingHour && this.is24hr && this.hour >= 12;
    },
    divider: function divider() {
      return this.selectingHour ? 12 : 60;
    },
    degrees: function degrees() {
      return this.degreesPerUnit * Math.PI / 180;
    },
    degreesPerUnit: function degreesPerUnit() {
      return 360 / this.divider;
    },

    inputTime: {
      get: function get() {
        if (this.value && !(this.value instanceof Date)) {
          if (!this.is24hr) {
            this.period = this.value.match(/pm/) ? 'pm' : 'am';
          }

          return this.value;
        }
        var value = new Date();

        if (this.value instanceof Date) {
          value = this.value;
        }

        var hour = value.getHours();
        var minute = value.getMinutes();
        var period = '';

        if (!this.is24hr) {
          hour = hour > 12 ? hour - 12 : hour;
          period = hour > 12 ? 'pm' : 'am';
        }

        period && (this.period = period);

        hour = this.firstAllowed('hour', hour);
        minute = this.firstAllowed('minute', minute);

        return hour + ':' + minute + period;
      },
      set: function set(val) {
        return this.$emit('input', val);
      }
    },
    timeArray: function timeArray() {
      return this.inputTime.replace(/(am|pm)/, '').split(':');
    },

    hour: {
      get: function get() {
        return parseInt(this.timeArray[0]);
      },
      set: function set(val) {
        if (!this.is24hr) {
          val = val > 12 ? val - 12 : val < 1 ? 12 : val;
        } else {
          val = val < 10 ? '0' + val : val > 23 ? '00' : val;
        }

        this.inputTime = val + ':' + this.minute + (!this.is24hr ? this.period : '');
      }
    },
    minute: {
      get: function get() {
        var minute = parseInt(this.timeArray[1]);

        return minute < 10 ? '0' + minute : minute > 59 ? '00' : minute;
      },
      set: function set(val) {
        val = val < 10 ? '0' + parseInt(val) : val > 59 ? '00' : val;
        var hour = this.hour;

        if (this.is24hr && hour < 10) {
          hour = '0' + hour;
        }

        this.inputTime = hour + ':' + val + (!this.is24hr ? this.period : '');
      }
    },
    clockHand: function clockHand() {
      if (this.selectingHour) return this.degreesPerUnit * this.hour;
      return this.degreesPerUnit * this.minute;
    },
    radius: function radius() {
      return this.clockSize / 2;
    },

    clockSize: {
      get: function get() {
        return this.size;
      },
      set: function set(val) {
        this.size = val;
      }
    },
    size: function size() {
      return this.landscape ? 250 : 280;
    }
  },

  watch: {
    period: function period(val) {
      var hour = !!this.allowedHours && this.selectingHour ? this.firstAllowed('hour', this.hour - 1) : this.hour;
      this.inputTime = hour + ':' + this.minute + val;
    },
    value: function value(val) {
      if (this.isSaving) {
        this.originalTime = this.inputTime;
        this.isSaving = false;
      }
    }
  },

  methods: {
    save: function save() {
      if (this.originalTime) {
        this.originalTime = this.value;
      } else {
        this.inputTime = this.inputTime;
        this.originalTime = this.inputTime;
      }

      if (this.$parent && this.$parent.isActive) this.$parent.isActive = false;
    },
    cancel: function cancel() {
      this.inputTime = this.originalTime;
      if (this.$parent && this.$parent.isActive) this.$parent.isActive = false;
    },
    isAllowed: function isAllowed(type, value) {
      var allowed = this['allowed' + (type.charAt(0).toUpperCase() + type.slice(1)) + 's'];

      if (!allowed) return true;

      if (Array.isArray(allowed)) {
        return !!allowed.find(function (v) {
          return v === value;
        });
      } else if (allowed instanceof Function) {
        return allowed(value);
      } else if (allowed === Object(allowed)) {
        var range = type === 'minute' ? this.ranges.minutes : this.ranges.hours;
        var mod = type === 'minute' ? 60 : 24;

        if (allowed.min === String(allowed.min)) {
          allowed.min = this.convert12to24hr(allowed.min);
        }

        if (allowed.max === String(allowed.max)) {
          allowed.max = this.convert12to24hr(allowed.max);
        }

        var steps = allowed.max - allowed.min;
        value = type === 'hour' && !this.is24hr && this.period === 'pm' ? value + 12 : value;

        for (var i = 0; i <= steps; i++) {
          var index = (allowed.min + i) % mod;
          if (range[index] === value) return true;
        }

        return false;
      }

      return true;
    },
    convert12to24hr: function convert12to24hr(input) {
      input = input.toLowerCase();
      var pm = input.indexOf('pm') !== -1;
      var hour = parseInt(input.slice(0, input.indexOf(pm ? 'pm' : 'am')));

      return pm ? hour + 12 : hour;
    },
    generateRange: function generateRange(type, start) {
      var range = type === 'hour' ? this.ranges.hours : this.ranges.minutes;
      var offset = 1;

      if (type === 'hour' && !this.is24hr) {
        range = range.slice(1, 13);
        offset = 0;
      }

      return range.slice(start + offset, range.length).concat(range.slice(0, start + offset));
    },
    firstAllowed: function firstAllowed(type, value) {
      var _this = this;

      var allowed = this['allowed' + (type.charAt(0).toUpperCase() + type.slice(1)) + 's'];

      if (!allowed) return value;

      var range = this.generateRange(type, value);

      var first = range.find(function (v) {
        return _this.isAllowed(type, v);
      });

      return first || value;
    }
  },

  render: function render(h) {
    var children = [this.genBody()];

    !this.noTitle && children.unshift(this.genTitle());
    this.$scopedSlots.default && children.push(this.genSlot());

    return h('v-card', {
      'class': {
        'picker picker--time': true,
        'picker--landscape': this.landscape,
        'picker--dark': this.dark,
        'picker--light': this.light && !this.dark,
        'picker--time--hours': this.selectingHour
      }
    }, children);
  }
});

/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genTitle: function genTitle() {
      var children = [this.genTime()];

      if (this.format === 'ampm') {
        children.push(this.genAMPM());
      }

      return this.$createElement('div', {
        'class': 'picker__title'
      }, children);
    },
    genTime: function genTime() {
      var _this = this;

      var hour = this.hour;

      if (this.is24hr && hour < 10) {
        hour = '0' + hour;
      }

      return this.$createElement('div', {
        'class': 'picker--time__title'
      }, [this.$createElement('span', {
        'class': { active: this.selectingHour },
        on: {
          click: function click() {
            return _this.selectingHour = true;
          }
        }
      }, hour), this.$createElement('span', {
        'class': { active: !this.selectingHour },
        on: {
          click: function click() {
            return _this.selectingHour = false;
          }
        }
      }, ':' + this.minute)]);
    },
    genAMPM: function genAMPM() {
      return this.$createElement('div', [this.genPeriod('am'), this.genPeriod('pm')]);
    },
    genPeriod: function genPeriod(period) {
      var _this2 = this;

      return this.$createElement('span', {
        'class': { active: this.period === period },
        on: { click: function click() {
            return _this2.period = period;
          } }
      }, period.toUpperCase());
    }
  }
});

/***/ }),
/* 63 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      hasChanged: false
    };
  },

  methods: {
    genBody: function genBody() {
      var _this = this;

      var children = [this.genHand(this.selectingHour ? 'hour' : 'minute')];
      var data = {
        'class': 'picker--time__clock',
        on: {
          mousedown: this.onMouseDown,
          mouseup: this.onMouseUp,
          mouseleave: function mouseleave() {
            _this.isDragging && _this.onMouseUp();
          },
          touchstart: this.onMouseDown,
          touchend: this.onMouseUp,
          mousemove: this.onDragMove,
          touchmove: this.onDragMove
        },
        key: this.selectingHour ? 'hour' : 'minute',
        ref: 'clock'
      };

      this.selectingHour && children.push(this.genHours()) || children.push(this.genMinutes());

      if (this.scrollable) {
        data.on.wheel = function (e) {
          e.preventDefault();

          var diff = e.wheelDelta > 0 ? 1 : -1;
          var changing = _this.selectingHour ? 'changeHour' : 'changeMinute';

          _this[changing](diff);
        };
      }

      return this.$createElement('div', {
        'class': 'picker__body'
      }, [this.$createElement('v-fade-transition', {
        props: { mode: 'out-in' }
      }, [this.$createElement('div', data, children)])]);
    },
    genHand: function genHand(type) {
      var scale = this.is24hrAfter12 ? 'scaleY(0.6)' : '';
      return [this.$createElement('div', {
        'class': 'picker--time__clock-hand ' + type,
        style: {
          transform: 'rotate(' + this.clockHand + 'deg) ' + scale
        }
      })];
    },
    genHours: function genHours() {
      var hours = this.is24hr ? 24 : 12;
      var children = [];
      var start = 0;

      if (hours === 12) {
        hours++;
        start = 1;
      }

      for (var i = start; i < hours; i++) {
        children.push(this.$createElement('span', {
          'class': {
            'active': i === this.hour,
            'disabled': !this.isAllowed('hour', i)
          },
          style: this.getTransform(i),
          domProps: { innerHTML: '<span>' + i + '</span>' }
        }));
      }

      return children;
    },
    genMinutes: function genMinutes() {
      var children = [];

      for (var i = 0; i < 60; i = i + 5) {
        var num = i;

        if (num < 10) num = '0' + num;
        if (num === 60) num = '00';

        children.push(this.$createElement('span', {
          'class': {
            'active': num.toString() === this.minute.toString(),
            'disabled': !this.isAllowed('minute', i)
          },
          style: this.getTransform(i),
          domProps: { innerHTML: '<span>' + num + '</span>' }
        }));
      }

      return children;
    },
    getTransform: function getTransform(i) {
      var _getPosition = this.getPosition(i),
          x = _getPosition.x,
          y = _getPosition.y;

      return { transform: 'translate(' + x + 'px, ' + y + 'px)' };
    },
    getPosition: function getPosition(i) {
      var radiusPercentage = this.selectingHour && this.is24hr && i >= 12 ? 0.5 : 0.8;
      var r = this.radius * radiusPercentage;
      i = this.selectingHour && this.is24hr ? i % 12 : i;
      return {
        x: Math.round(Math.sin(i * this.degrees) * r),
        y: Math.round(-Math.cos(i * this.degrees) * r)
      };
    },
    changeHour: function changeHour(time) {
      var _this2 = this;

      var range = this.generateRange('hour', this.hour);

      time < 0 && (range = range.reverse().slice(1));
      this.hour = range.find(function (h) {
        return _this2.allowedHours ? _this2.isAllowed('hour', h) : true;
      });

      return true;
    },
    changeMinute: function changeMinute(time) {
      var _this3 = this;

      var current = Number(this.minute);
      var range = this.generateRange('minute', current);

      time < 0 && (range = range.reverse().slice(1));
      var minute = range.find(function (m) {
        return _this3.allowedMinutes ? _this3.isAllowed('minute', m) : true;
      });

      this.minute = minute < 10 ? '0' + minute : minute;

      return true;
    },
    onMouseDown: function onMouseDown(e) {
      e.preventDefault();

      this.isDragging = true;
      this.onDragMove(e);
    },
    onMouseUp: function onMouseUp() {
      this.isDragging = false;
      !this.selectingHour && this.autosave && this.save();
      if (this.hasChanged) {
        this.selectingHour = false;
        this.hasChanged = false;
      }
    },
    onDragMove: function onDragMove(e) {
      e.preventDefault();
      if (!this.isDragging && e.type !== 'click') return;

      var rect = this.$refs.clock.getBoundingClientRect();
      var center = { x: rect.width / 2, y: 0 - rect.width / 2 };
      var clientY = 'touches' in e ? e.touches[0].clientY : e.clientY;
      var clientX = 'touches' in e ? e.touches[0].clientX : e.clientX;
      var coords = {
        y: rect.top - clientY,
        x: clientX - rect.left
      };

      var selecting = this.selectingHour ? 'hour' : 'minute';
      var value = Math.round(this.angle(center, coords) / this.degreesPerUnit);

      if (this.selectingHour && this.is24hr) {
        var insideClick = this.euclidean(center, coords) / this.radius < 0.65;
        value = insideClick ? value + 12 : value;

        // Necessary to fix edge case when selecting left part of 0 and 12
        value = this.angle(center, coords) >= 345 ? (value + 12) % 24 : value;
      }

      if (this.isAllowed(selecting, value)) {
        this[selecting] = value;
        this.hasChanged = true;
      }
    },
    euclidean: function euclidean(p0, p1) {
      var dx = Math.abs(p1.x - p0.x);
      var dy = Math.abs(p1.y - p0.y);

      return Math.sqrt(dx * dx + dy * dy);
    },
    angle: function angle(center, p1) {
      var p0 = {
        x: center.x,
        y: center.y + Math.sqrt(Math.abs(p1.x - center.x) * Math.abs(p1.x - center.x) + Math.abs(p1.y - center.y) * Math.abs(p1.y - center.y))
      };

      var value = 2 * Math.atan2(p1.y - p0.y, p1.x - p0.x);
      return Math.abs(value * 180 / Math.PI);
    }
  }
});

/***/ }),
/* 64 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VDialog__ = __webpack_require__(65);


/* harmony default export */ __webpack_exports__["a"] = ({
  VDialog: __WEBPACK_IMPORTED_MODULE_0__VDialog__["a" /* default */]
});

/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_bootable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_detachable__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_overlayable__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_toggleable__ = __webpack_require__(2);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-dialog',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_bootable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_detachable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_overlayable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_toggleable__["a" /* default */]],

  props: {
    disabled: Boolean,
    persistent: Boolean,
    fullscreen: Boolean,
    fullWidth: Boolean,
    lazy: Boolean,
    origin: {
      type: String,
      default: 'center center'
    },
    width: {
      type: [String, Number],
      default: 290
    },
    scrollable: Boolean,
    transition: {
      type: [String, Boolean],
      default: 'dialog-transition'
    }
  },

  computed: {
    classes: function classes() {
      return {
        'dialog': true,
        'dialog--active': this.isActive,
        'dialog--persistent': this.persistent,
        'dialog--fullscreen': this.fullscreen,
        'dialog--stacked-actions': this.stackedActions && !this.fullscreen,
        'dialog--scrollable': this.scrollable
      };
    }
  },

  watch: {
    isActive: function isActive(val) {
      if (val) {
        !this.fullscreen && !this.hideOverlay && this.genOverlay();
        this.fullscreen && this.hideScroll();
      } else {
        if (!this.fullscreen) this.removeOverlay();else this.showScroll();
      }
    }
  },

  mounted: function mounted() {
    var _this = this;

    this.isBooted = this.isActive;
    this.$vuetify.load(function () {
      return _this.isActive && _this.genOverlay();
    });
  },


  methods: {
    closeConditional: function closeConditional(e) {
      // close dialog if !persistent and clicked outside
      return !this.persistent;
    }
  },

  render: function render(h) {
    var _this2 = this;

    var children = [];
    var data = {
      'class': this.classes,
      ref: 'dialog',
      directives: [{ name: 'click-outside', value: this.closeConditional }, { name: 'show', value: this.isActive }]
    };

    if (!this.fullscreen) {
      data.style = {
        width: isNaN(this.width) ? this.width : this.width + 'px'
      };
    }

    if (this.$slots.activator) {
      children.push(h('div', {
        'class': 'dialog__activator',
        on: {
          click: function click(e) {
            e.stopPropagation();
            if (!_this2.disabled) _this2.isActive = !_this2.isActive;
          }
        }
      }, [this.$slots.activator]));
    }

    var dialog = h('transition', {
      props: {
        name: this.transition || '', // If false, show nothing
        origin: this.origin
      }
    }, [h('div', data, this.showLazyContent(this.$slots.default))]);

    children.push(h('div', {
      'class': ('dialog__content ' + this.contentClass).trim(),
      ref: 'content'
    }, [dialog]));

    return h('div', {
      'class': 'dialog__container',
      style: {
        display: !this.$slots.activator && 'none' || this.fullWidth ? 'block' : 'inline-block'
      }
    }, children);
  }
});

/***/ }),
/* 66 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VDivider__ = __webpack_require__(67);


/* harmony default export */ __webpack_exports__["a"] = ({
  VDivider: __WEBPACK_IMPORTED_MODULE_0__VDivider__["a" /* default */]
});

/***/ }),
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  props: {
    inset: Boolean
  },

  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        children = _ref.children;

    data.staticClass = ('divider ' + (data.staticClass || '')).trim();

    if (props.dark) data.staticClass += ' theme--dark';
    if (props.inset) data.staticClass += ' divider--inset';
    if (props.light) data.staticClass += ' theme--light';

    return h('hr', data);
  }
});

/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VExpansionPanel__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VExpansionPanelContent__ = __webpack_require__(70);



/* harmony default export */ __webpack_exports__["a"] = ({
  VExpansionPanel: __WEBPACK_IMPORTED_MODULE_0__VExpansionPanel__["a" /* default */],
  VExpansionPanelContent: __WEBPACK_IMPORTED_MODULE_1__VExpansionPanelContent__["a" /* default */]
});

/***/ }),
/* 69 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-expansion-panel',

  props: {
    expand: Boolean
  },

  computed: {
    params: function params() {
      return {
        expand: this.expand
      };
    }
  },

  render: function render(h) {
    return h('ul', {
      'class': 'expansion-panel'
    }, this.$slots.default);
  }
});

/***/ }),
/* 70 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_transitions__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__ = __webpack_require__(2);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-expansion-panel-content',

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__["a" /* default */]],

  data: function data() {
    return {
      height: 'auto'
    };
  },


  props: {
    ripple: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'expansion-panel__header': true,
        'expansion-panel__header--active': this.isActive
      };
    }
  },

  methods: {
    closeConditional: function closeConditional(e) {
      return this.$parent.$el.contains(e.target) && !this.$parent.expand && !this.$el.contains(e.target);
    },
    toggle: function toggle() {
      this.isActive = !this.isActive;
    },
    genHeader: function genHeader(h) {
      var _this = this;

      return h('div', {
        class: this.classes,
        directives: [{
          name: 'click-outside',
          value: this.closeConditional
        }, {
          name: 'ripple',
          value: this.ripple
        }],
        on: {
          click: function click() {
            _this.isActive = !_this.isActive;
          }
        }
      }, [this.$slots.header]);
    },
    genBody: function genBody(h) {
      return h('div', {
        ref: 'body',
        class: 'expansion-panel__body',
        directives: [{
          name: 'show',
          value: this.isActive
        }]
      }, [this.$slots.default]);
    }
  },

  render: function render(h) {
    var children = [];

    this.$slots.header && children.push(this.genHeader(h));
    children.push(h(__WEBPACK_IMPORTED_MODULE_0__components_transitions__["a" /* VExpandTransition */], [this.genBody(h)]));

    return h('li', children);
  }
});

/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


/* harmony default export */ __webpack_exports__["a"] = ({
  enter: function enter(el, done) {
    // Remove initial transition
    el.style.transition = 'none';
    Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["a" /* addOnceEventListener */])(el, 'transitionend', done);

    // Get height that is to be scrolled
    el.style.overflow = 'hidden';
    el.style.height = null;
    el.style.display = 'block';
    var height = el.clientHeight + 'px';
    el.style.height = 0;
    el.style.transition = null;

    setTimeout(function () {
      return el.style.height = height;
    }, 50);
  },
  afterEnter: function afterEnter(el) {
    el.style.height = 'auto';
    el.style.overflow = null;
  },
  leave: function leave(el, done) {
    // Remove initial transition
    el.style.transition = 'none';
    Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["a" /* addOnceEventListener */])(el, 'transitionend', done);

    // Set height before we transition to 0
    el.style.overflow = 'hidden';
    el.style.height = el.clientHeight + 'px';
    el.style.transition = null;

    setTimeout(function () {
      return el.style.height = 0;
    }, 50);
  }
});

/***/ }),
/* 72 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VFooter__ = __webpack_require__(73);


/* harmony default export */ __webpack_exports__["a"] = ({
  VFooter: __WEBPACK_IMPORTED_MODULE_0__VFooter__["a" /* default */]
});

/***/ }),
/* 73 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  props: {
    absolute: Boolean,
    fixed: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;

    data.staticClass = ('footer ' + (data.staticClass || '')).trim();

    if (props.absolute) data.staticClass += ' footer--absolute';
    if (props.fixed) data.staticClass += ' footer--fixed';

    return h('footer', data, children);
  }
});

/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


var Grid = function Grid(name) {
  return {
    functional: true,

    props: {
      id: String
    },

    render: function render(h, _ref) {
      var props = _ref.props,
          data = _ref.data,
          children = _ref.children;

      data.staticClass = (name + ' ' + (data.staticClass || '')).trim();

      if (data.attrs) {
        data.staticClass += ' ' + Object.keys(data.attrs).join(' ');
        delete data.attrs;
      }

      if (props.id) {
        data.domProps = data.domProps || {};
        data.domProps.id = props.id;
      }

      return h('div', data, children);
    }
  };
};

var VContainer = Grid('container');
var VFlex = Grid('flex');
var VLayout = Grid('layout');
var VSpacer = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('spacer');

/* harmony default export */ __webpack_exports__["a"] = ({
  VContainer: VContainer,
  VFlex: VFlex,
  VLayout: VLayout,
  VSpacer: VSpacer
});

/***/ }),
/* 75 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VIcon__ = __webpack_require__(3);


/* harmony default export */ __webpack_exports__["a"] = ({
  VIcon: __WEBPACK_IMPORTED_MODULE_0__VIcon__["a" /* default */]
});

/***/ }),
/* 76 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_transitions__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__ = __webpack_require__(2);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-list-group',

  inject: ['listClick', 'listClose'],

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__["a" /* default */]],

  data: function data() {
    return {
      isBooted: this.value
    };
  },


  props: {
    group: String,
    lazy: Boolean,
    noAction: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'list--group__header': true,
        'list--group__header--active': this.isActive,
        'list--group__header--no-action': this.noAction
      };
    }
  },

  watch: {
    isActive: function isActive() {
      this.isBooted = true;

      if (!this.isActive) {
        this.listClose(this._uid);
      }
    },
    $route: function $route(to) {
      var isActive = this.matchRoute(to.path);

      if (this.group) {
        if (isActive && this.isActive !== isActive) {
          this.listClick(this._uid);
        }
        this.isActive = isActive;
      }
    }
  },

  mounted: function mounted() {
    if (this.group) {
      this.isActive = this.matchRoute(this.$route.path);
    }

    if (this.isActive) {
      this.listClick(this._uid);
    }
  },


  methods: {
    click: function click() {
      var _this = this;

      if (!this.$refs.item.querySelector('.list__tile--disabled')) {
        requestAnimationFrame(function () {
          return _this.listClick(_this._uid);
        });
      }
    },
    toggle: function toggle(uid) {
      this.isActive = this._uid === uid;
    },
    matchRoute: function matchRoute(to) {
      if (!this.group) return false;
      return to.match(this.group) !== null;
    }
  },

  render: function render(h) {
    var group = h('ul', {
      'class': 'list list--group',
      directives: [{
        name: 'show',
        value: this.isActive
      }],
      ref: 'group'
    }, [this.lazy && !this.isBooted ? null : this.$slots.default]);

    var item = h('div', {
      'class': this.classes,
      on: Object.assign({}, { click: this.click }, this.$listeners),
      ref: 'item'
    }, [this.$slots.item]);

    var transition = h(__WEBPACK_IMPORTED_MODULE_0__components_transitions__["a" /* VExpandTransition */], [group]);

    return h('div', { 'class': 'list--group__container' }, [item, transition]);
  }
});

/***/ }),
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


function directive(el, binding) {
  var config = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["f" /* directiveConfig */])(binding, {
    icon: false,
    left: false,
    bottom: false,
    overlap: false,
    visible: true
  });

  if (!config.visible || binding.expression && !binding.value) {
    return unbind(el);
  }

  if (config.overlap) el.classList.add('badge--overlap');
  if (config.icon) el.classList.add('badge--icon');
  if (config.left) el.classList.add('badge--left');
  if (config.bottom) el.classList.add('badge--bottom');

  el.dataset.badge = config.value;
  el.classList.add('badge');
}

function unbind(el) {
  el.removeAttribute('data-badge');
  el.classList.remove('badge');
}

/* harmony default export */ __webpack_exports__["a"] = ({
  bind: directive,
  updated: directive,
  componentUpdated: directive,
  unbind: unbind
});

/***/ }),
/* 78 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function inserted(el, binding) {
  var debounce = function debounce(cb) {
    return setTimeout(cb, 50);
  };
  var onResize = function onResize() {
    clearTimeout(debounce);
    debounce(binding.value);
  };

  window.addEventListener('resize', onResize, { passive: true });
  el._onResize = onResize;
}

function unbind(el, binding) {
  window.removeEventListener('resize', el._onResize);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  inserted: inserted,
  unbind: unbind
});

/***/ }),
/* 79 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function inserted(el, binding) {
  var callback = typeof binding.value === 'function' ? binding.value : binding.value.callback;
  var options = binding.value.options || { passive: true };
  var target = binding.value.target || window;
  if (target === 'undefined') return;

  if (target !== window) {
    target = document.querySelector(target);
  }

  target.addEventListener('scroll', callback, options);

  el._onScroll = {
    target: target,
    options: options
  };
}

function unbind(el, binding) {
  var _el$_onScroll = el._onScroll,
      target = _el$_onScroll.target,
      options = _el$_onScroll.options;


  target.removeEventListener('scroll', binding.callback, options);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  inserted: inserted,
  unbind: unbind
});

/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


function directive(el, binding) {
  var config = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["f" /* directiveConfig */])(binding, {
    top: true,
    visible: true
  });

  if (!config.visible || binding.expression && !binding.value) {
    return unbind(el);
  }

  unbind(el, binding, config);

  el.dataset.tooltip = config.html;
  el.dataset['tooltipLocation'] = config.value;
}

function unbind(el) {
  el.removeAttribute('data-tooltip');
  el.removeAttribute('data-tooltip-location');
}

/* harmony default export */ __webpack_exports__["a"] = ({
  bind: directive,
  updated: directive,
  componentUpdated: directive,
  unbind: unbind
});

/***/ }),
/* 81 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var touchstart = function touchstart(event, wrapper) {
  var touch = event.changedTouches[0];
  wrapper.touchstartX = touch.clientX;
  wrapper.touchstartY = touch.clientY;

  wrapper.start && wrapper.start(Object.assign(event, wrapper));
};

var touchend = function touchend(event, wrapper) {
  var touch = event.changedTouches[0];
  wrapper.touchendX = touch.clientX;
  wrapper.touchendY = touch.clientY;

  wrapper.end && wrapper.end(Object.assign(event, wrapper));

  handleGesture(wrapper);
};

var touchmove = function touchmove(event, wrapper) {
  var touch = event.changedTouches[0];
  wrapper.touchmoveX = touch.clientX;
  wrapper.touchmoveY = touch.clientY;

  wrapper.move && wrapper.move(Object.assign(event, wrapper));
};

var handleGesture = function handleGesture(wrapper) {
  var touchstartX = wrapper.touchstartX,
      touchendX = wrapper.touchendX,
      touchstartY = wrapper.touchstartY,
      touchendY = wrapper.touchendY;

  wrapper.offsetX = touchendX - touchstartX;
  wrapper.offsetY = touchendY - touchstartY;

  if (touchendX < touchstartX) {
    wrapper.left && wrapper.left(wrapper);
  }
  if (touchendX > touchstartX) {
    wrapper.right && wrapper.right(wrapper);
  }
  if (touchendY < touchstartY) {
    wrapper.up && wrapper.up(wrapper);
  }
  if (touchendY > touchstartY) {
    wrapper.down && wrapper.down(wrapper);
  }
};

function inserted(el, _ref) {
  var value = _ref.value;

  var wrapper = {
    touchstartX: 0,
    touchstartY: 0,
    touchendX: 0,
    touchendY: 0,
    touchmoveX: 0,
    touchmoveY: 0,
    offsetX: 0,
    offsetY: 0,
    left: value.left,
    right: value.right,
    up: value.up,
    down: value.down,
    start: value.start,
    move: value.move,
    end: value.end
  };

  var target = value.parent ? el.parentNode : el;
  var options = value.options || {};

  target.addEventListener('touchstart', function (e) {
    return touchstart(e, wrapper);
  }, options);
  target.addEventListener('touchend', function (e) {
    return touchend(e, wrapper);
  }, options);
  target.addEventListener('touchmove', function (e) {
    return touchmove(e, wrapper);
  }, options);
}

function unbind(el, _ref2) {
  var value = _ref2.value;

  var target = value.parent ? el.parentNode : el;

  if (!target) return;

  target.removeEventListener('touchstart', touchstart);
  target.removeEventListener('touchend', touchend);
  target.removeEventListener('touchmove', touchmove);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  inserted: inserted,
  unbind: unbind
});

/***/ }),
/* 82 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VMenu_js__ = __webpack_require__(22);


/* harmony default export */ __webpack_exports__["a"] = ({
  VMenu: __WEBPACK_IMPORTED_MODULE_0__VMenu_js__["a" /* default */]
});

/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    getActivator: function getActivator() {
      if (this.activator) return this.activator;
      return this.$refs.activator.children ? this.$refs.activator.children[0] : this.$refs.activator;
    },
    activatorClickHandler: function activatorClickHandler(e) {
      if (this.disabled) return;else if (this.openOnClick && !this.isActive) {
        this.isActive = true;
        this.absoluteX = e.clientX;
        this.absoluteY = e.clientY;
      } else if (this.closeOnClick && this.isActive) this.isActive = false;
    },
    mouseEnterHandler: function mouseEnterHandler(e) {
      if (this.disabled || this.hasJustFocused) return;
      this.hasJustFocused = true;
      this.isActive = true;
    },
    mouseLeaveHandler: function mouseLeaveHandler(e) {
      if (this.isContentActive) return;
      this.isActive = false;
    },
    addActivatorEvents: function addActivatorEvents() {
      var activator = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      if (!activator) return;
      activator.addEventListener('click', this.activatorClickHandler);
    },
    removeActivatorEvents: function removeActivatorEvents() {
      var activator = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      if (!activator) return;
      activator.removeEventListener('click', this.activatorClickHandler);
    }
  }
});

/***/ }),
/* 84 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genActivator: function genActivator() {
      if (!this.$slots.activator) return null;

      var options = {
        'class': {
          'menu__activator--active': this.hasJustFocused || this.isActive
        },
        staticClass: 'menu__activator',
        ref: 'activator',
        slot: 'activator',
        on: {}
      };

      if (this.openOnHover) {
        options.on['mouseenter'] = this.mouseEnterHandler;
        options.on['mouseleave'] = this.mouseLeaveHandler;
      } else if (this.openOnClick) {
        options.on['click'] = this.activatorClickHandler;
      }

      return this.$createElement('div', options, this.$slots.activator);
    },
    genTransition: function genTransition() {
      return this.$createElement('transition', {
        props: {
          name: this.transition,
          origin: this.origin
        }
      }, [this.genContent()]);
    },
    genContent: function genContent() {
      var _this = this;

      var booted = this.lazy && this.isBooted || !this.lazy;
      return this.$createElement('div', {
        'class': ('menu__content ' + this.contentClass).trim(),
        ref: 'content',
        style: this.styles,
        directives: [{
          name: 'show',
          value: this.isContentActive
        }],
        on: {
          click: function click(e) {
            e.stopPropagation();
            if (e.target.getAttribute('disabled')) return;
            if (_this.closeOnContentClick) _this.isActive = false;
          },
          mouseleave: function mouseleave(e) {
            _this.openOnHover && (_this.isActive = false);
          }
        }
      }, [booted ? this.$slots.default : null]);
    }
  }
});

/***/ }),
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    // Revisit this
    calculateScroll: function calculateScroll() {
      if (this.selectedIndex === null) return;

      var scrollTop = 0;

      if (this.selectedIndex >= this.stopIndex) {
        scrollTop = this.$refs.content.scrollHeight;
      } else if (this.selectedIndex > this.startIndex) {
        scrollTop = this.selectedIndex * 48 - 56;
      }

      this.$refs.content.scrollTop = scrollTop;
    },
    calcLeftAuto: function calcLeftAuto() {
      var a = this.dimensions.activator;

      return parseInt(a.left - 16);
    },
    calcTopAuto: function calcTopAuto() {
      if (!this.hasActivator) return this.calcTop(true);

      var selectedIndex = Array.from(this.tiles).findIndex(function (n) {
        return n.classList.contains('list__tile--active');
      });

      if (selectedIndex === -1) {
        this.selectedIndex = null;

        return this.calcTop(true);
      }

      this.selectedIndex = selectedIndex;
      var actingIndex = selectedIndex;

      var offsetPadding = 1;
      // #708 Stop index should vary by tile length
      this.stopIndex = this.tiles.length > 4 ? this.tiles.length - 4 : this.tiles.length;

      if (selectedIndex > this.startIndex && selectedIndex < this.stopIndex) {
        actingIndex = 2;
        offsetPadding = 41;
      } else if (selectedIndex >= this.stopIndex) {
        offsetPadding = 9;
        actingIndex = selectedIndex - this.stopIndex;
      }

      return this.calcTop(true) + offsetPadding - actingIndex * 48;
    },
    calcLeft: function calcLeft() {
      if (this.auto) return this.calcLeftAuto();

      var a = this.dimensions.activator;
      var c = this.dimensions.content;
      var left = this.left ? a.right - c.width : a.left;

      if (this.offsetX) left += this.left ? -a.width : a.width;
      if (this.nudgeLeft) left += this.nudgeLeft;
      if (this.nudgeRight) left -= this.nudgeRight;

      return this.calcXOverflow(left);
    },
    calcTop: function calcTop(force) {
      if (this.auto && !force) return this.calcTopAuto();

      var a = this.dimensions.activator;
      var c = this.dimensions.content;
      var top = this.top ? a.bottom - c.height : a.top;

      if (this.offsetY) top += this.top ? -a.height : a.height;
      if (this.nudgeTop) top -= this.nudgeTop;
      if (this.nudgeBottom) top += this.nudgeBottom;

      var defined = typeof window !== 'undefined';
      var pageYOffset = defined ? window.pageYOffset : 0;

      return this.calcYOverflow(top) + pageYOffset;
    },
    calcXOverflow: function calcXOverflow(left) {
      var hasWindow = typeof window !== 'undefined';
      var innerWidth = hasWindow ? window.innerWidth : 0;
      var maxWidth = Math.max(this.dimensions.content.width, this.calculatedMinWidth, parseInt(this.maxWidth) || 0);
      var totalWidth = left + maxWidth;
      var availableWidth = totalWidth - innerWidth;

      if ((!this.left || this.right) && availableWidth > 0) {
        left = innerWidth - maxWidth - (innerWidth > 1024 ? 30 : 12) // Account for scrollbar
        ;
      } else if (this.left && left < 0) left = 12;

      return left;
    },
    calcYOverflow: function calcYOverflow(top) {
      var totalHeight = top + this.dimensions.content.height;
      var defined = typeof window !== 'undefined';
      var innerHeight = defined ? window.innerHeight : 0;

      if (this.top && top < 0) top = 12;else if ((!this.top || this.bottom) && innerHeight < totalHeight) {
        top = innerHeight - this.dimensions.content.height;
      }

      return top < 12 ? 12 : top;
    },
    sneakPeek: function sneakPeek(cb) {
      var _this = this;

      requestAnimationFrame(function () {
        var el = _this.$refs.content;
        var currentDisplay = el.style.display;

        el.style.display = 'inline-block';
        cb();
        el.style.display = currentDisplay;
      });
    },
    absolutePosition: function absolutePosition() {
      return {
        offsetTop: 0,
        scrollHeight: 0,
        top: this.positionY || this.absoluteY,
        bottom: this.positionY || this.absoluteY,
        left: this.positionX || this.absoluteX,
        right: this.positionX || this.absoluteX,
        height: 0,
        width: 0
      };
    },
    updateDimensions: function updateDimensions() {
      var _this2 = this;

      this.sneakPeek(function () {
        _this2.dimensions = {
          activator: !_this2.hasActivator || _this2.positionAbsolutely ? _this2.absolutePosition() : _this2.measure(_this2.getActivator()),
          content: _this2.measure(_this2.$refs.content)
        };
      });
    }
  }
});

/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    measure: function measure(el, selector) {
      var getParent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      el = selector ? el.querySelector(selector) : el;

      if (!el) return null;

      var _el$getBoundingClient = el.getBoundingClientRect(),
          top = _el$getBoundingClient.top,
          bottom = _el$getBoundingClient.bottom,
          left = _el$getBoundingClient.left,
          right = _el$getBoundingClient.right,
          height = _el$getBoundingClient.height,
          width = _el$getBoundingClient.width;

      return {
        offsetTop: el.offsetTop,
        scrollHeight: el.scrollHeight,
        top: top, bottom: bottom, left: left, right: right, height: height, width: width
      };
    }
  }
});

/***/ }),
/* 87 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      listIndex: -1,
      isUsingKeys: false,
      tiles: []
    };
  },

  watch: {
    isActive: function isActive(val) {
      if (!val) this.listIndex = -1;
    },
    listIndex: function listIndex(next, prev) {
      // For infinite scroll and autocomplete, re-evaluate children
      this.getTiles();

      if (next in this.tiles) {
        this.tiles[next].classList.add('list__tile--highlighted');
        this.$refs.content.scrollTop = next * 48;
      }

      prev in this.tiles && this.tiles[prev].classList.remove('list__tile--highlighted');
    }
  },

  methods: {
    changeListIndex: function changeListIndex(e) {
      [40, 38, 13].includes(e.keyCode) && e.preventDefault();
      e.keyCode === 32 && !this.isActive && e.preventDefault();

      if (this.listIndex === -1) this.setActiveListIndex();
      if ([27, 9].includes(e.keyCode)) return this.isActive = false;else if (!this.isActive && [13, 32].includes(e.keyCode)) {
        return this.isActive = true;
      }

      if (e.keyCode === 40 && this.listIndex < this.tiles.length - 1) {
        this.listIndex++;
      } else if (e.keyCode === 38 && this.listIndex > 0) {
        this.listIndex--;
      } else if (e.keyCode === 13 && this.listIndex !== -1) {
        this.tiles[this.listIndex].click();
      }
    },
    getTiles: function getTiles() {
      this.tiles = this.$refs.content.querySelectorAll('.list__tile');
    },
    setActiveListIndex: function setActiveListIndex() {
      var _this = this;

      this.tiles.forEach(function (t, i) {
        if (t.classList.contains('list__tile--active')) {
          _this.listIndex = i;
          return;
        }
      });
    }
  }
});

/***/ }),
/* 88 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VNavigationDrawer__ = __webpack_require__(89);


/* harmony default export */ __webpack_exports__["a"] = ({
  VNavigationDrawer: __WEBPACK_IMPORTED_MODULE_0__VNavigationDrawer__["a" /* default */]
});

/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_overlayable__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__directives__ = __webpack_require__(4);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-navigation-drawer',

  directives: {
    Resize: __WEBPACK_IMPORTED_MODULE_2__directives__["Resize"]
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_overlayable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_themeable__["a" /* default */]],

  data: function data() {
    return {
      isActive: this.value,
      isBooted: false,
      isMobile: false,
      touchArea: {
        left: 0,
        right: 0
      }
    };
  },


  props: {
    absolute: Boolean,
    clipped: Boolean,
    disableRouteWatcher: Boolean,
    enableResizeWatcher: Boolean,
    height: String,
    floating: Boolean,
    miniVariant: Boolean,
    mobileBreakPoint: {
      type: Number,
      default: 1024
    },
    permanent: Boolean,
    persistent: Boolean,
    right: Boolean,
    temporary: Boolean,
    touchless: Boolean,
    value: { required: false }
  },

  computed: {
    calculatedHeight: function calculatedHeight() {
      return this.height || '100%';
    },
    classes: function classes() {
      return {
        'navigation-drawer': true,
        'navigation-drawer--absolute': this.absolute,
        'navigation-drawer--clipped': this.clipped,
        'navigation-drawer--close': !this.isActive,
        'navigation-drawer--floating': this.floating,
        'navigation-drawer--is-booted': this.isBooted,
        'navigation-drawer--is-mobile': this.isMobile,
        'navigation-drawer--mini-variant': this.miniVariant,
        'navigation-drawer--open': this.isActive,
        'navigation-drawer--permanent': this.permanent,
        'navigation-drawer--persistent': this.persistent,
        'navigation-drawer--right': this.right,
        'navigation-drawer--temporary': this.temporary,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    },
    showOverlay: function showOverlay() {
      return !this.permanent && this.isActive && (this.temporary || this.isMobile);
    }
  },

  watch: {
    $route: function $route() {
      if (!this.disableRouteWatcher) {
        this.isActive = !this.closeConditional();
      }
    },
    isActive: function isActive(val) {
      this.$emit('input', val);
      this.showOverlay && val && this.genOverlay() || this.removeOverlay();
      this.$el.scrollTop = 0;
    },
    isMobile: function isMobile(val) {
      !val && this.removeOverlay();
    },
    permanent: function permanent(val) {
      this.$emit('input', val);
    },
    value: function value(val) {
      if (this.permanent) return;
      if (val !== this.isActive) this.isActive = val;
    }
  },

  mounted: function mounted() {
    this.$vuetify.load(this.init);
  },


  methods: {
    init: function init() {
      var _this = this;

      this.checkIfMobile();
      setTimeout(function () {
        return _this.isBooted = true;
      }, 0);

      if (this.permanent) this.isActive = true;else if (this.isMobile) this.isActive = false;else if (!this.value && (this.persistent || this.temporary)) this.isActive = false;
    },
    checkIfMobile: function checkIfMobile() {
      this.isMobile = window.innerWidth < parseInt(this.mobileBreakPoint);
    },
    closeConditional: function closeConditional() {
      return !this.permanent && (this.temporary || this.isMobile);
    },
    onResize: function onResize() {
      var _this2 = this;

      clearTimeout(this.resizeTimeout);

      if (!this.enableResizeWatcher || this.permanent || this.temporary) return;

      this.resizeTimeout = setTimeout(function () {
        _this2.checkIfMobile();
        _this2.isActive = !_this2.isMobile;
      }, 200);
    },
    swipeRight: function swipeRight(e) {
      if (this.isActive && !this.right) return;
      this.calculateTouchArea();

      if (Math.abs(e.touchendX - e.touchstartX) < 100) return;else if (!this.right && e.touchstartX <= this.touchArea.left) this.isActive = true;else if (this.right && this.isActive) this.isActive = false;
    },
    swipeLeft: function swipeLeft(e) {
      if (this.isActive && this.right) return;
      this.calculateTouchArea();

      if (Math.abs(e.touchendX - e.touchstartX) < 100) return;else if (this.right && e.touchstartX >= this.touchArea.right) this.isActive = true;else if (!this.right && this.isActive) this.isActive = false;
    },
    calculateTouchArea: function calculateTouchArea() {
      if (!this.$el.parentNode) return;
      var parentRect = this.$el.parentNode.getBoundingClientRect();

      this.touchArea = {
        left: parentRect.left + 50,
        right: parentRect.right - 50
      };
    },
    genDirectives: function genDirectives() {
      var directives = [{
        name: 'click-outside',
        value: this.closeConditional
      }, {
        name: 'resize',
        value: this.onResize
      }];

      !this.touchless && directives.push({
        name: 'touch',
        value: {
          parent: true,
          left: this.swipeLeft,
          right: this.swipeRight
        }
      });

      return directives;
    }
  },

  render: function render(h) {
    var _this3 = this;

    var data = {
      'class': this.classes,
      style: { height: this.calculatedHeight },
      directives: this.genDirectives(),
      on: Object.assign({}, {
        click: function click() {
          return _this3.$emit('update:miniVariant', false);
        }
      }, this.$listeners)
    };

    return h('aside', data, [this.$slots.default, h('div', { 'class': 'navigation-drawer__border' })]);
  }
});

/***/ }),
/* 90 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VSystemBar__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VToolbar__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VToolbarSideIcon__ = __webpack_require__(93);






var VToolbarTitle = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('toolbar__title');
var VToolbarItems = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('toolbar__items');

/* harmony default export */ __webpack_exports__["a"] = ({
  VSystemBar: __WEBPACK_IMPORTED_MODULE_1__VSystemBar__["a" /* default */],
  VToolbar: __WEBPACK_IMPORTED_MODULE_2__VToolbar__["a" /* default */],
  VToolbarItems: VToolbarItems,
  VToolbarTitle: VToolbarTitle,
  VToolbarSideIcon: __WEBPACK_IMPORTED_MODULE_3__VToolbarSideIcon__["a" /* default */]
});

/***/ }),
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  props: {
    lightsOut: Boolean,
    status: Boolean,
    window: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;

    data.staticClass = ('system-bar ' + (data.staticClass || '')).trim();

    if (props.dark) data.staticClass += ' theme--dark';
    if (props.light) data.staticClass += ' theme--light';
    if (props.status) data.staticClass += ' system-bar--status';
    if (props.window) data.staticClass += ' system-bar--window';
    if (props.lightsOut) data.staticClass += ' system-bar--lights-out';

    return h('div', data, children);
  }
});

/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-toolbar',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  data: function data() {
    return {
      isExtended: false,
      isScrolling: false,
      marginTop: 0,
      previousScroll: null,
      target: null
    };
  },

  props: {
    absolute: Boolean,
    card: Boolean,
    dense: Boolean,
    extended: Boolean,
    fixed: Boolean,
    flat: Boolean,
    floating: Boolean,
    prominent: Boolean,
    scrollOffScreen: Boolean,
    scrollTarget: String,
    scrollThreshHold: {
      type: Number,
      default: 100
    }
  },

  computed: {
    classes: function classes() {
      return {
        'toolbar': true,
        'elevation-0': this.flat,
        'toolbar--absolute': this.absolute,
        'toolbar--card': this.card,
        'toolbar--dense': this.dense,
        'toolbar--fixed': this.fixed,
        'toolbar--floating': this.floating,
        'toolbar--prominent': this.prominent,
        'toolbar--extended': this.isExtended,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    },
    styles: function styles() {
      return {
        marginTop: this.marginTop
      };
    }
  },

  watch: {
    isScrolling: function isScrolling(val) {
      if (!val) this.marginTop = 0;else this.marginTop = -this.$refs.content.clientHeight - 6 + 'px';
    }
  },

  methods: {
    onScroll: function onScroll() {
      if (typeof window === 'undefined') return;

      if (!this.target) {
        this.target = this.scrollTarget ? document.querySelector(this.scrollTarget) : window;
      }

      var currentScroll = this.scrollTarget ? this.target.scrollTop : this.target.pageYOffset || document.documentElement.scrollTop;

      if (currentScroll < this.scrollThreshHold) return;

      if (this.previousScroll === null) {
        this.previousScroll = currentScroll;
      }

      this.isScrolling = this.previousScroll < currentScroll;

      this.previousScroll = currentScroll;
    }
  },

  render: function render(h) {
    this.isExtended = this.extended || !!this.$slots.extension;
    var children = [];
    var data = {
      'class': this.classes,
      style: this.styles,
      on: this.$listeners
    };

    if (this.scrollOffScreen) {
      data.directives = [{
        name: 'scroll',
        value: {
          callback: this.onScroll,
          target: this.scrollTarget
        }
      }];
    }

    children.push(h('div', {
      'class': 'toolbar__content',
      ref: 'content'
    }, this.$slots.default));

    if (this.isExtended) {
      children.push(h('div', {
        'class': 'toolbar__extension'
      }, this.$slots.extension));
    }

    return h('nav', data, children);
  }
});

/***/ }),
/* 93 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_buttons_VBtn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_icons_VIcon__ = __webpack_require__(3);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-toolbar-side-icon',

  functional: true,

  render: function render(h, _ref) {
    var slots = _ref.slots,
        listeners = _ref.listeners,
        props = _ref.props;

    var data = {
      staticClass: 'toolbar__side-icon',
      props: Object.assign(props, {
        icon: true
      }),
      on: listeners
    };

    var defaultSlot = slots().default;

    return h(__WEBPACK_IMPORTED_MODULE_0__components_buttons_VBtn__["a" /* default */], data, defaultSlot || [h(__WEBPACK_IMPORTED_MODULE_1__components_icons_VIcon__["a" /* default */], 'menu')]);
  }
});

/***/ }),
/* 94 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VPagination__ = __webpack_require__(95);


/* harmony default export */ __webpack_exports__["a"] = ({
  VPagination: __WEBPACK_IMPORTED_MODULE_0__VPagination__["a" /* default */]
});

/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_icons_VIcon__ = __webpack_require__(3);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-pagination',

  props: {
    circle: Boolean,
    disabled: Boolean,
    length: {
      type: Number,
      default: 0,
      validator: function validator(val) {
        return val % 1 === 0;
      }
    },
    value: {
      type: Number,
      default: 0
    },
    prevIcon: {
      type: String,
      default: 'chevron_left'
    },
    nextIcon: {
      type: String,
      default: 'chevron_right'
    }
  },

  watch: {
    value: function value() {
      this.init();
    }
  },

  computed: {
    classes: function classes() {
      return {
        'pagination': true,
        'pagination--circle': this.circle,
        'pagination--disabled': this.disabled
      };
    },
    items: function items() {
      if (this.length <= 5) {
        return this.range(1, this.length);
      }

      var min = this.value - 3;
      min = min > 0 ? min : 1;

      var max = min + 6;
      max = max <= this.length ? max : this.length;

      if (max === this.length) {
        min = this.length - 6;
      }

      var range = this.range(min, max);

      if (this.value >= 4 && this.length > 6) {
        range.splice(0, 2, 1, '...');
      }

      if (this.value + 3 < this.length && this.length > 6) {
        range.splice(range.length - 2, 2, '...', this.length);
      }

      return range;
    }
  },

  mounted: function mounted() {
    this.$vuetify.load.call(this, this.init);
  },


  methods: {
    init: function init() {
      var _this = this;

      this.selected = null;

      // Change this
      setTimeout(function () {
        return _this.selected = _this.value;
      }, 100);
    },
    next: function next(e) {
      e.preventDefault();
      this.$emit('input', this.value + 1);
      this.$emit('next');
    },
    previous: function previous(e) {
      e.preventDefault();
      this.$emit('input', this.value - 1);
      this.$emit('previous');
    },
    range: function range(from, to) {
      var range = [];

      from = from > 0 ? from : 1;

      for (var i = from; i <= to; i++) {
        range.push(i);
      }

      return range;
    },
    genIcon: function genIcon(h, icon, disabled, fn) {
      return h('li', [h('a', {
        class: {
          'pagination__navigation': true,
          'pagination__navigation--disabled': disabled
        },
        attrs: { href: '#!' },
        on: { click: fn }
      }, [h(__WEBPACK_IMPORTED_MODULE_0__components_icons_VIcon__["a" /* default */], [icon])])]);
    },
    genItem: function genItem(h, i) {
      var _this2 = this;

      return h('a', {
        class: {
          'pagination__item': true,
          'pagination__item--active': i === this.value
        },
        attrs: { href: '#!' },
        on: {
          click: function click(e) {
            e.preventDefault();
            _this2.$emit('input', i);
          }
        }
      }, [i]);
    },
    genItems: function genItems(h) {
      var _this3 = this;

      return this.items.map(function (i) {
        return h('li', [isNaN(i) && h('span', { class: 'pagination__more' }, [i]) || _this3.genItem(h, i)]);
      });
    }
  },

  render: function render(h) {
    var children = [this.genIcon(h, this.prevIcon, this.value === 1, this.previous), this.genItems(h), this.genIcon(h, this.nextIcon, this.value === this.length, this.next)];

    return h('ul', { class: this.classes }, children);
  }
});

/***/ }),
/* 96 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VParallax__ = __webpack_require__(97);


/* harmony default export */ __webpack_exports__["a"] = ({
  VParallax: __WEBPACK_IMPORTED_MODULE_0__VParallax__["a" /* default */]
});

/***/ }),
/* 97 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_translatable__ = __webpack_require__(98);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-parallax',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_translatable__["a" /* default */]],

  props: {
    height: {
      type: [String, Number],
      default: 500
    },
    src: String
  },

  computed: {
    styles: function styles() {
      return {
        display: 'block',
        transform: 'translate3d(-50%, ' + this.parallax + 'px, 0)'
      };
    }
  },

  methods: {
    init: function init() {
      var _this = this;

      if (!this.$refs.img) return;

      if (this.$refs.img.complete) {
        this.translate();
        this.listeners();
      } else {
        this.$refs.img.addEventListener('load', function () {
          _this.translate();
          _this.listeners();
        }, false);
      }
    },
    objHeight: function objHeight() {
      return this.$refs.img.naturalHeight;
    },
    elOffsetTop: function elOffsetTop() {
      return this.$el.offsetTop;
    }
  },

  render: function render(h) {
    var container = h('div', {
      staticClass: 'parallax__image-container'
    }, [h('img', {
      staticClass: 'parallax__image',
      style: this.styles,
      attrs: {
        src: this.src
      },
      ref: 'img'
    })]);

    var content = h('div', {
      staticClass: 'parallax__content'
    }, this.$slots.default);

    return h('div', {
      staticClass: 'parallax',
      style: {
        height: parseInt(this.normalizedHeight) + 'px'
      },
      on: this.$listeners
    }, [container, content]);
  }
});

/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      parallax: null,
      parallaxDist: null,
      percentScrolled: null,
      scrollTop: null,
      windowHeight: null,
      windowBottom: null
    };
  },


  computed: {
    normalizedHeight: function normalizedHeight() {
      return Number(this.height.toString().replace(/(^[0-9]*$)/, '$1'));
    },
    imgHeight: function imgHeight() {
      return this.objHeight();
    }
  },

  mounted: function mounted() {
    this.$vuetify.load(this.init);
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('scroll', this.translate, false);
    window.removeEventListener('resize', this.translate, false);
  },


  methods: {
    listeners: function listeners() {
      window.addEventListener('scroll', this.translate, false);
      window.addEventListener('resize', this.translate, false);
    },
    translate: function translate() {
      this.calcDimensions();

      this.percentScrolled = (this.windowBottom - this.elOffsetTop) / (this.normalizedHeight + this.windowHeight);

      this.parallax = Math.round(this.parallaxDist * this.percentScrolled);

      if (this.translated) {
        this.translated();
      }
    },
    calcDimensions: function calcDimensions() {
      var offset = this.$el.getBoundingClientRect();

      this.scrollTop = window.pageYOffset;
      this.parallaxDist = this.imgHeight - this.normalizedHeight;
      this.elOffsetTop = offset.top + this.scrollTop;
      this.windowHeight = window.innerHeight;
      this.windowBottom = this.scrollTop + this.windowHeight;
    }
  }
});

/***/ }),
/* 99 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VProgressLinear__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VProgressCircular__ = __webpack_require__(100);



/* harmony default export */ __webpack_exports__["a"] = ({
  VProgressLinear: __WEBPACK_IMPORTED_MODULE_0__VProgressLinear__["a" /* default */],
  VProgressCircular: __WEBPACK_IMPORTED_MODULE_1__VProgressCircular__["a" /* default */]
});

/***/ }),
/* 100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _this = this;

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-progress-circular',

  props: {
    button: Boolean,

    fill: {
      type: String,
      default: function _default() {
        return _this.indeterminate ? 'none' : 'transparent';
      }
    },

    indeterminate: Boolean,

    rotate: {
      type: Number,
      default: 0
    },

    size: {
      type: [Number, String],
      default: 32
    },

    width: {
      type: Number,
      default: 4
    },

    value: {
      type: Number,
      default: 0
    }
  },

  computed: {
    calculatedSize: function calculatedSize() {
      var size = Number(this.size);

      if (this.button) {
        size += 8;
      }

      return size;
    },
    circumference: function circumference() {
      return 2 * Math.PI * this.radius;
    },
    classes: function classes() {
      return {
        'progress-circular': true,
        'progress-circular--indeterminate': this.indeterminate,
        'progress-circular--button': this.button
      };
    },
    cxy: function cxy() {
      return this.indeterminate && !this.button ? 50 : this.calculatedSize / 2;
    },
    normalizedValue: function normalizedValue() {
      if (this.value < 0) {
        return 0;
      }

      if (this.value > 100) {
        return 100;
      }

      return this.value;
    },
    radius: function radius() {
      return this.indeterminate && !this.button ? 20 : (this.calculatedSize - this.width) / 2;
    },
    strokeDashArray: function strokeDashArray() {
      return Math.round(this.circumference * 1000) / 1000;
    },
    strokeDashOffset: function strokeDashOffset() {
      return (100 - this.normalizedValue) / 100 * this.circumference + 'px';
    },
    styles: function styles() {
      return {
        height: this.calculatedSize + 'px',
        width: this.calculatedSize + 'px'
      };
    },
    svgSize: function svgSize() {
      return this.indeterminate ? false : this.calculatedSize;
    },
    svgStyles: function svgStyles() {
      return {
        transform: 'rotate(' + this.rotate + 'deg)'
      };
    },
    viewBox: function viewBox() {
      return this.indeterminate ? '25 25 50 50' : false;
    }
  },

  methods: {
    genCircle: function genCircle(h, name, offset) {
      return h('circle', {
        class: 'progress-circular__' + name,
        attrs: {
          fill: 'transparent',
          cx: this.cxy,
          cy: this.cxy,
          r: this.radius,
          'stroke-width': this.width,
          'stroke-dasharray': this.strokeDashArray,
          'stroke-dashoffset': offset
        }
      });
    },
    genSvg: function genSvg(h) {
      var children = [!this.indeterminate && this.genCircle(h, 'underlay', 0), this.genCircle(h, 'overlay', this.strokeDashOffset)];

      return h('svg', {
        style: this.svgStyles,
        attrs: {
          xmlns: 'http://www.w3.org/2000/svg',
          height: this.svgSize,
          width: this.svgSize,
          viewBox: this.viewBox
        }
      }, children);
    }
  },

  render: function render(h) {
    var info = h('div', { class: 'progress-circular__info' }, [this.$slots.default]);
    var svg = this.genSvg(h);

    return h('div', {
      class: this.classes,
      style: this.styles,
      on: this.$listeners
    }, [svg, info]);
  }
});

/*
<template lang="pug">
  div(
    class="progress-circular"
    v-bind:class="classes"
    v-bind:style="styles"
    v-on="$listeners"
  )
    svg(
      xmlns="http://www.w3.org/2000/svg"
      v-bind:height="svgSize"
      v-bind:width="svgSize"
      v-bind:viewBox="viewBox"
      v-bind:style="svgStyles"
    )
      circle(
        class="progress-circular__underlay"
        fill="transparent"
        v-bind:cx="cxy"
        v-bind:cy="cxy"
        v-bind:r="radius"
        v-bind:stroke-width="width"
        v-bind:stroke-dasharray="strokeDashArray"
        v-bind:stroke-dashoffset="0"
        v-if="!indeterminate"
      )
      circle(
        class="progress-circular__overlay"
        v-bind:fill="fill"
        v-bind:cx="cxy"
        v-bind:cy="cxy"
        v-bind:r="radius"
        v-bind:stroke-width="width"
        v-bind:stroke-dasharray="strokeDashArray"
        v-bind:stroke-dashoffset="strokeDashOffset"
      )
    div(class="progress-circular__info")
      slot
</template>
*/

/***/ }),
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VSelect__ = __webpack_require__(24);


/* harmony default export */ __webpack_exports__["a"] = ({
  VSelect: __WEBPACK_IMPORTED_MODULE_0__VSelect__["a" /* default */]
});

/***/ }),
/* 102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    filterSearch: function filterSearch() {
      var _this = this;

      return this.items.filter(function (i) {
        var text = _this.getText(i);
        if (typeof text !== 'string') return false;

        return text.toLowerCase().indexOf(_this.searchValue.toLowerCase()) !== -1;
      });
    },
    onKeyDown: function onKeyDown(e) {
      this.$refs.menu.changeListIndex(e);
    }
  }
});

/***/ }),
/* 103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genMenu: function genMenu() {
      var _this = this;

      var offsetY = this.autocomplete || this.offset || this.isDropdown;
      var data = {
        ref: 'menu',
        props: {
          activator: this.$refs.activator,
          auto: this.auto,
          closeOnClick: false,
          closeOnContentClick: !this.multiple,
          contentClass: this.computedContentClass,
          disabled: this.disabled,
          maxHeight: this.maxHeight,
          nudgeTop: this.isDropdown ? 22 : offsetY ? 38 : 0,
          offsetY: offsetY,
          value: this.isActive
        },
        on: { input: function input(val) {
            return _this.isActive = val;
          } }
      };

      this.minWidth && (data.props.minWidth = this.minWidth);

      return this.$createElement('v-menu', data, [this.genList()]);
    },
    genSelectionsAndSearch: function genSelectionsAndSearch() {
      var _this2 = this;

      var input = void 0;

      if (this.autocomplete || this.editable) {
        input = this.$createElement('input', {
          'class': 'input-group--select__autocomplete',
          domProps: { value: this.searchValue },
          on: { input: function input(e) {
              return _this2.searchValue = e.target.value;
            } },
          attrs: { tabindex: -1 },
          ref: 'input',
          key: 'input'
        });
      }

      var selections = this.isDirty && (!this.editable || this.editable && !this.focused) ? this.genSelections() : [];
      input && selections.push(input);
      var group = this.$createElement('div', selections);

      return this.$createElement('div', {
        'class': 'input-group__selections',
        style: { 'overflow': 'hidden' },
        ref: 'activator'
      }, [group]);
    },
    genSelections: function genSelections() {
      var _this3 = this;

      var children = [];
      var chips = this.chips;
      var slots = this.$scopedSlots.selection;
      var length = this.selectedItems.length;

      this.selectedItems.forEach(function (item, i) {
        if (slots) {
          children.push(_this3.genSlotSelection(item));
        } else if (chips) {
          children.push(_this3.genChipSelection(item));
        } else {
          children.push(_this3.genCommaSelection(item, i < length - 1));
        }
      });

      return children;
    },
    genSlotSelection: function genSlotSelection(item) {
      return this.$scopedSlots.selection({ parent: this, item: item });
    },
    genChipSelection: function genChipSelection(item) {
      var _this4 = this;

      return this.$createElement('v-chip', {
        'class': 'chip--select-multi',
        props: { close: true },
        on: {
          input: function input() {
            return _this4.selectItem(item);
          },
          click: function click(e) {
            return e.stopPropagation();
          }
        },
        key: this.getValue(item)
      }, this.getText(item));
    },
    genCommaSelection: function genCommaSelection(item, comma) {
      return this.$createElement('div', {
        'class': 'input-group__selections__comma',
        key: JSON.stringify(this.getValue(item)) // Item may be an object
      }, '' + this.getText(item) + (comma ? ', ' : ''));
    },
    genList: function genList() {
      var _this5 = this;

      var children = this.filteredItems.map(function (o) {
        if (o.header) return _this5.genHeader(o);
        if (o.divider) return _this5.genDivider(o);else return _this5.genTile(o);
      });

      if (!children.length) {
        children.push(this.genTile(this.noDataText, true));
      }

      return this.$createElement('v-card', [this.$createElement('v-list', {
        ref: 'list'
      }, children)]);
    },
    genHeader: function genHeader(item) {
      return this.$createElement('v-subheader', {
        props: item
      }, item.header);
    },
    genDivider: function genDivider(item) {
      return this.$createElement('v-divider', {
        props: item
      });
    },
    genTile: function genTile(item, disabled) {
      var _this6 = this;

      var active = this.selectedItems.indexOf(item) !== -1;

      if (typeof disabled === 'undefined') {
        disabled = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["g" /* getObjectValueByPath */])(item, this.itemDisabled);
      }

      var data = {
        on: { click: function click(e) {
            return _this6.selectItem(item);
          } },
        props: {
          avatar: item === Object(item) && 'avatar' in item,
          ripple: true,
          value: active
        }
      };

      if (disabled) {
        data.props.disabled = disabled;
      }

      if (this.$scopedSlots.item) {
        return this.$createElement('v-list-tile', data, [this.$scopedSlots.item({ parent: this, item: item })]);
      }

      return this.$createElement('v-list-tile', data, [this.genAction(item, active), this.genContent(item)]);
    },
    genAction: function genAction(item, active) {
      var _this7 = this;

      if (!this.multiple) return null;

      var data = {
        'class': {
          'list__tile__action--select-multi': this.multiple
        },
        on: {
          click: function click(e) {
            e.stopPropagation();
            _this7.selectItem(item);
          }
        }
      };

      return this.$createElement('v-list-tile-action', data, [this.$createElement('v-checkbox', { props: { inputValue: active } })]);
    },
    genContent: function genContent(item) {
      return this.$createElement('v-list-tile-content', [this.$createElement('v-list-tile-title', this.getText(item))]);
    }
  }
});

/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VCheckbox__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VRadio__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VSwitch__ = __webpack_require__(106);




/* harmony default export */ __webpack_exports__["a"] = ({
  VCheckbox: __WEBPACK_IMPORTED_MODULE_0__VCheckbox__["a" /* default */],
  VRadio: __WEBPACK_IMPORTED_MODULE_1__VRadio__["a" /* default */],
  VSwitch: __WEBPACK_IMPORTED_MODULE_2__VSwitch__["a" /* default */]
});

/***/ }),
/* 105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_input__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_colorable__ = __webpack_require__(28);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'radio',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_input__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_colorable__["a" /* default */]],

  model: {
    prop: 'inputValue',
    event: 'change'
  },

  props: {
    inputValue: [String, Number]
  },

  computed: {
    isActive: function isActive() {
      return this.inputValue === this.value;
    },
    classes: function classes() {
      return this.addColorClassChecks({
        'radio': true,
        'input-group--selection-controls': true,
        'input-group--active': this.isActive
      });
    },
    icon: function icon() {
      return this.isActive ? 'radio_button_checked' : 'radio_button_unchecked';
    }
  },

  methods: {
    genLabel: function genLabel() {
      return this.$createElement('label', {
        on: { click: this.toggle }
      }, this.label);
    },
    toggle: function toggle() {
      if (!this.disabled) {
        this.$emit('change', this.value);
      }
    }
  },

  render: function render(h) {
    var transition = h('v-fade-transition', {}, [h('v-icon', {
      'class': {
        'icon--radio': this.isActive
      },
      key: this.icon
    }, this.icon)]);

    var ripple = h('div', {
      'class': 'input-group--selection-controls__ripple',
      on: Object.assign({}, {
        click: this.toggle
      }, this.$listeners),
      directives: [{
        name: 'ripple',
        value: { center: true }
      }]
    });

    return this.genInputGroup([transition, ripple]);
  }
});

/***/ }),
/* 106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_selectable__ = __webpack_require__(27);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'switch',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_selectable__["a" /* default */]],

  computed: {
    classes: function classes() {
      return {
        'input-group--selection-controls switch': true
      };
    },
    rippleClasses: function rippleClasses() {
      return {
        'input-group--selection-controls__ripple': true,
        'input-group--selection-controls__ripple--active': this.isActive
      };
    },
    containerClasses: function containerClasses() {
      return this.addColorClassChecks({
        'input-group--selection-controls__container': true,
        'input-group--selection-controls__container--light': this.light,
        'input-group--selection-controls__container--disabled': this.disabled
      });
    },
    toggleClasses: function toggleClasses() {
      return {
        'input-group--selection-controls__toggle': true,
        'input-group--selection-controls__toggle--active': this.isActive
      };
    }
  },

  render: function render(h) {
    var ripple = h('div', {
      'class': this.rippleClasses,
      on: Object.assign({}, {
        click: this.toggle
      }, this.$listeners),
      directives: [{
        name: 'ripple',
        value: { center: true }
      }]
    });

    var container = h('div', {
      'class': this.containerClasses
    }, [h('div', { 'class': this.toggleClasses }), ripple]);

    return this.genInputGroup([container]);
  }
});

/***/ }),
/* 107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VSlider__ = __webpack_require__(108);


/* harmony default export */ __webpack_exports__["a"] = ({
  VSlider: __WEBPACK_IMPORTED_MODULE_0__VSlider__["a" /* default */]
});

/***/ }),
/* 108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_input__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_helpers__ = __webpack_require__(0);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-slider',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_input__["a" /* default */]],

  data: function data() {
    return {
      app: {},
      isActive: false,
      inputWidth: 0
    };
  },


  props: {
    inverted: Boolean,
    min: {
      type: [Number, String],
      default: 0
    },
    max: {
      type: [Number, String],
      default: 100
    },
    step: {
      type: [Number, String],
      default: null
    },
    thumbLabel: Boolean,
    value: [Number, String],
    vertical: Boolean,
    snap: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'input-group input-group--slider': true,
        'input-group--active': this.isActive,
        'input-group--dirty': this.inputWidth > 0,
        'input-group--disabled': this.disabled,
        'input-group--ticks': !this.disabled && this.step
      };
    },

    inputValue: {
      get: function get() {
        return this.value;
      },
      set: function set(val) {
        var min = this.min,
            max = this.max,
            step = this.step,
            snap = this.snap;

        val = val < min ? min : val > max ? max : val;
        if (Math.ceil(val) !== Math.ceil(this.lazyValue)) {
          this.inputWidth = this.calculateWidth(val);
        }

        var value = snap ? Math.round(val / step) * step : parseInt(val);
        this.lazyValue = value;

        if (value !== this.value) {
          this.$emit('input', value);
        }
      }
    },
    interval: function interval() {
      return 100 / (this.max - this.min) * this.step;
    },
    thumbContainerClasses: function thumbContainerClasses() {
      return {
        'slider__thumb-container': true,
        'slider__thumb-container--label': this.thumbLabel
      };
    },
    thumbStyles: function thumbStyles() {
      return {
        left: this.inputWidth + '%'
      };
    },
    tickContainerStyles: function tickContainerStyles() {
      return {
        transform: 'translate3d(0, -50%, 0)'
      };
    },
    trackStyles: function trackStyles() {
      var scaleX = this.calculateScale(1 - this.inputWidth / 100);
      var translateX = this.inputWidth < 1 && !this.isActive ? 8 + 'px' : 0;
      return {
        transform: 'scaleX(' + scaleX + ') translateX(' + translateX + ')'
      };
    },
    trackFillStyles: function trackFillStyles() {
      var inputWidth = this.inputWidth;
      var scaleX = this.calculateScale(inputWidth / 100);
      var translateX = inputWidth > 99 && !this.thumbLabel ? -8 + 'px' : 0;
      return {
        transform: 'scaleX(' + scaleX + ') translateX(' + translateX + ')'
      };
    },
    numTicks: function numTicks() {
      return parseInt((this.max - this.min) / this.step);
    }
  },

  watch: {
    value: function value() {
      this.inputValue = this.value;
    }
  },

  mounted: function mounted() {
    var _this = this;

    this.inputValue = this.value;
    this.$nextTick(function () {
      _this.inputWidth = _this.calculateWidth(_this.inputValue);
    });

    // Without a v-app, iOS does not work with body selectors
    this.app = document.querySelector('[data-app]') || console.warn('The v-slider component requires the present of v-app or a non-body wrapping element with the [data-app] attribute.');
  },


  methods: {
    calculateWidth: function calculateWidth(val) {
      if (this.snap) {
        val = Math.round(val / this.step) * this.step;
      }

      val = (val - this.min) / (this.max - this.min) * 100;

      return val < 0.15 ? 0 : val;
    },
    calculateScale: function calculateScale(scale) {
      if (scale < 0.02 && !this.thumbLabel) {
        return 0;
      }

      return this.disabled ? scale - 0.015 : scale;
    },
    onMouseDown: function onMouseDown(e) {
      var options = { passive: true };
      this.isActive = true;

      if ('touches' in e) {
        this.app.addEventListener('touchmove', this.onMouseMove, options);
        Object(__WEBPACK_IMPORTED_MODULE_1__util_helpers__["a" /* addOnceEventListener */])(this.app, 'touchend', this.onMouseUp);
      } else {
        this.app.addEventListener('mousemove', this.onMouseMove, options);
        Object(__WEBPACK_IMPORTED_MODULE_1__util_helpers__["a" /* addOnceEventListener */])(this.app, 'mouseup', this.onMouseUp);
      }
    },
    onMouseUp: function onMouseUp() {
      var options = { passive: true };
      this.isActive = false;
      this.app.removeEventListener('touchmove', this.onMouseMove, options);
      this.app.removeEventListener('mousemove', this.onMouseMove, options);
    },
    onMouseMove: function onMouseMove(e) {
      var _$refs$track$getBound = this.$refs.track.getBoundingClientRect(),
          offsetLeft = _$refs$track$getBound.left,
          trackWidth = _$refs$track$getBound.width;

      var clientX = 'touches' in e ? e.touches[0].clientX : e.clientX;
      var left = (clientX - offsetLeft) / trackWidth * 100;

      left = left < 0 ? 0 : left > 100 ? 100 : left;

      this.inputValue = this.min + left / 100 * (this.max - this.min);
    },
    onKeyDown: function onKeyDown(e) {
      if (!e.keyCode === 37 && !e.keyCode === 39) return;

      var direction = e.keyCode === 37 && -1 || e.keyCode === 39 && 1 || 0;
      var multiplier = e.shiftKey && 3 || e.ctrlKey && 2 || 1;
      var amount = this.snap && this.step || 1;

      this.inputValue = this.inputValue + direction * amount * multiplier;
    },
    sliderMove: function sliderMove(e) {
      if (!this.isActive) {
        this.onMouseMove(e);
      }
    },
    genThumbLabel: function genThumbLabel(h) {
      return h('v-scale-transition', {
        props: { origin: 'bottom center' }
      }, [h('div', {
        'class': 'slider__thumb--label__container',
        directives: [{
          name: 'show',
          value: this.isActive
        }]
      }, [h('div', { 'class': 'slider__thumb--label' }, [h('span', {}, parseInt(this.inputValue))])])]);
    },
    genThumbContainer: function genThumbContainer(h) {
      var children = [];
      children.push(h('div', { 'class': 'slider__thumb' }));

      this.thumbLabel && children.push(this.genThumbLabel(h));

      return h('div', {
        'class': this.thumbContainerClasses,
        style: this.thumbStyles,
        on: {
          touchstart: this.onMouseDown,
          mousedown: this.onMouseDown
        },
        ref: 'thumb'
      }, children);
    },
    genSteps: function genSteps(h) {
      var _this2 = this;

      var ticks = Object(__WEBPACK_IMPORTED_MODULE_1__util_helpers__["c" /* createRange */])(this.numTicks + 1).map(function (i) {
        var span = h('span', {
          class: 'slider__tick',
          style: {
            left: i * (100 / _this2.numTicks) + '%'
          }
        });

        return span;
      });

      return h('div', {
        'class': 'slider__ticks-container',
        style: this.tickContainerStyles
      }, ticks);
    },
    genTrackContainer: function genTrackContainer(h) {
      var children = [h('div', {
        'class': 'slider__track',
        style: this.trackStyles
      }), h('div', {
        'class': 'slider__track-fill',
        style: this.trackFillStyles
      })];

      return h('div', {
        'class': 'slider__track__container',
        ref: 'track'
      }, children);
    }
  },

  render: function render(h) {
    var children = [];

    children.push(this.genTrackContainer(h));
    this.step && children.push(this.genSteps(h));
    children.push(this.genThumbContainer(h));

    var slider = h('div', { 'class': 'slider' }, children);

    return this.genInputGroup([slider], {
      attrs: {
        role: 'slider',
        tabindex: this.tabindex
      },
      on: Object.assign({}, {
        mouseup: this.sliderMove,
        keydown: this.onKeyDown
      }, this.$listeners),
      directives: [{
        name: 'click-outside'
      }]
    });
  }
});

/***/ }),
/* 109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VSubheader__ = __webpack_require__(110);


/* harmony default export */ __webpack_exports__["a"] = ({
  VSubheader: __WEBPACK_IMPORTED_MODULE_0__VSubheader__["a" /* default */]
});

/***/ }),
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  props: {
    inset: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        children = _ref.children,
        props = _ref.props;

    data.staticClass = ('subheader ' + (data.staticClass || '')).trim();

    if (props.inset) data.staticClass += ' subheader--inset';
    if (props.light) data.staticClass += ' theme--light';
    if (props.dark) data.staticClass += ' theme--dark';

    return h('li', data, children);
  }
});

/***/ }),
/* 111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VStepper__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VStepperStep__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VStepperContent__ = __webpack_require__(114);





var VStepperHeader = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('stepper__header');

/* harmony default export */ __webpack_exports__["a"] = ({
  VStepper: __WEBPACK_IMPORTED_MODULE_1__VStepper__["a" /* default */],
  VStepperContent: __WEBPACK_IMPORTED_MODULE_3__VStepperContent__["a" /* default */],
  VStepperHeader: VStepperHeader,
  VStepperStep: __WEBPACK_IMPORTED_MODULE_2__VStepperStep__["a" /* default */]
});

/***/ }),
/* 112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-stepper',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  provide: function provide() {
    return {
      stepClick: this.stepClick
    };
  },
  data: function data() {
    return {
      inputValue: null,
      isBooted: false,
      steps: [],
      content: [],
      isReverse: false
    };
  },


  props: {
    nonLinear: Boolean,
    altLabels: Boolean,
    vertical: Boolean,
    value: [Number, String]
  },

  computed: {
    classes: function classes() {
      return {
        'stepper': true,
        'stepper--is-booted': this.isBooted,
        'stepper--vertical': this.vertical,
        'stepper--alt-labels': this.altLabels,
        'stepper--non-linear': this.nonLinear,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    }
  },

  watch: {
    inputValue: function inputValue(val, prev) {
      var _this = this;

      this.isReverse = Number(val) < Number(prev);
      this.steps.forEach(function (i) {
        return i.toggle(_this.inputValue);
      });
      this.content.forEach(function (i) {
        return i.toggle(_this.inputValue, _this.isReverse);
      });

      this.$emit('input', this.inputValue);
      prev && (this.isBooted = true);
    },
    value: function value() {
      this.inputValue = this.value;
    }
  },

  mounted: function mounted() {
    this.$vuetify.load(this.init);
  },


  methods: {
    init: function init() {
      var _this2 = this;

      this.$children.forEach(function (i) {
        if (i.$options._componentTag === 'v-stepper-step') {
          _this2.steps.push(i);
        } else if (i.$options._componentTag === 'v-stepper-content') {
          i.isVertical = _this2.vertical;
          _this2.content.push(i);
        }
      });

      this.inputValue = this.value || this.steps[0].step || 1;
    },
    stepClick: function stepClick(step) {
      this.inputValue = step;
    }
  },

  render: function render(h) {
    return h('div', {
      'class': this.classes
    }, this.$slots.default);
  }
});

/***/ }),
/* 113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-stepper-step',

  inject: ['stepClick'],

  data: function data() {
    return {
      isActive: false,
      isInactive: true
    };
  },


  props: {
    complete: Boolean,
    completeIcon: {
      type: String,
      default: 'check'
    },
    editIcon: {
      type: String,
      default: 'edit'
    },
    errorIcon: {
      type: String,
      default: 'warning'
    },
    editable: Boolean,
    rules: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    step: [Number, String]
  },

  computed: {
    classes: function classes() {
      return {
        'stepper__step': true,
        'stepper__step--active': this.isActive,
        'stepper__step--editable': this.editable,
        'stepper__step--inactive': this.isInactive,
        'stepper__step--error': this.hasError,
        'stepper__step--complete': this.complete
      };
    },
    hasError: function hasError() {
      return this.rules.some(function (i) {
        return i() !== true;
      });
    }
  },

  methods: {
    click: function click(e) {
      e.stopPropagation();

      if (this.editable) {
        this.stepClick(this.step);
      }
    },
    toggle: function toggle(step) {
      this.isActive = step.toString() === this.step.toString();
      this.isInactive = Number(step) < Number(this.step);
    }
  },

  render: function render(h) {
    var data = {
      'class': this.classes,
      directives: [{
        name: 'ripple',
        value: this.editable
      }],
      on: { click: this.click }
    };
    var stepContent = void 0;

    if (this.hasError) {
      stepContent = [h('v-icon', {}, this.errorIcon)];
    } else if (this.complete) {
      if (this.editable) {
        stepContent = [h('v-icon', {}, this.editIcon)];
      } else {
        stepContent = [h('v-icon', {}, this.completeIcon)];
      }
    } else {
      stepContent = this.step;
    }

    var step = h('span', { 'class': 'stepper__step__step' }, stepContent);
    var label = h('div', { 'class': 'stepper__label' }, this.$slots.default);

    return h('div', data, [step, label]);
  }
});

/***/ }),
/* 114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-stepper-content',

  data: function data() {
    return {
      height: 0,
      isActive: false,
      isReverse: false,
      isVertical: false
    };
  },


  props: {
    step: {
      type: [Number, String],
      required: true
    }
  },

  computed: {
    classes: function classes() {
      return {
        'stepper__content': true
      };
    },
    computedTransition: function computedTransition() {
      return this.isReverse ? 'v-tab-reverse-transition' : 'v-tab-transition';
    },
    styles: function styles() {
      if (!this.isVertical) return {};

      return {
        height: !isNaN(this.height) ? this.height + 'px' : this.height
      };
    },
    wrapperClasses: function wrapperClasses() {
      return {
        'stepper__wrapper': true
      };
    }
  },

  watch: {
    isActive: function isActive() {
      if (!this.isVertical) {
        return;
      }

      if (this.isActive) {
        this.enter();
      } else {
        this.leave();
      }
    }
  },

  mounted: function mounted() {
    this.$refs.wrapper.addEventListener('transitionend', this.onTransition, false);
  },
  beforeDestroy: function beforeDestroy() {
    this.$refs.wrapper.removeEventListener('transitionend', this.onTransition, false);
  },


  methods: {
    onTransition: function onTransition() {
      if (!this.isActive) return;

      this.height = 'auto';
    },
    enter: function enter() {
      var _this = this;

      var scrollHeight = 0;

      // Render bug with height
      setTimeout(function () {
        scrollHeight = _this.$refs.wrapper.scrollHeight;
      }, 0);

      this.height = 0;

      // Give the collapsing element time to collapse
      setTimeout(function () {
        return _this.height = scrollHeight || 'auto';
      }, 450);
    },
    leave: function leave() {
      var _this2 = this;

      this.height = this.$refs.wrapper.clientHeight;
      setTimeout(function () {
        return _this2.height = 0;
      }, 0);
    },
    toggle: function toggle(step, reverse) {
      this.isActive = step.toString() === this.step.toString();
      this.isReverse = reverse;
    }
  },

  render: function render(h) {
    var contentData = {
      'class': this.classes
    };
    var wrapperData = {
      'class': this.wrapperClasses,
      style: this.styles,
      ref: 'wrapper'
    };

    if (!this.isVertical) {
      contentData.directives = [{
        name: 'show',
        value: this.isActive
      }];
    }

    var wrapper = h('div', wrapperData, [this.$slots.default]);
    var content = h('div', contentData, [wrapper]);

    return h(this.computedTransition, {
      on: this.$listeners
    }, [content]);
  }
});

/***/ }),
/* 115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VTableOverflow */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VDataTable__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VEditDialog__ = __webpack_require__(121);




var VTableOverflow = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('table__overflow');

/* harmony default export */ __webpack_exports__["a"] = ({
  VDataTable: __WEBPACK_IMPORTED_MODULE_1__VDataTable__["a" /* default */],
  VEditDialog: __WEBPACK_IMPORTED_MODULE_2__VEditDialog__["a" /* default */],
  VTableOverflow: VTableOverflow
});

/***/ }),
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_head__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_body__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_foot__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_progress__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_filterable__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_buttons_VBtn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_icons_VIcon__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_progress_VProgressLinear__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_selects_VSelect__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__util_helpers__ = __webpack_require__(0);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };















/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-datatable',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_head__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_body__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_filterable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_foot__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_progress__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__mixins_themeable__["a" /* default */]],

  components: {
    VBtn: __WEBPACK_IMPORTED_MODULE_6__components_buttons_VBtn__["a" /* default */],
    VIcon: __WEBPACK_IMPORTED_MODULE_7__components_icons_VIcon__["a" /* default */],
    VProgressLinear: __WEBPACK_IMPORTED_MODULE_8__components_progress_VProgressLinear__["a" /* default */],
    VSelect: __WEBPACK_IMPORTED_MODULE_9__components_selects_VSelect__["a" /* default */],
    // Importing does not work properly
    'v-table-overflow': Object(__WEBPACK_IMPORTED_MODULE_10__util_helpers__["d" /* createSimpleFunctional */])('table__overflow')
  },

  data: function data() {
    return {
      all: false,
      searchLength: 0,
      defaultPagination: {
        page: 1,
        rowsPerPage: 5,
        descending: false,
        totalItems: 0
      }
    };
  },


  props: {
    headers: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    headerText: {
      type: String,
      default: 'text'
    },
    hideActions: Boolean,
    noResultsText: {
      type: String,
      default: 'No matching records found'
    },
    rowsPerPageItems: {
      type: Array,
      default: function _default() {
        return [5, 10, 25, { text: 'All', value: -1 }];
      }
    },
    rowsPerPageText: {
      type: String,
      default: 'Rows per page:'
    },
    selectAll: [Boolean, String],
    search: {
      required: false
    },
    filter: {
      type: Function,
      default: function _default(val, search) {
        return val !== null && ['undefined', 'boolean'].indexOf(typeof val === 'undefined' ? 'undefined' : _typeof(val)) === -1 && val.toString().toLowerCase().indexOf(search) !== -1;
      }
    },
    customFilter: {
      type: Function,
      default: function _default(items, search, filter) {
        search = search.toString().toLowerCase();
        return items.filter(function (i) {
          return Object.keys(i).some(function (j) {
            return filter(i[j], search);
          });
        });
      }
    },
    customSort: {
      type: Function,
      default: function _default(items, index, isDescending) {
        if (index === null) return items;

        return items.sort(function (a, b) {
          var sortA = Object(__WEBPACK_IMPORTED_MODULE_10__util_helpers__["g" /* getObjectValueByPath */])(a, index);
          var sortB = Object(__WEBPACK_IMPORTED_MODULE_10__util_helpers__["g" /* getObjectValueByPath */])(b, index);

          if (isDescending) {
            var _ref = [sortB, sortA];
            sortA = _ref[0];
            sortB = _ref[1];
          }

          // Check if both are numbers
          if (!isNaN(sortA) && !isNaN(sortB)) {
            return sortA - sortB;
          }

          // Check if both cannot be evaluated
          if (sortA === null && sortB === null) {
            return 0;
          }

          var _map = [sortA, sortB].map(function (s) {
            return (s || '').toString().toLocaleLowerCase();
          });

          var _map2 = _slicedToArray(_map, 2);

          sortA = _map2[0];
          sortB = _map2[1];


          if (sortA > sortB) return 1;
          if (sortA < sortB) return -1;

          return 0;
        });
      }
    },
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    items: {
      type: Array,
      required: true,
      default: function _default() {
        return [];
      }
    },
    totalItems: {
      type: Number,
      default: null
    },
    loading: {
      type: [Boolean, String],
      default: false
    },
    selectedKey: {
      type: String,
      default: 'id'
    },
    pagination: {
      type: Object,
      default: null
    }
  },

  computed: {
    classes: function classes() {
      return {
        'datatable table': true,
        'datatable--select-all': this.selectAll !== false,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    },
    computedPagination: function computedPagination() {
      return this.pagination || this.defaultPagination;
    },
    hasSelectAll: function hasSelectAll() {
      return this.selectAll !== undefined && this.selectAll !== false;
    },
    itemsLength: function itemsLength() {
      if (this.search) return this.searchLength;
      return this.totalItems || this.items.length;
    },
    indeterminate: function indeterminate() {
      return this.hasSelectAll && this.someItems && !this.everyItem;
    },
    everyItem: function everyItem() {
      var _this = this;

      return this.filteredItems.length && this.filteredItems.every(function (i) {
        return _this.isSelected(i);
      });
    },
    someItems: function someItems() {
      var _this2 = this;

      return this.filteredItems.some(function (i) {
        return _this2.isSelected(i);
      });
    },
    getPage: function getPage() {
      var rowsPerPage = this.computedPagination.rowsPerPage;


      return rowsPerPage === Object(rowsPerPage) ? rowsPerPage.value : rowsPerPage;
    },
    pageStart: function pageStart() {
      return this.getPage === -1 ? 0 : (this.computedPagination.page - 1) * this.getPage;
    },
    pageStop: function pageStop() {
      return this.getPage === -1 ? this.itemsLength : this.computedPagination.page * this.getPage;
    },
    filteredItems: function filteredItems() {
      if (this.totalItems) return this.items;

      var items = this.items.slice();
      var hasSearch = typeof this.search !== 'undefined' && this.search !== null;

      if (hasSearch) {
        items = this.customFilter(items, this.search, this.filter);
        this.searchLength = items.length;
      }

      items = this.customSort(items, this.computedPagination.sortBy, this.computedPagination.descending);

      return this.hideActions && !this.pagination ? items : items.slice(this.pageStart, this.pageStop);
    },
    selected: function selected() {
      var _this3 = this;

      var selected = {};
      this.value.forEach(function (i) {
        return selected[i[_this3.selectedKey]] = true;
      });
      return selected;
    }
  },

  watch: {
    indeterminate: function indeterminate(val) {
      if (val) this.all = true;
    },
    someItems: function someItems(val) {
      if (!val) this.all = false;
    },
    search: function search() {
      this.updatePagination({ page: 1 });
    },
    everyItem: function everyItem(val) {
      if (val) this.all = true;
    }
  },

  methods: {
    updatePagination: function updatePagination(val) {
      var pagination = this.pagination || this.defaultPagination;
      var updatedPagination = Object.assign({}, pagination, val);

      if (this.pagination) {
        this.$emit('update:pagination', updatedPagination);
      } else {
        this.defaultPagination = updatedPagination;
      }
    },
    isSelected: function isSelected(item) {
      return this.selected[item[this.selectedKey]];
    },
    sort: function sort(index) {
      var _computedPagination = this.computedPagination,
          sortBy = _computedPagination.sortBy,
          descending = _computedPagination.descending;

      if (sortBy === null) {
        this.updatePagination({ sortBy: index, descending: false });
      } else if (sortBy === index && !descending) {
        this.updatePagination({ descending: true });
      } else if (sortBy !== index) {
        this.updatePagination({ sortBy: index, descending: false });
      } else {
        this.updatePagination({ sortBy: null, descending: null });
      }
    },
    needsTR: function needsTR(row) {
      return row.length && row.find(function (c) {
        return c.tag === 'td';
      });
    },
    genTR: function genTR(children) {
      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      return this.$createElement('tr', data, children);
    },
    toggle: function toggle(value) {
      var _this4 = this;

      var selected = Object.assign({}, this.selected);
      this.filteredItems.forEach(function (i) {
        return selected[i[_this4.selectedKey]] = value;
      });

      this.$emit('input', this.items.filter(function (i) {
        return selected[i[_this4.selectedKey]];
      }));
    }
  },

  created: function created() {
    var firstSortable = this.headers.find(function (h) {
      return !('sortable' in h) || h.sortable;
    });

    this.defaultPagination.sortBy = firstSortable ? firstSortable.value : null;

    if (!this.rowsPerPageItems.length) {
      console.warn('The prop \'rows-per-page-items\' in v-data-table can not be empty.');
    } else {
      this.defaultPagination.rowsPerPage = this.rowsPerPageItems[0];
    }

    this.updatePagination(Object.assign({}, this.defaultPagination, this.pagination));
  },
  render: function render(h) {
    return h('v-table-overflow', {}, [h('table', {
      'class': this.classes
    }, [this.genTHead(), this.genTProgress(), this.genTBody(), this.genTFoot()])]);
  }
});

/***/ }),
/* 117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genTHead: function genTHead() {
      var _this = this;

      var children = [];

      if (this.$scopedSlots.headers) {
        var row = this.$scopedSlots.headers({
          headers: this.headers,
          indeterminate: this.indeterminate,
          all: this.all
        });

        children = this.needsTR(row) ? this.genTR(row) : row;
      } else {
        var _row = this.headers.map(function (o) {
          return _this.genHeader(o);
        });
        var checkbox = this.$createElement('v-checkbox', {
          props: {
            dark: this.dark,
            light: this.light,
            color: this.selectAll === true && '' || this.selectAll,
            hideDetails: true,
            inputValue: this.all,
            indeterminate: this.indeterminate
          },
          on: { change: this.toggle }
        });

        this.hasSelectAll && _row.unshift(this.$createElement('th', [checkbox]));

        children = this.genTR(_row);
      }

      return this.$createElement('thead', [children]);
    },
    genHeader: function genHeader(header) {
      var array = [this.$scopedSlots.headerCell ? this.$scopedSlots.headerCell({ header: header }) : header[this.headerText]];

      return this.$createElement.apply(this, ['th'].concat(_toConsumableArray(this.genHeaderData(header, array))));
    },
    genHeaderData: function genHeaderData(header, children) {
      var _this2 = this;

      var classes = ['column'];
      var data = {};
      var pagination = this.computedPagination;

      if ('sortable' in header && header.sortable || !('sortable' in header)) {
        data.on = { click: function click() {
            return _this2.sort(header.value);
          } };
        if (!('value' in header)) {
          console.warn('Data table headers must have a value property that corresponds to a value in the v-model array');
        }

        classes.push('sortable');
        var icon = this.$createElement('v-icon', 'arrow_upward');
        if (header.align && header.align === 'left') {
          children.push(icon);
        } else {
          children.unshift(icon);
        }

        var beingSorted = pagination.sortBy === header.value;
        if (beingSorted) {
          classes.push('active');
          classes.push(pagination.descending ? 'desc' : 'asc');
        }
      }

      classes.push('text-xs-' + (header.align || 'right'));
      data.class = classes;

      return [data, children];
    }
  }
});

/***/ }),
/* 118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genTBody: function genTBody() {
      var children = [];

      if (!this.itemsLength) {
        children.push(this.genEmptyBody(this.noDataText));
      } else if (!this.filteredItems.length) {
        children.push(this.genEmptyBody(this.noResultsText));
      } else {
        children.push(this.genFilteredItems());
      }

      return this.$createElement('tbody', children);
    },
    genFilteredItems: function genFilteredItems() {
      var _this = this;

      return this.filteredItems.map(function (item, index) {
        var props = { item: item, index: index };
        var key = _this.selectedKey;

        Object.defineProperty(props, 'selected', {
          get: function get() {
            return _this.selected[item[_this.selectedKey]];
          },
          set: function set(value) {
            var selected = _this.value.slice();
            if (value) selected.push(item);else selected = selected.filter(function (i) {
              return i[key] !== item[key];
            });

            _this.$emit('input', selected);
          }
        });

        var row = _this.$scopedSlots.items(props);

        return _this.needsTR(row) ? _this.genTR(row, {
          attrs: { active: _this.isSelected(item) }
        }) : row;
      });
    },
    genEmptyBody: function genEmptyBody(text) {
      return this.genTR([this.$createElement('td', {
        'class': 'text-xs-center',
        attrs: { colspan: '100%' }
      }, text)]);
    }
  }
});

/***/ }),
/* 119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genPrevIcon: function genPrevIcon() {
      var _this = this;

      return this.$createElement('v-btn', {
        props: {
          disabled: this.computedPagination.page === 1,
          icon: true,
          flat: true,
          dark: this.dark,
          light: this.light
        },
        on: {
          click: function click() {
            var page = _this.computedPagination.page;
            _this.updatePagination({ page: page - 1 });
          }
        }
      }, [this.$createElement('v-icon', 'chevron_left')]);
    },
    genNextIcon: function genNextIcon() {
      var _this2 = this;

      var pagination = this.computedPagination;
      var disabled = pagination.rowsPerPage < 0 || pagination.page * pagination.rowsPerPage >= this.itemsLength || this.pageStop < 0;

      return this.$createElement('v-btn', {
        props: {
          disabled: disabled,
          icon: true,
          flat: true,
          dark: this.dark,
          light: this.light
        },
        on: {
          click: function click() {
            var page = _this2.computedPagination.page;
            _this2.updatePagination({ page: page + 1 });
          }
        }
      }, [this.$createElement('v-icon', 'chevron_right')]);
    },
    genSelect: function genSelect() {
      var _this3 = this;

      return this.$createElement('div', {
        'class': 'datatable__actions__select'
      }, [this.rowsPerPageText, this.$createElement('v-select', {
        props: {
          items: this.rowsPerPageItems,
          value: this.computedPagination.rowsPerPage,
          hideDetails: true,
          auto: true,
          minWidth: '75px'
        },
        on: {
          input: function input(val) {
            _this3.updatePagination({
              page: 1,
              rowsPerPage: val
            });
          }
        }
      })]);
    },
    genPagination: function genPagination() {
      var pagination = '–';

      if (this.itemsLength) {
        var stop = this.itemsLength < this.pageStop || this.pageStop < 0 ? this.itemsLength : this.pageStop;

        pagination = this.$scopedSlots.pageText ? this.$scopedSlots.pageText({
          pageStart: this.pageStart + 1,
          pageStop: stop,
          itemsLength: this.itemsLength
        }) : this.pageStart + 1 + '-' + stop + ' of ' + this.itemsLength;
      }

      return this.$createElement('div', {
        'class': 'datatable__actions__pagination'
      }, [pagination]);
    },
    genActions: function genActions() {
      return [this.$createElement('div', {
        'class': 'datatable__actions'
      }, [this.genSelect(), this.genPagination(), this.genPrevIcon(), this.genNextIcon()])];
    },
    genTFoot: function genTFoot() {
      var children = [];

      if (this.$slots.footer) {
        var footer = this.$slots.footer;
        var row = this.needsTR(footer) ? this.genTR(footer) : footer;

        children.push(row);
      }

      if (!this.hideActions) {
        children.push(this.genTR([this.$createElement('td', {
          attrs: { colspan: '100%' }
        }, this.genActions())]));
      }

      if (!children.length) return null;
      return this.$createElement('tfoot', children);
    }
  }
});

/***/ }),
/* 120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      color: ''
    };
  },


  watch: {
    loading: function loading(val) {
      if (val) this.color = val;
    }
  },

  methods: {
    genTProgress: function genTProgress() {
      var loader = this.$createElement('v-progress-linear', {
        props: {
          primary: this.color === 'primary',
          secondary: this.color === 'secondary',
          success: this.color === 'success',
          info: this.color === 'info',
          warning: this.color === 'warning',
          error: this.color === 'error',
          indeterminate: true,
          height: 3,
          active: !!this.loading
        }
      });

      var col = this.$createElement('th', {
        class: 'column',
        attrs: {
          colspan: '100%'
        }
      }, [loader]);

      return this.$createElement('thead', {
        class: 'datatable__progress'
      }, [this.genTR([col])]);
    }
  }
});

/***/ }),
/* 121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-edit-dialog',

  data: function data() {
    return {
      isActive: false,
      isSaving: false
    };
  },


  props: {
    cancelText: {
      default: 'Cancel'
    },
    large: Boolean,
    lazy: Boolean,
    saveText: {
      default: 'Save'
    },
    transition: {
      type: String,
      default: 'slide-x-reverse-transition'
    }
  },

  watch: {
    isActive: function isActive(val) {
      val && this.$emit('open') && setTimeout(this.focus, 50); // Give DOM time to paint

      if (!val) {
        !this.isSaving && this.$emit('cancel');
        this.isSaving && this.$emit('close');
        this.isSaving = false;
      }
    }
  },

  methods: {
    cancel: function cancel() {
      this.isActive = false;
    },
    focus: function focus() {
      var input = this.$refs.content.querySelector('input');
      input && input.focus();
    },
    save: function save() {
      this.isSaving = true;
      this.isActive = false;
      this.$emit('save');
    },
    genButton: function genButton(fn, text) {
      return this.$createElement('v-btn', {
        props: {
          flat: true,
          primary: true,
          light: true
        },
        on: { click: fn }
      }, text);
    },
    genActions: function genActions() {
      return this.$createElement('div', {
        'class': 'small-dialog__actions',
        directives: [{
          name: 'show',
          value: this.large
        }]
      }, [this.genButton(this.cancel, this.cancelText), this.genButton(this.save, this.saveText)]);
    },
    genContent: function genContent() {
      var _this = this;

      return this.$createElement('div', {
        'class': 'small-dialog__content',
        on: {
          keydown: function keydown(e) {
            e.keyCode === 27 && _this.cancel();
            e.keyCode === 13 && _this.save();
          }
        },
        ref: 'content'
      }, [this.$slots.input]);
    }
  },

  render: function render(h) {
    var _this2 = this;

    return h('v-menu', {
      'class': 'small-dialog',
      props: {
        transition: this.transition,
        origin: 'top right',
        right: true,
        value: this.isActive,
        closeOnContentClick: false,
        lazy: this.lazy
      },
      on: {
        input: function input(val) {
          return _this2.isActive = val;
        }
      }
    }, [h('a', {
      domProps: { href: 'javascript:;' },
      slot: 'activator'
    }, this.$slots.default), this.genContent(), this.genActions()]);
  }
});

/***/ }),
/* 122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VTabs__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VTabsItem__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VTabsContent__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__VTabsBar__ = __webpack_require__(126);






var VTabsSlider = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('tabs__slider', 'li');

var VTabsItems = {
  name: 'v-tabs-items',

  render: function render(h) {
    return h('div', { 'class': { 'tabs__items': true } }, [this.$slots.default]);
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  VTabsItem: __WEBPACK_IMPORTED_MODULE_2__VTabsItem__["a" /* default */],
  VTabsItems: VTabsItems,
  VTabs: __WEBPACK_IMPORTED_MODULE_1__VTabs__["a" /* default */],
  VTabsContent: __WEBPACK_IMPORTED_MODULE_3__VTabsContent__["a" /* default */],
  VTabsBar: __WEBPACK_IMPORTED_MODULE_4__VTabsBar__["a" /* default */],
  VTabsSlider: VTabsSlider
});

/***/ }),
/* 123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__directives__ = __webpack_require__(4);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-tabs',

  directives: {
    Resize: __WEBPACK_IMPORTED_MODULE_1__directives__["Resize"]
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  provide: function provide() {
    var _this = this;

    return {
      slider: this.slider,
      tabClick: this.tabClick,
      isScrollable: function isScrollable() {
        return _this.scrollable;
      },
      isMobile: function isMobile() {
        return _this.isMobile;
      }
    };
  },
  data: function data() {
    return {
      activators: [],
      activeIndex: null,
      isMobile: false,
      reverse: false,
      target: null,
      tabsSlider: null,
      targetEl: null,
      tabsContainer: null
    };
  },


  props: {
    centered: Boolean,
    fixed: Boolean,
    grow: Boolean,
    icons: Boolean,
    mobileBreakPoint: {
      type: [Number, String],
      default: 1024
    },
    value: String,
    scrollable: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    classes: function classes() {
      return {
        'tabs': true,
        'tabs--centered': this.centered,
        'tabs--fixed': this.fixed,
        'tabs--grow': this.grow,
        'tabs--icons': this.icons,
        'tabs--mobile': this.isMobile,
        'tabs--scroll-bars': this.scrollable,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    }
  },

  watch: {
    value: function value() {
      this.tabClick(this.value);
    },
    activeIndex: function activeIndex() {
      this.updateTabs();
      this.$emit('input', this.target);
      this.isBooted = true;
    }
  },

  mounted: function mounted() {
    var _this2 = this;

    this.$vuetify.load(function () {
      var activators = _this2.$slots.activators;

      if (!activators || !activators.length || !activators[0].componentInstance) return;

      var bar = activators[0].componentInstance.$children;
      // // This is a workaround to detect if link is active
      // // when being used as a router or nuxt link
      var i = bar.findIndex(function (t) {
        return t.$el.firstChild.classList.contains('tabs__item--active');
      });

      var tab = _this2.value || (bar[i !== -1 ? i : 0] || {}).action;

      tab && _this2.tabClick(tab) && _this2.onResize();
    });
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.resize, { passive: true });
  },


  methods: {
    onResize: function onResize() {
      this.isMobile = window.innerWidth < this.mobileBreakPoint;
      this.slider();
    },
    slider: function slider(el) {
      var _this3 = this;

      this.tabsSlider = this.tabsSlider || this.$el.querySelector('.tabs__slider');

      this.tabsContainer = this.tabsContainer || this.$el.querySelector('.tabs__container');

      if (!this.tabsSlider || !this.tabsContainer) return;

      this.targetEl = el || this.targetEl;

      if (!this.targetEl || !this.tabsContainer) return;

      // Gives DOM time to paint when
      // processing slider for
      // dynamic tabs
      this.$nextTick(function () {
        // #684 Calculate width as %
        var width = _this3.targetEl.scrollWidth / _this3.tabsContainer.clientWidth * 100;

        _this3.tabsSlider.style.width = width + '%';
        _this3.tabsSlider.style.left = _this3.targetEl.offsetLeft + 'px';
      });
    },
    tabClick: function tabClick(target) {
      var _this4 = this;

      var setActiveIndex = function setActiveIndex(index) {
        if (_this4.activeIndex === index) {
          // #762 update tabs display
          // In case tabs count got changed but activeIndex didn't
          _this4.updateTabs();
        } else {
          _this4.activeIndex = index;
        }
      };

      this.target = target;

      var content = this.$refs.content;
      if (!content) {
        setActiveIndex(target);
        return;
      }

      this.$nextTick(function () {
        var nextIndex = content.$children.findIndex(function (i) {
          return i.id === target;
        });
        _this4.reverse = nextIndex < _this4.activeIndex;
        setActiveIndex(nextIndex);
      });
    },
    updateTabs: function updateTabs() {
      var _this5 = this;

      var activators = this.$slots.activators;
      var content = this.$refs.content;

      if (!activators || !activators.length || activators.length && !activators[0].componentInstance) return;

      activators[0].componentInstance.$children.filter(function (i) {
        return i.$options._componentTag === 'v-tabs-item';
      }).forEach(function (i) {
        return i.toggle(_this5.target);
      });

      content && content.$children.forEach(function (i) {
        return i.toggle(_this5.target, _this5.reverse, _this5.isBooted);
      });
    }
  },

  render: function render(h) {
    var content = [];
    var slot = [];
    var iter = this.$slots.default || [];

    iter.forEach(function (c) {
      if (!c.componentOptions) slot.push(c);else if (c.componentOptions.tag === 'v-tabs-content') content.push(c);else slot.push(c);
    });

    var tabs = content.length ? h('v-tabs-items', {
      ref: 'content'
    }, content) : null;

    return h('div', {
      'class': this.classes,
      directives: [{
        name: 'resize',
        value: this.onResize
      }]
    }, [slot, this.$slots.activators, tabs]);
  }
});

/***/ }),
/* 124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_route_link__ = __webpack_require__(9);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-tabs-item',

  inject: ['slider', 'tabClick'],

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_route_link__["a" /* default */]],

  data: function data() {
    return {
      isActive: false
    };
  },


  props: {
    activeClass: {
      type: String,
      default: 'tabs__item--active'
    }
  },

  computed: {
    classes: function classes() {
      var classes = {
        'tabs__item': true,
        'tabs__item--disabled': this.disabled
      };

      classes[this.activeClass] = !this.to && this.isActive;

      return classes;
    },
    action: function action() {
      var to = this.to || this.href;

      if (!to || to === Object(to)) return this._uid;

      return to.replace('#', '');
    }
  },

  watch: {
    $route: function $route() {
      this.to && this.callSlider();
    }
  },

  mounted: function mounted() {
    this.callSlider();
  },


  methods: {
    callSlider: function callSlider() {
      var _this = this;

      setTimeout(function () {
        _this.$el.firstChild.classList.contains('tabs__item--active') && _this.slider(_this.$el);
      }, 0);
    },
    click: function click(e) {
      e.preventDefault();

      if (!this.to && !this.href) return;

      if (!this.to) {
        this.tabClick(this.action);
      }

      this.callSlider();
    },
    toggle: function toggle(action) {
      var _this2 = this;

      this.isActive = this.action === action;

      this.$nextTick(function () {
        _this2.isActive && _this2.slider(_this2.$el);
      });
    }
  },

  render: function render(h) {
    var _generateRouteLink = this.generateRouteLink(),
        tag = _generateRouteLink.tag,
        data = _generateRouteLink.data;

    return h('li', {
      'class': 'tabs__li'
    }, [h(tag, data, this.$slots.default)]);
  }
});

/***/ }),
/* 125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_bootable__ = __webpack_require__(10);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-tabs-content',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_bootable__["a" /* default */]],

  data: function data() {
    return {
      isActive: false,
      reverse: false
    };
  },


  props: {
    id: {
      type: String,
      required: true
    },
    lazy: Boolean,
    transition: {
      type: String,
      default: 'v-tab-transition'
    },
    reverseTransition: {
      type: String,
      default: 'v-tab-reverse-transition'
    }
  },

  computed: {
    computedTransition: function computedTransition() {
      return this.reverse ? this.reverseTransition : this.transition;
    }
  },

  methods: {
    toggle: function toggle(target, reverse, showTransition) {
      this.$el.style.transition = !showTransition ? 'none' : null;
      this.reverse = reverse;
      this.isActive = this.id === target;
    }
  },

  render: function render(h) {
    return h(this.computedTransition, {}, [h('div', {
      'class': 'tabs__content',
      domProps: { id: this.id },
      directives: [{
        name: 'show',
        value: this.isActive
      }],
      on: this.$listeners
    }, this.lazy && this.isBooted || !this.lazy ? this.$slots.default : null)]);
  }
});

/***/ }),
/* 126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_icons_VIcon__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__directives__ = __webpack_require__(4);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-tabs-bar',

  directives: {
    Resize: __WEBPACK_IMPORTED_MODULE_1__directives__["Resize"]
  },

  inject: ['isScrollable', 'isMobile'],

  data: function data() {
    return {
      isOverflowing: false,
      scrollOffset: 0,
      itemOffset: 0,
      startX: 0
    };
  },


  computed: {
    classes: function classes() {
      return {
        'tabs__bar': true
      };
    },
    containerClasses: function containerClasses() {
      return {
        'tabs__container': true
      };
    },
    wrapperClasses: function wrapperClasses() {
      return {
        'tabs__wrapper': true,
        'tabs__wrapper--scrollable': this.isScrollable(),
        'tabs__wrapper--overflow': this.isOverflowing
      };
    },
    containerStyles: function containerStyles() {
      return {
        'transform': 'translateX(' + -this.scrollOffset + 'px)'
      };
    },
    leftIconVisible: function leftIconVisible() {
      return !this.isMobile() && this.isScrollable() && this.isOverflowing && this.scrollOffset > 0;
    },
    rightIconVisible: function rightIconVisible() {
      if (this.isMobile() || !this.isScrollable() || !this.isOverflowing) return;

      // Check one scroll ahead to know the width of right-most item
      var container = this.$refs.container;
      var item = this.newOffsetRight(this.scrollOffset, this.itemOffset);
      var itemWidth = item && container.children[item.index].clientWidth || 0;
      var scrollOffset = this.scrollOffset + container.clientWidth;

      return container.scrollWidth - scrollOffset > itemWidth * 0.30;
    }
  },

  methods: {
    genContainer: function genContainer() {
      return this.$createElement('ul', {
        'class': this.containerClasses,
        'style': this.containerStyles,
        ref: 'container'
      }, this.$slots.default);
    },
    genIcon: function genIcon(direction) {
      var capitalize = direction.charAt(0).toUpperCase() + direction.slice(1);
      return this.$createElement(__WEBPACK_IMPORTED_MODULE_0__components_icons_VIcon__["a" /* default */], {
        props: _defineProperty({}, '' + direction, true),
        style: { display: 'inline-flex' },
        on: {
          click: this['scroll' + capitalize]
        }
      }, 'chevron_' + direction);
    },
    genWrapper: function genWrapper() {
      return this.$createElement('div', {
        class: this.wrapperClasses,
        directives: [{
          name: 'touch',
          value: {
            start: this.start,
            move: this.move,
            end: this.end
          }
        }]
      }, [this.genContainer()]);
    },
    start: function start(e) {
      this.startX = this.scrollOffset + e.touchstartX;
      this.$refs.container.style.transition = 'none';
    },
    move: function move(e) {
      var offset = this.startX - e.touchmoveX;
      this.scrollOffset = offset;
    },
    end: function end(e) {
      this.onResize();
      var container = this.$refs.container;
      var scrollWidth = container.scrollWidth - this.$el.clientWidth / 2;
      container.style.transition = null;

      if (this.scrollOffset < 0 || !this.isOverflowing) {
        this.scrollOffset = 0;
      } else if (this.scrollOffset >= scrollWidth) {
        var lastItem = container.children[container.children.length - 1];
        this.scrollOffset = scrollWidth - lastItem.clientWidth;
      }
    },
    scrollLeft: function scrollLeft() {
      var _newOffset = this.newOffset('Left'),
          offset = _newOffset.offset,
          index = _newOffset.index;

      this.scrollOffset = offset;
      this.itemOffset = index;
    },
    scrollRight: function scrollRight() {
      var _newOffset2 = this.newOffset('Right'),
          offset = _newOffset2.offset,
          index = _newOffset2.index;

      this.scrollOffset = offset;
      this.itemOffset = index;
    },
    onResize: function onResize() {
      if (this._isDestroyed) return;

      var container = this.$refs.container;
      this.isOverflowing = container.clientWidth < container.scrollWidth;
    },
    newOffset: function newOffset(direction) {
      return this['newOffset' + direction](this.scrollOffset, this.itemOffset);
    },
    newOffsetLeft: function newOffsetLeft(currentOffset, currentIndex) {
      var container = this.$refs.container;
      var items = container.children;
      var offset = 0;

      for (var index = currentIndex - 1; index >= 0; index--) {
        if (!items[index].classList.contains('tabs__slider')) {
          var newOffset = offset + items[index].clientWidth;
          if (newOffset >= container.clientWidth) {
            return { offset: currentOffset - offset, index: index + 1 };
          }
          offset = newOffset;
        }
      }

      return { offset: 0, index: 0 };
    },
    newOffsetRight: function newOffsetRight(currentOffset, currentIndex) {
      var container = this.$refs.container;
      var items = container.children;
      var offset = currentOffset;

      for (var index = currentIndex; index < items.length; index++) {
        if (!items[index].classList.contains('tabs__slider')) {
          var newOffset = offset + items[index].clientWidth;
          if (newOffset > currentOffset + container.clientWidth) {
            return { offset: offset, index: index };
          }
          offset = newOffset;
        }
      }

      return null;
    }
  },

  render: function render(h) {
    return h('div', {
      'class': this.classes,
      directives: [{
        name: 'resize',
        value: this.onResize
      }]
    }, [this.genWrapper(), this.leftIconVisible ? this.genIcon('left') : null, this.rightIconVisible ? this.genIcon('right') : null]);
  }
});

/***/ }),
/* 127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VTextField__ = __webpack_require__(128);


/* harmony default export */ __webpack_exports__["a"] = ({
  VTextField: __WEBPACK_IMPORTED_MODULE_0__VTextField__["a" /* default */]
});

/***/ }),
/* 128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_input__ = __webpack_require__(7);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-text-field',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_input__["a" /* default */]],

  inheritAttrs: false,

  data: function data() {
    return {
      hasFocused: false,
      inputHeight: null
    };
  },


  props: {
    autofocus: Boolean,
    autoGrow: Boolean,
    counter: Boolean,
    fullWidth: Boolean,
    max: [Number, String],
    min: [Number, String],
    multiLine: Boolean,
    placeholder: String,
    prefix: String,
    rows: {
      default: 5
    },
    singleLine: Boolean,
    solo: Boolean,
    suffix: String,
    textarea: Boolean,
    type: {
      type: String,
      default: 'text'
    }
  },

  computed: {
    classes: function classes() {
      return {
        'input-group--text-field': true,
        'input-group--single-line': this.singleLine,
        'input-group--solo': this.solo,
        'input-group--multi-line': this.multiLine,
        'input-group--full-width': this.fullWidth,
        'input-group--prefix': this.prefix,
        'input-group--suffix': this.suffix,
        'input-group--textarea': this.textarea
      };
    },
    hasError: function hasError() {
      return this.validations.length || this.errorMessages.length > 0 || !this.counterIsValid() || !this.validateIsValid() || this.error;
    },
    count: function count() {
      var inputLength = void 0;
      if (this.inputValue) inputLength = this.inputValue.toString().length;else inputLength = 0;
      var min = inputLength;

      if (this.counterMin !== 0 && inputLength < this.counterMin) {
        min = this.counterMin;
      }

      return min + ' / ' + this.counterMax;
    },
    counterMin: function counterMin() {
      var parsedMin = parseInt(this.min, 10);
      return isNaN(parsedMin) ? 0 : parsedMin;
    },
    counterMax: function counterMax() {
      var parsedMax = parseInt(this.max, 10);
      return isNaN(parsedMax) ? 25 : parsedMax;
    },

    inputValue: {
      get: function get() {
        return this.value;
      },
      set: function set(val) {
        if (this.modifiers.trim) {
          val = val.trim();
        }

        if (this.modifiers.number) {
          val = Number(val);
        }

        if (!this.modifiers.lazy) {
          this.$emit('input', val);
        }

        this.lazyValue = val;
      }
    },
    isDirty: function isDirty() {
      return this.lazyValue !== null && typeof this.lazyValue !== 'undefined' && this.lazyValue.toString().length > 0 || this.placeholder;
    }
  },

  watch: {
    focused: function focused(val) {
      this.hasFocused = true;
    },
    value: function value() {
      this.lazyValue = this.value;
      this.validate();
      this.multiLine && this.autoGrow && this.calculateInputHeight();
    }
  },

  mounted: function mounted() {
    var _this = this;

    this.$vuetify.load(function () {
      _this.multiLine && _this.autoGrow && _this.calculateInputHeight();
      _this.autofocus && _this.focus();
    });
  },


  methods: {
    calculateInputHeight: function calculateInputHeight() {
      var _this2 = this;

      this.inputHeight = null;

      this.$nextTick(function () {
        var height = _this2.$refs.input.scrollHeight;
        var minHeight = _this2.rows * 24;
        var inputHeight = height < minHeight ? minHeight : height;
        _this2.inputHeight = inputHeight;
      });
    },
    onChange: function onChange(e) {
      this.lazyValue = e.target.value;
      this.$emit('change', this.lazyValue || null);
    },
    onInput: function onInput(e) {
      this.inputValue = e.target.value;
      this.multiLine && this.autoGrow && this.calculateInputHeight();
    },
    blur: function blur(e) {
      var _this3 = this;

      this.validate();
      this.$nextTick(function () {
        return _this3.focused = false;
      });
      this.$emit('blur', e);
    },
    focus: function focus(e) {
      this.focused = true;
      this.$refs.input.focus();
      this.$emit('focus', e);
    },
    genCounter: function genCounter() {
      return this.$createElement('div', {
        'class': {
          'input-group__counter': true,
          'input-group__counter--error': !this.counterIsValid()
        }
      }, this.count);
    },
    genInput: function genInput() {
      var tag = this.multiLine || this.textarea ? 'textarea' : 'input';

      var data = {
        style: {
          'height': this.inputHeight && this.inputHeight + 'px'
        },
        domProps: {
          autofocus: this.autofocus,
          disabled: this.disabled,
          required: this.required,
          value: this.lazyValue
        },
        attrs: _extends({}, this.$attrs, {
          tabindex: this.tabindex,
          'aria-label': !this.$attrs.id && this.label // Label `for` will be set if we have an id
        }),
        on: _extends({}, this.$listeners, {
          blur: this.blur,
          input: this.onInput,
          focus: this.focus
        }),
        ref: 'input'
      };

      if (this.placeholder) data.domProps.placeholder = this.placeholder;

      if (!this.counter) {
        if (![undefined, null].includes(this.max)) data.attrs.max = this.max;
        if (![undefined, null].includes(this.min)) data.attrs.min = this.min;
      }

      if (!this.textarea && !this.multiLine) {
        data.domProps.type = this.type;
      } else {
        data.domProps.rows = this.rows;
      }

      var children = [this.$createElement(tag, data)];

      this.prefix && children.unshift(this.genFix('prefix'));
      this.suffix && children.push(this.genFix('suffix'));

      return children;
    },
    genFix: function genFix(type) {
      return this.$createElement('span', {
        'class': 'input-group--text-field__' + type
      }, this[type]);
    },

    counterIsValid: function counterIsValid() {
      var val = this.inputValue && this.inputValue.toString() || '';

      return !this.counter || val.length >= this.counterMin && val.length <= this.counterMax;
    },
    validateIsValid: function validateIsValid() {
      return !this.required || this.required && this.isDirty || !this.hasFocused || this.hasFocused && this.focused;
    }
  },

  render: function render() {
    return this.genInputGroup(this.genInput(), { attrs: { tabindex: false } });
  }
});

/***/ }),
/* 129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VSnackbar__ = __webpack_require__(130);


/* harmony default export */ __webpack_exports__["a"] = ({
  VSnackbar: __WEBPACK_IMPORTED_MODULE_0__VSnackbar__["a" /* default */]
});

/***/ }),
/* 130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__ = __webpack_require__(2);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-snackbar',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__["a" /* default */]],

  data: function data() {
    return {
      activeTimeout: {}
    };
  },


  props: {
    absolute: Boolean,
    bottom: Boolean,
    left: Boolean,
    multiLine: Boolean,
    right: Boolean,
    top: Boolean,
    timeout: {
      type: Number,
      default: 6000
    },
    vertical: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'snack': true,
        'snack--active': this.isActive,
        'snack--absolute': this.absolute,
        'snack--bottom': this.bottom || !this.top,
        'snack--left': this.left,
        'snack--multi-line': this.multiLine && !this.vertical,
        'snack--right': this.right,
        'snack--top': this.top,
        'snack--vertical': this.vertical,
        'primary': this.primary,
        'secondary': this.secondary,
        'success': this.success,
        'info': this.info,
        'warning': this.warning,
        'error': this.error
      };
    },
    computedTransition: function computedTransition() {
      return this.top ? 'v-slide-y-transition' : 'v-slide-y-reverse-transition';
    }
  },

  watch: {
    isActive: function isActive() {
      var _this = this;

      clearTimeout(this.activeTimeout);

      if (this.isActive && this.timeout) {
        this.activeTimeout = setTimeout(function () {
          _this.isActive = false;
        }, this.timeout);
      }
    }
  },

  render: function render(h) {
    var children = [];

    if (this.isActive) {
      children.push(h('div', {
        'class': 'snack__content'
      }, this.$slots.default));
    }

    return h('div', {
      'class': this.classes,
      on: this.$listeners
    }, [h(this.computedTransition, children)]);
  }
});

/***/ }),
/* 131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function load(cb) {
  var i = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

  if (document.readyState === 'complete') {
    return setTimeout(cb, 0);
  }

  if (document.readyState === 'interactive' && i <= 10) {
    return setTimeout(function () {
      return load(cb, i + 1);
    }, 200);
  }

  window.addEventListener('load', cb);
}

/* harmony default export */ __webpack_exports__["a"] = (load);

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {exports = module.exports = SemVer;

// The debug function is excluded entirely from the minified version.
/* nomin */ var debug;
/* nomin */ if (typeof process === 'object' &&
    /* nomin */ process.env &&
    /* nomin */ process.env.NODE_DEBUG &&
    /* nomin */ /\bsemver\b/i.test(process.env.NODE_DEBUG))
  /* nomin */ debug = function() {
    /* nomin */ var args = Array.prototype.slice.call(arguments, 0);
    /* nomin */ args.unshift('SEMVER');
    /* nomin */ console.log.apply(console, args);
    /* nomin */ };
/* nomin */ else
  /* nomin */ debug = function() {};

// Note: this is the semver.org version of the spec that it implements
// Not necessarily the package version of this code.
exports.SEMVER_SPEC_VERSION = '2.0.0';

var MAX_LENGTH = 256;
var MAX_SAFE_INTEGER = Number.MAX_SAFE_INTEGER || 9007199254740991;

// The actual regexps go on exports.re
var re = exports.re = [];
var src = exports.src = [];
var R = 0;

// The following Regular Expressions can be used for tokenizing,
// validating, and parsing SemVer version strings.

// ## Numeric Identifier
// A single `0`, or a non-zero digit followed by zero or more digits.

var NUMERICIDENTIFIER = R++;
src[NUMERICIDENTIFIER] = '0|[1-9]\\d*';
var NUMERICIDENTIFIERLOOSE = R++;
src[NUMERICIDENTIFIERLOOSE] = '[0-9]+';


// ## Non-numeric Identifier
// Zero or more digits, followed by a letter or hyphen, and then zero or
// more letters, digits, or hyphens.

var NONNUMERICIDENTIFIER = R++;
src[NONNUMERICIDENTIFIER] = '\\d*[a-zA-Z-][a-zA-Z0-9-]*';


// ## Main Version
// Three dot-separated numeric identifiers.

var MAINVERSION = R++;
src[MAINVERSION] = '(' + src[NUMERICIDENTIFIER] + ')\\.' +
                   '(' + src[NUMERICIDENTIFIER] + ')\\.' +
                   '(' + src[NUMERICIDENTIFIER] + ')';

var MAINVERSIONLOOSE = R++;
src[MAINVERSIONLOOSE] = '(' + src[NUMERICIDENTIFIERLOOSE] + ')\\.' +
                        '(' + src[NUMERICIDENTIFIERLOOSE] + ')\\.' +
                        '(' + src[NUMERICIDENTIFIERLOOSE] + ')';

// ## Pre-release Version Identifier
// A numeric identifier, or a non-numeric identifier.

var PRERELEASEIDENTIFIER = R++;
src[PRERELEASEIDENTIFIER] = '(?:' + src[NUMERICIDENTIFIER] +
                            '|' + src[NONNUMERICIDENTIFIER] + ')';

var PRERELEASEIDENTIFIERLOOSE = R++;
src[PRERELEASEIDENTIFIERLOOSE] = '(?:' + src[NUMERICIDENTIFIERLOOSE] +
                                 '|' + src[NONNUMERICIDENTIFIER] + ')';


// ## Pre-release Version
// Hyphen, followed by one or more dot-separated pre-release version
// identifiers.

var PRERELEASE = R++;
src[PRERELEASE] = '(?:-(' + src[PRERELEASEIDENTIFIER] +
                  '(?:\\.' + src[PRERELEASEIDENTIFIER] + ')*))';

var PRERELEASELOOSE = R++;
src[PRERELEASELOOSE] = '(?:-?(' + src[PRERELEASEIDENTIFIERLOOSE] +
                       '(?:\\.' + src[PRERELEASEIDENTIFIERLOOSE] + ')*))';

// ## Build Metadata Identifier
// Any combination of digits, letters, or hyphens.

var BUILDIDENTIFIER = R++;
src[BUILDIDENTIFIER] = '[0-9A-Za-z-]+';

// ## Build Metadata
// Plus sign, followed by one or more period-separated build metadata
// identifiers.

var BUILD = R++;
src[BUILD] = '(?:\\+(' + src[BUILDIDENTIFIER] +
             '(?:\\.' + src[BUILDIDENTIFIER] + ')*))';


// ## Full Version String
// A main version, followed optionally by a pre-release version and
// build metadata.

// Note that the only major, minor, patch, and pre-release sections of
// the version string are capturing groups.  The build metadata is not a
// capturing group, because it should not ever be used in version
// comparison.

var FULL = R++;
var FULLPLAIN = 'v?' + src[MAINVERSION] +
                src[PRERELEASE] + '?' +
                src[BUILD] + '?';

src[FULL] = '^' + FULLPLAIN + '$';

// like full, but allows v1.2.3 and =1.2.3, which people do sometimes.
// also, 1.0.0alpha1 (prerelease without the hyphen) which is pretty
// common in the npm registry.
var LOOSEPLAIN = '[v=\\s]*' + src[MAINVERSIONLOOSE] +
                 src[PRERELEASELOOSE] + '?' +
                 src[BUILD] + '?';

var LOOSE = R++;
src[LOOSE] = '^' + LOOSEPLAIN + '$';

var GTLT = R++;
src[GTLT] = '((?:<|>)?=?)';

// Something like "2.*" or "1.2.x".
// Note that "x.x" is a valid xRange identifer, meaning "any version"
// Only the first item is strictly required.
var XRANGEIDENTIFIERLOOSE = R++;
src[XRANGEIDENTIFIERLOOSE] = src[NUMERICIDENTIFIERLOOSE] + '|x|X|\\*';
var XRANGEIDENTIFIER = R++;
src[XRANGEIDENTIFIER] = src[NUMERICIDENTIFIER] + '|x|X|\\*';

var XRANGEPLAIN = R++;
src[XRANGEPLAIN] = '[v=\\s]*(' + src[XRANGEIDENTIFIER] + ')' +
                   '(?:\\.(' + src[XRANGEIDENTIFIER] + ')' +
                   '(?:\\.(' + src[XRANGEIDENTIFIER] + ')' +
                   '(?:' + src[PRERELEASE] + ')?' +
                   src[BUILD] + '?' +
                   ')?)?';

var XRANGEPLAINLOOSE = R++;
src[XRANGEPLAINLOOSE] = '[v=\\s]*(' + src[XRANGEIDENTIFIERLOOSE] + ')' +
                        '(?:\\.(' + src[XRANGEIDENTIFIERLOOSE] + ')' +
                        '(?:\\.(' + src[XRANGEIDENTIFIERLOOSE] + ')' +
                        '(?:' + src[PRERELEASELOOSE] + ')?' +
                        src[BUILD] + '?' +
                        ')?)?';

var XRANGE = R++;
src[XRANGE] = '^' + src[GTLT] + '\\s*' + src[XRANGEPLAIN] + '$';
var XRANGELOOSE = R++;
src[XRANGELOOSE] = '^' + src[GTLT] + '\\s*' + src[XRANGEPLAINLOOSE] + '$';

// Tilde ranges.
// Meaning is "reasonably at or greater than"
var LONETILDE = R++;
src[LONETILDE] = '(?:~>?)';

var TILDETRIM = R++;
src[TILDETRIM] = '(\\s*)' + src[LONETILDE] + '\\s+';
re[TILDETRIM] = new RegExp(src[TILDETRIM], 'g');
var tildeTrimReplace = '$1~';

var TILDE = R++;
src[TILDE] = '^' + src[LONETILDE] + src[XRANGEPLAIN] + '$';
var TILDELOOSE = R++;
src[TILDELOOSE] = '^' + src[LONETILDE] + src[XRANGEPLAINLOOSE] + '$';

// Caret ranges.
// Meaning is "at least and backwards compatible with"
var LONECARET = R++;
src[LONECARET] = '(?:\\^)';

var CARETTRIM = R++;
src[CARETTRIM] = '(\\s*)' + src[LONECARET] + '\\s+';
re[CARETTRIM] = new RegExp(src[CARETTRIM], 'g');
var caretTrimReplace = '$1^';

var CARET = R++;
src[CARET] = '^' + src[LONECARET] + src[XRANGEPLAIN] + '$';
var CARETLOOSE = R++;
src[CARETLOOSE] = '^' + src[LONECARET] + src[XRANGEPLAINLOOSE] + '$';

// A simple gt/lt/eq thing, or just "" to indicate "any version"
var COMPARATORLOOSE = R++;
src[COMPARATORLOOSE] = '^' + src[GTLT] + '\\s*(' + LOOSEPLAIN + ')$|^$';
var COMPARATOR = R++;
src[COMPARATOR] = '^' + src[GTLT] + '\\s*(' + FULLPLAIN + ')$|^$';


// An expression to strip any whitespace between the gtlt and the thing
// it modifies, so that `> 1.2.3` ==> `>1.2.3`
var COMPARATORTRIM = R++;
src[COMPARATORTRIM] = '(\\s*)' + src[GTLT] +
                      '\\s*(' + LOOSEPLAIN + '|' + src[XRANGEPLAIN] + ')';

// this one has to use the /g flag
re[COMPARATORTRIM] = new RegExp(src[COMPARATORTRIM], 'g');
var comparatorTrimReplace = '$1$2$3';


// Something like `1.2.3 - 1.2.4`
// Note that these all use the loose form, because they'll be
// checked against either the strict or loose comparator form
// later.
var HYPHENRANGE = R++;
src[HYPHENRANGE] = '^\\s*(' + src[XRANGEPLAIN] + ')' +
                   '\\s+-\\s+' +
                   '(' + src[XRANGEPLAIN] + ')' +
                   '\\s*$';

var HYPHENRANGELOOSE = R++;
src[HYPHENRANGELOOSE] = '^\\s*(' + src[XRANGEPLAINLOOSE] + ')' +
                        '\\s+-\\s+' +
                        '(' + src[XRANGEPLAINLOOSE] + ')' +
                        '\\s*$';

// Star ranges basically just allow anything at all.
var STAR = R++;
src[STAR] = '(<|>)?=?\\s*\\*';

// Compile to actual regexp objects.
// All are flag-free, unless they were created above with a flag.
for (var i = 0; i < R; i++) {
  debug(i, src[i]);
  if (!re[i])
    re[i] = new RegExp(src[i]);
}

exports.parse = parse;
function parse(version, loose) {
  if (version instanceof SemVer)
    return version;

  if (typeof version !== 'string')
    return null;

  if (version.length > MAX_LENGTH)
    return null;

  var r = loose ? re[LOOSE] : re[FULL];
  if (!r.test(version))
    return null;

  try {
    return new SemVer(version, loose);
  } catch (er) {
    return null;
  }
}

exports.valid = valid;
function valid(version, loose) {
  var v = parse(version, loose);
  return v ? v.version : null;
}


exports.clean = clean;
function clean(version, loose) {
  var s = parse(version.trim().replace(/^[=v]+/, ''), loose);
  return s ? s.version : null;
}

exports.SemVer = SemVer;

function SemVer(version, loose) {
  if (version instanceof SemVer) {
    if (version.loose === loose)
      return version;
    else
      version = version.version;
  } else if (typeof version !== 'string') {
    throw new TypeError('Invalid Version: ' + version);
  }

  if (version.length > MAX_LENGTH)
    throw new TypeError('version is longer than ' + MAX_LENGTH + ' characters')

  if (!(this instanceof SemVer))
    return new SemVer(version, loose);

  debug('SemVer', version, loose);
  this.loose = loose;
  var m = version.trim().match(loose ? re[LOOSE] : re[FULL]);

  if (!m)
    throw new TypeError('Invalid Version: ' + version);

  this.raw = version;

  // these are actually numbers
  this.major = +m[1];
  this.minor = +m[2];
  this.patch = +m[3];

  if (this.major > MAX_SAFE_INTEGER || this.major < 0)
    throw new TypeError('Invalid major version')

  if (this.minor > MAX_SAFE_INTEGER || this.minor < 0)
    throw new TypeError('Invalid minor version')

  if (this.patch > MAX_SAFE_INTEGER || this.patch < 0)
    throw new TypeError('Invalid patch version')

  // numberify any prerelease numeric ids
  if (!m[4])
    this.prerelease = [];
  else
    this.prerelease = m[4].split('.').map(function(id) {
      if (/^[0-9]+$/.test(id)) {
        var num = +id;
        if (num >= 0 && num < MAX_SAFE_INTEGER)
          return num;
      }
      return id;
    });

  this.build = m[5] ? m[5].split('.') : [];
  this.format();
}

SemVer.prototype.format = function() {
  this.version = this.major + '.' + this.minor + '.' + this.patch;
  if (this.prerelease.length)
    this.version += '-' + this.prerelease.join('.');
  return this.version;
};

SemVer.prototype.toString = function() {
  return this.version;
};

SemVer.prototype.compare = function(other) {
  debug('SemVer.compare', this.version, this.loose, other);
  if (!(other instanceof SemVer))
    other = new SemVer(other, this.loose);

  return this.compareMain(other) || this.comparePre(other);
};

SemVer.prototype.compareMain = function(other) {
  if (!(other instanceof SemVer))
    other = new SemVer(other, this.loose);

  return compareIdentifiers(this.major, other.major) ||
         compareIdentifiers(this.minor, other.minor) ||
         compareIdentifiers(this.patch, other.patch);
};

SemVer.prototype.comparePre = function(other) {
  if (!(other instanceof SemVer))
    other = new SemVer(other, this.loose);

  // NOT having a prerelease is > having one
  if (this.prerelease.length && !other.prerelease.length)
    return -1;
  else if (!this.prerelease.length && other.prerelease.length)
    return 1;
  else if (!this.prerelease.length && !other.prerelease.length)
    return 0;

  var i = 0;
  do {
    var a = this.prerelease[i];
    var b = other.prerelease[i];
    debug('prerelease compare', i, a, b);
    if (a === undefined && b === undefined)
      return 0;
    else if (b === undefined)
      return 1;
    else if (a === undefined)
      return -1;
    else if (a === b)
      continue;
    else
      return compareIdentifiers(a, b);
  } while (++i);
};

// preminor will bump the version up to the next minor release, and immediately
// down to pre-release. premajor and prepatch work the same way.
SemVer.prototype.inc = function(release, identifier) {
  switch (release) {
    case 'premajor':
      this.prerelease.length = 0;
      this.patch = 0;
      this.minor = 0;
      this.major++;
      this.inc('pre', identifier);
      break;
    case 'preminor':
      this.prerelease.length = 0;
      this.patch = 0;
      this.minor++;
      this.inc('pre', identifier);
      break;
    case 'prepatch':
      // If this is already a prerelease, it will bump to the next version
      // drop any prereleases that might already exist, since they are not
      // relevant at this point.
      this.prerelease.length = 0;
      this.inc('patch', identifier);
      this.inc('pre', identifier);
      break;
    // If the input is a non-prerelease version, this acts the same as
    // prepatch.
    case 'prerelease':
      if (this.prerelease.length === 0)
        this.inc('patch', identifier);
      this.inc('pre', identifier);
      break;

    case 'major':
      // If this is a pre-major version, bump up to the same major version.
      // Otherwise increment major.
      // 1.0.0-5 bumps to 1.0.0
      // 1.1.0 bumps to 2.0.0
      if (this.minor !== 0 || this.patch !== 0 || this.prerelease.length === 0)
        this.major++;
      this.minor = 0;
      this.patch = 0;
      this.prerelease = [];
      break;
    case 'minor':
      // If this is a pre-minor version, bump up to the same minor version.
      // Otherwise increment minor.
      // 1.2.0-5 bumps to 1.2.0
      // 1.2.1 bumps to 1.3.0
      if (this.patch !== 0 || this.prerelease.length === 0)
        this.minor++;
      this.patch = 0;
      this.prerelease = [];
      break;
    case 'patch':
      // If this is not a pre-release version, it will increment the patch.
      // If it is a pre-release it will bump up to the same patch version.
      // 1.2.0-5 patches to 1.2.0
      // 1.2.0 patches to 1.2.1
      if (this.prerelease.length === 0)
        this.patch++;
      this.prerelease = [];
      break;
    // This probably shouldn't be used publicly.
    // 1.0.0 "pre" would become 1.0.0-0 which is the wrong direction.
    case 'pre':
      if (this.prerelease.length === 0)
        this.prerelease = [0];
      else {
        var i = this.prerelease.length;
        while (--i >= 0) {
          if (typeof this.prerelease[i] === 'number') {
            this.prerelease[i]++;
            i = -2;
          }
        }
        if (i === -1) // didn't increment anything
          this.prerelease.push(0);
      }
      if (identifier) {
        // 1.2.0-beta.1 bumps to 1.2.0-beta.2,
        // 1.2.0-beta.fooblz or 1.2.0-beta bumps to 1.2.0-beta.0
        if (this.prerelease[0] === identifier) {
          if (isNaN(this.prerelease[1]))
            this.prerelease = [identifier, 0];
        } else
          this.prerelease = [identifier, 0];
      }
      break;

    default:
      throw new Error('invalid increment argument: ' + release);
  }
  this.format();
  this.raw = this.version;
  return this;
};

exports.inc = inc;
function inc(version, release, loose, identifier) {
  if (typeof(loose) === 'string') {
    identifier = loose;
    loose = undefined;
  }

  try {
    return new SemVer(version, loose).inc(release, identifier).version;
  } catch (er) {
    return null;
  }
}

exports.diff = diff;
function diff(version1, version2) {
  if (eq(version1, version2)) {
    return null;
  } else {
    var v1 = parse(version1);
    var v2 = parse(version2);
    if (v1.prerelease.length || v2.prerelease.length) {
      for (var key in v1) {
        if (key === 'major' || key === 'minor' || key === 'patch') {
          if (v1[key] !== v2[key]) {
            return 'pre'+key;
          }
        }
      }
      return 'prerelease';
    }
    for (var key in v1) {
      if (key === 'major' || key === 'minor' || key === 'patch') {
        if (v1[key] !== v2[key]) {
          return key;
        }
      }
    }
  }
}

exports.compareIdentifiers = compareIdentifiers;

var numeric = /^[0-9]+$/;
function compareIdentifiers(a, b) {
  var anum = numeric.test(a);
  var bnum = numeric.test(b);

  if (anum && bnum) {
    a = +a;
    b = +b;
  }

  return (anum && !bnum) ? -1 :
         (bnum && !anum) ? 1 :
         a < b ? -1 :
         a > b ? 1 :
         0;
}

exports.rcompareIdentifiers = rcompareIdentifiers;
function rcompareIdentifiers(a, b) {
  return compareIdentifiers(b, a);
}

exports.major = major;
function major(a, loose) {
  return new SemVer(a, loose).major;
}

exports.minor = minor;
function minor(a, loose) {
  return new SemVer(a, loose).minor;
}

exports.patch = patch;
function patch(a, loose) {
  return new SemVer(a, loose).patch;
}

exports.compare = compare;
function compare(a, b, loose) {
  return new SemVer(a, loose).compare(b);
}

exports.compareLoose = compareLoose;
function compareLoose(a, b) {
  return compare(a, b, true);
}

exports.rcompare = rcompare;
function rcompare(a, b, loose) {
  return compare(b, a, loose);
}

exports.sort = sort;
function sort(list, loose) {
  return list.sort(function(a, b) {
    return exports.compare(a, b, loose);
  });
}

exports.rsort = rsort;
function rsort(list, loose) {
  return list.sort(function(a, b) {
    return exports.rcompare(a, b, loose);
  });
}

exports.gt = gt;
function gt(a, b, loose) {
  return compare(a, b, loose) > 0;
}

exports.lt = lt;
function lt(a, b, loose) {
  return compare(a, b, loose) < 0;
}

exports.eq = eq;
function eq(a, b, loose) {
  return compare(a, b, loose) === 0;
}

exports.neq = neq;
function neq(a, b, loose) {
  return compare(a, b, loose) !== 0;
}

exports.gte = gte;
function gte(a, b, loose) {
  return compare(a, b, loose) >= 0;
}

exports.lte = lte;
function lte(a, b, loose) {
  return compare(a, b, loose) <= 0;
}

exports.cmp = cmp;
function cmp(a, op, b, loose) {
  var ret;
  switch (op) {
    case '===':
      if (typeof a === 'object') a = a.version;
      if (typeof b === 'object') b = b.version;
      ret = a === b;
      break;
    case '!==':
      if (typeof a === 'object') a = a.version;
      if (typeof b === 'object') b = b.version;
      ret = a !== b;
      break;
    case '': case '=': case '==': ret = eq(a, b, loose); break;
    case '!=': ret = neq(a, b, loose); break;
    case '>': ret = gt(a, b, loose); break;
    case '>=': ret = gte(a, b, loose); break;
    case '<': ret = lt(a, b, loose); break;
    case '<=': ret = lte(a, b, loose); break;
    default: throw new TypeError('Invalid operator: ' + op);
  }
  return ret;
}

exports.Comparator = Comparator;
function Comparator(comp, loose) {
  if (comp instanceof Comparator) {
    if (comp.loose === loose)
      return comp;
    else
      comp = comp.value;
  }

  if (!(this instanceof Comparator))
    return new Comparator(comp, loose);

  debug('comparator', comp, loose);
  this.loose = loose;
  this.parse(comp);

  if (this.semver === ANY)
    this.value = '';
  else
    this.value = this.operator + this.semver.version;

  debug('comp', this);
}

var ANY = {};
Comparator.prototype.parse = function(comp) {
  var r = this.loose ? re[COMPARATORLOOSE] : re[COMPARATOR];
  var m = comp.match(r);

  if (!m)
    throw new TypeError('Invalid comparator: ' + comp);

  this.operator = m[1];
  if (this.operator === '=')
    this.operator = '';

  // if it literally is just '>' or '' then allow anything.
  if (!m[2])
    this.semver = ANY;
  else
    this.semver = new SemVer(m[2], this.loose);
};

Comparator.prototype.toString = function() {
  return this.value;
};

Comparator.prototype.test = function(version) {
  debug('Comparator.test', version, this.loose);

  if (this.semver === ANY)
    return true;

  if (typeof version === 'string')
    version = new SemVer(version, this.loose);

  return cmp(version, this.operator, this.semver, this.loose);
};


exports.Range = Range;
function Range(range, loose) {
  if ((range instanceof Range) && range.loose === loose)
    return range;

  if (!(this instanceof Range))
    return new Range(range, loose);

  this.loose = loose;

  // First, split based on boolean or ||
  this.raw = range;
  this.set = range.split(/\s*\|\|\s*/).map(function(range) {
    return this.parseRange(range.trim());
  }, this).filter(function(c) {
    // throw out any that are not relevant for whatever reason
    return c.length;
  });

  if (!this.set.length) {
    throw new TypeError('Invalid SemVer Range: ' + range);
  }

  this.format();
}

Range.prototype.format = function() {
  this.range = this.set.map(function(comps) {
    return comps.join(' ').trim();
  }).join('||').trim();
  return this.range;
};

Range.prototype.toString = function() {
  return this.range;
};

Range.prototype.parseRange = function(range) {
  var loose = this.loose;
  range = range.trim();
  debug('range', range, loose);
  // `1.2.3 - 1.2.4` => `>=1.2.3 <=1.2.4`
  var hr = loose ? re[HYPHENRANGELOOSE] : re[HYPHENRANGE];
  range = range.replace(hr, hyphenReplace);
  debug('hyphen replace', range);
  // `> 1.2.3 < 1.2.5` => `>1.2.3 <1.2.5`
  range = range.replace(re[COMPARATORTRIM], comparatorTrimReplace);
  debug('comparator trim', range, re[COMPARATORTRIM]);

  // `~ 1.2.3` => `~1.2.3`
  range = range.replace(re[TILDETRIM], tildeTrimReplace);

  // `^ 1.2.3` => `^1.2.3`
  range = range.replace(re[CARETTRIM], caretTrimReplace);

  // normalize spaces
  range = range.split(/\s+/).join(' ');

  // At this point, the range is completely trimmed and
  // ready to be split into comparators.

  var compRe = loose ? re[COMPARATORLOOSE] : re[COMPARATOR];
  var set = range.split(' ').map(function(comp) {
    return parseComparator(comp, loose);
  }).join(' ').split(/\s+/);
  if (this.loose) {
    // in loose mode, throw out any that are not valid comparators
    set = set.filter(function(comp) {
      return !!comp.match(compRe);
    });
  }
  set = set.map(function(comp) {
    return new Comparator(comp, loose);
  });

  return set;
};

// Mostly just for testing and legacy API reasons
exports.toComparators = toComparators;
function toComparators(range, loose) {
  return new Range(range, loose).set.map(function(comp) {
    return comp.map(function(c) {
      return c.value;
    }).join(' ').trim().split(' ');
  });
}

// comprised of xranges, tildes, stars, and gtlt's at this point.
// already replaced the hyphen ranges
// turn into a set of JUST comparators.
function parseComparator(comp, loose) {
  debug('comp', comp);
  comp = replaceCarets(comp, loose);
  debug('caret', comp);
  comp = replaceTildes(comp, loose);
  debug('tildes', comp);
  comp = replaceXRanges(comp, loose);
  debug('xrange', comp);
  comp = replaceStars(comp, loose);
  debug('stars', comp);
  return comp;
}

function isX(id) {
  return !id || id.toLowerCase() === 'x' || id === '*';
}

// ~, ~> --> * (any, kinda silly)
// ~2, ~2.x, ~2.x.x, ~>2, ~>2.x ~>2.x.x --> >=2.0.0 <3.0.0
// ~2.0, ~2.0.x, ~>2.0, ~>2.0.x --> >=2.0.0 <2.1.0
// ~1.2, ~1.2.x, ~>1.2, ~>1.2.x --> >=1.2.0 <1.3.0
// ~1.2.3, ~>1.2.3 --> >=1.2.3 <1.3.0
// ~1.2.0, ~>1.2.0 --> >=1.2.0 <1.3.0
function replaceTildes(comp, loose) {
  return comp.trim().split(/\s+/).map(function(comp) {
    return replaceTilde(comp, loose);
  }).join(' ');
}

function replaceTilde(comp, loose) {
  var r = loose ? re[TILDELOOSE] : re[TILDE];
  return comp.replace(r, function(_, M, m, p, pr) {
    debug('tilde', comp, _, M, m, p, pr);
    var ret;

    if (isX(M))
      ret = '';
    else if (isX(m))
      ret = '>=' + M + '.0.0 <' + (+M + 1) + '.0.0';
    else if (isX(p))
      // ~1.2 == >=1.2.0 <1.3.0
      ret = '>=' + M + '.' + m + '.0 <' + M + '.' + (+m + 1) + '.0';
    else if (pr) {
      debug('replaceTilde pr', pr);
      if (pr.charAt(0) !== '-')
        pr = '-' + pr;
      ret = '>=' + M + '.' + m + '.' + p + pr +
            ' <' + M + '.' + (+m + 1) + '.0';
    } else
      // ~1.2.3 == >=1.2.3 <1.3.0
      ret = '>=' + M + '.' + m + '.' + p +
            ' <' + M + '.' + (+m + 1) + '.0';

    debug('tilde return', ret);
    return ret;
  });
}

// ^ --> * (any, kinda silly)
// ^2, ^2.x, ^2.x.x --> >=2.0.0 <3.0.0
// ^2.0, ^2.0.x --> >=2.0.0 <3.0.0
// ^1.2, ^1.2.x --> >=1.2.0 <2.0.0
// ^1.2.3 --> >=1.2.3 <2.0.0
// ^1.2.0 --> >=1.2.0 <2.0.0
function replaceCarets(comp, loose) {
  return comp.trim().split(/\s+/).map(function(comp) {
    return replaceCaret(comp, loose);
  }).join(' ');
}

function replaceCaret(comp, loose) {
  debug('caret', comp, loose);
  var r = loose ? re[CARETLOOSE] : re[CARET];
  return comp.replace(r, function(_, M, m, p, pr) {
    debug('caret', comp, _, M, m, p, pr);
    var ret;

    if (isX(M))
      ret = '';
    else if (isX(m))
      ret = '>=' + M + '.0.0 <' + (+M + 1) + '.0.0';
    else if (isX(p)) {
      if (M === '0')
        ret = '>=' + M + '.' + m + '.0 <' + M + '.' + (+m + 1) + '.0';
      else
        ret = '>=' + M + '.' + m + '.0 <' + (+M + 1) + '.0.0';
    } else if (pr) {
      debug('replaceCaret pr', pr);
      if (pr.charAt(0) !== '-')
        pr = '-' + pr;
      if (M === '0') {
        if (m === '0')
          ret = '>=' + M + '.' + m + '.' + p + pr +
                ' <' + M + '.' + m + '.' + (+p + 1);
        else
          ret = '>=' + M + '.' + m + '.' + p + pr +
                ' <' + M + '.' + (+m + 1) + '.0';
      } else
        ret = '>=' + M + '.' + m + '.' + p + pr +
              ' <' + (+M + 1) + '.0.0';
    } else {
      debug('no pr');
      if (M === '0') {
        if (m === '0')
          ret = '>=' + M + '.' + m + '.' + p +
                ' <' + M + '.' + m + '.' + (+p + 1);
        else
          ret = '>=' + M + '.' + m + '.' + p +
                ' <' + M + '.' + (+m + 1) + '.0';
      } else
        ret = '>=' + M + '.' + m + '.' + p +
              ' <' + (+M + 1) + '.0.0';
    }

    debug('caret return', ret);
    return ret;
  });
}

function replaceXRanges(comp, loose) {
  debug('replaceXRanges', comp, loose);
  return comp.split(/\s+/).map(function(comp) {
    return replaceXRange(comp, loose);
  }).join(' ');
}

function replaceXRange(comp, loose) {
  comp = comp.trim();
  var r = loose ? re[XRANGELOOSE] : re[XRANGE];
  return comp.replace(r, function(ret, gtlt, M, m, p, pr) {
    debug('xRange', comp, ret, gtlt, M, m, p, pr);
    var xM = isX(M);
    var xm = xM || isX(m);
    var xp = xm || isX(p);
    var anyX = xp;

    if (gtlt === '=' && anyX)
      gtlt = '';

    if (xM) {
      if (gtlt === '>' || gtlt === '<') {
        // nothing is allowed
        ret = '<0.0.0';
      } else {
        // nothing is forbidden
        ret = '*';
      }
    } else if (gtlt && anyX) {
      // replace X with 0
      if (xm)
        m = 0;
      if (xp)
        p = 0;

      if (gtlt === '>') {
        // >1 => >=2.0.0
        // >1.2 => >=1.3.0
        // >1.2.3 => >= 1.2.4
        gtlt = '>=';
        if (xm) {
          M = +M + 1;
          m = 0;
          p = 0;
        } else if (xp) {
          m = +m + 1;
          p = 0;
        }
      } else if (gtlt === '<=') {
        // <=0.7.x is actually <0.8.0, since any 0.7.x should
        // pass.  Similarly, <=7.x is actually <8.0.0, etc.
        gtlt = '<';
        if (xm)
          M = +M + 1;
        else
          m = +m + 1;
      }

      ret = gtlt + M + '.' + m + '.' + p;
    } else if (xm) {
      ret = '>=' + M + '.0.0 <' + (+M + 1) + '.0.0';
    } else if (xp) {
      ret = '>=' + M + '.' + m + '.0 <' + M + '.' + (+m + 1) + '.0';
    }

    debug('xRange return', ret);

    return ret;
  });
}

// Because * is AND-ed with everything else in the comparator,
// and '' means "any version", just remove the *s entirely.
function replaceStars(comp, loose) {
  debug('replaceStars', comp, loose);
  // Looseness is ignored here.  star is always as loose as it gets!
  return comp.trim().replace(re[STAR], '');
}

// This function is passed to string.replace(re[HYPHENRANGE])
// M, m, patch, prerelease, build
// 1.2 - 3.4.5 => >=1.2.0 <=3.4.5
// 1.2.3 - 3.4 => >=1.2.0 <3.5.0 Any 3.4.x will do
// 1.2 - 3.4 => >=1.2.0 <3.5.0
function hyphenReplace($0,
                       from, fM, fm, fp, fpr, fb,
                       to, tM, tm, tp, tpr, tb) {

  if (isX(fM))
    from = '';
  else if (isX(fm))
    from = '>=' + fM + '.0.0';
  else if (isX(fp))
    from = '>=' + fM + '.' + fm + '.0';
  else
    from = '>=' + from;

  if (isX(tM))
    to = '';
  else if (isX(tm))
    to = '<' + (+tM + 1) + '.0.0';
  else if (isX(tp))
    to = '<' + tM + '.' + (+tm + 1) + '.0';
  else if (tpr)
    to = '<=' + tM + '.' + tm + '.' + tp + '-' + tpr;
  else
    to = '<=' + to;

  return (from + ' ' + to).trim();
}


// if ANY of the sets match ALL of its comparators, then pass
Range.prototype.test = function(version) {
  if (!version)
    return false;

  if (typeof version === 'string')
    version = new SemVer(version, this.loose);

  for (var i = 0; i < this.set.length; i++) {
    if (testSet(this.set[i], version))
      return true;
  }
  return false;
};

function testSet(set, version) {
  for (var i = 0; i < set.length; i++) {
    if (!set[i].test(version))
      return false;
  }

  if (version.prerelease.length) {
    // Find the set of versions that are allowed to have prereleases
    // For example, ^1.2.3-pr.1 desugars to >=1.2.3-pr.1 <2.0.0
    // That should allow `1.2.3-pr.2` to pass.
    // However, `1.2.4-alpha.notready` should NOT be allowed,
    // even though it's within the range set by the comparators.
    for (var i = 0; i < set.length; i++) {
      debug(set[i].semver);
      if (set[i].semver === ANY)
        continue;

      if (set[i].semver.prerelease.length > 0) {
        var allowed = set[i].semver;
        if (allowed.major === version.major &&
            allowed.minor === version.minor &&
            allowed.patch === version.patch)
          return true;
      }
    }

    // Version has a -pre, but it's not one of the ones we like.
    return false;
  }

  return true;
}

exports.satisfies = satisfies;
function satisfies(version, range, loose) {
  try {
    range = new Range(range, loose);
  } catch (er) {
    return false;
  }
  return range.test(version);
}

exports.maxSatisfying = maxSatisfying;
function maxSatisfying(versions, range, loose) {
  return versions.filter(function(version) {
    return satisfies(version, range, loose);
  }).sort(function(a, b) {
    return rcompare(a, b, loose);
  })[0] || null;
}

exports.minSatisfying = minSatisfying;
function minSatisfying(versions, range, loose) {
  return versions.filter(function(version) {
    return satisfies(version, range, loose);
  }).sort(function(a, b) {
    return compare(a, b, loose);
  })[0] || null;
}

exports.validRange = validRange;
function validRange(range, loose) {
  try {
    // Return '*' instead of '' so that truthiness works.
    // This will throw if it's invalid anyway
    return new Range(range, loose).range || '*';
  } catch (er) {
    return null;
  }
}

// Determine if version is less than all the versions possible in the range
exports.ltr = ltr;
function ltr(version, range, loose) {
  return outside(version, range, '<', loose);
}

// Determine if version is greater than all the versions possible in the range.
exports.gtr = gtr;
function gtr(version, range, loose) {
  return outside(version, range, '>', loose);
}

exports.outside = outside;
function outside(version, range, hilo, loose) {
  version = new SemVer(version, loose);
  range = new Range(range, loose);

  var gtfn, ltefn, ltfn, comp, ecomp;
  switch (hilo) {
    case '>':
      gtfn = gt;
      ltefn = lte;
      ltfn = lt;
      comp = '>';
      ecomp = '>=';
      break;
    case '<':
      gtfn = lt;
      ltefn = gte;
      ltfn = gt;
      comp = '<';
      ecomp = '<=';
      break;
    default:
      throw new TypeError('Must provide a hilo val of "<" or ">"');
  }

  // If it satisifes the range it is not outside
  if (satisfies(version, range, loose)) {
    return false;
  }

  // From now on, variable terms are as if we're in "gtr" mode.
  // but note that everything is flipped for the "ltr" function.

  for (var i = 0; i < range.set.length; ++i) {
    var comparators = range.set[i];

    var high = null;
    var low = null;

    comparators.forEach(function(comparator) {
      if (comparator.semver === ANY) {
        comparator = new Comparator('>=0.0.0')
      }
      high = high || comparator;
      low = low || comparator;
      if (gtfn(comparator.semver, high.semver, loose)) {
        high = comparator;
      } else if (ltfn(comparator.semver, low.semver, loose)) {
        low = comparator;
      }
    });

    // If the edge version comparator has a operator then our version
    // isn't outside it
    if (high.operator === comp || high.operator === ecomp) {
      return false;
    }

    // If the lowest version comparator has an operator and our version
    // is less than it then it isn't higher than the range
    if ((!low.operator || low.operator === comp) &&
        ltefn(version, low.semver)) {
      return false;
    } else if (low.operator === ecomp && ltfn(version, low.semver)) {
      return false;
    }
  }
  return true;
}

exports.prerelease = prerelease;
function prerelease(version, loose) {
  var parsed = parse(version, loose);
  return (parsed && parsed.prerelease.length) ? parsed.prerelease : null;
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(133)))

/***/ }),
/* 133 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ })
/******/ ]);
});
//# sourceMappingURL=vuetify.js.map

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define("VueShortkey",[],t):"object"==typeof exports?exports.VueShortkey=t():e.VueShortkey=t()}("undefined"!=typeof self?self:this,function(){return function(e){function t(r){if(n[r])return n[r].exports;var o=n[r]={i:r,l:!1,exports:{}};return e[r].call(o.exports,o,o.exports,t),o.l=!0,o.exports}var n={};return t.m=e,t.c=n,t.d=function(e,n,r){t.o(e,n)||Object.defineProperty(e,n,{configurable:!1,enumerable:!0,get:r})},t.n=function(e){var n=e&&e.__esModule?function(){return e.default}:function(){return e};return t.d(n,"a",n),n},t.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},t.p="../dist/",t(t.s=0)}([function(e,t,n){"use strict";(function(r){function o(e){if(Array.isArray(e)){for(var t=0,n=Array(e.length);t<e.length;t++)n[t]=e[t];return n}return Array.from(e)}var c;n(2),n(3);var u={},i={},a=[],l=[],s=!1,f=function(e){return e="string"==typeof e?JSON.parse(e.replace(/\'/gi,'"')):e,e instanceof Array?{"":e}:e},p=function(e,t,n,r){var o=!0===n.modifiers.push,c=!0===n.modifiers.avoid,u=!0==!n.modifiers.focus,i=!0===n.modifiers.once;c?(a=a.filter(function(e){return!e===t}),a.push(t)):v({b:e,push:o,once:i,focus:u,el:r.elm})},y=function(e,t){for(var n in e){var r=u.encodeKey(e[n]),o=i[r].el.indexOf(t);i[r].el.length>1&&o>-1?i[r].el.splice(o,1):delete i[r]}};u.install=function(e,t){l=[].concat(o(t&&t.prevent?t.prevent:[])),e.directive("shortkey",{bind:function(e,t,n){var r=f(t.value);p(r,e,t,n)},update:function(e,t,n){var r=f(t.oldValue);y(r,e);var o=f(t.value);p(o,e,t,n)},unbind:function(e,t){var n=f(t.value);y(n,e)}})},u.decodeKey=function(e){return d(e)},u.encodeKey=function(e){var t={};t.shiftKey=e.includes("shift"),t.ctrlKey=e.includes("ctrl"),t.metaKey=e.includes("meta"),t.altKey=e.includes("alt");var n=d(t);return n+=e.filter(function(e){return!["shift","ctrl","meta","alt"].includes(e)}).join("")};var d=function(e){var t="";return("Shift"===e.key||e.shiftKey)&&(t+="shift"),("Control"===e.key||e.ctrlKey)&&(t+="ctrl"),("Meta"===e.key||e.metaKey)&&(t+="meta"),("Alt"===e.key||e.altKey)&&(t+="alt"),"ArrowUp"===e.key&&(t+="arrowup"),"ArrowLeft"===e.key&&(t+="arrowleft"),"ArrowRight"===e.key&&(t+="arrowright"),"ArrowDown"===e.key&&(t+="arrowdown"),"AltGraph"===e.key&&(t+="altgraph"),"Escape"===e.key&&(t+="esc"),"Enter"===e.key&&(t+="enter"),"Tab"===e.key&&(t+="tab")," "===e.key&&(t+="space"),"PageUp"===e.key&&(t+="pageup"),"PageDown"===e.key&&(t+="pagedown"),"Home"===e.key&&(t+="home"),"End"===e.key&&(t+="end"),"Delete"===e.key&&(t+="del"),"Backspace"===e.key&&(t+="backspace"),"Insert"===e.key&&(t+="insert"),"NumLock"===e.key&&(t+="numlock"),"CapsLock"===e.key&&(t+="capslock"),"Pause"===e.key&&(t+="pause"),"ContextMenu"===e.key&&(t+="contextmenu"),"ScrollLock"===e.key&&(t+="scrolllock"),"BrowserHome"===e.key&&(t+="browserhome"),"MediaSelect"===e.key&&(t+="mediaselect"),(e.key&&" "!==e.key&&1===e.key.length||/F\d{1,2}|\//g.test(e.key))&&(t+=e.key.toLowerCase()),t},h=function(e){var t=new CustomEvent("shortkey",{bubbles:!1});i[e].key&&(t.srcKey=i[e].key);var n=i[e].el;n[n.length-1].dispatchEvent(t)};u.keyDown=function(e){(!i[e].once&&!i[e].push||i[e].push&&!s)&&h(e)},r&&Object({NODE_ENV:"production"})&&function(){document.addEventListener("keydown",function(e){var t=u.decodeKey(e);if(m(t))if(e.preventDefault(),e.stopPropagation(),i[t].focus)u.keyDown(t),s=!0;else if(!s){var n=i[t].el;n[n.length-1].focus(),s=!0}},!0),document.addEventListener("keyup",function(e){var t=u.decodeKey(e);m(t)&&(e.preventDefault(),e.stopPropagation(),(i[t].once||i[t].push)&&h(t)),s=!1},!0)}();var v=function(e){var t=e.b,n=e.push,r=e.once,o=e.focus,c=e.el;for(var a in t){var l=u.encodeKey(t[a]),s=i[l]&&i[l].el?i[l].el:[];s.push(c),i[l]={push:n,once:r,focus:o,key:a,el:s}}},m=function(e){var t=!!a.find(function(e){return e===document.activeElement}),n=!!l.find(function(e){return document.activeElement&&document.activeElement.matches(e)});return!!i[e]&&!(t||n)};void 0!==e&&e.exports?e.exports=u:void 0!==(c=function(){return u}.call(t,n,t,e))&&(e.exports=c)}).call(t,n(1))},function(e,t){function n(){throw new Error("setTimeout has not been defined")}function r(){throw new Error("clearTimeout has not been defined")}function o(e){if(s===setTimeout)return setTimeout(e,0);if((s===n||!s)&&setTimeout)return s=setTimeout,setTimeout(e,0);try{return s(e,0)}catch(t){try{return s.call(null,e,0)}catch(t){return s.call(this,e,0)}}}function c(e){if(f===clearTimeout)return clearTimeout(e);if((f===r||!f)&&clearTimeout)return f=clearTimeout,clearTimeout(e);try{return f(e)}catch(t){try{return f.call(null,e)}catch(t){return f.call(this,e)}}}function u(){h&&y&&(h=!1,y.length?d=y.concat(d):v=-1,d.length&&i())}function i(){if(!h){var e=o(u);h=!0;for(var t=d.length;t;){for(y=d,d=[];++v<t;)y&&y[v].run();v=-1,t=d.length}y=null,h=!1,c(e)}}function a(e,t){this.fun=e,this.array=t}function l(){}var s,f,p=e.exports={};!function(){try{s="function"==typeof setTimeout?setTimeout:n}catch(e){s=n}try{f="function"==typeof clearTimeout?clearTimeout:r}catch(e){f=r}}();var y,d=[],h=!1,v=-1;p.nextTick=function(e){var t=new Array(arguments.length-1);if(arguments.length>1)for(var n=1;n<arguments.length;n++)t[n-1]=arguments[n];d.push(new a(e,t)),1!==d.length||h||o(i)},a.prototype.run=function(){this.fun.apply(null,this.array)},p.title="browser",p.browser=!0,p.env={},p.argv=[],p.version="",p.versions={},p.on=l,p.addListener=l,p.once=l,p.off=l,p.removeListener=l,p.removeAllListeners=l,p.emit=l,p.prependListener=l,p.prependOnceListener=l,p.listeners=function(e){return[]},p.binding=function(e){throw new Error("process.binding is not supported")},p.cwd=function(){return"/"},p.chdir=function(e){throw new Error("process.chdir is not supported")},p.umask=function(){return 0}},function(e,t){Element.prototype.matches||(Element.prototype.matches=Element.prototype.matchesSelector||Element.prototype.msMatchesSelector||Element.prototype.webkitMatchesSelector)},function(e,t){!function(){if("undefined"!=typeof window)try{var e=new window.CustomEvent("test",{cancelable:!0});if(e.preventDefault(),!0!==e.defaultPrevented)throw new Error("Could not prevent default")}catch(e){var t=function(e,t){var n,r;return t=t||{},t.bubbles=!!t.bubbles,t.cancelable=!!t.cancelable,n=document.createEvent("CustomEvent"),n.initCustomEvent(e,t.bubbles,t.cancelable,t.detail),r=n.preventDefault,n.preventDefault=function(){r.call(this);try{Object.defineProperty(this,"defaultPrevented",{get:function(){return!0}})}catch(e){this.defaultPrevented=!0}},n};t.prototype=window.Event.prototype,window.CustomEvent=t}}()}])});
//# sourceMappingURL=index.js.map

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

(function (global, factory) {
   true ? factory(__webpack_require__(64)) :
  typeof define === 'function' && define.amd ? define(['hammerjs'], factory) :
  (factory(global.Hammer));
}(this, (function (Hammer) { 'use strict';

Hammer = 'default' in Hammer ? Hammer['default'] : Hammer;

function assign(target) {
  var sources = [], len = arguments.length - 1;
  while ( len-- > 0 ) sources[ len ] = arguments[ len + 1 ];
  for (var i = 0; i < sources.length; i++) {
    var source = sources[i];
    var keys = Object.keys(source);
    for (var i$1 = 0; i$1 < keys.length; i$1++) {
      var key = keys[i$1];
      target[key] = source[key];
    }
  }
  return target
}
function createProp() {
  return {
    type: Object,
    default: function() { return {} }
  }
}
function capitalize (str) {
  return str.charAt(0).toUpperCase() + str.slice(1)
}
var directions = ['up', 'down', 'left', 'right', 'horizontal', 'vertical', 'all'];
function guardDirections (options) {
  var dir = options.direction;
  if (typeof dir === 'string') {
    var hammerDirection = 'DIRECTION_' + dir.toUpperCase();
    if (directions.indexOf(dir) > -1 && Hammer.hasOwnProperty(hammerDirection)) {
      options.direction = Hammer[hammerDirection];
    } else {
      console.warn('[vue-touch] invalid direction: ' + dir);
    }
  }
  return options
}
var config = {
};
var customEvents = {
};
var gestures = [
  'pan','panstart','panmove','panend','pancancel','panleft','panright','panup','pandown',
  'pinch','pinchstart','pinchmove','pinchend','pinchcancel','pinchin','pinchout',
  'press','pressup',
  'rotate','rotatestart','rotatemove','rotateend','rotatecancel',
  'swipe','swipeleft','swiperight','swipeup','swipedown',
  'tap'
];
var gestureMap = {
  pan: 'pan',
  panstart: 'pan',
  panmove: 'pan',
  panend: 'pan',
  pancancel: 'pan',
  panleft: 'pan',
  panright: 'pan',
  panup: 'pan',
  pandown: 'pan',
  pinch: 'pinch',
  pinchstart: 'pinch',
  pinchmove: 'pinch',
  pinchend: 'pinch',
  pinchcancel: 'pinch',
  pinchin: 'pinch',
  pinchout: 'pinch',
  press: 'press',
  pressup: 'press',
  rotate: 'rotate',
  rotatestart: 'rotate',
  rotatemove: 'rotate',
  rotateend: 'rotate',
  rotatecancel: 'rotate',
  swipe: 'swipe',
  swipeleft: 'swipe',
  swiperight: 'swipe',
  swipeup: 'swipe',
  swipedown: 'swipe',
  tap: 'tap'
};

var Component = {
  props: {
    options: createProp(),
    tapOptions: createProp(),
    panOptions: createProp(),
    pinchOptions: createProp(),
    pressOptions: createProp(),
    rotateOptions: createProp(),
    swipeOptions: createProp(),
    tag: { type: String, default: 'div' },
    enabled: {
      default: true,
      type: [Boolean, Object],
    }
  },
  mounted: function mounted() {
    if (!this.$isServer) {
      this.hammer = new Hammer.Manager(this.$el, this.options);
      this.recognizers = {};
      this.setupBuiltinRecognizers();
      this.setupCustomRecognizers();
      this.updateEnabled(this.enabled);
    }
  },
  destroyed: function destroyed() {
    if (!this.$isServer) {
      this.hammer.destroy();
    }
  },
  watch: {
    enabled: {
      deep: true,
      handler: function handler() {
        var args = [], len = arguments.length;
        while ( len-- ) args[ len ] = arguments[ len ];
        (ref = this).updateEnabled.apply(ref, args);
        var ref;
      }
    }
  },
  methods: {
    setupBuiltinRecognizers: function setupBuiltinRecognizers()  {
      var this$1 = this;
      for (var i = 0; i < gestures.length; i++) {
        var gesture = gestures[i];
        if (this$1._events[gesture]) {
          var mainGesture = gestureMap[gesture];
          var options = assign({}, (config[mainGesture] || {}), this$1[(mainGesture + "Options")]);
          this$1.addRecognizer(mainGesture, options);
          this$1.addEvent(gesture);
        }
      }
    },
    setupCustomRecognizers: function setupCustomRecognizers() {
      var this$1 = this;
      var gestures$$1 = Object.keys(customEvents);
      for (var i = 0; i < gestures$$1.length; i++) {
        var gesture = gestures$$1[i];
        if (this$1._events[gesture]) {
          var opts = customEvents[gesture];
          var localCustomOpts = this$1[(gesture + "Options")] || {};
          var options = assign({}, opts, localCustomOpts);
          this$1.addRecognizer(gesture, options, {mainGesture: options.type});
          this$1.addEvent(gesture);
        }
      }
    },
    addRecognizer: function addRecognizer(gesture, options, ref) {
      if ( ref === void 0 ) ref = {};
      var mainGesture = ref.mainGesture;
      if (!this.recognizers[gesture]) {
        var recognizer = new Hammer[capitalize(mainGesture || gesture)](guardDirections(options));
        this.recognizers[gesture] = recognizer;
        this.hammer.add(recognizer);
        recognizer.recognizeWith(this.hammer.recognizers);
      }
    },
    addEvent: function addEvent(gesture) {
      var this$1 = this;
      this.hammer.on(gesture, function (e) { return this$1.$emit(gesture, e); });
    },
    updateEnabled: function updateEnabled(newVal, oldVal) {
      var this$1 = this;
      if (newVal === true) {
        this.enableAll();
      } else if (newVal === false) {
        this.disableAll();
      } else if (typeof newVal === 'object') {
        var keys = Object.keys(newVal);
        for (var i = 0; i < keys.length; i++) {
          var event = keys[i];
          if (this$1.recognizers[event]) {
            newVal[event]
              ? this$1.enable(event)
              : this$1.disable(event);
          }
        }
      }
    },
    enable: function enable(r) {
      var recognizer = this.recognizers[r];
      if (!recognizer.options.enable) {
        recognizer.set({ enable: true });
      }
    },
    disable: function disable(r) {
      var recognizer = this.recognizers[r];
      if (recognizer.options.enable) {
        recognizer.set({ enable: false });
      }
    },
    toggle: function toggle(r) {
      var recognizer = this.recognizers[r];
      if (recognizer) {
        recognizer.options.enable
          ? this.disable(r)
          : this.enable(r);
      }
    },
    enableAll: function enableAll(r) {
      this.toggleAll({ enable: true });
    },
    disableAll: function disableAll(r) {
      this.toggleAll({ enable: false });
    },
    toggleAll: function toggleAll(ref) {
      var this$1 = this;
      var enable = ref.enable;
      var keys = Object.keys(this.recognizers);
      for (var i = 0; i < keys.length; i++) {
        var r = this$1.recognizers[keys[i]];
        if (r.options.enable !== enable) {
          r.set({ enable: enable });
        }
      }
    },
    isEnabled: function isEnabled(r) {
      return this.recognizers[r] && this.recognizers[r].options.enable
    }
  },
  render: function render(h) {
    return h(this.tag, {}, this.$slots.default)
  }
};

var installed = false;
var vueTouch = { config: config, customEvents: customEvents };
vueTouch.install = function install(Vue, opts) {
  if ( opts === void 0 ) opts = {};
  var name = opts.name || 'v-touch';
  Vue.component(name, assign(Component, { name: name }));
  installed = true;
}.bind(vueTouch);
vueTouch.registerCustomEvent = function registerCustomEvent(event, options) {
  if ( options === void 0 ) options = {};
  if (installed) {
    console.warn(("\n      [vue-touch]: Custom Event '" + event + "' couldn't be added to vue-touch.\n      Custom Events have to be registered before installing the plugin.\n      "));
    return
  }
  options.event = event;
  customEvents[event] = options;
  Component.props[(event + "Options")] = {
    type: Object,
    default: function default$1() { return {} }
  };
}.bind(vueTouch);
vueTouch.component = Component;
if (true) {
  module.exports = vueTouch;
} else if (typeof define == "function" && define.amd) {
  define([], function(){ return vueTouch });
} else if (typeof window !== 'undefined' && window.Vue) {
  window.VueTouch = vueTouch;
  Vue.use(vueTouch);
}

})));
//# sourceMappingURL=vue-touch.js.map


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*! Hammer.JS - v2.0.7 - 2016-04-22
 * http://hammerjs.github.io/
 *
 * Copyright (c) 2016 Jorik Tangelder;
 * Licensed under the MIT license */
(function(window, document, exportName, undefined) {
  'use strict';

var VENDOR_PREFIXES = ['', 'webkit', 'Moz', 'MS', 'ms', 'o'];
var TEST_ELEMENT = document.createElement('div');

var TYPE_FUNCTION = 'function';

var round = Math.round;
var abs = Math.abs;
var now = Date.now;

/**
 * set a timeout with a given scope
 * @param {Function} fn
 * @param {Number} timeout
 * @param {Object} context
 * @returns {number}
 */
function setTimeoutContext(fn, timeout, context) {
    return setTimeout(bindFn(fn, context), timeout);
}

/**
 * if the argument is an array, we want to execute the fn on each entry
 * if it aint an array we don't want to do a thing.
 * this is used by all the methods that accept a single and array argument.
 * @param {*|Array} arg
 * @param {String} fn
 * @param {Object} [context]
 * @returns {Boolean}
 */
function invokeArrayArg(arg, fn, context) {
    if (Array.isArray(arg)) {
        each(arg, context[fn], context);
        return true;
    }
    return false;
}

/**
 * walk objects and arrays
 * @param {Object} obj
 * @param {Function} iterator
 * @param {Object} context
 */
function each(obj, iterator, context) {
    var i;

    if (!obj) {
        return;
    }

    if (obj.forEach) {
        obj.forEach(iterator, context);
    } else if (obj.length !== undefined) {
        i = 0;
        while (i < obj.length) {
            iterator.call(context, obj[i], i, obj);
            i++;
        }
    } else {
        for (i in obj) {
            obj.hasOwnProperty(i) && iterator.call(context, obj[i], i, obj);
        }
    }
}

/**
 * wrap a method with a deprecation warning and stack trace
 * @param {Function} method
 * @param {String} name
 * @param {String} message
 * @returns {Function} A new function wrapping the supplied method.
 */
function deprecate(method, name, message) {
    var deprecationMessage = 'DEPRECATED METHOD: ' + name + '\n' + message + ' AT \n';
    return function() {
        var e = new Error('get-stack-trace');
        var stack = e && e.stack ? e.stack.replace(/^[^\(]+?[\n$]/gm, '')
            .replace(/^\s+at\s+/gm, '')
            .replace(/^Object.<anonymous>\s*\(/gm, '{anonymous}()@') : 'Unknown Stack Trace';

        var log = window.console && (window.console.warn || window.console.log);
        if (log) {
            log.call(window.console, deprecationMessage, stack);
        }
        return method.apply(this, arguments);
    };
}

/**
 * extend object.
 * means that properties in dest will be overwritten by the ones in src.
 * @param {Object} target
 * @param {...Object} objects_to_assign
 * @returns {Object} target
 */
var assign;
if (typeof Object.assign !== 'function') {
    assign = function assign(target) {
        if (target === undefined || target === null) {
            throw new TypeError('Cannot convert undefined or null to object');
        }

        var output = Object(target);
        for (var index = 1; index < arguments.length; index++) {
            var source = arguments[index];
            if (source !== undefined && source !== null) {
                for (var nextKey in source) {
                    if (source.hasOwnProperty(nextKey)) {
                        output[nextKey] = source[nextKey];
                    }
                }
            }
        }
        return output;
    };
} else {
    assign = Object.assign;
}

/**
 * extend object.
 * means that properties in dest will be overwritten by the ones in src.
 * @param {Object} dest
 * @param {Object} src
 * @param {Boolean} [merge=false]
 * @returns {Object} dest
 */
var extend = deprecate(function extend(dest, src, merge) {
    var keys = Object.keys(src);
    var i = 0;
    while (i < keys.length) {
        if (!merge || (merge && dest[keys[i]] === undefined)) {
            dest[keys[i]] = src[keys[i]];
        }
        i++;
    }
    return dest;
}, 'extend', 'Use `assign`.');

/**
 * merge the values from src in the dest.
 * means that properties that exist in dest will not be overwritten by src
 * @param {Object} dest
 * @param {Object} src
 * @returns {Object} dest
 */
var merge = deprecate(function merge(dest, src) {
    return extend(dest, src, true);
}, 'merge', 'Use `assign`.');

/**
 * simple class inheritance
 * @param {Function} child
 * @param {Function} base
 * @param {Object} [properties]
 */
function inherit(child, base, properties) {
    var baseP = base.prototype,
        childP;

    childP = child.prototype = Object.create(baseP);
    childP.constructor = child;
    childP._super = baseP;

    if (properties) {
        assign(childP, properties);
    }
}

/**
 * simple function bind
 * @param {Function} fn
 * @param {Object} context
 * @returns {Function}
 */
function bindFn(fn, context) {
    return function boundFn() {
        return fn.apply(context, arguments);
    };
}

/**
 * let a boolean value also be a function that must return a boolean
 * this first item in args will be used as the context
 * @param {Boolean|Function} val
 * @param {Array} [args]
 * @returns {Boolean}
 */
function boolOrFn(val, args) {
    if (typeof val == TYPE_FUNCTION) {
        return val.apply(args ? args[0] || undefined : undefined, args);
    }
    return val;
}

/**
 * use the val2 when val1 is undefined
 * @param {*} val1
 * @param {*} val2
 * @returns {*}
 */
function ifUndefined(val1, val2) {
    return (val1 === undefined) ? val2 : val1;
}

/**
 * addEventListener with multiple events at once
 * @param {EventTarget} target
 * @param {String} types
 * @param {Function} handler
 */
function addEventListeners(target, types, handler) {
    each(splitStr(types), function(type) {
        target.addEventListener(type, handler, false);
    });
}

/**
 * removeEventListener with multiple events at once
 * @param {EventTarget} target
 * @param {String} types
 * @param {Function} handler
 */
function removeEventListeners(target, types, handler) {
    each(splitStr(types), function(type) {
        target.removeEventListener(type, handler, false);
    });
}

/**
 * find if a node is in the given parent
 * @method hasParent
 * @param {HTMLElement} node
 * @param {HTMLElement} parent
 * @return {Boolean} found
 */
function hasParent(node, parent) {
    while (node) {
        if (node == parent) {
            return true;
        }
        node = node.parentNode;
    }
    return false;
}

/**
 * small indexOf wrapper
 * @param {String} str
 * @param {String} find
 * @returns {Boolean} found
 */
function inStr(str, find) {
    return str.indexOf(find) > -1;
}

/**
 * split string on whitespace
 * @param {String} str
 * @returns {Array} words
 */
function splitStr(str) {
    return str.trim().split(/\s+/g);
}

/**
 * find if a array contains the object using indexOf or a simple polyFill
 * @param {Array} src
 * @param {String} find
 * @param {String} [findByKey]
 * @return {Boolean|Number} false when not found, or the index
 */
function inArray(src, find, findByKey) {
    if (src.indexOf && !findByKey) {
        return src.indexOf(find);
    } else {
        var i = 0;
        while (i < src.length) {
            if ((findByKey && src[i][findByKey] == find) || (!findByKey && src[i] === find)) {
                return i;
            }
            i++;
        }
        return -1;
    }
}

/**
 * convert array-like objects to real arrays
 * @param {Object} obj
 * @returns {Array}
 */
function toArray(obj) {
    return Array.prototype.slice.call(obj, 0);
}

/**
 * unique array with objects based on a key (like 'id') or just by the array's value
 * @param {Array} src [{id:1},{id:2},{id:1}]
 * @param {String} [key]
 * @param {Boolean} [sort=False]
 * @returns {Array} [{id:1},{id:2}]
 */
function uniqueArray(src, key, sort) {
    var results = [];
    var values = [];
    var i = 0;

    while (i < src.length) {
        var val = key ? src[i][key] : src[i];
        if (inArray(values, val) < 0) {
            results.push(src[i]);
        }
        values[i] = val;
        i++;
    }

    if (sort) {
        if (!key) {
            results = results.sort();
        } else {
            results = results.sort(function sortUniqueArray(a, b) {
                return a[key] > b[key];
            });
        }
    }

    return results;
}

/**
 * get the prefixed property
 * @param {Object} obj
 * @param {String} property
 * @returns {String|Undefined} prefixed
 */
function prefixed(obj, property) {
    var prefix, prop;
    var camelProp = property[0].toUpperCase() + property.slice(1);

    var i = 0;
    while (i < VENDOR_PREFIXES.length) {
        prefix = VENDOR_PREFIXES[i];
        prop = (prefix) ? prefix + camelProp : property;

        if (prop in obj) {
            return prop;
        }
        i++;
    }
    return undefined;
}

/**
 * get a unique id
 * @returns {number} uniqueId
 */
var _uniqueId = 1;
function uniqueId() {
    return _uniqueId++;
}

/**
 * get the window object of an element
 * @param {HTMLElement} element
 * @returns {DocumentView|Window}
 */
function getWindowForElement(element) {
    var doc = element.ownerDocument || element;
    return (doc.defaultView || doc.parentWindow || window);
}

var MOBILE_REGEX = /mobile|tablet|ip(ad|hone|od)|android/i;

var SUPPORT_TOUCH = ('ontouchstart' in window);
var SUPPORT_POINTER_EVENTS = prefixed(window, 'PointerEvent') !== undefined;
var SUPPORT_ONLY_TOUCH = SUPPORT_TOUCH && MOBILE_REGEX.test(navigator.userAgent);

var INPUT_TYPE_TOUCH = 'touch';
var INPUT_TYPE_PEN = 'pen';
var INPUT_TYPE_MOUSE = 'mouse';
var INPUT_TYPE_KINECT = 'kinect';

var COMPUTE_INTERVAL = 25;

var INPUT_START = 1;
var INPUT_MOVE = 2;
var INPUT_END = 4;
var INPUT_CANCEL = 8;

var DIRECTION_NONE = 1;
var DIRECTION_LEFT = 2;
var DIRECTION_RIGHT = 4;
var DIRECTION_UP = 8;
var DIRECTION_DOWN = 16;

var DIRECTION_HORIZONTAL = DIRECTION_LEFT | DIRECTION_RIGHT;
var DIRECTION_VERTICAL = DIRECTION_UP | DIRECTION_DOWN;
var DIRECTION_ALL = DIRECTION_HORIZONTAL | DIRECTION_VERTICAL;

var PROPS_XY = ['x', 'y'];
var PROPS_CLIENT_XY = ['clientX', 'clientY'];

/**
 * create new input type manager
 * @param {Manager} manager
 * @param {Function} callback
 * @returns {Input}
 * @constructor
 */
function Input(manager, callback) {
    var self = this;
    this.manager = manager;
    this.callback = callback;
    this.element = manager.element;
    this.target = manager.options.inputTarget;

    // smaller wrapper around the handler, for the scope and the enabled state of the manager,
    // so when disabled the input events are completely bypassed.
    this.domHandler = function(ev) {
        if (boolOrFn(manager.options.enable, [manager])) {
            self.handler(ev);
        }
    };

    this.init();

}

Input.prototype = {
    /**
     * should handle the inputEvent data and trigger the callback
     * @virtual
     */
    handler: function() { },

    /**
     * bind the events
     */
    init: function() {
        this.evEl && addEventListeners(this.element, this.evEl, this.domHandler);
        this.evTarget && addEventListeners(this.target, this.evTarget, this.domHandler);
        this.evWin && addEventListeners(getWindowForElement(this.element), this.evWin, this.domHandler);
    },

    /**
     * unbind the events
     */
    destroy: function() {
        this.evEl && removeEventListeners(this.element, this.evEl, this.domHandler);
        this.evTarget && removeEventListeners(this.target, this.evTarget, this.domHandler);
        this.evWin && removeEventListeners(getWindowForElement(this.element), this.evWin, this.domHandler);
    }
};

/**
 * create new input type manager
 * called by the Manager constructor
 * @param {Hammer} manager
 * @returns {Input}
 */
function createInputInstance(manager) {
    var Type;
    var inputClass = manager.options.inputClass;

    if (inputClass) {
        Type = inputClass;
    } else if (SUPPORT_POINTER_EVENTS) {
        Type = PointerEventInput;
    } else if (SUPPORT_ONLY_TOUCH) {
        Type = TouchInput;
    } else if (!SUPPORT_TOUCH) {
        Type = MouseInput;
    } else {
        Type = TouchMouseInput;
    }
    return new (Type)(manager, inputHandler);
}

/**
 * handle input events
 * @param {Manager} manager
 * @param {String} eventType
 * @param {Object} input
 */
function inputHandler(manager, eventType, input) {
    var pointersLen = input.pointers.length;
    var changedPointersLen = input.changedPointers.length;
    var isFirst = (eventType & INPUT_START && (pointersLen - changedPointersLen === 0));
    var isFinal = (eventType & (INPUT_END | INPUT_CANCEL) && (pointersLen - changedPointersLen === 0));

    input.isFirst = !!isFirst;
    input.isFinal = !!isFinal;

    if (isFirst) {
        manager.session = {};
    }

    // source event is the normalized value of the domEvents
    // like 'touchstart, mouseup, pointerdown'
    input.eventType = eventType;

    // compute scale, rotation etc
    computeInputData(manager, input);

    // emit secret event
    manager.emit('hammer.input', input);

    manager.recognize(input);
    manager.session.prevInput = input;
}

/**
 * extend the data with some usable properties like scale, rotate, velocity etc
 * @param {Object} manager
 * @param {Object} input
 */
function computeInputData(manager, input) {
    var session = manager.session;
    var pointers = input.pointers;
    var pointersLength = pointers.length;

    // store the first input to calculate the distance and direction
    if (!session.firstInput) {
        session.firstInput = simpleCloneInputData(input);
    }

    // to compute scale and rotation we need to store the multiple touches
    if (pointersLength > 1 && !session.firstMultiple) {
        session.firstMultiple = simpleCloneInputData(input);
    } else if (pointersLength === 1) {
        session.firstMultiple = false;
    }

    var firstInput = session.firstInput;
    var firstMultiple = session.firstMultiple;
    var offsetCenter = firstMultiple ? firstMultiple.center : firstInput.center;

    var center = input.center = getCenter(pointers);
    input.timeStamp = now();
    input.deltaTime = input.timeStamp - firstInput.timeStamp;

    input.angle = getAngle(offsetCenter, center);
    input.distance = getDistance(offsetCenter, center);

    computeDeltaXY(session, input);
    input.offsetDirection = getDirection(input.deltaX, input.deltaY);

    var overallVelocity = getVelocity(input.deltaTime, input.deltaX, input.deltaY);
    input.overallVelocityX = overallVelocity.x;
    input.overallVelocityY = overallVelocity.y;
    input.overallVelocity = (abs(overallVelocity.x) > abs(overallVelocity.y)) ? overallVelocity.x : overallVelocity.y;

    input.scale = firstMultiple ? getScale(firstMultiple.pointers, pointers) : 1;
    input.rotation = firstMultiple ? getRotation(firstMultiple.pointers, pointers) : 0;

    input.maxPointers = !session.prevInput ? input.pointers.length : ((input.pointers.length >
        session.prevInput.maxPointers) ? input.pointers.length : session.prevInput.maxPointers);

    computeIntervalInputData(session, input);

    // find the correct target
    var target = manager.element;
    if (hasParent(input.srcEvent.target, target)) {
        target = input.srcEvent.target;
    }
    input.target = target;
}

function computeDeltaXY(session, input) {
    var center = input.center;
    var offset = session.offsetDelta || {};
    var prevDelta = session.prevDelta || {};
    var prevInput = session.prevInput || {};

    if (input.eventType === INPUT_START || prevInput.eventType === INPUT_END) {
        prevDelta = session.prevDelta = {
            x: prevInput.deltaX || 0,
            y: prevInput.deltaY || 0
        };

        offset = session.offsetDelta = {
            x: center.x,
            y: center.y
        };
    }

    input.deltaX = prevDelta.x + (center.x - offset.x);
    input.deltaY = prevDelta.y + (center.y - offset.y);
}

/**
 * velocity is calculated every x ms
 * @param {Object} session
 * @param {Object} input
 */
function computeIntervalInputData(session, input) {
    var last = session.lastInterval || input,
        deltaTime = input.timeStamp - last.timeStamp,
        velocity, velocityX, velocityY, direction;

    if (input.eventType != INPUT_CANCEL && (deltaTime > COMPUTE_INTERVAL || last.velocity === undefined)) {
        var deltaX = input.deltaX - last.deltaX;
        var deltaY = input.deltaY - last.deltaY;

        var v = getVelocity(deltaTime, deltaX, deltaY);
        velocityX = v.x;
        velocityY = v.y;
        velocity = (abs(v.x) > abs(v.y)) ? v.x : v.y;
        direction = getDirection(deltaX, deltaY);

        session.lastInterval = input;
    } else {
        // use latest velocity info if it doesn't overtake a minimum period
        velocity = last.velocity;
        velocityX = last.velocityX;
        velocityY = last.velocityY;
        direction = last.direction;
    }

    input.velocity = velocity;
    input.velocityX = velocityX;
    input.velocityY = velocityY;
    input.direction = direction;
}

/**
 * create a simple clone from the input used for storage of firstInput and firstMultiple
 * @param {Object} input
 * @returns {Object} clonedInputData
 */
function simpleCloneInputData(input) {
    // make a simple copy of the pointers because we will get a reference if we don't
    // we only need clientXY for the calculations
    var pointers = [];
    var i = 0;
    while (i < input.pointers.length) {
        pointers[i] = {
            clientX: round(input.pointers[i].clientX),
            clientY: round(input.pointers[i].clientY)
        };
        i++;
    }

    return {
        timeStamp: now(),
        pointers: pointers,
        center: getCenter(pointers),
        deltaX: input.deltaX,
        deltaY: input.deltaY
    };
}

/**
 * get the center of all the pointers
 * @param {Array} pointers
 * @return {Object} center contains `x` and `y` properties
 */
function getCenter(pointers) {
    var pointersLength = pointers.length;

    // no need to loop when only one touch
    if (pointersLength === 1) {
        return {
            x: round(pointers[0].clientX),
            y: round(pointers[0].clientY)
        };
    }

    var x = 0, y = 0, i = 0;
    while (i < pointersLength) {
        x += pointers[i].clientX;
        y += pointers[i].clientY;
        i++;
    }

    return {
        x: round(x / pointersLength),
        y: round(y / pointersLength)
    };
}

/**
 * calculate the velocity between two points. unit is in px per ms.
 * @param {Number} deltaTime
 * @param {Number} x
 * @param {Number} y
 * @return {Object} velocity `x` and `y`
 */
function getVelocity(deltaTime, x, y) {
    return {
        x: x / deltaTime || 0,
        y: y / deltaTime || 0
    };
}

/**
 * get the direction between two points
 * @param {Number} x
 * @param {Number} y
 * @return {Number} direction
 */
function getDirection(x, y) {
    if (x === y) {
        return DIRECTION_NONE;
    }

    if (abs(x) >= abs(y)) {
        return x < 0 ? DIRECTION_LEFT : DIRECTION_RIGHT;
    }
    return y < 0 ? DIRECTION_UP : DIRECTION_DOWN;
}

/**
 * calculate the absolute distance between two points
 * @param {Object} p1 {x, y}
 * @param {Object} p2 {x, y}
 * @param {Array} [props] containing x and y keys
 * @return {Number} distance
 */
function getDistance(p1, p2, props) {
    if (!props) {
        props = PROPS_XY;
    }
    var x = p2[props[0]] - p1[props[0]],
        y = p2[props[1]] - p1[props[1]];

    return Math.sqrt((x * x) + (y * y));
}

/**
 * calculate the angle between two coordinates
 * @param {Object} p1
 * @param {Object} p2
 * @param {Array} [props] containing x and y keys
 * @return {Number} angle
 */
function getAngle(p1, p2, props) {
    if (!props) {
        props = PROPS_XY;
    }
    var x = p2[props[0]] - p1[props[0]],
        y = p2[props[1]] - p1[props[1]];
    return Math.atan2(y, x) * 180 / Math.PI;
}

/**
 * calculate the rotation degrees between two pointersets
 * @param {Array} start array of pointers
 * @param {Array} end array of pointers
 * @return {Number} rotation
 */
function getRotation(start, end) {
    return getAngle(end[1], end[0], PROPS_CLIENT_XY) + getAngle(start[1], start[0], PROPS_CLIENT_XY);
}

/**
 * calculate the scale factor between two pointersets
 * no scale is 1, and goes down to 0 when pinched together, and bigger when pinched out
 * @param {Array} start array of pointers
 * @param {Array} end array of pointers
 * @return {Number} scale
 */
function getScale(start, end) {
    return getDistance(end[0], end[1], PROPS_CLIENT_XY) / getDistance(start[0], start[1], PROPS_CLIENT_XY);
}

var MOUSE_INPUT_MAP = {
    mousedown: INPUT_START,
    mousemove: INPUT_MOVE,
    mouseup: INPUT_END
};

var MOUSE_ELEMENT_EVENTS = 'mousedown';
var MOUSE_WINDOW_EVENTS = 'mousemove mouseup';

/**
 * Mouse events input
 * @constructor
 * @extends Input
 */
function MouseInput() {
    this.evEl = MOUSE_ELEMENT_EVENTS;
    this.evWin = MOUSE_WINDOW_EVENTS;

    this.pressed = false; // mousedown state

    Input.apply(this, arguments);
}

inherit(MouseInput, Input, {
    /**
     * handle mouse events
     * @param {Object} ev
     */
    handler: function MEhandler(ev) {
        var eventType = MOUSE_INPUT_MAP[ev.type];

        // on start we want to have the left mouse button down
        if (eventType & INPUT_START && ev.button === 0) {
            this.pressed = true;
        }

        if (eventType & INPUT_MOVE && ev.which !== 1) {
            eventType = INPUT_END;
        }

        // mouse must be down
        if (!this.pressed) {
            return;
        }

        if (eventType & INPUT_END) {
            this.pressed = false;
        }

        this.callback(this.manager, eventType, {
            pointers: [ev],
            changedPointers: [ev],
            pointerType: INPUT_TYPE_MOUSE,
            srcEvent: ev
        });
    }
});

var POINTER_INPUT_MAP = {
    pointerdown: INPUT_START,
    pointermove: INPUT_MOVE,
    pointerup: INPUT_END,
    pointercancel: INPUT_CANCEL,
    pointerout: INPUT_CANCEL
};

// in IE10 the pointer types is defined as an enum
var IE10_POINTER_TYPE_ENUM = {
    2: INPUT_TYPE_TOUCH,
    3: INPUT_TYPE_PEN,
    4: INPUT_TYPE_MOUSE,
    5: INPUT_TYPE_KINECT // see https://twitter.com/jacobrossi/status/480596438489890816
};

var POINTER_ELEMENT_EVENTS = 'pointerdown';
var POINTER_WINDOW_EVENTS = 'pointermove pointerup pointercancel';

// IE10 has prefixed support, and case-sensitive
if (window.MSPointerEvent && !window.PointerEvent) {
    POINTER_ELEMENT_EVENTS = 'MSPointerDown';
    POINTER_WINDOW_EVENTS = 'MSPointerMove MSPointerUp MSPointerCancel';
}

/**
 * Pointer events input
 * @constructor
 * @extends Input
 */
function PointerEventInput() {
    this.evEl = POINTER_ELEMENT_EVENTS;
    this.evWin = POINTER_WINDOW_EVENTS;

    Input.apply(this, arguments);

    this.store = (this.manager.session.pointerEvents = []);
}

inherit(PointerEventInput, Input, {
    /**
     * handle mouse events
     * @param {Object} ev
     */
    handler: function PEhandler(ev) {
        var store = this.store;
        var removePointer = false;

        var eventTypeNormalized = ev.type.toLowerCase().replace('ms', '');
        var eventType = POINTER_INPUT_MAP[eventTypeNormalized];
        var pointerType = IE10_POINTER_TYPE_ENUM[ev.pointerType] || ev.pointerType;

        var isTouch = (pointerType == INPUT_TYPE_TOUCH);

        // get index of the event in the store
        var storeIndex = inArray(store, ev.pointerId, 'pointerId');

        // start and mouse must be down
        if (eventType & INPUT_START && (ev.button === 0 || isTouch)) {
            if (storeIndex < 0) {
                store.push(ev);
                storeIndex = store.length - 1;
            }
        } else if (eventType & (INPUT_END | INPUT_CANCEL)) {
            removePointer = true;
        }

        // it not found, so the pointer hasn't been down (so it's probably a hover)
        if (storeIndex < 0) {
            return;
        }

        // update the event in the store
        store[storeIndex] = ev;

        this.callback(this.manager, eventType, {
            pointers: store,
            changedPointers: [ev],
            pointerType: pointerType,
            srcEvent: ev
        });

        if (removePointer) {
            // remove from the store
            store.splice(storeIndex, 1);
        }
    }
});

var SINGLE_TOUCH_INPUT_MAP = {
    touchstart: INPUT_START,
    touchmove: INPUT_MOVE,
    touchend: INPUT_END,
    touchcancel: INPUT_CANCEL
};

var SINGLE_TOUCH_TARGET_EVENTS = 'touchstart';
var SINGLE_TOUCH_WINDOW_EVENTS = 'touchstart touchmove touchend touchcancel';

/**
 * Touch events input
 * @constructor
 * @extends Input
 */
function SingleTouchInput() {
    this.evTarget = SINGLE_TOUCH_TARGET_EVENTS;
    this.evWin = SINGLE_TOUCH_WINDOW_EVENTS;
    this.started = false;

    Input.apply(this, arguments);
}

inherit(SingleTouchInput, Input, {
    handler: function TEhandler(ev) {
        var type = SINGLE_TOUCH_INPUT_MAP[ev.type];

        // should we handle the touch events?
        if (type === INPUT_START) {
            this.started = true;
        }

        if (!this.started) {
            return;
        }

        var touches = normalizeSingleTouches.call(this, ev, type);

        // when done, reset the started state
        if (type & (INPUT_END | INPUT_CANCEL) && touches[0].length - touches[1].length === 0) {
            this.started = false;
        }

        this.callback(this.manager, type, {
            pointers: touches[0],
            changedPointers: touches[1],
            pointerType: INPUT_TYPE_TOUCH,
            srcEvent: ev
        });
    }
});

/**
 * @this {TouchInput}
 * @param {Object} ev
 * @param {Number} type flag
 * @returns {undefined|Array} [all, changed]
 */
function normalizeSingleTouches(ev, type) {
    var all = toArray(ev.touches);
    var changed = toArray(ev.changedTouches);

    if (type & (INPUT_END | INPUT_CANCEL)) {
        all = uniqueArray(all.concat(changed), 'identifier', true);
    }

    return [all, changed];
}

var TOUCH_INPUT_MAP = {
    touchstart: INPUT_START,
    touchmove: INPUT_MOVE,
    touchend: INPUT_END,
    touchcancel: INPUT_CANCEL
};

var TOUCH_TARGET_EVENTS = 'touchstart touchmove touchend touchcancel';

/**
 * Multi-user touch events input
 * @constructor
 * @extends Input
 */
function TouchInput() {
    this.evTarget = TOUCH_TARGET_EVENTS;
    this.targetIds = {};

    Input.apply(this, arguments);
}

inherit(TouchInput, Input, {
    handler: function MTEhandler(ev) {
        var type = TOUCH_INPUT_MAP[ev.type];
        var touches = getTouches.call(this, ev, type);
        if (!touches) {
            return;
        }

        this.callback(this.manager, type, {
            pointers: touches[0],
            changedPointers: touches[1],
            pointerType: INPUT_TYPE_TOUCH,
            srcEvent: ev
        });
    }
});

/**
 * @this {TouchInput}
 * @param {Object} ev
 * @param {Number} type flag
 * @returns {undefined|Array} [all, changed]
 */
function getTouches(ev, type) {
    var allTouches = toArray(ev.touches);
    var targetIds = this.targetIds;

    // when there is only one touch, the process can be simplified
    if (type & (INPUT_START | INPUT_MOVE) && allTouches.length === 1) {
        targetIds[allTouches[0].identifier] = true;
        return [allTouches, allTouches];
    }

    var i,
        targetTouches,
        changedTouches = toArray(ev.changedTouches),
        changedTargetTouches = [],
        target = this.target;

    // get target touches from touches
    targetTouches = allTouches.filter(function(touch) {
        return hasParent(touch.target, target);
    });

    // collect touches
    if (type === INPUT_START) {
        i = 0;
        while (i < targetTouches.length) {
            targetIds[targetTouches[i].identifier] = true;
            i++;
        }
    }

    // filter changed touches to only contain touches that exist in the collected target ids
    i = 0;
    while (i < changedTouches.length) {
        if (targetIds[changedTouches[i].identifier]) {
            changedTargetTouches.push(changedTouches[i]);
        }

        // cleanup removed touches
        if (type & (INPUT_END | INPUT_CANCEL)) {
            delete targetIds[changedTouches[i].identifier];
        }
        i++;
    }

    if (!changedTargetTouches.length) {
        return;
    }

    return [
        // merge targetTouches with changedTargetTouches so it contains ALL touches, including 'end' and 'cancel'
        uniqueArray(targetTouches.concat(changedTargetTouches), 'identifier', true),
        changedTargetTouches
    ];
}

/**
 * Combined touch and mouse input
 *
 * Touch has a higher priority then mouse, and while touching no mouse events are allowed.
 * This because touch devices also emit mouse events while doing a touch.
 *
 * @constructor
 * @extends Input
 */

var DEDUP_TIMEOUT = 2500;
var DEDUP_DISTANCE = 25;

function TouchMouseInput() {
    Input.apply(this, arguments);

    var handler = bindFn(this.handler, this);
    this.touch = new TouchInput(this.manager, handler);
    this.mouse = new MouseInput(this.manager, handler);

    this.primaryTouch = null;
    this.lastTouches = [];
}

inherit(TouchMouseInput, Input, {
    /**
     * handle mouse and touch events
     * @param {Hammer} manager
     * @param {String} inputEvent
     * @param {Object} inputData
     */
    handler: function TMEhandler(manager, inputEvent, inputData) {
        var isTouch = (inputData.pointerType == INPUT_TYPE_TOUCH),
            isMouse = (inputData.pointerType == INPUT_TYPE_MOUSE);

        if (isMouse && inputData.sourceCapabilities && inputData.sourceCapabilities.firesTouchEvents) {
            return;
        }

        // when we're in a touch event, record touches to  de-dupe synthetic mouse event
        if (isTouch) {
            recordTouches.call(this, inputEvent, inputData);
        } else if (isMouse && isSyntheticEvent.call(this, inputData)) {
            return;
        }

        this.callback(manager, inputEvent, inputData);
    },

    /**
     * remove the event listeners
     */
    destroy: function destroy() {
        this.touch.destroy();
        this.mouse.destroy();
    }
});

function recordTouches(eventType, eventData) {
    if (eventType & INPUT_START) {
        this.primaryTouch = eventData.changedPointers[0].identifier;
        setLastTouch.call(this, eventData);
    } else if (eventType & (INPUT_END | INPUT_CANCEL)) {
        setLastTouch.call(this, eventData);
    }
}

function setLastTouch(eventData) {
    var touch = eventData.changedPointers[0];

    if (touch.identifier === this.primaryTouch) {
        var lastTouch = {x: touch.clientX, y: touch.clientY};
        this.lastTouches.push(lastTouch);
        var lts = this.lastTouches;
        var removeLastTouch = function() {
            var i = lts.indexOf(lastTouch);
            if (i > -1) {
                lts.splice(i, 1);
            }
        };
        setTimeout(removeLastTouch, DEDUP_TIMEOUT);
    }
}

function isSyntheticEvent(eventData) {
    var x = eventData.srcEvent.clientX, y = eventData.srcEvent.clientY;
    for (var i = 0; i < this.lastTouches.length; i++) {
        var t = this.lastTouches[i];
        var dx = Math.abs(x - t.x), dy = Math.abs(y - t.y);
        if (dx <= DEDUP_DISTANCE && dy <= DEDUP_DISTANCE) {
            return true;
        }
    }
    return false;
}

var PREFIXED_TOUCH_ACTION = prefixed(TEST_ELEMENT.style, 'touchAction');
var NATIVE_TOUCH_ACTION = PREFIXED_TOUCH_ACTION !== undefined;

// magical touchAction value
var TOUCH_ACTION_COMPUTE = 'compute';
var TOUCH_ACTION_AUTO = 'auto';
var TOUCH_ACTION_MANIPULATION = 'manipulation'; // not implemented
var TOUCH_ACTION_NONE = 'none';
var TOUCH_ACTION_PAN_X = 'pan-x';
var TOUCH_ACTION_PAN_Y = 'pan-y';
var TOUCH_ACTION_MAP = getTouchActionProps();

/**
 * Touch Action
 * sets the touchAction property or uses the js alternative
 * @param {Manager} manager
 * @param {String} value
 * @constructor
 */
function TouchAction(manager, value) {
    this.manager = manager;
    this.set(value);
}

TouchAction.prototype = {
    /**
     * set the touchAction value on the element or enable the polyfill
     * @param {String} value
     */
    set: function(value) {
        // find out the touch-action by the event handlers
        if (value == TOUCH_ACTION_COMPUTE) {
            value = this.compute();
        }

        if (NATIVE_TOUCH_ACTION && this.manager.element.style && TOUCH_ACTION_MAP[value]) {
            this.manager.element.style[PREFIXED_TOUCH_ACTION] = value;
        }
        this.actions = value.toLowerCase().trim();
    },

    /**
     * just re-set the touchAction value
     */
    update: function() {
        this.set(this.manager.options.touchAction);
    },

    /**
     * compute the value for the touchAction property based on the recognizer's settings
     * @returns {String} value
     */
    compute: function() {
        var actions = [];
        each(this.manager.recognizers, function(recognizer) {
            if (boolOrFn(recognizer.options.enable, [recognizer])) {
                actions = actions.concat(recognizer.getTouchAction());
            }
        });
        return cleanTouchActions(actions.join(' '));
    },

    /**
     * this method is called on each input cycle and provides the preventing of the browser behavior
     * @param {Object} input
     */
    preventDefaults: function(input) {
        var srcEvent = input.srcEvent;
        var direction = input.offsetDirection;

        // if the touch action did prevented once this session
        if (this.manager.session.prevented) {
            srcEvent.preventDefault();
            return;
        }

        var actions = this.actions;
        var hasNone = inStr(actions, TOUCH_ACTION_NONE) && !TOUCH_ACTION_MAP[TOUCH_ACTION_NONE];
        var hasPanY = inStr(actions, TOUCH_ACTION_PAN_Y) && !TOUCH_ACTION_MAP[TOUCH_ACTION_PAN_Y];
        var hasPanX = inStr(actions, TOUCH_ACTION_PAN_X) && !TOUCH_ACTION_MAP[TOUCH_ACTION_PAN_X];

        if (hasNone) {
            //do not prevent defaults if this is a tap gesture

            var isTapPointer = input.pointers.length === 1;
            var isTapMovement = input.distance < 2;
            var isTapTouchTime = input.deltaTime < 250;

            if (isTapPointer && isTapMovement && isTapTouchTime) {
                return;
            }
        }

        if (hasPanX && hasPanY) {
            // `pan-x pan-y` means browser handles all scrolling/panning, do not prevent
            return;
        }

        if (hasNone ||
            (hasPanY && direction & DIRECTION_HORIZONTAL) ||
            (hasPanX && direction & DIRECTION_VERTICAL)) {
            return this.preventSrc(srcEvent);
        }
    },

    /**
     * call preventDefault to prevent the browser's default behavior (scrolling in most cases)
     * @param {Object} srcEvent
     */
    preventSrc: function(srcEvent) {
        this.manager.session.prevented = true;
        srcEvent.preventDefault();
    }
};

/**
 * when the touchActions are collected they are not a valid value, so we need to clean things up. *
 * @param {String} actions
 * @returns {*}
 */
function cleanTouchActions(actions) {
    // none
    if (inStr(actions, TOUCH_ACTION_NONE)) {
        return TOUCH_ACTION_NONE;
    }

    var hasPanX = inStr(actions, TOUCH_ACTION_PAN_X);
    var hasPanY = inStr(actions, TOUCH_ACTION_PAN_Y);

    // if both pan-x and pan-y are set (different recognizers
    // for different directions, e.g. horizontal pan but vertical swipe?)
    // we need none (as otherwise with pan-x pan-y combined none of these
    // recognizers will work, since the browser would handle all panning
    if (hasPanX && hasPanY) {
        return TOUCH_ACTION_NONE;
    }

    // pan-x OR pan-y
    if (hasPanX || hasPanY) {
        return hasPanX ? TOUCH_ACTION_PAN_X : TOUCH_ACTION_PAN_Y;
    }

    // manipulation
    if (inStr(actions, TOUCH_ACTION_MANIPULATION)) {
        return TOUCH_ACTION_MANIPULATION;
    }

    return TOUCH_ACTION_AUTO;
}

function getTouchActionProps() {
    if (!NATIVE_TOUCH_ACTION) {
        return false;
    }
    var touchMap = {};
    var cssSupports = window.CSS && window.CSS.supports;
    ['auto', 'manipulation', 'pan-y', 'pan-x', 'pan-x pan-y', 'none'].forEach(function(val) {

        // If css.supports is not supported but there is native touch-action assume it supports
        // all values. This is the case for IE 10 and 11.
        touchMap[val] = cssSupports ? window.CSS.supports('touch-action', val) : true;
    });
    return touchMap;
}

/**
 * Recognizer flow explained; *
 * All recognizers have the initial state of POSSIBLE when a input session starts.
 * The definition of a input session is from the first input until the last input, with all it's movement in it. *
 * Example session for mouse-input: mousedown -> mousemove -> mouseup
 *
 * On each recognizing cycle (see Manager.recognize) the .recognize() method is executed
 * which determines with state it should be.
 *
 * If the recognizer has the state FAILED, CANCELLED or RECOGNIZED (equals ENDED), it is reset to
 * POSSIBLE to give it another change on the next cycle.
 *
 *               Possible
 *                  |
 *            +-----+---------------+
 *            |                     |
 *      +-----+-----+               |
 *      |           |               |
 *   Failed      Cancelled          |
 *                          +-------+------+
 *                          |              |
 *                      Recognized       Began
 *                                         |
 *                                      Changed
 *                                         |
 *                                  Ended/Recognized
 */
var STATE_POSSIBLE = 1;
var STATE_BEGAN = 2;
var STATE_CHANGED = 4;
var STATE_ENDED = 8;
var STATE_RECOGNIZED = STATE_ENDED;
var STATE_CANCELLED = 16;
var STATE_FAILED = 32;

/**
 * Recognizer
 * Every recognizer needs to extend from this class.
 * @constructor
 * @param {Object} options
 */
function Recognizer(options) {
    this.options = assign({}, this.defaults, options || {});

    this.id = uniqueId();

    this.manager = null;

    // default is enable true
    this.options.enable = ifUndefined(this.options.enable, true);

    this.state = STATE_POSSIBLE;

    this.simultaneous = {};
    this.requireFail = [];
}

Recognizer.prototype = {
    /**
     * @virtual
     * @type {Object}
     */
    defaults: {},

    /**
     * set options
     * @param {Object} options
     * @return {Recognizer}
     */
    set: function(options) {
        assign(this.options, options);

        // also update the touchAction, in case something changed about the directions/enabled state
        this.manager && this.manager.touchAction.update();
        return this;
    },

    /**
     * recognize simultaneous with an other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    recognizeWith: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'recognizeWith', this)) {
            return this;
        }

        var simultaneous = this.simultaneous;
        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        if (!simultaneous[otherRecognizer.id]) {
            simultaneous[otherRecognizer.id] = otherRecognizer;
            otherRecognizer.recognizeWith(this);
        }
        return this;
    },

    /**
     * drop the simultaneous link. it doesnt remove the link on the other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    dropRecognizeWith: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'dropRecognizeWith', this)) {
            return this;
        }

        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        delete this.simultaneous[otherRecognizer.id];
        return this;
    },

    /**
     * recognizer can only run when an other is failing
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    requireFailure: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'requireFailure', this)) {
            return this;
        }

        var requireFail = this.requireFail;
        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        if (inArray(requireFail, otherRecognizer) === -1) {
            requireFail.push(otherRecognizer);
            otherRecognizer.requireFailure(this);
        }
        return this;
    },

    /**
     * drop the requireFailure link. it does not remove the link on the other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    dropRequireFailure: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'dropRequireFailure', this)) {
            return this;
        }

        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        var index = inArray(this.requireFail, otherRecognizer);
        if (index > -1) {
            this.requireFail.splice(index, 1);
        }
        return this;
    },

    /**
     * has require failures boolean
     * @returns {boolean}
     */
    hasRequireFailures: function() {
        return this.requireFail.length > 0;
    },

    /**
     * if the recognizer can recognize simultaneous with an other recognizer
     * @param {Recognizer} otherRecognizer
     * @returns {Boolean}
     */
    canRecognizeWith: function(otherRecognizer) {
        return !!this.simultaneous[otherRecognizer.id];
    },

    /**
     * You should use `tryEmit` instead of `emit` directly to check
     * that all the needed recognizers has failed before emitting.
     * @param {Object} input
     */
    emit: function(input) {
        var self = this;
        var state = this.state;

        function emit(event) {
            self.manager.emit(event, input);
        }

        // 'panstart' and 'panmove'
        if (state < STATE_ENDED) {
            emit(self.options.event + stateStr(state));
        }

        emit(self.options.event); // simple 'eventName' events

        if (input.additionalEvent) { // additional event(panleft, panright, pinchin, pinchout...)
            emit(input.additionalEvent);
        }

        // panend and pancancel
        if (state >= STATE_ENDED) {
            emit(self.options.event + stateStr(state));
        }
    },

    /**
     * Check that all the require failure recognizers has failed,
     * if true, it emits a gesture event,
     * otherwise, setup the state to FAILED.
     * @param {Object} input
     */
    tryEmit: function(input) {
        if (this.canEmit()) {
            return this.emit(input);
        }
        // it's failing anyway
        this.state = STATE_FAILED;
    },

    /**
     * can we emit?
     * @returns {boolean}
     */
    canEmit: function() {
        var i = 0;
        while (i < this.requireFail.length) {
            if (!(this.requireFail[i].state & (STATE_FAILED | STATE_POSSIBLE))) {
                return false;
            }
            i++;
        }
        return true;
    },

    /**
     * update the recognizer
     * @param {Object} inputData
     */
    recognize: function(inputData) {
        // make a new copy of the inputData
        // so we can change the inputData without messing up the other recognizers
        var inputDataClone = assign({}, inputData);

        // is is enabled and allow recognizing?
        if (!boolOrFn(this.options.enable, [this, inputDataClone])) {
            this.reset();
            this.state = STATE_FAILED;
            return;
        }

        // reset when we've reached the end
        if (this.state & (STATE_RECOGNIZED | STATE_CANCELLED | STATE_FAILED)) {
            this.state = STATE_POSSIBLE;
        }

        this.state = this.process(inputDataClone);

        // the recognizer has recognized a gesture
        // so trigger an event
        if (this.state & (STATE_BEGAN | STATE_CHANGED | STATE_ENDED | STATE_CANCELLED)) {
            this.tryEmit(inputDataClone);
        }
    },

    /**
     * return the state of the recognizer
     * the actual recognizing happens in this method
     * @virtual
     * @param {Object} inputData
     * @returns {Const} STATE
     */
    process: function(inputData) { }, // jshint ignore:line

    /**
     * return the preferred touch-action
     * @virtual
     * @returns {Array}
     */
    getTouchAction: function() { },

    /**
     * called when the gesture isn't allowed to recognize
     * like when another is being recognized or it is disabled
     * @virtual
     */
    reset: function() { }
};

/**
 * get a usable string, used as event postfix
 * @param {Const} state
 * @returns {String} state
 */
function stateStr(state) {
    if (state & STATE_CANCELLED) {
        return 'cancel';
    } else if (state & STATE_ENDED) {
        return 'end';
    } else if (state & STATE_CHANGED) {
        return 'move';
    } else if (state & STATE_BEGAN) {
        return 'start';
    }
    return '';
}

/**
 * direction cons to string
 * @param {Const} direction
 * @returns {String}
 */
function directionStr(direction) {
    if (direction == DIRECTION_DOWN) {
        return 'down';
    } else if (direction == DIRECTION_UP) {
        return 'up';
    } else if (direction == DIRECTION_LEFT) {
        return 'left';
    } else if (direction == DIRECTION_RIGHT) {
        return 'right';
    }
    return '';
}

/**
 * get a recognizer by name if it is bound to a manager
 * @param {Recognizer|String} otherRecognizer
 * @param {Recognizer} recognizer
 * @returns {Recognizer}
 */
function getRecognizerByNameIfManager(otherRecognizer, recognizer) {
    var manager = recognizer.manager;
    if (manager) {
        return manager.get(otherRecognizer);
    }
    return otherRecognizer;
}

/**
 * This recognizer is just used as a base for the simple attribute recognizers.
 * @constructor
 * @extends Recognizer
 */
function AttrRecognizer() {
    Recognizer.apply(this, arguments);
}

inherit(AttrRecognizer, Recognizer, {
    /**
     * @namespace
     * @memberof AttrRecognizer
     */
    defaults: {
        /**
         * @type {Number}
         * @default 1
         */
        pointers: 1
    },

    /**
     * Used to check if it the recognizer receives valid input, like input.distance > 10.
     * @memberof AttrRecognizer
     * @param {Object} input
     * @returns {Boolean} recognized
     */
    attrTest: function(input) {
        var optionPointers = this.options.pointers;
        return optionPointers === 0 || input.pointers.length === optionPointers;
    },

    /**
     * Process the input and return the state for the recognizer
     * @memberof AttrRecognizer
     * @param {Object} input
     * @returns {*} State
     */
    process: function(input) {
        var state = this.state;
        var eventType = input.eventType;

        var isRecognized = state & (STATE_BEGAN | STATE_CHANGED);
        var isValid = this.attrTest(input);

        // on cancel input and we've recognized before, return STATE_CANCELLED
        if (isRecognized && (eventType & INPUT_CANCEL || !isValid)) {
            return state | STATE_CANCELLED;
        } else if (isRecognized || isValid) {
            if (eventType & INPUT_END) {
                return state | STATE_ENDED;
            } else if (!(state & STATE_BEGAN)) {
                return STATE_BEGAN;
            }
            return state | STATE_CHANGED;
        }
        return STATE_FAILED;
    }
});

/**
 * Pan
 * Recognized when the pointer is down and moved in the allowed direction.
 * @constructor
 * @extends AttrRecognizer
 */
function PanRecognizer() {
    AttrRecognizer.apply(this, arguments);

    this.pX = null;
    this.pY = null;
}

inherit(PanRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof PanRecognizer
     */
    defaults: {
        event: 'pan',
        threshold: 10,
        pointers: 1,
        direction: DIRECTION_ALL
    },

    getTouchAction: function() {
        var direction = this.options.direction;
        var actions = [];
        if (direction & DIRECTION_HORIZONTAL) {
            actions.push(TOUCH_ACTION_PAN_Y);
        }
        if (direction & DIRECTION_VERTICAL) {
            actions.push(TOUCH_ACTION_PAN_X);
        }
        return actions;
    },

    directionTest: function(input) {
        var options = this.options;
        var hasMoved = true;
        var distance = input.distance;
        var direction = input.direction;
        var x = input.deltaX;
        var y = input.deltaY;

        // lock to axis?
        if (!(direction & options.direction)) {
            if (options.direction & DIRECTION_HORIZONTAL) {
                direction = (x === 0) ? DIRECTION_NONE : (x < 0) ? DIRECTION_LEFT : DIRECTION_RIGHT;
                hasMoved = x != this.pX;
                distance = Math.abs(input.deltaX);
            } else {
                direction = (y === 0) ? DIRECTION_NONE : (y < 0) ? DIRECTION_UP : DIRECTION_DOWN;
                hasMoved = y != this.pY;
                distance = Math.abs(input.deltaY);
            }
        }
        input.direction = direction;
        return hasMoved && distance > options.threshold && direction & options.direction;
    },

    attrTest: function(input) {
        return AttrRecognizer.prototype.attrTest.call(this, input) &&
            (this.state & STATE_BEGAN || (!(this.state & STATE_BEGAN) && this.directionTest(input)));
    },

    emit: function(input) {

        this.pX = input.deltaX;
        this.pY = input.deltaY;

        var direction = directionStr(input.direction);

        if (direction) {
            input.additionalEvent = this.options.event + direction;
        }
        this._super.emit.call(this, input);
    }
});

/**
 * Pinch
 * Recognized when two or more pointers are moving toward (zoom-in) or away from each other (zoom-out).
 * @constructor
 * @extends AttrRecognizer
 */
function PinchRecognizer() {
    AttrRecognizer.apply(this, arguments);
}

inherit(PinchRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof PinchRecognizer
     */
    defaults: {
        event: 'pinch',
        threshold: 0,
        pointers: 2
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_NONE];
    },

    attrTest: function(input) {
        return this._super.attrTest.call(this, input) &&
            (Math.abs(input.scale - 1) > this.options.threshold || this.state & STATE_BEGAN);
    },

    emit: function(input) {
        if (input.scale !== 1) {
            var inOut = input.scale < 1 ? 'in' : 'out';
            input.additionalEvent = this.options.event + inOut;
        }
        this._super.emit.call(this, input);
    }
});

/**
 * Press
 * Recognized when the pointer is down for x ms without any movement.
 * @constructor
 * @extends Recognizer
 */
function PressRecognizer() {
    Recognizer.apply(this, arguments);

    this._timer = null;
    this._input = null;
}

inherit(PressRecognizer, Recognizer, {
    /**
     * @namespace
     * @memberof PressRecognizer
     */
    defaults: {
        event: 'press',
        pointers: 1,
        time: 251, // minimal time of the pointer to be pressed
        threshold: 9 // a minimal movement is ok, but keep it low
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_AUTO];
    },

    process: function(input) {
        var options = this.options;
        var validPointers = input.pointers.length === options.pointers;
        var validMovement = input.distance < options.threshold;
        var validTime = input.deltaTime > options.time;

        this._input = input;

        // we only allow little movement
        // and we've reached an end event, so a tap is possible
        if (!validMovement || !validPointers || (input.eventType & (INPUT_END | INPUT_CANCEL) && !validTime)) {
            this.reset();
        } else if (input.eventType & INPUT_START) {
            this.reset();
            this._timer = setTimeoutContext(function() {
                this.state = STATE_RECOGNIZED;
                this.tryEmit();
            }, options.time, this);
        } else if (input.eventType & INPUT_END) {
            return STATE_RECOGNIZED;
        }
        return STATE_FAILED;
    },

    reset: function() {
        clearTimeout(this._timer);
    },

    emit: function(input) {
        if (this.state !== STATE_RECOGNIZED) {
            return;
        }

        if (input && (input.eventType & INPUT_END)) {
            this.manager.emit(this.options.event + 'up', input);
        } else {
            this._input.timeStamp = now();
            this.manager.emit(this.options.event, this._input);
        }
    }
});

/**
 * Rotate
 * Recognized when two or more pointer are moving in a circular motion.
 * @constructor
 * @extends AttrRecognizer
 */
function RotateRecognizer() {
    AttrRecognizer.apply(this, arguments);
}

inherit(RotateRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof RotateRecognizer
     */
    defaults: {
        event: 'rotate',
        threshold: 0,
        pointers: 2
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_NONE];
    },

    attrTest: function(input) {
        return this._super.attrTest.call(this, input) &&
            (Math.abs(input.rotation) > this.options.threshold || this.state & STATE_BEGAN);
    }
});

/**
 * Swipe
 * Recognized when the pointer is moving fast (velocity), with enough distance in the allowed direction.
 * @constructor
 * @extends AttrRecognizer
 */
function SwipeRecognizer() {
    AttrRecognizer.apply(this, arguments);
}

inherit(SwipeRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof SwipeRecognizer
     */
    defaults: {
        event: 'swipe',
        threshold: 10,
        velocity: 0.3,
        direction: DIRECTION_HORIZONTAL | DIRECTION_VERTICAL,
        pointers: 1
    },

    getTouchAction: function() {
        return PanRecognizer.prototype.getTouchAction.call(this);
    },

    attrTest: function(input) {
        var direction = this.options.direction;
        var velocity;

        if (direction & (DIRECTION_HORIZONTAL | DIRECTION_VERTICAL)) {
            velocity = input.overallVelocity;
        } else if (direction & DIRECTION_HORIZONTAL) {
            velocity = input.overallVelocityX;
        } else if (direction & DIRECTION_VERTICAL) {
            velocity = input.overallVelocityY;
        }

        return this._super.attrTest.call(this, input) &&
            direction & input.offsetDirection &&
            input.distance > this.options.threshold &&
            input.maxPointers == this.options.pointers &&
            abs(velocity) > this.options.velocity && input.eventType & INPUT_END;
    },

    emit: function(input) {
        var direction = directionStr(input.offsetDirection);
        if (direction) {
            this.manager.emit(this.options.event + direction, input);
        }

        this.manager.emit(this.options.event, input);
    }
});

/**
 * A tap is ecognized when the pointer is doing a small tap/click. Multiple taps are recognized if they occur
 * between the given interval and position. The delay option can be used to recognize multi-taps without firing
 * a single tap.
 *
 * The eventData from the emitted event contains the property `tapCount`, which contains the amount of
 * multi-taps being recognized.
 * @constructor
 * @extends Recognizer
 */
function TapRecognizer() {
    Recognizer.apply(this, arguments);

    // previous time and center,
    // used for tap counting
    this.pTime = false;
    this.pCenter = false;

    this._timer = null;
    this._input = null;
    this.count = 0;
}

inherit(TapRecognizer, Recognizer, {
    /**
     * @namespace
     * @memberof PinchRecognizer
     */
    defaults: {
        event: 'tap',
        pointers: 1,
        taps: 1,
        interval: 300, // max time between the multi-tap taps
        time: 250, // max time of the pointer to be down (like finger on the screen)
        threshold: 9, // a minimal movement is ok, but keep it low
        posThreshold: 10 // a multi-tap can be a bit off the initial position
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_MANIPULATION];
    },

    process: function(input) {
        var options = this.options;

        var validPointers = input.pointers.length === options.pointers;
        var validMovement = input.distance < options.threshold;
        var validTouchTime = input.deltaTime < options.time;

        this.reset();

        if ((input.eventType & INPUT_START) && (this.count === 0)) {
            return this.failTimeout();
        }

        // we only allow little movement
        // and we've reached an end event, so a tap is possible
        if (validMovement && validTouchTime && validPointers) {
            if (input.eventType != INPUT_END) {
                return this.failTimeout();
            }

            var validInterval = this.pTime ? (input.timeStamp - this.pTime < options.interval) : true;
            var validMultiTap = !this.pCenter || getDistance(this.pCenter, input.center) < options.posThreshold;

            this.pTime = input.timeStamp;
            this.pCenter = input.center;

            if (!validMultiTap || !validInterval) {
                this.count = 1;
            } else {
                this.count += 1;
            }

            this._input = input;

            // if tap count matches we have recognized it,
            // else it has began recognizing...
            var tapCount = this.count % options.taps;
            if (tapCount === 0) {
                // no failing requirements, immediately trigger the tap event
                // or wait as long as the multitap interval to trigger
                if (!this.hasRequireFailures()) {
                    return STATE_RECOGNIZED;
                } else {
                    this._timer = setTimeoutContext(function() {
                        this.state = STATE_RECOGNIZED;
                        this.tryEmit();
                    }, options.interval, this);
                    return STATE_BEGAN;
                }
            }
        }
        return STATE_FAILED;
    },

    failTimeout: function() {
        this._timer = setTimeoutContext(function() {
            this.state = STATE_FAILED;
        }, this.options.interval, this);
        return STATE_FAILED;
    },

    reset: function() {
        clearTimeout(this._timer);
    },

    emit: function() {
        if (this.state == STATE_RECOGNIZED) {
            this._input.tapCount = this.count;
            this.manager.emit(this.options.event, this._input);
        }
    }
});

/**
 * Simple way to create a manager with a default set of recognizers.
 * @param {HTMLElement} element
 * @param {Object} [options]
 * @constructor
 */
function Hammer(element, options) {
    options = options || {};
    options.recognizers = ifUndefined(options.recognizers, Hammer.defaults.preset);
    return new Manager(element, options);
}

/**
 * @const {string}
 */
Hammer.VERSION = '2.0.7';

/**
 * default settings
 * @namespace
 */
Hammer.defaults = {
    /**
     * set if DOM events are being triggered.
     * But this is slower and unused by simple implementations, so disabled by default.
     * @type {Boolean}
     * @default false
     */
    domEvents: false,

    /**
     * The value for the touchAction property/fallback.
     * When set to `compute` it will magically set the correct value based on the added recognizers.
     * @type {String}
     * @default compute
     */
    touchAction: TOUCH_ACTION_COMPUTE,

    /**
     * @type {Boolean}
     * @default true
     */
    enable: true,

    /**
     * EXPERIMENTAL FEATURE -- can be removed/changed
     * Change the parent input target element.
     * If Null, then it is being set the to main element.
     * @type {Null|EventTarget}
     * @default null
     */
    inputTarget: null,

    /**
     * force an input class
     * @type {Null|Function}
     * @default null
     */
    inputClass: null,

    /**
     * Default recognizer setup when calling `Hammer()`
     * When creating a new Manager these will be skipped.
     * @type {Array}
     */
    preset: [
        // RecognizerClass, options, [recognizeWith, ...], [requireFailure, ...]
        [RotateRecognizer, {enable: false}],
        [PinchRecognizer, {enable: false}, ['rotate']],
        [SwipeRecognizer, {direction: DIRECTION_HORIZONTAL}],
        [PanRecognizer, {direction: DIRECTION_HORIZONTAL}, ['swipe']],
        [TapRecognizer],
        [TapRecognizer, {event: 'doubletap', taps: 2}, ['tap']],
        [PressRecognizer]
    ],

    /**
     * Some CSS properties can be used to improve the working of Hammer.
     * Add them to this method and they will be set when creating a new Manager.
     * @namespace
     */
    cssProps: {
        /**
         * Disables text selection to improve the dragging gesture. Mainly for desktop browsers.
         * @type {String}
         * @default 'none'
         */
        userSelect: 'none',

        /**
         * Disable the Windows Phone grippers when pressing an element.
         * @type {String}
         * @default 'none'
         */
        touchSelect: 'none',

        /**
         * Disables the default callout shown when you touch and hold a touch target.
         * On iOS, when you touch and hold a touch target such as a link, Safari displays
         * a callout containing information about the link. This property allows you to disable that callout.
         * @type {String}
         * @default 'none'
         */
        touchCallout: 'none',

        /**
         * Specifies whether zooming is enabled. Used by IE10>
         * @type {String}
         * @default 'none'
         */
        contentZooming: 'none',

        /**
         * Specifies that an entire element should be draggable instead of its contents. Mainly for desktop browsers.
         * @type {String}
         * @default 'none'
         */
        userDrag: 'none',

        /**
         * Overrides the highlight color shown when the user taps a link or a JavaScript
         * clickable element in iOS. This property obeys the alpha value, if specified.
         * @type {String}
         * @default 'rgba(0,0,0,0)'
         */
        tapHighlightColor: 'rgba(0,0,0,0)'
    }
};

var STOP = 1;
var FORCED_STOP = 2;

/**
 * Manager
 * @param {HTMLElement} element
 * @param {Object} [options]
 * @constructor
 */
function Manager(element, options) {
    this.options = assign({}, Hammer.defaults, options || {});

    this.options.inputTarget = this.options.inputTarget || element;

    this.handlers = {};
    this.session = {};
    this.recognizers = [];
    this.oldCssProps = {};

    this.element = element;
    this.input = createInputInstance(this);
    this.touchAction = new TouchAction(this, this.options.touchAction);

    toggleCssProps(this, true);

    each(this.options.recognizers, function(item) {
        var recognizer = this.add(new (item[0])(item[1]));
        item[2] && recognizer.recognizeWith(item[2]);
        item[3] && recognizer.requireFailure(item[3]);
    }, this);
}

Manager.prototype = {
    /**
     * set options
     * @param {Object} options
     * @returns {Manager}
     */
    set: function(options) {
        assign(this.options, options);

        // Options that need a little more setup
        if (options.touchAction) {
            this.touchAction.update();
        }
        if (options.inputTarget) {
            // Clean up existing event listeners and reinitialize
            this.input.destroy();
            this.input.target = options.inputTarget;
            this.input.init();
        }
        return this;
    },

    /**
     * stop recognizing for this session.
     * This session will be discarded, when a new [input]start event is fired.
     * When forced, the recognizer cycle is stopped immediately.
     * @param {Boolean} [force]
     */
    stop: function(force) {
        this.session.stopped = force ? FORCED_STOP : STOP;
    },

    /**
     * run the recognizers!
     * called by the inputHandler function on every movement of the pointers (touches)
     * it walks through all the recognizers and tries to detect the gesture that is being made
     * @param {Object} inputData
     */
    recognize: function(inputData) {
        var session = this.session;
        if (session.stopped) {
            return;
        }

        // run the touch-action polyfill
        this.touchAction.preventDefaults(inputData);

        var recognizer;
        var recognizers = this.recognizers;

        // this holds the recognizer that is being recognized.
        // so the recognizer's state needs to be BEGAN, CHANGED, ENDED or RECOGNIZED
        // if no recognizer is detecting a thing, it is set to `null`
        var curRecognizer = session.curRecognizer;

        // reset when the last recognizer is recognized
        // or when we're in a new session
        if (!curRecognizer || (curRecognizer && curRecognizer.state & STATE_RECOGNIZED)) {
            curRecognizer = session.curRecognizer = null;
        }

        var i = 0;
        while (i < recognizers.length) {
            recognizer = recognizers[i];

            // find out if we are allowed try to recognize the input for this one.
            // 1.   allow if the session is NOT forced stopped (see the .stop() method)
            // 2.   allow if we still haven't recognized a gesture in this session, or the this recognizer is the one
            //      that is being recognized.
            // 3.   allow if the recognizer is allowed to run simultaneous with the current recognized recognizer.
            //      this can be setup with the `recognizeWith()` method on the recognizer.
            if (session.stopped !== FORCED_STOP && ( // 1
                    !curRecognizer || recognizer == curRecognizer || // 2
                    recognizer.canRecognizeWith(curRecognizer))) { // 3
                recognizer.recognize(inputData);
            } else {
                recognizer.reset();
            }

            // if the recognizer has been recognizing the input as a valid gesture, we want to store this one as the
            // current active recognizer. but only if we don't already have an active recognizer
            if (!curRecognizer && recognizer.state & (STATE_BEGAN | STATE_CHANGED | STATE_ENDED)) {
                curRecognizer = session.curRecognizer = recognizer;
            }
            i++;
        }
    },

    /**
     * get a recognizer by its event name.
     * @param {Recognizer|String} recognizer
     * @returns {Recognizer|Null}
     */
    get: function(recognizer) {
        if (recognizer instanceof Recognizer) {
            return recognizer;
        }

        var recognizers = this.recognizers;
        for (var i = 0; i < recognizers.length; i++) {
            if (recognizers[i].options.event == recognizer) {
                return recognizers[i];
            }
        }
        return null;
    },

    /**
     * add a recognizer to the manager
     * existing recognizers with the same event name will be removed
     * @param {Recognizer} recognizer
     * @returns {Recognizer|Manager}
     */
    add: function(recognizer) {
        if (invokeArrayArg(recognizer, 'add', this)) {
            return this;
        }

        // remove existing
        var existing = this.get(recognizer.options.event);
        if (existing) {
            this.remove(existing);
        }

        this.recognizers.push(recognizer);
        recognizer.manager = this;

        this.touchAction.update();
        return recognizer;
    },

    /**
     * remove a recognizer by name or instance
     * @param {Recognizer|String} recognizer
     * @returns {Manager}
     */
    remove: function(recognizer) {
        if (invokeArrayArg(recognizer, 'remove', this)) {
            return this;
        }

        recognizer = this.get(recognizer);

        // let's make sure this recognizer exists
        if (recognizer) {
            var recognizers = this.recognizers;
            var index = inArray(recognizers, recognizer);

            if (index !== -1) {
                recognizers.splice(index, 1);
                this.touchAction.update();
            }
        }

        return this;
    },

    /**
     * bind event
     * @param {String} events
     * @param {Function} handler
     * @returns {EventEmitter} this
     */
    on: function(events, handler) {
        if (events === undefined) {
            return;
        }
        if (handler === undefined) {
            return;
        }

        var handlers = this.handlers;
        each(splitStr(events), function(event) {
            handlers[event] = handlers[event] || [];
            handlers[event].push(handler);
        });
        return this;
    },

    /**
     * unbind event, leave emit blank to remove all handlers
     * @param {String} events
     * @param {Function} [handler]
     * @returns {EventEmitter} this
     */
    off: function(events, handler) {
        if (events === undefined) {
            return;
        }

        var handlers = this.handlers;
        each(splitStr(events), function(event) {
            if (!handler) {
                delete handlers[event];
            } else {
                handlers[event] && handlers[event].splice(inArray(handlers[event], handler), 1);
            }
        });
        return this;
    },

    /**
     * emit event to the listeners
     * @param {String} event
     * @param {Object} data
     */
    emit: function(event, data) {
        // we also want to trigger dom events
        if (this.options.domEvents) {
            triggerDomEvent(event, data);
        }

        // no handlers, so skip it all
        var handlers = this.handlers[event] && this.handlers[event].slice();
        if (!handlers || !handlers.length) {
            return;
        }

        data.type = event;
        data.preventDefault = function() {
            data.srcEvent.preventDefault();
        };

        var i = 0;
        while (i < handlers.length) {
            handlers[i](data);
            i++;
        }
    },

    /**
     * destroy the manager and unbinds all events
     * it doesn't unbind dom events, that is the user own responsibility
     */
    destroy: function() {
        this.element && toggleCssProps(this, false);

        this.handlers = {};
        this.session = {};
        this.input.destroy();
        this.element = null;
    }
};

/**
 * add/remove the css properties as defined in manager.options.cssProps
 * @param {Manager} manager
 * @param {Boolean} add
 */
function toggleCssProps(manager, add) {
    var element = manager.element;
    if (!element.style) {
        return;
    }
    var prop;
    each(manager.options.cssProps, function(value, name) {
        prop = prefixed(element.style, name);
        if (add) {
            manager.oldCssProps[prop] = element.style[prop];
            element.style[prop] = value;
        } else {
            element.style[prop] = manager.oldCssProps[prop] || '';
        }
    });
    if (!add) {
        manager.oldCssProps = {};
    }
}

/**
 * trigger dom event
 * @param {String} event
 * @param {Object} data
 */
function triggerDomEvent(event, data) {
    var gestureEvent = document.createEvent('Event');
    gestureEvent.initEvent(event, true, true);
    gestureEvent.gesture = data;
    data.target.dispatchEvent(gestureEvent);
}

assign(Hammer, {
    INPUT_START: INPUT_START,
    INPUT_MOVE: INPUT_MOVE,
    INPUT_END: INPUT_END,
    INPUT_CANCEL: INPUT_CANCEL,

    STATE_POSSIBLE: STATE_POSSIBLE,
    STATE_BEGAN: STATE_BEGAN,
    STATE_CHANGED: STATE_CHANGED,
    STATE_ENDED: STATE_ENDED,
    STATE_RECOGNIZED: STATE_RECOGNIZED,
    STATE_CANCELLED: STATE_CANCELLED,
    STATE_FAILED: STATE_FAILED,

    DIRECTION_NONE: DIRECTION_NONE,
    DIRECTION_LEFT: DIRECTION_LEFT,
    DIRECTION_RIGHT: DIRECTION_RIGHT,
    DIRECTION_UP: DIRECTION_UP,
    DIRECTION_DOWN: DIRECTION_DOWN,
    DIRECTION_HORIZONTAL: DIRECTION_HORIZONTAL,
    DIRECTION_VERTICAL: DIRECTION_VERTICAL,
    DIRECTION_ALL: DIRECTION_ALL,

    Manager: Manager,
    Input: Input,
    TouchAction: TouchAction,

    TouchInput: TouchInput,
    MouseInput: MouseInput,
    PointerEventInput: PointerEventInput,
    TouchMouseInput: TouchMouseInput,
    SingleTouchInput: SingleTouchInput,

    Recognizer: Recognizer,
    AttrRecognizer: AttrRecognizer,
    Tap: TapRecognizer,
    Pan: PanRecognizer,
    Swipe: SwipeRecognizer,
    Pinch: PinchRecognizer,
    Rotate: RotateRecognizer,
    Press: PressRecognizer,

    on: addEventListeners,
    off: removeEventListeners,
    each: each,
    merge: merge,
    extend: extend,
    assign: assign,
    inherit: inherit,
    bindFn: bindFn,
    prefixed: prefixed
});

// this prevents errors when Hammer is loaded in the presence of an AMD
//  style loader but by script tag, not by the loader.
var freeGlobal = (typeof window !== 'undefined' ? window : (typeof self !== 'undefined' ? self : {})); // jshint ignore:line
freeGlobal.Hammer = Hammer;

if (true) {
    !(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {
        return Hammer;
    }).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
} else if (typeof module != 'undefined' && module.exports) {
    module.exports = Hammer;
} else {
    window[exportName] = Hammer;
}

})(window, document, 'Hammer');


/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Url */
/* unused harmony export Http */
/* unused harmony export Resource */
/*!
 * vue-resource v1.5.1
 * https://github.com/pagekit/vue-resource
 * Released under the MIT License.
 */

/**
 * Promises/A+ polyfill v1.1.4 (https://github.com/bramstein/promis)
 */

var RESOLVED = 0;
var REJECTED = 1;
var PENDING = 2;

function Promise$1(executor) {

    this.state = PENDING;
    this.value = undefined;
    this.deferred = [];

    var promise = this;

    try {
        executor(function (x) {
            promise.resolve(x);
        }, function (r) {
            promise.reject(r);
        });
    } catch (e) {
        promise.reject(e);
    }
}

Promise$1.reject = function (r) {
    return new Promise$1(function (resolve, reject) {
        reject(r);
    });
};

Promise$1.resolve = function (x) {
    return new Promise$1(function (resolve, reject) {
        resolve(x);
    });
};

Promise$1.all = function all(iterable) {
    return new Promise$1(function (resolve, reject) {
        var count = 0, result = [];

        if (iterable.length === 0) {
            resolve(result);
        }

        function resolver(i) {
            return function (x) {
                result[i] = x;
                count += 1;

                if (count === iterable.length) {
                    resolve(result);
                }
            };
        }

        for (var i = 0; i < iterable.length; i += 1) {
            Promise$1.resolve(iterable[i]).then(resolver(i), reject);
        }
    });
};

Promise$1.race = function race(iterable) {
    return new Promise$1(function (resolve, reject) {
        for (var i = 0; i < iterable.length; i += 1) {
            Promise$1.resolve(iterable[i]).then(resolve, reject);
        }
    });
};

var p = Promise$1.prototype;

p.resolve = function resolve(x) {
    var promise = this;

    if (promise.state === PENDING) {
        if (x === promise) {
            throw new TypeError('Promise settled with itself.');
        }

        var called = false;

        try {
            var then = x && x['then'];

            if (x !== null && typeof x === 'object' && typeof then === 'function') {
                then.call(x, function (x) {
                    if (!called) {
                        promise.resolve(x);
                    }
                    called = true;

                }, function (r) {
                    if (!called) {
                        promise.reject(r);
                    }
                    called = true;
                });
                return;
            }
        } catch (e) {
            if (!called) {
                promise.reject(e);
            }
            return;
        }

        promise.state = RESOLVED;
        promise.value = x;
        promise.notify();
    }
};

p.reject = function reject(reason) {
    var promise = this;

    if (promise.state === PENDING) {
        if (reason === promise) {
            throw new TypeError('Promise settled with itself.');
        }

        promise.state = REJECTED;
        promise.value = reason;
        promise.notify();
    }
};

p.notify = function notify() {
    var promise = this;

    nextTick(function () {
        if (promise.state !== PENDING) {
            while (promise.deferred.length) {
                var deferred = promise.deferred.shift(),
                    onResolved = deferred[0],
                    onRejected = deferred[1],
                    resolve = deferred[2],
                    reject = deferred[3];

                try {
                    if (promise.state === RESOLVED) {
                        if (typeof onResolved === 'function') {
                            resolve(onResolved.call(undefined, promise.value));
                        } else {
                            resolve(promise.value);
                        }
                    } else if (promise.state === REJECTED) {
                        if (typeof onRejected === 'function') {
                            resolve(onRejected.call(undefined, promise.value));
                        } else {
                            reject(promise.value);
                        }
                    }
                } catch (e) {
                    reject(e);
                }
            }
        }
    });
};

p.then = function then(onResolved, onRejected) {
    var promise = this;

    return new Promise$1(function (resolve, reject) {
        promise.deferred.push([onResolved, onRejected, resolve, reject]);
        promise.notify();
    });
};

p.catch = function (onRejected) {
    return this.then(undefined, onRejected);
};

/**
 * Promise adapter.
 */

if (typeof Promise === 'undefined') {
    window.Promise = Promise$1;
}

function PromiseObj(executor, context) {

    if (executor instanceof Promise) {
        this.promise = executor;
    } else {
        this.promise = new Promise(executor.bind(context));
    }

    this.context = context;
}

PromiseObj.all = function (iterable, context) {
    return new PromiseObj(Promise.all(iterable), context);
};

PromiseObj.resolve = function (value, context) {
    return new PromiseObj(Promise.resolve(value), context);
};

PromiseObj.reject = function (reason, context) {
    return new PromiseObj(Promise.reject(reason), context);
};

PromiseObj.race = function (iterable, context) {
    return new PromiseObj(Promise.race(iterable), context);
};

var p$1 = PromiseObj.prototype;

p$1.bind = function (context) {
    this.context = context;
    return this;
};

p$1.then = function (fulfilled, rejected) {

    if (fulfilled && fulfilled.bind && this.context) {
        fulfilled = fulfilled.bind(this.context);
    }

    if (rejected && rejected.bind && this.context) {
        rejected = rejected.bind(this.context);
    }

    return new PromiseObj(this.promise.then(fulfilled, rejected), this.context);
};

p$1.catch = function (rejected) {

    if (rejected && rejected.bind && this.context) {
        rejected = rejected.bind(this.context);
    }

    return new PromiseObj(this.promise.catch(rejected), this.context);
};

p$1.finally = function (callback) {

    return this.then(function (value) {
        callback.call(this);
        return value;
    }, function (reason) {
        callback.call(this);
        return Promise.reject(reason);
    }
    );
};

/**
 * Utility functions.
 */

var ref = {};
var hasOwnProperty = ref.hasOwnProperty;
var ref$1 = [];
var slice = ref$1.slice;
var debug = false, ntick;

var inBrowser = typeof window !== 'undefined';

function Util (ref) {
    var config = ref.config;
    var nextTick = ref.nextTick;

    ntick = nextTick;
    debug = config.debug || !config.silent;
}

function warn(msg) {
    if (typeof console !== 'undefined' && debug) {
        console.warn('[VueResource warn]: ' + msg);
    }
}

function error(msg) {
    if (typeof console !== 'undefined') {
        console.error(msg);
    }
}

function nextTick(cb, ctx) {
    return ntick(cb, ctx);
}

function trim(str) {
    return str ? str.replace(/^\s*|\s*$/g, '') : '';
}

function trimEnd(str, chars) {

    if (str && chars === undefined) {
        return str.replace(/\s+$/, '');
    }

    if (!str || !chars) {
        return str;
    }

    return str.replace(new RegExp(("[" + chars + "]+$")), '');
}

function toLower(str) {
    return str ? str.toLowerCase() : '';
}

function toUpper(str) {
    return str ? str.toUpperCase() : '';
}

var isArray = Array.isArray;

function isString(val) {
    return typeof val === 'string';
}

function isFunction(val) {
    return typeof val === 'function';
}

function isObject(obj) {
    return obj !== null && typeof obj === 'object';
}

function isPlainObject(obj) {
    return isObject(obj) && Object.getPrototypeOf(obj) == Object.prototype;
}

function isBlob(obj) {
    return typeof Blob !== 'undefined' && obj instanceof Blob;
}

function isFormData(obj) {
    return typeof FormData !== 'undefined' && obj instanceof FormData;
}

function when(value, fulfilled, rejected) {

    var promise = PromiseObj.resolve(value);

    if (arguments.length < 2) {
        return promise;
    }

    return promise.then(fulfilled, rejected);
}

function options(fn, obj, opts) {

    opts = opts || {};

    if (isFunction(opts)) {
        opts = opts.call(obj);
    }

    return merge(fn.bind({$vm: obj, $options: opts}), fn, {$options: opts});
}

function each(obj, iterator) {

    var i, key;

    if (isArray(obj)) {
        for (i = 0; i < obj.length; i++) {
            iterator.call(obj[i], obj[i], i);
        }
    } else if (isObject(obj)) {
        for (key in obj) {
            if (hasOwnProperty.call(obj, key)) {
                iterator.call(obj[key], obj[key], key);
            }
        }
    }

    return obj;
}

var assign = Object.assign || _assign;

function merge(target) {

    var args = slice.call(arguments, 1);

    args.forEach(function (source) {
        _merge(target, source, true);
    });

    return target;
}

function defaults(target) {

    var args = slice.call(arguments, 1);

    args.forEach(function (source) {

        for (var key in source) {
            if (target[key] === undefined) {
                target[key] = source[key];
            }
        }

    });

    return target;
}

function _assign(target) {

    var args = slice.call(arguments, 1);

    args.forEach(function (source) {
        _merge(target, source);
    });

    return target;
}

function _merge(target, source, deep) {
    for (var key in source) {
        if (deep && (isPlainObject(source[key]) || isArray(source[key]))) {
            if (isPlainObject(source[key]) && !isPlainObject(target[key])) {
                target[key] = {};
            }
            if (isArray(source[key]) && !isArray(target[key])) {
                target[key] = [];
            }
            _merge(target[key], source[key], deep);
        } else if (source[key] !== undefined) {
            target[key] = source[key];
        }
    }
}

/**
 * Root Prefix Transform.
 */

function root (options$$1, next) {

    var url = next(options$$1);

    if (isString(options$$1.root) && !/^(https?:)?\//.test(url)) {
        url = trimEnd(options$$1.root, '/') + '/' + url;
    }

    return url;
}

/**
 * Query Parameter Transform.
 */

function query (options$$1, next) {

    var urlParams = Object.keys(Url.options.params), query = {}, url = next(options$$1);

    each(options$$1.params, function (value, key) {
        if (urlParams.indexOf(key) === -1) {
            query[key] = value;
        }
    });

    query = Url.params(query);

    if (query) {
        url += (url.indexOf('?') == -1 ? '?' : '&') + query;
    }

    return url;
}

/**
 * URL Template v2.0.6 (https://github.com/bramstein/url-template)
 */

function expand(url, params, variables) {

    var tmpl = parse(url), expanded = tmpl.expand(params);

    if (variables) {
        variables.push.apply(variables, tmpl.vars);
    }

    return expanded;
}

function parse(template) {

    var operators = ['+', '#', '.', '/', ';', '?', '&'], variables = [];

    return {
        vars: variables,
        expand: function expand(context) {
            return template.replace(/\{([^{}]+)\}|([^{}]+)/g, function (_, expression, literal) {
                if (expression) {

                    var operator = null, values = [];

                    if (operators.indexOf(expression.charAt(0)) !== -1) {
                        operator = expression.charAt(0);
                        expression = expression.substr(1);
                    }

                    expression.split(/,/g).forEach(function (variable) {
                        var tmp = /([^:*]*)(?::(\d+)|(\*))?/.exec(variable);
                        values.push.apply(values, getValues(context, operator, tmp[1], tmp[2] || tmp[3]));
                        variables.push(tmp[1]);
                    });

                    if (operator && operator !== '+') {

                        var separator = ',';

                        if (operator === '?') {
                            separator = '&';
                        } else if (operator !== '#') {
                            separator = operator;
                        }

                        return (values.length !== 0 ? operator : '') + values.join(separator);
                    } else {
                        return values.join(',');
                    }

                } else {
                    return encodeReserved(literal);
                }
            });
        }
    };
}

function getValues(context, operator, key, modifier) {

    var value = context[key], result = [];

    if (isDefined(value) && value !== '') {
        if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') {
            value = value.toString();

            if (modifier && modifier !== '*') {
                value = value.substring(0, parseInt(modifier, 10));
            }

            result.push(encodeValue(operator, value, isKeyOperator(operator) ? key : null));
        } else {
            if (modifier === '*') {
                if (Array.isArray(value)) {
                    value.filter(isDefined).forEach(function (value) {
                        result.push(encodeValue(operator, value, isKeyOperator(operator) ? key : null));
                    });
                } else {
                    Object.keys(value).forEach(function (k) {
                        if (isDefined(value[k])) {
                            result.push(encodeValue(operator, value[k], k));
                        }
                    });
                }
            } else {
                var tmp = [];

                if (Array.isArray(value)) {
                    value.filter(isDefined).forEach(function (value) {
                        tmp.push(encodeValue(operator, value));
                    });
                } else {
                    Object.keys(value).forEach(function (k) {
                        if (isDefined(value[k])) {
                            tmp.push(encodeURIComponent(k));
                            tmp.push(encodeValue(operator, value[k].toString()));
                        }
                    });
                }

                if (isKeyOperator(operator)) {
                    result.push(encodeURIComponent(key) + '=' + tmp.join(','));
                } else if (tmp.length !== 0) {
                    result.push(tmp.join(','));
                }
            }
        }
    } else {
        if (operator === ';') {
            result.push(encodeURIComponent(key));
        } else if (value === '' && (operator === '&' || operator === '?')) {
            result.push(encodeURIComponent(key) + '=');
        } else if (value === '') {
            result.push('');
        }
    }

    return result;
}

function isDefined(value) {
    return value !== undefined && value !== null;
}

function isKeyOperator(operator) {
    return operator === ';' || operator === '&' || operator === '?';
}

function encodeValue(operator, value, key) {

    value = (operator === '+' || operator === '#') ? encodeReserved(value) : encodeURIComponent(value);

    if (key) {
        return encodeURIComponent(key) + '=' + value;
    } else {
        return value;
    }
}

function encodeReserved(str) {
    return str.split(/(%[0-9A-Fa-f]{2})/g).map(function (part) {
        if (!/%[0-9A-Fa-f]/.test(part)) {
            part = encodeURI(part);
        }
        return part;
    }).join('');
}

/**
 * URL Template (RFC 6570) Transform.
 */

function template (options) {

    var variables = [], url = expand(options.url, options.params, variables);

    variables.forEach(function (key) {
        delete options.params[key];
    });

    return url;
}

/**
 * Service for URL templating.
 */

function Url(url, params) {

    var self = this || {}, options$$1 = url, transform;

    if (isString(url)) {
        options$$1 = {url: url, params: params};
    }

    options$$1 = merge({}, Url.options, self.$options, options$$1);

    Url.transforms.forEach(function (handler) {

        if (isString(handler)) {
            handler = Url.transform[handler];
        }

        if (isFunction(handler)) {
            transform = factory(handler, transform, self.$vm);
        }

    });

    return transform(options$$1);
}

/**
 * Url options.
 */

Url.options = {
    url: '',
    root: null,
    params: {}
};

/**
 * Url transforms.
 */

Url.transform = {template: template, query: query, root: root};
Url.transforms = ['template', 'query', 'root'];

/**
 * Encodes a Url parameter string.
 *
 * @param {Object} obj
 */

Url.params = function (obj) {

    var params = [], escape = encodeURIComponent;

    params.add = function (key, value) {

        if (isFunction(value)) {
            value = value();
        }

        if (value === null) {
            value = '';
        }

        this.push(escape(key) + '=' + escape(value));
    };

    serialize(params, obj);

    return params.join('&').replace(/%20/g, '+');
};

/**
 * Parse a URL and return its components.
 *
 * @param {String} url
 */

Url.parse = function (url) {

    var el = document.createElement('a');

    if (document.documentMode) {
        el.href = url;
        url = el.href;
    }

    el.href = url;

    return {
        href: el.href,
        protocol: el.protocol ? el.protocol.replace(/:$/, '') : '',
        port: el.port,
        host: el.host,
        hostname: el.hostname,
        pathname: el.pathname.charAt(0) === '/' ? el.pathname : '/' + el.pathname,
        search: el.search ? el.search.replace(/^\?/, '') : '',
        hash: el.hash ? el.hash.replace(/^#/, '') : ''
    };
};

function factory(handler, next, vm) {
    return function (options$$1) {
        return handler.call(vm, options$$1, next);
    };
}

function serialize(params, obj, scope) {

    var array = isArray(obj), plain = isPlainObject(obj), hash;

    each(obj, function (value, key) {

        hash = isObject(value) || isArray(value);

        if (scope) {
            key = scope + '[' + (plain || hash ? key : '') + ']';
        }

        if (!scope && array) {
            params.add(value.name, value.value);
        } else if (hash) {
            serialize(params, value, key);
        } else {
            params.add(key, value);
        }
    });
}

/**
 * XDomain client (Internet Explorer).
 */

function xdrClient (request) {
    return new PromiseObj(function (resolve) {

        var xdr = new XDomainRequest(), handler = function (ref) {
                var type = ref.type;


                var status = 0;

                if (type === 'load') {
                    status = 200;
                } else if (type === 'error') {
                    status = 500;
                }

                resolve(request.respondWith(xdr.responseText, {status: status}));
            };

        request.abort = function () { return xdr.abort(); };

        xdr.open(request.method, request.getUrl());

        if (request.timeout) {
            xdr.timeout = request.timeout;
        }

        xdr.onload = handler;
        xdr.onabort = handler;
        xdr.onerror = handler;
        xdr.ontimeout = handler;
        xdr.onprogress = function () {};
        xdr.send(request.getBody());
    });
}

/**
 * CORS Interceptor.
 */

var SUPPORTS_CORS = inBrowser && 'withCredentials' in new XMLHttpRequest();

function cors (request) {

    if (inBrowser) {

        var orgUrl = Url.parse(location.href);
        var reqUrl = Url.parse(request.getUrl());

        if (reqUrl.protocol !== orgUrl.protocol || reqUrl.host !== orgUrl.host) {

            request.crossOrigin = true;
            request.emulateHTTP = false;

            if (!SUPPORTS_CORS) {
                request.client = xdrClient;
            }
        }
    }

}

/**
 * Form data Interceptor.
 */

function form (request) {

    if (isFormData(request.body)) {
        request.headers.delete('Content-Type');
    } else if (isObject(request.body) && request.emulateJSON) {
        request.body = Url.params(request.body);
        request.headers.set('Content-Type', 'application/x-www-form-urlencoded');
    }

}

/**
 * JSON Interceptor.
 */

function json (request) {

    var type = request.headers.get('Content-Type') || '';

    if (isObject(request.body) && type.indexOf('application/json') === 0) {
        request.body = JSON.stringify(request.body);
    }

    return function (response) {

        return response.bodyText ? when(response.text(), function (text) {

            var type = response.headers.get('Content-Type') || '';

            if (type.indexOf('application/json') === 0 || isJson(text)) {

                try {
                    response.body = JSON.parse(text);
                } catch (e) {
                    response.body = null;
                }

            } else {
                response.body = text;
            }

            return response;

        }) : response;

    };
}

function isJson(str) {

    var start = str.match(/^\s*(\[|\{)/);
    var end = {'[': /]\s*$/, '{': /}\s*$/};

    return start && end[start[1]].test(str);
}

/**
 * JSONP client (Browser).
 */

function jsonpClient (request) {
    return new PromiseObj(function (resolve) {

        var name = request.jsonp || 'callback', callback = request.jsonpCallback || '_jsonp' + Math.random().toString(36).substr(2), body = null, handler, script;

        handler = function (ref) {
            var type = ref.type;


            var status = 0;

            if (type === 'load' && body !== null) {
                status = 200;
            } else if (type === 'error') {
                status = 500;
            }

            if (status && window[callback]) {
                delete window[callback];
                document.body.removeChild(script);
            }

            resolve(request.respondWith(body, {status: status}));
        };

        window[callback] = function (result) {
            body = JSON.stringify(result);
        };

        request.abort = function () {
            handler({type: 'abort'});
        };

        request.params[name] = callback;

        if (request.timeout) {
            setTimeout(request.abort, request.timeout);
        }

        script = document.createElement('script');
        script.src = request.getUrl();
        script.type = 'text/javascript';
        script.async = true;
        script.onload = handler;
        script.onerror = handler;

        document.body.appendChild(script);
    });
}

/**
 * JSONP Interceptor.
 */

function jsonp (request) {

    if (request.method == 'JSONP') {
        request.client = jsonpClient;
    }

}

/**
 * Before Interceptor.
 */

function before (request) {

    if (isFunction(request.before)) {
        request.before.call(this, request);
    }

}

/**
 * HTTP method override Interceptor.
 */

function method (request) {

    if (request.emulateHTTP && /^(PUT|PATCH|DELETE)$/i.test(request.method)) {
        request.headers.set('X-HTTP-Method-Override', request.method);
        request.method = 'POST';
    }

}

/**
 * Header Interceptor.
 */

function header (request) {

    var headers = assign({}, Http.headers.common,
        !request.crossOrigin ? Http.headers.custom : {},
        Http.headers[toLower(request.method)]
    );

    each(headers, function (value, name) {
        if (!request.headers.has(name)) {
            request.headers.set(name, value);
        }
    });

}

/**
 * XMLHttp client (Browser).
 */

function xhrClient (request) {
    return new PromiseObj(function (resolve) {

        var xhr = new XMLHttpRequest(), handler = function (event) {

                var response = request.respondWith(
                'response' in xhr ? xhr.response : xhr.responseText, {
                    status: xhr.status === 1223 ? 204 : xhr.status, // IE9 status bug
                    statusText: xhr.status === 1223 ? 'No Content' : trim(xhr.statusText)
                });

                each(trim(xhr.getAllResponseHeaders()).split('\n'), function (row) {
                    response.headers.append(row.slice(0, row.indexOf(':')), row.slice(row.indexOf(':') + 1));
                });

                resolve(response);
            };

        request.abort = function () { return xhr.abort(); };

        xhr.open(request.method, request.getUrl(), true);

        if (request.timeout) {
            xhr.timeout = request.timeout;
        }

        if (request.responseType && 'responseType' in xhr) {
            xhr.responseType = request.responseType;
        }

        if (request.withCredentials || request.credentials) {
            xhr.withCredentials = true;
        }

        if (!request.crossOrigin) {
            request.headers.set('X-Requested-With', 'XMLHttpRequest');
        }

        // deprecated use downloadProgress
        if (isFunction(request.progress) && request.method === 'GET') {
            xhr.addEventListener('progress', request.progress);
        }

        if (isFunction(request.downloadProgress)) {
            xhr.addEventListener('progress', request.downloadProgress);
        }

        // deprecated use uploadProgress
        if (isFunction(request.progress) && /^(POST|PUT)$/i.test(request.method)) {
            xhr.upload.addEventListener('progress', request.progress);
        }

        if (isFunction(request.uploadProgress) && xhr.upload) {
            xhr.upload.addEventListener('progress', request.uploadProgress);
        }

        request.headers.forEach(function (value, name) {
            xhr.setRequestHeader(name, value);
        });

        xhr.onload = handler;
        xhr.onabort = handler;
        xhr.onerror = handler;
        xhr.ontimeout = handler;
        xhr.send(request.getBody());
    });
}

/**
 * Http client (Node).
 */

function nodeClient (request) {

    var client = __webpack_require__(66);

    return new PromiseObj(function (resolve) {

        var url = request.getUrl();
        var body = request.getBody();
        var method = request.method;
        var headers = {}, handler;

        request.headers.forEach(function (value, name) {
            headers[name] = value;
        });

        client(url, {body: body, method: method, headers: headers}).then(handler = function (resp) {

            var response = request.respondWith(resp.body, {
                status: resp.statusCode,
                statusText: trim(resp.statusMessage)
            });

            each(resp.headers, function (value, name) {
                response.headers.set(name, value);
            });

            resolve(response);

        }, function (error$$1) { return handler(error$$1.response); });
    });
}

/**
 * Base client.
 */

function Client (context) {

    var reqHandlers = [sendRequest], resHandlers = [];

    if (!isObject(context)) {
        context = null;
    }

    function Client(request) {
        while (reqHandlers.length) {

            var handler = reqHandlers.pop();

            if (isFunction(handler)) {

                var response = (void 0), next = (void 0);

                response = handler.call(context, request, function (val) { return next = val; }) || next;

                if (isObject(response)) {
                    return new PromiseObj(function (resolve, reject) {

                        resHandlers.forEach(function (handler) {
                            response = when(response, function (response) {
                                return handler.call(context, response) || response;
                            }, reject);
                        });

                        when(response, resolve, reject);

                    }, context);
                }

                if (isFunction(response)) {
                    resHandlers.unshift(response);
                }

            } else {
                warn(("Invalid interceptor of type " + (typeof handler) + ", must be a function"));
            }
        }
    }

    Client.use = function (handler) {
        reqHandlers.push(handler);
    };

    return Client;
}

function sendRequest(request) {

    var client = request.client || (inBrowser ? xhrClient : nodeClient);

    return client(request);
}

/**
 * HTTP Headers.
 */

var Headers = function Headers(headers) {
    var this$1 = this;


    this.map = {};

    each(headers, function (value, name) { return this$1.append(name, value); });
};

Headers.prototype.has = function has (name) {
    return getName(this.map, name) !== null;
};

Headers.prototype.get = function get (name) {

    var list = this.map[getName(this.map, name)];

    return list ? list.join() : null;
};

Headers.prototype.getAll = function getAll (name) {
    return this.map[getName(this.map, name)] || [];
};

Headers.prototype.set = function set (name, value) {
    this.map[normalizeName(getName(this.map, name) || name)] = [trim(value)];
};

Headers.prototype.append = function append (name, value) {

    var list = this.map[getName(this.map, name)];

    if (list) {
        list.push(trim(value));
    } else {
        this.set(name, value);
    }
};

Headers.prototype.delete = function delete$1 (name) {
    delete this.map[getName(this.map, name)];
};

Headers.prototype.deleteAll = function deleteAll () {
    this.map = {};
};

Headers.prototype.forEach = function forEach (callback, thisArg) {
        var this$1 = this;

    each(this.map, function (list, name) {
        each(list, function (value) { return callback.call(thisArg, value, name, this$1); });
    });
};

function getName(map, name) {
    return Object.keys(map).reduce(function (prev, curr) {
        return toLower(name) === toLower(curr) ? curr : prev;
    }, null);
}

function normalizeName(name) {

    if (/[^a-z0-9\-#$%&'*+.^_`|~]/i.test(name)) {
        throw new TypeError('Invalid character in header field name');
    }

    return trim(name);
}

/**
 * HTTP Response.
 */

var Response = function Response(body, ref) {
    var url = ref.url;
    var headers = ref.headers;
    var status = ref.status;
    var statusText = ref.statusText;


    this.url = url;
    this.ok = status >= 200 && status < 300;
    this.status = status || 0;
    this.statusText = statusText || '';
    this.headers = new Headers(headers);
    this.body = body;

    if (isString(body)) {

        this.bodyText = body;

    } else if (isBlob(body)) {

        this.bodyBlob = body;

        if (isBlobText(body)) {
            this.bodyText = blobText(body);
        }
    }
};

Response.prototype.blob = function blob () {
    return when(this.bodyBlob);
};

Response.prototype.text = function text () {
    return when(this.bodyText);
};

Response.prototype.json = function json () {
    return when(this.text(), function (text) { return JSON.parse(text); });
};

Object.defineProperty(Response.prototype, 'data', {

    get: function get() {
        return this.body;
    },

    set: function set(body) {
        this.body = body;
    }

});

function blobText(body) {
    return new PromiseObj(function (resolve) {

        var reader = new FileReader();

        reader.readAsText(body);
        reader.onload = function () {
            resolve(reader.result);
        };

    });
}

function isBlobText(body) {
    return body.type.indexOf('text') === 0 || body.type.indexOf('json') !== -1;
}

/**
 * HTTP Request.
 */

var Request = function Request(options$$1) {

    this.body = null;
    this.params = {};

    assign(this, options$$1, {
        method: toUpper(options$$1.method || 'GET')
    });

    if (!(this.headers instanceof Headers)) {
        this.headers = new Headers(this.headers);
    }
};

Request.prototype.getUrl = function getUrl () {
    return Url(this);
};

Request.prototype.getBody = function getBody () {
    return this.body;
};

Request.prototype.respondWith = function respondWith (body, options$$1) {
    return new Response(body, assign(options$$1 || {}, {url: this.getUrl()}));
};

/**
 * Service for sending network requests.
 */

var COMMON_HEADERS = {'Accept': 'application/json, text/plain, */*'};
var JSON_CONTENT_TYPE = {'Content-Type': 'application/json;charset=utf-8'};

function Http(options$$1) {

    var self = this || {}, client = Client(self.$vm);

    defaults(options$$1 || {}, self.$options, Http.options);

    Http.interceptors.forEach(function (handler) {

        if (isString(handler)) {
            handler = Http.interceptor[handler];
        }

        if (isFunction(handler)) {
            client.use(handler);
        }

    });

    return client(new Request(options$$1)).then(function (response) {

        return response.ok ? response : PromiseObj.reject(response);

    }, function (response) {

        if (response instanceof Error) {
            error(response);
        }

        return PromiseObj.reject(response);
    });
}

Http.options = {};

Http.headers = {
    put: JSON_CONTENT_TYPE,
    post: JSON_CONTENT_TYPE,
    patch: JSON_CONTENT_TYPE,
    delete: JSON_CONTENT_TYPE,
    common: COMMON_HEADERS,
    custom: {}
};

Http.interceptor = {before: before, method: method, jsonp: jsonp, json: json, form: form, header: header, cors: cors};
Http.interceptors = ['before', 'method', 'jsonp', 'json', 'form', 'header', 'cors'];

['get', 'delete', 'head', 'jsonp'].forEach(function (method$$1) {

    Http[method$$1] = function (url, options$$1) {
        return this(assign(options$$1 || {}, {url: url, method: method$$1}));
    };

});

['post', 'put', 'patch'].forEach(function (method$$1) {

    Http[method$$1] = function (url, body, options$$1) {
        return this(assign(options$$1 || {}, {url: url, method: method$$1, body: body}));
    };

});

/**
 * Service for interacting with RESTful services.
 */

function Resource(url, params, actions, options$$1) {

    var self = this || {}, resource = {};

    actions = assign({},
        Resource.actions,
        actions
    );

    each(actions, function (action, name) {

        action = merge({url: url, params: assign({}, params)}, options$$1, action);

        resource[name] = function () {
            return (self.$http || Http)(opts(action, arguments));
        };
    });

    return resource;
}

function opts(action, args) {

    var options$$1 = assign({}, action), params = {}, body;

    switch (args.length) {

        case 2:

            params = args[0];
            body = args[1];

            break;

        case 1:

            if (/^(POST|PUT|PATCH)$/i.test(options$$1.method)) {
                body = args[0];
            } else {
                params = args[0];
            }

            break;

        case 0:

            break;

        default:

            throw 'Expected up to 2 arguments [params, body], got ' + args.length + ' arguments';
    }

    options$$1.body = body;
    options$$1.params = assign({}, options$$1.params, params);

    return options$$1;
}

Resource.actions = {

    get: {method: 'GET'},
    save: {method: 'POST'},
    query: {method: 'GET'},
    update: {method: 'PUT'},
    remove: {method: 'DELETE'},
    delete: {method: 'DELETE'}

};

/**
 * Install plugin.
 */

function plugin(Vue) {

    if (plugin.installed) {
        return;
    }

    Util(Vue);

    Vue.url = Url;
    Vue.http = Http;
    Vue.resource = Resource;
    Vue.Promise = PromiseObj;

    Object.defineProperties(Vue.prototype, {

        $url: {
            get: function get() {
                return options(Vue.url, this, this.$options.url);
            }
        },

        $http: {
            get: function get() {
                return options(Vue.http, this, this.$options.http);
            }
        },

        $resource: {
            get: function get() {
                return Vue.resource.bind(this);
            }
        },

        $promise: {
            get: function get() {
                var this$1 = this;

                return function (executor) { return new Vue.Promise(executor, this$1); };
            }
        }

    });
}

if (typeof window !== 'undefined' && window.Vue) {
    window.Vue.use(plugin);
}

/* harmony default export */ __webpack_exports__["a"] = (plugin);



/***/ }),
/* 66 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,n){if(true)module.exports=n();else if("function"==typeof define&&define.amd)define([],n);else{var t=n();for(var r in t)("object"==typeof exports?exports:e)[r]=t[r]}}("undefined"!=typeof self?self:this,(function(){return function(e){var n={};function t(r){if(n[r])return n[r].exports;var o=n[r]={i:r,l:!1,exports:{}};return e[r].call(o.exports,o,o.exports,t),o.l=!0,o.exports}return t.m=e,t.c=n,t.d=function(e,n,r){t.o(e,n)||Object.defineProperty(e,n,{enumerable:!0,get:r})},t.r=function(e){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})},t.t=function(e,n){if(1&n&&(e=t(e)),8&n)return e;if(4&n&&"object"==typeof e&&e&&e.__esModule)return e;var r=Object.create(null);if(t.r(r),Object.defineProperty(r,"default",{enumerable:!0,value:e}),2&n&&"string"!=typeof e)for(var o in e)t.d(r,o,function(n){return e[n]}.bind(null,o));return r},t.n=function(e){var n=e&&e.__esModule?function(){return e.default}:function(){return e};return t.d(n,"a",n),n},t.o=function(e,n){return Object.prototype.hasOwnProperty.call(e,n)},t.p="",t(t.s=0)}([function(e,n,t){"use strict";function r(e,n){var t=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);n&&(r=r.filter((function(n){return Object.getOwnPropertyDescriptor(e,n).enumerable}))),t.push.apply(t,r)}return t}function o(e){for(var n=1;n<arguments.length;n++){var t=null!=arguments[n]?arguments[n]:{};n%2?r(t,!0).forEach((function(n){i(e,n,t[n])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(t)):r(t).forEach((function(n){Object.defineProperty(e,n,Object.getOwnPropertyDescriptor(t,n))}))}return e}function i(e,n,t){return n in e?Object.defineProperty(e,n,{value:t,enumerable:!0,configurable:!0,writable:!0}):e[n]=t,e}t.r(n);var c={$vue:null,id:null,router:null,fields:{},customIdFields:{},ignoreRoutes:[],linkers:[],commands:{},disabled:!1,customResourceURL:null,set:[],require:[],ecommerce:{enabled:!1,options:null,enhanced:!1},autoTracking:{screenview:!1,shouldRouterUpdate:null,skipSamePath:!1,exception:!1,exceptionLogs:!0,page:!0,transformQueryString:!0,pageviewOnLoad:!0,pageviewTemplate:null,untracked:!0,prependBase:!0},debug:{enabled:!1,trace:!1,sendHitTask:!0},batch:{enabled:!1,delay:500,amount:2},checkDuplicatedScript:!1,disableScriptLoader:!1,beforeFirstHit:s,ready:s,untracked:[]},a=o({},c);function u(e){!function e(n,t){return Object.keys(t).forEach((function(r){var o=n[r]&&Object.prototype.toString.call(n[r]);"[object Object]"!==o&&"[object Array]"!==o?n[r]=t[r]:e(n[r],t[r])})),n}(a,e)}function f(){return a.id?[].concat(a.id):[]}var l=a;function s(){}var p=function(e){console.warn("[vue-analytics] ".concat(e))};function d(e,n){return new Promise((function(t,r){var o=document.head||document.getElementsByTagName("head")[0],i=document.createElement("script");if(i.async=!0,i.src=e,i.charset="utf-8",n){var c=document.createElement("link");c.href=n,c.rel="preconnect",o.appendChild(c)}o.appendChild(i),i.onload=t,i.onerror=r}))}function y(e){return e.name||e.replace(/-/gi,"")}function b(e,n){if(f().length>1){var t=y(n);return"".concat(t,".").concat(e)}return e}var m,v=function(e){if(e.then)return e;if("function"==typeof e){var n=e();return n.then?n:Promise.resolve(n)}return Promise.resolve(e)};function g(e){return function(e){if(Array.isArray(e)){for(var n=0,t=new Array(e.length);n<e.length;n++)t[n]=e[n];return t}}(e)||function(e){if(Symbol.iterator in Object(e)||"[object Arguments]"===Object.prototype.toString.call(e))return Array.from(e)}(e)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance")}()}var h=[];function w(e){for(var n=arguments.length,t=new Array(n>1?n-1:0),r=1;r<n;r++)t[r-1]=arguments[r];"undefined"!=typeof window&&f().forEach((function(n){var r,o={m:b(e,n),a:t};window.ga?l.batch.enabled?(h.push(o),m||(m=setInterval((function(){h.length?h.splice(0,l.batch.amount).forEach((function(e){var n;(n=window).ga.apply(n,[e.m].concat(g(e.a)))})):(clearInterval(m),m=null)}),l.batch.delay))):(r=window).ga.apply(r,[b(e,n)].concat(t)):l.untracked.push(o)}))}function O(e){return(O="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function j(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];"object"!==O(n[0])||n[0].constructor!==Object?w("set",n[0],n[1]):w("set",n[0])}function P(e,n){var t=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);n&&(r=r.filter((function(n){return Object.getOwnPropertyDescriptor(e,n).enumerable}))),t.push.apply(t,r)}return t}function S(e,n,t){return n in e?Object.defineProperty(e,n,{value:t,enumerable:!0,configurable:!0,writable:!0}):e[n]=t,e}function k(){if(window.ga||!l.debug.enabled){if(window.ga){var e=f();l.debug.enabled&&(window.ga_debug={trace:l.debug.trace}),e.forEach((function(n){var t=y(n),r=l.customIdFields[n]||{},o=e.length>1?function(e){for(var n=1;n<arguments.length;n++){var t=null!=arguments[n]?arguments[n]:{};n%2?P(t,!0).forEach((function(n){S(e,n,t[n])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(t)):P(t).forEach((function(n){Object.defineProperty(e,n,Object.getOwnPropertyDescriptor(t,n))}))}return e}({},l.fields,{},r,{name:t}):l.fields;window.ga("create",n.id||n,"auto",o)})),l.beforeFirstHit();var n=l.ecommerce;if(n.enabled){var t=n.enhanced?"ec":"ecommerce";n.options?w("require",t,n.options):w("require",t)}l.linkers.length>0&&(w("require","linker"),w("linker:autoLink",l.linkers)),l.debug.sendHitTask||j("sendHitTask",null)}}else p("Google Analytics has probably been blocked.")}var E=function(){2!=arguments.length?w("require",arguments.length<=0?void 0:arguments[0]):w("require",arguments.length<=0?void 0:arguments[0],arguments.length<=1?void 0:arguments[1])};function A(e){return(A="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}var x=function(){var e;l.set.forEach((function(e){var n=e.field,t=e.value;if(void 0===n||void 0===t)throw new Error('[vue-analytics] Wrong configuration in the plugin options.\nThe "set" array requires each item to have a "field" and a "value" property.');j(n,t)})),e=["ec","ecommerce"],l.require.forEach((function(n){if(-1!==e.indexOf(n)||-1!==e.indexOf(n.name))throw new Error("[vue-analytics] The ecommerce features are built-in in the plugin. \nFollow the ecommerce instructions available in the documentation.");if("string"!=typeof n&&"object"!==A(n))throw new Error('[vue-analytics] Wrong configuration in the plugin options. \nThe "require" array requires each item to be a string or to have a "name" and an "options" property.');var t=n.name||n;n.options?E(t,n.options):E(t)}))};function T(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];var r=n[0];if(1===n.length&&"string"==typeof r)return w("send","screenview",{screenName:r});w.apply(void 0,["send","screenview"].concat(n))}function D(e){return(D="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function q(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];var r;n.length&&!n[0]||(n.length&&n[0].currentRoute&&(r=n[0].currentRoute),n.length&&function(e){return e.query&&e.params}(n[0])&&(r=n[0]),r?R(r):(j("page","object"===D(n[0])?n[0].page:n[0]),w.apply(void 0,["send","pageview"].concat(n))))}function R(e){if(![(n=e).name,n.path].filter(Boolean).find((function(e){return-1!==l.ignoreRoutes.indexOf(e)}))){var n,t=l.autoTracking,r=e.meta.analytics,o=(void 0===r?{}:r).pageviewTemplate||t.pageviewTemplate;if(t.screenview&&!e.name)throw new Error("[vue-analytics] Route name is mandatory when using screenview.");if(t.screenview)T(e.name);else if(o)q(o(e));else{var i=l.router,c=l.autoTracking,a=c.transformQueryString,u=c.prependBase,f=function(e){var n=Object.keys(e).reduce((function(n,t,r,o){var i=r===o.length-1,c=e[t];return null==c?n:n+="".concat(t,"=").concat(c).concat(i?"":"&")}),"");return""!==n?"?".concat(n):""}(e.query),s=i&&i.options.base,p=u&&s,d=e.path+(a?f:"");q(d=p?function(e,n){var t=n.split("/"),r=e.split("/");return""===t[0]&&"/"===e[e.length-1]&&t.shift(),r.join("/")+t.join("/")}(s,d):d)}}}function I(e){return function(e){if(Array.isArray(e)){for(var n=0,t=new Array(e.length);n<e.length;n++)t[n]=e[n];return t}}(e)||function(e){if(Symbol.iterator in Object(e)||"[object Arguments]"===Object.prototype.toString.call(e))return Array.from(e)}(e)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance")}()}var L=function(){var e=!(arguments.length>0&&void 0!==arguments[0])||arguments[0];"undefined"!=typeof window&&f().forEach((function(n){window["ga-disable-".concat(n)]=e}))},_=function(){if("undefined"!=typeof document&&"undefined"!=typeof window){if(l.id){var e,n,t=[v(l.id),v(l.disabled)];if(e=l.checkDuplicatedScript,n=l.disableScriptLoader,[Boolean(window&&window.ga),e&&!(Array.prototype.slice.call(document.getElementsByTagName("script")).filter((function(e){return-1!==e.src.indexOf("analytics")||-1!==e.src.indexOf("gtag")})).length>0),!n].some(Boolean)){var r="https://www.google-analytics.com",o=l.debug.enabled?"analytics_debug":"analytics",i=l.customResourceURL?d(l.customResourceURL):d("".concat(r,"/").concat(o,".js"),r);t.push(i.catch((function(){p("An error occured! Please check your connection or disable your AD blocker")})))}return Promise.all(t).then((function(e){var n,t,r;u({id:e[0],disabled:e[1]}),L(l.disabled),k(),x(),l.untracked.forEach((function(e){w.apply(void 0,[e.m].concat(I(e.a)))})),n=l.router,t=l.autoTracking,r=l.$vue,t.page&&n&&n.onReady((function(){t.pageviewOnLoad&&n.history.ready&&R(n.currentRoute),n.afterEach((function(e,o){var i=t.skipSamePath,c=t.shouldRouterUpdate;i&&e.path===o.path||("function"!=typeof c||c(e,o))&&r.nextTick().then((function(){R(n.currentRoute)}))}))})),l.ready()})).catch((function(e){l.debug.enabled&&p(e.message)}))}p('Missing the "id" parameter. Add at least one tracking domain ID')}};var B=function(e){var n=arguments.length>1&&void 0!==arguments[1]&&arguments[1];w("send","exception",{exDescription:e,exFatal:n})},H=function(e){if(l.autoTracking.exception){window.addEventListener("error",(function(e){B(e.message)}));var n=e.config.errorHandler;e.config.errorHandler=function(e,t,r){B(e.message),l.autoTracking.exceptionLogs&&console.error(e),"function"==typeof n&&n.call(void 0,e,t,r)}}},F=B;function M(e,n){var t=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);n&&(r=r.filter((function(n){return Object.getOwnPropertyDescriptor(e,n).enumerable}))),t.push.apply(t,r)}return t}function U(e,n,t){return n in e?Object.defineProperty(e,n,{value:t,enumerable:!0,configurable:!0,writable:!0}):e[n]=t,e}var $=function(e){return"".concat(l.ecommerce.enhanced?"ec":"ecommerce",":").concat(e)},C=["addItem","addTransaction","addProduct","addImpression","setAction","addPromo","send"].reduce((function(e,n){return function(e){for(var n=1;n<arguments.length;n++){var t=null!=arguments[n]?arguments[n]:{};n%2?M(t,!0).forEach((function(n){U(e,n,t[n])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(t)):M(t).forEach((function(n){Object.defineProperty(e,n,Object.getOwnPropertyDescriptor(t,n))}))}return e}({},e,U({},n,(function(){for(var e=arguments.length,t=new Array(e),r=0;r<e;r++)t[r]=arguments[r];w.apply(void 0,[$(n)].concat(t))})))}),{}),N={event:function(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];w.apply(void 0,["send","event"].concat(n))},exception:F,page:q,query:w,require:E,set:j,social:function(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];w.apply(void 0,["send","social"].concat(n))},time:function(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];w.apply(void 0,["send","timing"].concat(n))},screenview:T,ecommerce:C,disable:function(){return L(!0)},enable:function(){return L(!1)},commands:l.commands},Q={inserted:function(e,n,t){var r=Object.keys(n.modifiers);0===r.length&&r.push("click"),r.forEach((function(r){e.addEventListener(r,(function(){var e="string"==typeof n.value?l.commands[n.value]:n.value;if(!e)throw new Error("[vue-analytics] The value passed to v-ga is not defined in the commands list.");e.apply(t.context)}))}))}};function W(e){return function(e){if(Array.isArray(e)){for(var n=0,t=new Array(e.length);n<e.length;n++)t[n]=e[n];return t}}(e)||function(e){if(Symbol.iterator in Object(e)||"[object Arguments]"===Object.prototype.toString.call(e))return Array.from(e)}(e)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance")}()}function G(e,n){return function(e){if(Array.isArray(e))return e}(e)||function(e,n){if(!(Symbol.iterator in Object(e)||"[object Arguments]"===Object.prototype.toString.call(e)))return;var t=[],r=!0,o=!1,i=void 0;try{for(var c,a=e[Symbol.iterator]();!(r=(c=a.next()).done)&&(t.push(c.value),!n||t.length!==n);r=!0);}catch(e){o=!0,i=e}finally{try{r||null==a.return||a.return()}finally{if(o)throw i}}return t}(e,n)||function(){throw new TypeError("Invalid attempt to destructure non-iterable instance")}()}function z(e,n){var t=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);n&&(r=r.filter((function(n){return Object.getOwnPropertyDescriptor(e,n).enumerable}))),t.push.apply(t,r)}return t}function J(e,n,t){return n in e?Object.defineProperty(e,n,{value:t,enumerable:!0,configurable:!0,writable:!0}):e[n]=t,e}function K(e){u(function(e){for(var n=1;n<arguments.length;n++){var t=null!=arguments[n]?arguments[n]:{};n%2?z(t,!0).forEach((function(n){J(e,n,t[n])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(t)):z(t).forEach((function(n){Object.defineProperty(e,n,Object.getOwnPropertyDescriptor(t,n))}))}return e}({},arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},{$vue:e})),e.directive("ga",Q),e.prototype.$ga=e.$ga=N,H(e),_()}t.d(n,"default",(function(){return K})),t.d(n,"analyticsMiddleware",(function(){return V})),t.d(n,"onAnalyticsReady",(function(){return X})),t.d(n,"event",(function(){return Y})),t.d(n,"ecommerce",(function(){return Z})),t.d(n,"set",(function(){return ee})),t.d(n,"page",(function(){return ne})),t.d(n,"query",(function(){return te})),t.d(n,"screenview",(function(){return re})),t.d(n,"time",(function(){return oe})),t.d(n,"require",(function(){return ie})),t.d(n,"exception",(function(){return ce})),t.d(n,"social",(function(){return ae}));var V=function(e){e.subscribe((function(e){var n=e.payload;if(n&&n.meta&&n.meta.analytics){var t=n.meta.analytics;if(!Array.isArray(t))throw new Error('The "analytics" property needs to be an array');t.forEach((function(e){var n,t,r=e.shift(),o=e;if(r.includes(":")){var i=G(r.split(":"),2);r=i[0],n=i[1]}if(!(r in N))throw new Error('[vue-analytics:vuex] The type "'.concat(r,"\" doesn't exist."));if(n&&!(n in N[r]))throw new Error('[vue-analytics:vuex] The type "'.concat(r,'" has not method "').concat(n,'".'));if("ecommerce"===r&&!n)throw new Error('[vue-analytics:vuex] The type "'.concat(r,'" needs to call a method. Check documentation.'));n?(t=N[r])[n].apply(t,W(o)):N[r].apply(N,W(o))}))}}))},X=function(){return new Promise((function(e,n){var t=setInterval((function(){"undefined"!=typeof window&&window.ga&&(e(),clearInterval(t))}),10)}))},Y=N.event,Z=N.ecommerce,ee=N.set,ne=N.page,te=N.query,re=N.screenview,oe=N.time,ie=N.require,ce=N.exception,ae=N.social}])}));

/***/ })
],[16]);


// WEBPACK FOOTER //
// js/app.f4a1ccd972b2a7ba195c.js